import { calculateFontSize } from 'utils/helperMethods';
import { colorConstants } from './colorConstants';

export const config = {
    kind: {
        //COMMON CONFIG
        commonConfig: {
            clientName: 'Kind',
            handleDim2SortingFromFrontend: false,
            dateFormat: 'MM/DD/YYYY',
            dateFormatAlt: 'MM/DD/YY',
            calenderStartDay: 'Sunday',
            showSecondaryLogo: false,
            showLogoInNavbar: true,
            logoHeight: '32px',
            logoWidth: '125px',
            loginPageTextPart1: 'Welcome to the',
            loginPageTextPart2: 'SRM Analytic Intelligence (AI) Tool Suite',
            width: window.innerWidth,
            limit: 10,
            offset: 0,
            lagList: [0, 1],
            graphFontSize: calculateFontSize(window.innerWidth, 13),
            graphFontSizeAlt: calculateFontSize(window.innerWidth, 13),
            graphFontFamily: "'Helvetica Neue', sans-serif",
            graphLabelColorAlt: '#4E4C55',
            graphLabelColor: '#433C4A',
            units: {
                currency: '$',
                volume: 'Eq Vol',
                currencyText: 'Dollar',
            },
            filterFormat: { dim1: { ids: [] }, dim2: { ids: [] } },
            frequency: 'W',
            showCampignCalender: false,
            showFullLabel: true,
            decimalForPercentage: 1,
            decimalForNonPercentage: 2,
        },
        latestDateForDifferentRoutes: {
            'promo-score-card': 'Promotion Data',
            'roi-analysis': 'Promotion Data',
            'roi-tracker': 'Promotion Data',
            'promo-recommendation': 'Promotion Data',
            default: 'POS Data',
        },
        screenDetailsWithRoutes: [
            {
                label: 'Growth Analysis',
                path: 'promo/category-diagnostics/growth-analysis',
                id: 'ga',
                pageId: 'ga',
            },
            {
                label: 'Bump Report',
                path: 'promo/category-diagnostics/bump-report',
                id: 'br',
                pageId: 'br',
            },
            {
                label: 'PVM Analysis',
                path: 'promo/category-diagnostics/pvm-analysis',
                id: 'pvm',
                pageId: 'pvm',
            },
            {
                label: 'Price Change',
                path: 'pricing/analytics/price-change',
                id: 'pcn',
                pageId: 'pcn',
            },
            {
                label: 'Price Point',
                path: 'pricing/analytics/price-point',
                id: 'pp',
                pageId: 'pp',
            },
            {
                label: 'Price Ladder',
                path: 'pricing/analytics/price-ladder',
                id: 'pld',
                pageId: 'pld',
            },
            {
                label: 'Price Curve',
                path: 'pricing/analytics/price-curve',
                id: 'pc',
                pageId: 'pc',
            },
            {
                label: 'Price Tracking',
                path: 'pricing/analytics/price-tracking',
                id: 'pt',
                pageId: 'pt',
            },
            {
                label: 'Opportunity Identification',
                path: 'pricing/analytics/opportunity-identification',
                id: 'oi',
                pageId: 'oi',
            },
            {
                label: 'Promo Scorecard',
                path: 'promo/analytics/promo-score-card',
                id: 'ps',
                pageId: 'ps',
            },
            {
                label: 'Investment & ROI Tracker',
                path: 'promo/analytics/roi-tracker',
                id: 'pl',
                pageId: 'pl',
            },
            {
                label: 'Promo ROI Analysis',
                path: 'promo/analytics/roi-analysis',
                id: 'pa',
                pageId: 'pa',
            },
            {
                label: 'Promo Recommendation',
                path: 'promo/recommendation/promo-recommendation',
                id: 'pr',
                pageId: 'pr',
            },
            {
                label: 'Best Weeks',
                path: 'promo/recommendation/best-weeks',
                id: 'bw',
                pageId: 'bw',
            },
            {
                label: 'Pricing Simulator v1',
                path: 'pricing/recommendation/price-simulator',
                id: 'psr',
                pageId: 'psr',
            },
            {
                label: 'Pricing Simulator v1',
                path: 'pricing/recommendation/price-simulator/new',
                id: 'psr',
                pageId: 'psrNew',
            },
            {
                label: 'Pricing Simulator v1',
                path: 'pricing/recommendation/price-simulator/edit/:id',
                id: 'psr',
                pageId: 'psrEdit',
            },
            {
                label: 'Pricing Simulator v1',
                path: 'pricing/recommendation/price-simulator/view/:id',
                id: 'psr',
                pageId: 'psrView',
            },
            {
                label: 'Pricing Simulator',
                path: 'pricing/recommendation/pricing-simulator',
                id: 'psrV2', //update id in simulator context as well
                pageId: 'psrV2',
            },
            {
                label: 'Pricing Simulator ',
                path: 'pricing/recommendation/pricing-simulator/:mode/:projectId/scenario/:scenarioId',
                id: 'psr',
                pageId: 'psrV2Update',
            },
            {
                label: 'Pricing Simulator',
                path: 'pricing/recommendation/pricing-simulator/:mode/:projectId/scenario/:scenarioId',
                id: 'psr',
                pageId: 'psrV2View',
            },
            {
                label: 'Pricing Analytics',
                path: 'pricing/recommendation/pricing-analytics',
                id: 'psa',
                pageId: 'psa', // pricing analytics
            },
            {
                label: 'Pricing Analytics',
                path: 'pricing/recommendation/pricing-analytics/:mode/:reportId',
                id: 'psa',
                pageId: 'psaUpdate', // pricing analytics update
            },
            {
                label: 'Pricing Analytics',
                path: 'pricing/recommendation/pricing-analytics/:mode/:reportId',
                id: 'psa',
                pageId: 'psaView', // pricing analytics view
            },
        ],
        screens: [
            {
                label: 'Category Diagnostics',
                path: ['promo/category-diagnostics'],
                showSubHeader: false,
                options: {
                    Promo: [
                        {
                            label: 'Growth Analysis',
                            path: 'growth-analysis',
                            id: 'ga',
                        },
                        { label: 'Bump Report', path: 'bump-report', id: 'br' },
                    ],
                    visible: false,
                },
            },
            {
                label: 'Pricing Analytics',
                path: ['pricing/analytics', null],
                showSubHeader: false,
                options: {
                    Promo: [
                        {
                            label: 'Price Change',
                            path: 'price-change',
                            id: 'pcn',
                        },
                        { label: 'Price Point', path: 'price-point', id: 'pp' },
                        {
                            label: 'Price Ladder',
                            path: 'price-ladder',
                            id: 'pld',
                        },
                        { label: 'Price Curve', path: 'price-curve', id: 'pc' },
                        {
                            label: 'Price Tracking',
                            path: 'price-tracking',
                            id: 'pt',
                        },
                        {
                            label: 'Opportunity Identification',
                            path: 'opportunity-identification',
                            id: 'oi',
                        },
                    ],
                    visible: false,
                },
            },
            {
                label: 'Promo Analytics',
                path: ['promo/analytics', null],
                showSubHeader: false,
                options: {
                    Promo: [
                        {
                            label: 'Promo Scorecard',
                            path: 'promo-score-card',
                            id: 'ps',
                        },
                        {
                            label: 'Investment & ROI Tracker',
                            path: 'roi-tracker',
                            id: 'pl',
                        },
                        {
                            label: 'Promo ROI Analysis',
                            path: 'roi-analysis',
                            id: 'pa',
                        },
                    ],
                    visible: false,
                },
            },
            {
                label: 'Price & Promo Modeling',
                path: ['promo/recommendation', 'pricing/recommendation'],
                showSubHeader: true,
                options: {
                    Promo: [
                        {
                            label: 'Promo Recommendation',
                            path: 'promo-recommendation',
                            id: 'pr',
                        },
                        {
                            label: 'Best Weeks',
                            path: 'best-weeks',
                            id: 'bw',
                        },
                    ],
                    Pricing: [
                        {
                            label: 'Pricing Simulator v1',
                            path: 'price-simulator',
                            id: 'psr',
                        },
                        { label: 'Pricing Simulator', path: 'pricing-simulator', id: 'psrV2' },
                    ],
                    visible: false,
                },
            },
        ],
        globalFilter: {
            presetConfig: {
                disablePresetFilter: false,
                presetEnabledRoutes: {
                    all: true,
                },
            },
            availableFrequenciesList: [{ key: 'W', label: 'Week' }],
            globalFilterChangingRoutes: {
                'growth-analysis': {
                    dimensionListKey: 'growth_analysis',
                    getGlobalTimestampsKey: 'default',
                    getAttributeNamesKey: 'growth_analysis',
                    groupKey: 'upc',
                    // disabledAttributeTypes: ['manufacturer'],
                    defaultGlobalFilterObj: {
                        dim1: {
                            Category: {
                                inclusion: [
                                    {
                                        dimension: 'dim1',
                                        isActive: true,
                                        attributeType: 'Category',
                                        attributeDesc: 'TOTAL BARS',
                                        attributeExId: 'TOTAL BARS',
                                    },
                                ],
                            },
                        },
                        dim2: {
                            Retailer: {
                                inclusion: [
                                    {
                                        dimension: 'dim2',
                                        isActive: true,
                                        attributeType: 'Retailer',
                                        attributeDesc: 'Kroger Corp w Roundys',
                                        attributeExId: 'Kroger Corp w Roundys',
                                    },
                                ],
                            },
                        },
                    },
                },
                'bump-report': {
                    dimensionListKey: 'bump_report',
                    getGlobalTimestampsKey: 'default',
                    getAttributeNamesKey: 'bump_report',
                    groupKey: 'upc',
                    // disabledAttributeTypes: ['manufacturer'],
                    defaultGlobalFilterObj: {
                        dim1: {
                            Category: {
                                inclusion: [
                                    {
                                        dimension: 'dim1',
                                        isActive: true,
                                        attributeType: 'Category',
                                        attributeDesc: 'TOTAL BARS',
                                        attributeExId: 'TOTAL BARS',
                                    },
                                ],
                            },
                        },
                        dim2: {
                            Retailer: {
                                inclusion: [
                                    {
                                        dimension: 'dim2',
                                        isActive: true,
                                        attributeType: 'Retailer',
                                        attributeDesc: 'Kroger Corp w Roundys',
                                        attributeExId: 'Kroger Corp w Roundys',
                                    },
                                ],
                            },
                        },
                    },
                },
                'promo-score-card': {
                    dimensionListKey: 'promo_scorecard',
                    getGlobalTimestampsKey: 'default',
                    getAttributeNamesKey: 'promo_scorecard',
                    groupKey: 'upc',
                    // disabledAttributeTypes: ['manufacturer'],
                    defaultGlobalFilterObj: {
                        dim1: {
                            Category: {
                                inclusion: [
                                    {
                                        dimension: 'dim1',
                                        isActive: true,
                                        attributeType: 'Category',
                                        attributeDesc: 'TOTAL BARS',
                                        attributeExId: 'TOTAL BARS',
                                    },
                                ],
                            },
                        },
                        dim2: {
                            Retailer: {
                                inclusion: [
                                    {
                                        dimension: 'dim2',
                                        isActive: true,
                                        attributeType: 'Retailer',
                                        attributeDesc: 'Kroger Corp w Roundys',
                                        attributeExId: 'Kroger Corp w Roundys',
                                    },
                                ],
                            },
                        },
                    },
                },
            },
            limit: 50,
            selectionAllowed: {
                'promo-recommendation': {
                    dim2: {
                        Retailer: 1,
                    },
                },
            },
            allSelectedLimit: 15,
            timePeriodScreenMapping: {
                default: ['4W', '12W', '26W', '52W', 'YTD', 'CUSTOM DATE'],
                'bump-report': ['52W', '104W', '156W', 'YTD', 'CUSTOM DATE'],
            },

            defaultPeriod: ['52W'],
            applyFilterApiPostFormat: {
                jsonstring_dim1: '{}',
                jsonstring_dim2: '{}',
            },
            defaultPreviousIdObject: {
                dim1: ['attr', 'attr'],
                dim2: ['attr', 'attr'],
            },
            defaultIdObject: {
                dim1: { ids: [] },
                dim2: { ids: [] },
            },
            defaultAttrIdObject: {
                attr: {
                    dim1: { ids: [] },
                    dim2: { ids: [] },
                },
            },
            promoScoreCardDefault: {
                Category: 'TOTAL BARS',
                Retailer: 'Kroger Corp w Roundys',
            },
            retainFiltersAcrossFeatures: true,
            PromoScoreCardDefaultObj: {
                dim1: {
                    Category: {
                        inclusion: [
                            {
                                dimension: 'dim1',
                                isActive: true,
                                attributeType: 'Category',
                                attributeDesc: 'TOTAL BARS',
                                attributeExId: 'TOTAL BARS',
                            },
                        ],
                    },
                },
                dim2: {
                    Retailer: {
                        inclusion: [
                            {
                                dimension: 'dim2',
                                isActive: true,
                                attributeType: 'Retailer',
                                attributeDesc: 'Kroger Corp w Roundys',
                                attributeExId: 'Kroger Corp w Roundys',
                            },
                        ],
                    },
                },
            },
        },
        priceSimulator: {
            dataSources: [
                { label: 'Projected Consumption', value: 'iri' },
                { label: 'Consumption Actuals', value: 'l52_weeks' },
                { label: 'Financials', value: 'financials' },
            ],
            allScenariosTableLimit: 500,
            a: 10,
            opportunityIdentificationTiles: [
                { key: 'recommendation', label: 'Recommendation' },
                { key: 'input', label: 'Input' },
                { key: 'output', label: 'Output' },
            ],
            cascadingColumns: ['COGS Rate', 'List Price', 'Everyday Retail Price'], // this should match with input key mapping and price simulator input columns
            levels: ['product', 'retailer'],
            inputKeyMapping: {
                // keep the order accuretly, to get it in multiselect
                cogs: 'COGS Rate',
                lp: 'List Price',
                rp: 'Everyday Retail Price',
                acv: 'ACV Distribution',
                oi: 'OI Rate',
                non_oi: 'Non OI Rate',
                promo_trade_spends: 'Promo Trade Rate Spends',
                tr: 'Trade Rate',
                cf: 'Comp Follow',
            },
            outputKeyMapping: {
                volume: {
                    label: 'New Volume',
                    pre: '',
                    pos: '',
                },
                volume_old: {
                    label: 'Current Volume',
                    pre: '',
                    pos: '',
                },
                vlmChg: {
                    label: 'Volume Chg %',
                    pre: '',
                    pos: '%',
                },
                units: {
                    label: 'New Units',
                    pre: '',
                    pos: '',
                },
                units_old: {
                    label: 'Current Units',
                    pre: '',
                    pos: '',
                },
                unitsChg: {
                    label: 'Units Chg %',
                    pre: '',
                    pos: '%',
                },
                rsv: {
                    label: 'New RSV',
                    pre: '$',
                    pos: '',
                },
                rsv_old: {
                    label: 'Current RSV',
                    pre: '$',
                    pos: '',
                },
                rsvChg: {
                    label: 'RSV Chg %',
                    pre: '',
                    pos: '%',
                },
                gsv: {
                    label: 'New GSV',
                    pre: '$',
                    pos: '',
                },
                gsv_old: {
                    label: 'Current GSV',
                    pre: '$',
                    pos: '',
                },
                gsvChg: {
                    label: 'GSV Chg %',
                    pre: '',
                    pos: '%',
                },
                nsv: {
                    label: 'New NSV',
                    pre: '$',
                    pos: '',
                },
                nsv_old: {
                    label: 'Current NSV',
                    pre: '$',
                    pos: '',
                },
                nsvChg: {
                    label: 'NSV Chg %',
                    pre: '',
                    pos: '%',
                },
                gmac: {
                    label: 'New GMAC',
                    pre: '$',
                    pos: '',
                },
                gmac_old: {
                    label: 'Current GMAC',
                    pre: '$',
                    pos: '',
                },
                gmacChg: {
                    label: 'GMAC Chg %',
                    pre: '',
                    pos: '%',
                },
                rtMg: {
                    label: 'New Retail Margin %',
                    pre: '',
                    pos: '%',
                },
                rtMg_old: {
                    label: 'Current Retail Margin %',
                    pre: '',
                    pos: '%',
                },
                rtMgPcChg: {
                    label: 'Retail Margin Chg %',
                    pre: '',
                    pos: '%',
                },
                retailer_profit: {
                    label: 'New Retail Profit',
                    pre: '',
                    pos: '',
                },
                retailer_profit_old: {
                    label: 'Current Retail Profit',
                    pre: '',
                    pos: '',
                },
                rtPfChg: {
                    label: 'Retail Profit Chg %',
                    pre: '',
                    pos: '%',
                },
                netRpChg: {
                    label: 'Net Effective Price % Chg',
                    pre: '',
                    pos: '%',
                },
                mgPc: {
                    label: 'New Margin %',
                    pre: '',
                    pos: '%',
                },
                mgPc_old: {
                    label: 'Current Margin %',
                    pre: '',
                    pos: '%',
                },
                mgPcChg: {
                    label: 'Margin Chg %',
                    pre: '',
                    pos: '%',
                },
                profitPool: {
                    label: 'New Profit Pool',
                    pre: '',
                    pos: '%',
                },
                profitPool_old: {
                    label: 'Current Profit Pool',
                    pre: '',
                    pos: '%',
                },
                profitPoolChg: {
                    label: 'Profit Pool Chg %',
                    pre: '',
                    pos: '$',
                },
                oi_cp: {
                    label: 'Current OI Rate',
                    pre: '',
                    pos: '%',
                },
                oi_np: {
                    label: 'New OI Rate',
                    pre: '',
                    pos: '',
                },
                oi_pc: {
                    label: 'OI Rate Chg %',
                    pre: '',
                    pos: '%',
                },
                non_oi_cp: {
                    label: 'Current Non OI Rate',
                    pre: '',
                    pos: '',
                },
                non_oi_np: {
                    label: 'New Non OI Rate',
                    pre: '',
                    pos: '',
                },
                non_oi_pc: {
                    label: 'Non OI Rate Chg %',
                    pre: '',
                    pos: '%',
                },
                promo_trade_spends_cp: {
                    label: 'Current Promo Trade Rate Spends',
                    pre: '',
                    pos: '',
                },
                promo_trade_spends_np: {
                    label: 'Current Promo Trade Rate Spends',
                    pre: '',
                    pos: '',
                },
                promo_trade_spends_pc: {
                    label: 'Promo Trade Rate Spends Chg %',
                    pre: '',
                    pos: '%',
                },
                tr_cp: {
                    label: 'Current Trade Rate',
                    pre: '',
                    pos: '',
                },
                tr_np: {
                    label: 'New Trade Rate',
                    pre: '',
                    pos: '',
                },
                tr_pc: {
                    label: 'Trade Rate Chg %',
                    pre: '',
                    pos: '%',
                },
            },
            recommendationKeyMapping: {
                recommended_list_price: {
                    label: 'New list price recom',
                    pre: '$',
                    pos: '',
                },
                role: {
                    label: 'Role',
                    pre: '',
                    pos: '',
                },
                strategy: {
                    label: 'Strategy',
                    pre: '',
                    pos: '',
                },
                mix: {
                    label: 'Mix',
                    pre: '',
                    pos: '',
                },
                growth: {
                    label: 'Growth',
                    pre: '',
                    pos: '',
                },
                gap: {
                    label: 'Gap',
                    pre: '',
                    pos: '',
                },

                cogs: {
                    label: 'COGs',
                    pre: '',
                    pos: '%',
                },
                list_to_retail: {
                    label: 'List to Retail',
                    pre: '',
                    pos: '',
                },
                bpe: {
                    label: 'BPE',
                    pre: '',
                    pos: '',
                },
                ppe: {
                    label: 'PPE',
                    pre: '',
                    pos: '',
                },
                margin: {
                    label: 'Margin',
                    pre: '',
                    pos: '%',
                },
                growth_vs_category: {
                    label: 'Gowth vs Category',
                    pre: '',
                    pos: '%',
                },
                pl_vs_category: {
                    label: 'PL vs Category',
                    pre: '',
                    pos: '%',
                },
                threshold: {
                    label: 'Threshold',
                    pre: '',
                    pos: '',
                },
                comp_index: {
                    label: 'Comp. Index',
                    pre: '',
                    pos: '',
                },
                curve_index: {
                    label: 'Curve Index',
                    pre: '',
                    pos: '',
                },
                cogs_realization: {
                    label: 'COGS & Realization',
                    pre: '',
                    pos: '',
                },
                cogs_forecast: {
                    label: 'COGS Forecast',
                    pre: '',
                    pos: '%',
                },
                net_to_retail: {
                    label: 'Net to Retail',
                    pre: '',
                    pos: '%',
                },
                gross_to_net: {
                    label: 'Gross to Net',
                    pre: '',
                    pos: '%',
                },
            },
            defaultKpiMetrics: [1, 2, 3, 4, 5],
            kpiMetrics: [
                {
                    key: 1,
                    value: 'volume_sales',
                    name: 'Kind Volume Sales',
                    pre: '',
                    post: '',
                    decimalToRoundOff: 0,
                },
                {
                    key: 2,
                    value: 'value_sales',
                    name: 'Kind Value Sales ($)',
                    pre: '$',
                    post: '',
                    decimalToRoundOff: 0,
                },
                {
                    key: 3,
                    value: 'profit_abs',
                    name: 'Kind Profit Abs ($)',
                    pre: '$',
                    post: '',
                    decimalToRoundOff: 0,
                },
                {
                    key: 4,
                    value: 'margin_percent',
                    name: 'Kind Margin (%)',
                    pre: '',
                    post: '%',
                    decimalToRoundOff: 2,
                },
                {
                    key: 5,
                    value: 'trade_rate_percent',
                    name: 'Kind Trade Rate (%)',
                    pre: '',
                    post: '%',
                    decimalToRoundOff: 2,
                },
                {
                    key: 6,
                    value: 'retailer_margin_percent',
                    name: 'Kind Retailer Margin (%)',
                    pre: '',
                    post: '%',
                    decimalToRoundOff: 2,
                },
                {
                    key: 7,
                    value: 'gross_profit',
                    name: 'Kind Gross Profit ($)',
                    pre: '$',
                    post: '',
                    decimalToRoundOff: 0,
                },
                {
                    key: 8,
                    value: 'retailer_profit',
                    name: 'Kind Retailer Profit ($)',
                    pre: '$',
                    post: '',
                    decimalToRoundOff: 0,
                },
                {
                    key: 9,
                    value: 'gross_sales',
                    name: 'Kind Gross Sales ($)',
                    pre: '$',
                    post: '',
                    decimalToRoundOff: 0,
                },
                {
                    key: 10,
                    value: 'net_sales',
                    name: 'Kind Net Sales($)',
                    pre: '$',
                    post: '',
                    decimalToRoundOff: 0,
                },
                {
                    key: 11,
                    value: 'total_volume',
                    name: 'Total Volume Sales',
                    pre: '$',
                    post: '',
                    decimalToRoundOff: 0,
                },
                {
                    key: 12,
                    value: 'total_value',
                    name: 'Total Value Sales($)',
                    pre: '$',
                    post: '',
                    decimalToRoundOff: 0,
                },
                {
                    key: 13,
                    value: 'net_retail_price_change',
                    name: 'Kind Net Retailer Price % Chg',
                    pre: '',
                    post: '%',
                    decimalToRoundOff: 2,
                },
            ],
            addPortfolioUpdateKpis: [
                {
                    key: 'volume',
                    value: '',
                    label: 'Volume',
                    rval: '',
                    percentChange: '',
                },
                {
                    key: 'value',
                    value: '',
                    label: 'Value',
                    rval: '',
                    percentChange: '',
                },
                {
                    key: 'units',
                    value: '',
                    label: 'Units',
                    rval: '',
                    percentChange: '',
                },
                {
                    key: 'trade_rate',
                    value: '',
                    label: 'Trade Rate %',
                    rval: '',
                    percentChange: '',
                },
                {
                    key: 'list_price',
                    value: '',
                    label: 'List Price per unit',
                    rval: '',
                    percentChange: '',
                },
                {
                    key: 'retail_price',
                    value: '',
                    label: 'Retail Price per unit',
                    rval: '',
                    percentChange: '',
                },
                {
                    key: 'acv',
                    value: '',
                    label: 'ACV Distribution %',
                    rval: '',
                    percentChange: '',
                },
                {
                    key: 'cogs',
                    value: '',
                    label: 'COGS per unit',
                    rval: '',
                    percentChange: '',
                },
                {
                    key: 'base_elasticity',
                    value: '',
                    label: 'Base Elasticity',
                    rval: '',
                    percentChange: '',
                },
                {
                    key: 'acv_elasticity',
                    value: '',
                    label: 'Acv Elasticity',
                    rval: '',
                    percentChange: '',
                },
            ],
            quarterMetricKeyMapping: [
                {
                    name: 'Volume',
                    value: 'volume',
                    pre: '',
                    post: '',
                },
                {
                    name: 'Revenue',
                    value: 'revenue',
                    pre: '$',
                    post: '',
                },
                {
                    name: 'Profit',
                    value: 'profit',
                    pre: '$',
                    post: '',
                },
                {
                    name: 'Trade Rate Percent',
                    value: 'tradeRatePercent',
                    pre: '',
                    post: '%',
                },
                {
                    name: 'Retailer Margin',
                    value: 'retailerMargin',
                    pre: '',
                    post: '',
                },
            ],
        },
        pricingSimulator: {
            enableAnalyticsTab: true,
            enableBulkUpload: false,
            indexPageTableLimit: 50,
            scenarioFilterOffsetLimit: 50,
            scenarioPerProjectLimit: 10,
            scenarioTableLimit: 500,
            analyticsChartLimit: 100,
            comparisonTableLimit: 50,
            dimAttributesLimit: 4,
            characterLimit: {
                kpiTileCharLimit: 22,
                kpiCompareCardLimit: 30,
            },
            enablePrivatePublicToggle: false,
            enableMicroInfoForTables: false,
            enableOneChangeAnalyticsChart: false,
            defaultGlobalKpiCount: 6,
            disableExport: true,
            indexTableFixedColumns: [
                { label: 'Project Name', key: 'projectName', sortKey: 'project_name' },
                { label: 'Created By', key: 'createdBy', sortKey: 'created_by' },
                { label: 'Status', key: 'status' },
                { label: 'Last Updated', key: 'lastUpdated', sortKey: 'updated_at' },
                { label: 'Simulation Period', key: 'simulationPeriod' },
                { label: 'Price Effective Date', key: 'priceEffectiveDate' },
            ],
            analyticsBaseScenarioFixedColumns: [
                { label: 'Project Name', key: 'projectName', sortKey: 'project_name' },
                { label: 'Created By', key: 'createdBy', sortKey: 'created_by' },
                { label: 'Status', key: 'status' },
            ],
            analyticsTableColumns: [
                { label: 'Report Name', key: 'reportName', sortKey: 'report_name' },
                { label: 'Base Scenario', key: 'baseScenario', sortKey: 'base_scenario' },
                { label: 'Created By', key: 'createdBy', sortKey: 'created_by' },
                { label: 'Last Updated', key: 'lastUpdated', sortKey: 'updated_at' },
                { label: 'Date Created', key: 'dateCreated', sortKey: 'created_at' },
            ],

            projectStatuses: {
                ACTIVE: { label: 'Active', colorType: 'success' },
                DRAFT: { label: 'Draft', colorType: 'processing' },
                SETUP: { label: 'Setup', colorType: 'processing' },
                IN_PROGRESS: { label: 'In-Progress', colorType: 'processing' },
                EXPIRED: { label: 'Expired', colorType: 'default' },
                ERROR: { label: 'Error', colorType: 'error' },
                INVALID: { label: 'Invalid', colorType: 'error' },
            },
            projectDataSource: [{ label: 'Actuals', value: 'depletion_data' }],
            simulatedPeriodItems: [
                { label: 'Custom Date', value: 'custom_date', dateArray: null },
                { label: 'Current Year', value: 'current_year', dateArray: ['01-05-2025', '12-28-2025'] },
                { label: 'Financial Year', value: 'financial_year', dateArray: ['03-02-2025', '02-22-2026'] },
            ],
            iconsMappings: {
                Elasticity: 'BorderOuterOutlined',
                BaseInput: 'BorderlessTableOutlined',
                COGS: 'DollarOutlined',
                Distributor: 'BuildOutlined',
                'Distributor P&L': 'BuildOutlined',
                FOB: 'ClusterOutlined',
                'P & L': 'LineChartOutlined',
                'Price Tree': 'MoneyCollectOutlined',
                Promotions: 'BoxPlotOutlined',
                'Retailer P&L': 'LineChartOutlined',
                Sales: 'AreaChartOutlined',
                Taxes: 'BlockOutlined',
                Volume: 'ExperimentOutlined',
                Others: 'UngroupOutlined',
                Product: 'GoldOutlined',
                Geo: 'ExpandOutlined',
                'Dollar Impact': 'DollarOutlined',
                'Standard Increase Metrics': 'ToTopOutlined',
                'EQV Metrics': 'BlockOutlined',
            },

            categoryMovementKpis: [
                { label: 'Volume Impact', value: 'volume', yAxisLabel: 'Vol', xAxisLabel: 'Retailer Vol' },
                { label: 'Sales Impact', value: 'sales', yAxisLabel: 'Sales $', xAxisLabel: 'Retailer Sales $' },
            ],
        },
        priceChange: {
            // TODO: remove unwanted props
            limit: 60,
            dimensionConfig: {
                //snake case eg sub_category
                excludedDimensions: [],
                defaultDimension: 'Vendor',
            },
            hiddenTableRows: [],
            timePeriodOptions: [
                { label: 'YA', value: 'year_ago' },
                { label: 'Prior Period', value: 'prior_period' },
                { label: 'Custom Period', value: 'custom' },
            ],
            absTileData: [
                { key: 'abs', label: 'Abs' },
                { key: 'percentage', label: '%' },
            ],
            kpiListData: [
                {
                    key: 'avg_price',
                    label: 'Avg Price',
                    value: 'average',
                    dataKey: 'avg_price',
                },
                {
                    key: 'base_price',
                    label: 'Base Price',
                    value: 'base',
                    dataKey: 'base_price',
                },
            ],
            volTileData: [
                {
                    key: 'units',
                    label: 'PU',
                    value: 'units',
                    dataKey: 'units',
                    tooltip: 'Per Unit',
                },
                {
                    key: 'vol',
                    label: 'PEQ',
                    value: 'vol',
                    dataKey: 'volume',
                    tooltip: 'Per Eq Volume',
                },
            ],
            salesTileData: [
                { key: 'sales', label: 'Sales' },
                { key: 'incremental', label: 'Incremental' },
                { key: 'promo', label: 'Promo' },
            ],
            salesAttributionChart: {
                colorList: ['#10AB5E', '#DC3826'],
                colorListType2: ['#758BEE', '#758BEE'],
                profitPoolColor: ['#826FD0', '#826FD0'],
                backGroundColor: 'rgba(0, 0, 0, 0.02)',
            },
            salesAttributionDrillDownChartKeyValueMapping: {
                'feature_&_display': 'Feature & Display',
                'Feature & Display': 'feature_&_display',
            },
            salesAttributionChart2Limit: 20,
        },
        growthAnalysis: {
            limit: 60,
            includeAggPeriod: true,
            dimensionConfig: {
                //snake case eg sub_category
                excludedDimensions: [],
                defaultDimension: 'Vendor',
            },
            absTileData: [
                { key: 'abs', label: 'Abs' },
                { key: 'percentage', label: '%' },
            ],
            subTileData: [
                {
                    label: 'PU',
                    key: 'PU',
                },
                {
                    label: 'PEQ',
                    key: 'PEQ',
                },
            ],
            volTileData: [
                {
                    key: 'val',
                    label: 'Dollars',
                    value: 'val',
                    dataKey: 'value',
                },
                {
                    key: 'vol',
                    label: 'Eq Volume',
                    value: 'vol',
                    dataKey: 'volume',
                },
                {
                    key: 'units',
                    label: 'Units',
                    value: 'units',
                    dataKey: 'units',
                },
                // { key: 'profit', label: 'Profit', value: 'profit', dataKey: 'profit' },
            ],
            showTotal: true,
            currentYearLabel: 'CY',
            yearAgoLabel: 'YA',
            trendChartDropdownData: [
                {
                    key: 'sales_volume',
                    label: 'Sales Volume',
                    value: 'sales_volume',
                    dataKey: 'sales_volume',
                },
                {
                    key: 'sales',
                    label: 'Sales $',
                    value: 'sales',
                    dataKey: 'sales',
                },
                {
                    key: 'average_price',
                    label: 'Average Price',
                    value: 'average_price',
                    dataKey: 'average_price',
                },
                {
                    key: 'base_price',
                    label: 'Base Price',
                    value: 'base_price',
                    dataKey: 'base_price',
                },
                { key: 'acv', label: '%ACV', value: 'acv', dataKey: 'acv' },
                {
                    key: 'avg_items',
                    label: 'Avg. no. of items',
                    value: 'avg_items',
                    dataKey: 'avg_items',
                },
                { key: 'tdp', label: 'TDP', value: 'tdp', dataKey: 'tdp' },
            ],
            salesTileData: [
                { key: 'sales', label: 'Sales' },
                { key: 'incremental', label: 'Incremental' },
                { key: 'promo', label: 'Promo' },
            ],
            graphExportHeaderMapping: {
                promo: ['Non-promo', 'Promo'],
                incremental: ['Base', 'Incremental'],
                sales: ['Sales Change'],
            },
            depletionDropdownData: [
                {
                    value: 'frontline_sales',
                    dataKey: 'frontline_sales',
                    key: 'frontline_sales',
                    label: 'Frontline Sales',
                },
                {
                    value: 'net_sales',
                    dataKey: 'net_sales',
                    key: 'net_sales',
                    label: 'Net Sales',
                },
            ],
            tableKeyUnitMapping: {
                'Market Share CY': {
                    unit: '%',
                    label: 'Market Share CY',
                    includePercentageChange: false,
                },
                'Market Share YA': {
                    unit: '%',
                    label: 'Market Share YA',
                    includePercentageChange: false,
                },
                'ACV CY': {
                    unit: '%',
                    label: 'Wtd. Avg ACV %',
                    includePercentageChange: false,
                },
                'ACV YA': {
                    unit: '%',
                    label: 'Wtd. Avg ACV % YA',
                    includePercentageChange: false,
                },
            },
            salesAttributionChart: {
                colorList: ['#10AB5E', '#DC3826'],
                colorListType2: ['#758BEE', '#758BEE'],
                profitPoolColor: ['#826FD0', '#826FD0'],
                backGroundColor: 'rgba(0, 0, 0, 0.02)',
            },
            salesAttributionDrillDownChartKeyValueMapping: {
                'feature_&_display': 'Feature & Display',
                'Feature & Display': 'feature_&_display',
            },
            salesAttributionChart2DisabledItems: ['unexplained'],
            salesAttributionChart2Limit: 50,
        },
        //BUMP REPORT
        bumpReport: {
            mainHeader: 'Bump Report',
            groupByKey: 'groupBy',
            comparisonTileData: [
                { key: 'cy_vs_ya', label: 'CY vs YA' },
                { key: 'difference', label: 'Difference' },
            ],
            enablePromoCalender: true,
            isPromoUpliftPercentValue: false,
            volGroupByOptionsMapping: {
                vol: [
                    {
                        value: 'total_eq_volume',
                        label: 'Total EQ Volume',
                        index: 1,
                    },
                    {
                        value: 'any_promo_eq_volume',
                        label: 'Any promo EQ Volume',
                        index: 1,
                    },
                    {
                        value: 'no_promo_eq_volume',
                        label: 'No Promo EQ Volume',
                        index: 1,
                    },

                    {
                        value: 'base_eq_volume',
                        label: 'Base EQ Volume',
                        index: 0,
                    },
                    {
                        value: 'incremental_eq_volume',
                        label: 'Incremental EQ Volume Total',
                        index: 0,
                    },
                    {
                        value: 'tpr_incremental_eq_volume',
                        label: 'Incremental EQ Volume TPR',
                        index: 0,
                    },
                    {
                        value: 'feature_incremental_eq_volume',
                        label: 'Incremental EQ Volume Feature',
                        index: 0,
                    },
                    {
                        value: 'display_incremental_eq_volume',
                        label: 'Incremental EQ Volume Display',
                        index: 0,
                    },
                    {
                        value: 'feature_and_display_incremental_eq_volume',
                        label: 'Incremental EQ Volume Feature & Display',
                        index: 0,
                    },
                ],
                val: [
                    { value: 'total_value', label: 'Total Value', index: 1 },
                    {
                        value: 'any_promo_value',
                        label: 'Any Promo Value',
                        index: 1,
                    },
                    {
                        value: 'no_promo_value',
                        label: 'No Promo Value',
                        index: 1,
                    },
                    { value: 'base_value', label: 'Base Value', index: 0 },
                    {
                        value: 'incremental_value',
                        label: 'Incremental Value Total',
                        index: 0,
                    },
                    {
                        value: 'tpr_incremental_value',
                        label: 'Incremental Value TPR',
                        index: 0,
                    },
                    {
                        value: 'feature_incremental_value',
                        label: 'Incremental Value Feature',
                        index: 0,
                    },
                    {
                        value: 'display_incremental_value',
                        label: 'Incremental Value Display',
                        index: 0,
                    },
                    {
                        value: 'feature_and_display_incremental_value',
                        label: 'Incremental Value Feature & Display',
                        index: 0,
                    },
                ],
                units: [
                    { value: 'total_units', label: 'Total Units', index: 1 },
                    {
                        value: 'any_promo_units',
                        label: 'Any Promo Units',
                        index: 1,
                    },
                    {
                        value: 'no_promo_units',
                        label: 'No Promo Units',
                        index: 1,
                    },
                    { value: 'base_units', label: 'Base Units', index: 0 },
                    {
                        value: 'incremental_units',
                        label: 'Incremental Units Total',
                        index: 0,
                    },
                    {
                        value: 'tpr_incremental_units',
                        label: 'Incremental Units TPR',
                        index: 0,
                    },
                    {
                        value: 'feature_incremental_units',
                        label: 'Incremental Units Feature',
                        index: 0,
                    },
                    {
                        value: 'display_incremental_units',
                        label: 'Incremental Units Display',
                        index: 0,
                    },
                    {
                        value: 'feature_and_display_incremental_units',
                        label: 'Incremental Units Feature & Display',
                        index: 0,
                    },
                ],
            },
            tooltipKeyLabelMapping: {
                increments: 'Incremental',
                promo: 'Any Promo',
            },
            bumpReportTileData: [
                { key: 'increments', label: 'Attribution' },
                { key: 'promo', label: 'Consumption' },
                { key: 'groupBy', label: 'Group By' },
            ],
            bumpReportTile1Data: [
                {
                    key: 'promo',
                    label: 'Promotions',
                    visibleTabs: ['increments', 'promo', 'groupBy'],
                }, //keys should match bumpReportTileData keys
            ],
            bumpReportTile2Data: [
                { key: 'total', label: 'Total' },
                { key: 'breakout', label: 'Breakout' },
            ],
            absTileData: [
                { key: 'abs', label: 'Abs' },
                { key: 'percentage', label: '%' },
            ],

            volTileData: [
                { key: 'val', label: 'Dollars', dataKey: 'value' },
                { key: 'vol', label: 'Eq Volume', dataKey: 'volume' },
                { key: 'units', label: 'Units', dataKey: 'units' },
            ],
            bumpChartY2Colors: [
                '#293BB8',
                '#DD449F',
                '#9E5897',
                '#19669D',
                '#43C9E2',
                '#37C7BE',
                '#00798C',
                '#E8A122',
                '#E06936',
                '#A5582D',
            ],
            bumpChartY2AxisOptions: {
                vol: [
                    {
                        value: 'avg_price_per_eq',
                        index: 0,
                        label: 'Avg. Price/EQ',
                        unit: '',
                    },
                    {
                        value: 'base_price_per_eq',
                        index: 0,
                        label: 'Base Price/EQ',
                        unit: '',
                    },
                    {
                        value: 'promo_price_per_eq',
                        index: 0,
                        label: 'Promo Price/EQ',
                        unit: '',
                    },
                    {
                        value: 'market_share_volume',
                        index: 0,
                        label: 'Market Share %',
                        unit: '',
                    },
                    {
                        value: 'distribution_tdp',
                        index: 0,
                        label: 'Distribution TDP',
                        unit: '',
                    },
                    {
                        value: 'display_tdp',
                        index: 0,
                        label: 'Display TDP',
                        unit: '',
                    },
                    {
                        value: 'feature_tdp',
                        index: 0,
                        label: 'Feature TDP',
                        unit: '',
                    },
                    {
                        value: 'feature_and_display_tdp',
                        index: 0,
                        label: 'Feature and Display TDP',
                        unit: '',
                    },
                    {
                        value: 'distribution_acv',
                        index: 0,
                        label: 'Distribution ACV %',
                        unit: '',
                    },
                    {
                        value: 'display_acv',
                        index: 0,
                        label: 'Display ACV %',
                        unit: '',
                    },
                    {
                        value: 'feature_acv',
                        index: 0,
                        label: 'Feature ACV %',
                        unit: '',
                    },
                    {
                        value: 'feature_and_display_acv',
                        index: 0,
                        label: 'Feature & Display ACV %',
                        unit: '',
                    },
                    {
                        value: 'unit_velocity',
                        index: 0,
                        label: 'Unit Velocity',
                        unit: '',
                    },
                    {
                        value: 'sales_velocity',
                        index: 0,
                        label: 'Dollar Velocity',
                        unit: '$',
                    },
                    {
                        value: 'volume_velocity',
                        index: 0,
                        label: 'Eq Velocity',
                        unit: '',
                    },
                    {
                        value: 'subsidized_base_sales',
                        index: 0,
                        label: 'Subsidized Base Sales',
                        unit: '',
                    },
                ],
                val: [
                    {
                        value: 'avg_price_per_unit',
                        index: 0,
                        label: 'Avg. Price/Unit ($)',
                        unit: '',
                    },
                    {
                        value: 'base_price_per_unit',
                        index: 0,
                        label: 'Base Price/unit',
                        unit: '',
                    },
                    {
                        value: 'promo_price_per_unit',
                        index: 0,
                        label: 'Promo Price/Unit',
                        unit: '',
                    },
                    {
                        value: 'market_share_value',
                        index: 0,
                        label: 'Market Share %',
                        unit: '',
                    },
                    {
                        value: 'distribution_tdp',
                        index: 0,
                        label: 'Distribution TDP',
                        unit: '',
                    },
                    {
                        value: 'display_tdp',
                        index: 0,
                        label: 'Display TDP',
                        unit: '',
                    },
                    {
                        value: 'feature_tdp',
                        index: 0,
                        label: 'Feature TDP',
                        unit: '',
                    },
                    {
                        value: 'feature_and_display_tdp',
                        index: 0,
                        label: 'Feature and Display TDP',
                        unit: '',
                    },
                    {
                        value: 'distribution_acv',
                        index: 0,
                        label: 'Distribution ACV %',
                        unit: '',
                    },
                    {
                        value: 'display_acv',
                        index: 0,
                        label: 'Display ACV %',
                        unit: '',
                    },
                    {
                        value: 'feature_acv',
                        index: 0,
                        label: 'Feature ACV %',
                        unit: '',
                    },
                    {
                        value: 'feature_and_display_acv',
                        index: 0,
                        label: 'Feature & Display ACV %',
                        unit: '',
                    },
                    {
                        value: 'unit_velocity',
                        index: 0,
                        label: 'Unit Velocity',
                        unit: '',
                    },
                    {
                        value: 'sales_velocity',
                        index: 0,
                        label: 'Dollar Velocity',
                        unit: '$',
                    },
                    {
                        value: 'volume_velocity',
                        index: 0,
                        label: 'Eq Velocity',
                        unit: '',
                    },
                    {
                        value: 'subsidized_base_sales',
                        index: 0,
                        label: 'Subsidized Base Sales',
                        unit: '',
                    },
                ],
                units: [
                    {
                        value: 'avg_price_per_unit',
                        index: 0,
                        label: 'Avg. Price/Unit ($)',
                        unit: '',
                    },
                    {
                        value: 'base_price_per_unit',
                        index: 0,
                        label: 'Base Price/unit',
                        unit: '',
                    },
                    {
                        value: 'promo_price_per_unit',
                        index: 0,
                        label: 'Promo Price/Unit',
                        unit: '',
                    },
                    {
                        value: 'market_share_units',
                        index: 0,
                        label: 'Market Share %',
                        unit: '',
                    },
                    {
                        value: 'distribution_tdp',
                        index: 0,
                        label: 'Distribution TDP',
                        unit: '',
                    },
                    {
                        value: 'display_tdp',
                        index: 0,
                        label: 'Display TDP',
                        unit: '',
                    },
                    {
                        value: 'feature_tdp',
                        index: 0,
                        label: 'Feature TDP',
                        unit: '',
                    },
                    {
                        value: 'feature_and_display_tdp',
                        index: 0,
                        label: 'Feature and Display TDP',
                        unit: '',
                    },
                    {
                        value: 'distribution_acv',
                        index: 0,
                        label: 'Distribution ACV %',
                        unit: '',
                    },
                    {
                        value: 'display_acv',
                        index: 0,
                        label: 'Display ACV %',
                        unit: '',
                    },
                    {
                        value: 'feature_acv',
                        index: 0,
                        label: 'Feature ACV %',
                        unit: '',
                    },
                    {
                        value: 'feature_and_display_acv',
                        index: 0,
                        label: 'Feature & Display ACV %',
                        unit: '',
                    },
                    {
                        value: 'unit_velocity',
                        index: 0,
                        label: 'Unit Velocity',
                        unit: '',
                    },
                    {
                        value: 'sales_velocity',
                        index: 0,
                        label: 'Dollar Velocity',
                        unit: '$',
                    },
                    {
                        value: 'volume_velocity',
                        index: 0,
                        label: 'Eq Velocity',
                        unit: '',
                    },
                    {
                        value: 'subsidized_base_sales',
                        index: 0,
                        label: 'Subsidized Base Sales',
                        unit: '',
                    },
                ],
            },
            promoTypeColorMapping: {
                'tpr/scan': {
                    label: 'TPR/Scan',
                    color: colorConstants.lightGreenAlt,
                },
                'feature ad': {
                    label: 'Feature Ad',
                    color: colorConstants.darkGreenAlt2,
                },
                display: { label: 'Display', color: colorConstants.pinkAlt },
                feature_display_tpr: {
                    label: 'Feature_Display_TPR',
                    color: colorConstants.orangeAlt2,
                },
                display_tpr: {
                    label: 'Display_TPR',
                    color: colorConstants.darkBlueAlt,
                },
            },
            stackedColors: [
                colorConstants.lightGreenAlt,
                colorConstants.darkGreenAlt2,
                colorConstants.pinkAlt,
                colorConstants.orangeAlt2,
                colorConstants.darkYellow,
            ],
            fieldKeyLabelMapping: {
                base_eq_volume: {
                    label: 'Base Sales (Eq Vol)',
                    color: colorConstants.darkYellow,
                    tableLabel: 'Base',
                },
                base_value: {
                    label: 'Base Sales ($)',
                    color: colorConstants.darkYellow,
                    tableLabel: 'Base',
                },
                base_units: {
                    label: 'Base Units',
                    color: colorConstants.darkYellow,
                    tableLabel: 'Base',
                },
                incremental_eq_volume: {
                    label: 'Incremental Sales (Eq Vol)',
                    color: colorConstants.darkGreenAlt2,
                    tableLabel: 'Incremental',
                },
                incremental_value: {
                    label: 'Incremental Sales ($)',
                    color: colorConstants.darkGreenAlt2,
                    tableLabel: 'Incremental',
                },
                incremental_units: {
                    label: 'Incremental Units',
                    color: colorConstants.darkGreenAlt2,
                    tableLabel: 'Incremental',
                },
                any_promo_eq_volume: {
                    label: 'Promo',
                    color: colorConstants.darkGreenAlt2,
                    tableLabel: 'Promo',
                },
                any_promo_value: {
                    label: 'Promo',
                    color: colorConstants.darkGreenAlt2,
                    tableLabel: 'Promo',
                },
                any_promo_units: {
                    label: 'Promo',
                    color: colorConstants.darkGreenAlt2,
                    tableLabel: 'Promo',
                },
                tpr_incremental_eq_volume: {
                    label: 'TPR Incremental',
                    color: colorConstants.lightGreenAlt,
                    tableLabel: 'TPR Incremental',
                },
                feature_incremental_eq_volume: {
                    label: 'Feature Incremental',
                    color: colorConstants.darkGreenAlt2,
                    tableLabel: 'Feature Incremental',
                },
                display_incremental_eq_volume: {
                    label: 'Display Incremental',
                    color: colorConstants.pinkAlt,
                    tableLabel: 'Display Incremental',
                },
                feature_and_display_incremental_eq_volume: {
                    label: 'F & D Incremental',
                    color: colorConstants.orangeAlt2,
                    tableLabel: 'F & D Incremental',
                },
                tpr_incremental_value: {
                    label: 'TPR Incremental',
                    color: colorConstants.lightGreenAlt,
                    tableLabel: 'TPR Incremental',
                },
                feature_incremental_value: {
                    label: 'Feature Incremental',
                    color: colorConstants.darkGreenAlt2,
                    tableLabel: 'Feature Incremental',
                },
                display_incremental_value: {
                    label: 'Display Incremental',
                    color: colorConstants.pinkAlt,
                    tableLabel: 'Display Incremental',
                },
                feature_and_display_incremental_value: {
                    label: 'F & D Incremental',
                    color: colorConstants.orangeAlt2,
                    tableLabel: 'F & D Incremental',
                },
                tpr_incremental_units: {
                    label: 'TPR Incremental',
                    color: colorConstants.lightGreenAlt,
                    tableLabel: 'TPR Incremental',
                },
                feature_incremental_units: {
                    label: 'Feature Incremental',
                    color: colorConstants.darkGreenAlt2,
                    tableLabel: 'Feature Incremental',
                },
                display_incremental_units: {
                    label: 'Display Incremental',
                    color: colorConstants.pinkAlt,
                    tableLabel: 'Display Incremental',
                },
                feature_and_display_incremental_units: {
                    label: 'F & D Incremental',
                    color: colorConstants.orangeAlt2,
                    tableLabel: 'F & D Incremental',
                },
                tpr_only_eq_volume: {
                    label: 'TPR',
                    color: colorConstants.lightGreenAlt,
                    tableLabel: 'TPR',
                },
                tpr_only_value: {
                    label: 'TPR',
                    color: colorConstants.lightGreenAlt,
                    tableLabel: 'TPR',
                },
                feature_only_eq_volume: {
                    label: 'Feature',
                    color: colorConstants.darkGreenAlt2,
                    tableLabel: 'Feature',
                },
                feature_only_value: {
                    label: 'Feature',
                    color: colorConstants.darkGreenAlt2,
                    tableLabel: 'Feature',
                },
                display_only_eq_volume: {
                    label: 'Display',
                    color: colorConstants.pinkAlt,
                    tableLabel: 'Display',
                },
                display_only_value: {
                    label: 'Display',
                    color: colorConstants.pinkAlt,
                    tableLabel: 'Display',
                },
                feature_and_display_only_eq_volume: {
                    label: 'F & D',
                    color: colorConstants.orangeAlt2,
                    tableLabel: 'F & D',
                },
                feature_and_display_only_value: {
                    label: 'F & D',
                    color: colorConstants.orangeAlt2,
                    tableLabel: 'F & D',
                },
                no_promo_eq_volume: {
                    label: 'Non Promo',
                    color: colorConstants.darkYellow,
                    tableLabel: 'Non Promo',
                },
                no_promo_value: {
                    label: 'Non Promo',
                    color: colorConstants.darkYellow,
                    tableLabel: 'Non Promo',
                },
                tpr_only_units: {
                    label: 'TPR',
                    color: colorConstants.lightGreenAlt,
                    tableLabel: 'TPR',
                },
                feature_only_units: {
                    label: 'Feature',
                    color: colorConstants.darkGreenAlt2,
                    tableLabel: 'Feature',
                },
                display_only_units: {
                    label: 'Display',
                    color: colorConstants.pinkAlt,
                    tableLabel: 'Display',
                },
                feature_and_display_only_units: {
                    label: 'F & D',
                    color: colorConstants.orangeAlt2,
                    tableLabel: 'F & D',
                },
                no_promo_units: {
                    label: 'Non Promo',
                    color: colorConstants.darkYellow,
                    tableLabel: 'Non Promo',
                },

                //for export label
                sales_year_ago: { label: 'YA Sales' },
                total_value: { label: 'Total' },
                incremental_eq_volume_percentage: {
                    label: 'Incremental Sales Percentage',
                },
                incremental_value_percentage: {
                    label: 'Incremental Sales Percentage',
                },
                incremental_units_percentage: {
                    label: 'Incremental Sales Percentage',
                },
                base_value_percentage: { label: 'Base Sales Percentage' },
                base_eq_volume_percentage: { label: 'Base Sales Percentage' },
                base_units_percentage: { label: 'Base Units Percentage' },
                any_promo_eq_volume_percentage: { label: 'Promo Percentage' },
                any_promo_value_percentage: { label: 'Promo Percentage' },
                any_promo_units_percentage: { label: 'Promo Percentage' },
                no_promo_eq_volume_percentage: {
                    label: 'Non Promo Percentage',
                },
                no_promo_units_percentage: { label: 'Non Promo Percentage' },
                no_promo_value_percentage: { label: 'Non Promo Percentage' },
            },

            tooltipExtraItems: {
                tpr_acv: { label: 'Tpr ACV %' },
                display_acv: { label: 'Display ACV %' },
                feature_acv: { label: 'Feature ACV %' },
                feature_and_display_acv: { label: 'F&D ACV %' },
                uplift: { label: 'Uplift' },
                promo_lift: { label: 'Promo Uplift' },
                media_lift: { label: 'Media Uplift' },
            },
            promoCalenderAttributeLevels: {
                promo: [
                    { value: 'product', label: 'Product' },
                    { value: 'geography', label: 'Geography' },
                ],
            },
            overlayKeys: {
                promo: [
                    { label: 'Start Week', dataKey: 'startTimestamp' },
                    { label: 'End Week', dataKey: 'endTimestamp' },
                    { label: 'Product', dataKey: 'product' },
                    { label: 'Promo Mechanics', dataKey: 'promoMech' },
                    { label: 'Promo Type', dataKey: 'promoType' },
                    { label: 'Investment', dataKey: 'field_value' },
                    // { label: 'ROI', dataKey: 'roi' },
                    // { label: 'Lift', dataKey: 'lift' },
                    // { label: 'Incremental Profit', dataKey: 'incrementalProfit' },
                    // { label: 'Incremental Retailer Profit', dataKey: 'incrementalRetailerProfit' },
                ],
            },
        },
        //PROMO SCORE CARD
        promoScoreCard: {
            mainHeader: 'Promotional Score Card',
            limit: 50,
            nestedTableLimit: 10,
            questionsNo: [1, 2, 3, 4, 5, 6, 7, 8],
            question: {
                Q: [
                    'Am I getting my fair share of quality support? ',
                    'How does my % Discount compare to competition? ',
                    'What % of Volume was sold on promotion? ',
                    'How many weeks am I promoting? ',
                    'What is my average price per eq volume? ',
                    'What is my average price/units? ',
                    'What is my value share of promotions? ',
                    'What is my volume share of promotions? ',
                ],
                unitsInItalics: [
                    '(Fair Share Index -$ Sold)',
                    '(Weighted Average % Price Reduction)',
                    '(% of Volume)',
                    '(Weighted Weeks)',
                    '(Price per bars/oz)',
                    '(Price per Unit)',
                    '(Value share %)',
                    '(EQ Volume %)',
                ],
                unit: ['value', '%', '%', 'week', '$', '$', '%', '%'],
                numberFormateDecimal: [0, 1, 1, 0, 2, 2, 1, 1],
            },
            promoTypeLabelMapping: {
                display: { label: 'Display Only' },
                tpr: { label: 'TPR Only' },
                feature: { label: 'Feature Only' },
                feature_and_display: { label: 'Feature & Display Only' },
                feature_display: { label: 'Feature & Display Only' },
            },
            showGradientTile: true,
            promoType: ['TPR Only', 'Display Only', 'Feature Only', 'Feature & Display Only'],
            promoExpandedViewTableUnit: 'volume',
            promoExpandedViewTableSalesAndVolumeLabel: ['EQ Volume', 'Total Sales $'],
            dropDown: ['Vendor', 'Brand', 'Sub_Brand'],
            listFor: ['Vendor', 'Brand', 'Sub_Brand', 'Product'],
            listForToDisplay: ['Vendor', 'Brand', 'Sub_Brand', 'Product'],
            listIn: ['Category', 'Sub_Category', 'Pack_Size', 'Form', 'Segment', 'Retailer'],
        },
        // PROMO LANDSCAPE
        promoLandscape: {
            mainHeader: 'Investment & ROI Tracker',
            roiLabel: 'ROI',
            defaultAttributeTypeIndex: 10,
            optimalInvestmentIndexThreshold1: 0.8,
            optimalInvestmentIndexThreshold2: 1.2,
            promoTacticDropdownName: 'Investment Type',
            dimensionConfig: {
                //snake case eg sub_category
                excludedDimensions: [],
                defaultDimension: '',
            },
            thresholdColorMapping: {
                optimal: { label: 'Optimal', color: colorConstants.darkGreen },
                over: { label: 'Over', color: colorConstants.darkRed },
                under: { label: 'Under', color: colorConstants.darkBlueAlt },
            },
            limit: 60,
            promoTypes: [
                { value: 'display', label: 'Display' },
                { value: 'tpr', label: 'TPR' },
                { value: 'feature', label: 'Feature' },
                // { value: 'feature & display', label: 'Feature & Display' },  //not required for now
            ],
            mediaLevelsDropdown: [],
            optimalIndexKey: 'competition_spend_index',
            showInvestmentDropdown: false,
            tableRowsKeyMapping: [
                {
                    label: 'Investment',
                    children: null,
                    parentKey: null,
                    key: 'investments',
                    unit: '$',
                },
                {
                    label: 'ROI',
                    children: null,
                    parentKey: null,
                    key: 'roi',
                    unit: '',
                },
                {
                    label: 'Optimal Investment Index',
                    children: [
                        {
                            label: 'Share of Investment',
                            key: 'share_of_investment',
                            unit: '',
                        },
                        {
                            label: 'Share of Sales',
                            key: 'share_of_sales',
                            unit: '',
                        },
                    ],
                    unit: '',
                    parentKey: 'competition_data',
                    key: 'competition_spend_index',
                },
                {
                    label: 'Incremental Sales Dollar',
                    children: [
                        {
                            label: 'Total Sales Dollar',
                            key: 'total_sales',
                            unit: '$',
                        },
                        {
                            label: 'Base Sales Dollar',
                            key: 'base_sales_dollar',
                            unit: '$',
                        },
                        {
                            label: 'Incremental Sales Eq',
                            key: 'incremental_sales_eq',
                            unit: '',
                        },
                        {
                            label: 'Total Sales Eq',
                            key: 'total_sales_eq',
                            unit: '',
                        },
                        {
                            label: 'Base Sales Eq',
                            key: 'base_sales_eq',
                            unit: '',
                        },
                    ],
                    unit: '$',
                    parentKey: 'incremental_sales_dollar_data',
                    key: 'incremental_sales_dollar',
                },
                {
                    label: 'Incremental Profit',
                    children: [
                        {
                            label: 'Share of Profit Pool',
                            key: 'share_of_profit_pool',
                            unit: '',
                        },
                        {
                            label: 'Total Profit',
                            key: 'total_profit',
                            unit: '',
                        },
                        {
                            label: 'Baseline Profit',
                            key: 'baseline_profit',
                            unit: '',
                        },

                        {
                            label: 'Incremental Net Sales',
                            key: 'incremental_net_sales',
                            unit: '$',
                        },
                        {
                            label: 'Total Net Sales',
                            key: 'total_net_sales',
                            unit: '$',
                        },
                        {
                            label: 'Baseline Net Sales',
                            key: 'baseline_net_sales',
                            unit: '$',
                        },
                        {
                            label: 'Promo % Margin',
                            key: 'promo_percentage_margin',
                            unit: '',
                        },
                        {
                            label: 'Baseline % Margin',
                            key: 'baseline_percentage_margin',
                            unit: '',
                        },
                    ],
                    parentKey: 'incremental_profit_data',
                    key: 'incremental_profit',
                    unit: '$',
                },
                {
                    label: 'Incremental Retailer Profit',
                    unit: '$',
                    children: [
                        {
                            label: 'Share of Profit Pool',
                            key: 'share_of_profit_pool_retailer',
                            unit: '',
                        },
                        {
                            label: 'Total Retailer Profit',
                            key: 'total_retailer_profit',
                            unit: '',
                        },
                        {
                            label: 'Baseline Retailer Profit',
                            key: 'baseline_retailer_profit',
                            unit: '',
                        },
                        {
                            label: 'Retailer Promo % Margin',
                            key: 'retailer_promo_percentage_margin',
                            unit: '',
                        },
                        {
                            label: 'Retailer Baseline % Margin',
                            key: 'retailer_baseline_percentage_margin',
                            unit: '',
                        },
                    ],
                    parentKey: 'incremental_retailer_profit_data',
                    key: 'incremental_retailer_profit',
                },
            ],
        },
        //PORTFOLIO ANALYSIS
        portfolioAnalysis: {
            mainHeader: 'Promo ROI Analysis',
            limit: 20,
            defaultGroupByIndex: 18,
            defaultGroupBy2Index: 5,
            chartColors: [],
            absTileData: [
                { key: 'Promotions', label: 'Promotions' },
                { key: 'Drivers', label: 'Drivers' },
            ],
            salesAttributionChart: {
                colorList: ['#10AB5E', '#DC3826'],
                colorListType2: ['#758BEE', '#758BEE'],
                profitPoolColor: ['#826FD0', '#826FD0'],
                backGroundColor: 'rgba(0, 0, 0, 0.02)',
            },
            // chartColors: [
            //     '#E8A122',
            //     '#293BB8',
            //     '#E06936',
            //     '#19669D',
            //     '#A5582D',
            //     '#43C9E2',
            //     '#DD449F',
            //     '#37C7BE',
            //     '#9E5897',
            //     '#00798C',
            //     '#EDB44E',
            //     '#4557D5',
            //     '#E6875E',
            //     '#228BD6',
            //     '#CC7442',
            //     '#69D4E8',
            //     '#E469B2',
            //     '#5FD3CB',
            //     '#B377AD',
            //     '#3394A3',
            //     '#F1C77A',
            //     '#7381E0',
            //     '#ECA586',
            //     '#55A8E4',
            //     '#D89672',
            //     '#8EDFEE',
            //     '#EB8FC5',
            //     '#87DED8',
            //     '#C699C2',
            //     '#66AFBA',
            //     '#F6D9A7',
            //     '#A2ABEA',
            //     '#F3C3AF',
            //     '#8EC5ED',
            //     '#E5B9A1',
            //     '#B4E9F3',
            //     '#F1B4D9',
            //     '#AFE9E5',
            //     '#D9BBD6',
            //     '#99C9D1',
            //     '#FAECD3',
            //     '#D0D5F5',
            //     '#F9E1D7',
            //     '#C6E2F6',
            //     '#F2DCD0',
            //     '#D9F4F9',
            //     '#F8DAEC',
            //     '#D7F4F2',
            //     '#ECDDEB',
            //     '#CCE4E8',
            // ],
            chartDropdownExtraKpis: [
                {
                    dimension: 'none',
                    label: 'Tactics',
                    dataKey: 'tactic_description',
                },
                {
                    dimension: 'none',
                    label: 'Mechanics',
                    dataKey: 'promotion_mechanic',
                },
                {
                    dimension: 'none',
                    label: 'Event Name',
                    dataKey: 'event_name',
                },
                {
                    dimension: 'dim1',
                    label: 'Week',
                    dataKey: 'week',
                },
            ],
            groupByHeaders: [
                {
                    label: 'Category',
                    value: 'category',
                    dimension: 'dim1',
                    isSelected: false,
                    sortKey: 'category',
                    multiSelectFilter: false,
                },
                {
                    label: 'Sub Category',
                    value: 'sub_category',
                    dimension: 'dim1',
                    isSelected: false,
                    sortKey: 'sub_category',
                    multiSelectFilter: false,
                },
                {
                    label: 'Brand',
                    value: 'brand',
                    dimension: 'dim1',
                    isSelected: true,
                    sortKey: 'brand',
                    multiSelectFilter: false,
                },
                {
                    label: 'Sub Brand',
                    value: 'sub_brand',
                    dimension: 'dim1',
                    isSelected: false,
                    sortKey: 'sub_brand',
                    multiSelectFilter: false,
                },
                {
                    label: 'Product',
                    value: 'product',
                    dimension: 'dim1',
                    isSelected: true,
                    sortKey: 'product',
                    multiSelectFilter: false,
                },
                {
                    label: 'Mechanics',
                    value: 'promotion_mechanic',
                    dimension: null,
                    isSelected: false,
                    sortKey: 'promotion_mechanic',
                    multiSelectFilter: true,
                },
                {
                    label: 'Tactic',
                    value: 'tactic_description',
                    dimension: null,
                    isSelected: false,
                    sortKey: 'tactic_description',
                    multiSelectFilter: true,
                },
                {
                    label: 'Week',
                    value: 'week',
                    dimension: null,
                    isSelected: true,
                    sortKey: 'week',
                    multiSelectFilter: false,
                },
            ],
            chartHeaderLabelKeyMapping: {
                lift: { label: 'Lift' },
                roi: { label: 'ROI' },
                investments: { label: 'Investments' },
                incremental_net_sales: { label: 'Incremental Net Sales' },
                incremental_profit: { label: 'Incremental Profit' },
                incremental_retailer_profit: {
                    label: 'Incremental Retailer Profit',
                },
                acv: { label: 'ACV Distribution' },
                profit_pool: { label: 'Profit Pool' },
                tpr_acv: { label: 'Tpr ACV' },
                display_acv: { label: 'Display ACV' },
                feature_acv: { label: 'Feature ACV' },
                feature_and_display_acv: { label: 'F&D ACV' },
                total_acv: { label: 'Total ACV' },
                weeks: { label: 'Promo Weeks' },
            },
            promoTypesChartLegends: [
                {
                    label: 'TPR',
                    color: colorConstants.lightCyan,
                    style: {
                        borderRadius: '100%',
                        height: `8px`,
                        width: '8px',
                    },
                },
                {
                    label: 'Feature',
                    color: colorConstants.lightCream,
                    style: {
                        borderRadius: '100%',
                        height: `8px`,
                        width: '8px',
                    },
                },
                {
                    label: 'Display',
                    color: colorConstants.lightPink,
                    style: {
                        borderRadius: '100%',
                        height: `8px`,
                        width: '8px',
                    },
                },
            ],
            promoTypes: ['tpr', 'feature', 'display'],
            promoTypesLabelMapping: {
                tpr: 'TPR',
                feature: 'Feature',
                display: 'Display',
            },
        },
        promoRecommendation: {
            playbookLimit: 50,
            clientName: 'Kind',
            mainHeader: 'Promo Recommendation',
            retailerKey: 'Retailer',
            hideAddSpends: false,
            calenderStartDay: 'Monday',
            spendLeversList: [
                {
                    label: 'Baseline Volume',
                    placeholder: 'Baseline Volume',
                    value: 'baseVolume',
                    isDisabled: false,
                },
                {
                    label: 'Uplift',
                    placeholder: 'Uplift',
                    value: 'uplift',
                    isDisabled: false,
                },
                {
                    label: 'Total Volume',
                    placeholder: 'Total Volume',
                    value: 'totalVolume',
                    isDisabled: true,
                },
                {
                    label: `Total Kind Profit ($)`,
                    placeholder: `Total Kind Profit`,
                    value: 'totalKindProfit',
                    isDisabled: true,
                },
                {
                    label: 'ROI',
                    placeholder: 'ROI',
                    value: 'roi',
                    isDisabled: true,
                },
                {
                    label: `Total Retailer Profit ($)`,
                    placeholder: 'Total Retailer Profit',
                    value: 'totalRetailerProfit',
                    isDisabled: true,
                },
            ],
            spendTypeList: [
                {
                    label: 'Lump Sum',
                    value: 'lump_sum',
                    inputRule: '',
                },
                {
                    label: 'Per Qty',
                    value: 'per_qty',
                    inputRule: '',
                },
                {
                    label: 'Display',
                    value: 'display',
                    inputRule: '',
                },
                {
                    label: 'Feature',
                    value: 'feature',
                    inputRule: '',
                },
            ],
            playbookKeyMapping: {
                Product: ['ppgName'],
                '%TS': ['guidelinePercentageTotalSpends', 'percentageTotalSpends', 'lesser_than', '', '%'],
                Frequency: ['guidelineFrequency', 'frequency', 'range', ''],
                ROI: ['guidelineRoi', 'roi', 'greater_than', '', ''],
            },
            // comparisonOperator: {
            //     '%TS': '<',
            //     Frequency: 'range',
            //     ROI: '>',
            // },
            menuButtons: [
                { key: 'recommendations', label: 'Recommendations' },
                {
                    key: 'summary',
                    label: 'Summary',
                },
                {
                    key: 'playbook',
                    label: 'Playbook',
                },
            ],

            promoTypeColorMapping: {
                'tpr/scan': {
                    label: 'TPR/Scan',
                    color: colorConstants.lightGreenAlt,
                },
                feature_ad: {
                    label: 'Feature Ad',
                    color: colorConstants.darkGreenAlt2,
                },
                display: { label: 'Display', color: colorConstants.pinkAlt },
                feature_display_tpr: {
                    label: 'Feature_Display_TPR',
                    color: colorConstants.orangeAlt2,
                },
                display_tpr: {
                    label: 'Display_TPR',
                    color: colorConstants.darkBlueAlt,
                },
            },
            overlayKeys: [
                {
                    label: 'Start Date',
                    dataKey: 'startDate',
                    pre: '',
                    post: '',
                },
                { label: 'Duration', dataKey: 'duration', pre: '', post: '' },
                {
                    label: 'Promo Type',
                    dataKey: 'tacticDescription',
                    pre: '',
                    post: '',
                },
                { label: 'Product(s)', dataKey: 'dim1AttributeNames', pre: '', post: '' },
                {
                    label: 'Total Volume',
                    dataKey: 'totalVolume',
                    pre: '',
                    post: '',
                    arrowConfig: 'positiveUp',
                },
                {
                    label: 'Total GSV',
                    dataKey: 'totalGsv',
                    pre: '$',
                    post: '',
                    arrowConfig: 'positiveUp',
                },
                {
                    label: 'Total NSV',
                    dataKey: 'totalNsv',
                    pre: '$',
                    post: '',
                    arrowConfig: 'positiveUp',
                },
                {
                    label: 'Total KIND Profit',
                    dataKey: 'totalKindProfit',
                    pre: '$',
                    post: '',
                    arrowConfig: 'positiveUp',
                },
                {
                    label: 'Total Retailer Profit',
                    dataKey: 'totalRetailerProfit',
                    pre: '$',
                    post: '',
                    arrowConfig: 'positiveUp',
                },
                {
                    label: 'Promo Spends',
                    dataKey: 'promoSpends',
                    pre: '$',
                    post: '',
                    arrowConfig: 'negativeUp',
                },
                {
                    label: '% Trade Spends GSV',
                    dataKey: 'percentageTradeSpendsGsv',
                    pre: '',
                    post: '%',
                    arrowConfig: 'negativeUp',
                },
                {
                    label: '% Trade Spends NSV',
                    dataKey: 'percentageTradeSpendsNsv',
                    pre: '',
                    post: '%',
                    arrowConfig: 'negativeUp',
                },

                {
                    label: 'Incremental Volume',
                    dataKey: 'incrementalVolume',
                    pre: '',
                    post: '',
                    arrowConfig: 'positiveUp',
                },
                {
                    label: 'Incremental GSV',
                    dataKey: 'incrementalGsv',
                    pre: '$',
                    post: '',
                    arrowConfig: 'positiveUp',
                },
                {
                    label: 'Incremental NSV',
                    dataKey: 'incrementalNsv',
                    pre: '$',
                    post: '',
                    arrowConfig: 'positiveUp',
                },
                {
                    label: 'Total Profit %',
                    dataKey: 'totalProfitPercentage',
                    pre: '',
                    post: '%',
                    arrowConfig: 'positiveUp',
                },
                {
                    label: 'Incremental Profit',
                    dataKey: 'incrementalProfit',
                    pre: '$',
                    post: '',
                    arrowConfig: 'positiveUp',
                },
                {
                    label: 'Promo ROI',
                    dataKey: 'roi',
                    pre: '',
                    post: '',
                    arrowConfig: 'positiveUp',
                },
                {
                    label: 'Retailer Incremental Profit',
                    dataKey: 'retailerIncrementalProfit',
                    pre: '$',
                    post: '',
                    arrowConfig: 'positiveUp',
                },
            ],
            spendLabel: {
                lump_sum: 'Lump Sum',
                per_qty: 'Per Qty',
                display: 'Display',
                feature: 'Feature',
            },
            offerMethodList: [
                { value: 'option', label: 'List of Option', dimension: 'dim1' },
                { value: 'manual', label: 'Manual', dimension: 'dim1' },
                { value: 'previous', label: 'Previous', dimension: 'dim1' },
            ],
            addEventList: [
                { value: 'new', label: 'Add New Event' },
                { value: 'import', label: 'Import Event' },
            ],
            leverKeys: [
                'promptEventName',
                'offerMethod',
                'discount',
                'startDate',
                'duration',
                'displayAcv',
                'featureAcv',
            ],
            spendTopForm: ['baseVolume', 'uplift', 'totalVolume', 'totalKindProfit', 'roi', 'totalRetailerProfit'],
            formList: [
                {
                    value: 'duration',
                    label: 'Duration',
                    inputRule: '',
                    placeHolder: 'Enter',
                },
                {
                    value: 'displayAcv',
                    label: 'Display ACV',
                    inputRule: '',
                    placeHolder: 'Enter display ACV',
                },
                {
                    value: 'featureAcv',
                    label: 'Feature ACV',
                    inputRule: '',
                    placeHolder: 'Enter feature ACV',
                },
            ],
            offerSelectionKeys: ['promotionMechanic', 'tacticDescription'],
            spendPerQtyKey: ['per_qty', 'redemption'],
        },
        priceLadder: {
            isThresholdDropdownEnabled: true,
            hideMraup: true,
            limit: 50, //update this when implementing infinite scroller
            dimensionConfig: {
                //snake case eg sub_category
                excludedDimensions: [],
                defaultDimension: 'Retailer',
            },
            tileData: [
                {
                    label: 'Product by Market',
                    key: 'product by market',
                },
                // {
                //     label: 'Product vs Competitors',
                //     key: 'product vs competitors',
                // },
            ],
            subTileData: [
                {
                    label: 'PU',
                    key: 'PU',
                },
                {
                    label: 'PEQ',
                    key: 'PEQ',
                },
            ],
            legendMapping: {
                PU: [
                    {
                        color: '#E6E6EA',
                        label: 'Sales $',
                        key: 'salesValueDollars',
                        dataKey: 'sales',
                        metricDataKey: 'units',
                    },
                    {
                        color: '#66AFBA',
                        label: 'Avg. Price PU',
                        key: 'avgPrice',
                        dataKey: 'avg_price_per_unit',
                        metricDataKey: 'units',
                    },
                    {
                        color: '#ECA586',
                        label: 'Max Price PU',
                        key: 'maxPrice',
                        dataKey: 'max_price_per_unit',
                        metricDataKey: 'units',
                    },
                    {
                        color: '#EB8FC5',
                        label: 'Min Price PU',
                        key: 'minPrice',
                        dataKey: 'min_price_per_unit',
                        metricDataKey: 'units',
                    },
                    {
                        color: '#F1C77A',
                        label: 'Promo Price PU',
                        key: 'promoPrice',
                        dataKey: 'promo_price_per_unit',
                        metricDataKey: 'units',
                    },
                    {
                        color: '#6771DB',
                        label: 'Base Price PU',
                        key: 'basePrice',
                        dataKey: 'base_price_per_unit',
                        metricDataKey: 'units',
                    },
                    // { color: '#5463FF', label: 'MRAUP', key: 'mraup', dataKey: 'mraup' },
                ],
                PEQ: [
                    {
                        color: '#E6E6EA',
                        label: 'Sales $',
                        key: 'salesValueDollars',
                        dataKey: '',
                        metricDataKey: 'volume',
                    },
                    {
                        color: '#66AFBA',
                        label: 'Avg. Price PEQ',
                        key: 'avgPrice',
                        dataKey: 'avg_price_per_eq',
                        metricDataKey: 'volume',
                    },
                    {
                        color: '#ECA586',
                        label: 'Max Price PEQ',
                        key: 'maxPrice',
                        dataKey: 'max_price_per_eq',
                        metricDataKey: 'volume',
                    },
                    {
                        color: '#EB8FC5',
                        label: 'Min Price PEQ',
                        key: 'minPrice',
                        dataKey: 'min_price_per_eq',
                        metricDataKey: 'volume',
                    },
                    {
                        color: '#F1C77A',
                        label: 'Promo Price PEQ',
                        key: 'promoPrice',
                        dataKey: 'promo_price_per_eq',
                        metricDataKey: 'volume',
                    },
                    {
                        color: '#6771DB',
                        label: 'Base Price PEQ',
                        key: 'basePrice',
                        dataKey: 'base_price_per_eq',
                        metricDataKey: 'volume',
                    },
                    // { color: '#5463FF', label: 'MRAUP', key: 'mraup', dataKey: 'mraup' },
                ],
            },
            dataKeyMapping: {
                PU: [
                    { label: 'Sales $', key: 'salesValueDollars' },
                    { label: 'Avg. Price PU', key: 'avgPrice' },
                    { label: 'Max Price PU', key: 'maxPrice' },
                    { label: 'Min Price PU', key: 'minPrice' },
                    { label: 'Promo Price PU', key: 'promoPrice' },
                    { label: 'Base Price PU', key: 'basePrice' },
                ],
                PEQ: [
                    { label: 'Sales $', key: 'salesValueDollars' },
                    { label: 'Avg. Price PEQ', key: 'avgPrice' },
                    { label: 'Max Price PEQ', key: 'maxPrice' },
                    { label: 'Min Price PEQ', key: 'minPrice' },
                    { label: 'Promo Price PEQ', key: 'promoPrice' },
                    { label: 'Base Price PEQ', key: 'basePrice' },
                ],
            },
            tableColumnLabelKeyMapping: {
                sales: { label: 'Sales $' },
                sales_percentage: { label: 'Sales %' },
                avg_price_pu: { label: 'Average Price $ PU' },
                avg_price_peq: { label: 'Average Price $ PEQ' },
                max_price_pu: { label: 'Max Price $ PU' },
                max_price_peq: { label: 'Max Price $ PEQ' },
                min_price_pu: { label: 'Min Price $ PU' },
                min_price_peq: { label: 'Min Price $ PEQ' },
                // mraup: { label: 'MRAUP' },
                base_price_pu: { label: 'Base Price $ PU' },
                base_price_peq: { label: 'Base Price $ PEQ' },
                promo_price_pu: { label: 'Promo Price $ PU' },
                promo_price_peq: { label: 'Promo Price $ PEQ' },
            },
            dropdown2Filter: ['Category', 'Pack_Size', 'Segment', 'Channel', 'Retailer'],
        },
        opportunityIdentification: {
            reversePpeAxis: true,
            bubbleCategoryOptions: [
                { value: 'brand', label: 'Brand', dimension: 'dim1' },
                { value: 'sub_brand', label: 'Sub Brand', dimension: 'dim1' },
                { value: 'category', label: 'Category', dimension: 'dim1' },
                {
                    value: 'sub_category',
                    label: 'Sub Category',
                    dimension: 'dim1',
                },
                { value: 'pack_size', label: 'Pack Size', dimension: 'dim1' },
                { value: 'vendor', label: 'Vendor', dimension: 'dim1' },
                { value: 'product', label: 'Product', dimension: 'dim1' },
                { value: 'country', label: 'Country', dimension: 'dim2' },
                { value: 'channel', label: 'Channel', dimension: 'dim2' },
                { value: 'retailer', label: 'Retailer', dimension: 'dim2' },
                { value: 'division', label: 'Division', dimension: 'dim2' },
                { value: 'geography', label: 'Geography', dimension: 'dim2' },
            ],
            kpis: {
                xaxis: [
                    { label: 'BPE', value: 'bpe' },
                    { label: '% RSV Growth', value: 'rsv_growth' },
                    { label: 'MAC %', value: 'mac_percentage' },
                ],
                yaxis: [
                    { label: 'PPE', value: 'ppe' },
                    { label: '% RSV Growth', value: 'rsv_growth' },
                    { label: 'MAC %', value: 'mac_percentage' },
                ],
                bubbleSize: [
                    { label: 'Eq Volume', value: 'total_volume' },
                    { label: 'BPE', value: 'bpe' },
                    { label: 'PPE', value: 'ppe' },
                    { label: 'MAC', value: 'mac' },
                    { label: 'MAC %', value: 'mac_percentage' },
                    { label: 'RSV', value: 'rsv' },
                    { label: '% RSV Growth', value: 'rsv_growth' },
                ],
            },
            elasticityDriver: {
                chart2Limit: 100,
                levels: [
                    { label: 'Retailer', value: 'retailer', dimension: 'dim2' },
                    { label: 'Product', value: 'product', dimension: 'dim1' },
                    { label: 'Vendor', value: 'vendor', dimension: 'dim1' },
                    { label: 'Category', value: 'category', dimension: 'dim1' },
                    { label: 'Sub Category', value: 'sub_category', dimension: 'dim1' },
                    { label: 'Segment', value: 'segment', dimension: 'dim1' },
                    { label: 'Brand', value: 'brand', dimension: 'dim1' },
                    { label: 'Sub Brand', value: 'sub_brand', dimension: 'dim1' },
                    { label: 'Pack Size', value: 'pack_size', dimension: 'dim1' },
                    { label: 'Form', value: 'form', dimension: 'dim1' },
                    { label: 'Count', value: 'count', dimension: 'dim1' },
                    { label: 'Ounces', value: 'ounces', dimension: 'dim1' },
                    { label: 'Country', value: 'country', dimension: 'dim2' },
                    { label: 'Channel', value: 'channel', dimension: 'dim2' },
                    { label: 'Division', value: 'division', dimension: 'dim2' },
                ],
                limit: 50,
                offset: 0,
                dimension: 'dim1',
                legendMapping: [
                    {
                        dataKey: 'own',
                        label: 'Own Elasticity',
                        color: '#69D4E8',
                    },
                    {
                        dataKey: 'internal',
                        label: 'Internal Competitor Elasticity',
                        color: '#E469B2',
                    },
                    {
                        dataKey: 'external',
                        label: 'External Competitor Elasticity',
                        color: '#EDB44E',
                    },
                ],
            },
        },
        priceCurve: {
            chart1Limit: 100,
            xAxisKeyValue: [
                { value: 'pack_size', label: 'Pack Size' },
                { value: 'sub_brand', label: 'Sub Brand' },
                { value: 'count', label: 'Count' },
            ],
            YAxisKeyValue: [
                { value: 'retail_price', label: 'Avg Price' },
                { value: 'list_price', label: 'List Price' },
                { value: 'base_price', label: 'Base Price' },
            ],
            levels: [
                { value: 'brand', label: 'Brand' },
                { value: 'sub_brand', label: 'Sub Brand' },
                { value: 'sub_category', label: 'Sub Category' },
                { value: 'category', label: 'Category' },
                { value: 'vendor', label: 'Vendor' },
                { value: 'count', label: 'Count' },
                { value: 'ounces', label: 'Ounces' },
            ],
            subTileData: [
                {
                    label: 'PU',
                    key: 'PU',
                    dataKey: 'per_unit',
                },
                {
                    label: 'PEQ',
                    key: 'PEQ',
                    dataKey: 'per_eq',
                },
            ],
            chartColors: [
                '#E8A122',
                '#293BB8',
                '#E06936',
                '#19669D',
                '#A5582D',
                '#43C9E2',
                '#DD449F',
                '#37C7BE',
                '#9E5897',
                '#00798C',
                '#EDB44E',
                '#4557D5',
                '#E6875E',
                '#228BD6',
                '#CC7442',
                '#69D4E8',
                '#E469B2',
                '#5FD3CB',
                '#B377AD',
                '#3394A3',
                '#F1C77A',
                '#7381E0',
                '#ECA586',
                '#55A8E4',
                '#D89672',
                '#8EDFEE',
                '#EB8FC5',
                '#87DED8',
                '#C699C2',
                '#66AFBA',
                '#F6D9A7',
                '#A2ABEA',
                '#F3C3AF',
                '#8EC5ED',
                '#E5B9A1',
                '#B4E9F3',
                '#F1B4D9',
                '#AFE9E5',
                '#D9BBD6',
                '#99C9D1',
                '#FAECD3',
                '#D0D5F5',
                '#F9E1D7',
                '#C6E2F6',
                '#F2DCD0',
                '#D9F4F9',
                '#F8DAEC',
                '#D7F4F2',
                '#ECDDEB',
                '#CCE4E8',
            ],
            tableHeaders: [
                { label: 'List Price $', key: 'list_price' },
                { label: 'List Price $ YA', key: 'list_price_ya' },
                { label: 'Avg Price $', key: 'retail_price' },
                { label: 'Avg Price $ YA', key: 'retail_price_ya' },
                { label: 'Base Price $', key: 'base_price' },
                { label: 'Base Price $ YA', key: 'base_price_ya' },
            ],
        },
        pricePoint: {
            priceRange: [0, 10],
            graphColorScheme: ['#D7D6D9', '#66AFBA', '#ECA586', '#F1C77A', '#EB8FC5'],
            hideMraup: true,
            limit: 500,
            dimensionConfig: {
                //snake case eg sub_category
                excludedDimensions: [],
                defaultDimension: 'Vendor',
            },
            contributionThreshold: 5,
            priceTypeOptions: [
                { label: 'Avg Price', value: 'avg_price' },
                { label: 'Base Price', value: 'base_price' },
            ],
            subTileData: [
                {
                    label: 'PU',
                    key: 'per_unit',
                    xAxisLabel: 'Price Per Unit',
                    tooltip: 'Per Unit',
                },
                {
                    label: 'PEQ',
                    key: 'per_volume',
                    xAxisLabel: 'Price Per Eq',
                    tooltip: 'Per Eq Volume',
                },
            ],
            yAxisDropdownData: [
                {
                    label: 'Dollars',
                    value: 'value',
                },
                {
                    label: 'Volume',
                    value: 'volume',
                },
                {
                    label: 'Units',
                    value: 'units',
                },
            ],
            tableHeaderKeyMapping: {
                growth_percentage: ['Growth % vs YA', '', '%'],
                total_sales: ['Total Value ($)', '$', ''],
                total_volume: ['Total Volume', '', ''],
                total_units: ['Total Units', '', ''],
                avg_price_per_unit: ['Avg. Price per Unit', '$', ''],
                avg_price_per_eq: ['Avg. Price per EQ', '$', ''],
                base_price_per_unit: ['Base Price per Unit', '$', ''],
                base_price_per_eq: ['Base Price per EQ', '$', ''],
            },
            drilldownTableHeaderKeyMapping: {
                growth_abs: ['Growth Abs', '$', ''],
                growth_percentage: ['Growth %', '', '%'],
                contribution_to_category: ['Contribution to category', '$', ''],
                cy_share: ['CY share', '', '%'],
                ya_share: ['YA share', '', '%'],
                change: ['Change %', '', '%'],
            },
            dropdown2Filter: ['Category', 'Pack_Size', 'Segment', 'Channel', 'Retailer'],
            customThresholdData: [
                {
                    id: 1,
                    value: '',
                },
                {
                    id: 2,
                    value: '',
                },
                {
                    id: 3,
                    value: '',
                },
                {
                    id: 4,
                    value: '',
                },
                {
                    id: 5,
                    value: '',
                },
            ],
        },
        priceTracking: {
            limit: 20,
            dimensionConfig: {
                //snake case eg sub_category
                excludedDimensions: ['segment', 'form', 'count', 'ounces'],
                defaultRowDimension: 'Product',
                defaultColumnDimension: 'Retailer',
            },
            attributeNamesLimit: 50,
            frequency: 'W',
            timePeriodOptions: [
                { label: 'YA', value: 'year_ago' },
                { label: 'Prior Period', value: 'prior_period' },
                { label: 'Custom Period', value: 'custom' },
            ],
            priceTypeOptions: [
                { label: 'Base Price', value: 'base' },
                { label: 'Avg Price', value: 'average' },
            ],
            kpiOptions: [
                { label: '% Change', value: 'percent_change' },
                { label: 'Price Index', value: 'index' },
            ],
            subTileData: [
                {
                    label: 'PU',
                    key: 'units',
                    xAxisLabel: 'Price Per Unit',
                    tooltip: 'Per Unit',
                },
                {
                    label: 'PEQ',
                    key: 'volume',
                    xAxisLabel: 'Price Per Eq',
                    tooltip: 'Per Eq Volume',
                },
            ],
            weeksOptions: [
                { label: 'L W1', value: 1 },
                { label: 'L W4', value: 4 },
                { label: 'L W12', value: 12 },
            ],
            monthsOptions: [
                { label: 'L M1', value: 1 },
                { label: 'L M3', value: 3 },
                { label: 'L M6', value: 6 },
                { label: 'L M12', value: 12 },
            ],
            quartersOptions: [
                { label: 'L Q1', value: 1 },
                { label: 'L Q2', value: 2 },
                { label: 'L Q4', value: 4 },
            ],
            kpiMapping: {
                'Base Price': ['$', ''],
                'Base Price YA': ['$', ''],
                'Avg Price': ['$', ''],
                'Avg Price YA': ['$', ''],
                'Base Price Index % Chg': ['', '%'],
                'Base Price % Chg': ['', '%'],
                'Avg Price Index % Chg': ['', '%'],
                'Avg Price % Chg': ['', '%'],
                'TDP % Chg': ['', '%'],
                TDP: ['', ''],
                'TDP YA': ['', ''],
                'Volume Velocity % Chg': ['', '%'],
                'Volume Velocity': ['', ''],
                'Volume Velocity YA': ['', ''],
            },
        },
        bestWeeks: {
            limit: 50,
            drilldownTableConfig: [
                { label: 'Period No:', value: 'period_no', sorting: false },
                { label: 'Year', value: 'year', sorting: false },
            ],
            dimensionConfig: {
                //snake case eg sub_category
                excludedDimensions: ['dim2'],
                defaultDimension: 'Brand',
            },
            rankingCriteriaOptions: [
                { label: 'Base Volume', value: 'base_eq_volume' },
                { label: 'ACV', value: 'total_per_acv_dist' },
                { label: 'Incremental Volume', value: 'incremental_eq_volume' },
                { label: 'Total Volume', value: 'total_eq_volume' },
            ],
        },
    },
    truFru: {
        //COMMON CONFIG
        commonConfig: {
            clientName: 'Trufru',
            handleDim2SortingFromFrontend: false,
            dateFormat: 'MM/DD/YYYY',
            dateFormatAlt: 'MM/DD/YY',
            calenderStartDay: 'Sunday',
            showSecondaryLogo: false,
            showLogoInNavbar: true,
            logoHeight: '32px',
            logoWidth: '125px',
            loginPageTextPart1: 'Welcome to',
            loginPageTextPart2: 'Pricing and Promo',
            width: window.innerWidth,
            limit: 10,
            offset: 0,
            lagList: [0, 1],
            graphFontSize: calculateFontSize(window.innerWidth, 13),
            graphFontSizeAlt: calculateFontSize(window.innerWidth, 13),
            graphFontFamily: "'Helvetica Neue', sans-serif",
            graphLabelColorAlt: '#4E4C55',
            graphLabelColor: '#433C4A',
            units: {
                currency: '$',
                volume: 'Eq Vol',
                currencyText: 'Dollar',
            },
            filterFormat: { dim1: { ids: [] }, dim2: { ids: [] } },
            frequency: 'W',
            showCampignCalender: false,
            showFullLabel: true,
            decimalForPercentage: 1,
            decimalForNonPercentage: 2,
        },
        latestDateForDifferentRoutes: {
            'promo-score-card': 'Promotion Data',
            'roi-analysis': 'Promotion Data',
            'roi-tracker': 'Promotion Data',
            'promo-recommendation': 'Promotion Data',
            default: 'POS Data',
        },
        screenDetailsWithRoutes: [
            {
                label: 'Growth Analysis',
                path: 'promo/category-diagnostics/growth-analysis',
                id: 'ga',
                pageId: 'ga',
            },
            {
                label: 'Bump Report',
                path: 'promo/category-diagnostics/bump-report',
                id: 'br',
                pageId: 'br',
            },
            {
                label: 'Price Change',
                path: 'pricing/analytics/price-change',
                id: 'pcn',
                pageId: 'pcn',
            },
            {
                label: 'Price Point',
                path: 'pricing/analytics/price-point',
                id: 'pp',
                pageId: 'pp',
            },
            {
                label: 'Price Ladder',
                path: 'pricing/analytics/price-ladder',
                id: 'pld',
                pageId: 'pld',
            },
            {
                label: 'Price Curve',
                path: 'pricing/analytics/price-curve',
                id: 'pc',
                pageId: 'pc',
            },
            {
                label: 'Price Tracking',
                path: 'pricing/analytics/price-tracking',
                id: 'pt',
                pageId: 'pt',
            },
            {
                label: 'Opportunity Identification',
                path: 'pricing/analytics/opportunity-identification',
                id: 'oi',
                pageId: 'oi',
            },
            {
                label: 'Promo Scorecard',
                path: 'promo/analytics/promo-score-card',
                id: 'ps',
                pageId: 'ps',
            },
            {
                label: 'Investment & ROI Tracker',
                path: 'promo/analytics/roi-tracker',
                id: 'pl',
                pageId: 'pl',
            },
            {
                label: 'Promo ROI Analysis',
                path: 'promo/analytics/roi-analysis',
                id: 'pa',
                pageId: 'pa',
            },
            {
                label: 'Promo Recommendation',
                path: 'promo/recommendation/promo-recommendation',
                id: 'pr',
                pageId: 'pr',
            },
            {
                label: 'Pricing Simulator',
                path: 'pricing/recommendation/price-simulator',
                id: 'psr',
                pageId: 'psr',
            },
            {
                label: 'Pricing Simulator',
                path: 'pricing/recommendation/price-simulator/new',
                id: 'psr',
                pageId: 'psrNew',
            },
            {
                label: 'Pricing Simulator',
                path: 'pricing/recommendation/price-simulator/edit/:id',
                id: 'psr',
                pageId: 'psrEdit',
            },
            {
                label: 'Pricing Simulator',
                path: 'pricing/recommendation/price-simulator/view/:id',
                id: 'psr',
                pageId: 'psrView',
            },
        ],
        screens: [
            {
                label: 'Category Diagnostics',
                path: ['promo/category-diagnostics'],
                showSubHeader: false,
                options: {
                    Promo: [
                        {
                            label: 'Growth Analysis',
                            path: 'growth-analysis',
                            id: 'ga',
                        },
                        { label: 'Bump Report', path: 'bump-report', id: 'br' },
                    ],
                    visible: false,
                },
            },
            {
                label: 'Pricing Analytics',
                path: ['pricing/analytics', null],
                showSubHeader: false,
                options: {
                    Promo: [
                        {
                            label: 'Price Change',
                            path: 'price-change',
                            id: 'pcn',
                        },
                        { label: 'Price Point', path: 'price-point', id: 'pp' },
                        {
                            label: 'Price Ladder',
                            path: 'price-ladder',
                            id: 'pld',
                        },
                        { label: 'Price Curve', path: 'price-curve', id: 'pc' },
                        {
                            label: 'Price Tracking',
                            path: 'price-tracking',
                            id: 'pt',
                        },
                        {
                            label: 'Opportunity Identification',
                            path: 'opportunity-identification',
                            id: 'oi',
                        },
                    ],
                    visible: false,
                },
            },
            {
                label: 'Promo Analytics',
                path: ['promo/analytics', null],
                showSubHeader: false,
                options: {
                    Promo: [
                        {
                            label: 'Promo Scorecard',
                            path: 'promo-score-card',
                            id: 'ps',
                        },
                        {
                            label: 'Investment & ROI Tracker',
                            path: 'roi-tracker',
                            id: 'pl',
                        },
                        {
                            label: 'Promo ROI Analysis',
                            path: 'roi-analysis',
                            id: 'pa',
                        },
                    ],
                    visible: false,
                },
            },
            {
                label: 'Price & Promo Modeling',
                path: ['promo/recommendation', 'pricing/recommendation'],
                showSubHeader: true,
                options: {
                    Promo: [
                        {
                            label: 'Promo Recommendation',
                            path: 'promo-recommendation',
                            id: 'pr',
                        },
                    ],
                    Pricing: [
                        {
                            label: 'Pricing Simulator',
                            path: 'price-simulator',
                            id: 'psr',
                        },
                    ],
                    visible: false,
                },
            },
        ],
        globalFilter: {
            presetConfig: {
                disablePresetFilter: false,
                presetEnabledRoutes: {
                    all: true,
                },
            },
            availableFrequenciesList: [{ key: 'W', label: 'Week' }],
            globalFilterChangingRoutes: {},
            limit: 50,
            selectionAllowed: {
                'promo-recommendation': {
                    dim2: {
                        Retailer: 1,
                    },
                },
            },
            allSelectedLimit: 15,
            timePeriodScreenMapping: {
                default: ['4W', '12W', '26W', '52W', '1M', '3M', '6M', '12M', '1Q', '2Q', '4Q', 'YTD', 'CUSTOM DATE'],
                'bump-report': ['52W', '104W', '156W', '1M', '3M', '6M', '12M', '1Q', '2Q', '4Q', 'YTD', 'CUSTOM DATE'],
            },

            defaultPeriod: ['52W'],
            applyFilterApiPostFormat: {
                jsonstring_dim1: '{}',
                jsonstring_dim2: '{}',
            },
            defaultPreviousIdObject: {
                dim1: ['attr', 'attr'],
                dim2: ['attr', 'attr'],
            },
            defaultIdObject: {
                dim1: { ids: [] },
                dim2: { ids: [] },
            },
            defaultAttrIdObject: {
                attr: {
                    dim1: { ids: [] },
                    dim2: { ids: [] },
                },
            },
            promoScoreCardDefault: {
                Category: 'CHOCOLATE',
                Retailer: 'Food Lion',
            },
            retainFiltersAcrossFeatures: false,

            PromoScoreCardDefaultObj: {
                dim1: {},
                dim2: {
                    geography: {
                        inclusion: [
                            {
                                dimension: 'dim2',
                                isActive: true,
                                attributeType: 'geography',
                                attributeDesc: 'Total US xAOC + Conv',
                                attributeExId: 'Total US xAOC + Conv',
                            },
                        ],
                    },
                },
            },
        },
        priceSimulator: {
            dataSources: [
                { label: 'Projected Consumption', value: 'iri' },
                { label: 'Consumption Actuals', value: 'l52_weeks' },
                { label: 'Financials', value: 'financials' },
            ],
            allScenariosTableLimit: 500,
            a: 10,
            opportunityIdentificationTiles: [
                { key: 'recommendation', label: 'Recommendation' },
                { key: 'input', label: 'Input' },
                { key: 'output', label: 'Output' },
            ],
            cascadingColumns: ['COGS Rate', 'List Price', 'Everyday Retail Price'], // this should match with input key mapping and price simulator input columns
            levels: ['product', 'retailer'],
            inputKeyMapping: {
                // keep the order accuretly, to get it in multiselect
                cogs: 'COGS Rate',
                lp: 'List Price',
                rp: 'Everyday Retail Price',
                acv: 'ACV Distribution',
                oi: 'OI Rate',
                non_oi: 'Non OI Rate',
                promo_trade_spends: 'Promo Trade Rate Spends',
                tr: 'Trade Rate',
                cf: 'Comp Follow',
            },
            outputKeyMapping: {
                volume: {
                    label: 'New Volume',
                    pre: '',
                    pos: '',
                },
                volume_old: {
                    label: 'Current Volume',
                    pre: '',
                    pos: '',
                },
                vlmChg: {
                    label: 'Volume Chg %',
                    pre: '',
                    pos: '%',
                },
                units: {
                    label: 'New Units',
                    pre: '',
                    pos: '',
                },
                units_old: {
                    label: 'Current Units',
                    pre: '',
                    pos: '',
                },
                unitsChg: {
                    label: 'Units Chg %',
                    pre: '',
                    pos: '%',
                },
                rsv: {
                    label: 'New RSV',
                    pre: '$',
                    pos: '',
                },
                rsv_old: {
                    label: 'Current RSV',
                    pre: '$',
                    pos: '',
                },
                rsvChg: {
                    label: 'RSV Chg %',
                    pre: '',
                    pos: '%',
                },
                gsv: {
                    label: 'New GSV',
                    pre: '$',
                    pos: '',
                },
                gsv_old: {
                    label: 'Current GSV',
                    pre: '$',
                    pos: '',
                },
                gsvChg: {
                    label: 'GSV Chg %',
                    pre: '',
                    pos: '%',
                },
                nsv: {
                    label: 'New NSV',
                    pre: '$',
                    pos: '',
                },
                nsv_old: {
                    label: 'Current NSV',
                    pre: '$',
                    pos: '',
                },
                nsvChg: {
                    label: 'NSV Chg %',
                    pre: '',
                    pos: '%',
                },
                gmac: {
                    label: 'New GMAC',
                    pre: '$',
                    pos: '',
                },
                gmac_old: {
                    label: 'Current GMAC',
                    pre: '$',
                    pos: '',
                },
                gmacChg: {
                    label: 'GMAC Chg %',
                    pre: '',
                    pos: '%',
                },
                rtMg: {
                    label: 'New Retail Margin %',
                    pre: '',
                    pos: '%',
                },
                rtMg_old: {
                    label: 'Current Retail Margin %',
                    pre: '',
                    pos: '%',
                },
                rtMgPcChg: {
                    label: 'Retail Margin Chg %',
                    pre: '',
                    pos: '%',
                },
                retailer_profit: {
                    label: 'New Retail Profit',
                    pre: '',
                    pos: '',
                },
                retailer_profit_old: {
                    label: 'Current Retail Profit',
                    pre: '',
                    pos: '',
                },
                rtPfChg: {
                    label: 'Retail Profit Chg %',
                    pre: '',
                    pos: '%',
                },
                netRpChg: {
                    label: 'Net Effective Price % Chg',
                    pre: '',
                    pos: '%',
                },
                mgPc: {
                    label: 'New Margin %',
                    pre: '',
                    pos: '%',
                },
                mgPc_old: {
                    label: 'Current Margin %',
                    pre: '',
                    pos: '%',
                },
                mgPcChg: {
                    label: 'Margin Chg %',
                    pre: '',
                    pos: '%',
                },
                profitPool: {
                    label: 'New Profit Pool',
                    pre: '',
                    pos: '%',
                },
                profitPool_old: {
                    label: 'Current Profit Pool',
                    pre: '',
                    pos: '%',
                },
                profitPoolChg: {
                    label: 'Profit Pool Chg %',
                    pre: '',
                    pos: '$',
                },
                oi_cp: {
                    label: 'Current OI Rate',
                    pre: '',
                    pos: '%',
                },
                oi_np: {
                    label: 'New OI Rate',
                    pre: '',
                    pos: '',
                },
                oi_pc: {
                    label: 'OI Rate Chg %',
                    pre: '',
                    pos: '%',
                },
                non_oi_cp: {
                    label: 'Current Non OI Rate',
                    pre: '',
                    pos: '',
                },
                non_oi_np: {
                    label: 'New Non OI Rate',
                    pre: '',
                    pos: '',
                },
                non_oi_pc: {
                    label: 'Non OI Rate Chg %',
                    pre: '',
                    pos: '%',
                },
                promo_trade_spends_cp: {
                    label: 'Current Promo Trade Rate Spends',
                    pre: '',
                    pos: '',
                },
                promo_trade_spends_np: {
                    label: 'Current Promo Trade Rate Spends',
                    pre: '',
                    pos: '',
                },
                promo_trade_spends_pc: {
                    label: 'Promo Trade Rate Spends Chg %',
                    pre: '',
                    pos: '%',
                },
                tr_cp: {
                    label: 'Current Trade Rate',
                    pre: '',
                    pos: '',
                },
                tr_np: {
                    label: 'New Trade Rate',
                    pre: '',
                    pos: '',
                },
                tr_pc: {
                    label: 'Trade Rate Chg %',
                    pre: '',
                    pos: '%',
                },
            },
            recommendationKeyMapping: {
                recommended_list_price: {
                    label: 'New list price recom',
                    pre: '$',
                    pos: '',
                },
                role: {
                    label: 'Role',
                    pre: '',
                    pos: '',
                },
                strategy: {
                    label: 'Strategy',
                    pre: '',
                    pos: '',
                },
                mix: {
                    label: 'Mix',
                    pre: '',
                    pos: '',
                },
                growth: {
                    label: 'Growth',
                    pre: '',
                    pos: '',
                },
                gap: {
                    label: 'Gap',
                    pre: '',
                    pos: '',
                },

                cogs: {
                    label: 'COGs',
                    pre: '',
                    pos: '%',
                },
                list_to_retail: {
                    label: 'List to Retail',
                    pre: '',
                    pos: '',
                },
                bpe: {
                    label: 'BPE',
                    pre: '',
                    pos: '',
                },
                ppe: {
                    label: 'PPE',
                    pre: '',
                    pos: '',
                },
                margin: {
                    label: 'Margin',
                    pre: '',
                    pos: '%',
                },
                growth_vs_category: {
                    label: 'Gowth vs Category',
                    pre: '',
                    pos: '%',
                },
                pl_vs_category: {
                    label: 'PL vs Category',
                    pre: '',
                    pos: '%',
                },
                threshold: {
                    label: 'Threshold',
                    pre: '',
                    pos: '',
                },
                comp_index: {
                    label: 'Comp. Index',
                    pre: '',
                    pos: '',
                },
                curve_index: {
                    label: 'Curve Index',
                    pre: '',
                    pos: '',
                },
                cogs_realization: {
                    label: 'COGS & Realization',
                    pre: '',
                    pos: '',
                },
                cogs_forecast: {
                    label: 'COGS Forecast',
                    pre: '',
                    pos: '%',
                },
                net_to_retail: {
                    label: 'Net to Retail',
                    pre: '',
                    pos: '%',
                },
                gross_to_net: {
                    label: 'Gross to Net',
                    pre: '',
                    pos: '%',
                },
            },
            defaultKpiMetrics: [1, 2, 3, 4, 5],
            kpiMetrics: [
                {
                    key: 1,
                    value: 'volume_sales',
                    name: 'TruFru Volume Sales',
                    pre: '',
                    post: '',
                },
                {
                    key: 2,
                    value: 'value_sales',
                    name: 'TruFru Value Sales ($)',
                    pre: '$',
                    post: '',
                },
                {
                    key: 3,
                    value: 'profit_abs',
                    name: 'TruFru Profit Abs ($)',
                    pre: '$',
                    post: '',
                },
                {
                    key: 4,
                    value: 'margin_percent',
                    name: 'TruFru Margin (%)',
                    pre: '',
                    post: '%',
                },
                {
                    key: 5,
                    value: 'trade_rate_percent',
                    name: 'TruFru Trade Rate (%)',
                    pre: '',
                    post: '%',
                },
                {
                    key: 6,
                    value: 'retailer_margin_percent',
                    name: 'TruFru Retailer Margin (%)',
                    pre: '',
                    post: '%',
                },
                {
                    key: 7,
                    value: 'gross_profit',
                    name: 'TruFru Gross Profit ($)',
                    pre: '$',
                    post: '',
                },
                {
                    key: 8,
                    value: 'retailer_profit',
                    name: 'TruFru Retailer Profit ($)',
                    pre: '$',
                    post: '',
                },
                {
                    key: 9,
                    value: 'gross_sales',
                    name: 'TruFru Gross Sales ($)',
                    pre: '$',
                    post: '',
                },
                {
                    key: 10,
                    value: 'net_sales',
                    name: 'TruFru Net Sales($)',
                    pre: '$',
                    post: '',
                },
                {
                    key: 11,
                    value: 'total_volume',
                    name: 'Total Volume Sales',
                    pre: '$',
                    post: '',
                },
                {
                    key: 12,
                    value: 'total_value',
                    name: 'Total Value Sales($)',
                    pre: '$',
                    post: '',
                },
                {
                    key: 13,
                    value: 'net_retail_price_change',
                    name: 'TruFru Net Retailer Price % Chg',
                    pre: '',
                    post: '%',
                },
            ],
            addPortfolioUpdateKpis: [
                {
                    key: 'volume',
                    value: '',
                    label: 'Volume',
                    rval: '',
                    percentChange: '',
                },
                {
                    key: 'value',
                    value: '',
                    label: 'Value',
                    rval: '',
                    percentChange: '',
                },
                {
                    key: 'units',
                    value: '',
                    label: 'Units',
                    rval: '',
                    percentChange: '',
                },
                {
                    key: 'trade_rate',
                    value: '',
                    label: 'Trade Rate %',
                    rval: '',
                    percentChange: '',
                },
                {
                    key: 'list_price',
                    value: '',
                    label: 'List Price per unit',
                    rval: '',
                    percentChange: '',
                },
                {
                    key: 'retail_price',
                    value: '',
                    label: 'Retail Price per unit',
                    rval: '',
                    percentChange: '',
                },
                {
                    key: 'acv',
                    value: '',
                    label: 'ACV Distribution %',
                    rval: '',
                    percentChange: '',
                },
                {
                    key: 'cogs',
                    value: '',
                    label: 'COGS per unit',
                    rval: '',
                    percentChange: '',
                },
                {
                    key: 'base_elasticity',
                    value: '',
                    label: 'Base Elasticity',
                    rval: '',
                    percentChange: '',
                },
                {
                    key: 'acv_elasticity',
                    value: '',
                    label: 'Acv Elasticity',
                    rval: '',
                    percentChange: '',
                },
            ],
            quarterMetricKeyMapping: [
                {
                    name: 'Volume',
                    value: 'volume',
                    pre: '',
                    post: '',
                },
                {
                    name: 'Revenue',
                    value: 'revenue',
                    pre: '$',
                    post: '',
                },
                {
                    name: 'Profit',
                    value: 'profit',
                    pre: '$',
                    post: '',
                },
                {
                    name: 'Trade Rate Percent',
                    value: 'tradeRatePercent',
                    pre: '',
                    post: '%',
                },
                {
                    name: 'Retailer Margin',
                    value: 'retailerMargin',
                    pre: '',
                    post: '',
                },
            ],
        },
        priceChange: {
            // TODO: remove unwanted props
            limit: 60,
            dimensionConfig: {
                //snake case eg sub_category
                excludedDimensions: [],
                defaultDimension: 'Category',
            },
            hiddenTableRows: [],
            timePeriodOptions: [
                { label: 'YA', value: 'year_ago' },
                { label: 'Prior Period', value: 'prior_period' },
                { label: 'Custom Period', value: 'custom' },
            ],
            absTileData: [
                { key: 'abs', label: 'Abs' },
                { key: 'percentage', label: '%' },
            ],
            kpiListData: [
                {
                    key: 'avg_price',
                    label: 'Avg Price',
                    value: 'average',
                    dataKey: 'avg_price',
                },
                {
                    key: 'base_price',
                    label: 'Base Price',
                    value: 'base',
                    dataKey: 'base_price',
                },
            ],
            volTileData: [
                {
                    key: 'units',
                    label: 'PU',
                    value: 'units',
                    dataKey: 'units',
                    tooltip: 'Per Unit',
                },
                {
                    key: 'vol',
                    label: 'PEQ',
                    value: 'vol',
                    dataKey: 'volume',
                    tooltip: 'Per Eq Volume',
                },
            ],
            salesTileData: [
                { key: 'sales', label: 'Sales' },
                { key: 'incremental', label: 'Incremental' },
                { key: 'promo', label: 'Promo' },
            ],
            salesAttributionChart: {
                colorList: ['#10AB5E', '#DC3826'],
                colorListType2: ['#758BEE', '#758BEE'],
                profitPoolColor: ['#826FD0', '#826FD0'],
                backGroundColor: 'rgba(0, 0, 0, 0.02)',
            },
            salesAttributionDrillDownChartKeyValueMapping: {
                'feature_&_display': 'Feature & Display',
                'Feature & Display': 'feature_&_display',
            },
            salesAttributionChart2Limit: 20,
        },
        growthAnalysis: {
            limit: 60,
            includeAggPeriod: true,
            dimensionConfig: {
                //snake case eg sub_category
                excludedDimensions: [],
                defaultDimension: 'Category',
            },
            absTileData: [
                { key: 'abs', label: 'Abs' },
                { key: 'percentage', label: '%' },
            ],
            subTileData: [
                {
                    label: 'PU',
                    key: 'PU',
                },
                {
                    label: 'PEQ',
                    key: 'PEQ',
                },
            ],
            volTileData: [
                {
                    key: 'val',
                    label: 'Dollars',
                    value: 'val',
                    dataKey: 'value',
                },
                {
                    key: 'vol',
                    label: 'Eq Volume',
                    value: 'vol',
                    dataKey: 'volume',
                },
                {
                    key: 'units',
                    label: 'Units',
                    value: 'units',
                    dataKey: 'units',
                },
                // { key: 'profit', label: 'Profit', value: 'profit', dataKey: 'profit' },
            ],
            showTotal: true,
            currentYearLabel: 'CY',
            yearAgoLabel: 'YA',
            trendChartDropdownData: [
                {
                    key: 'sales_volume',
                    label: 'Sales Volume',
                    value: 'sales_volume',
                    dataKey: 'sales_volume',
                },
                {
                    key: 'sales',
                    label: 'Sales $',
                    value: 'sales',
                    dataKey: 'sales',
                },
                {
                    key: 'average_price',
                    label: 'Average Price',
                    value: 'average_price',
                    dataKey: 'average_price',
                },
                {
                    key: 'base_price',
                    label: 'Base Price',
                    value: 'base_price',
                    dataKey: 'base_price',
                },
                { key: 'acv', label: '%ACV', value: 'acv', dataKey: 'acv' },
                {
                    key: 'avg_items',
                    label: 'Avg. no. of items',
                    value: 'avg_items',
                    dataKey: 'avg_items',
                },
                { key: 'tdp', label: 'TDP', value: 'tdp', dataKey: 'tdp' },
            ],
            salesTileData: [
                { key: 'sales', label: 'Sales' },
                { key: 'incremental', label: 'Incremental' },
                { key: 'promo', label: 'Promo' },
            ],
            graphExportHeaderMapping: {
                promo: ['Non-promo', 'Promo'],
                incremental: ['Base', 'Incremental'],
                sales: ['Sales Change'],
            },
            depletionDropdownData: [
                {
                    value: 'frontline_sales',
                    dataKey: 'frontline_sales',
                    key: 'frontline_sales',
                    label: 'Frontline Sales',
                },
                {
                    value: 'net_sales',
                    dataKey: 'net_sales',
                    key: 'net_sales',
                    label: 'Net Sales',
                },
            ],
            tableKeyUnitMapping: {
                'Market Share CY': {
                    unit: '%',
                    label: 'Market Share CY',
                    includePercentageChange: false,
                },
                'Market Share YA': {
                    unit: '%',
                    label: 'Market Share YA',
                    includePercentageChange: false,
                },
                'ACV CY': {
                    unit: '%',
                    label: 'Wtd. Avg ACV %',
                    includePercentageChange: false,
                },
                'ACV YA': {
                    unit: '%',
                    label: 'Wtd. Avg ACV % YA',
                    includePercentageChange: false,
                },
            },
            salesAttributionChart: {
                colorList: ['#10AB5E', '#DC3826'],
                colorListType2: ['#758BEE', '#758BEE'],
                profitPoolColor: ['#826FD0', '#826FD0'],
                backGroundColor: 'rgba(0, 0, 0, 0.02)',
            },
            salesAttributionDrillDownChartKeyValueMapping: {
                'feature_&_display': 'Feature & Display',
                'Feature & Display': 'feature_&_display',
            },
            salesAttributionChart2DisabledItems: ['unexplained'],
            salesAttributionChart2Limit: 50,
        },
        //BUMP REPORT
        bumpReport: {
            mainHeader: 'Bump Report',
            groupByKey: 'groupBy',
            comparisonTileData: [
                { key: 'cy_vs_ya', label: 'CY vs YA' },
                { key: 'difference', label: 'Difference' },
            ],
            enablePromoCalender: true,
            isPromoUpliftPercentValue: false,
            volGroupByOptionsMapping: {
                vol: [
                    {
                        value: 'total_eq_volume',
                        label: 'Total EQ Volume',
                        index: 1,
                    },
                    {
                        value: 'any_promo_eq_volume',
                        label: 'Any promo EQ Volume',
                        index: 1,
                    },
                    {
                        value: 'no_promo_eq_volume',
                        label: 'No Promo EQ Volume',
                        index: 1,
                    },

                    {
                        value: 'base_eq_volume',
                        label: 'Base EQ Volume',
                        index: 0,
                    },
                    {
                        value: 'incremental_eq_volume',
                        label: 'Incremental EQ Volume Total',
                        index: 0,
                    },
                    {
                        value: 'tpr_incremental_eq_volume',
                        label: 'Incremental EQ Volume TPR',
                        index: 0,
                    },
                    {
                        value: 'feature_incremental_eq_volume',
                        label: 'Incremental EQ Volume Feature',
                        index: 0,
                    },
                    {
                        value: 'display_incremental_eq_volume',
                        label: 'Incremental EQ Volume Display',
                        index: 0,
                    },
                    {
                        value: 'feature_and_display_incremental_eq_volume',
                        label: 'Incremental EQ Volume Feature & Display',
                        index: 0,
                    },
                ],
                val: [
                    { value: 'total_value', label: 'Total Value', index: 1 },
                    {
                        value: 'any_promo_value',
                        label: 'Any Promo Value',
                        index: 1,
                    },
                    {
                        value: 'no_promo_value',
                        label: 'No Promo Value',
                        index: 1,
                    },
                    { value: 'base_value', label: 'Base Value', index: 0 },
                    {
                        value: 'incremental_value',
                        label: 'Incremental Value Total',
                        index: 0,
                    },
                    {
                        value: 'tpr_incremental_value',
                        label: 'Incremental Value TPR',
                        index: 0,
                    },
                    {
                        value: 'feature_incremental_value',
                        label: 'Incremental Value Feature',
                        index: 0,
                    },
                    {
                        value: 'display_incremental_value',
                        label: 'Incremental Value Display',
                        index: 0,
                    },
                    {
                        value: 'feature_and_display_incremental_value',
                        label: 'Incremental Value Feature & Display',
                        index: 0,
                    },
                ],
                units: [
                    { value: 'total_units', label: 'Total Units', index: 1 },
                    {
                        value: 'any_promo_units',
                        label: 'Any Promo Units',
                        index: 1,
                    },
                    {
                        value: 'no_promo_units',
                        label: 'No Promo Units',
                        index: 1,
                    },
                    { value: 'base_units', label: 'Base Units', index: 0 },
                    {
                        value: 'incremental_units',
                        label: 'Incremental Units Total',
                        index: 0,
                    },
                    {
                        value: 'tpr_incremental_units',
                        label: 'Incremental Units TPR',
                        index: 0,
                    },
                    {
                        value: 'feature_incremental_units',
                        label: 'Incremental Units Feature',
                        index: 0,
                    },
                    {
                        value: 'display_incremental_units',
                        label: 'Incremental Units Display',
                        index: 0,
                    },
                    {
                        value: 'feature_and_display_incremental_units',
                        label: 'Incremental Units Feature & Display',
                        index: 0,
                    },
                ],
            },
            tooltipKeyLabelMapping: {
                increments: 'Incremental',
                promo: 'Any Promo',
            },
            bumpReportTileData: [
                { key: 'increments', label: 'Attribution' },
                { key: 'promo', label: 'Consumption' },
                { key: 'groupBy', label: 'Group By' },
            ],
            bumpReportTile1Data: [
                {
                    key: 'promo',
                    label: 'Promotions',
                    visibleTabs: ['increments', 'promo', 'groupBy'],
                }, //keys should match bumpReportTileData keys
            ],
            bumpReportTile2Data: [
                { key: 'total', label: 'Total' },
                { key: 'breakout', label: 'Breakout' },
            ],
            absTileData: [
                { key: 'abs', label: 'Abs' },
                { key: 'percentage', label: '%' },
            ],

            volTileData: [
                { key: 'val', label: 'Dollars', dataKey: 'value' },
                { key: 'vol', label: 'Eq Volume', dataKey: 'volume' },
                { key: 'units', label: 'Units', dataKey: 'units' },
            ],
            bumpChartY2Colors: [
                '#293BB8',
                '#DD449F',
                '#9E5897',
                '#19669D',
                '#43C9E2',
                '#37C7BE',
                '#00798C',
                '#E8A122',
                '#E06936',
                '#A5582D',
            ],
            bumpChartY2AxisOptions: {
                vol: [
                    {
                        value: 'avg_price_per_eq',
                        index: 0,
                        label: 'Avg. Price/EQ',
                        unit: '',
                    },
                    {
                        value: 'base_price_per_eq',
                        index: 0,
                        label: 'Base Price/EQ',
                        unit: '',
                    },
                    {
                        value: 'promo_price_per_eq',
                        index: 0,
                        label: 'Promo Price/EQ',
                        unit: '',
                    },
                    {
                        value: 'market_share_volume',
                        index: 0,
                        label: 'Market Share %',
                        unit: '',
                    },
                    {
                        value: 'distribution_tdp',
                        index: 0,
                        label: 'Distribution TDP',
                        unit: '',
                    },
                    {
                        value: 'display_tdp',
                        index: 0,
                        label: 'Display TDP',
                        unit: '',
                    },
                    {
                        value: 'feature_tdp',
                        index: 0,
                        label: 'Feature TDP',
                        unit: '',
                    },
                    {
                        value: 'feature_and_display_tdp',
                        index: 0,
                        label: 'Feature and Display TDP',
                        unit: '',
                    },
                    {
                        value: 'unit_velocity',
                        index: 0,
                        label: 'Unit Velocity',
                        unit: '',
                    },
                    {
                        value: 'sales_velocity',
                        index: 0,
                        label: 'Dollar Velocity',
                        unit: '$',
                    },
                    {
                        value: 'volume_velocity',
                        index: 0,
                        label: 'Eq Velocity',
                        unit: '',
                    },
                    {
                        value: 'subsidized_base_sales',
                        index: 0,
                        label: 'Subsidized Base Sales',
                        unit: '',
                    },
                ],
                val: [
                    {
                        value: 'avg_price_per_eq',
                        index: 0,
                        label: 'Avg. Price/EQ',
                        unit: '',
                    },
                    {
                        value: 'base_price_per_eq',
                        index: 0,
                        label: 'Base Price/EQ',
                        unit: '',
                    },
                    {
                        value: 'promo_price_per_eq',
                        index: 0,
                        label: 'Promo Price/EQ',
                        unit: '',
                    },
                    {
                        value: 'market_share_value',
                        index: 0,
                        label: 'Market Share %',
                        unit: '',
                    },
                    {
                        value: 'distribution_tdp',
                        index: 0,
                        label: 'Distribution TDP',
                        unit: '',
                    },
                    {
                        value: 'display_tdp',
                        index: 0,
                        label: 'Display TDP',
                        unit: '',
                    },
                    {
                        value: 'feature_tdp',
                        index: 0,
                        label: 'Feature TDP',
                        unit: '',
                    },
                    {
                        value: 'feature_and_display_tdp',
                        index: 0,
                        label: 'Feature and Display TDP',
                        unit: '',
                    },
                    {
                        value: 'unit_velocity',
                        index: 0,
                        label: 'Unit Velocity',
                        unit: '',
                    },
                    {
                        value: 'sales_velocity',
                        index: 0,
                        label: 'Dollar Velocity',
                        unit: '$',
                    },
                    {
                        value: 'volume_velocity',
                        index: 0,
                        label: 'Eq Velocity',
                        unit: '',
                    },
                    {
                        value: 'subsidized_base_sales',
                        index: 0,
                        label: 'Subsidized Base Sales',
                        unit: '',
                    },
                ],
                units: [
                    {
                        value: 'avg_price_per_unit',
                        index: 0,
                        label: 'Avg. Price/Unit ($)',
                        unit: '',
                    },
                    {
                        value: 'base_price_per_unit',
                        index: 0,
                        label: 'Base Price/unit',
                        unit: '',
                    },
                    {
                        value: 'promo_price_per_unit',
                        index: 0,
                        label: 'Promo Price/Unit',
                        unit: '',
                    },
                    {
                        value: 'market_share_units',
                        index: 0,
                        label: 'Market Share %',
                        unit: '',
                    },
                    {
                        value: 'distribution_tdp',
                        index: 0,
                        label: 'Distribution TDP',
                        unit: '',
                    },
                    {
                        value: 'display_tdp',
                        index: 0,
                        label: 'Display TDP',
                        unit: '',
                    },
                    {
                        value: 'feature_tdp',
                        index: 0,
                        label: 'Feature TDP',
                        unit: '',
                    },
                    {
                        value: 'feature_and_display_tdp',
                        index: 0,
                        label: 'Feature and Display TDP',
                        unit: '',
                    },
                    {
                        value: 'unit_velocity',
                        index: 0,
                        label: 'Unit Velocity',
                        unit: '',
                    },
                    {
                        value: 'sales_velocity',
                        index: 0,
                        label: 'Dollar Velocity',
                        unit: '$',
                    },
                    {
                        value: 'volume_velocity',
                        index: 0,
                        label: 'Eq Velocity',
                        unit: '',
                    },
                    {
                        value: 'subsidized_base_sales',
                        index: 0,
                        label: 'Subsidized Base Sales',
                        unit: '',
                    },
                ],
            },
            promoTypeColorMapping: {
                'tpr/scan': {
                    label: 'TPR/Scan',
                    color: colorConstants.lightGreenAlt,
                },
                'feature ad': {
                    label: 'Feature Ad',
                    color: colorConstants.darkGreenAlt2,
                },
                display: { label: 'Display', color: colorConstants.pinkAlt },
                feature_display_tpr: {
                    label: 'Feature_Display_TPR',
                    color: colorConstants.orangeAlt2,
                },
                display_tpr: {
                    label: 'Display_TPR',
                    color: colorConstants.darkBlueAlt,
                },
            },
            stackedColors: [
                colorConstants.lightGreenAlt,
                colorConstants.darkGreenAlt2,
                colorConstants.pinkAlt,
                colorConstants.orangeAlt2,
                colorConstants.darkYellow,
            ],
            fieldKeyLabelMapping: {
                base_eq_volume: {
                    label: 'Base Sales (Eq Vol)',
                    color: colorConstants.darkYellow,
                    tableLabel: 'Base',
                },
                base_value: {
                    label: 'Base Sales ($)',
                    color: colorConstants.darkYellow,
                    tableLabel: 'Base',
                },
                base_units: {
                    label: 'Base Units',
                    color: colorConstants.darkYellow,
                    tableLabel: 'Base',
                },
                incremental_eq_volume: {
                    label: 'Incremental Sales (Eq Vol)',
                    color: colorConstants.darkGreenAlt2,
                    tableLabel: 'Incremental',
                },
                incremental_value: {
                    label: 'Incremental Sales ($)',
                    color: colorConstants.darkGreenAlt2,
                    tableLabel: 'Incremental',
                },
                incremental_units: {
                    label: 'Incremental Units',
                    color: colorConstants.darkGreenAlt2,
                    tableLabel: 'Incremental',
                },
                any_promo_eq_volume: {
                    label: 'Promo',
                    color: colorConstants.darkGreenAlt2,
                    tableLabel: 'Promo',
                },
                any_promo_value: {
                    label: 'Promo',
                    color: colorConstants.darkGreenAlt2,
                    tableLabel: 'Promo',
                },
                any_promo_units: {
                    label: 'Promo',
                    color: colorConstants.darkGreenAlt2,
                    tableLabel: 'Promo',
                },
                tpr_incremental_eq_volume: {
                    label: 'TPR Incremental',
                    color: colorConstants.lightGreenAlt,
                    tableLabel: 'TPR Incremental',
                },
                feature_incremental_eq_volume: {
                    label: 'Feature Incremental',
                    color: colorConstants.darkGreenAlt2,
                    tableLabel: 'Feature Incremental',
                },
                display_incremental_eq_volume: {
                    label: 'Display Incremental',
                    color: colorConstants.pinkAlt,
                    tableLabel: 'Display Incremental',
                },
                feature_and_display_incremental_eq_volume: {
                    label: 'F & D Incremental',
                    color: colorConstants.orangeAlt2,
                    tableLabel: 'F & D Incremental',
                },
                tpr_incremental_value: {
                    label: 'TPR Incremental',
                    color: colorConstants.lightGreenAlt,
                    tableLabel: 'TPR Incremental',
                },
                feature_incremental_value: {
                    label: 'Feature Incremental',
                    color: colorConstants.darkGreenAlt2,
                    tableLabel: 'Feature Incremental',
                },
                display_incremental_value: {
                    label: 'Display Incremental',
                    color: colorConstants.pinkAlt,
                    tableLabel: 'Display Incremental',
                },
                feature_and_display_incremental_value: {
                    label: 'F & D Incremental',
                    color: colorConstants.orangeAlt2,
                    tableLabel: 'F & D Incremental',
                },
                tpr_incremental_units: {
                    label: 'TPR Incremental',
                    color: colorConstants.lightGreenAlt,
                    tableLabel: 'TPR Incremental',
                },
                feature_incremental_units: {
                    label: 'Feature Incremental',
                    color: colorConstants.darkGreenAlt2,
                    tableLabel: 'Feature Incremental',
                },
                display_incremental_units: {
                    label: 'Display Incremental',
                    color: colorConstants.pinkAlt,
                    tableLabel: 'Display Incremental',
                },
                feature_and_display_incremental_units: {
                    label: 'F & D Incremental',
                    color: colorConstants.orangeAlt2,
                    tableLabel: 'F & D Incremental',
                },
                tpr_only_eq_volume: {
                    label: 'TPR',
                    color: colorConstants.lightGreenAlt,
                    tableLabel: 'TPR',
                },
                tpr_only_value: {
                    label: 'TPR',
                    color: colorConstants.lightGreenAlt,
                    tableLabel: 'TPR',
                },
                feature_only_eq_volume: {
                    label: 'Feature',
                    color: colorConstants.darkGreenAlt2,
                    tableLabel: 'Feature',
                },
                feature_only_value: {
                    label: 'Feature',
                    color: colorConstants.darkGreenAlt2,
                    tableLabel: 'Feature',
                },
                display_only_eq_volume: {
                    label: 'Display',
                    color: colorConstants.pinkAlt,
                    tableLabel: 'Display',
                },
                display_only_value: {
                    label: 'Display',
                    color: colorConstants.pinkAlt,
                    tableLabel: 'Display',
                },
                feature_and_display_only_eq_volume: {
                    label: 'F & D',
                    color: colorConstants.orangeAlt2,
                    tableLabel: 'F & D',
                },
                feature_and_display_only_value: {
                    label: 'F & D',
                    color: colorConstants.orangeAlt2,
                    tableLabel: 'F & D',
                },
                no_promo_eq_volume: {
                    label: 'Non Promo',
                    color: colorConstants.darkYellow,
                    tableLabel: 'Non Promo',
                },
                no_promo_value: {
                    label: 'Non Promo',
                    color: colorConstants.darkYellow,
                    tableLabel: 'Non Promo',
                },
                tpr_only_units: {
                    label: 'TPR',
                    color: colorConstants.lightGreenAlt,
                    tableLabel: 'TPR',
                },
                feature_only_units: {
                    label: 'Feature',
                    color: colorConstants.darkGreenAlt2,
                    tableLabel: 'Feature',
                },
                display_only_units: {
                    label: 'Display',
                    color: colorConstants.pinkAlt,
                    tableLabel: 'Display',
                },
                feature_and_display_only_units: {
                    label: 'F & D',
                    color: colorConstants.orangeAlt2,
                    tableLabel: 'F & D',
                },
                no_promo_units: {
                    label: 'Non Promo',
                    color: colorConstants.darkYellow,
                    tableLabel: 'Non Promo',
                },

                //for export label
                sales_year_ago: { label: 'YA Sales' },
                total_value: { label: 'Total' },
                incremental_eq_volume_percentage: {
                    label: 'Incremental Sales Percentage',
                },
                incremental_value_percentage: {
                    label: 'Incremental Sales Percentage',
                },
                incremental_units_percentage: {
                    label: 'Incremental Sales Percentage',
                },
                base_value_percentage: { label: 'Base Sales Percentage' },
                base_eq_volume_percentage: { label: 'Base Sales Percentage' },
                base_units_percentage: { label: 'Base Units Percentage' },
                any_promo_eq_volume_percentage: { label: 'Promo Percentage' },
                any_promo_value_percentage: { label: 'Promo Percentage' },
                any_promo_units_percentage: { label: 'Promo Percentage' },
                no_promo_eq_volume_percentage: {
                    label: 'Non Promo Percentage',
                },
                no_promo_units_percentage: { label: 'Non Promo Percentage' },
                no_promo_value_percentage: { label: 'Non Promo Percentage' },
            },

            tooltipExtraItems: {
                tpr_acv: { label: 'Tpr ACV %' },
                display_acv: { label: 'Display ACV %' },
                feature_acv: { label: 'Feature ACV %' },
                feature_and_display_acv: { label: 'F&D ACV %' },
                uplift: { label: 'Uplift' },
                promo_lift: { label: 'Promo Uplift' },
                media_lift: { label: 'Media Uplift' },
            },
            promoCalenderAttributeLevels: {
                promo: [
                    { value: 'product', label: 'Product' },
                    { value: 'geography', label: 'Geography' },
                ],
            },
            overlayKeys: {
                promo: [
                    { label: 'Start Week', dataKey: 'startTimestamp' },
                    { label: 'End Week', dataKey: 'endTimestamp' },
                    { label: 'Product', dataKey: 'product' },
                    { label: 'Promo Mechanics', dataKey: 'promoMech' },
                    { label: 'Promo Type', dataKey: 'promoType' },
                    { label: 'Investment', dataKey: 'field_value' },
                    // { label: 'ROI', dataKey: 'roi' },
                    // { label: 'Lift', dataKey: 'lift' },
                    // { label: 'Incremental Profit', dataKey: 'incrementalProfit' },
                    // { label: 'Incremental Retailer Profit', dataKey: 'incrementalRetailerProfit' },
                ],
            },
        },
        //PROMO SCORE CARD
        promoScoreCard: {
            mainHeader: 'Promo Scorecard',
            limit: 50,
            nestedTableLimit: 10,
            questionsNo: [1, 2, 3, 4, 5, 6, 7, 8],
            question: {
                Q: [
                    'Am I getting my fair share of quality support? ',
                    'How does my % Discount compare to competition? ',
                    'What % of Volume was sold on promotion? ',
                    'How many weeks am I promoting? ',
                    'What is my average price per eq volume? ',
                    'What is my average price/units? ',
                    'What is my value share of promotions? ',
                    'What is my volume share of promotions? ',
                ],
                unitsInItalics: [
                    '(Fair Share Index -$ Sold)',
                    '(Weighted Average % Price Reduction)',
                    '(% of Volume)',
                    '(Weighted Weeks)',
                    '(Price per bars/oz)',
                    '(Price per Unit)',
                    '(Value share %)',
                    '(EQ Volume %)',
                ],
                unit: ['value', '%', '%', 'week', '$', '$', '%', '%'],
                numberFormateDecimal: [0, 1, 1, 0, 2, 2, 1, 1],
            },
            promoTypeLabelMapping: {
                display: { label: 'Display Only' },
                tpr: { label: 'TPR Only' },
                feature: { label: 'Feature Only' },
                feature_and_display: { label: 'Feature & Display Only' },
                feature_display: { label: 'Feature & Display Only' },
            },
            showGradientTile: true,
            promoType: ['TPR Only', 'Display Only', 'Feature Only', 'Feature & Display Only'],
            promoExpandedViewTableUnit: 'volume',
            promoExpandedViewTableSalesAndVolumeLabel: ['EQ Volume', 'Total Sales $'],
            dropDown: ['Category', 'Manufacturer', 'Segment', 'Product_Type', 'Brand'],
            listFor: ['Brand', 'product'],
            listForToDisplay: ['Brand', 'product'],
            listIn: [
                'Category',
                'Sub_Category',
                'Manufacturer',
                'Pricing_Group',
                'Pack_Type',
                'Segment',
                'Channel',
                'Retailer',
                'geography',
            ],
        },

        // PROMO LANDSCAPE
        promoLandscape: {
            mainHeader: 'Investment & ROI Tracker',
            roiLabel: 'ROI',
            optimalInvestmentIndexThreshold1: 0.8,
            defaultAttributeTypeIndex: 10,
            optimalInvestmentIndexThreshold2: 1.2,
            promoTacticDropdownName: 'Investment Type',
            dimensionConfig: {
                //snake case eg sub_category
                excludedDimensions: [],
                defaultDimension: '',
            },
            thresholdColorMapping: {
                optimal: { label: 'Optimal', color: colorConstants.darkGreen },
                over: { label: 'Over', color: colorConstants.darkRed },
                under: { label: 'Under', color: colorConstants.darkBlueAlt },
            },
            limit: 60,
            promoTypes: [
                { value: 'display', label: 'Display' },
                { value: 'tpr', label: 'TPR' },
                { value: 'feature', label: 'Feature' },
                // { value: 'feature & display', label: 'Feature & Display' },  //not required for now
            ],
            mediaLevelsDropdown: [],
            optimalIndexKey: 'competition_spend_index',
            showInvestmentDropdown: false,
            tableRowsKeyMapping: [
                {
                    label: 'Investment',
                    children: null,
                    parentKey: null,
                    key: 'investments',
                    unit: '$',
                },
                {
                    label: 'ROI',
                    children: null,
                    parentKey: null,
                    key: 'roi',
                    unit: '',
                },
                {
                    label: 'Optimal Investment Index',
                    children: [
                        {
                            label: 'Share of Investment',
                            key: 'share_of_investment',
                            unit: '',
                        },
                        {
                            label: 'Share of Sales',
                            key: 'share_of_sales',
                            unit: '',
                        },
                    ],
                    unit: '',
                    parentKey: 'competition_data',
                    key: 'competition_spend_index',
                },
                {
                    label: 'Incremental Sales Dollar',
                    children: [
                        {
                            label: 'Total Sales Dollar',
                            key: 'total_sales',
                            unit: '$',
                        },
                        {
                            label: 'Base Sales Dollar',
                            key: 'base_sales_dollar',
                            unit: '$',
                        },
                        {
                            label: 'Incremental Sales Eq',
                            key: 'incremental_sales_eq',
                            unit: '',
                        },
                        {
                            label: 'Total Sales Eq',
                            key: 'total_sales_eq',
                            unit: '',
                        },
                        {
                            label: 'Base Sales Eq',
                            key: 'base_sales_eq',
                            unit: '',
                        },
                    ],
                    unit: '$',
                    parentKey: 'incremental_sales_dollar_data',
                    key: 'incremental_sales_dollar',
                },
                {
                    label: 'Incremental Profit',
                    children: [
                        {
                            label: 'Share of Profit Pool',
                            key: 'share_of_profit_pool',
                            unit: '',
                        },
                        {
                            label: 'Total Profit',
                            key: 'total_profit',
                            unit: '',
                        },
                        {
                            label: 'Baseline Profit',
                            key: 'baseline_profit',
                            unit: '',
                        },

                        {
                            label: 'Incremental Net Sales',
                            key: 'incremental_net_sales',
                            unit: '$',
                        },
                        {
                            label: 'Total Net Sales',
                            key: 'total_net_sales',
                            unit: '$',
                        },
                        {
                            label: 'Baseline Net Sales',
                            key: 'baseline_net_sales',
                            unit: '$',
                        },
                        {
                            label: 'Promo % Margin',
                            key: 'promo_percentage_margin',
                            unit: '',
                        },
                        {
                            label: 'Baseline % Margin',
                            key: 'baseline_percentage_margin',
                            unit: '',
                        },
                    ],
                    parentKey: 'incremental_profit_data',
                    key: 'incremental_profit',
                    unit: '$',
                },
                {
                    label: 'Incremental Retailer Profit',
                    unit: '$',
                    children: [
                        {
                            label: 'Share of Profit Pool',
                            key: 'share_of_profit_pool_retailer',
                            unit: '',
                        },
                        {
                            label: 'Total Retailer Profit',
                            key: 'total_retailer_profit',
                            unit: '',
                        },
                        {
                            label: 'Baseline Retailer Profit',
                            key: 'baseline_retailer_profit',
                            unit: '',
                        },
                        {
                            label: 'Retailer Promo % Margin',
                            key: 'retailer_promo_percentage_margin',
                            unit: '',
                        },
                        {
                            label: 'Retailer Baseline % Margin',
                            key: 'retailer_baseline_percentage_margin',
                            unit: '',
                        },
                    ],
                    parentKey: 'incremental_retailer_profit_data',
                    key: 'incremental_retailer_profit',
                },
            ],
        },
        //PORTFOLIO ANALYSIS
        portfolioAnalysis: {
            mainHeader: 'Promo ROI Analysis',
            limit: 20,
            defaultGroupByIndex: 15,
            defaultGroupBy2Index: 5,
            chartColors: [],
            absTileData: [
                { key: 'Promotions', label: 'Promotions' },
                { key: 'Drivers', label: 'Drivers' },
            ],
            salesAttributionChart: {
                colorList: ['#10AB5E', '#DC3826'],
                colorListType2: ['#758BEE', '#758BEE'],
                profitPoolColor: ['#826FD0', '#826FD0'],
                backGroundColor: 'rgba(0, 0, 0, 0.02)',
            },
            chartDropdownExtraKpis: [
                {
                    dimension: 'none',
                    label: 'Tactics',
                    dataKey: 'tactic_description',
                },
                {
                    dimension: 'none',
                    label: 'Mechanics',
                    dataKey: 'promotion_mechanic',
                },
                {
                    dimension: 'none',
                    label: 'Event Name',
                    dataKey: 'event_name',
                },
                {
                    dimension: 'dim1',
                    label: 'Week',
                    dataKey: 'week',
                },
            ],
            groupByHeaders: [
                {
                    label: 'Category',
                    value: 'category',
                    dimension: 'dim1',
                    isSelected: false,
                    sortKey: 'category',
                    multiSelectFilter: false,
                },
                {
                    label: 'Sub Category',
                    value: 'sub_category',
                    dimension: 'dim1',
                    isSelected: false,
                    sortKey: 'sub_category',
                    multiSelectFilter: false,
                },
                {
                    label: 'Brand',
                    value: 'brand',
                    dimension: 'dim1',
                    isSelected: true,
                    sortKey: 'brand',
                    multiSelectFilter: false,
                },
                {
                    label: 'Sub Brand',
                    value: 'sub_brand',
                    dimension: 'dim1',
                    isSelected: false,
                    sortKey: 'sub_brand',
                    multiSelectFilter: false,
                },
                {
                    label: 'Product',
                    value: 'product',
                    dimension: 'dim1',
                    isSelected: true,
                    sortKey: 'product',
                    multiSelectFilter: false,
                },
                {
                    label: 'Mechanics',
                    value: 'promotion_mechanic',
                    dimension: null,
                    isSelected: false,
                    sortKey: 'promotion_mechanic',
                    multiSelectFilter: true,
                },
                {
                    label: 'Tactic',
                    value: 'tactic_description',
                    dimension: null,
                    isSelected: false,
                    sortKey: 'tactic_description',
                    multiSelectFilter: true,
                },
            ],

            chartHeaderLabelKeyMapping: {
                lift: { label: 'Lift' },
                roi: { label: 'ROI' },
                investments: { label: 'Investments' },
                incremental_net_sales: { label: 'Incremental Net Sales' },
                incremental_profit: { label: 'Incremental Profit' },
                incremental_retailer_profit: {
                    label: 'Incremental Retailer Profit',
                },
                acv: { label: 'ACV Distribution' },
                profit_pool: { label: 'Profit Pool' },
                tpr_acv: { label: 'Tpr ACV' },
                display_acv: { label: 'Display ACV' },
                feature_acv: { label: 'Feature ACV' },
                feature_and_display_acv: { label: 'F&D ACV' },
                total_acv: { label: 'Total ACV' },
                weeks: { label: 'Promo Weeks' },
            },
            promoTypesChartLegends: [
                {
                    label: 'TPR',
                    color: colorConstants.lightCyan,
                    style: {
                        borderRadius: '100%',
                        height: `8px`,
                        width: '8px',
                    },
                },
                {
                    label: 'Feature',
                    color: colorConstants.lightCream,
                    style: {
                        borderRadius: '100%',
                        height: `8px`,
                        width: '8px',
                    },
                },
                {
                    label: 'Display',
                    color: colorConstants.lightPink,
                    style: {
                        borderRadius: '100%',
                        height: `8px`,
                        width: '8px',
                    },
                },
            ],
            promoTypes: ['tpr', 'feature', 'display'],
            promoTypesLabelMapping: {
                tpr: 'TPR',
                feature: 'Feature',
                display: 'Display',
            },
        },
        promoRecommendation: {
            playbookLimit: 50,
            clientName: 'TruFru',
            hideAddSpends: false,
            mainHeader: 'Promo Recommendation',

            retailerKey: 'Retailer',
            calenderStartDay: 'Monday',
            spendLeversList: [
                {
                    label: 'Baseline Volume',
                    placeholder: 'Baseline Volume',
                    value: 'baseVolume',
                    isDisabled: false,
                },
                {
                    label: 'Uplift',
                    placeholder: 'Uplift',
                    value: 'uplift',
                    isDisabled: false,
                },
                {
                    label: 'Total Volume',
                    placeholder: 'Total Volume',
                    value: 'totalVolume',
                    isDisabled: true,
                },
                {
                    label: `Total TruFru Profit ($)`,
                    placeholder: `Total TruFru Profit`,
                    value: 'totalKindProfit',
                    isDisabled: true,
                },
                {
                    label: 'ROI',
                    placeholder: 'ROI',
                    value: 'roi',
                    isDisabled: true,
                },
                {
                    label: `Total Retailer Profit ($)`,
                    placeholder: 'Total Retailer Profit',
                    value: 'totalRetailerProfit',
                    isDisabled: true,
                },
            ],
            spendTypeList: [
                {
                    label: 'Lump Sum',
                    value: 'lump_sum',
                    inputRule: '',
                },
                {
                    label: 'Per Qty',
                    value: 'per_qty',
                    inputRule: '',
                },
                {
                    label: 'Display',
                    value: 'display',
                    inputRule: '',
                },
                {
                    label: 'Feature',
                    value: 'feature',
                    inputRule: '',
                },
            ],
            playbookKeyMapping: {
                Product: ['ppgName'],
                '%TS': ['guidelinePercentageTotalSpends', 'percentageTotalSpends', 'lesser_than', '', '%'],
                Frequency: ['guidelineFrequency', 'frequency', 'range', ''],
                ROI: ['guidelineRoi', 'roi', 'greater_than', '', ''],
            },
            // comparisonOperator: {
            //     '%TS': '<',
            //     Frequency: 'range',
            //     ROI: '>',
            // },
            menuButtons: [
                { key: 'recommendations', label: 'Recommendations' },
                {
                    key: 'summary',
                    label: 'Summary',
                },
                {
                    key: 'playbook',
                    label: 'Playbook',
                },
            ],

            promoTypeColorMapping: {
                'tpr/scan': {
                    label: 'TPR/Scan',
                    color: colorConstants.lightGreenAlt,
                },
                feature_ad: {
                    label: 'Feature Ad',
                    color: colorConstants.darkGreenAlt2,
                },
                display: { label: 'Display', color: colorConstants.pinkAlt },
                feature_display_tpr: {
                    label: 'Feature_Display_TPR',
                    color: colorConstants.orangeAlt2,
                },
                display_tpr: {
                    label: 'Display_TPR',
                    color: colorConstants.darkBlueAlt,
                },
            },
            overlayKeys: [
                {
                    label: 'Start Date',
                    dataKey: 'startDate',
                    pre: '',
                    post: '',
                },
                { label: 'Duration', dataKey: 'duration', pre: '', post: '' },
                {
                    label: 'Promo Type',
                    dataKey: 'tacticDescription',
                    pre: '',
                    post: '',
                },
                { label: 'Product(s)', dataKey: 'dim1AttributeNames', pre: '', post: '' },
                {
                    label: 'Total Volume',
                    dataKey: 'totalVolume',
                    pre: '',
                    post: '',
                    arrowConfig: 'positiveUp',
                },
                {
                    label: 'Total GSV',
                    dataKey: 'totalGsv',
                    pre: '$',
                    post: '',
                    arrowConfig: 'positiveUp',
                },
                {
                    label: 'Total NSV',
                    dataKey: 'totalNsv',
                    pre: '$',
                    post: '',
                    arrowConfig: 'positiveUp',
                },
                {
                    label: 'Total TruFru Profit',
                    dataKey: 'totalKindProfit',
                    pre: '$',
                    post: '',
                    arrowConfig: 'positiveUp',
                },
                {
                    label: 'Total Retailer Profit',
                    dataKey: 'totalRetailerProfit',
                    pre: '$',
                    post: '',
                    arrowConfig: 'positiveUp',
                },
                {
                    label: 'Promo Spends',
                    dataKey: 'promoSpends',
                    pre: '$',
                    post: '',
                    arrowConfig: 'negativeUp',
                },
                {
                    label: '% Trade Spends GSV',
                    dataKey: 'percentageTradeSpendsGsv',
                    pre: '',
                    post: '%',
                    arrowConfig: 'negativeUp',
                },
                {
                    label: '% Trade Spends NSV',
                    dataKey: 'percentageTradeSpendsNsv',
                    pre: '',
                    post: '%',
                    arrowConfig: 'negativeUp',
                },

                {
                    label: 'Incremental Volume',
                    dataKey: 'incrementalVolume',
                    pre: '',
                    post: '',
                    arrowConfig: 'positiveUp',
                },
                {
                    label: 'Incremental GSV',
                    dataKey: 'incrementalGsv',
                    pre: '$',
                    post: '',
                    arrowConfig: 'positiveUp',
                },
                {
                    label: 'Incremental NSV',
                    dataKey: 'incrementalNsv',
                    pre: '$',
                    post: '',
                    arrowConfig: 'positiveUp',
                },
                {
                    // label: 'Total Profit %',
                    dataKey: 'totalProfitPercentage',
                    pre: '',
                    post: '%',
                    arrowConfig: 'positiveUp',
                },
                {
                    label: 'Incremental Profit',
                    dataKey: 'incrementalProfit',
                    pre: '$',
                    post: '',
                    arrowConfig: 'positiveUp',
                },
                {
                    label: 'Promo ROI',
                    dataKey: 'roi',
                    pre: '',
                    post: '',
                    arrowConfig: 'positiveUp',
                },
                {
                    label: 'Retailer Incremental Profit',
                    dataKey: 'retailerIncrementalProfit',
                    pre: '$',
                    post: '',
                    arrowConfig: 'positiveUp',
                },
            ],
            spendLabel: {
                lump_sum: 'Lump Sum',
                per_qty: 'Per Qty',
                display: 'Display',
                feature: 'Feature',
            },
            offerMethodList: [
                { value: 'option', label: 'List of Option', dimension: 'dim1' },
                { value: 'manual', label: 'Manual', dimension: 'dim1' },
                { value: 'previous', label: 'Previous', dimension: 'dim1' },
            ],
            addEventList: [
                { value: 'new', label: 'Add New Event' },
                { value: 'import', label: 'Import Event' },
            ],
            leverKeys: [
                'promptEventName',
                'offerMethod',
                'discount',
                'startDate',
                'duration',
                'displayAcv',
                'featureAcv',
            ],
            spendTopForm: ['baseVolume', 'uplift', 'totalVolume', 'totalKindProfit', 'roi', 'totalRetailerProfit'],
            formList: [
                {
                    value: 'duration',
                    label: 'Duration',
                    inputRule: '',
                    placeHolder: 'Enter',
                },
                {
                    value: 'displayAcv',
                    label: 'Display ACV',
                    inputRule: '',
                    placeHolder: 'Enter display ACV',
                },
                {
                    value: 'featureAcv',
                    label: 'Feature ACV',
                    inputRule: '',
                    placeHolder: 'Enter feature ACV',
                },
            ],
            offerSelectionKeys: ['promotionMechanic', 'tacticDescription'],
            spendPerQtyKey: ['per_qty', 'redemption'],
        },
        priceLadder: {
            isThresholdDropdownEnabled: true,
            hideMraup: true,
            limit: 100,
            dimensionConfig: {
                //snake case eg sub_category
                excludedDimensions: [],
                defaultDimension: 'Retailer',
            },
            tileData: [
                {
                    label: 'Product by Market',
                    key: 'product by market',
                },
                // {
                //     label: 'Product vs Competitors',
                //     key: 'product vs competitors',
                // },
            ],
            subTileData: [
                {
                    label: 'PU',
                    key: 'PU',
                },
                {
                    label: 'PEQ',
                    key: 'PEQ',
                },
            ],
            legendMapping: {
                PU: [
                    {
                        color: '#E6E6EA',
                        label: 'Sales $',
                        key: 'salesValueDollars',
                        dataKey: 'sales',
                        metricDataKey: 'units',
                    },
                    {
                        color: '#66AFBA',
                        label: 'Avg. Price PU',
                        key: 'avgPrice',
                        dataKey: 'avg_price_per_unit',
                        metricDataKey: 'units',
                    },
                    {
                        color: '#ECA586',
                        label: 'Max Price PU',
                        key: 'maxPrice',
                        dataKey: 'max_price_per_unit',
                        metricDataKey: 'units',
                    },
                    {
                        color: '#EB8FC5',
                        label: 'Min Price PU',
                        key: 'minPrice',
                        dataKey: 'min_price_per_unit',
                        metricDataKey: 'units',
                    },
                    {
                        color: '#F1C77A',
                        label: 'Promo Price PU',
                        key: 'promoPrice',
                        dataKey: 'promo_price_per_unit',
                        metricDataKey: 'units',
                    },
                    {
                        color: '#6771DB',
                        label: 'Base Price PU',
                        key: 'basePrice',
                        dataKey: 'base_price_per_unit',
                        metricDataKey: 'units',
                    },
                    // { color: '#5463FF', label: 'MRAUP', key: 'mraup', dataKey: 'mraup' },
                ],
                PEQ: [
                    {
                        color: '#E6E6EA',
                        label: 'Sales $',
                        key: 'salesValueDollars',
                        dataKey: '',
                        metricDataKey: 'volume',
                    },
                    {
                        color: '#66AFBA',
                        label: 'Avg. Price PEQ',
                        key: 'avgPrice',
                        dataKey: 'avg_price_per_eq',
                        metricDataKey: 'volume',
                    },
                    {
                        color: '#ECA586',
                        label: 'Max Price PEQ',
                        key: 'maxPrice',
                        dataKey: 'max_price_per_eq',
                        metricDataKey: 'volume',
                    },
                    {
                        color: '#EB8FC5',
                        label: 'Min Price PEQ',
                        key: 'minPrice',
                        dataKey: 'min_price_per_eq',
                        metricDataKey: 'volume',
                    },
                    {
                        color: '#F1C77A',
                        label: 'Promo Price PEQ',
                        key: 'promoPrice',
                        dataKey: 'promo_price_per_eq',
                        metricDataKey: 'volume',
                    },
                    {
                        color: '#6771DB',
                        label: 'Base Price PEQ',
                        key: 'basePrice',
                        dataKey: 'base_price_per_eq',
                        metricDataKey: 'volume',
                    },
                    // { color: '#5463FF', label: 'MRAUP', key: 'mraup', dataKey: 'mraup' },
                ],
            },
            dataKeyMapping: {
                PU: [
                    { label: 'Sales $', key: 'salesValueDollars' },
                    { label: 'Avg. Price PU', key: 'avgPrice' },
                    { label: 'Max Price PU', key: 'maxPrice' },
                    { label: 'Min Price PU', key: 'minPrice' },
                    { label: 'Promo Price PU', key: 'promoPrice' },
                    { label: 'Base Price PU', key: 'basePrice' },
                ],
                PEQ: [
                    { label: 'Sales $', key: 'salesValueDollars' },
                    { label: 'Avg. Price PEQ', key: 'avgPrice' },
                    { label: 'Max Price PEQ', key: 'maxPrice' },
                    { label: 'Min Price PEQ', key: 'minPrice' },
                    { label: 'Promo Price PEQ', key: 'promoPrice' },
                    { label: 'Base Price PEQ', key: 'basePrice' },
                ],
            },
            tableColumnLabelKeyMapping: {
                sales: { label: 'Sales $' },
                sales_percentage: { label: 'Sales %' },
                avg_price_pu: { label: 'Average Price $ PU' },
                avg_price_peq: { label: 'Average Price $ PEQ' },
                max_price_pu: { label: 'Max Price $ PU' },
                max_price_peq: { label: 'Max Price $ PEQ' },
                min_price_pu: { label: 'Min Price $ PU' },
                min_price_peq: { label: 'Min Price $ PEQ' },
                // mraup: { label: 'MRAUP' },
                base_price_pu: { label: 'Base Price $ PU' },
                base_price_peq: { label: 'Base Price $ PEQ' },
                promo_price_pu: { label: 'Promo Price $ PU' },
                promo_price_peq: { label: 'Promo Price $ PEQ' },
            },
            dropdown2Filter: ['Category', 'Pack_Size', 'Segment', 'Channel', 'Retailer'],
        },
        opportunityIdentification: {
            reversePpeAxis: false,
            bubbleCategoryOptions: [
                { value: 'brand', label: 'Brand', dimension: 'dim1' },
                { value: 'category', label: 'Category', dimension: 'dim1' },
                {
                    value: 'sub_category',
                    label: 'Sub Category',
                    dimension: 'dim1',
                },
                { value: 'manufacturer', label: 'Manufacturer', dimension: 'dim1' },
                { value: 'segment', label: 'Segment', dimension: 'dim1' },
                { value: 'Pack_Type', label: 'Pack Type', dimension: 'dim1' },
                { value: 'form', label: 'Form', dimension: 'dim1' },
                { value: 'flavour', label: 'Flavour', dimension: 'dim1' },
                { value: 'size', label: 'Size', dimension: 'dim1' },
                { value: 'product_description', label: 'Product Description', dimension: 'dim1' },
                { value: 'product', label: 'Product', dimension: 'dim1' },
                { value: 'channel', label: 'Channel', dimension: 'dim2' },
                { value: 'retailer', label: 'Retailer', dimension: 'dim2' },
                { value: 'geography', label: 'Geography', dimension: 'dim2' },
            ],
            kpis: {
                xaxis: [
                    { label: 'BPE', value: 'bpe' },
                    { label: '% RSV Growth', value: 'rsv_growth' },
                    { label: 'MAC %', value: 'mac_percentage' },
                ],
                yaxis: [
                    { label: 'PPE', value: 'ppe' },
                    { label: '% RSV Growth', value: 'rsv_growth' },
                    { label: 'MAC %', value: 'mac_percentage' },
                ],
                bubbleSize: [
                    { label: 'Eq Volume', value: 'total_volume' },
                    { label: 'BPE', value: 'bpe' },
                    { label: 'PPE', value: 'ppe' },
                    { label: 'MAC', value: 'mac' },
                    { label: 'MAC %', value: 'mac_percentage' },
                    { label: 'RSV', value: 'rsv' },
                    { label: '% RSV Growth', value: 'rsv_growth' },
                ],
            },
            elasticityDriver: {
                chart2Limit: 100,
                levels: [
                    { label: 'Retailer', value: 'retailer', dimension: 'dim2' },
                    { label: 'Product', value: 'product', dimension: 'dim1' },
                    { label: 'Brand', value: 'brand', dimension: 'dim1' },
                    { value: 'category', label: 'Category', dimension: 'dim1' },
                    {
                        value: 'sub_category',
                        label: 'Sub Category',
                        dimension: 'dim1',
                    },
                ],
                limit: 50,
                offset: 0,
                dimension: 'dim1',
                legendMapping: [
                    {
                        dataKey: 'own',
                        label: 'Own Elasticity',
                        color: '#69D4E8',
                    },
                    {
                        dataKey: 'internal',
                        label: 'Internal Competitor Elasticity',
                        color: '#E469B2',
                    },
                    {
                        dataKey: 'external',
                        label: 'External Competitor Elasticity',
                        color: '#EDB44E',
                    },
                ],
            },
        },
        priceCurve: {
            chart1Limit: 100,
            xAxisKeyValue: [
                // { value: 'pack_type', label: 'Pack Type' },
                // { value: 'brand', label: 'Brand' },
                // { value: 'segment', label: 'Segment' },
                { value: 'size', label: 'Size' },
                // { value: 'product', label: 'Product' },
            ],
            YAxisKeyValue: [
                { value: 'retail_price', label: 'Retail Price' },
                { value: 'base_price', label: 'Base Price' },
                { value: 'list_price', label: 'List Price' },
            ],
            levels: [
                { value: 'category', label: 'Category' },
                { value: 'sub_category', label: 'Sub Category' },
                { value: 'manufacturer', label: 'Manufacturer' },
                { value: 'brand', label: 'Brand' },
                { value: 'segment', label: 'Segment' },
                { value: 'form', label: 'Form' },
                { value: 'flavour', label: 'Flavour' },
                { value: 'pack_type', label: 'Pack Type' },
                { value: 'product', label: 'Product' },
            ],
            subTileData: [
                {
                    label: 'PU',
                    key: 'PU',
                    dataKey: 'per_unit',
                },
                {
                    label: 'PEQ',
                    key: 'PEQ',
                    dataKey: 'per_eq',
                },
            ],
            chartColors: [
                '#E8A122',
                '#293BB8',
                '#E06936',
                '#19669D',
                '#A5582D',
                '#43C9E2',
                '#DD449F',
                '#37C7BE',
                '#9E5897',
                '#00798C',
                '#EDB44E',
                '#4557D5',
                '#E6875E',
                '#228BD6',
                '#CC7442',
                '#69D4E8',
                '#E469B2',
                '#5FD3CB',
                '#B377AD',
                '#3394A3',
                '#F1C77A',
                '#7381E0',
                '#ECA586',
                '#55A8E4',
                '#D89672',
                '#8EDFEE',
                '#EB8FC5',
                '#87DED8',
                '#C699C2',
                '#66AFBA',
                '#F6D9A7',
                '#A2ABEA',
                '#F3C3AF',
                '#8EC5ED',
                '#E5B9A1',
                '#B4E9F3',
                '#F1B4D9',
                '#AFE9E5',
                '#D9BBD6',
                '#99C9D1',
                '#FAECD3',
                '#D0D5F5',
                '#F9E1D7',
                '#C6E2F6',
                '#F2DCD0',
                '#D9F4F9',
                '#F8DAEC',
                '#D7F4F2',
                '#ECDDEB',
                '#CCE4E8',
            ],
            tableHeaders: [
                { label: 'List Price $', key: 'list_price' },
                { label: 'List Price $ YA', key: 'list_price_ya' },
                { label: 'Retail Price $', key: 'retail_price' },
                { label: 'Retail Price $ YA', key: 'retail_price_ya' },
                { label: 'Base Price $', key: 'base_price' },
                { label: 'Base Price $ YA', key: 'base_price_ya' },
            ],
        },
        pricePoint: {
            priceRange: [0, 10],
            graphColorScheme: ['#D7D6D9', '#66AFBA', '#ECA586', '#F1C77A', '#EB8FC5'],
            hideMraup: true,
            limit: 500,
            dimensionConfig: {
                //snake case eg sub_category
                excludedDimensions: [],
                defaultDimension: 'Category',
            },
            contributionThreshold: 5,
            priceTypeOptions: [
                { label: 'Avg Price', value: 'avg_price' },
                { label: 'Base Price', value: 'base_price' },
            ],
            subTileData: [
                {
                    label: 'PU',
                    key: 'per_unit',
                    xAxisLabel: 'Price Per Unit',
                    tooltip: 'Per Unit',
                },
                {
                    label: 'PEQ',
                    key: 'per_volume',
                    xAxisLabel: 'Price Per Eq',
                    tooltip: 'Per Eq Volume',
                },
            ],
            yAxisDropdownData: [
                {
                    label: 'Dollars',
                    value: 'value',
                },
                {
                    label: 'Volume',
                    value: 'volume',
                },
                {
                    label: 'Units',
                    value: 'units',
                },
            ],
            tableHeaderKeyMapping: {
                growth_percentage: ['Growth % vs YA', '', '%'],
                total_sales: ['Total Value ($)', '$', ''],
                total_volume: ['Total Volume', '', ''],
                total_units: ['Total Units', '', ''],
                avg_price_per_unit: ['Avg. Price per Unit', '$', ''],
                avg_price_per_eq: ['Avg. Price per EQ', '$', ''],
                base_price_per_unit: ['Base Price per Unit', '$', ''],
                base_price_per_eq: ['Base Price per EQ', '$', ''],
            },
            drilldownTableHeaderKeyMapping: {
                growth_abs: ['Growth Abs', '$', ''],
                growth_percentage: ['Growth %', '', '%'],
                contribution_to_category: ['Contribution to category', '$', ''],
                cy_share: ['CY share', '', '%'],
                ya_share: ['YA share', '', '%'],
                change: ['Change %', '', '%'],
            },
            dropdown2Filter: ['Category', 'Pack_Size', 'Segment', 'Channel', 'Retailer'],
            customThresholdData: [
                {
                    id: 1,
                    value: '',
                },
                {
                    id: 2,
                    value: '',
                },
                {
                    id: 3,
                    value: '',
                },
                {
                    id: 4,
                    value: '',
                },
                {
                    id: 5,
                    value: '',
                },
            ],
        },
        priceTracking: {
            limit: 20,
            dimensionConfig: {
                //snake case eg sub_category
                excludedDimensions: ['form', 'flavour', 'product_description'],
                defaultRowDimension: 'Product',
                defaultColumnDimension: 'Retailer',
            },
            attributeNamesLimit: 50,
            frequency: 'W',
            timePeriodOptions: [
                { label: 'YA', value: 'year_ago' },
                { label: 'Prior Period', value: 'prior_period' },
                { label: 'Custom Period', value: 'custom' },
            ],
            priceTypeOptions: [
                { label: 'Base Price', value: 'base' },
                { label: 'Avg Price', value: 'average' },
            ],
            kpiOptions: [
                { label: '% Change', value: 'percent_change' },
                { label: 'Price Index', value: 'index' },
            ],
            subTileData: [
                {
                    label: 'PU',
                    key: 'units',
                    xAxisLabel: 'Price Per Unit',
                    tooltip: 'Per Unit',
                },
                {
                    label: 'PEQ',
                    key: 'volume',
                    xAxisLabel: 'Price Per Eq',
                    tooltip: 'Per Eq Volume',
                },
            ],
            weeksOptions: [
                { label: 'L W1', value: 1 },
                { label: 'L W4', value: 4 },
                { label: 'L W12', value: 12 },
            ],
            monthsOptions: [
                { label: 'L M1', value: 1 },
                { label: 'L M3', value: 3 },
                { label: 'L M6', value: 6 },
                { label: 'L M12', value: 12 },
            ],
            quartersOptions: [
                { label: 'L Q1', value: 1 },
                { label: 'L Q2', value: 2 },
                { label: 'L Q4', value: 4 },
            ],
            kpiMapping: {
                'Base Price': ['$', ''],
                'Base Price YA': ['$', ''],
                'Avg Price': ['$', ''],
                'Avg Price YA': ['$', ''],
                'Base Price Index % Chg': ['', '%'],
                'Base Price % Chg': ['', '%'],
                'Avg Price Index % Chg': ['', '%'],
                'Avg Price % Chg': ['', '%'],
                'TDP % Chg': ['', '%'],
                TDP: ['', ''],
                'TDP YA': ['', ''],
                'Volume Velocity % Chg': ['', '%'],
                'Volume Velocity': ['', ''],
                'Volume Velocity YA': ['', ''],
            },
        },
        bestWeeks: {
            limit: 50,
            drilldownTableConfig: [
                { label: 'Period No:', value: 'period_no', sorting: false },
                { label: 'Year', value: 'year', sorting: false },
            ],
            dimensionConfig: {
                //snake case eg sub_category
                excludedDimensions: ['dim2'],
                defaultDimension: 'Brand',
            },
        },
        rankingCriteriaOptions: [
            { label: 'Base Sales', value: 'base_eq_volume' },
            { label: 'ACV', value: 'total_per_acv_dist' },
            { label: 'Incremental', value: 'incremental_eq_volume' },
            { label: 'Total Volume', value: 'total_eq_volume' },
        ],
    },
    perrigo: {
        //COMMON CONFIG
        commonConfig: {
            clientName: 'Perrigo',
            handleDim2SortingFromFrontend: true,
            dateFormat: 'DD/MM/YY',
            dateFormatAlt: 'DD/MM/YY',
            calenderStartDay: 'Saturday',
            showSecondaryLogo: false,
            showLogoInNavbar: true,
            logoHeight: '32px',
            logoWidth: '125px',
            loginPageTextPart1: 'Welcome to',
            loginPageTextPart2: 'Commercial Growth AI Tool',
            width: window.innerWidth,
            limit: 10,
            offset: 0,
            lagList: [0, 1],
            graphFontSize: calculateFontSize(window.innerWidth, 13),
            graphFontSizeAlt: calculateFontSize(window.innerWidth, 13),
            graphFontFamily: "'Helvetica Neue', sans-serif",
            graphLabelColorAlt: '#4E4C55',
            graphLabelColor: '#433C4A',
            units: {
                currency: '£',
                volume: 'Eq Vol',
                currencyText: 'Value',
            },
            filterFormat: { dim1: { ids: [] }, dim2: { ids: [] } },
            frequency: 'W',
            showCampignCalender: false,
            showFullLabel: true,
            decimalForPercentage: 1,
            decimalForNonPercentage: 2,
        },
        latestDateForDifferentRoutes: {
            'promo-score-card': 'Promotion Data',
            'roi-analysis': 'Promotion Data',
            'roi-tracker': 'Promotion Data',
            'commercial-forecast': 'Commercial Forecast',
            default: 'POS Data',
        },
        screenDetailsWithRoutes: [
            {
                label: 'Growth Analysis',
                path: 'promo/category-diagnostics/growth-analysis',
                id: 'ga',
                pageId: 'ga',
            },
            {
                label: 'Bump Report',
                path: 'promo/category-diagnostics/bump-report',
                id: 'br',
                pageId: 'br',
            },
            {
                label: 'Price Change',
                path: 'pricing/analytics/price-change',
                id: 'pcn',
                pageId: 'pcn',
            },
            {
                label: 'Price Point',
                path: 'pricing/analytics/price-point',
                id: 'pp',
                pageId: 'pp',
            },
            {
                label: 'Price Ladder',
                path: 'pricing/analytics/price-ladder',
                id: 'pld',
                pageId: 'pld',
            },
            {
                label: 'Price Curve',
                path: 'pricing/analytics/price-curve',
                id: 'pc',
                pageId: 'pc',
            },
            {
                label: 'Price Tracking',
                path: 'pricing/analytics/price-tracking',
                id: 'pt',
                pageId: 'pt',
            },
            {
                label: 'Opportunity Identification',
                path: 'pricing/analytics/opportunity-identification',
                id: 'oi',
                pageId: 'oi',
            },
            {
                label: 'Promo Scorecard',
                path: 'promo/analytics/promo-score-card',
                id: 'ps',
                pageId: 'ps',
            },
            {
                label: 'Investment & ROI Tracker',
                path: 'promo/analytics/roi-tracker',
                id: 'pl',
                pageId: 'pl',
            },
            {
                label: 'Promo ROI Analysis',
                path: 'promo/analytics/roi-analysis',
                id: 'pa',
                pageId: 'pa',
            },
            {
                label: 'Commercial Forecast',
                path: 'promo/recommendation/commercial-forecast',
                id: 'cf',
                pageId: 'cf',
            },

            {
                label: 'Promo Recommendation',
                path: 'promo/recommendation/promo-recommendation',
                id: 'pr',
                pageId: 'pr',
            },
            // { label: 'Pricing Simulator', path: 'pricing/recommendation/price-simulator', id: 'psr', pageId: 'psr' },
            // {
            //     label: 'Pricing Simulator',
            //     path: 'pricing/recommendation/price-simulator/new',
            //     id: 'psr',
            //     pageId: 'psrNew',
            // },
            // {
            //     label: 'Pricing Simulator',
            //     path: 'pricing/recommendation/price-simulator/edit/:id',
            //     id: 'psr',
            //     pageId: 'psrEdit',
            // },
            // {
            //     label: 'Pricing Simulator',
            //     path: 'pricing/recommendation/price-simulator/view/:id',
            //     id: 'psr',
            //     pageId: 'psrView',
            // },
            {
                label: 'Pricing Simulator',
                path: 'pricing/recommendation/pricing-simulator',
                id: 'psrV2', //update id in simulator context as well
                pageId: 'psrV2',
            },
            {
                label: 'Pricing Simulator',
                path: 'pricing/recommendation/pricing-simulator/:mode/:projectId/scenario/:scenarioId',
                id: 'psr',
                pageId: 'psrV2Update',
            },
            {
                label: 'Pricing Simulator',
                path: 'pricing/recommendation/pricing-simulator/:mode/:projectId/scenario/:scenarioId',
                id: 'psr',
                pageId: 'psrV2View',
            },
            {
                label: 'Pricing Analytics',
                path: 'pricing/recommendation/pricing-analytics',
                id: 'psa',
                pageId: 'psa', // pricing analytics
            },
            {
                label: 'Pricing Analytics',
                path: 'pricing/recommendation/pricing-analytics/:mode/:reportId',
                id: 'psa',
                pageId: 'psaUpdate', // pricing analytics update
            },
            {
                label: 'Pricing Analytics',
                path: 'pricing/recommendation/pricing-analytics/:mode/:reportId',
                id: 'psa',
                pageId: 'psaView', // pricing analytics view
            },
            {
                label: 'Best Weeks',
                path: 'promo/recommendation/best-weeks',
                id: 'bw',
                pageId: 'bw',
            },
        ],
        screens: [
            {
                label: 'Category Diagnostics',
                path: ['promo/category-diagnostics'],
                showSubHeader: false,
                options: {
                    Promo: [
                        {
                            label: 'Growth Analysis',
                            path: 'growth-analysis',
                            id: 'ga',
                        },
                        { label: 'Bump Report', path: 'bump-report', id: 'br' },
                    ],
                    visible: false,
                },
            },
            {
                label: 'Pricing Analytics',
                path: ['pricing/analytics', null],
                showSubHeader: false,
                options: {
                    Promo: [
                        {
                            label: 'Price Change',
                            path: 'price-change',
                            id: 'pcn',
                        },
                        { label: 'Price Point', path: 'price-point', id: 'pp' },
                        {
                            label: 'Price Ladder',
                            path: 'price-ladder',
                            id: 'pld',
                        },
                        { label: 'Price Curve', path: 'price-curve', id: 'pc' },
                        {
                            label: 'Price Tracking',
                            path: 'price-tracking',
                            id: 'pt',
                        },
                        {
                            label: 'Opportunity Identification',
                            path: 'opportunity-identification',
                            id: 'oi',
                        },
                    ],
                    visible: false,
                },
            },
            {
                label: 'Spend Analytics',
                path: ['promo/analytics', null],
                showSubHeader: false,
                options: {
                    Promo: [
                        {
                            label: 'Promo Scorecard',
                            path: 'promo-score-card',
                            id: 'ps',
                        },
                        {
                            label: 'Investment & ROI Tracker',
                            path: 'roi-tracker',
                            id: 'pl',
                        },
                        {
                            label: 'Promo ROI Analysis',
                            path: 'roi-analysis',
                            id: 'pa',
                        },
                    ],
                    visible: false,
                },
            },
            {
                label: 'Price & Promo Modeling',
                path: ['promo/recommendation', 'pricing/recommendation'],
                showSubHeader: true,
                options: {
                    Promo: [
                        { label: 'Promo Recommendation', path: 'promo-recommendation', id: 'pr' },
                        { label: 'Commercial Forecast', path: 'commercial-forecast', id: 'cf' },
                        {
                            label: 'Best Weeks',
                            path: 'best-weeks',
                            id: 'bw',
                        },
                    ],
                    Pricing: [{ label: 'Pricing Simulator', path: 'pricing-simulator', id: 'psrV2' }],
                    visible: false,
                },
            },
        ],
        globalFilter: {
            presetConfig: {
                disablePresetFilter: false,
                presetEnabledRoutes: {
                    all: true,
                },
            },
            availableFrequenciesList: [{ key: 'W', label: 'Week' }],
            globalFilterChangingRoutes: {
                'commercial-forecast': {
                    dimensionListKey: 'default',
                    getGlobalTimestampsKey: 'commercial_forecast',
                    getAttributeNamesKey: 'default',
                    // disabledAttributeTypes: ['manufacturer'],
                    defaultGlobalFilterObj: null,
                },
            },
            retainFiltersAcrossFeatures: true,
            limit: 50,
            selectionAllowed: {
                'promo-recommendation': {
                    dim2: {
                        Retailer: 1,
                    },
                },
            },
            allSelectedLimit: 15,
            timePeriodScreenMapping: {
                default: ['4W', '12W', '26W', '52W', '1M', '3M', '6M', '12M', '1Q', '2Q', '4Q', 'CUSTOM DATE'],
                'bump-report': ['52W', '104W', '156W', '1M', '3M', '6M', '12M', '1Q', '2Q', '4Q', 'CUSTOM DATE'],
                'commercial-forecast': [
                    '4W',
                    '12W',
                    '26W',
                    '52W',
                    '1M',
                    '3M',
                    '6M',
                    '12M',
                    '1Q',
                    '2Q',
                    '4Q',
                    'YTG',
                    'CUSTOM DATE',
                ],
            },

            defaultPeriod: ['52W', '12M'],
            applyFilterApiPostFormat: {
                jsonstring_dim1: '{}',
                jsonstring_dim2: '{}',
            },
            defaultPreviousIdObject: {
                dim1: ['attr', 'attr'],
                dim2: ['attr', 'attr'],
            },
            defaultIdObject: {
                dim1: { ids: [] },
                dim2: { ids: [] },
            },
            defaultAttrIdObject: {
                attr: {
                    dim1: { ids: [] },
                    dim2: { ids: [] },
                },
            },

            promoScoreCardDefault: {
                Category: 'OTC COUGH COLD & RESPIRATORY',
                Retailer: 'All Outlets CC',
            },
            PromoScoreCardDefaultObj: {
                dim1: {
                    // Manufacturer: {
                    //     inclusion: [
                    //         {
                    //             dimension: 'dim1',
                    //             isActive: true,
                    //             attributeType: 'Manufacturer',
                    //             attributeDesc: 'PERRIGO',
                    //             attributeExId: 'PERRIGO',
                    //         },
                    //     ],
                    // },
                    Category: {
                        inclusion: [
                            {
                                dimension: 'dim1',
                                isActive: true,
                                attributeType: 'Category',
                                attributeDesc: 'OTC COUGH COLD & RESPIRATORY',
                                attributeExId: 'OTC COUGH COLD & RESPIRATORY',
                            },
                        ],
                    },
                },
                dim2: {
                    Retailer: {
                        inclusion: [
                            {
                                dimension: 'dim2',
                                isActive: true,
                                attributeType: 'Retailer',
                                attributeDesc: 'All Outlets CC',
                                attributeExId: 'All Outlets CC',
                            },
                        ],
                    },
                },
            },
        },
        priceSimulator: {
            allScenariosTableLimit: 500,
            a: 10,
            opportunityIdentificationTiles: [
                { key: 'recommendation', label: 'Recommendation' },
                { key: 'input', label: 'Input' },
                { key: 'output', label: 'Output' },
            ],
            cascadingColumns: ['COGS Rate', 'List Price', 'Everyday Retail Price'], // this should match with input key mapping and price simulator input columns
            levels: ['product', 'retailer'],
            inputKeyMapping: {
                // keep the order accuretly, to get it in multiselect
                cogs: 'COGS Rate',
                lp: 'List Price',
                rp: 'Everyday Retail Price',
                acv: 'ACV Distribution',
                oi: 'OI Rate',
                non_oi: 'Non OI Rate',
                promo_trade_spends: 'Promo Trade Rate Spends',
                tr: 'Trade Rate',
                cf: 'Comp Follow',
            },
            outputKeyMapping: {
                gsv: {
                    label: 'GSV',
                    pre: '£',
                    pos: '',
                },
                nsv: {
                    label: 'NSV',
                    pre: '£',
                    pos: '',
                },
                volume: {
                    label: 'Volume',
                    pre: '£',
                    pos: '',
                },
                rsv: {
                    label: 'RSV',
                    pre: '£',
                    pos: '',
                },
                rtMg: {
                    label: 'Retail Margin %',
                    pre: '',
                    pos: '%',
                },
                gmac: {
                    label: 'GMAC',
                    pre: '£',
                    pos: '',
                },
                units: {
                    label: 'Units',
                    pre: '£',
                    pos: '',
                },
                rsvMkSh: {
                    label: 'RSV Mkt Share',
                    pre: '£',
                    pos: '',
                },
                vlmMkSh: {
                    label: 'Volume Mkt Share',
                    pre: '',
                    pos: '%',
                },
                gsvMkSh: {
                    label: 'GSV Mkt Share',
                    pre: '',
                    pos: '%',
                },
                vlmChg: {
                    label: 'Volume Chg %',
                    pre: '',
                    pos: '%',
                },
                rtPfChg: {
                    label: 'Retail Profit % Chg',
                    pre: '',
                    pos: '%',
                },
                rMgChg: {
                    label: 'Retail Margin % Chg',
                    pre: '',
                    pos: '%',
                },
                netRpChg: {
                    label: 'Net Effective Price % Chg',
                    pre: '',
                    pos: '%',
                },
            },
            recommendationKeyMapping: {
                recommended_list_price: {
                    label: 'New Recommendation Price',
                    pre: '£',
                    pos: '',
                },
                role: {
                    label: 'Role',
                    pre: '',
                    pos: '',
                },
                strategy: {
                    label: 'Strategy',
                    pre: '',
                    pos: '',
                },
                mix: {
                    label: 'Mix',
                    pre: '',
                    pos: '',
                },
                growth: {
                    label: 'Growth',
                    pre: '',
                    pos: '',
                },
                gap: {
                    label: 'Gap',
                    pre: '',
                    pos: '',
                },
                cogs_realization: {
                    label: 'COGS & Realization',
                    pre: '',
                    pos: '',
                },
                cogs: {
                    label: 'COGs',
                    pre: '',
                    pos: '%',
                },
                list_to_retail: {
                    label: 'List to Retail',
                    pre: '',
                    pos: '',
                },
                bpe: {
                    label: 'BPE',
                    pre: '',
                    pos: '',
                },
                ppe: {
                    label: 'PPE',
                    pre: '',
                    pos: '',
                },
                margin: {
                    label: 'Margin',
                    pre: '',
                    pos: '',
                },
                growth_vs_category: {
                    label: 'Gowth vs Category',
                    pre: '',
                    pos: '%',
                },
                pl_vs_category: {
                    label: 'PL vs Category',
                    pre: '',
                    pos: '%',
                },
                threshold: {
                    label: 'Threshold',
                    pre: '',
                    pos: '',
                },
                comp_index: {
                    label: 'Comp. Index',
                    pre: '',
                    pos: '',
                },
                curve_index: {
                    label: 'Curve Index',
                    pre: '',
                    pos: '',
                },
            },
            defaultKpiMetrics: [1, 2, 3, 4, 5],
            kpiMetrics: [
                {
                    key: 1,
                    value: 'volume_sales',
                    name: 'Volume Sales',
                    pre: '',
                    post: '',
                },
                {
                    key: 2,
                    value: 'value_sales',
                    name: 'Value Sales (£)',
                    pre: '£',
                    post: '',
                },
                {
                    key: 3,
                    value: 'profit_abs',
                    name: 'Profit Abs (£)',
                    pre: '£',
                    post: '',
                },
                {
                    key: 4,
                    value: 'margin_percent',
                    name: 'Margin (%)',
                    pre: '',
                    post: '%',
                },
                {
                    key: 5,
                    value: 'trade_rate_percent',
                    name: 'Trade Rate (%)',
                    pre: '',
                    post: '%',
                },

                {
                    key: 6,
                    value: 'retailer_margin_percent',
                    name: 'Retailer Margin (%)',
                    pre: '',
                    post: '%',
                },
                {
                    key: 7,
                    value: 'gross_profit',
                    name: 'Gross Profit (£)',
                    pre: '£',
                    post: '',
                },
                {
                    key: 8,
                    value: 'retailer_profit',
                    name: 'Retailer Profit (£)',
                    pre: '£',
                    post: '',
                },
                {
                    key: 9,
                    value: 'net_retail_price_change',
                    name: 'Net Retailer Price % Chg',
                    pre: '',
                    post: '%',
                },
            ],
        },
        pricingSimulator: {
            enableAnalyticsTab: true,
            enableBulkUpload: false,
            indexPageTableLimit: 50,
            scenarioFilterOffsetLimit: 50,
            scenarioPerProjectLimit: 10,
            scenarioTableLimit: 500,
            analyticsChartLimit: 100,
            comparisonTableLimit: 50,
            dimAttributesLimit: 4,
            characterLimit: {
                kpiTileCharLimit: 22,
                kpiCompareCardLimit: 30,
            },
            enablePrivatePublicToggle: false,
            enableMicroInfoForTables: false,
            enableOneChangeAnalyticsChart: false,
            defaultGlobalKpiCount: 6,
            disableExport: false,
            indexTableFixedColumns: [
                { label: 'Project Name', key: 'projectName', sortKey: 'project_name' },
                { label: 'Created By', key: 'createdBy', sortKey: 'created_by' },
                { label: 'Status', key: 'status' },
                { label: 'Last Updated', key: 'lastUpdated', sortKey: 'updated_at' },
                { label: 'Simulation Period', key: 'simulationPeriod' },
                { label: 'Price Effective Date', key: 'priceEffectiveDate' },
            ],
            analyticsBaseScenarioFixedColumns: [
                { label: 'Project Name', key: 'projectName', sortKey: 'project_name' },
                { label: 'Created By', key: 'createdBy', sortKey: 'created_by' },
                { label: 'Status', key: 'status' },
            ],
            analyticsTableColumns: [
                { label: 'Report Name', key: 'reportName', sortKey: 'report_name' },
                { label: 'Base Scenario', key: 'baseScenario', sortKey: 'base_scenario' },
                { label: 'Created By', key: 'createdBy', sortKey: 'created_by' },
                { label: 'Last Updated', key: 'lastUpdated', sortKey: 'updated_at' },
                { label: 'Date Created', key: 'dateCreated', sortKey: 'created_at' },
            ],
            projectStatuses: {
                ACTIVE: { label: 'Active', colorType: 'success' },
                DRAFT: { label: 'Draft', colorType: 'processing' },
                SETUP: { label: 'Setup', colorType: 'processing' },
                IN_PROGRESS: { label: 'In-Progress', colorType: 'processing' },
                EXPIRED: { label: 'Expired', colorType: 'default' },
                ERROR: { label: 'Error', colorType: 'error' },
                INVALID: { label: 'Invalid', colorType: 'error' },
            },
            projectDataSource: [{ label: 'Projected', value: 'depletion_data' }],
            simulatedPeriodItems: [
                { label: 'Custom Date', value: 'custom_date', dateArray: null },
                { label: 'Current Year', value: 'current_year', dateArray: ['01-05-2025', '12-28-2025'] },
                // { label: 'Financial Year', value: 'financial_year', dateArray: ['03-03-2024', '02-23-2025'] },
            ],
            iconsMappings: {
                Elasticity: 'BorderOuterOutlined',
                BaseInput: 'BorderlessTableOutlined',
                COGS: 'DollarOutlined',
                Distributor: 'BuildOutlined',
                'Distributor P&L': 'BuildOutlined',
                FOB: 'ClusterOutlined',
                'P&L': 'LineChartOutlined',
                Price: 'MoneyCollectOutlined',
                Promotions: 'BoxPlotOutlined',
                'Retailer P&L': 'LineChartOutlined',
                Sales: 'AreaChartOutlined',
                Taxes: 'BlockOutlined',
                Volume: 'ExperimentOutlined',
                Others: 'UngroupOutlined',
                Product: 'GoldOutlined',
                Geo: 'ExpandOutlined',
                'Dollar Impact': 'DollarOutlined',
                'Standard Increase Metrics': 'ToTopOutlined',
                'EQV Metrics': 'BlockOutlined',
            },
            categoryMovementKpis: [
                { label: 'Volume Impact', value: 'volume', yAxisLabel: 'Vol', xAxisLabel: 'Retailer Vol' },
                { label: 'Sales Impact', value: 'sales', yAxisLabel: 'Sales £', xAxisLabel: 'Retailer Sales £' },
            ],
        },
        priceChange: {
            // TODO: remove unwanted props
            limit: 60,
            dimensionConfig: {
                //snake case eg sub_category
                excludedDimensions: [],
                defaultDimension: 'Manufacturer',
            },
            hiddenTableRows: [],
            timePeriodOptions: [
                { label: 'YA', value: 'year_ago' },
                { label: 'Prior Period', value: 'prior_period' },
                { label: 'Custom Period', value: 'custom' },
            ],
            absTileData: [
                { key: 'abs', label: 'Abs' },
                { key: 'percentage', label: '%' },
            ],
            kpiListData: [
                {
                    key: 'avg_price',
                    label: 'Avg Price',
                    value: 'average',
                    dataKey: 'avg_price',
                },
                {
                    key: 'base_price',
                    label: 'Regular Price',
                    value: 'base',
                    dataKey: 'base_price',
                },
            ],
            volTileData: [
                {
                    key: 'units',
                    label: 'Per Unit',
                    value: 'units',
                    dataKey: 'units',
                    tooltip: 'Per Unit',
                },
                // { key: 'vol', label: 'PEQ', value: 'vol', dataKey: 'volume', tooltip: 'Per Eq Volume' },
            ],
            salesTileData: [
                { key: 'sales', label: 'Sales' },
                { key: 'incremental', label: 'Incremental' },
                { key: 'promo', label: 'Promo' },
            ],
            salesAttributionChart: {
                colorList: ['#10AB5E', '#DC3826'],
                colorListType2: ['#758BEE', '#758BEE'],
                profitPoolColor: ['#826FD0', '#826FD0'],
                backGroundColor: 'rgba(0, 0, 0, 0.02)',
            },
            salesAttributionDrillDownChartKeyValueMapping: {
                'feature_&_display': 'Feature & Display',
                'Feature & Display': 'feature_&_display',
            },
            salesAttributionChart2Limit: 20,
        },
        growthAnalysis: {
            limit: 60,
            includeAggPeriod: true,
            dimensionConfig: {
                //snake case eg sub_category
                excludedDimensions: [],
                defaultDimension: 'Manufacturer',
            },
            absTileData: [
                { key: 'abs', label: 'Abs' },
                { key: 'percentage', label: '%' },
            ],
            subTileData: [
                {
                    label: 'Per Unit',
                    key: 'PU',
                },
                {
                    label: 'PEQ',
                    key: 'PEQ',
                },
            ],
            volTileData: [
                // { key: 'vol', label: 'Eq Volume', value: 'vol', dataKey: 'volume' },
                { key: 'val', label: 'Value', value: 'val', dataKey: 'value' },
                {
                    key: 'units',
                    label: 'Units',
                    value: 'units',
                    dataKey: 'units',
                },
                // { key: 'profit', label: 'Profit', value: 'profit', dataKey: 'profit' },
            ],
            showTotal: true,
            currentYearLabel: 'CY',
            yearAgoLabel: 'YA',
            trendChartDropdownData: [
                {
                    key: 'sales_volume',
                    label: 'Sales Volume',
                    value: 'sales_volume',
                    dataKey: 'sales_volume',
                },
                {
                    key: 'sales',
                    label: 'Sales £',
                    value: 'sales',
                    dataKey: 'sales',
                },
                {
                    key: 'average_price',
                    label: 'Average Price',
                    value: 'average_price',
                    dataKey: 'average_price',
                },
                {
                    key: 'base_price',
                    label: 'Base Price',
                    value: 'base_price',
                    dataKey: 'base_price',
                },
                { key: 'acv', label: '%ACV', value: 'acv', dataKey: 'acv' },
                {
                    key: 'avg_items',
                    label: 'Avg. no. of items',
                    value: 'avg_items',
                    dataKey: 'avg_items',
                },
                { key: 'tdp', label: 'TDP', value: 'tdp', dataKey: 'tdp' },
            ],
            salesTileData: [
                { key: 'sales', label: 'Sales' },
                { key: 'incremental', label: 'Incremental' },
                { key: 'promo', label: 'Promo' },
            ],
            graphExportHeaderMapping: {
                promo: ['Non-promo', 'Promo'],
                incremental: ['Base', 'Incremental'],
                sales: ['Sales Change'],
            },
            depletionDropdownData: [
                {
                    value: 'frontline_sales',
                    dataKey: 'frontline_sales',
                    key: 'frontline_sales',
                    label: 'Frontline Sales',
                },
                {
                    value: 'net_sales',
                    dataKey: 'net_sales',
                    key: 'net_sales',
                    label: 'Net Sales',
                },
            ],
            tableKeyUnitMapping: {
                'Market Share CY': {
                    unit: '%',
                    label: 'Market Share CY',
                    includePercentageChange: false,
                },
                'Market Share YA': {
                    unit: '%',
                    label: 'Market Share YA',
                    includePercentageChange: false,
                },
                'ACV CY': {
                    unit: '%',
                    label: 'Wtd. Avg ACV %',
                    includePercentageChange: false,
                },
                'ACV YA': {
                    unit: '%',
                    label: 'Wtd. Avg ACV % YA',
                    includePercentageChange: false,
                },
            },
            salesAttributionChart: {
                colorList: ['#10AB5E', '#DC3826'],
                colorListType2: ['#758BEE', '#758BEE'],
                profitPoolColor: ['#826FD0', '#826FD0'],
                backGroundColor: 'rgba(0, 0, 0, 0.02)',
            },
            salesAttributionDrillDownChartKeyValueMapping: {
                'feature_&_display': 'Feature & Display',
                'Feature & Display': 'feature_&_display',
            },
            salesAttributionChart2DisabledItems: ['unexplained'],
            salesAttributionChart2Limit: 50,
        },
        //BUMP REPORT
        bumpReport: {
            mainHeader: 'Bump Report',
            groupByKey: 'groupBy',
            comparisonTileData: [
                { key: 'cy_vs_ya', label: 'CY vs YA' },
                { key: 'difference', label: 'Difference' },
            ],
            enablePromoCalender: true,
            isPromoUpliftPercentValue: false,
            volGroupByOptionsMapping: {
                // vol: [
                //     { value: 'total_eq_volume', label: 'Total EQ Volume', index: 1 },
                //     { value: 'any_promo_eq_volume', label: 'Any promo EQ Volume', index: 1 },
                //     { value: 'no_promo_eq_volume', label: 'No Promo EQ Volume', index: 1 },

                //     { value: 'base_eq_volume', label: 'Base EQ Volume', index: 0 },
                //     { value: 'incremental_eq_volume', label: 'Incremental EQ Volume Total', index: 0 },
                //     { value: 'tpr_incremental_eq_volume', label: 'Incremental EQ Volume TPR', index: 0 },
                //     { value: 'feature_incremental_eq_volume', label: 'Incremental EQ Volume Feature', index: 0 },
                //     { value: 'display_incremental_eq_volume', label: 'Incremental EQ Volume Display', index: 0 },
                //     {
                //         value: 'feature_and_display_incremental_eq_volume',
                //         label: 'Incremental EQ Volume Feature & Display',
                //         index: 0,
                //     },
                // ],
                val: [
                    { value: 'total_value', label: 'Total Value', index: 1 },
                    {
                        value: 'any_promo_value',
                        label: 'Any Promo Value',
                        index: 1,
                    },
                    {
                        value: 'no_promo_value',
                        label: 'No Promo Value',
                        index: 1,
                    },
                    { value: 'base_value', label: 'Regular Value', index: 0 },
                    {
                        value: 'incremental_value',
                        label: 'Incremental Value Total',
                        index: 0,
                    },
                    {
                        value: 'tpr_incremental_value',
                        label: 'Price Cut Incremental Value',
                        index: 0,
                    },
                    {
                        value: 'feature_incremental_value',
                        label: 'On Shelf Incremental Value',
                        index: 0,
                    },
                    {
                        value: 'display_incremental_value',
                        label: 'Off Shelf Incremental Value',
                        index: 0,
                    },
                    {
                        value: 'feature_and_display_incremental_value',
                        label: 'Special Pack Incremental Value',
                        index: 0,
                    },
                ],
                units: [
                    { value: 'total_units', label: 'Total Units', index: 1 },
                    {
                        value: 'any_promo_units',
                        label: 'Any Promo Units',
                        index: 1,
                    },
                    {
                        value: 'no_promo_units',
                        label: 'No Promo Units',
                        index: 1,
                    },
                    { value: 'base_units', label: 'Regular Units', index: 0 },
                    {
                        value: 'incremental_units',
                        label: 'Incremental Units Total',
                        index: 0,
                    },
                    {
                        value: 'tpr_incremental_units',
                        label: 'Price Cut Incremental Units',
                        index: 0,
                    },
                    {
                        value: 'feature_incremental_units',
                        label: 'On Shelf Incremental Units',
                        index: 0,
                    },
                    {
                        value: 'display_incremental_units',
                        label: 'Off Shelf Incremental Units',
                        index: 0,
                    },
                    {
                        value: 'feature_and_display_incremental_units',
                        label: 'Special Pack Incremental Units',
                        index: 0,
                    },
                ],
            },
            tooltipKeyLabelMapping: {
                increments: 'Incremental',
                promo: 'Any Promo',
            },
            bumpReportTileData: [
                { key: 'increments', label: 'Attribution' },
                { key: 'promo', label: 'Consumption' },
                { key: 'groupBy', label: 'Group By' },
            ],
            bumpReportTile1Data: [
                {
                    key: 'promo',
                    label: 'Promotions',
                    visibleTabs: ['increments', 'promo', 'groupBy'],
                }, //keys should match bumpReportTileData keys
                {
                    key: 'media',
                    label: 'Media',
                    visibleTabs: ['increments', 'groupBy'],
                }, //keys should match bumpReportTileData keys
            ],
            bumpReportTile2Data: [
                { key: 'total', label: 'Total' },
                { key: 'breakout', label: 'Breakout' },
            ],
            absTileData: [
                { key: 'abs', label: 'Abs' },
                { key: 'percentage', label: '%' },
            ],

            volTileData: [
                // { key: 'vol', label: 'Eq Volume', dataKey: 'volume' },
                { key: 'val', label: 'Value', dataKey: 'value' },
                { key: 'units', label: 'Units', dataKey: 'units' },
            ],
            bumpChartY2Colors: [
                '#293BB8',
                '#DD449F',
                '#9E5897',
                '#19669D',
                '#43C9E2',
                '#37C7BE',
                '#00798C',
                '#E8A122',
                '#E06936',
                '#A5582D',
            ],
            bumpChartY2AxisOptions: {
                // vol: [
                //     { value: 'avg_price_per_eq', index: 0, label: 'Avg. Price/EQ', unit: '' },
                //     { value: 'base_price_per_eq', index: 0, label: 'Base Price/EQ', unit: '' },
                //     { value: 'promo_price_per_eq', index: 0, label: 'Promo Price/EQ', unit: '' },
                //     { value: 'distribution_tdp', index: 0, label: 'Distribution TDP', unit: '' },
                //     { value: 'display_tdp', index: 0, label: 'Display TDP', unit: '' },
                //     { value: 'feature_tdp', index: 0, label: 'Feature TDP', unit: '' },
                //     { value: 'feature_and_display_tdp', index: 0, label: 'Feature and Display TDP', unit: '' },
                //     { value: 'unit_velocity', index: 0, label: 'Unit Velocity', unit: '' },
                //     { value: 'sales_velocity', index: 0, label: 'Dollar Velocity', unit: '£' },
                //     { value: 'volume_velocity', index: 0, label: 'Eq Velocity', unit: '' },
                // ],
                val: [
                    {
                        value: 'avg_price_per_unit',
                        index: 0,
                        label: 'Avg. Price/Unit (£)',
                        unit: '',
                    },
                    {
                        value: 'base_price_per_unit',
                        index: 0,
                        label: 'Regular Price/Unit',
                        unit: '',
                    },
                    {
                        value: 'promo_price_per_unit',
                        index: 0,
                        label: 'Promo Price/Unit',
                        unit: '',
                    },
                    {
                        value: 'market_share_value',
                        index: 0,
                        label: 'Market Share %',
                        unit: '',
                    },
                    {
                        value: 'distribution_tdp',
                        index: 0,
                        label: 'Distribution TDP',
                        unit: '',
                    },
                    {
                        value: 'display_tdp',
                        index: 0,
                        label: 'Off Shelf TDP',
                        unit: '',
                    },
                    {
                        value: 'feature_tdp',
                        index: 0,
                        label: 'On Shelf TDP',
                        unit: '',
                    },
                    {
                        value: 'feature_and_display_tdp',
                        index: 0,
                        label: 'Special Pack TDP',
                        unit: '',
                    },
                    {
                        value: 'distribution_acv',
                        index: 0,
                        label: 'Distribution ACV %',
                        unit: '',
                    },
                    {
                        value: 'display_acv',
                        index: 0,
                        label: 'Off Shelf ACV %',
                        unit: '',
                    },
                    {
                        value: 'feature_acv',
                        index: 0,
                        label: 'On Shelf ACV %',
                        unit: '',
                    },
                    {
                        value: 'feature_and_display_acv',
                        index: 0,
                        label: 'Special Pack ACV %',
                        unit: '',
                    },
                    {
                        value: 'cwd_weighted_distribution',
                        index: 0,
                        label: 'CWD weighted distribution',
                        unit: '',
                    },
                    {
                        value: 'unit_velocity',
                        index: 0,
                        label: 'Unit Velocity',
                        unit: '',
                    },
                    {
                        value: 'sales_velocity',
                        index: 0,
                        label: 'Value Velocity',
                        unit: '£',
                    },
                    {
                        value: 'subsidized_base_sales',
                        index: 0,
                        label: 'Subsidized Base Sales',
                        unit: '',
                    },
                    // { value: 'volume_velocity', index: 0, label: 'Eq Velocity', unit: '' },
                ],
                units: [
                    {
                        value: 'avg_price_per_unit',
                        index: 0,
                        label: 'Avg. Price/Unit (£)',
                        unit: '',
                    },
                    {
                        value: 'base_price_per_unit',
                        index: 0,
                        label: 'Regular Price/Unit',
                        unit: '',
                    },
                    {
                        value: 'promo_price_per_unit',
                        index: 0,
                        label: 'Promo Price/Unit',
                        unit: '',
                    },
                    {
                        value: 'market_share_units',
                        index: 0,
                        label: 'Market Share %',
                        unit: '',
                    },
                    {
                        value: 'distribution_tdp',
                        index: 0,
                        label: 'Distribution TDP',
                        unit: '',
                    },
                    {
                        value: 'display_tdp',
                        index: 0,
                        label: 'Off Shelf TDP',
                        unit: '',
                    },
                    {
                        value: 'feature_tdp',
                        index: 0,
                        label: 'On Shelf TDP',
                        unit: '',
                    },
                    {
                        value: 'feature_and_display_tdp',
                        index: 0,
                        label: 'Special Pack TDP',
                        unit: '',
                    },
                    {
                        value: 'distribution_acv',
                        index: 0,
                        label: 'Distribution ACV %',
                        unit: '',
                    },
                    {
                        value: 'display_acv',
                        index: 0,
                        label: 'Off Shelf ACV %',
                        unit: '',
                    },
                    {
                        value: 'feature_acv',
                        index: 0,
                        label: 'On Shelf ACV %',
                        unit: '',
                    },
                    {
                        value: 'feature_and_display_acv',
                        index: 0,
                        label: 'Special Pack ACV %',
                        unit: '',
                    },
                    {
                        value: 'cwd_weighted_distribution',
                        index: 0,
                        label: 'CWD weighted distribution',
                        unit: '',
                    },
                    {
                        value: 'unit_velocity',
                        index: 0,
                        label: 'Unit Velocity',
                        unit: '',
                    },
                    {
                        value: 'sales_velocity',
                        index: 0,
                        label: 'Value Velocity',
                        unit: '£',
                    },
                    {
                        value: 'subsidized_base_sales',
                        index: 0,
                        label: 'Subsidized Base Sales',
                        unit: '',
                    },
                    // { value: 'volume_velocity', index: 0, label: 'Eq Velocity', unit: '' },
                ],
            },
            promoTypeColorMapping: {
                'tpr/scan': {
                    label: 'Price Cut',
                    color: colorConstants.lightGreenAlt,
                },
                'feature ad': {
                    label: 'Price Cut & On Shelf',
                    color: colorConstants.darkGreenAlt2,
                },
                display: { label: 'Off Shelf', color: colorConstants.pinkAlt },
                feature_display_tpr: {
                    label: 'Special Pack',
                    color: colorConstants.orangeAlt2,
                },
                cinema: {
                    label: 'Cinema',
                    color: colorConstants.lightGreenAlt,
                }, // media types starts here
                digital: { label: 'Digital', color: colorConstants.violetAlt2 },
                'direct mail': {
                    label: 'Direct Mail',
                    color: colorConstants.violetAlt3,
                },
                outdoor: { label: 'Outdoor', color: colorConstants.purpleAlt1 },
                press: { label: 'Press', color: colorConstants.pinkAlt2 },
                radio: { label: 'Radio', color: colorConstants.orangeAlt3 },
                tv: { label: 'TV', color: colorConstants.yellow },
                // display_tpr: { label: 'Display_TPR', color: colorConstants.darkBlueAlt },
            },
            stackedColors: [
                colorConstants.lightGreenAlt,
                colorConstants.darkGreenAlt2,
                colorConstants.pinkAlt,
                colorConstants.orangeAlt2,
                colorConstants.darkYellow,
            ],
            fieldKeyLabelMapping: {
                base_eq_volume: {
                    label: 'Regular Sales (Eq Vol)',
                    color: colorConstants.darkYellow,
                    tableLabel: 'Regular',
                },
                base_value: {
                    label: 'Regular Sales (£)',
                    color: colorConstants.darkYellow,
                    tableLabel: 'Regular',
                },
                base_units: {
                    label: 'Regular Units',
                    color: colorConstants.darkYellow,
                    tableLabel: 'Regular',
                },
                incremental_eq_volume: {
                    label: 'Incremental Sales (Eq Vol)',
                    color: colorConstants.darkGreenAlt2,
                    tableLabel: 'Incremental',
                },
                incremental_value: {
                    label: 'Promotion Sales (£)',
                    color: colorConstants.lightGreenAlt,
                    tableLabel: 'Promotion',
                },
                tpr_incremental_eq_volume: {
                    label: 'Price Cut & On Shelf',
                    color: colorConstants.lightGreenAlt,
                    tableLabel: 'Price Cut & On Shelf',
                },
                feature_incremental_eq_volume: {
                    label: 'On Shelf',
                    color: colorConstants.darkGreenAlt2,
                    tableLabel: 'On Shelf',
                },
                display_incremental_eq_volume: {
                    label: 'Off Shelf',
                    color: colorConstants.pinkAlt,
                    tableLabel: 'Off Shelf',
                },
                feature_and_display_incremental_eq_volume: {
                    label: 'Special Pack',
                    color: colorConstants.orangeAlt2,
                    tableLabel: 'Special Pack',
                },
                tpr_incremental_value: {
                    label: 'Price Cut & On Shelf',
                    color: colorConstants.lightGreenAlt,
                    tableLabel: 'Price Cut & On Shelf',
                },
                feature_incremental_value: {
                    label: 'On Shelf',
                    color: colorConstants.darkGreenAlt2,
                    tableLabel: 'On Shelf',
                },
                display_incremental_value: {
                    label: 'Off Shelf',
                    color: colorConstants.pinkAlt,
                    tableLabel: 'Off Shelf',
                },
                incremental_units: {
                    label: 'Promotion Units',
                    color: colorConstants.lightGreenAlt,
                    tableLabel: 'Promotion',
                },
                feature_and_display_incremental_value: {
                    label: 'Special Pack',
                    color: colorConstants.orangeAlt2,
                    tableLabel: 'Special Pack',
                },
                tpr_incremental_units: {
                    label: 'Price Cut & On Shelf',
                    color: colorConstants.lightGreenAlt,
                    tableLabel: 'Price Cut & On Shelf',
                },
                feature_incremental_units: {
                    label: 'On Shelf',
                    color: colorConstants.darkGreenAlt2,
                    tableLabel: 'On Shelf',
                },
                display_incremental_units: {
                    label: 'Off Shelf',
                    color: colorConstants.pinkAlt,
                    tableLabel: 'Off Shelf',
                },
                feature_and_display_incremental_units: {
                    label: 'Special Pack',
                    color: colorConstants.orangeAlt2,
                    tableLabel: 'Special Pack',
                },
                incremental_total_units: {
                    label: 'Promotions',
                    color: colorConstants.lightGreenAlt,
                    tableLabel: 'Promotions',
                },
                incremental_total_value: {
                    label: 'Promotions',
                    color: colorConstants.lightGreenAlt,
                    tableLabel: 'Promotions',
                },
                media_incremental_value: {
                    label: 'Media',
                    color: colorConstants.darkGreenAlt3,
                    tableLabel: 'Media',
                },
                media_incremental_units: {
                    label: 'Media',
                    color: colorConstants.darkGreenAlt3,
                    tableLabel: 'Media',
                },
                tpr_only_eq_volume: {
                    label: 'Price Cut & On Shelf',
                    color: colorConstants.lightGreenAlt,
                    tableLabel: 'Price Cut & On Shelf',
                },
                tpr_only_value: {
                    label: 'Price Cut & On Shelf',
                    color: colorConstants.lightGreenAlt,
                    tableLabel: 'Price Cut & On Shelf',
                },
                feature_only_eq_volume: {
                    label: 'On Shelf',
                    color: colorConstants.darkGreenAlt2,
                    tableLabel: 'On Shelf',
                },
                feature_only_value: {
                    label: 'On Shelf',
                    color: colorConstants.darkGreenAlt2,
                    tableLabel: 'On Shelf',
                },
                display_only_eq_volume: {
                    label: 'Off Shelf',
                    color: colorConstants.pinkAlt,
                    tableLabel: 'Off Shelf',
                },
                display_only_value: {
                    label: 'Off Shelf',
                    color: colorConstants.pinkAlt,
                    tableLabel: 'Off Shelf',
                },
                feature_and_display_only_eq_volume: {
                    label: 'Special Pack',
                    color: colorConstants.orangeAlt2,
                    tableLabel: 'Special Pack',
                },
                feature_and_display_only_value: {
                    label: 'Special Pack',
                    color: colorConstants.orangeAlt2,
                    tableLabel: 'Special Pack',
                },
                no_promo_eq_volume: {
                    label: 'Non Promo',
                    color: colorConstants.darkYellow,
                    tableLabel: 'Non Promo',
                },
                no_promo_value: {
                    label: 'Non Promo',
                    color: colorConstants.darkYellow,
                    tableLabel: 'Non Promo',
                },
                any_promo_value: {
                    label: 'Promo',
                    color: colorConstants.lightGreenAlt,
                    tableLabel: 'Promo',
                },
                tpr_only_units: {
                    label: 'Price Cut & On Shelf',
                    color: colorConstants.lightGreenAlt,
                    tableLabel: 'Price Cut & On Shelf',
                },
                feature_only_units: {
                    label: 'On Shelf',
                    color: colorConstants.darkGreenAlt2,
                    tableLabel: 'On Shelf',
                },
                display_only_units: {
                    label: 'Off Shelf',
                    color: colorConstants.pinkAlt,
                    tableLabel: 'Off Shelf',
                },
                feature_and_display_only_units: {
                    label: 'Special Pack',
                    color: colorConstants.orangeAlt2,
                    tableLabel: 'Special Pack',
                },

                no_promo_units: {
                    label: 'Non Promo',
                    color: colorConstants.darkYellow,
                    tableLabel: 'Non Promo',
                },
                any_promo_units: {
                    label: 'Promo',
                    color: colorConstants.lightGreenAlt,
                    tableLabel: 'Promo',
                },
                promo_only_total_value: {
                    label: 'Promotions',
                    color: colorConstants.lightGreenAlt,
                    tableLabel: 'Promotions',
                },
                promo_only_total_units: {
                    label: 'Promotions',
                    color: colorConstants.lightGreenAlt,
                    tableLabel: 'Promotions',
                },
                tv_value: {
                    label: 'TV',
                    color: colorConstants.orangeAlt2,
                    tableLabel: 'TV',
                }, // media types starts here
                tv_units: {
                    label: 'TV',
                    color: colorConstants.orangeAlt2,
                    tableLabel: 'TV',
                },
                cinema_value: {
                    label: 'Cinema',
                    color: colorConstants.lightGreenAlt1,
                    tableLabel: 'Cinema',
                },
                cinema_units: {
                    label: 'Cinema',
                    color: colorConstants.lightGreenAlt1,
                    tableLabel: 'Cinema',
                },
                digital_units: {
                    label: 'Digital',
                    color: colorConstants.darkGreenAlt2,
                    tableLabel: 'Digital',
                },
                digital_value: {
                    label: 'Digital',
                    color: colorConstants.darkGreenAlt2,
                    tableLabel: 'Digital',
                },
                directmail_value: {
                    label: 'Direct mail',
                    color: colorConstants.darkGreenAlt3,
                    tableLabel: 'Direct mail',
                },
                directmail_units: {
                    label: 'Direct mail',
                    color: colorConstants.darkGreenAlt3,
                    tableLabel: 'Direct mail',
                },
                outdoor_units: {
                    label: 'Outdoor',
                    color: colorConstants.purpleAlt,
                    tableLabel: 'Outdoor',
                },
                outdoor_value: {
                    label: 'Outdoor',
                    color: colorConstants.purpleAlt,
                    tableLabel: 'Outdoor',
                },
                press_value: {
                    label: 'Press',
                    color: colorConstants.pinkAlt,
                    tableLabel: 'Press',
                },
                press_units: {
                    label: 'Press',
                    color: colorConstants.pinkAlt,
                    tableLabel: 'Press',
                },
                radio_units: {
                    label: 'Radio',
                    color: colorConstants.orangeAlt1,
                    tableLabel: 'Radio',
                },
                radio_value: {
                    label: 'Radio',
                    color: colorConstants.orangeAlt1,
                    tableLabel: 'Radio',
                },

                //for export label
                sales_year_ago: { label: 'YA Sales' },
                total_value: { label: 'Total' },
                media_incremental_value_percentage: {
                    label: 'Media Percentage',
                },
                media_incremental_units_percentage: {
                    label: 'Media Percentage',
                },
                incremental_value_percentage: {
                    label: 'Promotion Sales Percentage',
                },
                incremental_units_percentage: {
                    label: 'Promotion Sales Percentage',
                },
                base_value_percentage: { label: 'Regular Sales Percentage' },
                base_units_percentage: { label: 'Regular Sales Percentage' },
                tpr_incremental_value_percentage: {
                    label: 'Price Cut & On Shelf Percentage',
                },
                tpr_incremental_units_percentage: {
                    label: 'Price Cut & On Shelf Percentage',
                },
                tpr_only_value_percentage: {
                    label: 'Price Cut & On Shelf Percentage',
                },
                tpr_only_units_percentage: {
                    label: 'Price Cut & On Shelf Percentage',
                },
                feature_incremental_value_percentage: {
                    label: 'On Shelf Percentage',
                },
                feature_incremental_units_percentage: {
                    label: 'On Shelf Percentage',
                },
                feature_only_value_percentage: { label: 'On Shelf Percentage' },
                feature_only_units_percentage: { label: 'On Shelf Percentage' },
                display_incremental_value_percentage: {
                    label: 'Off Shelf Percentage',
                },
                display_incremental_units_percentage: {
                    label: 'Off Shelf Percentage',
                },
                display_only_value_percentage: {
                    label: 'Off Shelf Percentage',
                },
                display_only_units_percentage: {
                    label: 'Off Shelf Percentage',
                },
                feature_and_display_incremental_value_percentage: {
                    label: 'Special Pack Percentage',
                },
                feature_and_display_incremental_units_percentage: {
                    label: 'Special Pack Percentage',
                },
                feature_and_display_only_value_percentage: {
                    label: 'Special Pack Percentage',
                },
                feature_and_display_only_units_percentage: {
                    label: 'Special Pack Percentage',
                },
                no_promo_value_percentage: { label: 'Non Promo Percentage' },
                no_promo_units_percentage: { label: 'Non Promo Percentage' },
            },
            tooltipExtraItems: {
                tpr_acv: { label: 'Price Cut ACV %' },
                display_acv: { label: 'Off Shelf ACV %' },
                feature_acv: { label: 'On Shelf ACV %' },
                feature_and_display_acv: { label: 'Special Pack ACV %' },
                uplift: { label: 'Uplift' },
                promo_lift: { label: 'Promo Uplift' },
                media_lift: { label: 'Media Uplift' },
            },
            promoCalenderAttributeLevels: {
                promo: [
                    { value: 'product', label: 'Product' },
                    { value: 'retailer', label: 'Retailer' },
                ],
                media: [{ value: 'sub_brand', label: 'Sub Brand' }],
            },
            overlayKeys: {
                promo: [
                    { label: 'Start Week', dataKey: 'startTimestamp' },
                    { label: 'End Week', dataKey: 'endTimestamp' },
                    { label: 'Product', dataKey: 'product' },
                    { label: 'Promo Mechanics', dataKey: 'promoMech' },
                    { label: 'Promo Type', dataKey: 'promoType' },
                    { label: 'Investment', dataKey: 'field_value' },
                    // { label: 'ROI', dataKey: 'roi' },
                    // { label: 'Lift', dataKey: 'lift' },
                    // { label: 'Incremental Profit', dataKey: 'incrementalProfit' },
                    // { label: 'Incremental Retailer Profit', dataKey: 'incrementalRetailerProfit' },
                ],
                media: [
                    { label: 'Start Week', dataKey: 'startTimestamp' },
                    { label: 'End Week', dataKey: 'endTimestamp' },
                    { label: 'Sub Brand', dataKey: 'product' },
                    { label: 'Media Type', dataKey: 'promoType' },
                    { label: 'Investment', dataKey: 'field_value' },
                ],
            },
        },
        //PROMO SCORE CARD
        promoScoreCard: {
            mainHeader: 'Promo Scorecard',
            limit: 50,
            nestedTableLimit: 10,
            questionsNo: [1, 2, 3, 4, 6, 7],
            question: {
                Q: [
                    'Am I getting my fair share of quality support? ',
                    'How does my % Discount compare to competition? ',
                    'What % of Volume was sold on promotion? ',
                    'How many weeks am I promoting? ',
                    'What is my average price/units? ',
                    'What is my value share of promotions? ',
                ],
                unitsInItalics: [
                    '(Fair Share Index -£ Sold)',
                    '(Weighted Average % Price Reduction)',
                    '(% of Volume)',
                    '(Weighted Weeks)',
                    '(Price per Unit)',
                    '(Value share %)',
                ],
                unit: ['value', '%', '%', 'week', '£', '%'],
                numberFormateDecimal: [0, 1, 1, 0, 2, 1],
            },
            promoTypeLabelMapping: {
                display: { label: 'Off Shelf Only' },
                tpr: { label: 'Price Cut Only' },
                feature: { label: 'On Shelf Only' },
                feature_and_display: { label: 'Special Pack Only' },
                feature_display: { label: 'Special Pack Only' },
            },
            showGradientTile: true,
            promoType: ['Price Cut Only', 'Off Shelf Only', 'On Shelf Only', 'Special Pack Only'],
            promoExpandedViewTableUnit: 'volume',
            promoExpandedViewTableSalesAndVolumeLabel: ['Units', 'Total Sales £'],
            dropDown: ['Category', 'Sub_Category', 'Brand', 'Sub_Brand', 'Type'],
            listFor: ['Manufacturer', 'Brand', 'Sub_Brand', 'Branding', 'Perrigo_Pl', 'Dosage', 'product'],
            listForToDisplay: [
                'Manufacturer',
                'Brand',
                'Sub_Brand',
                'Branding',
                'Perrigo_Pl',
                'Dosage',
                'product',
                'Retailer',
                'Channel',
                'Country',
            ],
            listIn: [
                'Category',
                'Sub_Category',
                'Pack_Size',
                'Type',
                'Class',
                'Consumer',
                'Retailer',
                'Channel',
                'Country',
            ],
        },

        // PROMO LANDSCAPE
        promoLandscape: {
            mainHeader: 'Investment & ROI Tracker',
            roiLabel: 'ROI',
            defaultAttributeTypeIndex: 3,
            defaultInvestmentTypeItems: ['digital'],
            optimalInvestmentIndexThreshold1: 0.8,
            optimalInvestmentIndexThreshold2: 1.2,
            promoTacticDropdownName: 'Investment Type',
            dimensionConfig: {
                //snake case eg sub_category
                excludedDimensions: [],
                defaultDimension: '',
            },
            thresholdColorMapping: {
                optimal: { label: 'Optimal', color: colorConstants.darkGreen },
                over: { label: 'Over', color: colorConstants.darkRed },
                under: { label: 'Under', color: colorConstants.darkBlueAlt },
            },
            limit: 60,
            promoTypes: [
                { value: 'display', label: 'Off Shelf' },
                { value: 'tpr', label: 'Price Cut' },
                { value: 'feature', label: 'On Shelf' },
                // { value: 'feature & display', label: 'Feature & Display' },  //not required for now
            ],
            mediaLevelsDropdown: ['Manufacturer', 'Category', 'Sub Category', 'Brand', 'Sub Brand', 'Type'],
            showInvestmentDropdown: true,
            optimalIndexKey: 'competition_spend_index',
            tableRowsKeyMapping: [
                {
                    label: 'Investment',
                    children: null,
                    parentKey: null,
                    key: 'investments',
                    unit: '£',
                },
                {
                    label: 'ROI',
                    children: null,
                    parentKey: null,
                    key: 'roi',
                    unit: '',
                },
                {
                    label: 'Competition Spend Index',
                    children: [
                        {
                            label: 'Share of Investment',
                            key: 'share_of_investment',
                            unit: '%',
                        },
                        {
                            label: 'Share of Sales',
                            key: 'share_of_sales',
                            unit: '%',
                        },
                    ],
                    unit: '',
                    parentKey: 'competition_data',
                    key: 'competition_spend_index',
                },
                {
                    label: 'Incremental Sales',
                    unit: '£',
                    children: [
                        {
                            label: 'Total Sales',
                            key: 'total_sales',
                            unit: '',
                        },
                        {
                            label: 'Base Sales',
                            key: 'base_sales',
                            unit: '',
                        },
                    ],
                    parentKey: 'sales_data',
                    key: 'incremental_retail_sales',
                },
                {
                    label: 'Total Profit',
                    unit: '£',
                    children: [
                        {
                            label: 'Incremental Profit',
                            key: 'incremental_profit',
                            unit: '£',
                        },
                        {
                            label: 'Base Profit',
                            key: 'base_profit',
                            unit: '£',
                        },
                    ],
                    parentKey: 'profit_data',
                    key: 'total_profit',
                },
                // {
                //     label: 'Share of Spends',
                //     children: null,
                //     parentKey: null,
                //     key: 'shareOfSpends',
                //     unit: '',
                // },
            ],
        },
        //PORTFOLIO ANALYSIS
        portfolioAnalysis: {
            mainHeader: 'Promo ROI Analysis',
            limit: 20,
            defaultGroupByIndex: 15,
            defaultGroupBy2Index: 5,
            chartColors: [],
            absTileData: [
                { key: 'Promotions', label: 'Promotions' },
                { key: 'Drivers', label: 'Drivers' },
                { key: 'Media', label: 'Media' },
            ],
            salesAttributionChart: {
                colorList: ['#10AB5E', '#DC3826'],
                colorListType2: ['#758BEE', '#758BEE'],
                profitPoolColor: ['#826FD0', '#826FD0'],
                backGroundColor: 'rgba(0, 0, 0, 0.02)',
            },
            chartDropdownExtraKpis: [
                {
                    dimension: 'none',
                    label: 'Media Descriptor',
                    dataKey: 'tactic_description',
                },
                {
                    dimension: 'none',
                    label: 'Mechanics',
                    dataKey: 'promotion_mechanic',
                },
                {
                    dimension: 'none',
                    label: 'Event Name',
                    dataKey: 'event_name',
                },
                {
                    dimension: 'dim1',
                    label: 'Week',
                    dataKey: 'week',
                },
            ],
            groupByHeaders: [
                {
                    label: 'Category',
                    value: 'category',
                    dimension: 'dim1',
                    isSelected: false,
                    sortKey: 'category',
                    multiSelectFilter: false,
                },
                {
                    label: 'Sub Category',
                    value: 'sub_category',
                    dimension: 'dim1',
                    isSelected: false,
                    sortKey: 'sub_category',
                    multiSelectFilter: false,
                },
                {
                    label: 'Brand',
                    value: 'brand',
                    dimension: 'dim1',
                    isSelected: false,
                    sortKey: 'brand',
                    multiSelectFilter: false,
                },
                // {
                //     label: 'Sub Brand',
                //     value: 'sub_brand',
                //     dimension: 'dim1',
                //     isSelected: false,
                //     sortKey: 'sub_brand',
                //     multiSelectFilter: false,
                // },
                {
                    label: 'Product',
                    value: 'product',
                    dimension: 'dim1',
                    isSelected: true,
                    sortKey: 'product',
                    multiSelectFilter: false,
                },
                {
                    label: 'Mechanics',
                    value: 'promotion_mechanic',
                    dimension: null,
                    isSelected: true,
                    sortKey: 'promotion_mechanic',
                    multiSelectFilter: true,
                },
                {
                    label: 'Media Descriptor',
                    value: 'tactic_description',
                    dimension: null,
                    isSelected: false,
                    sortKey: 'tactic_description',
                    multiSelectFilter: true,
                },
                {
                    label: 'Week',
                    value: 'week',
                    dimension: null,
                    isSelected: true,
                    sortKey: 'week',
                    multiSelectFilter: false,
                },
                {
                    label: 'Retailer',
                    value: 'retailer',
                    dimension: 'dim2',
                    isSelected: true,
                    sortKey: 'retailer',
                    multiSelectFilter: false,
                },
            ],

            mediaSpendsLabelKeyMapping: {
                attribute_name: 'Attribute Name',
                media_type: 'Media Type',
                media_investment: 'Media Spends',
                share_of_media_spend: 'Share Of Media Spends(%)',
                incremental_retail_sales: 'Incremental Sales from Media',
                media_lift: 'Media Lift',
                media_roi: 'Media ROI',
            },
            mediaSpendsAttributeOptions: [
                // { label: 'Sub Brand', key: 'Sub_Brand', dim: 'dim1' },
                { label: 'Brand', key: 'Brand', dim: 'dim1' },
                { label: 'Manufacturer', key: 'Manufacturer', dim: 'dim1' },
                { label: 'Category', key: 'Category', dim: 'dim1' },
                { label: 'Sub Category', key: 'Sub_Category', dim: 'dim1' },
            ],

            chartHeaderLabelKeyMapping: {
                lift: { label: 'Lift' },
                roi: { label: 'ROI' },
                investments: { label: 'Investments' },
                incremental_net_sales: { label: 'Incremental Net Sales' },
                incremental_profit: { label: 'Incremental Profit' },
                incremental_retailer_profit: {
                    label: 'Incremental Retailer Profit',
                },
                acv: { label: 'ACV Distribution' },
                profit_pool: { label: 'Profit Pool' },
                tpr_acv: { label: 'Price Cut ACV' },
                display_acv: { label: 'Off Shelf ACV' },
                feature_acv: { label: 'On Shelf ACV' },
                feature_and_display_acv: { label: 'Special Pack ACV' },
                total_acv: { label: 'Total ACV' },
                weeks: { label: 'Promo Weeks' },
            },
            dimension: 'dim1',
            attributeType: 'product',
            promoTypesChartLegends: [
                {
                    label: 'Price Cut',
                    color: colorConstants.lightCyan,
                    style: {
                        borderRadius: '100%',
                        height: `8px`,
                        width: '8px',
                    },
                },
                {
                    label: 'On Shelf',
                    color: colorConstants.lightCream,
                    style: {
                        borderRadius: '100%',
                        height: `8px`,
                        width: '8px',
                    },
                },
                {
                    label: 'Off Shelf',
                    color: colorConstants.lightPink,
                    style: {
                        borderRadius: '100%',
                        height: `8px`,
                        width: '8px',
                    },
                },
            ],
            promoTypes: ['tpr/scan', 'feature ad', 'display'],
            promoTypesLabelMapping: {
                'tpr/scan': 'Price Cut',
                'feature ad': 'On Shelf',
                display: 'Off Shelf',
            },
        },
        promoRecommendation: {
            playbookLimit: 50,
            clientName: 'Perrigo',
            hideAddSpends: false,
            mainHeader: 'Promo Recommendation',

            retailerKey: 'Retailer',
            calenderStartDay: 'Sunday',
            spendLeversList: [
                {
                    label: 'Baseline Volume',
                    placeholder: 'Baseline Volume',
                    value: 'baseVolume',
                    isDisabled: false,
                },
                {
                    label: 'Uplift',
                    placeholder: 'Uplift',
                    value: 'uplift',
                    isDisabled: false,
                },
                {
                    label: 'Total Volume',
                    placeholder: 'Total Volume',
                    value: 'totalVolume',
                    isDisabled: true,
                },
                {
                    label: `Total Perrigo Profit (£)`,
                    placeholder: `Total Perrigo Profit`,
                    value: 'totalKindProfit',
                    isDisabled: true,
                },
                {
                    label: 'ROI',
                    placeholder: 'ROI',
                    value: 'roi',
                    isDisabled: true,
                },
                {
                    label: `Total Retailer Profit (£)`,
                    placeholder: 'Total Retailer Profit',
                    value: 'totalRetailerProfit',
                    isDisabled: true,
                },
            ],
            spendTypeList: [
                {
                    label: 'Lump Sum',
                    value: 'lump_sum',
                    inputRule: '',
                },
                {
                    label: 'Per Qty',
                    value: 'per_qty',
                    inputRule: '',
                },
                {
                    label: 'Off Shelf',
                    value: 'display',
                    inputRule: '',
                },
                {
                    label: 'On Shelf',
                    value: 'feature',
                    inputRule: '',
                },
            ],
            playbookKeyMapping: {
                Product: ['ppgName'],
                '%TS': ['guidelinePercentageTotalSpends', 'percentageTotalSpends', 'lesser_than', '', '%'],
                Frequency: ['guidelineFrequency', 'frequency', 'range', ''],
                ROI: ['guidelineRoi', 'roi', 'greater_than', '', ''],
            },
            // comparisonOperator: {
            //     '%TS': '<',
            //     Frequency: 'range',
            //     ROI: '>',
            // },
            menuButtons: [
                { key: 'recommendations', label: 'Recommendations' },
                {
                    key: 'summary',
                    label: 'Summary',
                },
                {
                    key: 'playbook',
                    label: 'Playbook',
                },
            ],

            promoTypeColorMapping: {
                'tpr/scan': {
                    label: 'Price Cut',
                    color: colorConstants.lightGreenAlt,
                },
                'feature ad': {
                    label: 'On Shelf',
                    color: colorConstants.darkGreenAlt2,
                },
                display: { label: 'Off Shelf', color: colorConstants.pinkAlt },
                feature_display_tpr: {
                    label: 'Special Pack',
                    color: colorConstants.orangeAlt2,
                },
                // display_tpr: { label: 'Display_TPR', color: colorConstants.darkBlueAlt },
            },
            overlayKeys: [
                {
                    label: 'Start Date',
                    dataKey: 'startDate',
                    pre: '',
                    post: '',
                },
                { label: 'Duration', dataKey: 'duration', pre: '', post: '' },
                {
                    label: 'Promo Type',
                    dataKey: 'tacticDescription',
                    pre: '',
                    post: '',
                },
                { label: 'Product(s)', dataKey: 'dim1AttributeNames', pre: '', post: '' },
                {
                    label: 'Total Volume',
                    dataKey: 'totalVolume',
                    pre: '',
                    post: '',
                    arrowConfig: 'positiveUp',
                },
                {
                    label: 'Total GSV',
                    dataKey: 'totalGsv',
                    pre: '£',
                    post: '',
                    arrowConfig: 'positiveUp',
                },
                {
                    label: 'Total NSV',
                    dataKey: 'totalNsv',
                    pre: '£',
                    post: '',
                    arrowConfig: 'positiveUp',
                },
                {
                    label: 'Total Perrigo Profit',
                    dataKey: 'totalKindProfit',
                    pre: '£',
                    post: '',
                    arrowConfig: 'positiveUp',
                },
                {
                    label: 'Total Retailer Profit',
                    dataKey: 'totalRetailerProfit',
                    pre: '£',
                    post: '',
                    arrowConfig: 'positiveUp',
                },
                {
                    label: 'Promo Spends',
                    dataKey: 'promoSpends',
                    pre: '£',
                    post: '',
                    arrowConfig: 'negativeUp',
                },
                {
                    label: '% Trade Spends GSV',
                    dataKey: 'percentageTradeSpendsGsv',
                    pre: '',
                    post: '%',
                    arrowConfig: 'negativeUp',
                },
                {
                    label: '% Trade Spends NSV',
                    dataKey: 'percentageTradeSpendsNsv',
                    pre: '',
                    post: '%',
                    arrowConfig: 'negativeUp',
                },

                {
                    label: 'Incremental Volume',
                    dataKey: 'incrementalVolume',
                    pre: '',
                    post: '',
                    arrowConfig: 'positiveUp',
                },
                {
                    label: 'Incremental GSV',
                    dataKey: 'incrementalGsv',
                    pre: '£',
                    post: '',
                    arrowConfig: 'positiveUp',
                },
                {
                    label: 'Incremental NSV',
                    dataKey: 'incrementalNsv',
                    pre: '£',
                    post: '',
                    arrowConfig: 'positiveUp',
                },
                {
                    label: 'Total Profit %',
                    dataKey: 'totalProfitPercentage',
                    pre: '',
                    post: '%',
                    arrowConfig: 'positiveUp',
                },
                {
                    label: 'Incremental Profit',
                    dataKey: 'incrementalProfit',
                    pre: '£',
                    post: '',
                    arrowConfig: 'positiveUp',
                },
                {
                    label: 'Promo ROI',
                    dataKey: 'roi',
                    pre: '',
                    post: '',
                    arrowConfig: 'positiveUp',
                },
                {
                    label: 'Retailer Incremental Profit',
                    dataKey: 'retailerIncrementalProfit',
                    pre: '£',
                    post: '',
                    arrowConfig: 'positiveUp',
                },
            ],
            spendLabel: {
                lump_sum: 'Lump Sum',
                per_qty: 'Per Qty',
                display: 'Off Shelf',
                feature: 'On Shelf',
            },
            offerMethodList: [
                { value: 'option', label: 'List of Option', dimension: 'dim1' },
                { value: 'manual', label: 'Manual', dimension: 'dim1' },
                { value: 'previous', label: 'Previous', dimension: 'dim1' },
            ],
            addEventList: [
                { value: 'new', label: 'Add New Event' },
                { value: 'import', label: 'Import Event' },
            ],
            leverKeys: [
                'promptEventName',
                'offerMethod',
                'discount',
                'startDate',
                'duration',
                'displayAcv',
                'featureAcv',
            ],
            spendTopForm: ['baseVolume', 'uplift', 'totalVolume', 'totalKindProfit', 'roi', 'totalRetailerProfit'],
            formList: [
                {
                    value: 'duration',
                    label: 'Duration',
                    inputRule: '',
                    placeHolder: 'Enter',
                },
                {
                    value: 'displayAcv',
                    label: 'Off Shelf ACV',
                    inputRule: '',
                    placeHolder: 'Enter Off Shelf ACV',
                },
                {
                    value: 'featureAcv',
                    label: 'On Shelf ACV',
                    inputRule: '',
                    placeHolder: 'Enter On Shelf ACV',
                },
            ],
            offerSelectionKeys: ['promotionMechanic', 'tacticDescription'],
            spendPerQtyKey: ['per_qty', 'redemption'],
        },
        commercialForecast: {
            externalAnalyticsToolName: { shortName: 'VF' },
            excludedAttributeTypes: ['manufacturer'],
            limit: 60,
            forecastDropdownData: [
                {
                    key: 'asper',
                    label: 'Asper Forecast',
                    value: 'asper',
                    dataKey: 'asper',
                },
                {
                    key: 'external',
                    label: 'VF Forecast',
                    value: 'external',
                    dataKey: 'external',
                },
                {
                    key: 'difference',
                    label: 'Difference',
                    value: 'difference',
                    dataKey: 'difference',
                },
                // { key: 'profit', label: 'Profit', value: 'profit', dataKey: 'profit' },
            ],
            trendChartDropdownData: [
                {
                    key: 'month',
                    label: 'Months',
                    labelAlt: 'Monthly',
                    value: 'month',
                    dataKey: 'month',
                },
                {
                    key: 'week',
                    label: 'Weeks',
                    labelAlt: 'Weekly',
                    value: 'week',
                    dataKey: 'week',
                },
                // { key: 'profit', label: 'Profit', value: 'profit', dataKey: 'profit' },
            ],
            graphExportHeaderMapping: {
                base: ['Non-promo', 'Promo'],
                incremental: ['Base', 'Incremental'],
                total: ['Consumption'],
                depletion: ['Depletion'],
            },
            mainTileData: [
                { key: 'total', label: 'Total' },
                { key: 'base', label: 'Base' },
                { key: 'incremental', label: 'Incremental' },
            ],
            graphLegendMapping: {
                total_asper: {
                    color: colorConstants.lightGreenAlt,
                    label: 'Total Units Asper',
                },
                base_asper: {
                    color: colorConstants.lightGreenAlt,
                    label: 'Base Units Asper',
                },
                incremental_asper: {
                    color: colorConstants.lightGreenAlt,
                    label: 'Incremental Units Asper',
                },
                total_external: {
                    color: colorConstants.darkYellow,
                    label: 'Total Units VF',
                },
                base_external: {
                    color: colorConstants.darkYellow,
                    label: 'Base Units VF',
                },
                incremental_external: {
                    color: colorConstants.darkYellow,
                    label: 'Incremental Units VF',
                },
                total_difference: {
                    color: colorConstants.orangeAlt2,
                    label: 'Total Units Difference',
                },
                base_difference: {
                    color: colorConstants.orangeAlt2,
                    label: 'Base Units Difference',
                },
                incremental_difference: {
                    color: colorConstants.orangeAlt2,
                    label: 'Incremental Units Difference',
                },
            },
            tableKeyLabelMapping: {
                total_sales_asper: {
                    label: 'Total Units Asper',
                    pre: '',
                    post: '',
                },
                total_sales_difference: {
                    label: 'Total Units Difference',
                    pre: '',
                    post: '',
                },
                total_sales_external: {
                    label: 'Total Units VF',
                    pre: '',
                    post: '',
                },
                incremental_sales_asper: {
                    label: 'Incremental Units Asper',
                    pre: '',
                    post: '',
                },
                incremental_sales_difference: {
                    label: 'Incremental Units Difference',
                    pre: '',
                    post: '',
                },
                incremental_sales_external: {
                    label: 'Incremental Units VF',
                    pre: '',
                    post: '',
                },
                base_sales_asper: {
                    label: 'Base Units Asper',
                    pre: '',
                    post: '',
                },
                base_sales_difference: {
                    label: 'Base Units Difference',
                    pre: '',
                    post: '',
                },
                base_sales_external: {
                    label: 'Base Units VF',
                    pre: '',
                    post: '',
                },
            },
        },
        priceLadder: {
            isThresholdDropdownEnabled: true,
            hideMraup: true,
            limit: 50, //update this when implementing infinite scroller,
            dimensionConfig: {
                //snake case eg sub_category
                excludedDimensions: [],
                defaultDimension: 'Brand',
            },
            tileData: [
                {
                    label: 'Product by Market',
                    key: 'product by market',
                },
                // {
                //     label: 'Product vs Competitors',
                //     key: 'product vs competitors',
                // },
            ],
            subTileData: [
                {
                    label: 'Per Unit',
                    key: 'PU',
                },
                // {
                //     label: 'PEQ',
                //     key: 'PEQ',
                // },
            ],
            legendMapping: {
                PU: [
                    {
                        color: '#E6E6EA',
                        label: 'Sales £',
                        key: 'salesValueDollars',
                        dataKey: 'sales',
                        metricDataKey: 'units',
                    },
                    {
                        color: '#66AFBA',
                        label: 'Avg. Price Per Unit',
                        key: 'avgPrice',
                        dataKey: 'avg_price_per_unit',
                        metricDataKey: 'units',
                    },
                    {
                        color: '#ECA586',
                        label: 'Max Price Per Unit',
                        key: 'maxPrice',
                        dataKey: 'max_price_per_unit',
                        metricDataKey: 'units',
                    },
                    {
                        color: '#EB8FC5',
                        label: 'Min Price Per Unit',
                        key: 'minPrice',
                        dataKey: 'min_price_per_unit',
                        metricDataKey: 'units',
                    },
                    {
                        color: '#F1C77A',
                        label: 'Promo Price Per Unit',
                        key: 'promoPrice',
                        dataKey: 'promo_price_per_unit',
                        metricDataKey: 'units',
                    },
                    {
                        color: '#6771DB',
                        label: 'Regular Price Per Unit',
                        key: 'basePrice',
                        dataKey: 'base_price_per_unit',
                        metricDataKey: 'units',
                    },
                    // { color: '#5463FF', label: 'MRAUP', key: 'mraup', dataKey: 'mraup' },
                ],
                PEQ: [
                    {
                        color: '#E6E6EA',
                        label: 'Sales £',
                        key: 'salesValueDollars',
                        dataKey: '',
                        metricDataKey: 'volume',
                    },
                    {
                        color: '#66AFBA',
                        label: 'Avg. Price PEQ',
                        key: 'avgPrice',
                        dataKey: 'avg_price_per_eq',
                        metricDataKey: 'volume',
                    },
                    {
                        color: '#ECA586',
                        label: 'Max Price PEQ',
                        key: 'maxPrice',
                        dataKey: 'max_price_per_eq',
                        metricDataKey: 'volume',
                    },
                    {
                        color: '#EB8FC5',
                        label: 'Min Price PEQ',
                        key: 'minPrice',
                        dataKey: 'min_price_per_eq',
                        metricDataKey: 'volume',
                    },
                    {
                        color: '#F1C77A',
                        label: 'Promo Price PEQ',
                        key: 'promoPrice',
                        dataKey: 'promo_price_per_eq',
                        metricDataKey: 'volume',
                    },
                    {
                        color: '#6771DB',
                        label: 'Regular Price PEQ',
                        key: 'basePrice',
                        dataKey: 'base_price_per_eq',
                        metricDataKey: 'volume',
                    },
                    // { color: '#5463FF', label: 'MRAUP', key: 'mraup', dataKey: 'mraup' },
                ],
            },
            dataKeyMapping: {
                PU: [
                    { label: 'Sales £', key: 'salesValueDollars' },
                    { label: 'Avg. Price Per Unit', key: 'avgPrice' },
                    { label: 'Max Price Per Unit', key: 'maxPrice' },
                    { label: 'Min Price Per Unit', key: 'minPrice' },
                    { label: 'Promo Price Per Unit', key: 'promoPrice' },
                    { label: 'Regular Price Per Unit', key: 'basePrice' },
                ],
                PEQ: [
                    { label: 'Sales £', key: 'salesValueDollars' },
                    { label: 'Avg. Price PEQ', key: 'avgPrice' },
                    { label: 'Max Price PEQ', key: 'maxPrice' },
                    { label: 'Min Price PEQ', key: 'minPrice' },
                    { label: 'Promo Price PEQ', key: 'promoPrice' },
                    { label: 'Regular Price PEQ', key: 'basePrice' },
                ],
            },
            tableColumnLabelKeyMapping: {
                sales: { label: 'Sales £' },
                sales_percentage: { label: 'Sales %' },
                avg_price_pu: { label: 'Average Price £ Per Unit' },
                // avg_price_peq: { label: 'Average Price £ PEQ' },
                max_price_pu: { label: 'Max Price £ Per Unit' },
                // max_price_peq: { label: 'Max Price £ PEQ' },
                min_price_pu: { label: 'Min Price £ Per Unit' },
                // min_price_peq: { label: 'Min Price £ PEQ' },
                // mraup: { label: 'MRAUP' },
                base_price_pu: { label: 'Regular Price £ Per Unit' },
                // base_price_peq: { label: 'Base Price £ PEQ' },
                promo_price_pu: { label: 'Promo Price £ Per Unit' },
                // promo_price_peq: { label: 'Promo Price £ PEQ' },
            },
            dropdown2Filter: ['Category', 'Pack_Size', 'Segment', 'Channel', 'Retailer'],
        },
        opportunityIdentification: {
            reversePpeAxis: false,
            bubbleCategoryOptions: [
                { value: 'brand', label: 'Brand', dimension: 'dim1' },
                { value: 'category', label: 'Category', dimension: 'dim1' },
                {
                    value: 'sub_category',
                    label: 'Sub Category',
                    dimension: 'dim1',
                },
                { value: 'pack_size', label: 'Pack Size', dimension: 'dim1' },
                {
                    value: 'manufacturer',
                    label: 'Manufacturer',
                    dimension: 'dim1',
                },
                { value: 'product', label: 'Product', dimension: 'dim1' },
            ],
            kpis: {
                xaxis: [
                    { label: 'BPE', value: 'bpe' },
                    { label: 'Value Sales Growth %', value: 'rsv_growth' },
                    { label: 'Gross Profit %', value: 'mac_percentage' },
                ],
                yaxis: [
                    { label: 'PPE', value: 'ppe' },
                    { label: 'Value Sales Growth %', value: 'rsv_growth' },
                    { label: 'Gross Profit %', value: 'mac_percentage' },
                ],
                bubbleSize: [
                    //{ label: 'Eq Volume', value: 'total_volume' },
                    { label: 'Units', value: 'total_units' },
                    { label: 'BPE', value: 'bpe' },
                    { label: 'PPE', value: 'ppe' },
                    { label: 'Gross Profit', value: 'mac' },
                    { label: 'Gross Profit %', value: 'mac_percentage' },
                    { label: 'Value Sales', value: 'rsv' },
                    { label: 'Value Sales Growth %', value: 'rsv_growth' },
                ],
            },
            elasticityDriver: {
                chart2Limit: 100,
                levels: [
                    { label: 'Retailer', value: 'retailer', dimension: 'dim2' },
                    { label: 'Product', value: 'product', dimension: 'dim1' },
                    { label: 'Category', value: 'category', dimension: 'dim1' },
                    { label: 'Sub Category', value: 'sub_category', dimension: 'dim1' },
                    { label: 'Brand', value: 'brand', dimension: 'dim1' },
                    { label: 'Pack Size', value: 'pack_size', dimension: 'dim1' },
                    { label: 'Channel', value: 'channel', dimension: 'dim2' },
                ],
                limit: 50,
                offset: 0,
                dimension: 'dim1',
                legendMapping: [
                    {
                        dataKey: 'own',
                        label: 'Own Elasticity',
                        color: '#69D4E8',
                    },
                    {
                        dataKey: 'internal',
                        label: 'Internal Competitor Elasticity',
                        color: '#E469B2',
                    },
                    {
                        dataKey: 'external',
                        label: 'External Competitor Elasticity',
                        color: '#EDB44E',
                    },
                ],
            },
        },
        priceCurve: {
            chart1Limit: 100,
            xAxisKeyValue: [
                { value: 'pack_size', label: 'Pack Size' },
                { value: 'brand', label: 'Brand' },
            ],
            YAxisKeyValue: [
                { value: 'retail_price', label: 'Retail Price' },
                { value: 'list_price', label: 'List Price' },
                { value: 'base_price', label: 'Regular Price' },
            ],
            levels: [
                { value: 'brand', label: 'Brand' },
                { value: 'manufacturer', label: 'Manufacturer' },
                { value: 'type', label: 'Type' },
                { value: 'class', label: 'Class' },
                { value: 'consumer', label: 'Consumer' },
            ],
            subTileData: [
                {
                    label: 'Per Unit',
                    key: 'PU',
                    dataKey: 'per_unit',
                },
                // {
                //     label: 'PEQ',
                //     key: 'PEQ',
                //     dataKey: 'per_eq',
                // },
            ],
            chartColors: [
                '#E8A122',
                '#293BB8',
                '#E06936',
                '#19669D',
                '#A5582D',
                '#43C9E2',
                '#DD449F',
                '#37C7BE',
                '#9E5897',
                '#00798C',
                '#EDB44E',
                '#4557D5',
                '#E6875E',
                '#228BD6',
                '#CC7442',
                '#69D4E8',
                '#E469B2',
                '#5FD3CB',
                '#B377AD',
                '#3394A3',
                '#F1C77A',
                '#7381E0',
                '#ECA586',
                '#55A8E4',
                '#D89672',
                '#8EDFEE',
                '#EB8FC5',
                '#87DED8',
                '#C699C2',
                '#66AFBA',
                '#F6D9A7',
                '#A2ABEA',
                '#F3C3AF',
                '#8EC5ED',
                '#E5B9A1',
                '#B4E9F3',
                '#F1B4D9',
                '#AFE9E5',
                '#D9BBD6',
                '#99C9D1',
                '#FAECD3',
                '#D0D5F5',
                '#F9E1D7',
                '#C6E2F6',
                '#F2DCD0',
                '#D9F4F9',
                '#F8DAEC',
                '#D7F4F2',
                '#ECDDEB',
                '#CCE4E8',
            ],
            tableHeaders: [
                { label: 'List Price £', key: 'list_price' },
                { label: 'List Price £ YA', key: 'list_price_ya' },
                { label: 'Retail Price £', key: 'retail_price' },
                { label: 'Retail Price £ YA', key: 'retail_price_ya' },
                { label: 'Regular Price £', key: 'base_price' },
                { label: 'Regular Price £ YA', key: 'base_price_ya' },
            ],
        },
        pricePoint: {
            priceRange: [0, 10],
            graphColorScheme: ['#D7D6D9', '#66AFBA', '#ECA586', '#F1C77A', '#EB8FC5'],
            hideMraup: true,
            limit: 500,
            dimensionConfig: {
                //snake case eg sub_category
                excludedDimensions: [],
                defaultDimension: 'Manufacturer',
            },
            contributionThreshold: 5,
            priceTypeOptions: [
                { label: 'Avg Price', value: 'avg_price' },
                { label: 'Base Price', value: 'base_price' },
            ],
            subTileData: [
                {
                    label: 'Per Unit',
                    key: 'per_unit',
                    xAxisLabel: 'Price Per Unit',
                    tooltip: 'Per Unit',
                },
                // {
                //     label: 'PEQ',
                //     key: 'per_volume',
                //     xAxisLabel: 'Price Per Eq',
                //     tooltip: 'Per Eq Volume',
                // },
            ],
            yAxisDropdownData: [
                {
                    label: 'Value',
                    value: 'value',
                },
                // {
                //     label: 'Volume',
                //     value: 'volume',
                // },
                {
                    label: 'Units',
                    value: 'units',
                },
            ],
            tableHeaderKeyMapping: {
                growth_percentage: ['Growth % vs YA', '', '%'],
                total_sales: ['Total Value (£)', '£', ''],
                total_volume: ['Total Volume', '', ''],
                total_units: ['Total Units', '', ''],
                avg_price_per_unit: ['Avg. Price per Unit', '£', ''],
                avg_price_per_eq: ['Avg. Price per EQ', '£', ''],
                base_price_per_unit: ['Base Price per Unit', '£', ''],
                base_price_per_eq: ['Base Price per EQ', '£', ''],
            },
            drilldownTableHeaderKeyMapping: {
                growth_abs: ['Growth Abs', '£', ''],
                growth_percentage: ['Growth %', '', '%'],
                contribution_to_category: ['Contribution to category', '£', ''],
                cy_share: ['CY share', '', '%'],
                ya_share: ['YA share', '', '%'],
                change: ['Change %', '', '%'],
            },
            dropdown2Filter: ['Category', 'Pack_Size', 'Segment', 'Channel', 'Retailer'],
            customThresholdData: [
                {
                    id: 1,
                    value: '',
                },
                {
                    id: 2,
                    value: '',
                },
                {
                    id: 3,
                    value: '',
                },
                {
                    id: 4,
                    value: '',
                },
                {
                    id: 5,
                    value: '',
                },
            ],
        },
        priceTracking: {
            limit: 20,
            dimensionConfig: {
                //snake case eg sub_category
                excludedDimensions: ['manufacturer', 'type', 'class', 'consumer', 'dosage', 'branding', 'perrigo_pl'],
                defaultRowDimension: 'Product',
                defaultColumnDimension: 'Retailer',
            },
            attributeNamesLimit: 50,
            frequency: 'W',
            timePeriodOptions: [
                { label: 'YA', value: 'year_ago' },
                { label: 'Prior Period', value: 'prior_period' },
                { label: 'Custom Period', value: 'custom' },
            ],
            priceTypeOptions: [
                { label: 'Regular Price', value: 'base' },
                { label: 'Avg Price', value: 'average' },
            ],
            kpiOptions: [
                { label: '% Change', value: 'percent_change' },
                { label: 'Price Index', value: 'index' },
            ],
            subTileData: [
                {
                    label: 'Per Unit',
                    key: 'units',
                    xAxisLabel: 'Price Per Unit',
                    tooltip: 'Per Unit',
                },
                // {
                //     label: 'PEQ',
                //     key: 'volume',
                //     xAxisLabel: 'Price Per Eq',
                //     tooltip: 'Per Eq Volume',
                // },
            ],

            weeksOptions: [
                { label: 'L W1', value: 1 },
                { label: 'L W4', value: 4 },
                { label: 'L W12', value: 12 },
            ],
            monthsOptions: [
                { label: 'L M1', value: 1 },
                { label: 'L M3', value: 3 },
                { label: 'L M6', value: 6 },
                { label: 'L M12', value: 12 },
            ],
            quartersOptions: [
                { label: 'L Q1', value: 1 },
                { label: 'L Q2', value: 2 },
                { label: 'L Q4', value: 4 },
            ],
            kpiMapping: {
                'Base Price': ['£', ''],
                'Base Price YA': ['£', ''],
                'Avg Price': ['£', ''],
                'Avg Price YA': ['£', ''],
                'Base Price Index % Chg': ['', '%'],
                'Base Price % Chg': ['', '%'],
                'Avg Price Index % Chg': ['', '%'],
                'Avg Price % Chg': ['', '%'],
                'TDP % Chg': ['', '%'],
                TDP: ['', ''],
                'TDP YA': ['', ''],
                'Volume Velocity % Chg': ['', '%'],
                'Volume Velocity': ['', ''],
                'Volume Velocity YA': ['', ''],
            },
        },
        bestWeeks: {
            limit: 50,
            drilldownTableConfig: [
                { label: 'Period No:', value: 'period_no', sorting: false },
                { label: 'Year', value: 'year', sorting: false },
            ],
            dimensionConfig: {
                //snake case eg sub_category
                excludedDimensions: ['dim2'],
                defaultDimension: 'Brand',
            },
            rankingCriteriaOptions: [
                { label: 'Base Volume', value: 'base_eq_volume' },
                { label: 'ACV', value: 'total_per_acv_dist' },
                { label: 'Incremental Volume', value: 'incremental_eq_volume' },
                { label: 'Total Volume', value: 'total_eq_volume' },
            ],
        },
    },
    constellation: {
        //COMMON CONFIG
        commonConfig: {
            clientName: 'CBI',
            handleDim2SortingFromFrontend: false,
            dateFormat: 'MM/DD/YYYY',
            dateFormatAlt: 'MM/DD/YY',
            calenderStartDay: 'Sunday',
            showSecondaryLogo: true,
            showLogoInNavbar: true,
            logoHeight: '38px',
            logoWidth: '206px',
            loginPageTextPart1: '',
            loginPageTextPart2: 'LYRA',
            width: window.innerWidth,
            limit: 10,
            offset: 0,
            lagList: [0, 1],
            graphFontSize: calculateFontSize(window.innerWidth, 13),
            graphFontSizeAlt: calculateFontSize(window.innerWidth, 13),
            graphFontFamily: "'Helvetica Neue', sans-serif",
            graphLabelColorAlt: '#4E4C55',
            graphLabelColor: '#433C4A',
            units: {
                currency: '$',
                volume: 'Eq Volume',
                currencyText: 'Dollar',
            },
            filterFormat: { dim1: { ids: [] }, dim2: { ids: [] } },
            frequency: 'W',
            showCampignCalender: false,
            showFullLabel: true,
            decimalForPercentage: 1,
            decimalForNonPercentage: 2,
        },
        latestDateForDifferentRoutes: {
            'depletion-analysis': 'Depletion Data',
            'pvm-analysis': 'PVM Data',
            'promo-score-card': 'Promotion Data',
            'roi-analysis': 'Promotion Data',
            'roi-tracker': 'Promotion Data',
            default: 'POS Data',
        },
        screenDetailsWithRoutes: [
            {
                label: 'Growth Analysis',
                path: 'promo/category-diagnostics/growth-analysis',
                id: 'ga',
                pageId: 'ga',
            },
            {
                label: 'Bump Report',
                path: 'promo/category-diagnostics/bump-report',
                id: 'br',
                pageId: 'br',
            },
            {
                label: 'Depletion Analysis',
                path: 'promo/category-diagnostics/depletion-analysis',
                id: 'da',
                pageId: 'da',
            },
            {
                label: 'PVM Analysis',
                path: 'promo/category-diagnostics/pvm-analysis',
                id: 'pvm',
                pageId: 'pvm',
            },
            {
                label: 'Price Change',
                path: 'pricing/analytics/price-change',
                id: 'pcn',
                pageId: 'pcn',
            },
            {
                label: 'Price Point',
                path: 'pricing/analytics/price-point',
                id: 'pp',
                pageId: 'pp',
            },
            {
                label: 'Price Ladder',
                path: 'pricing/analytics/price-ladder',
                id: 'pld',
                pageId: 'pld',
            },
            {
                label: 'Price Curve',
                path: 'pricing/analytics/price-curve',
                id: 'pc',
                pageId: 'pc',
            },
            {
                label: 'Price Tracking',
                path: 'pricing/analytics/price-tracking',
                id: 'pt',
                pageId: 'pt',
            },
            {
                label: 'Opportunity Identification',
                path: 'pricing/analytics/opportunity-identification',
                id: 'oi',
                pageId: 'oi',
            },
            {
                label: 'Promo Scorecard',
                path: 'promo/analytics/promo-score-card',
                id: 'ps',
                pageId: 'ps',
            },
            {
                label: 'Investment & ROI Tracker',
                path: 'promo/analytics/roi-tracker',
                id: 'pl',
                pageId: 'pl',
            },
            {
                label: 'Promo ROI Analysis',
                path: 'promo/analytics/roi-analysis',
                id: 'pa',
                pageId: 'pa',
            },
            {
                label: 'Promo Recommendation',
                path: 'promo/recommendation/promo-recommendation',
                id: 'pr',
                pageId: 'pr',
            },
            // {
            //     label: 'Pricing Simulator',
            //     path: 'pricing/recommendation/price-simulator',
            //     id: 'psr',
            //     pageId: 'psr',
            // },
            // {
            //     label: 'Pricing Simulator',
            //     path: 'pricing/recommendation/price-simulator/new',
            //     id: 'psr',
            //     pageId: 'psrNew',
            // },
            // {
            //     label: 'Pricing Simulator',
            //     path: 'pricing/recommendation/price-simulator/edit/:id',
            //     id: 'psr',
            //     pageId: 'psrEdit',
            // },
            // {
            //     label: 'Pricing Simulator',
            //     path: 'pricing/recommendation/price-simulator/view/:id',
            //     id: 'psr',
            //     pageId: 'psrView',
            // },
            {
                label: 'Pricing Simulator',
                path: 'pricing/recommendation/pricing-simulator',
                id: 'psrV2', //update id in simulator context as well
                pageId: 'psrV2',
            },
            {
                label: 'Pricing Simulator',
                path: 'pricing/recommendation/pricing-simulator/:mode/:projectId/scenario/:scenarioId',
                id: 'psr',
                pageId: 'psrV2Update',
            },
            {
                label: 'Pricing Simulator',
                path: 'pricing/recommendation/pricing-simulator/:mode/:projectId/scenario/:scenarioId',
                id: 'psr',
                pageId: 'psrV2View',
            },
            {
                label: 'Pricing Analytics',
                path: 'pricing/recommendation/pricing-analytics',
                id: 'psa',
                pageId: 'psa', // pricing analytics
            },
            {
                label: 'Pricing Analytics',
                path: 'pricing/recommendation/pricing-analytics/:mode/:reportId',
                id: 'psa',
                pageId: 'psaUpdate', // pricing analytics update
            },
            {
                label: 'Pricing Analytics',
                path: 'pricing/recommendation/pricing-analytics/:mode/:reportId',
                id: 'psa',
                pageId: 'psaView', // pricing analytics view
            },
            {
                label: 'Best Weeks',
                path: 'promo/recommendation/best-weeks',
                id: 'bw',
                pageId: 'bw',
            },
            {
                label: 'Profit Pool overview',
                path: 'profit-pool/overview',
                id: 'ppo',
                pageId: 'ppo',
            },
            {
                label: 'Profit Pool evolution',
                path: 'profit-pool/evolution',
                id: 'ppevo',
                pageId: 'ppevo',
            },
            {
                label: 'Growth margin drivers',
                path: 'profit-pool/growth-margin-driver',
                id: 'gmd',
                pageId: 'gmd',
            },
            {
                label: 'Growth margin bridges',
                path: 'profit-pool/growth-margin-bridges',
                id: 'gmb',
                pageId: 'gmb',
            },
            {
                label: 'Strategic Opportunity',
                path: 'profit-pool/strategic-opportunity',
                id: 'so',
                pageId: 'so',
            },
        ],
        screens: [
            {
                label: 'Category Diagnostics',
                path: ['promo/category-diagnostics'],
                showSubHeader: false,
                options: {
                    Promo: [
                        {
                            label: 'DINO',
                            path: 'growth-analysis',
                            id: 'ga',
                        },
                        { label: 'Bump Report', path: 'bump-report', id: 'br' },
                        {
                            label: 'Depletion Analysis',
                            path: 'depletion-analysis',
                            id: 'br',
                        },
                        {
                            label: 'PVM Analysis',
                            path: 'pvm-analysis',
                            id: 'pvm',
                        },
                    ],
                    visible: false,
                },
            },
            {
                label: 'Pricing Analytics',
                path: ['pricing/analytics', null],
                showSubHeader: false,
                options: {
                    Promo: [
                        {
                            label: 'Price Change',
                            path: 'price-change',
                            id: 'pcn',
                        },
                        { label: 'Price Point', path: 'price-point', id: 'pp' },
                        {
                            label: 'Price Ladder',
                            path: 'price-ladder',
                            id: 'pld',
                        },
                        { label: 'Price Curve', path: 'price-curve', id: 'pc' },
                        {
                            label: 'Price Tracking',
                            path: 'price-tracking',
                            id: 'pt',
                        },
                        {
                            label: 'Opportunity Identification',
                            path: 'opportunity-identification',
                            id: 'oi',
                        },
                    ],
                    visible: false,
                },
            },
            {
                label: 'Promo Analytics',
                path: ['promo/analytics', null],
                showSubHeader: false,
                options: {
                    Promo: [
                        { label: 'Promo Scorecard', path: 'promo-score-card', id: 'ps' },
                        { label: 'Investment & ROI Tracker', path: 'roi-tracker', id: 'pl' },
                        { label: 'Promo ROI Analysis', path: 'roi-analysis', id: 'pa' },
                    ],
                    visible: false,
                },
            },
            {
                label: 'Price & Promo Modeling',
                path: ['promo/recommendation', 'pricing/recommendation'],
                showSubHeader: true,
                options: {
                    Promo: [
                        {
                            label: 'Best Weeks',
                            path: 'best-weeks',
                            id: 'bw',
                        },
                    ],
                    Pricing: [{ label: 'Pricing Simulator', path: 'pricing-simulator', id: 'psrV2' }],
                    visible: false,
                },
            },
            {
                label: 'Profit Pool',
                path: ['profit-pool'],
                showSubHeader: false,
                options: {
                    Promo: [
                        {
                            label: 'Profit Pool Overview',
                            path: 'overview',
                            id: 'ppo',
                        },
                        {
                            label: 'Profit Pool Evolution',
                            path: 'evolution',
                            id: 'ppevo',
                        },
                        {
                            label: 'Growth Margin Drivers',
                            path: 'growth-margin-driver',
                            id: 'gmd',
                        },
                        {
                            label: 'Growth Margin Bridges',
                            path: 'growth-margin-bridges',
                            id: 'gmb',
                        },
                        {
                            label: 'Strategic Opportunity',
                            path: 'strategic-opportunity',
                            id: 'so',
                        },
                    ],
                    visible: false,
                },
            },
        ],
        globalFilter: {
            presetConfig: {
                disablePresetFilter: false,
                presetEnabledRoutes: {
                    'growth-analysis': true,
                    'bump-report': true,
                    'price-change': true,
                    'price-point': true,
                    'price-ladder': true,
                    'price-curve': true,
                    'price-tracking': true,
                    'opportunity-identification': true,
                    overview: true,
                    evolution: true,
                    'growth-margin-driver': true,
                    'strategic-opportunity': true,
                    'growth-margin-bridges': true,
                },
            },
            availableFrequenciesList: [
                { key: 'W', label: 'Week' },
                { key: 'M', label: 'Month' },
                { key: 'Q', label: 'Quarter' },
            ],
            globalFilterChangingRoutes: {
                //the keys should be equal to the final/last path of the screen
                'depletion-analysis': {
                    dimensionListKey: 'depletion',
                    getGlobalTimestampsKey: 'depletion',
                    getAttributeNamesKey: 'depletion',
                    defaultGlobalFilterObj: {
                        dim1: {
                            Category: {
                                inclusion: [
                                    {
                                        dimension: 'dim1',
                                        isActive: true,
                                        attributeType: 'Category',
                                        attributeDesc: 'BEER',
                                        attributeExId: 'BEER',
                                    },
                                ],
                            },
                        },
                        dim2: {},
                        dim3: {},
                    },
                },
                'pvm-analysis': {
                    dimensionListKey: 'pvm',
                    getAttributeNamesKey: 'pvm',
                    getGlobalTimestampsKey: 'pvm',
                    defaultGlobalFilterObj: {
                        dim1: {
                            Category: {
                                inclusion: [
                                    {
                                        dimension: 'dim1',
                                        isActive: true,
                                        attributeType: 'Category',
                                        attributeDesc: 'BEER',
                                        attributeExId: 'BEER',
                                    },
                                ],
                            },
                        },
                        dim4: {},
                    },
                },
                overview: {
                    dimensionListKey: 'profit_pool',
                    getGlobalTimestampsKey: 'profit_pool',
                    getAttributeNamesKey: 'profit_pool',
                    groupKey: 'profitPool',
                    defaultGlobalFilterObj: {
                        dim1: {},
                        dim2: {
                            State: {
                                inclusion: [
                                    {
                                        dimension: 'dim2',
                                        isActive: true,
                                        attributeType: 'State',
                                        attributeDesc: 'TEXAS',
                                        attributeExId: 'TEXAS',
                                    },
                                ],
                            },
                        },
                        dim3: {},
                    },
                },
                evolution: {
                    dimensionListKey: 'profit_pool',
                    getGlobalTimestampsKey: 'profit_pool',
                    getAttributeNamesKey: 'profit_pool',
                    groupKey: 'profitPool',
                    defaultGlobalFilterObj: {
                        dim1: {},
                        dim2: {
                            State: {
                                inclusion: [
                                    {
                                        dimension: 'dim2',
                                        isActive: true,
                                        attributeType: 'State',
                                        attributeDesc: 'TEXAS',
                                        attributeExId: 'TEXAS',
                                    },
                                ],
                            },
                        },
                        dim3: {},
                    },
                },
                'growth-margin-driver': {
                    dimensionListKey: 'profit_pool',
                    getGlobalTimestampsKey: 'profit_pool',
                    getAttributeNamesKey: 'profit_pool',
                    groupKey: 'profitPool',
                    defaultGlobalFilterObj: {
                        dim1: {},
                        dim2: {
                            State: {
                                inclusion: [
                                    {
                                        dimension: 'dim2',
                                        isActive: true,
                                        attributeType: 'State',
                                        attributeDesc: 'TEXAS',
                                        attributeExId: 'TEXAS',
                                    },
                                ],
                            },
                        },
                        dim3: {},
                    },
                },
                'strategic-opportunity': {
                    dimensionListKey: 'profit_pool',
                    getGlobalTimestampsKey: 'profit_pool',
                    getAttributeNamesKey: 'profit_pool',
                    groupKey: 'profitPool',
                    defaultGlobalFilterObj: {
                        dim1: {},
                        dim2: {
                            State: {
                                inclusion: [
                                    {
                                        dimension: 'dim2',
                                        isActive: true,
                                        attributeType: 'State',
                                        attributeDesc: 'TEXAS',
                                        attributeExId: 'TEXAS',
                                    },
                                ],
                            },
                        },
                        dim3: {},
                    },
                },
                'growth-margin-bridges': {
                    dimensionListKey: 'profit_pool',
                    getGlobalTimestampsKey: 'profit_pool',
                    getAttributeNamesKey: 'profit_pool',
                    groupKey: 'profitPool',
                    defaultGlobalFilterObj: {
                        dim1: {},
                        dim2: {
                            State: {
                                inclusion: [
                                    {
                                        dimension: 'dim2',
                                        isActive: true,
                                        attributeType: 'State',
                                        attributeDesc: 'TEXAS',
                                        attributeExId: 'TEXAS',
                                    },
                                ],
                            },
                        },
                        dim3: {},
                    },
                },
            },

            limit: 50,
            selectionAllowed: {
                'promo-recommendation': {
                    dim2: {
                        Retailer: 1,
                    },
                },
            },
            allSelectedLimit: 15,
            timePeriodScreenMapping: {
                default: ['4W', '12W', '26W', '52W', '1M', '3M', '6M', '12M', '1Q', '2Q', '4Q', 'YTD', 'CUSTOM DATE'],
                'bump-report': ['52W', '104W', '156W', '1M', '3M', '6M', '12M', '1Q', '2Q', '4Q', 'YTD', 'CUSTOM DATE'],
                overview: ['3M', '6M', '9M', '12M', 'YTD', 'CUSTOM DATE'],
                evolution: ['3M', '6M', '9M', '12M', 'YTD', 'CUSTOM DATE'],
                'growth-margin-driver': ['3M', '6M', '9M', '12M', 'YTD', 'CUSTOM DATE'],
                'growth-margin-bridges': ['3M', '6M', '9M', '12M', 'YTD', 'CUSTOM DATE'],
            },

            defaultPeriod: ['52W', '12M', '4Q'],
            applyFilterApiPostFormat: {
                jsonstring_dim1: '{}',
                jsonstring_dim2: '{}',
            },
            defaultPreviousIdObject: {
                dim1: ['attr', 'attr'],
                dim2: ['attr', 'attr'],
            },
            defaultIdObject: {
                dim1: { ids: [] },
                dim2: { ids: [] },
                dim3: { ids: [] },
                dim4: { ids: [] },
            },
            defaultAttrIdObject: {
                attr: {
                    dim1: { ids: [] },
                    dim2: { ids: [] },
                },
            },
            promoScoreCardDefault: {
                Category: 'BEER',
                Pack_Format: 'BOTTLE',
            },
            retainFiltersAcrossFeatures: false,
            PromoScoreCardDefaultObj: {
                dim1: {
                    Category: {
                        inclusion: [
                            {
                                dimension: 'dim1',
                                isActive: true,
                                attributeType: 'Category',
                                attributeDesc: 'BEER',
                                attributeExId: 'BEER',
                            },
                        ],
                    },
                    Pack_Format: {
                        inclusion: [
                            {
                                dimension: 'dim1',
                                isActive: true,
                                attributeType: 'Pack_Format',
                                attributeDesc: 'BOTTLE',
                                attributeExId: 'BOTTLE',
                            },
                            {
                                dimension: 'dim1',
                                isActive: true,
                                attributeType: 'Pack_Format',
                                attributeDesc: 'CAN',
                                attributeExId: 'CAN',
                            },
                            {
                                dimension: 'dim1',
                                isActive: true,
                                attributeType: 'Pack_Format',
                                attributeDesc: 'KEG',
                                attributeExId: 'KEG',
                            },
                            {
                                dimension: 'dim1',
                                isActive: true,
                                attributeType: 'Pack_Format',
                                attributeDesc: 'OTHER',
                                attributeExId: 'OTHER',
                            },
                        ],
                    },
                },
                dim2: {
                    geography: {
                        inclusion: [
                            {
                                dimension: 'dim2',
                                isActive: true,
                                attributeType: 'geography',
                                attributeDesc: 'TOTAL U.S. - MULTI OUTLET + CONVENIENCE+ (W/S/B)',
                                attributeExId: 'TOTAL U.S. - MULTI OUTLET + CONVENIENCE+ (W/S/B)',
                            },
                        ],
                    },
                },
            },
        },
        pvmAnalysis: {
            limit: 20,
            subTileData: [
                {
                    label: 'PU',
                    key: 'PU',
                },
                {
                    label: 'PEQ',
                    key: 'PEQ',
                },
            ],
            absTileData: [
                { key: 'abs', label: 'Abs' },
                { key: 'percentage', label: '%' },
            ],
            dataSizeOptions: [
                { value: 'top_5', label: 'Top 5', limit: 5 },
                { value: 'top_10', label: 'Top 10', limit: 10 },
                { value: 'bottom_5', label: 'Bottom 5', limit: 5 },
                { value: 'bottom_10', label: 'Bottom 10', limit: 10 },
                { value: 'all', label: 'All', limit: 20 },
            ],
            volTileData: [
                {
                    key: 'vol',
                    label: 'Eq Volume',
                    value: 'vol',
                    dataKey: 'volume',
                },
                {
                    key: 'val',
                    label: 'Dollars',
                    value: 'val',
                    dataKey: 'value',
                },
                {
                    key: 'units',
                    label: 'Units',
                    value: 'units',
                    dataKey: 'units',
                },
            ],
            salesTileData: [{ key: 'sales', label: 'Sales' }],
            salesAttributionChart: {
                colorList: ['#10AB5E', '#DC3826'],
                colorListType2: ['#758BEE', '#758BEE'],
                profitPoolColor: ['#826FD0', '#826FD0'],
                backGroundColor: 'rgba(0, 0, 0, 0.02)',
            },
            salesAttributionDrillDownChartKeyValueMapping: {
                'feature_&_display': 'Feature & Display',
                'Feature & Display': 'feature_&_display',
            },
            salesAttributionChart2DisabledItems: ['unexplained'],
            salesAttributionChart2Limit: 20,
        },
        priceSimulator: {
            allScenariosTableLimit: 500,
            a: 10,
            opportunityIdentificationTiles: [
                { key: 'recommendation', label: 'Recommendation' },
                { key: 'input', label: 'Input' },
                { key: 'output', label: 'Output' },
            ],
            cascadingColumns: ['COGS Rate', 'List Price', 'Everyday Retail Price'], // this should match with input key mapping and price simulator input columns
            levels: ['product', 'retailer'],
            inputKeyMapping: {
                // keep the order accuretly, to get it in multiselect
                cogs: 'COGS Rate',
                lp: 'List Price',
                rp: 'Everyday Retail Price',
                acv: 'ACV Distribution',
                oi: 'OI Rate',
                non_oi: 'Non OI Rate',
                promo_trade_spends: 'Promo Trade Rate Spends',
                tr: 'Trade Rate',
                cf: 'Comp Follow',
            },
            outputKeyMapping: {
                gsv: {
                    label: 'GSV',
                    pre: '$',
                    pos: '',
                },
                nsv: {
                    label: 'NSV',
                    pre: '$',
                    pos: '',
                },
                volume: {
                    label: 'Volume',
                    pre: '$',
                    pos: '',
                },
                rsv: {
                    label: 'RSV',
                    pre: '$',
                    pos: '',
                },
                rtMg: {
                    label: 'Retail Margin %',
                    pre: '',
                    pos: '%',
                },
                gmac: {
                    label: 'GMAC',
                    pre: '$',
                    pos: '',
                },
                units: {
                    label: 'Units',
                    pre: '$',
                    pos: '',
                },
                rsvMkSh: {
                    label: 'RSV Mkt Share',
                    pre: '$',
                    pos: '',
                },
                vlmMkSh: {
                    label: 'Volume Mkt Share',
                    pre: '',
                    pos: '%',
                },
                gsvMkSh: {
                    label: 'GSV Mkt Share',
                    pre: '',
                    pos: '%',
                },
                vlmChg: {
                    label: 'Volume Chg %',
                    pre: '',
                    pos: '%',
                },
                rtPfChg: {
                    label: 'Retail Profit % Chg',
                    pre: '',
                    pos: '%',
                },
                rMgChg: {
                    label: 'Retail Margin % Chg',
                    pre: '',
                    pos: '%',
                },
                netRpChg: {
                    label: 'Net Effective Price % Chg',
                    pre: '',
                    pos: '%',
                },
            },
            recommendationKeyMapping: {
                recommended_list_price: {
                    label: 'New recom price',
                    pre: '$',
                    pos: '',
                },
                role: {
                    label: 'Role',
                    pre: '',
                    pos: '',
                },
                strategy: {
                    label: 'Strategy',
                    pre: '',
                    pos: '',
                },
                mix: {
                    label: 'Mix',
                    pre: '',
                    pos: '',
                },
                growth: {
                    label: 'Growth',
                    pre: '',
                    pos: '',
                },
                gap: {
                    label: 'Gap',
                    pre: '',
                    pos: '',
                },

                cogs: {
                    label: 'COGs',
                    pre: '',
                    pos: '%',
                },
                list_to_retail: {
                    label: 'List to Retail',
                    pre: '',
                    pos: '',
                },
                bpe: {
                    label: 'BPE',
                    pre: '',
                    pos: '',
                },
                ppe: {
                    label: 'PPE',
                    pre: '',
                    pos: '',
                },
                margin: {
                    label: 'Margin',
                    pre: '',
                    pos: '%',
                },
                growth_vs_category: {
                    label: 'Gowth vs Category',
                    pre: '',
                    pos: '%',
                },
                pl_vs_category: {
                    label: 'PL vs Category',
                    pre: '',
                    pos: '%',
                },
                threshold: {
                    label: 'Threshold',
                    pre: '',
                    pos: '',
                },
                comp_index: {
                    label: 'Comp. Index',
                    pre: '',
                    pos: '',
                },
                curve_index: {
                    label: 'Curve Index',
                    pre: '',
                    pos: '',
                },
                cogs_realization: {
                    label: 'COGS & Realization',
                    pre: '',
                    pos: '',
                },
                cogs_forecast: {
                    label: 'COGS Forecast',
                    pre: '',
                    pos: '%',
                },
                net_to_retail: {
                    label: 'Net to Retail',
                    pre: '',
                    pos: '%',
                },
                gross_to_net: {
                    label: 'Gross to Net',
                    pre: '',
                    pos: '%',
                },
            },
            defaultKpiMetrics: [1, 2, 3, 4, 5],
            kpiMetrics: [
                {
                    key: 1,
                    value: 'volume_sales',
                    name: 'Volume Sales',
                    pre: '',
                    post: '',
                },
                {
                    key: 2,
                    value: 'value_sales',
                    name: 'Value Sales ($)',
                    pre: '$',
                    post: '',
                },
                {
                    key: 3,
                    value: 'profit_abs',
                    name: 'Profit Abs ($)',
                    pre: '$',
                    post: '',
                },
                {
                    key: 4,
                    value: 'margin_percent',
                    name: 'Margin (%)',
                    pre: '',
                    post: '%',
                },
                {
                    key: 5,
                    value: 'trade_rate_percent',
                    name: 'Trade Rate (%)',
                    pre: '',
                    post: '%',
                },

                {
                    key: 6,
                    value: 'retailer_margin_percent',
                    name: 'Retailer Margin (%)',
                    pre: '',
                    post: '%',
                },
                {
                    key: 7,
                    value: 'gross_profit',
                    name: 'Gross Profit ($)',
                    pre: '$',
                    post: '',
                },
                {
                    key: 8,
                    value: 'retailer_profit',
                    name: 'Retailer Profit ($)',
                    pre: '$',
                    post: '',
                },
                {
                    key: 9,
                    value: 'net_retail_price_change',
                    name: 'Net Retailer Price % Chg',
                    pre: '',
                    post: '%',
                },
            ],
            addPortfolioUpdateKpis: [
                {
                    key: 'volume',
                    value: '',
                    label: 'Volume',
                    rval: '',
                    percentChange: '',
                },
                {
                    key: 'value',
                    value: '',
                    label: 'Value',
                    rval: '',
                    percentChange: '',
                },
                {
                    key: 'units',
                    value: '',
                    label: 'Units',
                    rval: '',
                    percentChange: '',
                },
                {
                    key: 'trade_rate',
                    value: '',
                    label: 'Trade Rate %',
                    rval: '',
                    percentChange: '',
                },
                {
                    key: 'list_price',
                    value: '',
                    label: 'List Price',
                    rval: '',
                    percentChange: '',
                },
                {
                    key: 'retail_price',
                    value: '',
                    label: 'Retail Price',
                    rval: '',
                    percentChange: '',
                },
                {
                    key: 'acv',
                    value: '',
                    label: 'ACV Distribution',
                    rval: '',
                    percentChange: '',
                },
                {
                    key: 'cogs',
                    value: '',
                    label: 'COGS',
                    rval: '',
                    percentChange: '',
                },
                {
                    key: 'base_elasticity',
                    value: '',
                    label: 'Base Elasticity',
                    rval: '',
                    percentChange: '',
                },
                {
                    key: 'acv_elasticity',
                    value: '',
                    label: 'Acv Elasticity',
                    rval: '',
                    percentChange: '',
                },
            ],
            quarterMetricKeyMapping: [
                {
                    name: 'Volume',
                    value: 'volume',
                    pre: '',
                    post: '',
                },
                {
                    name: 'Revenue',
                    value: 'revenue',
                    pre: '$',
                    post: '',
                },
                {
                    name: 'Profit',
                    value: 'profit',
                    pre: '$',
                    post: '',
                },
                {
                    name: 'Trade Rate Percent',
                    value: 'tradeRatePercent',
                    pre: '',
                    post: '%',
                },
                {
                    name: 'Retailer Margin',
                    value: 'retailerMargin',
                    pre: '',
                    post: '',
                },
            ],
        },
        pricingSimulator: {
            enableAnalyticsTab: true,
            enableBulkUpload: true,
            indexPageTableLimit: 50,
            scenarioFilterOffsetLimit: 50,
            scenarioPerProjectLimit: 10,
            scenarioTableLimit: 500,
            analyticsChartLimit: 100,
            comparisonTableLimit: 50,
            dimAttributesLimit: 7,
            characterLimit: {
                kpiTileCharLimit: 22,
                kpiCompareCardLimit: 30,
            },
            enablePrivatePublicToggle: false,
            enableMicroInfoForTables: false,
            enableOneChangeAnalyticsChart: false,
            defaultGlobalKpiCount: 14,
            disableExport: false,
            indexTableFixedColumns: [
                { label: 'Project Name', key: 'projectName', sortKey: 'project_name' },
                { label: 'Created By', key: 'createdBy', sortKey: 'created_by' },
                { label: 'Status', key: 'status' },
                { label: 'Last Updated', key: 'lastUpdated', sortKey: 'updated_at' },
                { label: 'Simulation Period', key: 'simulationPeriod' },
                { label: 'Price Effective Date', key: 'priceEffectiveDate' },
            ],
            analyticsBaseScenarioFixedColumns: [
                { label: 'Project Name', key: 'projectName', sortKey: 'project_name' },
                { label: 'Created By', key: 'createdBy', sortKey: 'created_by' },
                { label: 'Status', key: 'status' },
            ],
            analyticsTableColumns: [
                { label: 'Report Name', key: 'reportName', sortKey: 'report_name' },
                { label: 'Base Scenario', key: 'baseScenario', sortKey: 'base_scenario' },
                { label: 'Created By', key: 'createdBy', sortKey: 'created_by' },
                { label: 'Last Updated', key: 'lastUpdated', sortKey: 'updated_at' },
                { label: 'Date Created', key: 'dateCreated', sortKey: 'created_at' },
            ],
            projectStatuses: {
                ACTIVE: { label: 'Active', colorType: 'success' },
                DRAFT: { label: 'Draft', colorType: 'processing' },
                SETUP: { label: 'Setup', colorType: 'processing' },
                IN_PROGRESS: { label: 'In-Progress', colorType: 'processing' },
                EXPIRED: { label: 'Expired', colorType: 'default' },
                ERROR: { label: 'Error', colorType: 'error' },
                INVALID: { label: 'Invalid', colorType: 'error' },
            },
            projectDataSource: [{ label: 'Depletion', value: 'depletion_data' }],
            simulatedPeriodItems: [
                { label: 'Custom Date', value: 'custom_date', dateArray: null },
                { label: 'Current Year', value: 'current_year', dateArray: ['01-05-2025', '12-28-2025'] },
                { label: 'Financial Year', value: 'financial_year', dateArray: ['03-02-2025', '02-22-2026'] },
            ],
            iconsMappings: {
                Elasticity: 'BorderOuterOutlined',
                BaseInput: 'BorderlessTableOutlined',
                COGS: 'DollarOutlined',
                Distributor: 'BuildOutlined',
                'Distributor P&L': 'BuildOutlined',
                FOB: 'ClusterOutlined',
                'P&L': 'LineChartOutlined',
                Price: 'MoneyCollectOutlined',
                Promotions: 'BoxPlotOutlined',
                'Retailer P&L': 'LineChartOutlined',
                Sales: 'AreaChartOutlined',
                Taxes: 'BlockOutlined',
                Volume: 'ExperimentOutlined',
                Others: 'UngroupOutlined',
                Product: 'GoldOutlined',
                Geo: 'ExpandOutlined',
                'Dollar Impact': 'DollarOutlined',
                'Standard Increase Metrics': 'ToTopOutlined',
                'EQV Metrics': 'BlockOutlined',
            },
            categoryMovementKpis: [
                { label: 'Volume Impact', value: 'volume', yAxisLabel: 'Vol', xAxisLabel: 'Retailer Vol' },
                { label: 'Sales Impact', value: 'sales', yAxisLabel: 'Sales $', xAxisLabel: 'Retailer Sales $' },
            ],
            tierAnalytics: {
                tabLabel: '3-Tier Analytics',
                showNegativesInParenthesis: true,
                resetFilterDimension: {
                    defaultFilterDimId: 'manufacturer',
                    defaultFilterDimValue: 'CONSTELLATION BRANDS',
                },
                visualConfig: {
                    volume: {
                        chartColor: colorConstants.greyAlt15,
                        tableColor: colorConstants.greyAlt9,
                        label: 'Volume',
                    },
                    company: {
                        chartColor: colorConstants.greenALt1,
                        tableColor: colorConstants.lightGreen1,
                        label: 'CBI',
                    },
                    distributor: {
                        chartColor: colorConstants.lightOrangeAlt,
                        tableColor: colorConstants.lightYellow1,
                        label: 'Distributor',
                    },
                    retailer: {
                        chartColor: colorConstants.lightPurpleAlt,
                        tableColor: colorConstants.lightBlue1,
                        label: 'Retailer',
                    },
                },
                leftChartLabels: {
                    mainLabel: 'CBI, Distributor, Retailer KPI % Change',
                    xAxis: 'Metric',
                    yAxis: 'Sales',
                },
                columnMapping: {
                    current: 'Current',
                    simulation: 'Simulation',
                    change_amount: 'Change Amount FAV/(Unfav)',
                    change_perc: 'Change in %',
                    constant: 'Constant',
                    constant_change_amount: 'Change Amount FAV/(Unfav)',
                    constant_change_perc: 'Change in %',
                    breakeven_volume: 'B/E (EQV)',
                    breakeven_volume_variance: 'B/E Variance (EQV)',
                    breakeven_percentage: 'B/E % (EQV)',
                },
            },
        },
        priceChange: {
            // TODO: remove unwanted props
            limit: 60,
            dimensionConfig: {
                //snake case eg sub_category
                excludedDimensions: [],
                defaultDimension: 'Manufacturer',
            },
            hiddenTableRows: [],
            timePeriodOptions: [
                { label: 'YA', value: 'year_ago' },
                { label: 'Prior Period', value: 'prior_period' },
                { label: 'Custom Period', value: 'custom' },
            ],
            absTileData: [
                { key: 'abs', label: 'Abs' },
                { key: 'percentage', label: '%' },
            ],
            kpiListData: [
                {
                    key: 'avg_price',
                    label: 'Avg Price',
                    value: 'average',
                    dataKey: 'avg_price',
                },
                {
                    key: 'base_price',
                    label: 'Base Price',
                    value: 'base',
                    dataKey: 'base_price',
                },
            ],
            volTileData: [
                {
                    key: 'units',
                    label: 'PU',
                    value: 'units',
                    dataKey: 'units',
                    tooltip: 'Per Unit',
                },
                {
                    key: 'vol',
                    label: 'PEQ',
                    value: 'vol',
                    dataKey: 'volume',
                    tooltip: 'Per Eq Volume',
                },
            ],
            salesTileData: [
                { key: 'sales', label: 'Sales' },
                { key: 'incremental', label: 'Incremental' },
                { key: 'promo', label: 'Promo' },
            ],
            salesAttributionChart: {
                colorList: ['#10AB5E', '#DC3826'],
                colorListType2: ['#758BEE', '#758BEE'],
                profitPoolColor: ['#826FD0', '#826FD0'],
                backGroundColor: 'rgba(0, 0, 0, 0.02)',
            },
            salesAttributionDrillDownChartKeyValueMapping: {
                'feature_&_display': 'Feature & Display',
                'Feature & Display': 'feature_&_display',
            },
            salesAttributionChart2Limit: 20,
        },
        growthAnalysis: {
            limit: 60,
            includeAggPeriod: true,
            dimensionConfig: {
                //snake case eg sub_category
                excludedDimensions: [],
                defaultDimension: 'Manufacturer',
            },
            absTileData: [
                { key: 'abs', label: 'Abs' },
                { key: 'percentage', label: '%' },
            ],
            subTileData: [
                {
                    label: 'PU',
                    key: 'PU',
                },
                {
                    label: 'PEQ',
                    key: 'PEQ',
                },
            ],
            volTileData: [
                {
                    key: 'val',
                    label: 'Dollars',
                    value: 'val',
                    dataKey: 'value',
                },
                {
                    key: 'vol',
                    label: 'Eq Volume',
                    value: 'vol',
                    dataKey: 'volume',
                },
                {
                    key: 'units',
                    label: 'Units',
                    value: 'units',
                    dataKey: 'units',
                },
                // { key: 'profit', label: 'Profit', value: 'profit', dataKey: 'profit' },
            ],
            showTotal: true,
            currentYearLabel: 'CY',
            yearAgoLabel: 'YA',
            trendChartDropdownData: [
                {
                    key: 'sales_volume',
                    label: 'Sales Volume',
                    value: 'sales_volume',
                    dataKey: 'sales_volume',
                },
                {
                    key: 'sales',
                    label: 'Sales $',
                    value: 'sales',
                    dataKey: 'sales',
                },
                {
                    key: 'average_price',
                    label: 'Average Price',
                    value: 'average_price',
                    dataKey: 'average_price',
                },
                {
                    key: 'base_price',
                    label: 'Base Price',
                    value: 'base_price',
                    dataKey: 'base_price',
                },
                { key: 'acv', label: '%ACV', value: 'acv', dataKey: 'acv' },
                {
                    key: 'avg_items',
                    label: 'Avg. no. of items',
                    value: 'avg_items',
                    dataKey: 'avg_items',
                },
                { key: 'tdp', label: 'TDP', value: 'tdp', dataKey: 'tdp' },
            ],
            salesTileData: [
                { key: 'sales', label: 'Consumption' },
                { key: 'incremental', label: 'Incremental' },
                { key: 'promo', label: 'Promo' },
            ],
            depletionTileData: { key: 'depletion', label: 'Depletion' },
            graphExportHeaderMapping: {
                promo: ['Non-promo', 'Promo'],
                incremental: ['Base', 'Incremental'],
                sales: ['Consumption'],
                depletion: ['Depletion'],
            },
            depletionDropdownData: [
                {
                    value: 'frontline',
                    dataKey: 'frontline',
                    key: 'frontline',
                    label: 'Frontline Sales',
                },
                {
                    value: 'net',
                    dataKey: 'net',
                    key: 'net',
                    label: 'Net Sales',
                },
            ],
            tableKeyUnitMapping: {
                'Market Share CY': {
                    unit: '%',
                    label: 'Market Share CY',
                    includePercentageChange: false,
                },
                'Market Share YA': {
                    unit: '%',
                    label: 'Market Share YA',
                    includePercentageChange: false,
                },
                'ACV CY': {
                    unit: '%',
                    label: 'Wtd. Avg ACV %',
                    includePercentageChange: false,
                },
                'ACV YA': {
                    unit: '%',
                    label: 'Wtd. Avg ACV % YA',
                    includePercentageChange: false,
                },
            },
            salesAttributionChart: {
                colorList: ['#10AB5E', '#DC3826'],
                colorListType2: ['#758BEE', '#758BEE'],
                profitPoolColor: ['#826FD0', '#826FD0'],
                backGroundColor: 'rgba(0, 0, 0, 0.02)',
            },
            salesAttributionDrillDownChartKeyValueMapping: {
                'feature_&_display': 'Feature & Display',
                'Feature & Display': 'feature_&_display',
            },
            salesAttributionChart2DisabledItems: ['unexplained'],
            salesAttributionChart2Limit: 50,
        },
        //BUMP REPORT
        bumpReport: {
            mainHeader: 'Bump Report',
            groupByKey: 'groupBy',
            comparisonTileData: [
                { key: 'cy_vs_ya', label: 'CY vs YA' },
                { key: 'difference', label: 'Difference' },
            ],
            enablePromoCalender: true,
            isPromoUpliftPercentValue: false,
            volGroupByOptionsMapping: {
                vol: [
                    {
                        value: 'total_eq_volume',
                        label: 'Total EQ Volume',
                        index: 1,
                    },
                    {
                        value: 'any_promo_eq_volume',
                        label: 'Any promo EQ Volume',
                        index: 1,
                    },
                    {
                        value: 'no_promo_eq_volume',
                        label: 'No Promo EQ Volume',
                        index: 1,
                    },

                    {
                        value: 'base_eq_volume',
                        label: 'Base EQ Volume',
                        index: 0,
                    },
                    {
                        value: 'incremental_eq_volume',
                        label: 'Incremental EQ Volume Total',
                        index: 0,
                    },
                    {
                        value: 'tpr_incremental_eq_volume',
                        label: 'Incremental EQ Volume TPR',
                        index: 0,
                    },
                    {
                        value: 'feature_incremental_eq_volume',
                        label: 'Incremental EQ Volume Feature',
                        index: 0,
                    },
                    {
                        value: 'display_incremental_eq_volume',
                        label: 'Incremental EQ Volume Display',
                        index: 0,
                    },
                    {
                        value: 'feature_and_display_incremental_eq_volume',
                        label: 'Incremental EQ Volume Feature & Display',
                        index: 0,
                    },
                ],
                val: [
                    { value: 'total_value', label: 'Total Value', index: 1 },
                    {
                        value: 'any_promo_value',
                        label: 'Any Promo Value',
                        index: 1,
                    },
                    {
                        value: 'no_promo_value',
                        label: 'No Promo Value',
                        index: 1,
                    },
                    { value: 'base_value', label: 'Base Value', index: 0 },
                    {
                        value: 'incremental_value',
                        label: 'Incremental Value Total',
                        index: 0,
                    },
                    {
                        value: 'tpr_incremental_value',
                        label: 'Incremental Value TPR',
                        index: 0,
                    },
                    {
                        value: 'feature_incremental_value',
                        label: 'Incremental Value Feature',
                        index: 0,
                    },
                    {
                        value: 'display_incremental_value',
                        label: 'Incremental Value Display',
                        index: 0,
                    },
                    {
                        value: 'feature_and_display_incremental_value',
                        label: 'Incremental Value Feature & Display',
                        index: 0,
                    },
                ],
                units: [
                    { value: 'total_units', label: 'Total Units', index: 1 },
                    {
                        value: 'any_promo_units',
                        label: 'Any Promo Units',
                        index: 1,
                    },
                    {
                        value: 'no_promo_units',
                        label: 'No Promo Units',
                        index: 1,
                    },
                    { value: 'base_units', label: 'Base Units', index: 0 },
                    {
                        value: 'incremental_units',
                        label: 'Incremental Units Total',
                        index: 0,
                    },
                    {
                        value: 'tpr_incremental_units',
                        label: 'Incremental Units TPR',
                        index: 0,
                    },
                    {
                        value: 'feature_incremental_units',
                        label: 'Incremental Units Feature',
                        index: 0,
                    },
                    {
                        value: 'display_incremental_units',
                        label: 'Incremental Units Display',
                        index: 0,
                    },
                    {
                        value: 'feature_and_display_incremental_units',
                        label: 'Incremental Units Feature & Display',
                        index: 0,
                    },
                ],
            },
            tooltipKeyLabelMapping: {
                increments: 'Incremental',
                promo: 'Any Promo',
            },
            bumpReportTileData: [
                { key: 'increments', label: 'Attribution' },
                { key: 'promo', label: 'Consumption' },
                { key: 'groupBy', label: 'Group By' },
            ],
            bumpReportTile1Data: [
                {
                    key: 'promo',
                    label: 'Promotions',
                    visibleTabs: ['increments', 'promo', 'groupBy'],
                }, //keys should match bumpReportTileData keys
            ],
            bumpReportTile2Data: [
                { key: 'total', label: 'Total' },
                { key: 'breakout', label: 'Breakout' },
            ],
            absTileData: [
                { key: 'abs', label: 'Abs' },
                { key: 'percentage', label: '%' },
            ],

            volTileData: [
                { key: 'val', label: 'Dollars', dataKey: 'value' },
                { key: 'vol', label: 'Eq Volume', dataKey: 'volume' },
                { key: 'units', label: 'Units', dataKey: 'units' },
            ],
            bumpChartY2Colors: [
                '#293BB8',
                '#DD449F',
                '#9E5897',
                '#19669D',
                '#43C9E2',
                '#37C7BE',
                '#00798C',
                '#E8A122',
                '#E06936',
                '#A5582D',
            ],
            bumpChartY2AxisOptions: {
                vol: [
                    {
                        value: 'avg_price_per_eq',
                        index: 0,
                        label: 'Avg. Price/EQ',
                        unit: '',
                    },
                    {
                        value: 'base_price_per_eq',
                        index: 0,
                        label: 'Base Price/EQ',
                        unit: '',
                    },
                    {
                        value: 'promo_price_per_eq',
                        index: 0,
                        label: 'Promo Price/EQ',
                        unit: '',
                    },
                    {
                        value: 'market_share_volume',
                        index: 0,
                        label: 'Market Share %',
                        unit: '',
                    },
                    {
                        value: 'distribution_tdp',
                        index: 0,
                        label: 'Distribution TDP',
                        unit: '',
                    },
                    {
                        value: 'display_tdp',
                        index: 0,
                        label: 'Display TDP',
                        unit: '',
                    },
                    {
                        value: 'feature_tdp',
                        index: 0,
                        label: 'Feature TDP',
                        unit: '',
                    },
                    {
                        value: 'feature_and_display_tdp',
                        index: 0,
                        label: 'Feature and Display TDP',
                        unit: '',
                    },
                    {
                        value: 'unit_velocity',
                        index: 0,
                        label: 'Unit Velocity',
                        unit: '',
                    },
                    {
                        value: 'sales_velocity',
                        index: 0,
                        label: 'Dollar Velocity',
                        unit: '$',
                    },
                    {
                        value: 'volume_velocity',
                        index: 0,
                        label: 'Eq Velocity',
                        unit: '',
                    },
                    {
                        value: 'subsidized_base_sales',
                        index: 0,
                        label: 'Subsidized Base Sales',
                        unit: '',
                    },
                    {
                        value: 'distribution_acv',
                        index: 0,
                        label: 'ACV %',
                        unit: '',
                    },
                    {
                        value: 'display_acv',
                        index: 0,
                        label: 'Display ACV %',
                        unit: '',
                    },
                    {
                        value: 'feature_acv',
                        index: 0,
                        label: 'Feature ACV %',
                        unit: '',
                    },
                    {
                        value: 'feature_and_display_acv',
                        index: 0,
                        label: 'Feature & Display ACV %',
                        unit: '',
                    },
                ],
                val: [
                    {
                        value: 'avg_price_per_eq',
                        index: 0,
                        label: 'Avg. Price/EQ',
                        unit: '',
                    },
                    {
                        value: 'base_price_per_eq',
                        index: 0,
                        label: 'Base Price/EQ',
                        unit: '',
                    },
                    {
                        value: 'promo_price_per_eq',
                        index: 0,
                        label: 'Promo Price/EQ',
                        unit: '',
                    },
                    {
                        value: 'market_share_value',
                        index: 0,
                        label: 'Market Share %',
                        unit: '',
                    },
                    {
                        value: 'distribution_tdp',
                        index: 0,
                        label: 'Distribution TDP',
                        unit: '',
                    },
                    {
                        value: 'display_tdp',
                        index: 0,
                        label: 'Display TDP',
                        unit: '',
                    },
                    {
                        value: 'feature_tdp',
                        index: 0,
                        label: 'Feature TDP',
                        unit: '',
                    },
                    {
                        value: 'feature_and_display_tdp',
                        index: 0,
                        label: 'Feature and Display TDP',
                        unit: '',
                    },
                    {
                        value: 'unit_velocity',
                        index: 0,
                        label: 'Unit Velocity',
                        unit: '',
                    },
                    {
                        value: 'sales_velocity',
                        index: 0,
                        label: 'Dollar Velocity',
                        unit: '$',
                    },
                    {
                        value: 'volume_velocity',
                        index: 0,
                        label: 'Eq Velocity',
                        unit: '',
                    },
                    {
                        value: 'subsidized_base_sales',
                        index: 0,
                        label: 'Subsidized Base Sales',
                        unit: '',
                    },
                    {
                        value: 'distribution_acv',
                        index: 0,
                        label: 'ACV %',
                        unit: '',
                    },
                    {
                        value: 'display_acv',
                        index: 0,
                        label: 'Display ACV %',
                        unit: '',
                    },
                    {
                        value: 'feature_acv',
                        index: 0,
                        label: 'Feature ACV %',
                        unit: '',
                    },
                    {
                        value: 'feature_and_display_acv',
                        index: 0,
                        label: 'Feature & Display ACV %',
                        unit: '',
                    },
                ],
                units: [
                    {
                        value: 'avg_price_per_unit',
                        index: 0,
                        label: 'Avg. Price/Unit ($)',
                        unit: '',
                    },
                    {
                        value: 'base_price_per_unit',
                        index: 0,
                        label: 'Base Price/unit',
                        unit: '',
                    },
                    {
                        value: 'promo_price_per_unit',
                        index: 0,
                        label: 'Promo Price/Unit',
                        unit: '',
                    },
                    {
                        value: 'market_share_units',
                        index: 0,
                        label: 'Market Share %',
                        unit: '',
                    },
                    {
                        value: 'distribution_tdp',
                        index: 0,
                        label: 'Distribution TDP',
                        unit: '',
                    },
                    {
                        value: 'display_tdp',
                        index: 0,
                        label: 'Display TDP',
                        unit: '',
                    },
                    {
                        value: 'feature_tdp',
                        index: 0,
                        label: 'Feature TDP',
                        unit: '',
                    },
                    {
                        value: 'feature_and_display_tdp',
                        index: 0,
                        label: 'Feature and Display TDP',
                        unit: '',
                    },
                    {
                        value: 'unit_velocity',
                        index: 0,
                        label: 'Unit Velocity',
                        unit: '',
                    },
                    {
                        value: 'sales_velocity',
                        index: 0,
                        label: 'Dollar Velocity',
                        unit: '$',
                    },
                    {
                        value: 'volume_velocity',
                        index: 0,
                        label: 'Eq Velocity',
                        unit: '',
                    },
                    {
                        value: 'subsidized_base_sales',
                        index: 0,
                        label: 'Subsidized Base Sales',
                        unit: '',
                    },
                    {
                        value: 'distribution_acv',
                        index: 0,
                        label: 'ACV %',
                        unit: '',
                    },
                    {
                        value: 'display_acv',
                        index: 0,
                        label: 'Display ACV %',
                        unit: '',
                    },
                    {
                        value: 'feature_acv',
                        index: 0,
                        label: 'Feature ACV %',
                        unit: '',
                    },
                    {
                        value: 'feature_and_display_acv',
                        index: 0,
                        label: 'Feature & Display ACV %',
                        unit: '',
                    },
                ],
            },
            promoTypeColorMapping: {
                'tpr/scan': {
                    label: 'TPR/Scan',
                    color: colorConstants.lightGreenAlt,
                },
                'feature ad': {
                    label: 'Feature Ad',
                    color: colorConstants.darkGreenAlt2,
                },
                display: { label: 'Display', color: colorConstants.pinkAlt },
                feature_display_tpr: {
                    label: 'Feature_Display_TPR',
                    color: colorConstants.orangeAlt2,
                },
                display_tpr: {
                    label: 'Display_TPR',
                    color: colorConstants.darkBlueAlt,
                },
            },
            stackedColors: [
                colorConstants.lightGreenAlt,
                colorConstants.darkGreenAlt2,
                colorConstants.pinkAlt,
                colorConstants.orangeAlt2,
                colorConstants.darkYellow,
            ],
            fieldKeyLabelMapping: {
                base_eq_volume: {
                    label: 'Base Sales (Eq Vol)',
                    color: colorConstants.darkYellow,
                    tableLabel: 'Base',
                },
                base_value: {
                    label: 'Base Sales ($)',
                    color: colorConstants.darkYellow,
                    tableLabel: 'Base',
                },
                base_units: {
                    label: 'Base Units',
                    color: colorConstants.darkYellow,
                    tableLabel: 'Base',
                },
                incremental_eq_volume: {
                    label: 'Incremental Sales (Eq Vol)',
                    color: colorConstants.darkGreenAlt2,
                    tableLabel: 'Incremental',
                },
                incremental_value: {
                    label: 'Incremental Sales ($)',
                    color: colorConstants.darkGreenAlt2,
                    tableLabel: 'Incremental',
                },
                incremental_units: {
                    label: 'Incremental Units',
                    color: colorConstants.darkGreenAlt2,
                    tableLabel: 'Incremental',
                },
                any_promo_eq_volume: {
                    label: 'Promo',
                    color: colorConstants.darkGreenAlt2,
                    tableLabel: 'Promo',
                },
                any_promo_value: {
                    label: 'Promo',
                    color: colorConstants.darkGreenAlt2,
                    tableLabel: 'Promo',
                },
                any_promo_units: {
                    label: 'Promo',
                    color: colorConstants.darkGreenAlt2,
                    tableLabel: 'Promo',
                },
                tpr_incremental_eq_volume: {
                    label: 'TPR Incremental',
                    color: colorConstants.lightGreenAlt,
                    tableLabel: 'TPR Incremental',
                },
                feature_incremental_eq_volume: {
                    label: 'Feature Incremental',
                    color: colorConstants.darkGreenAlt2,
                    tableLabel: 'Feature Incremental',
                },
                display_incremental_eq_volume: {
                    label: 'Display Incremental',
                    color: colorConstants.pinkAlt,
                    tableLabel: 'Display Incremental',
                },
                feature_and_display_incremental_eq_volume: {
                    label: 'F & D Incremental',
                    color: colorConstants.orangeAlt2,
                    tableLabel: 'F & D Incremental',
                },
                tpr_incremental_value: {
                    label: 'TPR Incremental',
                    color: colorConstants.lightGreenAlt,
                    tableLabel: 'TPR Incremental',
                },
                feature_incremental_value: {
                    label: 'Feature Incremental',
                    color: colorConstants.darkGreenAlt2,
                    tableLabel: 'Feature Incremental',
                },
                display_incremental_value: {
                    label: 'Display Incremental',
                    color: colorConstants.pinkAlt,
                    tableLabel: 'Display Incremental',
                },
                feature_and_display_incremental_value: {
                    label: 'F & D Incremental',
                    color: colorConstants.orangeAlt2,
                    tableLabel: 'F & D Incremental',
                },
                tpr_incremental_units: {
                    label: 'TPR Incremental',
                    color: colorConstants.lightGreenAlt,
                    tableLabel: 'TPR Incremental',
                },
                feature_incremental_units: {
                    label: 'Feature Incremental',
                    color: colorConstants.darkGreenAlt2,
                    tableLabel: 'Feature Incremental',
                },
                display_incremental_units: {
                    label: 'Display Incremental',
                    color: colorConstants.pinkAlt,
                    tableLabel: 'Display Incremental',
                },
                feature_and_display_incremental_units: {
                    label: 'F & D Incremental',
                    color: colorConstants.orangeAlt2,
                    tableLabel: 'F & D Incremental',
                },
                tpr_only_eq_volume: {
                    label: 'TPR',
                    color: colorConstants.lightGreenAlt,
                    tableLabel: 'TPR',
                },
                tpr_only_value: {
                    label: 'TPR',
                    color: colorConstants.lightGreenAlt,
                    tableLabel: 'TPR',
                },
                feature_only_eq_volume: {
                    label: 'Feature',
                    color: colorConstants.darkGreenAlt2,
                    tableLabel: 'Feature',
                },
                feature_only_value: {
                    label: 'Feature',
                    color: colorConstants.darkGreenAlt2,
                    tableLabel: 'Feature',
                },
                display_only_eq_volume: {
                    label: 'Display',
                    color: colorConstants.pinkAlt,
                    tableLabel: 'Display',
                },
                display_only_value: {
                    label: 'Display',
                    color: colorConstants.pinkAlt,
                    tableLabel: 'Display',
                },
                feature_and_display_only_eq_volume: {
                    label: 'F & D',
                    color: colorConstants.orangeAlt2,
                    tableLabel: 'F & D',
                },
                feature_and_display_only_value: {
                    label: 'F & D',
                    color: colorConstants.orangeAlt2,
                    tableLabel: 'F & D',
                },
                no_promo_eq_volume: {
                    label: 'Non Promo',
                    color: colorConstants.darkYellow,
                    tableLabel: 'Non Promo',
                },
                no_promo_value: {
                    label: 'Non Promo',
                    color: colorConstants.darkYellow,
                    tableLabel: 'Non Promo',
                },
                tpr_only_units: {
                    label: 'TPR',
                    color: colorConstants.lightGreenAlt,
                    tableLabel: 'TPR',
                },
                feature_only_units: {
                    label: 'Feature',
                    color: colorConstants.darkGreenAlt2,
                    tableLabel: 'Feature',
                },
                display_only_units: {
                    label: 'Display',
                    color: colorConstants.pinkAlt,
                    tableLabel: 'Display',
                },
                feature_and_display_only_units: {
                    label: 'F & D',
                    color: colorConstants.orangeAlt2,
                    tableLabel: 'F & D',
                },
                no_promo_units: {
                    label: 'Non Promo',
                    color: colorConstants.darkYellow,
                    tableLabel: 'Non Promo',
                },

                //for export label
                sales_year_ago: { label: 'YA Sales' },
                total_value: { label: 'Total' },
                incremental_eq_volume_percentage: {
                    label: 'Incremental Sales Percentage',
                },
                incremental_value_percentage: {
                    label: 'Incremental Sales Percentage',
                },
                incremental_units_percentage: {
                    label: 'Incremental Sales Percentage',
                },
                base_value_percentage: { label: 'Base Sales Percentage' },
                base_eq_volume_percentage: { label: 'Base Sales Percentage' },
                base_units_percentage: { label: 'Base Units Percentage' },
                any_promo_eq_volume_percentage: { label: 'Promo Percentage' },
                any_promo_value_percentage: { label: 'Promo Percentage' },
                any_promo_units_percentage: { label: 'Promo Percentage' },
                no_promo_eq_volume_percentage: {
                    label: 'Non Promo Percentage',
                },
                no_promo_units_percentage: { label: 'Non Promo Percentage' },
                no_promo_value_percentage: { label: 'Non Promo Percentage' },
            },

            tooltipExtraItems: {
                tpr_acv: { label: 'Tpr ACV %' },
                display_acv: { label: 'Display ACV %' },
                feature_acv: { label: 'Feature ACV %' },
                feature_and_display_acv: { label: 'F&D ACV %' },
                uplift: { label: 'Uplift' },
                promo_lift: { label: 'Promo Uplift' },
                media_lift: { label: 'Media Uplift' },
            },
            promoCalenderAttributeLevels: {
                promo: [
                    { value: 'product', label: 'Product' },
                    { value: 'geography', label: 'Geography' },
                ],
            },
            overlayKeys: {
                promo: [
                    { label: 'Start Week', dataKey: 'startTimestamp' },
                    { label: 'End Week', dataKey: 'endTimestamp' },
                    { label: 'Product', dataKey: 'product' },
                    { label: 'Promo Mechanics', dataKey: 'promoMech' },
                    { label: 'Promo Type', dataKey: 'promoType' },
                    { label: 'Investment', dataKey: 'field_value' },
                    // { label: 'ROI', dataKey: 'roi' },
                    // { label: 'Lift', dataKey: 'lift' },
                    // { label: 'Incremental Profit', dataKey: 'incrementalProfit' },
                    // { label: 'Incremental Retailer Profit', dataKey: 'incrementalRetailerProfit' },
                ],
            },
        },
        //PROMO SCORE CARD
        promoScoreCard: {
            mainHeader: 'Promotional Score Card',
            limit: 50,
            nestedTableLimit: 10,
            questionsNo: [1, 2, 3, 4, 5, 6, 7, 8, 9],
            question: {
                Q: [
                    'Am I getting my fair share of quality support? ',
                    'How does my % Discount compare to competition? ',
                    'What % of Volume was sold on promotion? ',
                    'How many weeks am I promoting? ',
                    'What is my average price per eq volume? ',
                    'What is my average price/units? ',
                    'What is my value share of promotions? ',
                    'What is my volume share of promotions? ',
                    'What is my brands Quality Support? ',
                ],
                unitsInItalics: [
                    '(Fair Share Index -$ Sold)',
                    '(Weighted Average % Price Reduction)',
                    '(% of Volume)',
                    '(Weighted Weeks)',
                    '(Price per bars/oz)',
                    '(Price per Unit)',
                    '(Value share %)',
                    '(EQ Volume %)',
                    '(%ACV)',
                ],
                tooltips: [
                    `This question helps you compare whether your brand has a fair share index of quality merchandising (such as displays and features) relative to total sales. \nFor example, if you hold a 5% value share in the category, do you also have 5% or more of the displays? If your share of displays is less than your fair share, the next step is to collaborate with the retailer to secure more displays in the coming year, aiming to match or exceed your fair share.`,
                    `This question helps to identify if your product promotions are balanced compared to competitors. For example, if competitors offer a 15% discount and you offer 30%, you're over-promoting, which can erode value and lead to subsidized sales. Consider reducing discounts. Conversely, if your discounts are low but competitors offer deeper discounts and you're losing market share, you might need to increase your discounts to stay competitive.`,
                    `The question helps benchmarking your promotional intensity against competitors. Having a higher share of in-store support than competitors benefit your brands.`,
                    `It helps the user understand the total number of weeks a promotion was applied during the selected year or time period. This insight helps determine if they were conducting enough promotions.`,
                    `This information helps the user understand the average price at which the product was sold during each promo event. It also helps the user identify their position at the retailer compared to their competitors`,
                    `This information helps the user understand the average price at which the product was sold during each promo event. It also helps identify their position at the retailer compared to their competitors.`,
                    `This information helps the user grasp the value share of promotions, providing insight into how effectively their promotional efforts are contributing to overall sales and market positioning.`,
                    `This information helps the user grasp the value share of promotions, providing insight into how effectively their promotional efforts are contributing to overall sales and market positioning.`,
                    `This enables business to compare the reach (%ACV) of our product vs competition product when they are on TPR vs Feature vs Display vs Feature and Display.`,
                ],
                unit: ['value', '%', '%', 'week', '$', '$', '%', '%', '%'],
                numberFormateDecimal: [0, 1, 1, 0, 2, 2, 1, 1, 0, 0],
            },
            promoTypeLabelMapping: {
                display: { label: 'Display Only' },
                tpr: { label: 'TPR Only' },
                feature: { label: 'Feature Only' },
                feature_and_display: { label: 'Feature & Display Only' },
                feature_display: { label: 'Feature & Display Only' },
            },
            showGradientTile: true,
            promoType: ['TPR Only', 'Display Only', 'Feature Only', 'Feature & Display Only'],
            promoExpandedViewTableUnit: 'volume',
            promoExpandedViewTableSalesAndVolumeLabel: ['EQ Volume', 'Total Sales $'],
            dropDown: ['Manufacturer', 'Brand_Family', 'Brand', 'Pack_Format', 'Count', 'Size'],
            listFor: ['Manufacturer', 'Category', 'Sub_Brand', 'product'],
            listForToDisplay: ['Manufacturer', 'Category', 'Sub_Brand', 'product'],
            listIn: [
                'Pack_Format',
                'Price_Segment',
                'Product_Type',
                'Product_Segment',
                'Size_Group',
                'Count',
                'Retailer',
            ],
        },

        // PROMO LANDSCAPE
        promoLandscape: {
            mainHeader: 'Investment & ROI Tracker',
            roiLabel: 'ROI',
            optimalInvestmentIndexThreshold1: 0.8,
            defaultAttributeTypeIndex: 10,
            optimalInvestmentIndexThreshold2: 1.2,
            promoTacticDropdownName: 'Investment Type',
            dimensionConfig: {
                //snake case eg sub_category
                excludedDimensions: [],
                defaultDimension: '',
            },
            thresholdColorMapping: {
                optimal: { label: 'Optimal', color: colorConstants.darkGreen },
                over: { label: 'Over', color: colorConstants.darkRed },
                under: { label: 'Under', color: colorConstants.darkBlueAlt },
            },
            limit: 60,
            promoTypes: [
                { value: 'display', label: 'Display' },
                { value: 'tpr', label: 'TPR' },
                { value: 'feature', label: 'Feature' },
                // { value: 'feature & display', label: 'Feature & Display' },  //not required for now
            ],
            mediaLevelsDropdown: [],
            optimalIndexKey: 'competition_spend_index',
            showInvestmentDropdown: false,
            tableRowsKeyMapping: [
                {
                    label: 'Investment',
                    children: null,
                    parentKey: null,
                    key: 'investments',
                    unit: '$',
                },
                {
                    label: 'ROI',
                    children: null,
                    parentKey: null,
                    key: 'roi',
                    unit: '',
                },
                {
                    label: 'Optimal Investment Index',
                    children: [
                        {
                            label: 'Share of Investment',
                            key: 'share_of_investment',
                            unit: '',
                        },
                        {
                            label: 'Share of Sales',
                            key: 'share_of_sales',
                            unit: '',
                        },
                    ],
                    unit: '',
                    parentKey: 'competition_data',
                    key: 'competition_spend_index',
                },
                {
                    label: 'Incremental Sales Dollar',
                    children: [
                        {
                            label: 'Total Sales Dollar',
                            key: 'total_sales',
                            unit: '$',
                        },
                        {
                            label: 'Base Sales Dollar',
                            key: 'base_sales_dollar',
                            unit: '$',
                        },
                        {
                            label: 'Incremental Sales Eq',
                            key: 'incremental_sales_eq',
                            unit: '',
                        },
                        {
                            label: 'Total Sales Eq',
                            key: 'total_sales_eq',
                            unit: '',
                        },
                        {
                            label: 'Base Sales Eq',
                            key: 'base_sales_eq',
                            unit: '',
                        },
                    ],
                    unit: '$',
                    parentKey: 'incremental_sales_dollar_data',
                    key: 'incremental_sales_dollar',
                },
                {
                    label: 'Incremental Profit',
                    children: [
                        {
                            label: 'Share of Profit Pool',
                            key: 'share_of_profit_pool',
                            unit: '',
                        },
                        {
                            label: 'Total Profit',
                            key: 'total_profit',
                            unit: '',
                        },
                        {
                            label: 'Baseline Profit',
                            key: 'baseline_profit',
                            unit: '',
                        },

                        {
                            label: 'Incremental Net Sales',
                            key: 'incremental_net_sales',
                            unit: '$',
                        },
                        {
                            label: 'Total Net Sales',
                            key: 'total_net_sales',
                            unit: '$',
                        },
                        {
                            label: 'Baseline Net Sales',
                            key: 'baseline_net_sales',
                            unit: '$',
                        },
                        {
                            label: 'Promo % Margin',
                            key: 'promo_percentage_margin',
                            unit: '',
                        },
                        {
                            label: 'Baseline % Margin',
                            key: 'baseline_percentage_margin',
                            unit: '',
                        },
                    ],
                    parentKey: 'incremental_profit_data',
                    key: 'incremental_profit',
                    unit: '$',
                },
                {
                    label: 'Incremental Retailer Profit',
                    unit: '$',
                    children: [
                        {
                            label: 'Share of Profit Pool',
                            key: 'share_of_profit_pool_retailer',
                            unit: '',
                        },
                        {
                            label: 'Total Retailer Profit',
                            key: 'total_retailer_profit',
                            unit: '',
                        },
                        {
                            label: 'Baseline Retailer Profit',
                            key: 'baseline_retailer_profit',
                            unit: '',
                        },
                        {
                            label: 'Retailer Promo % Margin',
                            key: 'retailer_promo_percentage_margin',
                            unit: '',
                        },
                        {
                            label: 'Retailer Baseline % Margin',
                            key: 'retailer_baseline_percentage_margin',
                            unit: '',
                        },
                    ],
                    parentKey: 'incremental_retailer_profit_data',
                    key: 'incremental_retailer_profit',
                },
            ],
        },
        //PORTFOLIO ANALYSIS
        portfolioAnalysis: {
            mainHeader: 'Promo ROI Analysis',
            limit: 20,
            defaultGroupByIndex: 18,
            defaultGroupBy2Index: 5,
            chartColors: [],
            absTileData: [
                { key: 'Promotions', label: 'Promotions' },
                { key: 'Drivers', label: 'Drivers' },
            ],
            salesAttributionChart: {
                colorList: ['#10AB5E', '#DC3826'],
                colorListType2: ['#758BEE', '#758BEE'],
                profitPoolColor: ['#826FD0', '#826FD0'],
                backGroundColor: 'rgba(0, 0, 0, 0.02)',
            },
            chartDropdownExtraKpis: [
                {
                    dimension: 'none',
                    label: 'Tactics',
                    dataKey: 'tactic_description',
                },
                {
                    dimension: 'none',
                    label: 'Mechanics',
                    dataKey: 'promotion_mechanic',
                },
                {
                    dimension: 'none',
                    label: 'Event Name',
                    dataKey: 'event_name',
                },
                {
                    dimension: 'dim1',
                    label: 'Week',
                    dataKey: 'week',
                },
            ],
            groupByHeaders: [
                {
                    label: 'Category',
                    value: 'category',
                    dimension: 'dim1',
                    isSelected: false,
                    sortKey: 'category',
                    multiSelectFilter: false,
                },

                {
                    label: 'Brand',
                    value: 'brand',
                    dimension: 'dim1',
                    isSelected: true,
                    sortKey: 'brand',
                    multiSelectFilter: false,
                },

                {
                    label: 'Product',
                    value: 'product',
                    dimension: 'dim1',
                    isSelected: true,
                    sortKey: 'product',
                    multiSelectFilter: false,
                },
                {
                    label: 'Mechanics',
                    value: 'promotion_mechanic',
                    dimension: null,
                    isSelected: false,
                    sortKey: 'promotion_mechanic',
                    multiSelectFilter: true,
                },
                {
                    label: 'Tactic',
                    value: 'tactic_description',
                    dimension: null,
                    isSelected: false,
                    sortKey: 'tactic_description',
                    multiSelectFilter: true,
                },
            ],

            chartHeaderLabelKeyMapping: {
                lift: { label: 'Lift' },
                roi: { label: 'ROI' },
                investments: { label: 'Investments' },
                incremental_net_sales: { label: 'Incremental Net Sales' },
                incremental_profit: { label: 'Incremental Profit' },
                incremental_retailer_profit: {
                    label: 'Incremental Retailer Profit',
                },
                acv: { label: 'ACV Distribution' },
                profit_pool: { label: 'Profit Pool' },
                tpr_acv: { label: 'Tpr ACV' },
                display_acv: { label: 'Display ACV' },
                feature_acv: { label: 'Feature ACV' },
                feature_and_display_acv: { label: 'F&D ACV' },
                total_acv: { label: 'Total ACV' },
                weeks: { label: 'Promo Weeks' },
            },

            promoTypesChartLegends: [
                {
                    label: 'TPR',
                    color: colorConstants.lightCyan,
                    style: {
                        borderRadius: '100%',
                        height: `8px`,
                        width: '8px',
                    },
                },
                {
                    label: 'Feature',
                    color: colorConstants.lightCream,
                    style: {
                        borderRadius: '100%',
                        height: `8px`,
                        width: '8px',
                    },
                },
                {
                    label: 'Display',
                    color: colorConstants.lightPink,
                    style: {
                        borderRadius: '100%',
                        height: `8px`,
                        width: '8px',
                    },
                },
            ],
            promoTypes: ['tpr', 'feature', 'display'],
            promoTypesLabelMapping: {
                tpr: 'TPR',
                feature: 'Feature',
                display: 'Display',
            },
        },
        promoRecommendation: {
            playbookLimit: 50,
            clientName: 'Constellation',
            hideAddSpends: false,
            mainHeader: 'Promo Recommendation',

            retailerKey: 'Retailer',
            calenderStartDay: 'Monday',
            spendLeversList: [
                {
                    label: 'Baseline Volume',
                    placeholder: 'Baseline Volume',
                    value: 'baseVolume',
                    isDisabled: false,
                },
                {
                    label: 'Uplift',
                    placeholder: 'Uplift',
                    value: 'uplift',
                    isDisabled: false,
                },
                {
                    label: 'Total Volume',
                    placeholder: 'Total Volume',
                    value: 'totalVolume',
                    isDisabled: true,
                },
                {
                    label: `Total Constellation Profit ($)`,
                    placeholder: `Total Constellation Profit`,
                    value: 'totalKindProfit',
                    isDisabled: true,
                },
                {
                    label: 'ROI',
                    placeholder: 'ROI',
                    value: 'roi',
                    isDisabled: true,
                },
                {
                    label: `Total Retailer Profit ($)`,
                    placeholder: 'Total Retailer Profit',
                    value: 'totalRetailerProfit',
                    isDisabled: true,
                },
            ],
            spendTypeList: [
                {
                    label: 'Lump Sum',
                    value: 'lump_sum',
                    inputRule: '',
                },
                {
                    label: 'Per Qty',
                    value: 'per_qty',
                    inputRule: '',
                },
                {
                    label: 'Display',
                    value: 'display',
                    inputRule: '',
                },
                {
                    label: 'Feature',
                    value: 'feature',
                    inputRule: '',
                },
            ],
            playbookKeyMapping: {
                Product: ['ppgName'],
                '%TS': ['guidelinePercentageTotalSpends', 'percentageTotalSpends', 'lesser_than', '', '%'],
                Frequency: ['guidelineFrequency', 'frequency', 'range', ''],
                ROI: ['guidelineRoi', 'roi', 'greater_than', '', ''],
            },
            // comparisonOperator: {
            //     '%TS': '<',
            //     Frequency: 'range',
            //     ROI: '>',
            // },
            menuButtons: [
                { key: 'recommendations', label: 'Recommendations' },
                {
                    key: 'summary',
                    label: 'Summary',
                },
                {
                    key: 'playbook',
                    label: 'Playbook',
                },
            ],

            promoTypeColorMapping: {
                'tpr/scan': {
                    label: 'TPR/Scan',
                    color: colorConstants.lightGreenAlt,
                },
                feature_ad: {
                    label: 'Feature Ad',
                    color: colorConstants.darkGreenAlt2,
                },
                display: { label: 'Display', color: colorConstants.pinkAlt },
                feature_display_tpr: {
                    label: 'Feature_Display_TPR',
                    color: colorConstants.orangeAlt2,
                },
                display_tpr: {
                    label: 'Display_TPR',
                    color: colorConstants.darkBlueAlt,
                },
            },
            overlayKeys: [
                {
                    label: 'Start Date',
                    dataKey: 'startDate',
                    pre: '',
                    post: '',
                },
                { label: 'Duration', dataKey: 'duration', pre: '', post: '' },
                {
                    label: 'Promo Type',
                    dataKey: 'tacticDescription',
                    pre: '',
                    post: '',
                },
                { label: 'Product(s)', dataKey: 'dim1AttributeNames', pre: '', post: '' },
                {
                    label: 'Total Volume',
                    dataKey: 'totalVolume',
                    pre: '',
                    post: '',
                    arrowConfig: 'positiveUp',
                },
                {
                    label: 'Total GSV',
                    dataKey: 'totalGsv',
                    pre: '$',
                    post: '',
                    arrowConfig: 'positiveUp',
                },
                {
                    label: 'Total NSV',
                    dataKey: 'totalNsv',
                    pre: '$',
                    post: '',
                    arrowConfig: 'positiveUp',
                },
                {
                    label: 'Total KIND Profit',
                    dataKey: 'totalKindProfit',
                    pre: '$',
                    post: '',
                    arrowConfig: 'positiveUp',
                },
                {
                    label: 'Total Retailer Profit',
                    dataKey: 'totalRetailerProfit',
                    pre: '$',
                    post: '',
                    arrowConfig: 'positiveUp',
                },
                {
                    label: 'Promo Spends',
                    dataKey: 'promoSpends',
                    pre: '$',
                    post: '',
                    arrowConfig: 'negativeUp',
                },
                {
                    label: '% Trade Spends GSV',
                    dataKey: 'percentageTradeSpendsGsv',
                    pre: '',
                    post: '%',
                    arrowConfig: 'negativeUp',
                },
                {
                    label: '% Trade Spends NSV',
                    dataKey: 'percentageTradeSpendsNsv',
                    pre: '',
                    post: '%',
                    arrowConfig: 'negativeUp',
                },

                {
                    label: 'Incremental Volume',
                    dataKey: 'incrementalVolume',
                    pre: '',
                    post: '',
                    arrowConfig: 'positiveUp',
                },
                {
                    label: 'Incremental GSV',
                    dataKey: 'incrementalGsv',
                    pre: '$',
                    post: '',
                    arrowConfig: 'positiveUp',
                },
                {
                    label: 'Incremental NSV',
                    dataKey: 'incrementalNsv',
                    pre: '$',
                    arrowConfig: 'positiveUp',
                },
                {
                    label: 'Total Profit %',
                    dataKey: 'totalProfitPercentage',
                    pre: '',
                    post: '%',
                    arrowConfig: 'positiveUp',
                },
                {
                    label: 'Incremental Profit',
                    dataKey: 'incrementalProfit',
                    pre: '$',
                    post: '',
                    arrowConfig: 'positiveUp',
                },
                {
                    label: 'Promo ROI',
                    dataKey: 'roi',
                    pre: '',
                    post: '',
                    arrowConfig: 'positiveUp',
                },
                {
                    label: 'Retailer Incremental Profit',
                    dataKey: 'retailerIncrementalProfit',
                    pre: '$',
                    post: '',
                    arrowConfig: 'positiveUp',
                },
            ],
            spendLabel: {
                lump_sum: 'Lump Sum',
                per_qty: 'Per Qty',
                display: 'Display',
                feature: 'Feature',
            },
            offerMethodList: [
                { value: 'option', label: 'List of Option', dimension: 'dim1' },
                { value: 'manual', label: 'Manual', dimension: 'dim1' },
                { value: 'previous', label: 'Previous', dimension: 'dim1' },
            ],
            addEventList: [
                { value: 'new', label: 'Add New Event' },
                { value: 'import', label: 'Import Event' },
            ],
            leverKeys: [
                'promptEventName',
                'offerMethod',
                'discount',
                'startDate',
                'duration',
                'displayAcv',
                'featureAcv',
            ],
            spendTopForm: ['baseVolume', 'uplift', 'totalVolume', 'totalKindProfit', 'roi', 'totalRetailerProfit'],
            formList: [
                {
                    value: 'duration',
                    label: 'Duration',
                    inputRule: '',
                    placeHolder: 'Enter',
                },
                {
                    value: 'displayAcv',
                    label: 'Display ACV',
                    inputRule: '',
                    placeHolder: 'Enter display ACV',
                },
                {
                    value: 'featureAcv',
                    label: 'Feature ACV',
                    inputRule: '',
                    placeHolder: 'Enter feature ACV',
                },
            ],
            offerSelectionKeys: ['promotionMechanic', 'tacticDescription'],
            spendPerQtyKey: ['per_qty', 'redemption'],
        },
        priceLadder: {
            isThresholdDropdownEnabled: true,
            hideMraup: true,
            limit: 50,
            dimensionConfig: {
                //snake case eg sub_category
                excludedDimensions: [],
                defaultDimension: 'Manufacturer',
            },
            tileData: [
                {
                    label: 'Product by Market',
                    key: 'product by market',
                },
                // {
                //     label: 'Product vs Competitors',
                //     key: 'product vs competitors',
                // },
            ],
            subTileData: [
                {
                    label: 'PU',
                    key: 'PU',
                },
                {
                    label: 'PEQ',
                    key: 'PEQ',
                },
            ],
            legendMapping: {
                PU: [
                    {
                        color: '#E6E6EA',
                        label: 'Sales $',
                        key: 'salesValueDollars',
                        dataKey: 'sales',
                        metricDataKey: 'units',
                    },
                    {
                        color: '#66AFBA',
                        label: 'Avg. Price PU',
                        key: 'avgPrice',
                        dataKey: 'avg_price_per_unit',
                        metricDataKey: 'units',
                    },
                    {
                        color: '#ECA586',
                        label: 'Max Price PU',
                        key: 'maxPrice',
                        dataKey: 'max_price_per_unit',
                        metricDataKey: 'units',
                    },
                    {
                        color: '#EB8FC5',
                        label: 'Min Price PU',
                        key: 'minPrice',
                        dataKey: 'min_price_per_unit',
                        metricDataKey: 'units',
                    },
                    {
                        color: '#F1C77A',
                        label: 'Promo Price PU',
                        key: 'promoPrice',
                        dataKey: 'promo_price_per_unit',
                        metricDataKey: 'units',
                    },
                    {
                        color: '#6771DB',
                        label: 'Base Price PU',
                        key: 'basePrice',
                        dataKey: 'base_price_per_unit',
                        metricDataKey: 'units',
                    },
                    // { color: '#5463FF', label: 'MRAUP', key: 'mraup', dataKey: 'mraup' },
                ],
                PEQ: [
                    {
                        color: '#E6E6EA',
                        label: 'Sales $',
                        key: 'salesValueDollars',
                        dataKey: '',
                        metricDataKey: 'volume',
                    },
                    {
                        color: '#66AFBA',
                        label: 'Avg. Price PEQ',
                        key: 'avgPrice',
                        dataKey: 'avg_price_per_eq',
                        metricDataKey: 'volume',
                    },
                    {
                        color: '#ECA586',
                        label: 'Max Price PEQ',
                        key: 'maxPrice',
                        dataKey: 'max_price_per_eq',
                        metricDataKey: 'volume',
                    },
                    {
                        color: '#EB8FC5',
                        label: 'Min Price PEQ',
                        key: 'minPrice',
                        dataKey: 'min_price_per_eq',
                        metricDataKey: 'volume',
                    },
                    {
                        color: '#F1C77A',
                        label: 'Promo Price PEQ',
                        key: 'promoPrice',
                        dataKey: 'promo_price_per_eq',
                        metricDataKey: 'volume',
                    },
                    {
                        color: '#6771DB',
                        label: 'Base Price PEQ',
                        key: 'basePrice',
                        dataKey: 'base_price_per_eq',
                        metricDataKey: 'volume',
                    },
                    // { color: '#5463FF', label: 'MRAUP', key: 'mraup', dataKey: 'mraup' },
                ],
            },
            dataKeyMapping: {
                PU: [
                    { label: 'Sales $', key: 'salesValueDollars' },
                    { label: 'Avg. Price PU', key: 'avgPrice' },
                    { label: 'Max Price PU', key: 'maxPrice' },
                    { label: 'Min Price PU', key: 'minPrice' },
                    { label: 'Promo Price PU', key: 'promoPrice' },
                    { label: 'Base Price PU', key: 'basePrice' },
                ],
                PEQ: [
                    { label: 'Sales $', key: 'salesValueDollars' },
                    { label: 'Avg. Price PEQ', key: 'avgPrice' },
                    { label: 'Max Price PEQ', key: 'maxPrice' },
                    { label: 'Min Price PEQ', key: 'minPrice' },
                    { label: 'Promo Price PEQ', key: 'promoPrice' },
                    { label: 'Base Price PEQ', key: 'basePrice' },
                ],
            },
            tableColumnLabelKeyMapping: {
                sales: { label: 'Sales $' },
                sales_percentage: { label: 'Sales %' },
                avg_price_pu: { label: 'Average Price $ PU' },
                avg_price_peq: { label: 'Average Price $ PEQ' },
                max_price_pu: { label: 'Max Price $ PU' },
                max_price_peq: { label: 'Max Price $ PEQ' },
                min_price_pu: { label: 'Min Price $ PU' },
                min_price_peq: { label: 'Min Price $ PEQ' },
                // mraup: { label: 'MRAUP' },
                base_price_pu: { label: 'Base Price $ PU' },
                base_price_peq: { label: 'Base Price $ PEQ' },
                promo_price_pu: { label: 'Promo Price $ PU' },
                promo_price_peq: { label: 'Promo Price $ PEQ' },
            },
            dropdown2Filter: ['Category', 'Product_Segment', 'Channel', 'Retailer'],
        },
        opportunityIdentification: {
            reversePpeAxis: false,
            bubbleCategoryOptions: [
                { value: 'brand', label: 'Brand', dimension: 'dim1' },
                { value: 'sub_brand', label: 'Sub Brand', dimension: 'dim1' },
                { value: 'category', label: 'Category', dimension: 'dim1' },
                {
                    value: 'sub_category',
                    label: 'Sub Category',
                    dimension: 'dim1',
                },
                {
                    value: 'manufacturer',
                    label: 'Manufacturer',
                    dimension: 'dim1',
                },
            ],
            kpis: {
                xaxis: [
                    { label: 'BPE', value: 'bpe' },
                    { label: '% RSV Growth', value: 'rsv_growth' },
                    { label: 'MAC %', value: 'mac_percentage' },
                ],
                yaxis: [
                    { label: 'PPE', value: 'ppe' },
                    { label: '% RSV Growth', value: 'rsv_growth' },
                    { label: 'MAC %', value: 'mac_percentage' },
                ],
                bubbleSize: [
                    { label: 'Eq Volume', value: 'total_volume' },
                    { label: 'BPE', value: 'bpe' },
                    { label: 'PPE', value: 'ppe' },
                    { label: 'MAC', value: 'mac' },
                    { label: 'MAC %', value: 'mac_percentage' },
                    { label: 'RSV', value: 'rsv' },
                    { label: '% RSV Growth', value: 'rsv_growth' },
                ],
            },
            elasticityDriver: {
                chart2Limit: 100,
                levels: [
                    { label: 'Product', value: 'product', dimension: 'dim1' },
                    { label: 'Manufacturer', value: 'manufacturer', dimension: 'dim1' },
                    { label: 'Brand', value: 'brand', dimension: 'dim1' },
                    { label: 'Category', value: 'category', dimension: 'dim1' },
                    { label: 'Price Segment', value: 'price_segment', dimension: 'dim1' },
                    { label: 'Geography', value: 'geography', dimension: 'dim2' },
                ],
                limit: 50,
                offset: 0,
                dimension: 'dim1',
                legendMapping: [
                    {
                        dataKey: 'own',
                        label: 'Own Elasticity',
                        color: '#69D4E8',
                    },
                    {
                        dataKey: 'internal',
                        label: 'Internal Competitor Elasticity',
                        color: '#E469B2',
                    },
                    {
                        dataKey: 'external',
                        label: 'External Competitor Elasticity',
                        color: '#EDB44E',
                    },
                ],
            },
        },
        priceCurve: {
            chart1Limit: 100,
            xAxisKeyValue: [
                { value: 'count', label: 'Count' },
                { value: 'size', label: 'Size' },
            ],
            YAxisKeyValue: [
                { value: 'retail_price', label: 'Retail Price' },
                { value: 'base_price', label: 'Base Price' },
                { value: 'list_price', label: 'List Price' },
            ],
            levels: [
                { value: 'category', label: 'Category' },
                { value: 'manufacturer', label: 'Manufacturer' },
                { value: 'brand', label: 'Brand' },
                { value: 'pack_format', label: 'Pack Format' },
                { value: 'price_segment', label: 'Price Segment' },
                { value: 'product_type', label: 'Product Type' },
                { value: 'product_segment', label: 'Product Segment' },
                { value: 'product', label: 'Product' },
            ],
            subTileData: [
                {
                    label: 'PU',
                    key: 'PU',
                    dataKey: 'per_unit',
                },
                {
                    label: 'PEQ',
                    key: 'PEQ',
                    dataKey: 'per_eq',
                },
            ],
            chartColors: [
                '#E8A122',
                '#293BB8',
                '#E06936',
                '#19669D',
                '#A5582D',
                '#43C9E2',
                '#DD449F',
                '#37C7BE',
                '#9E5897',
                '#00798C',
                '#EDB44E',
                '#4557D5',
                '#E6875E',
                '#228BD6',
                '#CC7442',
                '#69D4E8',
                '#E469B2',
                '#5FD3CB',
                '#B377AD',
                '#3394A3',
                '#F1C77A',
                '#7381E0',
                '#ECA586',
                '#55A8E4',
                '#D89672',
                '#8EDFEE',
                '#EB8FC5',
                '#87DED8',
                '#C699C2',
                '#66AFBA',
                '#F6D9A7',
                '#A2ABEA',
                '#F3C3AF',
                '#8EC5ED',
                '#E5B9A1',
                '#B4E9F3',
                '#F1B4D9',
                '#AFE9E5',
                '#D9BBD6',
                '#99C9D1',
                '#FAECD3',
                '#D0D5F5',
                '#F9E1D7',
                '#C6E2F6',
                '#F2DCD0',
                '#D9F4F9',
                '#F8DAEC',
                '#D7F4F2',
                '#ECDDEB',
                '#CCE4E8',
            ],
            tableHeaders: [
                { label: 'List Price $', key: 'list_price' },
                { label: 'List Price $ YA', key: 'list_price_ya' },
                { label: 'Retail Price $', key: 'retail_price' },
                { label: 'Retail Price $ YA', key: 'retail_price_ya' },
                { label: 'Base Price $', key: 'base_price' },
                { label: 'Base Price $ YA', key: 'base_price_ya' },
            ],
        },
        pricePoint: {
            priceRange: [0, 10],
            graphColorScheme: ['#D7D6D9', '#66AFBA', '#ECA586', '#F1C77A', '#EB8FC5'],
            hideMraup: true,
            limit: 500,
            dimensionConfig: {
                //snake case eg sub_category
                excludedDimensions: [],
                defaultDimension: 'Manufacturer',
            },
            contributionThreshold: 5,
            priceTypeOptions: [
                { label: 'Avg Price', value: 'avg_price' },
                { label: 'Base Price', value: 'base_price' },
            ],
            subTileData: [
                {
                    label: 'PU',
                    key: 'per_unit',
                    xAxisLabel: 'Price Per Unit',
                    tooltip: 'Per Unit',
                },
                {
                    label: 'PEQ',
                    key: 'per_volume',
                    xAxisLabel: 'Price Per Eq',
                    tooltip: 'Per Eq Volume',
                },
            ],
            yAxisDropdownData: [
                {
                    label: 'Dollars',
                    value: 'value',
                },
                {
                    label: 'Volume',
                    value: 'volume',
                },
                {
                    label: 'Units',
                    value: 'units',
                },
            ],
            tableHeaderKeyMapping: {
                growth_percentage: ['Growth % vs YA', '', '%'],
                total_sales: ['Total Value ($)', '$', ''],
                total_volume: ['Total Volume', '', ''],
                total_units: ['Total Units', '', ''],
                avg_price_per_unit: ['Avg. Price per Unit', '$', ''],
                avg_price_per_eq: ['Avg. Price per EQ', '$', ''],
                base_price_per_unit: ['Base Price per Unit', '$', ''],
                base_price_per_eq: ['Base Price per EQ', '$', ''],
            },
            drilldownTableHeaderKeyMapping: {
                growth_abs: ['Growth Abs', '$', ''],
                growth_percentage: ['Growth %', '', '%'],
                contribution_to_category: ['Contribution to category', '$', ''],
                cy_share: ['CY share', '', '%'],
                ya_share: ['YA share', '', '%'],
                change: ['Change %', '', '%'],
            },
            dropdown2Filter: ['Category', 'Product_Segment', 'Channel', 'Retailer'],
            customThresholdData: [
                {
                    id: 1,
                    value: '',
                },
                {
                    id: 2,
                    value: '',
                },
                {
                    id: 3,
                    value: '',
                },
                {
                    id: 4,
                    value: '',
                },
                {
                    id: 5,
                    value: '',
                },
            ],
        },
        priceTracking: {
            limit: 20,
            dimensionConfig: {
                //snake case eg sub_category
                excludedDimensions: [
                    'brand_family',
                    'pack_format',
                    'price_segment',
                    'product_type',
                    'product_segment',
                    'count',
                    'size',
                ],
                defaultRowDimension: 'Manufacturer',
                defaultColumnDimension: 'Geography',
            },
            attributeNamesLimit: 50,
            frequency: 'W',
            timePeriodOptions: [
                { label: 'YA', value: 'year_ago' },
                { label: 'Prior Period', value: 'prior_period' },
                { label: 'Custom Period', value: 'custom' },
            ],
            priceTypeOptions: [
                { label: 'Base Price', value: 'base' },
                { label: 'Avg Price', value: 'average' },
            ],
            kpiOptions: [
                { label: '% Change', value: 'percent_change' },
                { label: 'Price Index', value: 'index' },
            ],
            subTileData: [
                {
                    label: 'PU',
                    key: 'units',
                    xAxisLabel: 'Price Per Unit',
                    tooltip: 'Per Unit',
                },
                {
                    label: 'PEQ',
                    key: 'volume',
                    xAxisLabel: 'Price Per Eq',
                    tooltip: 'Per Eq Volume',
                },
            ],
            weeksOptions: [
                { label: 'L W1', value: 1 },
                { label: 'L W4', value: 4 },
                { label: 'L W12', value: 12 },
            ],
            monthsOptions: [
                { label: 'L M1', value: 1 },
                { label: 'L M3', value: 3 },
                { label: 'L M6', value: 6 },
                { label: 'L M12', value: 12 },
            ],
            quartersOptions: [
                { label: 'L Q1', value: 1 },
                { label: 'L Q2', value: 2 },
                { label: 'L Q4', value: 4 },
            ],
            kpiMapping: {
                'Base Price': ['$', ''],
                'Base Price YA': ['$', ''],
                'Avg Price': ['$', ''],
                'Avg Price YA': ['$', ''],
                'Base Price Index % Chg': ['', '%'],
                'Base Price % Chg': ['', '%'],
                'Avg Price Index % Chg': ['', '%'],
                'Avg Price % Chg': ['', '%'],
                'TDP % Chg': ['', '%'],
                TDP: ['', ''],
                'TDP YA': ['', ''],
                'Volume Velocity % Chg': ['', '%'],
                'Volume Velocity': ['', ''],
                'Volume Velocity YA': ['', ''],
            },
        },
        bestWeeks: {
            limit: 50,
            drilldownTableConfig: [{ label: 'Period No', key: 'period_no', sorting: false }],
            dimensionConfig: {
                //snake case eg sub_category
                excludedDimensions: ['dim2'],
                defaultDimension: 'Brand',
            },
            rankingCriteriaOptions: [
                { label: 'Base Volume', value: 'base_eq_volume' },
                { label: 'ACV', value: 'total_per_acv_dist' },
                { label: 'Incremental Volume', value: 'incremental_eq_volume' },
                { label: 'Total Volume', value: 'total_eq_volume' },
                { label: 'Uplift', value: 'uplift' },
            ],
        },
        profitPool: {
            defaultCurrencySymbol: '$',
            defaultAttributeForData: {
                attributeType: 'Brand',
                dimension: 'dim1',
                isAttribute: true,
                dataset: [],
                key: 'Brand',
                dataKey: 'Brand',
            },
            growthKpisTierMapping: {
                tier1: [
                    'volume_sales_equivalent',
                    'gross_sales',
                    'total_trade',
                    'net_sales',
                    'cogs',
                    'profit_absolute',
                    'profit_percent',
                ],
                tier2: ['volume_sales_equivalent', 'profit_absolute', 'profit_percent'],
                tier3: ['volume_sales_equivalent', 'profit_absolute', 'profit_percent'],
            },
            ppOverviewDropDownOptions: [
                { label: 'Absolute $', key: 'profit_absolute' },
                { label: '$ per eqv', key: 'profit_equivalent' },
                { label: '$ per unit', key: 'profit_unit' },
            ],
            ppGrowthDropDownOptions: [
                { label: 'Absolute $', key: 'profit_growth_absolute' },
                { label: '$ per eqv', key: 'profit_growth_equivalent' },
                { label: '$ per unit', key: 'profit_growth_unit' },
            ],
            tiersColorMap: {
                tier1: '#8EDFEE',
                tier2: '#4557D5',
                tier3: '#9BDE91',
                'tier1(YA)': '#E8EAFA',
                'tier2(YA)': '#D0D5F5',
                'tier3(YA)': '#A2ABEA',
            },
            tiersColorMapPPOverview: {
                tier1: '#9BDE91',
                tier2: '#8EDFEE',
                tier3: '#4557D5',
                'tier1(YA)': '#E8EAFA',
                'tier2(YA)': '#D0D5F5',
                'tier3(YA)': '#A2ABEA',
            },
            marginPercentChartColors: ['#9BDE91', '#8EDFEE', '#4557D5'],
            defaultTierFilterSelections: {
                multiSelect: ['tier1', 'tier2'],
                singleSelect: ['tier1'],
            },
            kpiLabelMappingForPPGBreakdown: {
                volume_sales_equivalent: 'Depletion Volume',
                total_trade: 'Total Trade',
                net_sales: '_tier_ Net Sales $',
                gross_sales: 'FOB Amount',
                cogs: '_tier_ COGS',
                profit_absolute: '_tier_ Profit',
                profit_percent: '_tier_ Profit %',
            },
            kpiLabelMapping: {
                profit: 'GP',
                volume_sales_equivalent: 'Depletion Volume',
            },
            defaultEvolutionFrequency: 'M',
            frequencyList: [
                {
                    key: 'M',
                    label: 'Monthly',
                },
                {
                    key: 'Q',
                    label: 'Quarterly',
                },
                {
                    key: 'Y',
                    label: 'Yearly',
                },
            ],
            kpiEvolutionDropDownOptions: [
                { label: 'Promo Rate PHY', key: 'promo_rate_phy', unitLabel: '$' },
                { label: 'Promo Rate EQV', key: 'promo_rate_eqv', unitLabel: '$' },
                { label: 'NPTR PHY', key: 'nptr_phy', unitLabel: '$' },
                { label: 'NPTR EQV', key: 'nptr_eqv', unitLabel: '$' },
                { label: 'COGS per PHY', key: 'cogs_per_unit', unitLabel: '$' },
                { label: 'COGS Rate EQV', key: 'cogs_rate_eqv', unitLabel: '$' },
                { label: 'FOB Rate PHY', key: 'fob_rate_phy', unitLabel: '$' },
                { label: 'FOB Rate EQV', key: 'fob_rate_eqv', unitLabel: '$' },
                { label: 'Purchase Allowance', key: 'purchase_allowance', unitLabel: '$' },
            ],
            singleSelectTierEnabledRoutes: ['growth-margin-driver', 'growth-margin-bridges'],
            growthMarginDriversDropDownOptionsMapping: {
                tier1: [
                    { label: 'Profit', key: 'profit_absolute' },
                    { label: 'Net Sales', key: 'net_sales' },
                ],
                tier2: [{ label: 'Profit', key: 'profit_absolute' }],
            },
            defaultStrategicOpportunitySelection: {
                xaxis: { tier: ['tier1'], kpi: 'profit_absolute', label: 'CBBD Profit' },
                yaxis: { tier: ['tier2'], kpi: 'profit_absolute', label: 'Distributor Profit' },
                bubbleSize: { tier: [], kpi: 'volume_sales_equivalent', label: 'Depletion Volume' },
                label: 'CBBD Profit vs Distributor Profit',
            },
            defaultStrategicOpportunityOptions: [
                {
                    label: 'CBBD Profit vs Distributor Profit',
                    xaxis: { tier: ['tier1'], kpi: 'profit_absolute', label: 'CBBD Profit' },
                    yaxis: { tier: ['tier2'], kpi: 'profit_absolute', label: 'Distributor Profit' },
                    bubbleSize: { tier: [], kpi: 'volume_sales_equivalent', label: 'Depletion Volume' },
                },
                // {
                //     label: 'CBI Profit Growth vs Dist Profit Growth',
                //     xaxis: { tier: ['tier1'], kpi: 'profit_growth_absolute', label: 'CBI Profit Growth' },
                //     yaxis: { tier: ['tier2'], kpi: 'profit_growth_absolute', label: 'Dist Profit Growth' },
                //     bubbleSize: { tier: [], kpi: 'volume_sales_equivalent', label: 'Depletion Volume' },
                // },
                // {
                //     label: 'Distributor Profit vs CBI Net Sale Growth',
                //     xaxis: { tier: ['tier2'], kpi: 'profit_absolute', label: 'Distributor Profit' },
                //     yaxis: { tier: ['tier1'], kpi: 'net_sales', label: 'CBI Net Sale Growth' },
                //     bubbleSize: { tier: [], kpi: 'volume_sales_equivalent', label: 'Depletion Volume' },
                // },
            ],
            customStrategicOpportunityXaxisOptions: [
                { tier: ['tier1'], kpi: 'profit_percent', label: 'CBBD Profit %', key: 'cbi_profit_percent' },
                { tier: ['tier2'], kpi: 'profit_percent', label: 'Distributor Profit %', key: 'dist_profit_percent' },
                { tier: ['tier1'], kpi: 'profit_absolute', label: 'CBBD Profit', key: 'cbi_profit' },
                { tier: ['tier2'], kpi: 'profit_absolute', label: 'Distributor Profit', key: 'dist_profit' },
                { tier: ['tier1'], kpi: 'net_sales', label: 'CBBD Net Sales', key: 'cbi_net_sale' },
                { tier: ['tier1'], kpi: 'cogs', label: 'CBBD COGS', key: 'cbi_cogs' },
                { tier: ['tier1'], kpi: 'total_trade', label: 'CBBD Total Trade', key: 'cbi_total_trade' },
            ],
            customStrategicOpportunityYaxisOptions: [
                { tier: ['tier1'], kpi: 'profit_percent', label: 'CBBD Profit %', key: 'cbi_profit_percent' },
                { tier: ['tier2'], kpi: 'profit_percent', label: 'Distributor Profit %', key: 'dist_profit_percent' },
                { tier: ['tier1'], kpi: 'profit_absolute', label: 'CBBD Profit', key: 'cbi_profit' },
                { tier: ['tier2'], kpi: 'profit_absolute', label: 'Distributor Profit', key: 'dist_profit' },
                { tier: ['tier1'], kpi: 'net_sales', label: 'CBBD Net Sales', key: 'cbi_net_sale' },
                { tier: ['tier1'], kpi: 'cogs', label: 'CBBD COGS', key: 'cbi_cogs' },
                { tier: ['tier1'], kpi: 'total_trade', label: 'CBBD Total Trade', key: 'cbi_total_trade' },
            ],
            defaultAttributeForStrategicOpportunityData: {
                attributeType: 'product',
                dimension: 'dim1',
                isAttribute: false,
                dataset: [],
                key: 'product',
                dataKey: 'product',
            },
            defaultAttributeForStrategicOpportunityColoredByData: {
                attributeType: 'Pack_Count',
                dimension: 'dim1',
                isAttribute: true,
                dataset: [],
                key: 'Pack_Count',
                dataKey: 'Pack_Count',
            },
            strategicOpportunityMetricConfig: {
                'CBBD Profit vs Distributor Profit': {
                    abs: {
                        x: 'profit_absolute',
                        y: 'profit_absolute',
                    },
                    percent: {
                        x: 'margin_percent',
                        y: 'margin_percent',
                    },
                },
            },
            growthBridgesKpiLabelMapping: {
                fob_eqv: 'FOB (EQV)',
                price_promotions_eqv: 'Price Promotions (EQV)',
                purchase_allowance: 'Purchase Allowance',
                fet: 'FET',
                cogs_eqv: 'COGS (EQV)',
                portfolio_changes: 'Portfolio changes',
                mix_impact: 'Mix impact',
                volume_impact: 'Volume impact',
            },
        },
    },
    demo: {
        //COMMON CONFIG
        commonConfig: {
            clientName: 'Demo',
            handleDim2SortingFromFrontend: false,
            dateFormat: 'MM/DD/YYYY',
            dateFormatAlt: 'MM/DD/YY',
            calenderStartDay: 'Sunday',
            showSecondaryLogo: false,
            showLogoInNavbar: true,
            logoHeight: '32px',
            logoWidth: '125px',
            loginPageTextPart1: 'Welcome to',
            loginPageTextPart2: 'Pricing and Promo',
            width: window.innerWidth,
            limit: 10,
            offset: 0,
            lagList: [0, 1],
            graphFontSize: calculateFontSize(window.innerWidth, 13),
            graphFontSizeAlt: calculateFontSize(window.innerWidth, 13),
            graphFontFamily: "'Helvetica Neue', sans-serif",
            graphLabelColorAlt: '#4E4C55',
            graphLabelColor: '#433C4A',
            units: {
                currency: '$',
                volume: 'Eq Vol',
                currencyText: 'Dollar',
            },
            filterFormat: { dim1: { ids: [] }, dim2: { ids: [] } },
            frequency: 'W',
            showCampignCalender: false,
            showFullLabel: true,
            decimalForPercentage: 1,
            decimalForNonPercentage: 2,
        },
        latestDateForDifferentRoutes: {
            'promo-score-card': 'Promotion Data',
            'roi-analysis': 'Promotion Data',
            'roi-tracker': 'Promotion Data',
            'promo-recommendation': 'Promotion Data',
            default: 'POS Data',
        },
        screenDetailsWithRoutes: [
            {
                label: 'Growth Analysis',
                path: 'promo/category-diagnostics/growth-analysis',
                id: 'ga',
                pageId: 'ga',
            },
            {
                label: 'Bump Report',
                path: 'promo/category-diagnostics/bump-report',
                id: 'br',
                pageId: 'br',
            },
            {
                label: 'Price Change',
                path: 'pricing/analytics/price-change',
                id: 'pcn',
                pageId: 'pcn',
            },
            {
                label: 'Price Point',
                path: 'pricing/analytics/price-point',
                id: 'pp',
                pageId: 'pp',
            },
            {
                label: 'Price Ladder',
                path: 'pricing/analytics/price-ladder',
                id: 'pld',
                pageId: 'pld',
            },
            {
                label: 'Price Curve',
                path: 'pricing/analytics/price-curve',
                id: 'pc',
                pageId: 'pc',
            },
            {
                label: 'Price Tracking',
                path: 'pricing/analytics/price-tracking',
                id: 'pt',
                pageId: 'pt',
            },
            {
                label: 'Opportunity Identification',
                path: 'pricing/analytics/opportunity-identification',
                id: 'oi',
                pageId: 'oi',
            },
            {
                label: 'Promo Scorecard',
                path: 'promo/analytics/promo-score-card',
                id: 'ps',
                pageId: 'ps',
            },
            {
                label: 'Investment & ROI Tracker',
                path: 'promo/analytics/roi-tracker',
                id: 'pl',
                pageId: 'pl',
            },
            {
                label: 'Promo ROI Analysis',
                path: 'promo/analytics/roi-analysis',
                id: 'pa',
                pageId: 'pa',
            },
            {
                label: 'Promo Recommendation',
                path: 'promo/recommendation/promo-recommendation',
                id: 'pr',
                pageId: 'pr',
            },
            {
                label: 'Pricing Simulator',
                path: 'pricing/recommendation/price-simulator',
                id: 'psr',
                pageId: 'psr',
            },
            {
                label: 'Pricing Simulator',
                path: 'pricing/recommendation/price-simulator/new',
                id: 'psr',
                pageId: 'psrNew',
            },
            {
                label: 'Pricing Simulator',
                path: 'pricing/recommendation/price-simulator/edit/:id',
                id: 'psr',
                pageId: 'psrEdit',
            },
            {
                label: 'Pricing Simulator',
                path: 'pricing/recommendation/price-simulator/view/:id',
                id: 'psr',
                pageId: 'psrView',
            },
        ],
        screens: [
            {
                label: 'Category Diagnostics',
                path: ['promo/category-diagnostics'],
                showSubHeader: false,
                options: {
                    Promo: [
                        {
                            label: 'Growth Analysis',
                            path: 'growth-analysis',
                            id: 'ga',
                        },
                        { label: 'Bump Report', path: 'bump-report', id: 'br' },
                    ],
                    visible: false,
                },
            },
            {
                label: 'Pricing Analytics',
                path: ['pricing/analytics', null],
                showSubHeader: false,
                options: {
                    Promo: [
                        {
                            label: 'Price Change',
                            path: 'price-change',
                            id: 'pcn',
                        },
                        { label: 'Price Point', path: 'price-point', id: 'pp' },
                        {
                            label: 'Price Ladder',
                            path: 'price-ladder',
                            id: 'pld',
                        },
                        { label: 'Price Curve', path: 'price-curve', id: 'pc' },
                        {
                            label: 'Price Tracking',
                            path: 'price-tracking',
                            id: 'pt',
                        },
                        {
                            label: 'Opportunity Identification',
                            path: 'opportunity-identification',
                            id: 'oi',
                        },
                    ],
                    visible: false,
                },
            },
            {
                label: 'Promo Analytics',
                path: ['promo/analytics', null],
                showSubHeader: false,
                options: {
                    Promo: [
                        {
                            label: 'Promo Scorecard',
                            path: 'promo-score-card',
                            id: 'ps',
                        },
                        {
                            label: 'Investment & ROI Tracker',
                            path: 'roi-tracker',
                            id: 'pl',
                        },
                        {
                            label: 'Promo ROI Analysis',
                            path: 'roi-analysis',
                            id: 'pa',
                        },
                    ],
                    visible: false,
                },
            },
            {
                label: 'Price & Promo Modeling',
                path: ['promo/recommendation', 'pricing/recommendation'],
                showSubHeader: true,
                options: {
                    Promo: [
                        {
                            label: 'Promo Recommendation',
                            path: 'promo-recommendation',
                            id: 'pr',
                        },
                    ],
                    Pricing: [
                        {
                            label: 'Pricing Simulator',
                            path: 'price-simulator',
                            id: 'psr',
                        },
                    ],
                    visible: false,
                },
            },
        ],
        globalFilter: {
            presetConfig: {
                disablePresetFilter: false,
                presetEnabledRoutes: {
                    all: true,
                },
            },
            availableFrequenciesList: [{ key: 'W', label: 'Week' }],
            globalFilterChangingRoutes: {},
            limit: 50,
            numberOfDimensions: 2, // dim1, dim2
            selectionAllowed: {
                'promo-recommendation': {
                    dim2: {
                        Retailer: 1,
                    },
                },
            },
            allSelectedLimit: 15,
            timePeriodScreenMapping: {
                default: ['4W', '12W', '26W', '52W', '1M', '3M', '6M', '12M', '1Q', '2Q', '4Q', 'YTD', 'CUSTOM DATE'],
                'bump-report': ['52W', '104W', '156W', '1M', '3M', '6M', '12M', '1Q', '2Q', '4Q', 'YTD', 'CUSTOM DATE'],
            },

            defaultPeriod: ['52W'],
            applyFilterApiPostFormat: {
                jsonstring_dim1: '{}',
                jsonstring_dim2: '{}',
            },
            defaultPreviousIdObject: {
                dim1: ['attr', 'attr'],
                dim2: ['attr', 'attr'],
            },
            defaultIdObject: {
                dim1: { ids: [] },
                dim2: { ids: [] },
            },
            defaultAttrIdObject: {
                attr: {
                    dim1: { ids: [] },
                    dim2: { ids: [] },
                },
            },

            promoScoreCardDefault: {
                Category: 'TOTAL BARS',
                Retailer: 'Kroger_Roundys',
            },
            retainFiltersAcrossFeatures: false,
            PromoScoreCardDefaultObj: {
                dim1: {
                    Category: {
                        inclusion: [
                            {
                                dimension: 'dim1',
                                isActive: true,
                                attributeType: 'Category',
                                attributeDesc: 'TOTAL BARS',
                                attributeExId: 'TOTAL BARS',
                            },
                        ],
                    },
                },
                dim2: {
                    Retailer: {
                        inclusion: [
                            {
                                dimension: 'dim2',
                                isActive: true,
                                attributeType: 'Retailer',
                                attributeDesc: 'Kroger_Roundys',
                                attributeExId: 'Kroger_Roundys',
                            },
                        ],
                    },
                },
            },
        },
        priceSimulator: {
            dataSources: [
                { label: 'Projected Consumption', value: 'iri' },
                { label: 'Consumption Actuals', value: 'l52_weeks' },
                { label: 'Financials', value: 'financials' },
            ],
            allScenariosTableLimit: 500,
            a: 10,
            opportunityIdentificationTiles: [
                { key: 'recommendation', label: 'Recommendation' },
                { key: 'input', label: 'Input' },
                { key: 'output', label: 'Output' },
            ],
            cascadingColumns: ['COGS Rate', 'List Price', 'Everyday Retail Price'], // this should match with input key mapping and price simulator input columns
            levels: ['product', 'retailer'],
            inputKeyMapping: {
                // keep the order accuretly, to get it in multiselect
                cogs: 'COGS Rate',
                lp: 'List Price',
                rp: 'Everyday Retail Price',
                acv: 'ACV Distribution',
                oi: 'OI Rate',
                non_oi: 'Non OI Rate',
                promo_trade_spends: 'Promo Trade Rate Spends',
                tr: 'Trade Rate',
                cf: 'Comp Follow',
            },
            outputKeyMapping: {
                volume: {
                    label: 'New Volume',
                    pre: '',
                    pos: '',
                },
                volume_old: {
                    label: 'Current Volume',
                    pre: '',
                    pos: '',
                },
                vlmChg: {
                    label: 'Volume Chg %',
                    pre: '',
                    pos: '%',
                },
                units: {
                    label: 'New Units',
                    pre: '',
                    pos: '',
                },
                units_old: {
                    label: 'Current Units',
                    pre: '',
                    pos: '',
                },
                unitsChg: {
                    label: 'Units Chg %',
                    pre: '',
                    pos: '%',
                },
                rsv: {
                    label: 'New RSV',
                    pre: '$',
                    pos: '',
                },
                rsv_old: {
                    label: 'Current RSV',
                    pre: '$',
                    pos: '',
                },
                rsvChg: {
                    label: 'RSV Chg %',
                    pre: '',
                    pos: '%',
                },
                gsv: {
                    label: 'New GSV',
                    pre: '$',
                    pos: '',
                },
                gsv_old: {
                    label: 'Current GSV',
                    pre: '$',
                    pos: '',
                },
                gsvChg: {
                    label: 'GSV Chg %',
                    pre: '',
                    pos: '%',
                },
                nsv: {
                    label: 'New NSV',
                    pre: '$',
                    pos: '',
                },
                nsv_old: {
                    label: 'Current NSV',
                    pre: '$',
                    pos: '',
                },
                nsvChg: {
                    label: 'NSV Chg %',
                    pre: '',
                    pos: '%',
                },
                gmac: {
                    label: 'New GMAC',
                    pre: '$',
                    pos: '',
                },
                gmac_old: {
                    label: 'Current GMAC',
                    pre: '$',
                    pos: '',
                },
                gmacChg: {
                    label: 'GMAC Chg %',
                    pre: '',
                    pos: '%',
                },
                rtMg: {
                    label: 'New Retail Margin %',
                    pre: '',
                    pos: '%',
                },
                rtMg_old: {
                    label: 'Current Retail Margin %',
                    pre: '',
                    pos: '%',
                },
                rtMgPcChg: {
                    label: 'Retail Margin Chg %',
                    pre: '',
                    pos: '%',
                },
                retailer_profit: {
                    label: 'New Retail Profit',
                    pre: '',
                    pos: '',
                },
                retailer_profit_old: {
                    label: 'Current Retail Profit',
                    pre: '',
                    pos: '',
                },
                rtPfChg: {
                    label: 'Retail Profit Chg %',
                    pre: '',
                    pos: '%',
                },
                netRpChg: {
                    label: 'Net Effective Price % Chg',
                    pre: '',
                    pos: '%',
                },
                mgPc: {
                    label: 'New Margin %',
                    pre: '',
                    pos: '%',
                },
                mgPc_old: {
                    label: 'Current Margin %',
                    pre: '',
                    pos: '%',
                },
                mgPcChg: {
                    label: 'Margin Chg %',
                    pre: '',
                    pos: '%',
                },
                profitPool: {
                    label: 'New Profit Pool',
                    pre: '',
                    pos: '%',
                },
                profitPool_old: {
                    label: 'Current Profit Pool',
                    pre: '',
                    pos: '%',
                },
                profitPoolChg: {
                    label: 'Profit Pool Chg %',
                    pre: '',
                    pos: '$',
                },
                oi_cp: {
                    label: 'Current OI Rate',
                    pre: '',
                    pos: '%',
                },
                oi_np: {
                    label: 'New OI Rate',
                    pre: '',
                    pos: '',
                },
                oi_pc: {
                    label: 'OI Rate Chg %',
                    pre: '',
                    pos: '%',
                },
                non_oi_cp: {
                    label: 'Current Non OI Rate',
                    pre: '',
                    pos: '',
                },
                non_oi_np: {
                    label: 'New Non OI Rate',
                    pre: '',
                    pos: '',
                },
                non_oi_pc: {
                    label: 'Non OI Rate Chg %',
                    pre: '',
                    pos: '%',
                },
                promo_trade_spends_cp: {
                    label: 'Current Promo Trade Rate Spends',
                    pre: '',
                    pos: '',
                },
                promo_trade_spends_np: {
                    label: 'Current Promo Trade Rate Spends',
                    pre: '',
                    pos: '',
                },
                promo_trade_spends_pc: {
                    label: 'Promo Trade Rate Spends Chg %',
                    pre: '',
                    pos: '%',
                },
                tr_cp: {
                    label: 'Current Trade Rate',
                    pre: '',
                    pos: '',
                },
                tr_np: {
                    label: 'New Trade Rate',
                    pre: '',
                    pos: '',
                },
                tr_pc: {
                    label: 'Trade Rate Chg %',
                    pre: '',
                    pos: '%',
                },
            },
            recommendationKeyMapping: {
                recommended_list_price: {
                    label: 'New list price recom',
                    pre: '$',
                    pos: '',
                },
                role: {
                    label: 'Role',
                    pre: '',
                    pos: '',
                },
                strategy: {
                    label: 'Strategy',
                    pre: '',
                    pos: '',
                },
                mix: {
                    label: 'Mix',
                    pre: '',
                    pos: '',
                },
                growth: {
                    label: 'Growth',
                    pre: '',
                    pos: '',
                },
                gap: {
                    label: 'Gap',
                    pre: '',
                    pos: '',
                },

                cogs: {
                    label: 'COGs',
                    pre: '',
                    pos: '%',
                },
                list_to_retail: {
                    label: 'List to Retail',
                    pre: '',
                    pos: '',
                },
                bpe: {
                    label: 'BPE',
                    pre: '',
                    pos: '',
                },
                ppe: {
                    label: 'PPE',
                    pre: '',
                    pos: '',
                },
                margin: {
                    label: 'Margin',
                    pre: '',
                    pos: '%',
                },
                growth_vs_category: {
                    label: 'Gowth vs Category',
                    pre: '',
                    pos: '%',
                },
                pl_vs_category: {
                    label: 'PL vs Category',
                    pre: '',
                    pos: '%',
                },
                threshold: {
                    label: 'Threshold',
                    pre: '',
                    pos: '',
                },
                comp_index: {
                    label: 'Comp. Index',
                    pre: '',
                    pos: '',
                },
                curve_index: {
                    label: 'Curve Index',
                    pre: '',
                    pos: '',
                },
                cogs_realization: {
                    label: 'COGS & Realization',
                    pre: '',
                    pos: '',
                },
                cogs_forecast: {
                    label: 'COGS Forecast',
                    pre: '',
                    pos: '%',
                },
                net_to_retail: {
                    label: 'Net to Retail',
                    pre: '',
                    pos: '%',
                },
                gross_to_net: {
                    label: 'Gross to Net',
                    pre: '',
                    pos: '%',
                },
            },
            defaultKpiMetrics: [1, 2, 3, 4, 5],
            kpiMetrics: [
                {
                    key: 1,
                    value: 'volume_sales',
                    name: 'Nutrifuel Volume Sales',
                    pre: '',
                    post: '',
                },
                {
                    key: 2,
                    value: 'value_sales',
                    name: 'Nutrifuel Value Sales ($)',
                    pre: '$',
                    post: '',
                },
                {
                    key: 3,
                    value: 'profit_abs',
                    name: 'Nutrifuel Profit Abs ($)',
                    pre: '$',
                    post: '',
                },
                {
                    key: 4,
                    value: 'margin_percent',
                    name: 'Nutrifuel Margin (%)',
                    pre: '',
                    post: '%',
                },
                {
                    key: 5,
                    value: 'trade_rate_percent',
                    name: 'Nutrifuel Trade Rate (%)',
                    pre: '',
                    post: '%',
                },
                {
                    key: 6,
                    value: 'retailer_margin_percent',
                    name: 'Nutrifuel Retailer Margin (%)',
                    pre: '',
                    post: '%',
                },
                {
                    key: 7,
                    value: 'gross_profit',
                    name: 'Nutrifuel Gross Profit ($)',
                    pre: '$',
                    post: '',
                },
                {
                    key: 8,
                    value: 'retailer_profit',
                    name: 'Nutrifuel Retailer Profit ($)',
                    pre: '$',
                    post: '',
                },
                {
                    key: 9,
                    value: 'gross_sales',
                    name: 'Nutrifuel Gross Sales ($)',
                    pre: '$',
                    post: '',
                },
                {
                    key: 10,
                    value: 'net_sales',
                    name: 'Nutrifuel Net Sales($)',
                    pre: '$',
                    post: '',
                },
                {
                    key: 11,
                    value: 'total_volume',
                    name: 'Total Volume Sales',
                    pre: '$',
                    post: '',
                },
                {
                    key: 12,
                    value: 'total_value',
                    name: 'Total Value Sales($)',
                    pre: '$',
                    post: '',
                },
                {
                    key: 13,
                    value: 'net_retail_price_change',
                    name: 'Nutrifuel Net Retailer Price % Chg',
                    pre: '',
                    post: '%',
                },
            ],
            addPortfolioUpdateKpis: [
                {
                    key: 'volume',
                    value: '',
                    label: 'Volume',
                    rval: '',
                    percentChange: '',
                },
                {
                    key: 'value',
                    value: '',
                    label: 'Value',
                    rval: '',
                    percentChange: '',
                },
                {
                    key: 'units',
                    value: '',
                    label: 'Units',
                    rval: '',
                    percentChange: '',
                },
                {
                    key: 'trade_rate',
                    value: '',
                    label: 'Trade Rate %',
                    rval: '',
                    percentChange: '',
                },
                {
                    key: 'list_price',
                    value: '',
                    label: 'List Price per unit',
                    rval: '',
                    percentChange: '',
                },
                {
                    key: 'retail_price',
                    value: '',
                    label: 'Retail Price per unit',
                    rval: '',
                    percentChange: '',
                },
                {
                    key: 'acv',
                    value: '',
                    label: 'ACV Distribution %',
                    rval: '',
                    percentChange: '',
                },
                {
                    key: 'cogs',
                    value: '',
                    label: 'COGS per unit',
                    rval: '',
                    percentChange: '',
                },
                {
                    key: 'base_elasticity',
                    value: '',
                    label: 'Base Elasticity',
                    rval: '',
                    percentChange: '',
                },
                {
                    key: 'acv_elasticity',
                    value: '',
                    label: 'Acv Elasticity',
                    rval: '',
                    percentChange: '',
                },
            ],
            quarterMetricKeyMapping: [
                {
                    name: 'Volume',
                    value: 'volume',
                    pre: '',
                    post: '',
                },
                {
                    name: 'Revenue',
                    value: 'revenue',
                    pre: '$',
                    post: '',
                },
                {
                    name: 'Profit',
                    value: 'profit',
                    pre: '$',
                    post: '',
                },
                {
                    name: 'Trade Rate Percent',
                    value: 'tradeRatePercent',
                    pre: '',
                    post: '%',
                },
                {
                    name: 'Retailer Margin',
                    value: 'retailerMargin',
                    pre: '',
                    post: '',
                },
            ],
        },
        priceChange: {
            // TODO: remove unwanted props
            limit: 60,
            dimensionConfig: {
                //snake case eg sub_category
                excludedDimensions: [],
                defaultDimension: 'Manufacturer',
            },
            hiddenTableRows: [],
            timePeriodOptions: [
                { label: 'YA', value: 'year_ago' },
                { label: 'Prior Period', value: 'prior_period' },
                { label: 'Custom Period', value: 'custom' },
            ],
            absTileData: [
                { key: 'abs', label: 'Abs' },
                { key: 'percentage', label: '%' },
            ],
            kpiListData: [
                {
                    key: 'avg_price',
                    label: 'Avg Price',
                    value: 'average',
                    dataKey: 'avg_price',
                },
                {
                    key: 'base_price',
                    label: 'Base Price',
                    value: 'base',
                    dataKey: 'base_price',
                },
            ],
            volTileData: [
                {
                    key: 'units',
                    label: 'PU',
                    value: 'units',
                    dataKey: 'units',
                    tooltip: 'Per Unit',
                },
                {
                    key: 'vol',
                    label: 'PEQ',
                    value: 'vol',
                    dataKey: 'volume',
                    tooltip: 'Per Eq Volume',
                },
            ],
            salesTileData: [
                { key: 'sales', label: 'Sales' },
                { key: 'incremental', label: 'Incremental' },
                { key: 'promo', label: 'Promo' },
            ],
            salesAttributionChart: {
                colorList: ['#10AB5E', '#DC3826'],
                colorListType2: ['#758BEE', '#758BEE'],
                profitPoolColor: ['#826FD0', '#826FD0'],
                backGroundColor: 'rgba(0, 0, 0, 0.02)',
            },
            salesAttributionDrillDownChartKeyValueMapping: {
                'feature_&_display': 'Feature & Display',
                'Feature & Display': 'feature_&_display',
            },
            salesAttributionChart2Limit: 20,
        },
        growthAnalysis: {
            limit: 60,
            includeAggPeriod: true,
            dimensionConfig: {
                //snake case eg sub_category
                excludedDimensions: [],
                defaultDimension: 'Vendor',
            },
            absTileData: [
                { key: 'abs', label: 'Abs' },
                { key: 'percentage', label: '%' },
            ],
            subTileData: [
                {
                    label: 'PU',
                    key: 'PU',
                },
                {
                    label: 'PEQ',
                    key: 'PEQ',
                },
            ],
            volTileData: [
                {
                    key: 'val',
                    label: 'Dollars',
                    value: 'val',
                    dataKey: 'value',
                },
                {
                    key: 'vol',
                    label: 'Eq Volume',
                    value: 'vol',
                    dataKey: 'volume',
                },
                {
                    key: 'units',
                    label: 'Units',
                    value: 'units',
                    dataKey: 'units',
                },
                // { key: 'profit', label: 'Profit', value: 'profit', dataKey: 'profit' },
            ],
            showTotal: true,
            currentYearLabel: 'CY',
            yearAgoLabel: 'YA',
            trendChartDropdownData: [
                {
                    key: 'sales_volume',
                    label: 'Sales Volume',
                    value: 'sales_volume',
                    dataKey: 'sales_volume',
                },
                {
                    key: 'sales',
                    label: 'Sales $',
                    value: 'sales',
                    dataKey: 'sales',
                },
                {
                    key: 'average_price',
                    label: 'Average Price',
                    value: 'average_price',
                    dataKey: 'average_price',
                },
                {
                    key: 'base_price',
                    label: 'Base Price',
                    value: 'base_price',
                    dataKey: 'base_price',
                },
                { key: 'acv', label: '%ACV', value: 'acv', dataKey: 'acv' },
                {
                    key: 'avg_items',
                    label: 'Avg. no. of items',
                    value: 'avg_items',
                    dataKey: 'avg_items',
                },
                { key: 'tdp', label: 'TDP', value: 'tdp', dataKey: 'tdp' },
            ],
            salesTileData: [
                { key: 'sales', label: 'Sales' },
                { key: 'incremental', label: 'Incremental' },
                { key: 'promo', label: 'Promo' },
            ],
            graphExportHeaderMapping: {
                promo: ['Non-promo', 'Promo'],
                incremental: ['Base', 'Incremental'],
                sales: ['Sales Change'],
            },
            depletionDropdownData: [
                {
                    value: 'frontline_sales',
                    dataKey: 'frontline_sales',
                    key: 'frontline_sales',
                    label: 'Frontline Sales',
                },
                {
                    value: 'net_sales',
                    dataKey: 'net_sales',
                    key: 'net_sales',
                    label: 'Net Sales',
                },
            ],
            tableKeyUnitMapping: {
                'Market Share CY': {
                    unit: '%',
                    label: 'Market Share CY',
                    includePercentageChange: false,
                },
                'Market Share YA': {
                    unit: '%',
                    label: 'Market Share YA',
                    includePercentageChange: false,
                },
                'ACV CY': {
                    unit: '%',
                    label: 'Wtd. Avg ACV %',
                    includePercentageChange: false,
                },
                'ACV YA': {
                    unit: '%',
                    label: 'Wtd. Avg ACV % YA',
                    includePercentageChange: false,
                },
            },
            salesAttributionChart: {
                colorList: ['#10AB5E', '#DC3826'],
                colorListType2: ['#758BEE', '#758BEE'],
                profitPoolColor: ['#826FD0', '#826FD0'],
                backGroundColor: 'rgba(0, 0, 0, 0.02)',
            },
            salesAttributionDrillDownChartKeyValueMapping: {
                'feature_&_display': 'Feature & Display',
                'Feature & Display': 'feature_&_display',
            },
            salesAttributionChart2DisabledItems: ['unexplained'],
            salesAttributionChart2Limit: 50,
        },
        //BUMP REPORT
        bumpReport: {
            mainHeader: 'Bump Report',
            groupByKey: 'groupBy',
            comparisonTileData: [
                { key: 'cy_vs_ya', label: 'CY vs YA' },
                { key: 'difference', label: 'Difference' },
            ],
            enablePromoCalender: true,
            isPromoUpliftPercentValue: false,
            volGroupByOptionsMapping: {
                vol: [
                    {
                        value: 'total_eq_volume',
                        label: 'Total EQ Volume',
                        index: 1,
                    },
                    {
                        value: 'any_promo_eq_volume',
                        label: 'Any promo EQ Volume',
                        index: 1,
                    },
                    {
                        value: 'no_promo_eq_volume',
                        label: 'No Promo EQ Volume',
                        index: 1,
                    },

                    {
                        value: 'base_eq_volume',
                        label: 'Base EQ Volume',
                        index: 0,
                    },
                    {
                        value: 'incremental_eq_volume',
                        label: 'Incremental EQ Volume Total',
                        index: 0,
                    },
                    {
                        value: 'tpr_incremental_eq_volume',
                        label: 'Incremental EQ Volume TPR',
                        index: 0,
                    },
                    {
                        value: 'feature_incremental_eq_volume',
                        label: 'Incremental EQ Volume Feature',
                        index: 0,
                    },
                    {
                        value: 'display_incremental_eq_volume',
                        label: 'Incremental EQ Volume Display',
                        index: 0,
                    },
                    {
                        value: 'feature_and_display_incremental_eq_volume',
                        label: 'Incremental EQ Volume Feature & Display',
                        index: 0,
                    },
                ],
                val: [
                    { value: 'total_value', label: 'Total Value', index: 1 },
                    {
                        value: 'any_promo_value',
                        label: 'Any Promo Value',
                        index: 1,
                    },
                    {
                        value: 'no_promo_value',
                        label: 'No Promo Value',
                        index: 1,
                    },
                    { value: 'base_value', label: 'Base Value', index: 0 },
                    {
                        value: 'incremental_value',
                        label: 'Incremental Value Total',
                        index: 0,
                    },
                    {
                        value: 'tpr_incremental_value',
                        label: 'Incremental Value TPR',
                        index: 0,
                    },
                    {
                        value: 'feature_incremental_value',
                        label: 'Incremental Value Feature',
                        index: 0,
                    },
                    {
                        value: 'display_incremental_value',
                        label: 'Incremental Value Display',
                        index: 0,
                    },
                    {
                        value: 'feature_and_display_incremental_value',
                        label: 'Incremental Value Feature & Display',
                        index: 0,
                    },
                ],
                units: [
                    { value: 'total_units', label: 'Total Units', index: 1 },
                    {
                        value: 'any_promo_units',
                        label: 'Any Promo Units',
                        index: 1,
                    },
                    {
                        value: 'no_promo_units',
                        label: 'No Promo Units',
                        index: 1,
                    },
                    { value: 'base_units', label: 'Base Units', index: 0 },
                    {
                        value: 'incremental_units',
                        label: 'Incremental Units Total',
                        index: 0,
                    },
                    {
                        value: 'tpr_incremental_units',
                        label: 'Incremental Units TPR',
                        index: 0,
                    },
                    {
                        value: 'feature_incremental_units',
                        label: 'Incremental Units Feature',
                        index: 0,
                    },
                    {
                        value: 'display_incremental_units',
                        label: 'Incremental Units Display',
                        index: 0,
                    },
                    {
                        value: 'feature_and_display_incremental_units',
                        label: 'Incremental Units Feature & Display',
                        index: 0,
                    },
                ],
            },
            tooltipKeyLabelMapping: {
                increments: 'Incremental',
                promo: 'Any Promo',
            },
            bumpReportTileData: [
                { key: 'increments', label: 'Attribution' },
                { key: 'promo', label: 'Consumption' },
                { key: 'groupBy', label: 'Group By' },
            ],
            bumpReportTile1Data: [
                {
                    key: 'promo',
                    label: 'Promotions',
                    visibleTabs: ['increments', 'promo', 'groupBy'],
                }, //keys should match bumpReportTileData keys
            ],
            bumpReportTile2Data: [
                { key: 'total', label: 'Total' },
                { key: 'breakout', label: 'Breakout' },
            ],
            absTileData: [
                { key: 'abs', label: 'Abs' },
                { key: 'percentage', label: '%' },
            ],

            volTileData: [
                { key: 'val', label: 'Dollars', dataKey: 'value' },
                { key: 'vol', label: 'Eq Volume', dataKey: 'volume' },
                { key: 'units', label: 'Units', dataKey: 'units' },
            ],
            bumpChartY2Colors: [
                '#293BB8',
                '#DD449F',
                '#9E5897',
                '#19669D',
                '#43C9E2',
                '#37C7BE',
                '#00798C',
                '#E8A122',
                '#E06936',
                '#A5582D',
            ],
            bumpChartY2AxisOptions: {
                vol: [
                    {
                        value: 'avg_price_per_eq',
                        index: 0,
                        label: 'Avg. Price/EQ',
                        unit: '',
                    },
                    {
                        value: 'base_price_per_eq',
                        index: 0,
                        label: 'Base Price/EQ',
                        unit: '',
                    },
                    {
                        value: 'promo_price_per_eq',
                        index: 0,
                        label: 'Promo Price/EQ',
                        unit: '',
                    },
                    {
                        value: 'market_share_volume',
                        index: 0,
                        label: 'Market Share %',
                        unit: '',
                    },
                    {
                        value: 'distribution_tdp',
                        index: 0,
                        label: 'Distribution TDP',
                        unit: '',
                    },
                    {
                        value: 'display_tdp',
                        index: 0,
                        label: 'Display TDP',
                        unit: '',
                    },
                    {
                        value: 'feature_tdp',
                        index: 0,
                        label: 'Feature TDP',
                        unit: '',
                    },
                    {
                        value: 'feature_and_display_tdp',
                        index: 0,
                        label: 'Feature and Display TDP',
                        unit: '',
                    },
                    {
                        value: 'unit_velocity',
                        index: 0,
                        label: 'Unit Velocity',
                        unit: '',
                    },
                    {
                        value: 'sales_velocity',
                        index: 0,
                        label: 'Dollar Velocity',
                        unit: '$',
                    },
                    {
                        value: 'volume_velocity',
                        index: 0,
                        label: 'Eq Velocity',
                        unit: '',
                    },
                    {
                        value: 'subsidized_base_sales',
                        index: 0,
                        label: 'Subsidized Base Sales',
                        unit: '',
                    },
                ],
                val: [
                    {
                        value: 'avg_price_per_eq',
                        index: 0,
                        label: 'Avg. Price/EQ',
                        unit: '',
                    },
                    {
                        value: 'base_price_per_eq',
                        index: 0,
                        label: 'Base Price/EQ',
                        unit: '',
                    },
                    {
                        value: 'promo_price_per_eq',
                        index: 0,
                        label: 'Promo Price/EQ',
                        unit: '',
                    },
                    {
                        value: 'market_share_value',
                        index: 0,
                        label: 'Market Share %',
                        unit: '',
                    },
                    {
                        value: 'distribution_tdp',
                        index: 0,
                        label: 'Distribution TDP',
                        unit: '',
                    },
                    {
                        value: 'display_tdp',
                        index: 0,
                        label: 'Display TDP',
                        unit: '',
                    },
                    {
                        value: 'feature_tdp',
                        index: 0,
                        label: 'Feature TDP',
                        unit: '',
                    },
                    {
                        value: 'feature_and_display_tdp',
                        index: 0,
                        label: 'Feature and Display TDP',
                        unit: '',
                    },
                    {
                        value: 'unit_velocity',
                        index: 0,
                        label: 'Unit Velocity',
                        unit: '',
                    },
                    {
                        value: 'sales_velocity',
                        index: 0,
                        label: 'Dollar Velocity',
                        unit: '$',
                    },
                    {
                        value: 'volume_velocity',
                        index: 0,
                        label: 'Eq Velocity',
                        unit: '',
                    },
                    {
                        value: 'subsidized_base_sales',
                        index: 0,
                        label: 'Subsidized Base Sales',
                        unit: '',
                    },
                ],
                units: [
                    {
                        value: 'avg_price_per_unit',
                        index: 0,
                        label: 'Avg. Price/Unit ($)',
                        unit: '',
                    },
                    {
                        value: 'base_price_per_unit',
                        index: 0,
                        label: 'Base Price/unit',
                        unit: '',
                    },
                    {
                        value: 'promo_price_per_unit',
                        index: 0,
                        label: 'Promo Price/Unit',
                        unit: '',
                    },
                    {
                        value: 'market_share_units',
                        index: 0,
                        label: 'Market Share %',
                        unit: '',
                    },
                    {
                        value: 'distribution_tdp',
                        index: 0,
                        label: 'Distribution TDP',
                        unit: '',
                    },
                    {
                        value: 'display_tdp',
                        index: 0,
                        label: 'Display TDP',
                        unit: '',
                    },
                    {
                        value: 'feature_tdp',
                        index: 0,
                        label: 'Feature TDP',
                        unit: '',
                    },
                    {
                        value: 'feature_and_display_tdp',
                        index: 0,
                        label: 'Feature and Display TDP',
                        unit: '',
                    },
                    {
                        value: 'unit_velocity',
                        index: 0,
                        label: 'Unit Velocity',
                        unit: '',
                    },
                    {
                        value: 'sales_velocity',
                        index: 0,
                        label: 'Dollar Velocity',
                        unit: '$',
                    },
                    {
                        value: 'volume_velocity',
                        index: 0,
                        label: 'Eq Velocity',
                        unit: '',
                    },
                    {
                        value: 'subsidized_base_sales',
                        index: 0,
                        label: 'Subsidized Base Sales',
                        unit: '',
                    },
                ],
            },
            promoTypeColorMapping: {
                'tpr/scan': {
                    label: 'TPR/Scan',
                    color: colorConstants.lightGreenAlt,
                },
                'feature ad': {
                    label: 'Feature Ad',
                    color: colorConstants.darkGreenAlt2,
                },
                display: { label: 'Display', color: colorConstants.pinkAlt },
                feature_display_tpr: {
                    label: 'Feature_Display_TPR',
                    color: colorConstants.orangeAlt2,
                },
                display_tpr: {
                    label: 'Display_TPR',
                    color: colorConstants.darkBlueAlt,
                },
            },
            stackedColors: [
                colorConstants.lightGreenAlt,
                colorConstants.darkGreenAlt2,
                colorConstants.pinkAlt,
                colorConstants.orangeAlt2,
                colorConstants.darkYellow,
            ],
            fieldKeyLabelMapping: {
                base_eq_volume: {
                    label: 'Base Sales (Eq Vol)',
                    color: colorConstants.darkYellow,
                    tableLabel: 'Base',
                },
                base_value: {
                    label: 'Base Sales ($)',
                    color: colorConstants.darkYellow,
                    tableLabel: 'Base',
                },
                base_units: {
                    label: 'Base Units',
                    color: colorConstants.darkYellow,
                    tableLabel: 'Base',
                },
                incremental_eq_volume: {
                    label: 'Incremental Sales (Eq Vol)',
                    color: colorConstants.darkGreenAlt2,
                    tableLabel: 'Incremental',
                },
                incremental_value: {
                    label: 'Incremental Sales ($)',
                    color: colorConstants.darkGreenAlt2,
                    tableLabel: 'Incremental',
                },
                incremental_units: {
                    label: 'Incremental Units',
                    color: colorConstants.darkGreenAlt2,
                    tableLabel: 'Incremental',
                },
                any_promo_eq_volume: {
                    label: 'Promo',
                    color: colorConstants.darkGreenAlt2,
                    tableLabel: 'Promo',
                },
                any_promo_value: {
                    label: 'Promo',
                    color: colorConstants.darkGreenAlt2,
                    tableLabel: 'Promo',
                },
                any_promo_units: {
                    label: 'Promo',
                    color: colorConstants.darkGreenAlt2,
                    tableLabel: 'Promo',
                },
                tpr_incremental_eq_volume: {
                    label: 'TPR Incremental',
                    color: colorConstants.lightGreenAlt,
                    tableLabel: 'TPR Incremental',
                },
                feature_incremental_eq_volume: {
                    label: 'Feature Incremental',
                    color: colorConstants.darkGreenAlt2,
                    tableLabel: 'Feature Incremental',
                },
                display_incremental_eq_volume: {
                    label: 'Display Incremental',
                    color: colorConstants.pinkAlt,
                    tableLabel: 'Display Incremental',
                },
                feature_and_display_incremental_eq_volume: {
                    label: 'F & D Incremental',
                    color: colorConstants.orangeAlt2,
                    tableLabel: 'F & D Incremental',
                },
                tpr_incremental_value: {
                    label: 'TPR Incremental',
                    color: colorConstants.lightGreenAlt,
                    tableLabel: 'TPR Incremental',
                },
                feature_incremental_value: {
                    label: 'Feature Incremental',
                    color: colorConstants.darkGreenAlt2,
                    tableLabel: 'Feature Incremental',
                },
                display_incremental_value: {
                    label: 'Display Incremental',
                    color: colorConstants.pinkAlt,
                    tableLabel: 'Display Incremental',
                },
                feature_and_display_incremental_value: {
                    label: 'F & D Incremental',
                    color: colorConstants.orangeAlt2,
                    tableLabel: 'F & D Incremental',
                },
                tpr_incremental_units: {
                    label: 'TPR Incremental',
                    color: colorConstants.lightGreenAlt,
                    tableLabel: 'TPR Incremental',
                },
                feature_incremental_units: {
                    label: 'Feature Incremental',
                    color: colorConstants.darkGreenAlt2,
                    tableLabel: 'Feature Incremental',
                },
                display_incremental_units: {
                    label: 'Display Incremental',
                    color: colorConstants.pinkAlt,
                    tableLabel: 'Display Incremental',
                },
                feature_and_display_incremental_units: {
                    label: 'F & D Incremental',
                    color: colorConstants.orangeAlt2,
                    tableLabel: 'F & D Incremental',
                },
                tpr_only_eq_volume: {
                    label: 'TPR',
                    color: colorConstants.lightGreenAlt,
                    tableLabel: 'TPR',
                },
                tpr_only_value: {
                    label: 'TPR',
                    color: colorConstants.lightGreenAlt,
                    tableLabel: 'TPR',
                },
                feature_only_eq_volume: {
                    label: 'Feature',
                    color: colorConstants.darkGreenAlt2,
                    tableLabel: 'Feature',
                },
                feature_only_value: {
                    label: 'Feature',
                    color: colorConstants.darkGreenAlt2,
                    tableLabel: 'Feature',
                },
                display_only_eq_volume: {
                    label: 'Display',
                    color: colorConstants.pinkAlt,
                    tableLabel: 'Display',
                },
                display_only_value: {
                    label: 'Display',
                    color: colorConstants.pinkAlt,
                    tableLabel: 'Display',
                },
                feature_and_display_only_eq_volume: {
                    label: 'F & D',
                    color: colorConstants.orangeAlt2,
                    tableLabel: 'F & D',
                },
                feature_and_display_only_value: {
                    label: 'F & D',
                    color: colorConstants.orangeAlt2,
                    tableLabel: 'F & D',
                },
                no_promo_eq_volume: {
                    label: 'Non Promo',
                    color: colorConstants.darkYellow,
                    tableLabel: 'Non Promo',
                },
                no_promo_value: {
                    label: 'Non Promo',
                    color: colorConstants.darkYellow,
                    tableLabel: 'Non Promo',
                },
                tpr_only_units: {
                    label: 'TPR',
                    color: colorConstants.lightGreenAlt,
                    tableLabel: 'TPR',
                },
                feature_only_units: {
                    label: 'Feature',
                    color: colorConstants.darkGreenAlt2,
                    tableLabel: 'Feature',
                },
                display_only_units: {
                    label: 'Display',
                    color: colorConstants.pinkAlt,
                    tableLabel: 'Display',
                },
                feature_and_display_only_units: {
                    label: 'F & D',
                    color: colorConstants.orangeAlt2,
                    tableLabel: 'F & D',
                },
                no_promo_units: {
                    label: 'Non Promo',
                    color: colorConstants.darkYellow,
                    tableLabel: 'Non Promo',
                },

                //for export label
                sales_year_ago: { label: 'YA Sales' },
                total_value: { label: 'Total' },
                incremental_eq_volume_percentage: {
                    label: 'Incremental Sales Percentage',
                },
                incremental_value_percentage: {
                    label: 'Incremental Sales Percentage',
                },
                incremental_units_percentage: {
                    label: 'Incremental Sales Percentage',
                },
                base_value_percentage: { label: 'Base Sales Percentage' },
                base_eq_volume_percentage: { label: 'Base Sales Percentage' },
                base_units_percentage: { label: 'Base Units Percentage' },
                any_promo_eq_volume_percentage: { label: 'Promo Percentage' },
                any_promo_value_percentage: { label: 'Promo Percentage' },
                any_promo_units_percentage: { label: 'Promo Percentage' },
                no_promo_eq_volume_percentage: {
                    label: 'Non Promo Percentage',
                },
                no_promo_units_percentage: { label: 'Non Promo Percentage' },
                no_promo_value_percentage: { label: 'Non Promo Percentage' },
            },
            tooltipExtraItems: {
                tpr_acv: { label: 'Tpr ACV %' },
                display_acv: { label: 'Display ACV %' },
                feature_acv: { label: 'Feature ACV %' },
                feature_and_display_acv: { label: 'F&D ACV %' },
                uplift: { label: 'Uplift' },
                promo_lift: { label: 'Promo Uplift' },
                media_lift: { label: 'Media Uplift' },
            },
            promoCalenderAttributeLevels: {
                promo: [
                    { value: 'product', label: 'Product' },
                    { value: 'geography', label: 'Geography' },
                ],
            },
            overlayKeys: {
                promo: [
                    { label: 'Start Week', dataKey: 'startTimestamp' },
                    { label: 'End Week', dataKey: 'endTimestamp' },
                    { label: 'Product', dataKey: 'product' },
                    { label: 'Promo Mechanics', dataKey: 'promoMech' },
                    { label: 'Promo Type', dataKey: 'promoType' },
                    { label: 'Investment', dataKey: 'field_value' },
                    // { label: 'ROI', dataKey: 'roi' },
                    // { label: 'Lift', dataKey: 'lift' },
                    // { label: 'Incremental Profit', dataKey: 'incrementalProfit' },
                    // { label: 'Incremental Retailer Profit', dataKey: 'incrementalRetailerProfit' },
                ],
            },
        },
        //PROMO SCORE CARD
        promoScoreCard: {
            mainHeader: 'Promotional Score Card',
            limit: 50,
            nestedTableLimit: 10,
            questionsNo: [1, 2, 3, 4, 5, 6, 7, 8],
            question: {
                Q: [
                    'Am I getting my fair share of quality support? ',
                    'How does my % Discount compare to competition? ',
                    'What % of Volume was sold on promotion? ',
                    'How many weeks am I promoting? ',
                    'What is my average price per eq volume? ',
                    'What is my average price/units? ',
                    'What is my value share of promotions? ',
                    'What is my volume share of promotions? ',
                ],
                unitsInItalics: [
                    '(Fair Share Index -$ Sold)',
                    '(Weighted Average % Price Reduction)',
                    '(% of Volume)',
                    '(Weighted Weeks)',
                    '(Price per bars/oz)',
                    '(Price per Unit)',
                    '(Value share %)',
                    '(EQ Volume %)',
                ],
                unit: ['value', '%', '%', 'week', '$', '$', '%', '%'],
                numberFormateDecimal: [0, 1, 1, 0, 2, 2, 1, 1],
            },
            promoTypeLabelMapping: {
                display: { label: 'Display Only' },
                tpr: { label: 'TPR Only' },
                feature: { label: 'Feature Only' },
                feature_and_display: { label: 'Feature & Display Only' },
                feature_display: { label: 'Feature & Display Only' },
            },
            showGradientTile: true,
            promoType: ['TPR Only', 'Display Only', 'Feature Only', 'Feature & Display Only'],
            promoExpandedViewTableUnit: 'volume',
            promoExpandedViewTableSalesAndVolumeLabel: ['EQ Volume', 'Total Sales $'],
            dropDown: ['Vendor', 'Brand', 'Sub_Brand'],
            listFor: ['Vendor', 'Brand', 'Sub_Brand', 'product'],
            listForToDisplay: ['Vendor', 'Brand', 'Sub_Brand', 'product'],
            listIn: ['Category', 'Sub_Category', 'Pack_Size', 'Form', 'Segment', 'Retailer'],
        },

        // PROMO LANDSCAPE
        promoLandscape: {
            mainHeader: 'Investment & ROI Tracker',
            roiLabel: 'ROI',
            optimalInvestmentIndexThreshold1: 0.8,
            defaultAttributeTypeIndex: 10,
            optimalInvestmentIndexThreshold2: 1.2,
            promoTacticDropdownName: 'Investment Type',
            dimensionConfig: {
                //snake case eg sub_category
                excludedDimensions: [],
                defaultDimension: '',
            },
            thresholdColorMapping: {
                optimal: { label: 'Optimal', color: colorConstants.darkGreen },
                over: { label: 'Over', color: colorConstants.darkRed },
                under: { label: 'Under', color: colorConstants.darkBlueAlt },
            },
            limit: 60,
            promoTypes: [
                { value: 'display', label: 'Display' },
                { value: 'tpr', label: 'TPR' },
                { value: 'feature', label: 'Feature' },
                // { value: 'feature & display', label: 'Feature & Display' },  //not required for now
            ],
            mediaLevelsDropdown: [],
            optimalIndexKey: 'competition_spend_index',
            showInvestmentDropdown: false,
            tableRowsKeyMapping: [
                {
                    label: 'Investment',
                    children: null,
                    parentKey: null,
                    key: 'investments',
                    unit: '$',
                },
                {
                    label: 'ROI',
                    children: null,
                    parentKey: null,
                    key: 'roi',
                    unit: '',
                },
                {
                    label: 'Optimal Investment Index',
                    children: [
                        {
                            label: 'Share of Investment',
                            key: 'share_of_investment',
                            unit: '',
                        },
                        {
                            label: 'Share of Sales',
                            key: 'share_of_sales',
                            unit: '',
                        },
                    ],
                    unit: '',
                    parentKey: 'competition_data',
                    key: 'competition_spend_index',
                },
                {
                    label: 'Incremental Sales Dollar',
                    children: [
                        {
                            label: 'Total Sales Dollar',
                            key: 'total_sales',
                            unit: '$',
                        },
                        {
                            label: 'Base Sales Dollar',
                            key: 'base_sales_dollar',
                            unit: '$',
                        },
                        {
                            label: 'Incremental Sales Eq',
                            key: 'incremental_sales_eq',
                            unit: '',
                        },
                        {
                            label: 'Total Sales Eq',
                            key: 'total_sales_eq',
                            unit: '',
                        },
                        {
                            label: 'Base Sales Eq',
                            key: 'base_sales_eq',
                            unit: '',
                        },
                    ],
                    unit: '$',
                    parentKey: 'incremental_sales_dollar_data',
                    key: 'incremental_sales_dollar',
                },
                {
                    label: 'Incremental Profit',
                    children: [
                        {
                            label: 'Share of Profit Pool',
                            key: 'share_of_profit_pool',
                            unit: '',
                        },
                        {
                            label: 'Total Profit',
                            key: 'total_profit',
                            unit: '',
                        },
                        {
                            label: 'Baseline Profit',
                            key: 'baseline_profit',
                            unit: '',
                        },

                        {
                            label: 'Incremental Net Sales',
                            key: 'incremental_net_sales',
                            unit: '$',
                        },
                        {
                            label: 'Total Net Sales',
                            key: 'total_net_sales',
                            unit: '$',
                        },
                        {
                            label: 'Baseline Net Sales',
                            key: 'baseline_net_sales',
                            unit: '$',
                        },
                        {
                            label: 'Promo % Margin',
                            key: 'promo_percentage_margin',
                            unit: '',
                        },
                        {
                            label: 'Baseline % Margin',
                            key: 'baseline_percentage_margin',
                            unit: '',
                        },
                    ],
                    parentKey: 'incremental_profit_data',
                    key: 'incremental_profit',
                    unit: '$',
                },
                {
                    label: 'Incremental Retailer Profit',
                    unit: '$',
                    children: [
                        {
                            label: 'Share of Profit Pool',
                            key: 'share_of_profit_pool_retailer',
                            unit: '',
                        },
                        {
                            label: 'Total Retailer Profit',
                            key: 'total_retailer_profit',
                            unit: '',
                        },
                        {
                            label: 'Baseline Retailer Profit',
                            key: 'baseline_retailer_profit',
                            unit: '',
                        },
                        {
                            label: 'Retailer Promo % Margin',
                            key: 'retailer_promo_percentage_margin',
                            unit: '',
                        },
                        {
                            label: 'Retailer Baseline % Margin',
                            key: 'retailer_baseline_percentage_margin',
                            unit: '',
                        },
                    ],
                    parentKey: 'incremental_retailer_profit_data',
                    key: 'incremental_retailer_profit',
                },
            ],
        },
        //PORTFOLIO ANALYSIS
        portfolioAnalysis: {
            mainHeader: 'Promo ROI Analysis',
            limit: 20,
            defaultGroupByIndex: 18,
            defaultGroupBy2Index: 5,
            chartColors: [],
            absTileData: [
                { key: 'Promotions', label: 'Promotions' },
                { key: 'Drivers', label: 'Drivers' },
            ],
            salesAttributionChart: {
                colorList: ['#10AB5E', '#DC3826'],
                colorListType2: ['#758BEE', '#758BEE'],
                profitPoolColor: ['#826FD0', '#826FD0'],
                backGroundColor: 'rgba(0, 0, 0, 0.02)',
            },
            chartDropdownExtraKpis: [
                {
                    dimension: 'none',
                    label: 'Tactics',
                    dataKey: 'tactic_description',
                },
                {
                    dimension: 'none',
                    label: 'Mechanics',
                    dataKey: 'promotion_mechanic',
                },
                {
                    dimension: 'none',
                    label: 'Event Name',
                    dataKey: 'event_name',
                },
                {
                    dimension: 'dim1',
                    label: 'Week',
                    dataKey: 'week',
                },
            ],
            groupByHeaders: [
                {
                    label: 'Category',
                    value: 'category',
                    dimension: 'dim1',
                    isSelected: false,
                    sortKey: 'category',
                    multiSelectFilter: false,
                },
                {
                    label: 'Sub Category',
                    value: 'sub_category',
                    dimension: 'dim1',
                    isSelected: false,
                    sortKey: 'sub_category',
                    multiSelectFilter: false,
                },
                {
                    label: 'Brand',
                    value: 'brand',
                    dimension: 'dim1',
                    isSelected: true,
                    sortKey: 'brand',
                    multiSelectFilter: false,
                },
                {
                    label: 'Sub Brand',
                    value: 'sub_brand',
                    dimension: 'dim1',
                    isSelected: false,
                    sortKey: 'sub_brand',
                    multiSelectFilter: false,
                },
                {
                    label: 'Product',
                    value: 'product',
                    dimension: 'dim1',
                    isSelected: true,
                    sortKey: 'product',
                    multiSelectFilter: false,
                },
                {
                    label: 'Mechanics',
                    value: 'promotion_mechanic',
                    dimension: null,
                    isSelected: false,
                    sortKey: 'promotion_mechanic',
                    multiSelectFilter: true,
                },
                {
                    label: 'Tactic',
                    value: 'tactic_description',
                    dimension: null,
                    isSelected: false,
                    sortKey: 'tactic_description',
                    multiSelectFilter: true,
                },
            ],

            chartHeaderLabelKeyMapping: {
                lift: { label: 'Lift' },
                roi: { label: 'ROI' },
                investments: { label: 'Investments' },
                incremental_net_sales: { label: 'Incremental Net Sales' },
                incremental_profit: { label: 'Incremental Profit' },
                incremental_retailer_profit: {
                    label: 'Incremental Retailer Profit',
                },
                acv: { label: 'ACV Distribution' },
                profit_pool: { label: 'Profit Pool' },
                tpr_acv: { label: 'Tpr ACV' },
                display_acv: { label: 'Display ACV' },
                feature_acv: { label: 'Feature ACV' },
                feature_and_display_acv: { label: 'F&D ACV' },
                total_acv: { label: 'Total ACV' },
                weeks: { label: 'Promo Weeks' },
            },

            promoTypesChartLegends: [
                {
                    label: 'TPR',
                    color: colorConstants.lightCyan,
                    style: {
                        borderRadius: '100%',
                        height: `8px`,
                        width: '8px',
                    },
                },
                {
                    label: 'Feature',
                    color: colorConstants.lightCream,
                    style: {
                        borderRadius: '100%',
                        height: `8px`,
                        width: '8px',
                    },
                },
                {
                    label: 'Display',
                    color: colorConstants.lightPink,
                    style: {
                        borderRadius: '100%',
                        height: `8px`,
                        width: '8px',
                    },
                },
            ],
            promoTypes: ['tpr', 'feature', 'display'],
            promoTypesLabelMapping: {
                tpr: 'TPR',
                feature: 'Feature',
                display: 'Display',
            },
        },
        promoRecommendation: {
            playbookLimit: 50,
            clientName: 'Nutrifuel',
            mainHeader: 'Promo Recommendation',

            retailerKey: 'Retailer',
            hideAddSpends: false,
            calenderStartDay: 'Monday',

            spendTypeList: [
                {
                    label: 'Lump Sum',
                    value: 'lump_sum',
                    inputRule: '',
                },
                {
                    label: 'Per Qty',
                    value: 'per_qty',
                    inputRule: '',
                },
                {
                    label: 'Display',
                    value: 'display',
                    inputRule: '',
                },
                {
                    label: 'Feature',
                    value: 'feature',
                    inputRule: '',
                },
            ],
            playbookKeyMapping: {
                Product: ['ppgName'],
                '%TS': ['guidelinePercentageTotalSpends', 'percentageTotalSpends', 'lesser_than', '', '%'],
                Frequency: ['guidelineFrequency', 'frequency', 'range', ''],
                ROI: ['guidelineRoi', 'roi', 'greater_than', '', ''],
            },
            // comparisonOperator: {
            //     '%TS': '<',
            //     Frequency: 'range',
            //     ROI: '>',
            // },
            menuButtons: [
                { key: 'recommendations', label: 'Recommendations' },
                {
                    key: 'summary',
                    label: 'Summary',
                },
                {
                    key: 'playbook',
                    label: 'Playbook',
                },
            ],

            promoTypeColorMapping: {
                'tpr/scan': {
                    label: 'TPR/Scan',
                    color: colorConstants.lightGreenAlt,
                },
                'feature ad': {
                    label: 'Feature Ad',
                    color: colorConstants.darkGreenAlt2,
                },
                display: { label: 'Display', color: colorConstants.pinkAlt },
                feature_display_tpr: {
                    label: 'Feature_Display_TPR',
                    color: colorConstants.orangeAlt2,
                },
                display_tpr: {
                    label: 'Display_TPR',
                    color: colorConstants.darkBlueAlt,
                },
            },
            overlayKeys: [
                {
                    label: 'Start Date',
                    dataKey: 'startDate',
                    pre: '',
                    post: '',
                },
                { label: 'Duration', dataKey: 'duration', pre: '', post: '' },
                {
                    label: 'Promo Type',
                    dataKey: 'tacticDescription',
                    pre: '',
                    post: '',
                },
                { label: 'Product(s)', dataKey: 'dim1AttributeNames', pre: '', post: '' },
                {
                    label: 'Total Volume',
                    dataKey: 'totalVolume',
                    pre: '',
                    post: '',
                    arrowConfig: 'positiveUp',
                },
                {
                    label: 'Total GSV',
                    dataKey: 'totalGsv',
                    pre: '$',
                    post: '',
                    arrowConfig: 'positiveUp',
                },
                {
                    label: 'Total NSV',
                    dataKey: 'totalNsv',
                    pre: '$',
                    post: '',
                    arrowConfig: 'positiveUp',
                },
                {
                    label: 'Total Nutrifuel Profit',
                    dataKey: 'totalKindProfit',
                    pre: '$',
                    post: '',
                    arrowConfig: 'positiveUp',
                },
                {
                    label: 'Total Retailer Profit',
                    dataKey: 'totalRetailerProfit',
                    pre: '$',
                    post: '',
                    arrowConfig: 'positiveUp',
                },
                {
                    label: 'Promo Spends',
                    dataKey: 'promoSpends',
                    pre: '$',
                    post: '',
                    arrowConfig: 'negativeUp',
                },
                {
                    label: '% Trade Spends GSV',
                    dataKey: 'percentageTradeSpendsGsv',
                    pre: '',
                    post: '%',
                    arrowConfig: 'negativeUp',
                },
                {
                    label: '% Trade Spends NSV',
                    dataKey: 'percentageTradeSpendsNsv',
                    pre: '',
                    post: '%',
                    arrowConfig: 'negativeUp',
                },

                {
                    label: 'Incremental Volume',
                    dataKey: 'incrementalVolume',
                    pre: '',
                    post: '',
                    arrowConfig: 'positiveUp',
                },
                {
                    label: 'Incremental GSV',
                    dataKey: 'incrementalGsv',
                    pre: '$',
                    post: '',
                    arrowConfig: 'positiveUp',
                },
                {
                    label: 'Incremental NSV',
                    dataKey: 'incrementalNsv',
                    pre: '$',
                    post: '',
                    arrowConfig: 'positiveUp',
                },
                {
                    label: 'Total Profit %',
                    dataKey: 'totalProfitPercentage',
                    pre: '',
                    post: '%',
                    arrowConfig: 'positiveUp',
                },
                {
                    label: 'Incremental Profit',
                    dataKey: 'incrementalProfit',
                    pre: '$',
                    post: '',
                    arrowConfig: 'positiveUp',
                },
                {
                    label: 'Promo ROI',
                    dataKey: 'roi',
                    pre: '',
                    post: '',
                    arrowConfig: 'positiveUp',
                },
                {
                    label: 'Retailer Incremental Profit',
                    dataKey: 'retailerIncrementalProfit',
                    pre: '$',
                    post: '',
                    arrowConfig: 'positiveUp',
                },
            ],
            spendLabel: {
                lump_sum: 'Lump Sum',
                per_qty: 'Per Qty',
                display: 'Display',
                feature: 'Feature',
            },
            offerMethodList: [
                { value: 'option', label: 'List of Option', dimension: 'dim1' },
                { value: 'manual', label: 'Manual', dimension: 'dim1' },
                { value: 'previous', label: 'Previous', dimension: 'dim1' },
            ],
            addEventList: [
                { value: 'new', label: 'Add New Event' },
                { value: 'import', label: 'Import Event' },
            ],
            leverKeys: [
                'promptEventName',
                'offerMethod',
                'discount',
                'startDate',
                'duration',
                'displayAcv',
                'featureAcv',
            ],
            spendTopForm: ['baseVolume', 'uplift', 'totalVolume', 'totalKindProfit', 'roi', 'totalRetailerProfit'],
            formList: [
                {
                    value: 'duration',
                    label: 'Duration',
                    inputRule: '',
                    placeHolder: 'Enter',
                },
                {
                    value: 'displayAcv',
                    label: 'Display ACV',
                    inputRule: '',
                    placeHolder: 'Enter display ACV',
                },
                {
                    value: 'featureAcv',
                    label: 'Feature ACV',
                    inputRule: '',
                    placeHolder: 'Enter feature ACV',
                },
            ],
            offerSelectionKeys: ['promotionMechanic', 'tacticDescription'],
            spendPerQtyKey: ['per_qty', 'redemption'],
        },
        priceLadder: {
            isThresholdDropdownEnabled: true,
            hideMraup: true,
            limit: 50, //update this when implementing infinite scroller
            dimensionConfig: {
                //snake case eg sub_category
                excludedDimensions: [],
                defaultDimension: 'Manufacturer',
            },
            tileData: [
                {
                    label: 'Product by Market',
                    key: 'product by market',
                },
                // {
                //     label: 'Product vs Competitors',
                //     key: 'product vs competitors',
                // },
            ],
            subTileData: [
                {
                    label: 'PU',
                    key: 'PU',
                },
                {
                    label: 'PEQ',
                    key: 'PEQ',
                },
            ],
            legendMapping: {
                PU: [
                    {
                        color: '#E6E6EA',
                        label: 'Sales $',
                        key: 'salesValueDollars',
                        dataKey: 'sales',
                        metricDataKey: 'units',
                    },
                    {
                        color: '#66AFBA',
                        label: 'Avg. Price PU',
                        key: 'avgPrice',
                        dataKey: 'avg_price_per_unit',
                        metricDataKey: 'units',
                    },
                    {
                        color: '#ECA586',
                        label: 'Max Price PU',
                        key: 'maxPrice',
                        dataKey: 'max_price_per_unit',
                        metricDataKey: 'units',
                    },
                    {
                        color: '#EB8FC5',
                        label: 'Min Price PU',
                        key: 'minPrice',
                        dataKey: 'min_price_per_unit',
                        metricDataKey: 'units',
                    },
                    {
                        color: '#F1C77A',
                        label: 'Promo Price PU',
                        key: 'promoPrice',
                        dataKey: 'promo_price_per_unit',
                        metricDataKey: 'units',
                    },
                    {
                        color: '#6771DB',
                        label: 'Base Price PU',
                        key: 'basePrice',
                        dataKey: 'base_price_per_unit',
                        metricDataKey: 'units',
                    },
                    // { color: '#5463FF', label: 'MRAUP', key: 'mraup', dataKey: 'mraup' },
                ],
                PEQ: [
                    {
                        color: '#E6E6EA',
                        label: 'Sales $',
                        key: 'salesValueDollars',
                        dataKey: '',
                        metricDataKey: 'volume',
                    },
                    {
                        color: '#66AFBA',
                        label: 'Avg. Price PEQ',
                        key: 'avgPrice',
                        dataKey: 'avg_price_per_eq',
                        metricDataKey: 'volume',
                    },
                    {
                        color: '#ECA586',
                        label: 'Max Price PEQ',
                        key: 'maxPrice',
                        dataKey: 'max_price_per_eq',
                        metricDataKey: 'volume',
                    },
                    {
                        color: '#EB8FC5',
                        label: 'Min Price PEQ',
                        key: 'minPrice',
                        dataKey: 'min_price_per_eq',
                        metricDataKey: 'volume',
                    },
                    {
                        color: '#F1C77A',
                        label: 'Promo Price PEQ',
                        key: 'promoPrice',
                        dataKey: 'promo_price_per_eq',
                        metricDataKey: 'volume',
                    },
                    {
                        color: '#6771DB',
                        label: 'Base Price PEQ',
                        key: 'basePrice',
                        dataKey: 'base_price_per_eq',
                        metricDataKey: 'volume',
                    },
                    // { color: '#5463FF', label: 'MRAUP', key: 'mraup', dataKey: 'mraup' },
                ],
            },
            dataKeyMapping: {
                PU: [
                    { label: 'Sales $', key: 'salesValueDollars' },
                    { label: 'Avg. Price PU', key: 'avgPrice' },
                    { label: 'Max Price PU', key: 'maxPrice' },
                    { label: 'Min Price PU', key: 'minPrice' },
                    { label: 'Promo Price PU', key: 'promoPrice' },
                    { label: 'Base Price PU', key: 'basePrice' },
                ],
                PEQ: [
                    { label: 'Sales $', key: 'salesValueDollars' },
                    { label: 'Avg. Price PEQ', key: 'avgPrice' },
                    { label: 'Max Price PEQ', key: 'maxPrice' },
                    { label: 'Min Price PEQ', key: 'minPrice' },
                    { label: 'Promo Price PEQ', key: 'promoPrice' },
                    { label: 'Base Price PEQ', key: 'basePrice' },
                ],
            },
            tableColumnLabelKeyMapping: {
                sales: { label: 'Sales $' },
                sales_percentage: { label: 'Sales %' },
                avg_price_pu: { label: 'Average Price $ PU' },
                avg_price_peq: { label: 'Average Price $ PEQ' },
                max_price_pu: { label: 'Max Price $ PU' },
                max_price_peq: { label: 'Max Price $ PEQ' },
                min_price_pu: { label: 'Min Price $ PU' },
                min_price_peq: { label: 'Min Price $ PEQ' },
                // mraup: { label: 'MRAUP' },
                base_price_pu: { label: 'Base Price $ PU' },
                base_price_peq: { label: 'Base Price $ PEQ' },
                promo_price_pu: { label: 'Promo Price $ PU' },
                promo_price_peq: { label: 'Promo Price $ PEQ' },
            },
            dropdown2Filter: ['Category', 'Pack_Size', 'Segment', 'Channel', 'Retailer'],
        },
        opportunityIdentification: {
            reversePpeAxis: true,
            bubbleCategoryOptions: [
                { value: 'brand', label: 'Brand', dimension: 'dim1' },
                { value: 'sub_brand', label: 'Sub Brand', dimension: 'dim1' },
                { value: 'category', label: 'Category', dimension: 'dim1' },
                {
                    value: 'sub_category',
                    label: 'Sub Category',
                    dimension: 'dim1',
                },
                { value: 'pack_size', label: 'Pack Size', dimension: 'dim1' },
                { value: 'vendor', label: 'Vendor', dimension: 'dim1' },
                { value: 'product', label: 'Product', dimension: 'dim1' },
            ],
            kpis: {
                xaxis: [
                    { label: 'BPE', value: 'bpe' },
                    { label: '% RSV Growth', value: 'rsv_growth' },
                    { label: 'MAC %', value: 'mac_percentage' },
                ],
                yaxis: [
                    { label: 'PPE', value: 'ppe' },
                    { label: '% RSV Growth', value: 'rsv_growth' },
                    { label: 'MAC %', value: 'mac_percentage' },
                ],
                bubbleSize: [
                    { label: 'Eq Volume', value: 'total_volume' },
                    { label: 'BPE', value: 'bpe' },
                    { label: 'PPE', value: 'ppe' },
                    { label: 'MAC', value: 'mac' },
                    { label: 'MAC %', value: 'mac_percentage' },
                    { label: 'RSV', value: 'rsv' },
                    { label: '% RSV Growth', value: 'rsv_growth' },
                ],
            },
            elasticityDriver: {
                chart2Limit: 100,
                levels: [
                    { label: 'Retailer', value: 'retailer', dimension: 'dim2' },
                    { label: 'Product', value: 'product', dimension: 'dim1' },
                    { label: 'Vendor', value: 'vendor', dimension: 'dim1' },
                    { label: 'Brand', value: 'brand', dimension: 'dim1' },
                    { label: 'Sub-brand', value: 'sub_brand', dimension: 'dim1' },
                    { value: 'category', label: 'Category', dimension: 'dim1' },
                    {
                        value: 'sub_category',
                        label: 'Sub Category',
                        dimension: 'dim1',
                    },
                ],
                limit: 50,
                offset: 0,
                dimension: 'dim1',
                legendMapping: [
                    {
                        dataKey: 'own',
                        label: 'Own Elasticity',
                        color: '#69D4E8',
                    },
                    {
                        dataKey: 'internal',
                        label: 'Internal Competitor Elasticity',
                        color: '#E469B2',
                    },
                    {
                        dataKey: 'external',
                        label: 'External Competitor Elasticity',
                        color: '#EDB44E',
                    },
                ],
            },
        },
        priceCurve: {
            chart1Limit: 100,
            xAxisKeyValue: [
                { value: 'pack_size', label: 'Pack Size' },
                { value: 'brand', label: 'Brand' },
                { value: 'sub_brand', label: 'Sub Brand' },
                { value: 'count', label: 'Count' },
            ],
            YAxisKeyValue: [
                { value: 'retail_price', label: 'Retail Price' },
                { value: 'list_price', label: 'List Price' },
                { value: 'base_price', label: 'Base Price' },
            ],
            levels: [
                { value: 'brand', label: 'Brand' },
                { value: 'sub_brand', label: 'Sub Brand' },
                { value: 'sub_category', label: 'Sub Category' },
                { value: 'category', label: 'Category' },
                { value: 'vendor', label: 'Vendor' },
                { value: 'pack_size', label: 'Pack Size' },
                { value: 'count', label: 'Count' },
                { value: 'ounces', label: 'Ounces' },
            ],
            subTileData: [
                {
                    label: 'PU',
                    key: 'PU',
                    dataKey: 'per_unit',
                },
                {
                    label: 'PEQ',
                    key: 'PEQ',
                    dataKey: 'per_eq',
                },
            ],
            chartColors: [
                '#E8A122',
                '#293BB8',
                '#E06936',
                '#19669D',
                '#A5582D',
                '#43C9E2',
                '#DD449F',
                '#37C7BE',
                '#9E5897',
                '#00798C',
                '#EDB44E',
                '#4557D5',
                '#E6875E',
                '#228BD6',
                '#CC7442',
                '#69D4E8',
                '#E469B2',
                '#5FD3CB',
                '#B377AD',
                '#3394A3',
                '#F1C77A',
                '#7381E0',
                '#ECA586',
                '#55A8E4',
                '#D89672',
                '#8EDFEE',
                '#EB8FC5',
                '#87DED8',
                '#C699C2',
                '#66AFBA',
                '#F6D9A7',
                '#A2ABEA',
                '#F3C3AF',
                '#8EC5ED',
                '#E5B9A1',
                '#B4E9F3',
                '#F1B4D9',
                '#AFE9E5',
                '#D9BBD6',
                '#99C9D1',
                '#FAECD3',
                '#D0D5F5',
                '#F9E1D7',
                '#C6E2F6',
                '#F2DCD0',
                '#D9F4F9',
                '#F8DAEC',
                '#D7F4F2',
                '#ECDDEB',
                '#CCE4E8',
            ],
            tableHeaders: [
                { label: 'List Price $', key: 'list_price' },
                { label: 'List Price $ YA', key: 'list_price_ya' },
                { label: 'Retail Price $', key: 'retail_price' },
                { label: 'Retail Price $ YA', key: 'retail_price_ya' },
                { label: 'Base Price $', key: 'base_price' },
                { label: 'Base Price $ YA', key: 'base_price_ya' },
            ],
        },
        pricePoint: {
            priceRange: [0, 10],
            graphColorScheme: ['#D7D6D9', '#66AFBA', '#ECA586', '#F1C77A', '#EB8FC5'],
            hideMraup: true,
            limit: 500,
            dimensionConfig: {
                //snake case eg sub_category
                excludedDimensions: [],
                defaultDimension: 'Manufacturer',
            },
            contributionThreshold: 5,
            priceTypeOptions: [
                { label: 'Avg Price', value: 'avg_price' },
                { label: 'Base Price', value: 'base_price' },
            ],
            subTileData: [
                {
                    label: 'PU',
                    key: 'per_unit',
                    xAxisLabel: 'Price Per Unit',
                    tooltip: 'Per Unit',
                },
                {
                    label: 'PEQ',
                    key: 'per_volume',
                    xAxisLabel: 'Price Per Eq',
                    tooltip: 'Per Eq Volume',
                },
            ],
            yAxisDropdownData: [
                {
                    label: 'Dollars',
                    value: 'value',
                },
                {
                    label: 'Volume',
                    value: 'volume',
                },
                {
                    label: 'Units',
                    value: 'units',
                },
            ],
            tableHeaderKeyMapping: {
                growth_percentage: ['Growth % vs YA', '', '%'],
                total_sales: ['Total Value ($)', '$', ''],
                total_volume: ['Total Volume', '', ''],
                total_units: ['Total Units', '', ''],
                avg_price_per_unit: ['Avg. Price per Unit', '$', ''],
                avg_price_per_eq: ['Avg. Price per EQ', '$', ''],
                base_price_per_unit: ['Base Price per Unit', '$', ''],
                base_price_per_eq: ['Base Price per EQ', '$', ''],
            },
            drilldownTableHeaderKeyMapping: {
                growth_abs: ['Growth Abs', '$', ''],
                growth_percentage: ['Growth %', '', '%'],
                contribution_to_category: ['Contribution to category', '$', ''],
                cy_share: ['CY share', '', '%'],
                ya_share: ['YA share', '', '%'],
                change: ['Change %', '', '%'],
            },
            dropdown2Filter: ['Category', 'Pack_Size', 'Segment', 'Channel', 'Retailer'],
            customThresholdData: [
                {
                    id: 1,
                    value: '',
                },
                {
                    id: 2,
                    value: '',
                },
                {
                    id: 3,
                    value: '',
                },
                {
                    id: 4,
                    value: '',
                },
                {
                    id: 5,
                    value: '',
                },
            ],
        },
        priceTracking: {
            limit: 20,
            dimensionConfig: {
                //snake case eg sub_category
                excludedDimensions: ['manufacturer', 'segment', 'form', 'count', 'ounces'],
                defaultRowDimension: 'Product',
                defaultColumnDimension: 'Retailer',
            },
            attributeNamesLimit: 50,
            frequency: 'W',
            timePeriodOptions: [
                { label: 'YA', value: 'year_ago' },
                { label: 'Prior Period', value: 'prior_period' },
                { label: 'Custom Period', value: 'custom' },
            ],
            priceTypeOptions: [
                { label: 'Base Price', value: 'base' },
                { label: 'Avg Price', value: 'average' },
            ],
            kpiOptions: [
                { label: '% Change', value: 'percent_change' },
                { label: 'Price Index', value: 'index' },
            ],
            subTileData: [
                {
                    label: 'PU',
                    key: 'units',
                    xAxisLabel: 'Price Per Unit',
                    tooltip: 'Per Unit',
                },
                {
                    label: 'PEQ',
                    key: 'volume',
                    xAxisLabel: 'Price Per Eq',
                    tooltip: 'Per Eq Volume',
                },
            ],
            weeksOptions: [
                { label: 'L W1', value: 1 },
                { label: 'L W4', value: 4 },
                { label: 'L W12', value: 12 },
            ],
            monthsOptions: [
                { label: 'L M1', value: 1 },
                { label: 'L M3', value: 3 },
                { label: 'L M6', value: 6 },
                { label: 'L M12', value: 12 },
            ],
            quartersOptions: [
                { label: 'L Q1', value: 1 },
                { label: 'L Q2', value: 2 },
                { label: 'L Q4', value: 4 },
            ],
            kpiMapping: {
                'Base Price': ['$', ''],
                'Base Price YA': ['$', ''],
                'Avg Price': ['$', ''],
                'Avg Price YA': ['$', ''],
                'Base Price Index % Chg': ['', '%'],
                'Base Price % Chg': ['', '%'],
                'Avg Price Index % Chg': ['', '%'],
                'Avg Price % Chg': ['', '%'],
                'TDP % Chg': ['', '%'],
                TDP: ['', ''],
                'TDP YA': ['', ''],
                'Volume Velocity % Chg': ['', '%'],
                'Volume Velocity': ['', ''],
                'Volume Velocity YA': ['', ''],
            },
        },
        bestWeeks: {
            limit: 50,
            drilldownTableConfig: [
                { label: 'Period No:', value: 'period_no', sorting: false },
                { label: 'Year', value: 'year', sorting: false },
            ],
            dimensionConfig: {
                //snake case eg sub_category
                excludedDimensions: ['dim2'],
                defaultDimension: 'Brand',
            },
            rankingCriteriaOptions: [
                { label: 'Base Volume', value: 'base_eq_volume' },
                { label: 'ACV', value: 'total_per_acv_dist' },
                { label: 'Incremental Volume', value: 'incremental_eq_volume' },
                { label: 'Total Volume', value: 'total_eq_volume' },
            ],
        },
    },
    naturesBakery: {
        //COMMON CONFIG
        commonConfig: {
            clientName: 'naturesBakery',
            handleDim2SortingFromFrontend: false,
            dateFormat: 'MM/DD/YYYY',
            dateFormatAlt: 'MM/DD/YY',
            calenderStartDay: 'Sunday',
            showSecondaryLogo: false,
            showLogoInNavbar: true,
            logoHeight: '32px',
            logoWidth: '125px',
            loginPageTextPart1: 'Welcome to the',
            loginPageTextPart2: 'SRM Analytic Intelligence (AI) Tool Suite',
            width: window.innerWidth,
            limit: 10,
            offset: 0,
            lagList: [0, 1],
            graphFontSize: calculateFontSize(window.innerWidth, 13),
            graphFontSizeAlt: calculateFontSize(window.innerWidth, 13),
            graphFontFamily: "'Helvetica Neue', sans-serif",
            graphLabelColorAlt: '#4E4C55',
            graphLabelColor: '#433C4A',
            units: {
                currency: '$',
                volume: 'Eq Vol',
                currencyText: 'Dollar',
            },
            filterFormat: { dim1: { ids: [] }, dim2: { ids: [] } },
            frequency: 'W',
            showCampignCalender: false,
            showFullLabel: true,
            decimalForPercentage: 1,
            decimalForNonPercentage: 2,
        },
        latestDateForDifferentRoutes: {
            'promo-score-card': 'Promotion Data',
            'roi-analysis': 'Promotion Data',
            'roi-tracker': 'Promotion Data',
            'promo-recommendation': 'Promotion Data',
            default: 'POS Data',
        },
        screenDetailsWithRoutes: [
            {
                label: 'Growth Analysis',
                path: 'promo/category-diagnostics/growth-analysis',
                id: 'ga',
                pageId: 'ga',
            },
            {
                label: 'Bump Report',
                path: 'promo/category-diagnostics/bump-report',
                id: 'br',
                pageId: 'br',
            },
            {
                label: 'PVM Analysis',
                path: 'promo/category-diagnostics/pvm-analysis',
                id: 'pvm',
                pageId: 'pvm',
            },
            {
                label: 'Price Change',
                path: 'pricing/analytics/price-change',
                id: 'pcn',
                pageId: 'pcn',
            },
            {
                label: 'Price Point',
                path: 'pricing/analytics/price-point',
                id: 'pp',
                pageId: 'pp',
            },
            {
                label: 'Price Ladder',
                path: 'pricing/analytics/price-ladder',
                id: 'pld',
                pageId: 'pld',
            },
            {
                label: 'Price Curve',
                path: 'pricing/analytics/price-curve',
                id: 'pc',
                pageId: 'pc',
            },
            {
                label: 'Price Tracking',
                path: 'pricing/analytics/price-tracking',
                id: 'pt',
                pageId: 'pt',
            },
            {
                label: 'Opportunity Identification',
                path: 'pricing/analytics/opportunity-identification',
                id: 'oi',
                pageId: 'oi',
            },
            {
                label: 'Promo Scorecard',
                path: 'promo/analytics/promo-score-card',
                id: 'ps',
                pageId: 'ps',
            },
            {
                label: 'Investment & ROI Tracker',
                path: 'promo/analytics/roi-tracker',
                id: 'pl',
                pageId: 'pl',
            },
            {
                label: 'Promo ROI Analysis',
                path: 'promo/analytics/roi-analysis',
                id: 'pa',
                pageId: 'pa',
            },
            {
                label: 'Promo Recommendation',
                path: 'promo/recommendation/promo-recommendation',
                id: 'pr',
                pageId: 'pr',
            },
            // {
            //     label: 'Pricing Simulator V1',
            //     path: 'pricing/recommendation/price-simulator',
            //     id: 'psr',
            //     pageId: 'psr',
            // },
            // {
            //     label: 'Pricing Simulator V1',
            //     path: 'pricing/recommendation/price-simulator/new',
            //     id: 'psr',
            //     pageId: 'psrNew',
            // },
            // {
            //     label: 'Pricing Simulator V1',
            //     path: 'pricing/recommendation/price-simulator/edit/:id',
            //     id: 'psr',
            //     pageId: 'psrEdit',
            // },
            // {
            //     label: 'Pricing Simulator V1',
            //     path: 'pricing/recommendation/price-simulator/view/:id',
            //     id: 'psr',
            //     pageId: 'psrView',
            // },
            {
                label: 'Pricing Simulator',
                path: 'pricing/recommendation/pricing-simulator',
                id: 'psrV2', //update id in simulator context as well
                pageId: 'psrV2',
            },
            {
                label: 'Pricing Simulator ',
                path: 'pricing/recommendation/pricing-simulator/:mode/:projectId/scenario/:scenarioId',
                id: 'psr',
                pageId: 'psrV2Update',
            },
            {
                label: 'Pricing Simulator',
                path: 'pricing/recommendation/pricing-simulator/:mode/:projectId/scenario/:scenarioId',
                id: 'psr',
                pageId: 'psrV2View',
            },
            {
                label: 'Pricing Analytics',
                path: 'pricing/recommendation/pricing-analytics',
                id: 'psa',
                pageId: 'psa', // pricing analytics
            },
            {
                label: 'Pricing Analytics',
                path: 'pricing/recommendation/pricing-analytics/:mode/:reportId',
                id: 'psa',
                pageId: 'psaUpdate', // pricing analytics update
            },
            {
                label: 'Pricing Analytics',
                path: 'pricing/recommendation/pricing-analytics/:mode/:reportId',
                id: 'psa',
                pageId: 'psaView', // pricing analytics view
            },
            {
                label: 'Best Weeks',
                path: 'promo/recommendation/best-weeks',
                id: 'bw',
                pageId: 'bw',
            },
        ],
        screens: [
            {
                label: 'Category Diagnostics',
                path: ['promo/category-diagnostics'],
                showSubHeader: false,
                options: {
                    Promo: [
                        {
                            label: 'Growth Analysis',
                            path: 'growth-analysis',
                            id: 'ga',
                        },
                        { label: 'Bump Report', path: 'bump-report', id: 'br' },
                    ],
                    visible: false,
                },
            },
            {
                label: 'Pricing Analytics',
                path: ['pricing/analytics', null],
                showSubHeader: false,
                options: {
                    Promo: [
                        {
                            label: 'Price Change',
                            path: 'price-change',
                            id: 'pcn',
                        },
                        { label: 'Price Point', path: 'price-point', id: 'pp' },
                        {
                            label: 'Price Ladder',
                            path: 'price-ladder',
                            id: 'pld',
                        },
                        { label: 'Price Curve', path: 'price-curve', id: 'pc' },
                        {
                            label: 'Price Tracking',
                            path: 'price-tracking',
                            id: 'pt',
                        },
                        {
                            label: 'Opportunity Identification',
                            path: 'opportunity-identification',
                            id: 'oi',
                        },
                    ],
                    visible: false,
                },
            },
            {
                label: 'Promo Analytics',
                path: ['promo/analytics', null],
                showSubHeader: false,
                options: {
                    Promo: [
                        { label: 'Promo Scorecard', path: 'promo-score-card', id: 'ps' },
                        { label: 'Investment & ROI Tracker', path: 'roi-tracker', id: 'pl' },
                        { label: 'Promo ROI Analysis', path: 'roi-analysis', id: 'pa' },
                    ],
                    visible: false,
                },
            },
            {
                label: 'Price & Promo Modeling',
                path: ['promo/recommendation', 'pricing/recommendation'],
                showSubHeader: true,
                options: {
                    Promo: [
                        { label: 'Promo Recommendation', path: 'promo-recommendation', id: 'pr' },
                        {
                            label: 'Best Weeks',
                            path: 'best-weeks',
                            id: 'bw',
                        },
                    ],
                    Pricing: [
                        // { label: 'Pricing Simulator V1', path: 'price-simulator', id: 'psr' },
                        { label: 'Pricing Simulator', path: 'pricing-simulator', id: 'psrV2' },
                    ],
                    visible: false,
                },
            },
        ],
        globalFilter: {
            presetConfig: {
                disablePresetFilter: false,
                presetEnabledRoutes: {
                    all: true,
                },
            },
            availableFrequenciesList: [{ key: 'W', label: 'Week' }],
            globalFilterChangingRoutes: {
                'growth-analysis': {
                    dimensionListKey: 'growth_analysis',
                    getGlobalTimestampsKey: 'default',
                    getAttributeNamesKey: 'growth_analysis',
                    groupKey: 'upc',
                    // disabledAttributeTypes: ['manufacturer'],
                    defaultGlobalFilterObj: {
                        dim1: {
                            Category: {
                                inclusion: [
                                    {
                                        dimension: 'dim1',
                                        isAttribute: true,
                                        isActive: true,
                                        attributeType: 'Category',
                                        attributeDesc: 'TOTAL BARS',
                                        attributeExId: 'TOTAL BARS',
                                        count: 3976,
                                        __typename: 'AttributeDetails',
                                    },
                                ],
                            },
                        },
                        dim2: {
                            geography: {
                                inclusion: [
                                    {
                                        dimension: 'dim2',
                                        isAttribute: true,
                                        isActive: true,
                                        attributeType: 'geography',
                                        attributeDesc: 'Total US - Multi Outlet Plus',
                                        attributeExId: 'Total US - Multi Outlet Plus',
                                        count: 11,
                                        __typename: 'AttributeDetails',
                                    },
                                ],
                            },
                        },
                    },
                },
                'bump-report': {
                    dimensionListKey: 'bump_report',
                    getGlobalTimestampsKey: 'default',
                    getAttributeNamesKey: 'bump_report',
                    groupKey: 'upc',
                    // disabledAttributeTypes: ['manufacturer'],
                    defaultGlobalFilterObj: {
                        dim1: {
                            Category: {
                                inclusion: [
                                    {
                                        dimension: 'dim1',
                                        isAttribute: true,
                                        isActive: true,
                                        attributeType: 'Category',
                                        attributeDesc: 'TOTAL BARS',
                                        attributeExId: 'TOTAL BARS',
                                        count: 3976,
                                        __typename: 'AttributeDetails',
                                    },
                                ],
                            },
                        },
                        dim2: {
                            geography: {
                                inclusion: [
                                    {
                                        dimension: 'dim2',
                                        isAttribute: true,
                                        isActive: true,
                                        attributeType: 'geography',
                                        attributeDesc: 'Total US - Multi Outlet Plus',
                                        attributeExId: 'Total US - Multi Outlet Plus',
                                        count: 11,
                                        __typename: 'AttributeDetails',
                                    },
                                ],
                            },
                        },
                    },
                },
                'promo-score-card': {
                    dimensionListKey: 'promo_scorecard',
                    getGlobalTimestampsKey: 'default',
                    getAttributeNamesKey: 'promo_scorecard',
                    groupKey: 'upc',
                    // disabledAttributeTypes: ['manufacturer'],
                    defaultGlobalFilterObj: {
                        dim1: {
                            Category: {
                                inclusion: [
                                    {
                                        dimension: 'dim1',
                                        isAttribute: true,
                                        isActive: true,
                                        attributeType: 'Category',
                                        attributeDesc: 'TOTAL BARS',
                                        attributeExId: 'TOTAL BARS',
                                        count: 3976,
                                        __typename: 'AttributeDetails',
                                    },
                                ],
                            },
                        },
                        dim2: {
                            geography: {
                                inclusion: [
                                    {
                                        dimension: 'dim2',
                                        isAttribute: true,
                                        isActive: true,
                                        attributeType: 'geography',
                                        attributeDesc: 'Total US - Multi Outlet Plus',
                                        attributeExId: 'Total US - Multi Outlet Plus',
                                        count: 11,
                                        __typename: 'AttributeDetails',
                                    },
                                ],
                            },
                        },
                    },
                },
                'roi-tracker': {
                    dimensionListKey: 'promo_diagnostics',
                    getGlobalTimestampsKey: 'promo_diagnostics',
                    getAttributeNamesKey: 'promo_diagnostics',
                    groupKey: 'promo_diagnostics',
                    defaultGlobalFilterObj: {
                        dim1: {
                            Category: {
                                inclusion: [
                                    {
                                        dimension: 'dim1',
                                        isAttribute: true,
                                        isActive: true,
                                        attributeType: 'Category',
                                        attributeDesc: 'TOTAL BARS',
                                        attributeExId: 'TOTAL BARS',
                                        count: 3976,
                                        __typename: 'AttributeDetails',
                                    },
                                ],
                            },
                        },
                        dim2: {
                            geography: {
                                inclusion: [
                                    {
                                        dimension: 'dim2',
                                        isAttribute: true,
                                        isActive: true,
                                        attributeType: 'geography',
                                        attributeDesc: 'Total US - Multi Outlet Plus',
                                        attributeExId: 'Total US - Multi Outlet Plus',
                                        count: 11,
                                        __typename: 'AttributeDetails',
                                    },
                                ],
                            },
                        },
                        dim3: {},
                    },
                },
                'roi-analysis': {
                    dimensionListKey: 'promo_diagnostics',
                    getAttributeNamesKey: 'promo_diagnostics',
                    getGlobalTimestampsKey: 'promo_diagnostics',
                    groupKey: 'promo_diagnostics',
                    defaultGlobalFilterObj: {
                        dim1: {
                            Category: {
                                inclusion: [
                                    {
                                        dimension: 'dim1',
                                        isAttribute: true,
                                        isActive: true,
                                        attributeType: 'Category',
                                        attributeDesc: 'TOTAL BARS',
                                        attributeExId: 'TOTAL BARS',
                                        count: 3976,
                                        __typename: 'AttributeDetails',
                                    },
                                ],
                            },
                        },
                        dim2: {
                            geography: {
                                inclusion: [
                                    {
                                        dimension: 'dim2',
                                        isAttribute: true,
                                        isActive: true,
                                        attributeType: 'geography',
                                        attributeDesc: 'Total US - Multi Outlet Plus',
                                        attributeExId: 'Total US - Multi Outlet Plus',
                                        count: 11,
                                        __typename: 'AttributeDetails',
                                    },
                                ],
                            },
                        },
                        dim3: {},
                    },
                },
            },
            limit: 50,
            selectionAllowed: {
                'promo-recommendation': {
                    dim2: {
                        Retailer: 1,
                    },
                },
            },
            allSelectedLimit: 15,
            timePeriodScreenMapping: {
                default: ['4W', '12W', '26W', '52W', 'YTD', 'CUSTOM DATE'],
                'bump-report': ['52W', '104W', '156W', 'YTD', 'CUSTOM DATE'],
            },
            defaultPeriod: ['52W'],
            applyFilterApiPostFormat: {
                jsonstring_dim1: '{}',
                jsonstring_dim2: '{}',
            },
            defaultPreviousIdObject: {
                dim1: ['attr', 'attr'],
                dim2: ['attr', 'attr'],
            },
            defaultIdObject: {
                dim1: { ids: [] },
                dim2: { ids: [] },
            },
            defaultAttrIdObject: {
                attr: {
                    dim1: { ids: [] },
                    dim2: { ids: [] },
                },
            },
            promoScoreCardDefault: {
                Category: 'TOTAL BARS',
                Retailer: 'Kroger_Roundys',
            },
            retainFiltersAcrossFeatures: true,
            PromoScoreCardDefaultObj: {
                dim1: {
                    Category: {
                        inclusion: [
                            {
                                dimension: 'dim1',
                                isActive: true,
                                attributeType: 'Category',
                                attributeDesc: 'TOTAL BARS',
                                attributeExId: 'TOTAL BARS',
                            },
                        ],
                    },
                },
                dim2: {
                    geography: {
                        inclusion: [
                            {
                                dimension: 'dim2',
                                isAttribute: true,
                                isActive: true,
                                attributeType: 'geography',
                                attributeDesc: 'Total US - Multi Outlet Plus',
                                attributeExId: 'Total US - Multi Outlet Plus',
                                count: 11,
                                __typename: 'AttributeDetails',
                            },
                        ],
                    },
                },
            },
        },
        priceSimulator: {
            dataSources: [
                { label: 'Projected Consumption', value: 'iri' },
                { label: 'Consumption Actuals', value: 'l52_weeks' },
                { label: 'Financials', value: 'financials' },
            ],
            allScenariosTableLimit: 500,
            a: 10,
            opportunityIdentificationTiles: [
                { key: 'recommendation', label: 'Recommendation' },
                { key: 'input', label: 'Input' },
                { key: 'output', label: 'Output' },
            ],
            cascadingColumns: ['COGS Rate', 'List Price', 'Everyday Retail Price'], // this should match with input key mapping and price simulator input columns
            levels: ['product', 'retailer'],
            inputKeyMapping: {
                // keep the order accuretly, to get it in multiselect
                cogs: 'COGS Rate',
                lp: 'List Price',
                rp: 'Everyday Retail Price',
                acv: 'ACV Distribution',
                oi: 'OI Rate',
                non_oi: 'Non OI Rate',
                promo_trade_spends: 'Promo Trade Rate Spends',
                tr: 'Trade Rate',
                cf: 'Comp Follow',
            },
            outputKeyMapping: {
                volume: {
                    label: 'New Volume',
                    pre: '',
                    pos: '',
                },
                volume_old: {
                    label: 'Current Volume',
                    pre: '',
                    pos: '',
                },
                vlmChg: {
                    label: 'Volume Chg %',
                    pre: '',
                    pos: '%',
                },
                units: {
                    label: 'New Units',
                    pre: '',
                    pos: '',
                },
                units_old: {
                    label: 'Current Units',
                    pre: '',
                    pos: '',
                },
                unitsChg: {
                    label: 'Units Chg %',
                    pre: '',
                    pos: '%',
                },
                rsv: {
                    label: 'New RSV',
                    pre: '$',
                    pos: '',
                },
                rsv_old: {
                    label: 'Current RSV',
                    pre: '$',
                    pos: '',
                },
                rsvChg: {
                    label: 'RSV Chg %',
                    pre: '',
                    pos: '%',
                },
                gsv: {
                    label: 'New GSV',
                    pre: '$',
                    pos: '',
                },
                gsv_old: {
                    label: 'Current GSV',
                    pre: '$',
                    pos: '',
                },
                gsvChg: {
                    label: 'GSV Chg %',
                    pre: '',
                    pos: '%',
                },
                nsv: {
                    label: 'New NSV',
                    pre: '$',
                    pos: '',
                },
                nsv_old: {
                    label: 'Current NSV',
                    pre: '$',
                    pos: '',
                },
                nsvChg: {
                    label: 'NSV Chg %',
                    pre: '',
                    pos: '%',
                },
                gmac: {
                    label: 'New GMAC',
                    pre: '$',
                    pos: '',
                },
                gmac_old: {
                    label: 'Current GMAC',
                    pre: '$',
                    pos: '',
                },
                gmacChg: {
                    label: 'GMAC Chg %',
                    pre: '',
                    pos: '%',
                },
                rtMg: {
                    label: 'New Retail Margin %',
                    pre: '',
                    pos: '%',
                },
                rtMg_old: {
                    label: 'Current Retail Margin %',
                    pre: '',
                    pos: '%',
                },
                rtMgPcChg: {
                    label: 'Retail Margin Chg %',
                    pre: '',
                    pos: '%',
                },
                retailer_profit: {
                    label: 'New Retail Profit',
                    pre: '',
                    pos: '',
                },
                retailer_profit_old: {
                    label: 'Current Retail Profit',
                    pre: '',
                    pos: '',
                },
                rtPfChg: {
                    label: 'Retail Profit Chg %',
                    pre: '',
                    pos: '%',
                },
                netRpChg: {
                    label: 'Net Effective Price % Chg',
                    pre: '',
                    pos: '%',
                },
                mgPc: {
                    label: 'New Margin %',
                    pre: '',
                    pos: '%',
                },
                mgPc_old: {
                    label: 'Current Margin %',
                    pre: '',
                    pos: '%',
                },
                mgPcChg: {
                    label: 'Margin Chg %',
                    pre: '',
                    pos: '%',
                },
                profitPool: {
                    label: 'New Profit Pool',
                    pre: '',
                    pos: '%',
                },
                profitPool_old: {
                    label: 'Current Profit Pool',
                    pre: '',
                    pos: '%',
                },
                profitPoolChg: {
                    label: 'Profit Pool Chg %',
                    pre: '',
                    pos: '$',
                },
                oi_cp: {
                    label: 'Current OI Rate',
                    pre: '',
                    pos: '%',
                },
                oi_np: {
                    label: 'New OI Rate',
                    pre: '',
                    pos: '',
                },
                oi_pc: {
                    label: 'OI Rate Chg %',
                    pre: '',
                    pos: '%',
                },
                non_oi_cp: {
                    label: 'Current Non OI Rate',
                    pre: '',
                    pos: '',
                },
                non_oi_np: {
                    label: 'New Non OI Rate',
                    pre: '',
                    pos: '',
                },
                non_oi_pc: {
                    label: 'Non OI Rate Chg %',
                    pre: '',
                    pos: '%',
                },
                promo_trade_spends_cp: {
                    label: 'Current Promo Trade Rate Spends',
                    pre: '',
                    pos: '',
                },
                promo_trade_spends_np: {
                    label: 'Current Promo Trade Rate Spends',
                    pre: '',
                    pos: '',
                },
                promo_trade_spends_pc: {
                    label: 'Promo Trade Rate Spends Chg %',
                    pre: '',
                    pos: '%',
                },
                tr_cp: {
                    label: 'Current Trade Rate',
                    pre: '',
                    pos: '',
                },
                tr_np: {
                    label: 'New Trade Rate',
                    pre: '',
                    pos: '',
                },
                tr_pc: {
                    label: 'Trade Rate Chg %',
                    pre: '',
                    pos: '%',
                },
            },
            recommendationKeyMapping: {
                recommended_list_price: {
                    label: 'New list price recom',
                    pre: '$',
                    pos: '',
                },
                role: {
                    label: 'Role',
                    pre: '',
                    pos: '',
                },
                strategy: {
                    label: 'Strategy',
                    pre: '',
                    pos: '',
                },
                mix: {
                    label: 'Mix',
                    pre: '',
                    pos: '',
                },
                growth: {
                    label: 'Growth',
                    pre: '',
                    pos: '',
                },
                gap: {
                    label: 'Gap',
                    pre: '',
                    pos: '',
                },

                cogs: {
                    label: 'COGs',
                    pre: '',
                    pos: '%',
                },
                list_to_retail: {
                    label: 'List to Retail',
                    pre: '',
                    pos: '',
                },
                bpe: {
                    label: 'BPE',
                    pre: '',
                    pos: '',
                },
                ppe: {
                    label: 'PPE',
                    pre: '',
                    pos: '',
                },
                margin: {
                    label: 'Margin',
                    pre: '',
                    pos: '%',
                },
                growth_vs_category: {
                    label: 'Gowth vs Category',
                    pre: '',
                    pos: '%',
                },
                pl_vs_category: {
                    label: 'PL vs Category',
                    pre: '',
                    pos: '%',
                },
                threshold: {
                    label: 'Threshold',
                    pre: '',
                    pos: '',
                },
                comp_index: {
                    label: 'Comp. Index',
                    pre: '',
                    pos: '',
                },
                curve_index: {
                    label: 'Curve Index',
                    pre: '',
                    pos: '',
                },
                cogs_realization: {
                    label: 'COGS & Realization',
                    pre: '',
                    pos: '',
                },
                cogs_forecast: {
                    label: 'COGS Forecast',
                    pre: '',
                    pos: '%',
                },
                net_to_retail: {
                    label: 'Net to Retail',
                    pre: '',
                    pos: '%',
                },
                gross_to_net: {
                    label: 'Gross to Net',
                    pre: '',
                    pos: '%',
                },
            },
            defaultKpiMetrics: [1, 2, 3, 4, 5],
            kpiMetrics: [
                {
                    key: 1,
                    value: 'volume_sales',
                    name: 'NB Volume Sales',
                    pre: '',
                    post: '',
                },
                {
                    key: 2,
                    value: 'value_sales',
                    name: 'NB Value Sales ($)',
                    pre: '$',
                    post: '',
                },
                {
                    key: 3,
                    value: 'profit_abs',
                    name: 'NB Profit Abs ($)',
                    pre: '$',
                    post: '',
                },
                {
                    key: 4,
                    value: 'margin_percent',
                    name: 'NB Margin (%)',
                    pre: '',
                    post: '%',
                },
                {
                    key: 5,
                    value: 'trade_rate_percent',
                    name: 'NB Trade Rate (%)',
                    pre: '',
                    post: '%',
                },
                {
                    key: 6,
                    value: 'retailer_margin_percent',
                    name: 'NB Retailer Margin (%)',
                    pre: '',
                    post: '%',
                },
                {
                    key: 7,
                    value: 'gross_profit',
                    name: 'NB Gross Profit ($)',
                    pre: '$',
                    post: '',
                },
                {
                    key: 8,
                    value: 'retailer_profit',
                    name: 'NB Retailer Profit ($)',
                    pre: '$',
                    post: '',
                },
                {
                    key: 9,
                    value: 'gross_sales',
                    name: 'NB Gross Sales ($)',
                    pre: '$',
                    post: '',
                },
                {
                    key: 10,
                    value: 'net_sales',
                    name: 'NB Net Sales($)',
                    pre: '$',
                    post: '',
                },
                {
                    key: 11,
                    value: 'total_volume',
                    name: 'Total Volume Sales',
                    pre: '$',
                    post: '',
                },
                {
                    key: 12,
                    value: 'total_value',
                    name: 'Total Value Sales($)',
                    pre: '$',
                    post: '',
                },
                {
                    key: 13,
                    value: 'net_retail_price_change',
                    name: 'NB Net Retailer Price % Chg',
                    pre: '',
                    post: '%',
                },
            ],
            addPortfolioUpdateKpis: [
                {
                    key: 'volume',
                    value: '',
                    label: 'Volume',
                    rval: '',
                    percentChange: '',
                },
                {
                    key: 'value',
                    value: '',
                    label: 'Value',
                    rval: '',
                    percentChange: '',
                },
                {
                    key: 'units',
                    value: '',
                    label: 'Units',
                    rval: '',
                    percentChange: '',
                },
                {
                    key: 'trade_rate',
                    value: '',
                    label: 'Trade Rate %',
                    rval: '',
                    percentChange: '',
                },
                {
                    key: 'list_price',
                    value: '',
                    label: 'List Price per unit',
                    rval: '',
                    percentChange: '',
                },
                {
                    key: 'retail_price',
                    value: '',
                    label: 'Retail Price per unit',
                    rval: '',
                    percentChange: '',
                },
                {
                    key: 'acv',
                    value: '',
                    label: 'ACV Distribution %',
                    rval: '',
                    percentChange: '',
                },
                {
                    key: 'cogs',
                    value: '',
                    label: 'COGS per unit',
                    rval: '',
                    percentChange: '',
                },
                {
                    key: 'base_elasticity',
                    value: '',
                    label: 'Base Elasticity',
                    rval: '',
                    percentChange: '',
                },
                {
                    key: 'acv_elasticity',
                    value: '',
                    label: 'Acv Elasticity',
                    rval: '',
                    percentChange: '',
                },
            ],
            quarterMetricKeyMapping: [
                {
                    name: 'Volume',
                    value: 'volume',
                    pre: '',
                    post: '',
                },
                {
                    name: 'Revenue',
                    value: 'revenue',
                    pre: '$',
                    post: '',
                },
                {
                    name: 'Profit',
                    value: 'profit',
                    pre: '$',
                    post: '',
                },
                {
                    name: 'Trade Rate Percent',
                    value: 'tradeRatePercent',
                    pre: '',
                    post: '%',
                },
                {
                    name: 'Retailer Margin',
                    value: 'retailerMargin',
                    pre: '',
                    post: '',
                },
            ],
        },
        pricingSimulator: {
            enableAnalyticsTab: true,
            enableBulkUpload: false,
            indexPageTableLimit: 50,
            scenarioFilterOffsetLimit: 50,
            scenarioPerProjectLimit: 10,
            scenarioTableLimit: 500,
            analyticsChartLimit: 100,
            comparisonTableLimit: 50,
            dimAttributesLimit: 4,
            characterLimit: {
                kpiTileCharLimit: 22,
                kpiCompareCardLimit: 30,
            },
            enablePrivatePublicToggle: false,
            enableMicroInfoForTables: false,
            enableOneChangeAnalyticsChart: false,
            defaultGlobalKpiCount: 6,
            disableExport: true,
            indexTableFixedColumns: [
                { label: 'Project Name', key: 'projectName', sortKey: 'project_name' },
                { label: 'Created By', key: 'createdBy', sortKey: 'created_by' },
                { label: 'Status', key: 'status' },
                { label: 'Last Updated', key: 'lastUpdated', sortKey: 'updated_at' },
                { label: 'Simulation Period', key: 'simulationPeriod' },
                { label: 'Price Effective Date', key: 'priceEffectiveDate' },
            ],
            analyticsBaseScenarioFixedColumns: [
                { label: 'Project Name', key: 'projectName', sortKey: 'project_name' },
                { label: 'Created By', key: 'createdBy', sortKey: 'created_by' },
                { label: 'Status', key: 'status' },
            ],
            analyticsTableColumns: [
                { label: 'Report Name', key: 'reportName', sortKey: 'report_name' },
                { label: 'Base Scenario', key: 'baseScenario', sortKey: 'base_scenario' },
                { label: 'Created By', key: 'createdBy', sortKey: 'created_by' },
                { label: 'Last Updated', key: 'lastUpdated', sortKey: 'updated_at' },
                { label: 'Date Created', key: 'dateCreated', sortKey: 'created_at' },
            ],

            projectStatuses: {
                ACTIVE: { label: 'Active', colorType: 'success' },
                DRAFT: { label: 'Draft', colorType: 'processing' },
                SETUP: { label: 'Setup', colorType: 'processing' },
                IN_PROGRESS: { label: 'In-Progress', colorType: 'processing' },
                EXPIRED: { label: 'Expired', colorType: 'default' },
                ERROR: { label: 'Error', colorType: 'error' },
                INVALID: { label: 'Invalid', colorType: 'error' },
            },
            projectDataSource: [{ label: 'Actuals', value: 'depletion_data' }],
            simulatedPeriodItems: [
                { label: 'Custom Date', value: 'custom_date', dateArray: null },
                { label: 'Current Year', value: 'current_year', dateArray: ['01-05-2025', '12-28-2025'] },
                { label: 'Financial Year', value: 'financial_year', dateArray: ['03-02-2025', '02-22-2026'] },
            ],
            iconsMappings: {
                Elasticity: 'BorderOuterOutlined',
                BaseInput: 'BorderlessTableOutlined',
                COGS: 'DollarOutlined',
                Distributor: 'BuildOutlined',
                'Distributor P&L': 'BuildOutlined',
                FOB: 'ClusterOutlined',
                'P & L': 'LineChartOutlined',
                'Price Tree': 'MoneyCollectOutlined',
                Promotions: 'BoxPlotOutlined',
                'Retailer P&L': 'LineChartOutlined',
                Sales: 'AreaChartOutlined',
                Taxes: 'BlockOutlined',
                Volume: 'ExperimentOutlined',
                Others: 'UngroupOutlined',
                Product: 'GoldOutlined',
                Geo: 'ExpandOutlined',
                'Dollar Impact': 'DollarOutlined',
                'Standard Increase Metrics': 'ToTopOutlined',
                'EQV Metrics': 'BlockOutlined',
            },

            categoryMovementKpis: [
                { label: 'Volume Impact', value: 'volume', yAxisLabel: 'Vol', xAxisLabel: 'Retailer Vol' },
                { label: 'Sales Impact', value: 'sales', yAxisLabel: 'Sales $', xAxisLabel: 'Retailer Sales $' },
            ],
        },
        priceChange: {
            // TODO: remove unwanted props
            limit: 60,
            dimensionConfig: {
                //snake case eg sub_category
                excludedDimensions: [],
                defaultDimension: 'Manufacturer',
            },
            hiddenTableRows: [],
            timePeriodOptions: [
                { label: 'YA', value: 'year_ago' },
                { label: 'Prior Period', value: 'prior_period' },
                { label: 'Custom Period', value: 'custom' },
            ],
            absTileData: [
                { key: 'abs', label: 'Abs' },
                { key: 'percentage', label: '%' },
            ],
            kpiListData: [
                {
                    key: 'avg_price',
                    label: 'Avg Price',
                    value: 'average',
                    dataKey: 'avg_price',
                },
                {
                    key: 'base_price',
                    label: 'Base Price',
                    value: 'base',
                    dataKey: 'base_price',
                },
            ],
            volTileData: [
                {
                    key: 'units',
                    label: 'PU',
                    value: 'units',
                    dataKey: 'units',
                    tooltip: 'Per Unit',
                },
                {
                    key: 'vol',
                    label: 'PEQ',
                    value: 'vol',
                    dataKey: 'volume',
                    tooltip: 'Per Eq Volume',
                },
            ],
            salesTileData: [
                { key: 'sales', label: 'Sales' },
                { key: 'incremental', label: 'Incremental' },
                { key: 'promo', label: 'Promo' },
            ],
            salesAttributionChart: {
                colorList: ['#10AB5E', '#DC3826'],
                colorListType2: ['#758BEE', '#758BEE'],
                profitPoolColor: ['#826FD0', '#826FD0'],
                backGroundColor: 'rgba(0, 0, 0, 0.02)',
            },
            salesAttributionDrillDownChartKeyValueMapping: {
                'feature_&_display': 'Feature & Display',
                'Feature & Display': 'feature_&_display',
            },
            salesAttributionChart2Limit: 20,
        },
        growthAnalysis: {
            limit: 60,
            includeAggPeriod: true,
            dimensionConfig: {
                //snake case eg sub_category
                excludedDimensions: [],
                defaultDimension: 'Manufacturer',
            },
            absTileData: [
                { key: 'abs', label: 'Abs' },
                { key: 'percentage', label: '%' },
            ],
            subTileData: [
                {
                    label: 'PU',
                    key: 'PU',
                },
                {
                    label: 'PEQ',
                    key: 'PEQ',
                },
            ],
            volTileData: [
                {
                    key: 'val',
                    label: 'Dollars',
                    value: 'val',
                    dataKey: 'value',
                },
                {
                    key: 'vol',
                    label: 'Eq Volume',
                    value: 'vol',
                    dataKey: 'volume',
                },
                {
                    key: 'units',
                    label: 'Units',
                    value: 'units',
                    dataKey: 'units',
                },
                // { key: 'profit', label: 'Profit', value: 'profit', dataKey: 'profit' },
            ],
            showTotal: true,
            currentYearLabel: 'CY',
            yearAgoLabel: 'YA',
            trendChartDropdownData: [
                {
                    key: 'sales_volume',
                    label: 'Sales Volume',
                    value: 'sales_volume',
                    dataKey: 'sales_volume',
                },
                {
                    key: 'sales',
                    label: 'Sales $',
                    value: 'sales',
                    dataKey: 'sales',
                },
                {
                    key: 'average_price',
                    label: 'Average Price',
                    value: 'average_price',
                    dataKey: 'average_price',
                },
                {
                    key: 'base_price',
                    label: 'Base Price',
                    value: 'base_price',
                    dataKey: 'base_price',
                },
                { key: 'acv', label: '%ACV', value: 'acv', dataKey: 'acv' },
                {
                    key: 'avg_items',
                    label: 'Avg. no. of items',
                    value: 'avg_items',
                    dataKey: 'avg_items',
                },
                { key: 'tdp', label: 'TDP', value: 'tdp', dataKey: 'tdp' },
            ],
            salesTileData: [
                { key: 'sales', label: 'Sales' },
                { key: 'incremental', label: 'Incremental' },
                { key: 'promo', label: 'Promo' },
            ],
            graphExportHeaderMapping: {
                promo: ['Non-promo', 'Promo'],
                incremental: ['Base', 'Incremental'],
                sales: ['Sales Change'],
            },
            depletionDropdownData: [
                {
                    value: 'frontline_sales',
                    dataKey: 'frontline_sales',
                    key: 'frontline_sales',
                    label: 'Frontline Sales',
                },
                {
                    value: 'net_sales',
                    dataKey: 'net_sales',
                    key: 'net_sales',
                    label: 'Net Sales',
                },
            ],
            tableKeyUnitMapping: {
                'Market Share CY': {
                    unit: '%',
                    label: 'Market Share CY',
                    includePercentageChange: false,
                },
                'Market Share YA': {
                    unit: '%',
                    label: 'Market Share YA',
                    includePercentageChange: false,
                },
                'ACV CY': {
                    unit: '%',
                    label: 'Wtd. Avg ACV %',
                    includePercentageChange: false,
                },
                'ACV YA': {
                    unit: '%',
                    label: 'Wtd. Avg ACV % YA',
                    includePercentageChange: false,
                },
            },
            salesAttributionChart: {
                colorList: ['#10AB5E', '#DC3826'],
                colorListType2: ['#758BEE', '#758BEE'],
                profitPoolColor: ['#826FD0', '#826FD0'],
                backGroundColor: 'rgba(0, 0, 0, 0.02)',
            },
            salesAttributionDrillDownChartKeyValueMapping: {
                'feature_&_display': 'Feature & Display',
                'Feature & Display': 'feature_&_display',
            },
            salesAttributionChart2DisabledItems: ['unexplained'],
            salesAttributionChart2Limit: 50,
        },
        //BUMP REPORT
        bumpReport: {
            mainHeader: 'Bump Report',
            groupByKey: 'groupBy',
            comparisonTileData: [
                { key: 'cy_vs_ya', label: 'CY vs YA' },
                { key: 'difference', label: 'Difference' },
            ],
            enablePromoCalender: true,
            isPromoUpliftPercentValue: false,
            volGroupByOptionsMapping: {
                vol: [
                    {
                        value: 'total_eq_volume',
                        label: 'Total EQ Volume',
                        index: 1,
                    },
                    {
                        value: 'any_promo_eq_volume',
                        label: 'Any promo EQ Volume',
                        index: 1,
                    },
                    {
                        value: 'no_promo_eq_volume',
                        label: 'No Promo EQ Volume',
                        index: 1,
                    },

                    {
                        value: 'base_eq_volume',
                        label: 'Base EQ Volume',
                        index: 0,
                    },
                    {
                        value: 'incremental_eq_volume',
                        label: 'Incremental EQ Volume Total',
                        index: 0,
                    },
                    {
                        value: 'tpr_incremental_eq_volume',
                        label: 'Incremental EQ Volume TPR',
                        index: 0,
                    },
                    {
                        value: 'feature_incremental_eq_volume',
                        label: 'Incremental EQ Volume Feature',
                        index: 0,
                    },
                    {
                        value: 'display_incremental_eq_volume',
                        label: 'Incremental EQ Volume Display',
                        index: 0,
                    },
                    {
                        value: 'feature_and_display_incremental_eq_volume',
                        label: 'Incremental EQ Volume Feature & Display',
                        index: 0,
                    },
                ],
                val: [
                    { value: 'total_value', label: 'Total Value', index: 1 },
                    {
                        value: 'any_promo_value',
                        label: 'Any Promo Value',
                        index: 1,
                    },
                    {
                        value: 'no_promo_value',
                        label: 'No Promo Value',
                        index: 1,
                    },
                    { value: 'base_value', label: 'Base Value', index: 0 },
                    {
                        value: 'incremental_value',
                        label: 'Incremental Value Total',
                        index: 0,
                    },
                    {
                        value: 'tpr_incremental_value',
                        label: 'Incremental Value TPR',
                        index: 0,
                    },
                    {
                        value: 'feature_incremental_value',
                        label: 'Incremental Value Feature',
                        index: 0,
                    },
                    {
                        value: 'display_incremental_value',
                        label: 'Incremental Value Display',
                        index: 0,
                    },
                    {
                        value: 'feature_and_display_incremental_value',
                        label: 'Incremental Value Feature & Display',
                        index: 0,
                    },
                ],
                units: [
                    { value: 'total_units', label: 'Total Units', index: 1 },
                    {
                        value: 'any_promo_units',
                        label: 'Any Promo Units',
                        index: 1,
                    },
                    {
                        value: 'no_promo_units',
                        label: 'No Promo Units',
                        index: 1,
                    },
                    { value: 'base_units', label: 'Base Units', index: 0 },
                    {
                        value: 'incremental_units',
                        label: 'Incremental Units Total',
                        index: 0,
                    },
                    {
                        value: 'tpr_incremental_units',
                        label: 'Incremental Units TPR',
                        index: 0,
                    },
                    {
                        value: 'feature_incremental_units',
                        label: 'Incremental Units Feature',
                        index: 0,
                    },
                    {
                        value: 'display_incremental_units',
                        label: 'Incremental Units Display',
                        index: 0,
                    },
                    {
                        value: 'feature_and_display_incremental_units',
                        label: 'Incremental Units Feature & Display',
                        index: 0,
                    },
                ],
            },
            tooltipKeyLabelMapping: {
                increments: 'Incremental',
                promo: 'Any Promo',
            },
            bumpReportTileData: [
                { key: 'increments', label: 'Attribution' },
                { key: 'promo', label: 'Consumption' },
                { key: 'groupBy', label: 'Group By' },
            ],
            bumpReportTile1Data: [
                {
                    key: 'promo',
                    label: 'Promotions',
                    visibleTabs: ['increments', 'promo', 'groupBy'],
                }, //keys should match bumpReportTileData keys
            ],
            bumpReportTile2Data: [
                { key: 'total', label: 'Total' },
                { key: 'breakout', label: 'Breakout' },
            ],
            absTileData: [
                { key: 'abs', label: 'Abs' },
                { key: 'percentage', label: '%' },
            ],

            volTileData: [
                { key: 'val', label: 'Dollars', dataKey: 'value' },
                { key: 'vol', label: 'Eq Volume', dataKey: 'volume' },
                { key: 'units', label: 'Units', dataKey: 'units' },
            ],
            bumpChartY2Colors: [
                '#293BB8',
                '#DD449F',
                '#9E5897',
                '#19669D',
                '#43C9E2',
                '#37C7BE',
                '#00798C',
                '#E8A122',
                '#E06936',
                '#A5582D',
            ],
            bumpChartY2AxisOptions: {
                vol: [
                    {
                        value: 'avg_price_per_eq',
                        index: 0,
                        label: 'Avg. Price/EQ',
                        unit: '',
                    },
                    {
                        value: 'base_price_per_eq',
                        index: 0,
                        label: 'Base Price/EQ',
                        unit: '',
                    },
                    {
                        value: 'promo_price_per_eq',
                        index: 0,
                        label: 'Promo Price/EQ',
                        unit: '',
                    },
                    {
                        value: 'market_share_volume',
                        index: 0,
                        label: 'Market Share %',
                        unit: '',
                    },
                    {
                        value: 'distribution_tdp',
                        index: 0,
                        label: 'Distribution TDP',
                        unit: '',
                    },
                    {
                        value: 'display_tdp',
                        index: 0,
                        label: 'Display TDP',
                        unit: '',
                    },
                    {
                        value: 'feature_tdp',
                        index: 0,
                        label: 'Feature TDP',
                        unit: '',
                    },
                    {
                        value: 'feature_and_display_tdp',
                        index: 0,
                        label: 'Feature and Display TDP',
                        unit: '',
                    },
                    {
                        value: 'distribution_acv',
                        index: 0,
                        label: 'Distribution ACV %',
                        unit: '',
                    },
                    {
                        value: 'display_acv',
                        index: 0,
                        label: 'Display ACV %',
                        unit: '',
                    },
                    {
                        value: 'feature_acv',
                        index: 0,
                        label: 'Feature ACV %',
                        unit: '',
                    },
                    {
                        value: 'feature_and_display_acv',
                        index: 0,
                        label: 'Feature & Display ACV %',
                        unit: '',
                    },
                    {
                        value: 'unit_velocity',
                        index: 0,
                        label: 'Unit Velocity',
                        unit: '',
                    },
                    {
                        value: 'sales_velocity',
                        index: 0,
                        label: 'Dollar Velocity',
                        unit: '$',
                    },
                    {
                        value: 'volume_velocity',
                        index: 0,
                        label: 'Eq Velocity',
                        unit: '',
                    },
                    {
                        value: 'subsidized_base_sales',
                        index: 0,
                        label: 'Subsidized Base Sales',
                        unit: '',
                    },
                ],
                val: [
                    {
                        value: 'avg_price_per_unit',
                        index: 0,
                        label: 'Avg. Price/Unit ($)',
                        unit: '',
                    },
                    {
                        value: 'base_price_per_unit',
                        index: 0,
                        label: 'Base Price/unit',
                        unit: '',
                    },
                    {
                        value: 'promo_price_per_unit',
                        index: 0,
                        label: 'Promo Price/Unit',
                        unit: '',
                    },
                    {
                        value: 'market_share_value',
                        index: 0,
                        label: 'Market Share %',
                        unit: '',
                    },
                    {
                        value: 'distribution_tdp',
                        index: 0,
                        label: 'Distribution TDP',
                        unit: '',
                    },
                    {
                        value: 'display_tdp',
                        index: 0,
                        label: 'Display TDP',
                        unit: '',
                    },
                    {
                        value: 'feature_tdp',
                        index: 0,
                        label: 'Feature TDP',
                        unit: '',
                    },
                    {
                        value: 'feature_and_display_tdp',
                        index: 0,
                        label: 'Feature and Display TDP',
                        unit: '',
                    },
                    {
                        value: 'distribution_acv',
                        index: 0,
                        label: 'Distribution ACV %',
                        unit: '',
                    },
                    {
                        value: 'display_acv',
                        index: 0,
                        label: 'Display ACV %',
                        unit: '',
                    },
                    {
                        value: 'feature_acv',
                        index: 0,
                        label: 'Feature ACV %',
                        unit: '',
                    },
                    {
                        value: 'feature_and_display_acv',
                        index: 0,
                        label: 'Feature & Display ACV %',
                        unit: '',
                    },
                    {
                        value: 'unit_velocity',
                        index: 0,
                        label: 'Unit Velocity',
                        unit: '',
                    },
                    {
                        value: 'sales_velocity',
                        index: 0,
                        label: 'Dollar Velocity',
                        unit: '$',
                    },
                    {
                        value: 'volume_velocity',
                        index: 0,
                        label: 'Eq Velocity',
                        unit: '',
                    },
                    {
                        value: 'subsidized_base_sales',
                        index: 0,
                        label: 'Subsidized Base Sales',
                        unit: '',
                    },
                ],
                units: [
                    {
                        value: 'avg_price_per_unit',
                        index: 0,
                        label: 'Avg. Price/Unit ($)',
                        unit: '',
                    },
                    {
                        value: 'base_price_per_unit',
                        index: 0,
                        label: 'Base Price/unit',
                        unit: '',
                    },
                    {
                        value: 'promo_price_per_unit',
                        index: 0,
                        label: 'Promo Price/Unit',
                        unit: '',
                    },
                    {
                        value: 'market_share_units',
                        index: 0,
                        label: 'Market Share %',
                        unit: '',
                    },
                    {
                        value: 'distribution_tdp',
                        index: 0,
                        label: 'Distribution TDP',
                        unit: '',
                    },
                    {
                        value: 'display_tdp',
                        index: 0,
                        label: 'Display TDP',
                        unit: '',
                    },
                    {
                        value: 'feature_tdp',
                        index: 0,
                        label: 'Feature TDP',
                        unit: '',
                    },
                    {
                        value: 'feature_and_display_tdp',
                        index: 0,
                        label: 'Feature and Display TDP',
                        unit: '',
                    },
                    {
                        value: 'distribution_acv',
                        index: 0,
                        label: 'Distribution ACV %',
                        unit: '',
                    },
                    {
                        value: 'display_acv',
                        index: 0,
                        label: 'Display ACV %',
                        unit: '',
                    },
                    {
                        value: 'feature_acv',
                        index: 0,
                        label: 'Feature ACV %',
                        unit: '',
                    },
                    {
                        value: 'feature_and_display_acv',
                        index: 0,
                        label: 'Feature & Display ACV %',
                        unit: '',
                    },
                    {
                        value: 'unit_velocity',
                        index: 0,
                        label: 'Unit Velocity',
                        unit: '',
                    },
                    {
                        value: 'sales_velocity',
                        index: 0,
                        label: 'Dollar Velocity',
                        unit: '$',
                    },
                    {
                        value: 'volume_velocity',
                        index: 0,
                        label: 'Eq Velocity',
                        unit: '',
                    },
                    {
                        value: 'subsidized_base_sales',
                        index: 0,
                        label: 'Subsidized Base Sales',
                        unit: '',
                    },
                ],
            },
            promoTypeColorMapping: {
                'tpr/scan': {
                    label: 'TPR/Scan',
                    color: colorConstants.lightGreenAlt,
                },
                'feature ad': {
                    label: 'Feature Ad',
                    color: colorConstants.darkGreenAlt2,
                },
                display: { label: 'Display', color: colorConstants.pinkAlt },
                feature_display_tpr: {
                    label: 'Feature_Display_TPR',
                    color: colorConstants.orangeAlt2,
                },
                display_tpr: {
                    label: 'Display_TPR',
                    color: colorConstants.darkBlueAlt,
                },
            },
            stackedColors: [
                colorConstants.lightGreenAlt,
                colorConstants.darkGreenAlt2,
                colorConstants.pinkAlt,
                colorConstants.orangeAlt2,
                colorConstants.darkYellow,
            ],
            fieldKeyLabelMapping: {
                base_eq_volume: {
                    label: 'Base Sales (Eq Vol)',
                    color: colorConstants.darkYellow,
                    tableLabel: 'Base',
                },
                base_value: {
                    label: 'Base Sales ($)',
                    color: colorConstants.darkYellow,
                    tableLabel: 'Base',
                },
                base_units: {
                    label: 'Base Units',
                    color: colorConstants.darkYellow,
                    tableLabel: 'Base',
                },
                incremental_eq_volume: {
                    label: 'Incremental Sales (Eq Vol)',
                    color: colorConstants.darkGreenAlt2,
                    tableLabel: 'Incremental',
                },
                incremental_value: {
                    label: 'Incremental Sales ($)',
                    color: colorConstants.darkGreenAlt2,
                    tableLabel: 'Incremental',
                },
                incremental_units: {
                    label: 'Incremental Units',
                    color: colorConstants.darkGreenAlt2,
                    tableLabel: 'Incremental',
                },
                any_promo_eq_volume: {
                    label: 'Promo',
                    color: colorConstants.darkGreenAlt2,
                    tableLabel: 'Promo',
                },
                any_promo_value: {
                    label: 'Promo',
                    color: colorConstants.darkGreenAlt2,
                    tableLabel: 'Promo',
                },
                any_promo_units: {
                    label: 'Promo',
                    color: colorConstants.darkGreenAlt2,
                    tableLabel: 'Promo',
                },
                tpr_incremental_eq_volume: {
                    label: 'TPR Incremental',
                    color: colorConstants.lightGreenAlt,
                    tableLabel: 'TPR Incremental',
                },
                feature_incremental_eq_volume: {
                    label: 'Feature Incremental',
                    color: colorConstants.darkGreenAlt2,
                    tableLabel: 'Feature Incremental',
                },
                display_incremental_eq_volume: {
                    label: 'Display Incremental',
                    color: colorConstants.pinkAlt,
                    tableLabel: 'Display Incremental',
                },
                feature_and_display_incremental_eq_volume: {
                    label: 'F & D Incremental',
                    color: colorConstants.orangeAlt2,
                    tableLabel: 'F & D Incremental',
                },
                tpr_incremental_value: {
                    label: 'TPR Incremental',
                    color: colorConstants.lightGreenAlt,
                    tableLabel: 'TPR Incremental',
                },
                feature_incremental_value: {
                    label: 'Feature Incremental',
                    color: colorConstants.darkGreenAlt2,
                    tableLabel: 'Feature Incremental',
                },
                display_incremental_value: {
                    label: 'Display Incremental',
                    color: colorConstants.pinkAlt,
                    tableLabel: 'Display Incremental',
                },
                feature_and_display_incremental_value: {
                    label: 'F & D Incremental',
                    color: colorConstants.orangeAlt2,
                    tableLabel: 'F & D Incremental',
                },
                tpr_incremental_units: {
                    label: 'TPR Incremental',
                    color: colorConstants.lightGreenAlt,
                    tableLabel: 'TPR Incremental',
                },
                feature_incremental_units: {
                    label: 'Feature Incremental',
                    color: colorConstants.darkGreenAlt2,
                    tableLabel: 'Feature Incremental',
                },
                display_incremental_units: {
                    label: 'Display Incremental',
                    color: colorConstants.pinkAlt,
                    tableLabel: 'Display Incremental',
                },
                feature_and_display_incremental_units: {
                    label: 'F & D Incremental',
                    color: colorConstants.orangeAlt2,
                    tableLabel: 'F & D Incremental',
                },
                tpr_only_eq_volume: {
                    label: 'TPR',
                    color: colorConstants.lightGreenAlt,
                    tableLabel: 'TPR',
                },
                tpr_only_value: {
                    label: 'TPR',
                    color: colorConstants.lightGreenAlt,
                    tableLabel: 'TPR',
                },
                feature_only_eq_volume: {
                    label: 'Feature',
                    color: colorConstants.darkGreenAlt2,
                    tableLabel: 'Feature',
                },
                feature_only_value: {
                    label: 'Feature',
                    color: colorConstants.darkGreenAlt2,
                    tableLabel: 'Feature',
                },
                display_only_eq_volume: {
                    label: 'Display',
                    color: colorConstants.pinkAlt,
                    tableLabel: 'Display',
                },
                display_only_value: {
                    label: 'Display',
                    color: colorConstants.pinkAlt,
                    tableLabel: 'Display',
                },
                feature_and_display_only_eq_volume: {
                    label: 'F & D',
                    color: colorConstants.orangeAlt2,
                    tableLabel: 'F & D',
                },
                feature_and_display_only_value: {
                    label: 'F & D',
                    color: colorConstants.orangeAlt2,
                    tableLabel: 'F & D',
                },
                no_promo_eq_volume: {
                    label: 'Non Promo',
                    color: colorConstants.darkYellow,
                    tableLabel: 'Non Promo',
                },
                no_promo_value: {
                    label: 'Non Promo',
                    color: colorConstants.darkYellow,
                    tableLabel: 'Non Promo',
                },
                tpr_only_units: {
                    label: 'TPR',
                    color: colorConstants.lightGreenAlt,
                    tableLabel: 'TPR',
                },
                feature_only_units: {
                    label: 'Feature',
                    color: colorConstants.darkGreenAlt2,
                    tableLabel: 'Feature',
                },
                display_only_units: {
                    label: 'Display',
                    color: colorConstants.pinkAlt,
                    tableLabel: 'Display',
                },
                feature_and_display_only_units: {
                    label: 'F & D',
                    color: colorConstants.orangeAlt2,
                    tableLabel: 'F & D',
                },
                no_promo_units: {
                    label: 'Non Promo',
                    color: colorConstants.darkYellow,
                    tableLabel: 'Non Promo',
                },

                //for export label
                sales_year_ago: { label: 'YA Sales' },
                total_value: { label: 'Total' },
                incremental_eq_volume_percentage: {
                    label: 'Incremental Sales Percentage',
                },
                incremental_value_percentage: {
                    label: 'Incremental Sales Percentage',
                },
                incremental_units_percentage: {
                    label: 'Incremental Sales Percentage',
                },
                base_value_percentage: { label: 'Base Sales Percentage' },
                base_eq_volume_percentage: { label: 'Base Sales Percentage' },
                base_units_percentage: { label: 'Base Units Percentage' },
                any_promo_eq_volume_percentage: { label: 'Promo Percentage' },
                any_promo_value_percentage: { label: 'Promo Percentage' },
                any_promo_units_percentage: { label: 'Promo Percentage' },
                no_promo_eq_volume_percentage: {
                    label: 'Non Promo Percentage',
                },
                no_promo_units_percentage: { label: 'Non Promo Percentage' },
                no_promo_value_percentage: { label: 'Non Promo Percentage' },
            },

            tooltipExtraItems: {
                tpr_acv: { label: 'Tpr ACV %' },
                display_acv: { label: 'Display ACV %' },
                feature_acv: { label: 'Feature ACV %' },
                feature_and_display_acv: { label: 'F&D ACV %' },
                uplift: { label: 'Uplift' },
                promo_lift: { label: 'Promo Uplift' },
                media_lift: { label: 'Media Uplift' },
            },
            promoCalenderAttributeLevels: {
                promo: [
                    { value: 'product', label: 'Product' },
                    { value: 'geography', label: 'Geography' },
                ],
            },
            overlayKeys: {
                promo: [
                    { label: 'Start Week', dataKey: 'startTimestamp' },
                    { label: 'End Week', dataKey: 'endTimestamp' },
                    { label: 'Product', dataKey: 'product' },
                    { label: 'Promo Mechanics', dataKey: 'promoMech' },
                    { label: 'Promo Type', dataKey: 'promoType' },
                    { label: 'Investment', dataKey: 'field_value' },
                    // { label: 'ROI', dataKey: 'roi' },
                    // { label: 'Lift', dataKey: 'lift' },
                    // { label: 'Incremental Profit', dataKey: 'incrementalProfit' },
                    // { label: 'Incremental Retailer Profit', dataKey: 'incrementalRetailerProfit' },
                ],
            },
        },
        //PROMO SCORE CARD
        promoScoreCard: {
            mainHeader: 'Promotional Score Card',
            limit: 50,
            nestedTableLimit: 10,
            questionsNo: [1, 2, 3, 4, 5, 6, 7, 8],
            question: {
                Q: [
                    'Am I getting my fair share of quality support? ',
                    'How does my % Discount compare to competition? ',
                    'What % of Volume was sold on promotion? ',
                    'How many weeks am I promoting? ',
                    'What is my average price per eq volume? ',
                    'What is my average price/units? ',
                    'What is my value share of promotions? ',
                    'What is my volume share of promotions? ',
                ],
                unitsInItalics: [
                    '(Fair Share Index -$ Sold)',
                    '(Weighted Average % Price Reduction)',
                    '(% of Volume)',
                    '(Weighted Weeks)',
                    '(Price per bars/oz)',
                    '(Price per Unit)',
                    '(Value share %)',
                    '(EQ Volume %)',
                ],
                unit: ['value', '%', '%', 'week', '$', '$', '%', '%'],
                numberFormateDecimal: [0, 1, 1, 0, 2, 2, 1, 1],
            },
            promoTypeLabelMapping: {
                display: { label: 'Display Only' },
                tpr: { label: 'TPR Only' },
                feature: { label: 'Feature Only' },
                feature_and_display: { label: 'Feature & Display Only' },
                feature_display: { label: 'Feature & Display Only' },
            },
            showGradientTile: true,
            promoType: ['TPR Only', 'Display Only', 'Feature Only', 'Feature & Display Only'],
            promoExpandedViewTableUnit: 'volume',
            promoExpandedViewTableSalesAndVolumeLabel: ['EQ Volume', 'Total Sales $'],
            dropDown: ['Manufacturer', 'Brand', 'Sub_Brand'],
            listFor: ['Manufacturer', 'Brand', 'Sub_Brand', 'Product'],
            listForToDisplay: ['Manufacturer', 'Brand', 'Sub_Brand', 'Product'],
            listIn: ['Category', 'Sub_Category', 'Pack_Size', 'Form', 'Segment', 'Retailer'],
        },

        // PROMO LANDSCAPE
        promoLandscape: {
            mainHeader: 'Investment & ROI Tracker',
            roiLabel: 'ROI',
            defaultAttributeTypeIndex: 10,
            optimalInvestmentIndexThreshold1: 0.8,
            optimalInvestmentIndexThreshold2: 1.2,
            promoTacticDropdownName: 'Investment Type',
            dimensionConfig: {
                //snake case eg sub_category
                excludedDimensions: [],
                defaultDimension: '',
            },
            thresholdColorMapping: {
                optimal: { label: 'Optimal', color: colorConstants.darkGreen },
                over: { label: 'Over', color: colorConstants.darkRed },
                under: { label: 'Under', color: colorConstants.darkBlueAlt },
            },
            limit: 60,
            promoTypes: [
                { value: 'display', label: 'Display' },
                { value: 'tpr', label: 'TPR' },
                { value: 'feature', label: 'Feature' },
                // { value: 'feature & display', label: 'Feature & Display' },  //not required for now
            ],
            mediaLevelsDropdown: [],
            optimalIndexKey: 'competition_spend_index',
            showInvestmentDropdown: false,
            tableRowsKeyMapping: [
                {
                    label: 'Investment',
                    children: null,
                    parentKey: null,
                    key: 'investments',
                    unit: '$',
                },
                {
                    label: 'ROI',
                    children: null,
                    parentKey: null,
                    key: 'roi',
                    unit: '',
                },
                {
                    label: 'Optimal Investment Index',
                    children: [
                        {
                            label: 'Share of Investment',
                            key: 'share_of_investment',
                            unit: '',
                        },
                        {
                            label: 'Share of Sales',
                            key: 'share_of_sales',
                            unit: '',
                        },
                    ],
                    unit: '',
                    parentKey: 'competition_data',
                    key: 'competition_spend_index',
                },
                {
                    label: 'Incremental Sales Dollar',
                    children: [
                        {
                            label: 'Total Sales Dollar',
                            key: 'total_sales',
                            unit: '$',
                        },
                        {
                            label: 'Base Sales Dollar',
                            key: 'base_sales_dollar',
                            unit: '$',
                        },
                        {
                            label: 'Incremental Sales Eq',
                            key: 'incremental_sales_eq',
                            unit: '',
                        },
                        {
                            label: 'Total Sales Eq',
                            key: 'total_sales_eq',
                            unit: '',
                        },
                        {
                            label: 'Base Sales Eq',
                            key: 'base_sales_eq',
                            unit: '',
                        },
                    ],
                    unit: '$',
                    parentKey: 'incremental_sales_dollar_data',
                    key: 'incremental_sales_dollar',
                },
                {
                    label: 'Incremental Profit',
                    children: [
                        {
                            label: 'Share of Profit Pool',
                            key: 'share_of_profit_pool',
                            unit: '',
                        },
                        {
                            label: 'Total Profit',
                            key: 'total_profit',
                            unit: '',
                        },
                        {
                            label: 'Baseline Profit',
                            key: 'baseline_profit',
                            unit: '',
                        },

                        {
                            label: 'Incremental Net Sales',
                            key: 'incremental_net_sales',
                            unit: '$',
                        },
                        {
                            label: 'Total Net Sales',
                            key: 'total_net_sales',
                            unit: '$',
                        },
                        {
                            label: 'Baseline Net Sales',
                            key: 'baseline_net_sales',
                            unit: '$',
                        },
                        {
                            label: 'Promo % Margin',
                            key: 'promo_percentage_margin',
                            unit: '',
                        },
                        {
                            label: 'Baseline % Margin',
                            key: 'baseline_percentage_margin',
                            unit: '',
                        },
                    ],
                    parentKey: 'incremental_profit_data',
                    key: 'incremental_profit',
                    unit: '$',
                },
                {
                    label: 'Incremental Retailer Profit',
                    unit: '$',
                    children: [
                        {
                            label: 'Share of Profit Pool',
                            key: 'share_of_profit_pool_retailer',
                            unit: '',
                        },
                        {
                            label: 'Total Retailer Profit',
                            key: 'total_retailer_profit',
                            unit: '',
                        },
                        {
                            label: 'Baseline Retailer Profit',
                            key: 'baseline_retailer_profit',
                            unit: '',
                        },
                        {
                            label: 'Retailer Promo % Margin',
                            key: 'retailer_promo_percentage_margin',
                            unit: '',
                        },
                        {
                            label: 'Retailer Baseline % Margin',
                            key: 'retailer_baseline_percentage_margin',
                            unit: '',
                        },
                    ],
                    parentKey: 'incremental_retailer_profit_data',
                    key: 'incremental_retailer_profit',
                },
            ],
        },
        //PORTFOLIO ANALYSIS
        portfolioAnalysis: {
            mainHeader: 'Promo ROI Analysis',
            limit: 20,
            defaultGroupByIndex: 18,
            defaultGroupBy2Index: 5,
            chartColors: [],
            absTileData: [
                { key: 'Promotions', label: 'Promotions' },
                { key: 'Drivers', label: 'Drivers' },
            ],
            salesAttributionChart: {
                colorList: ['#10AB5E', '#DC3826'],
                colorListType2: ['#758BEE', '#758BEE'],
                profitPoolColor: ['#826FD0', '#826FD0'],
                backGroundColor: 'rgba(0, 0, 0, 0.02)',
            },
            // chartColors: [
            //     '#E8A122',
            //     '#293BB8',
            //     '#E06936',
            //     '#19669D',
            //     '#A5582D',
            //     '#43C9E2',
            //     '#DD449F',
            //     '#37C7BE',
            //     '#9E5897',
            //     '#00798C',
            //     '#EDB44E',
            //     '#4557D5',
            //     '#E6875E',
            //     '#228BD6',
            //     '#CC7442',
            //     '#69D4E8',
            //     '#E469B2',
            //     '#5FD3CB',
            //     '#B377AD',
            //     '#3394A3',
            //     '#F1C77A',
            //     '#7381E0',
            //     '#ECA586',
            //     '#55A8E4',
            //     '#D89672',
            //     '#8EDFEE',
            //     '#EB8FC5',
            //     '#87DED8',
            //     '#C699C2',
            //     '#66AFBA',
            //     '#F6D9A7',
            //     '#A2ABEA',
            //     '#F3C3AF',
            //     '#8EC5ED',
            //     '#E5B9A1',
            //     '#B4E9F3',
            //     '#F1B4D9',
            //     '#AFE9E5',
            //     '#D9BBD6',
            //     '#99C9D1',
            //     '#FAECD3',
            //     '#D0D5F5',
            //     '#F9E1D7',
            //     '#C6E2F6',
            //     '#F2DCD0',
            //     '#D9F4F9',
            //     '#F8DAEC',
            //     '#D7F4F2',
            //     '#ECDDEB',
            //     '#CCE4E8',
            // ],
            chartDropdownExtraKpis: [
                {
                    dimension: 'none',
                    label: 'Tactics',
                    dataKey: 'tactic_description',
                },
                {
                    dimension: 'none',
                    label: 'Mechanics',
                    dataKey: 'promotion_mechanic',
                },
                {
                    dimension: 'none',
                    label: 'Event Name',
                    dataKey: 'event_name',
                },
                {
                    dimension: 'dim1',
                    label: 'Week',
                    dataKey: 'week',
                },
            ],
            groupByHeaders: [
                {
                    label: 'Category',
                    value: 'category',
                    dimension: 'dim1',
                    isSelected: false,
                    sortKey: 'category',
                    multiSelectFilter: false,
                },
                {
                    label: 'Sub Category',
                    value: 'sub_category',
                    dimension: 'dim1',
                    isSelected: false,
                    sortKey: 'sub_category',
                    multiSelectFilter: false,
                },
                {
                    label: 'Brand',
                    value: 'brand',
                    dimension: 'dim1',
                    isSelected: true,
                    sortKey: 'brand',
                    multiSelectFilter: false,
                },
                {
                    label: 'Sub Brand',
                    value: 'sub_brand',
                    dimension: 'dim1',
                    isSelected: false,
                    sortKey: 'sub_brand',
                    multiSelectFilter: false,
                },
                {
                    label: 'Product',
                    value: 'product',
                    dimension: 'dim1',
                    isSelected: true,
                    sortKey: 'product',
                    multiSelectFilter: false,
                },
                {
                    label: 'Promotion Id',
                    value: 'Promotion_Id',
                    dimension: 'dim3',
                    isSelected: false,
                    sortKey: 'Promotion_Id',
                    multiSelectFilter: false,
                },
                {
                    label: 'Mechanics',
                    value: 'promotion_mechanic',
                    dimension: null,
                    isSelected: false,
                    sortKey: 'promotion_mechanic',
                    multiSelectFilter: true,
                },
                {
                    label: 'Tactic',
                    value: 'tactic_description',
                    dimension: null,
                    isSelected: false,
                    sortKey: 'tactic_description',
                    multiSelectFilter: true,
                },
            ],

            chartHeaderLabelKeyMapping: {
                lift: { label: 'Lift' },
                roi: { label: 'ROI' },
                investments: { label: 'Investments' },
                incremental_net_sales: { label: 'Incremental Net Sales' },
                incremental_profit: { label: 'Incremental Profit' },
                incremental_retailer_profit: {
                    label: 'Incremental Retailer Profit',
                },
                acv: { label: 'ACV Distribution' },
                profit_pool: { label: 'Profit Pool' },
                tpr_acv: { label: 'Tpr ACV' },
                display_acv: { label: 'Display ACV' },
                feature_acv: { label: 'Feature ACV' },
                feature_and_display_acv: { label: 'F&D ACV' },
                total_acv: { label: 'Total ACV' },
                weeks: { label: 'Promo Weeks' },
            },

            promoTypesChartLegends: [
                {
                    label: 'TPR',
                    color: colorConstants.lightCyan,
                    style: {
                        borderRadius: '100%',
                        height: `8px`,
                        width: '8px',
                    },
                },
                {
                    label: 'Feature',
                    color: colorConstants.lightCream,
                    style: {
                        borderRadius: '100%',
                        height: `8px`,
                        width: '8px',
                    },
                },
                {
                    label: 'Display',
                    color: colorConstants.lightPink,
                    style: {
                        borderRadius: '100%',
                        height: `8px`,
                        width: '8px',
                    },
                },
            ],
            promoTypes: ['tpr', 'feature', 'display'],
            promoTypesLabelMapping: {
                tpr: 'TPR',
                feature: 'Feature',
                display: 'Display',
            },
        },
        promoRecommendation: {
            playbookLimit: 50,
            clientName: 'NB',
            retailerKey: 'Retailer',
            hideAddSpends: false,
            mainHeader: 'Promo Recommendation',

            calenderStartDay: 'Monday',
            spendLeversList: [
                {
                    label: 'Baseline Units',
                    placeholder: 'Baseline Units',
                    value: 'baseVolume',
                    isDisabled: false,
                },
                {
                    label: 'Uplift',
                    placeholder: 'Uplift',
                    value: 'uplift',
                    isDisabled: false,
                },
                {
                    label: 'Total Units',
                    placeholder: 'Total Units',
                    value: 'totalVolume',
                    isDisabled: true,
                },
                {
                    label: `Total NB Profit ($)`,
                    placeholder: `Total NB Profit`,
                    value: 'totalKindProfit',
                    isDisabled: true,
                },
                {
                    label: 'ROI',
                    placeholder: 'ROI',
                    value: 'roi',
                    isDisabled: true,
                },
                {
                    label: `Total Retailer Profit ($)`,
                    placeholder: 'Total Retailer Profit',
                    value: 'totalRetailerProfit',
                    isDisabled: true,
                },
            ],
            spendTypeList: [
                {
                    label: 'Lump Sum',
                    value: 'lump_sum',
                    inputRule: '',
                },
                {
                    label: 'Per Qty',
                    value: 'per_qty',
                    inputRule: '',
                },
                {
                    label: 'Display',
                    value: 'display',
                    inputRule: '',
                },
                {
                    label: 'Feature',
                    value: 'feature',
                    inputRule: '',
                },
            ],
            playbookKeyMapping: {
                Product: ['ppgName'],
                '%TS': ['guidelinePercentageTotalSpends', 'percentageTotalSpends', 'lesser_than', '', '%'],
                Frequency: ['guidelineFrequency', 'frequency', 'range', ''],
                ROI: ['guidelineRoi', 'roi', 'greater_than', '', ''],
            },
            // comparisonOperator: {
            //     '%TS': '<',
            //     Frequency: 'range',
            //     ROI: '>',
            // },
            menuButtons: [
                { key: 'recommendations', label: 'Recommendations' },
                {
                    key: 'summary',
                    label: 'Summary',
                },
                {
                    key: 'playbook',
                    label: 'Playbook',
                },
            ],
            promoTypeColorMapping: {
                'tpr/scan': {
                    label: 'TPR/Scan',
                    color: colorConstants.lightGreenAlt,
                },
                feature_ad: {
                    label: 'Feature Ad',
                    color: colorConstants.darkGreenAlt2,
                },
                display: { label: 'Display', color: colorConstants.pinkAlt },
                feature_display_tpr: {
                    label: 'Feature_Display_TPR',
                    color: colorConstants.orangeAlt2,
                },
                display_tpr: {
                    label: 'Display_TPR',
                    color: colorConstants.darkBlueAlt,
                },
            },
            overlayKeys: [
                {
                    label: 'Start Date',
                    dataKey: 'startDate',
                    pre: '',
                    post: '',
                },
                { label: 'Duration', dataKey: 'duration', pre: '', post: '' },
                {
                    label: 'Promo Type',
                    dataKey: 'tacticDescription',
                    pre: '',
                    post: '',
                },
                { label: 'Product(s)', dataKey: 'dim1AttributeNames', pre: '', post: '' },
                {
                    label: 'Total Units',
                    dataKey: 'totalVolume',
                    pre: '',
                    post: '',
                    arrowConfig: 'positiveUp',
                },
                {
                    label: 'Total GSV',
                    dataKey: 'totalGsv',
                    pre: '$',
                    post: '',
                    arrowConfig: 'positiveUp',
                },
                {
                    label: 'Total NSV',
                    dataKey: 'totalNsv',
                    pre: '$',
                    post: '',
                    arrowConfig: 'positiveUp',
                },
                {
                    label: 'Total NB Profit',
                    dataKey: 'totalKindProfit',
                    pre: '$',
                    post: '',
                    arrowConfig: 'positiveUp',
                },
                {
                    label: 'Total Retailer Profit',
                    dataKey: 'totalRetailerProfit',
                    pre: '$',
                    post: '',
                    arrowConfig: 'positiveUp',
                },
                {
                    label: 'Promo Spends',
                    dataKey: 'promoSpends',
                    pre: '$',
                    post: '',
                    arrowConfig: 'negativeUp',
                },
                {
                    label: '% Trade Spends GSV',
                    dataKey: 'percentageTradeSpendsGsv',
                    pre: '',
                    post: '%',
                    arrowConfig: 'negativeUp',
                },
                {
                    label: '% Trade Spends NSV',
                    dataKey: 'percentageTradeSpendsNsv',
                    pre: '',
                    post: '%',
                    arrowConfig: 'negativeUp',
                },

                {
                    label: 'Incremental Units',
                    dataKey: 'incrementalVolume',
                    pre: '',
                    post: '',
                    arrowConfig: 'positiveUp',
                },
                {
                    label: 'Incremental GSV',
                    dataKey: 'incrementalGsv',
                    pre: '$',
                    post: '',
                    arrowConfig: 'positiveUp',
                },
                {
                    label: 'Incremental NSV',
                    dataKey: 'incrementalNsv',
                    pre: '$',
                    post: '',
                    arrowConfig: 'positiveUp',
                },
                {
                    label: 'Total NB Profit %',
                    dataKey: 'totalProfitPercentage',
                    pre: '',
                    post: '%',
                    arrowConfig: 'positiveUp',
                },
                {
                    label: 'Incremental MAC',
                    dataKey: 'incrementalProfit',
                    pre: '$',
                    post: '',
                    arrowConfig: 'positiveUp',
                },
                {
                    label: 'Promo ROI',
                    dataKey: 'roi',
                    pre: '',
                    post: '',
                    arrowConfig: 'positiveUp',
                },
                {
                    label: 'Retailer Incremental Profit',
                    dataKey: 'retailerIncrementalProfit',
                    pre: '$',
                    post: '',
                    arrowConfig: 'positiveUp',
                },
                // {
                //     label: 'Promo NSV Per Unit',
                //     dataKey: 'NSV Per Unit',
                //     pre: ' ',
                //     post: '',
                //     arrowConfig: 'positiveUp',
                // },
                // {
                //     label: 'GSV Per Unit',
                //     dataKey: 'GSV Per Unit',
                //     pre: ' ',
                //     post: '',
                //     arrowConfig: 'positiveUp',
                // },
                // {
                //     label: 'Promo MAC Per Unit',
                //     dataKey: 'MAC Per Unit',
                //     pre: ' ',
                //     post: '',
                //     arrowConfig: 'positiveUp',
                // },
                {
                    label: 'GSV Per Unit',
                    dataKey: 'gsvPerUnit',
                    pre: ' ',
                    post: '',
                    arrowConfig: 'positiveUp',
                },
                {
                    label: 'Base NSV Per Unit',
                    dataKey: 'baseNsvPerUnit',
                    pre: ' ',
                    post: '',
                    arrowConfig: 'positiveUp',
                },
                {
                    label: 'Base MAC Per Unit',
                    dataKey: 'macPromoUnit',
                    pre: ' ',
                    post: '',
                    arrowConfig: 'positiveUp',
                },
                {
                    label: 'Total NSV Per Unit',
                    dataKey: 'nsvPerUnit',
                    pre: ' ',
                    post: '',
                    arrowConfig: 'positiveUp',
                },

                {
                    label: 'Total MAC Per Unit',
                    dataKey: 'macPerUnit',
                    pre: ' ',
                    post: '',
                    arrowConfig: 'positiveUp',
                },
            ],
            spendLabel: {
                lump_sum: 'Lump Sum',
                per_qty: 'Per Qty',
                display: 'Display',
                feature: 'Feature',
            },
            offerMethodList: [
                { value: 'option', label: 'List of Option', dimension: 'dim1' },
                { value: 'manual', label: 'Manual', dimension: 'dim1' },
                { value: 'previous', label: 'Previous', dimension: 'dim1' },
            ],
            addEventList: [
                { value: 'new', label: 'Add New Event' },
                { value: 'import', label: 'Import Event' },
            ],
            leverKeys: [
                'promptEventName',
                'offerMethod',
                'discount',
                'startDate',
                'duration',
                'displayAcv',
                'featureAcv',
            ],
            spendTopForm: ['baseVolume', 'uplift', 'totalVolume', 'totalKindProfit', 'roi', 'totalRetailerProfit'],
            formList: [
                {
                    value: 'duration',
                    label: 'Duration',
                    inputRule: '',
                    placeHolder: 'Enter',
                },
                {
                    value: 'displayAcv',
                    label: 'Display ACV',
                    inputRule: '',
                    placeHolder: 'Enter display ACV',
                },
                {
                    value: 'featureAcv',
                    label: 'Feature ACV',
                    inputRule: '',
                    placeHolder: 'Enter feature ACV',
                },
            ],
            offerSelectionKeys: ['promotionMechanic', 'tacticDescription'],
            spendPerQtyKey: ['per_qty', 'redemption'],
        },
        priceLadder: {
            isThresholdDropdownEnabled: true,
            hideMraup: true,
            limit: 50, //update this when implementing infinite scroller
            dimensionConfig: {
                //snake case eg sub_category
                excludedDimensions: [],
                defaultDimension: 'Retailer',
            },
            tileData: [
                {
                    label: 'Product by Market',
                    key: 'product by market',
                },
                // {
                //     label: 'Product vs Competitors',
                //     key: 'product vs competitors',
                // },
            ],
            subTileData: [
                {
                    label: 'PU',
                    key: 'PU',
                },
                {
                    label: 'PEQ',
                    key: 'PEQ',
                },
            ],
            legendMapping: {
                PU: [
                    {
                        color: '#E6E6EA',
                        label: 'Sales $',
                        key: 'salesValueDollars',
                        dataKey: 'sales',
                        metricDataKey: 'units',
                    },
                    {
                        color: '#66AFBA',
                        label: 'Avg. Price PU',
                        key: 'avgPrice',
                        dataKey: 'avg_price_per_unit',
                        metricDataKey: 'units',
                    },
                    {
                        color: '#ECA586',
                        label: 'Max Price PU',
                        key: 'maxPrice',
                        dataKey: 'max_price_per_unit',
                        metricDataKey: 'units',
                    },
                    {
                        color: '#EB8FC5',
                        label: 'Min Price PU',
                        key: 'minPrice',
                        dataKey: 'min_price_per_unit',
                        metricDataKey: 'units',
                    },
                    {
                        color: '#F1C77A',
                        label: 'Promo Price PU',
                        key: 'promoPrice',
                        dataKey: 'promo_price_per_unit',
                        metricDataKey: 'units',
                    },
                    {
                        color: '#6771DB',
                        label: 'Base Price PU',
                        key: 'basePrice',
                        dataKey: 'base_price_per_unit',
                        metricDataKey: 'units',
                    },
                    // { color: '#5463FF', label: 'MRAUP', key: 'mraup', dataKey: 'mraup' },
                ],
                PEQ: [
                    {
                        color: '#E6E6EA',
                        label: 'Sales $',
                        key: 'salesValueDollars',
                        dataKey: '',
                        metricDataKey: 'volume',
                    },
                    {
                        color: '#66AFBA',
                        label: 'Avg. Price PEQ',
                        key: 'avgPrice',
                        dataKey: 'avg_price_per_eq',
                        metricDataKey: 'volume',
                    },
                    {
                        color: '#ECA586',
                        label: 'Max Price PEQ',
                        key: 'maxPrice',
                        dataKey: 'max_price_per_eq',
                        metricDataKey: 'volume',
                    },
                    {
                        color: '#EB8FC5',
                        label: 'Min Price PEQ',
                        key: 'minPrice',
                        dataKey: 'min_price_per_eq',
                        metricDataKey: 'volume',
                    },
                    {
                        color: '#F1C77A',
                        label: 'Promo Price PEQ',
                        key: 'promoPrice',
                        dataKey: 'promo_price_per_eq',
                        metricDataKey: 'volume',
                    },
                    {
                        color: '#6771DB',
                        label: 'Base Price PEQ',
                        key: 'basePrice',
                        dataKey: 'base_price_per_eq',
                        metricDataKey: 'volume',
                    },
                    // { color: '#5463FF', label: 'MRAUP', key: 'mraup', dataKey: 'mraup' },
                ],
            },
            dataKeyMapping: {
                PU: [
                    { label: 'Sales $', key: 'salesValueDollars' },
                    { label: 'Avg. Price PU', key: 'avgPrice' },
                    { label: 'Max Price PU', key: 'maxPrice' },
                    { label: 'Min Price PU', key: 'minPrice' },
                    { label: 'Promo Price PU', key: 'promoPrice' },
                    { label: 'Base Price PU', key: 'basePrice' },
                ],
                PEQ: [
                    { label: 'Sales $', key: 'salesValueDollars' },
                    { label: 'Avg. Price PEQ', key: 'avgPrice' },
                    { label: 'Max Price PEQ', key: 'maxPrice' },
                    { label: 'Min Price PEQ', key: 'minPrice' },
                    { label: 'Promo Price PEQ', key: 'promoPrice' },
                    { label: 'Base Price PEQ', key: 'basePrice' },
                ],
            },
            tableColumnLabelKeyMapping: {
                sales: { label: 'Sales $' },
                sales_percentage: { label: 'Sales %' },
                avg_price_pu: { label: 'Average Price $ PU' },
                avg_price_peq: { label: 'Average Price $ PEQ' },
                max_price_pu: { label: 'Max Price $ PU' },
                max_price_peq: { label: 'Max Price $ PEQ' },
                min_price_pu: { label: 'Min Price $ PU' },
                min_price_peq: { label: 'Min Price $ PEQ' },
                // mraup: { label: 'MRAUP' },
                base_price_pu: { label: 'Base Price $ PU' },
                base_price_peq: { label: 'Base Price $ PEQ' },
                promo_price_pu: { label: 'Promo Price $ PU' },
                promo_price_peq: { label: 'Promo Price $ PEQ' },
            },
            dropdown2Filter: ['Category', 'Pack_Size', 'Segment', 'Channel', 'Retailer'],
        },
        opportunityIdentification: {
            reversePpeAxis: true,
            bubbleCategoryOptions: [
                { value: 'brand', label: 'Brand', dimension: 'dim1' },
                { value: 'sub_brand', label: 'Sub Brand', dimension: 'dim1' },
                { value: 'category', label: 'Category', dimension: 'dim1' },
                {
                    value: 'sub_category',
                    label: 'Sub Category',
                    dimension: 'dim1',
                },
                { value: 'pack_size', label: 'Pack Size', dimension: 'dim1' },
                { value: 'product', label: 'Product', dimension: 'dim1' },
                { value: 'country', label: 'Country', dimension: 'dim2' },
                { value: 'channel', label: 'Channel', dimension: 'dim2' },
                { value: 'retailer', label: 'Retailer', dimension: 'dim2' },
                { value: 'division', label: 'Division', dimension: 'dim2' },
                { value: 'geography', label: 'Geography', dimension: 'dim2' },
            ],
            kpis: {
                xaxis: [
                    { label: 'BPE', value: 'bpe' },
                    { label: '% RSV Growth', value: 'rsv_growth' },
                    { label: 'MAC %', value: 'mac_percentage' },
                ],
                yaxis: [
                    { label: 'PPE', value: 'ppe' },
                    { label: '% RSV Growth', value: 'rsv_growth' },
                    { label: 'MAC %', value: 'mac_percentage' },
                ],
                bubbleSize: [
                    { label: 'Eq Volume', value: 'total_volume' },
                    { label: 'BPE', value: 'bpe' },
                    { label: 'PPE', value: 'ppe' },
                    { label: 'MAC', value: 'mac' },
                    { label: 'MAC %', value: 'mac_percentage' },
                    { label: 'RSV', value: 'rsv' },
                    { label: '% RSV Growth', value: 'rsv_growth' },
                ],
            },
            elasticityDriver: {
                chart2Limit: 100,
                levels: [
                    { label: 'Retailer', value: 'retailer', dimension: 'dim2' },
                    { label: 'Product', value: 'product', dimension: 'dim1' },
                    { label: 'Brand', value: 'brand', dimension: 'dim1' },
                    { label: 'Sub-brand', value: 'sub_brand', dimension: 'dim1' },
                    { value: 'category', label: 'Category', dimension: 'dim1' },
                    {
                        value: 'sub_category',
                        label: 'Sub Category',
                        dimension: 'dim1',
                    },
                ],
                limit: 50,
                offset: 0,
                dimension: 'dim1',
                legendMapping: [
                    {
                        dataKey: 'own',
                        label: 'Own Elasticity',
                        color: '#69D4E8',
                    },
                    {
                        dataKey: 'internal',
                        label: 'Internal Competitor Elasticity',
                        color: '#E469B2',
                    },
                    {
                        dataKey: 'external',
                        label: 'External Competitor Elasticity',
                        color: '#EDB44E',
                    },
                ],
            },
        },
        priceCurve: {
            chart1Limit: 100,
            xAxisKeyValue: [
                { value: 'pack_size', label: 'Pack Size' },
                { value: 'sub_brand', label: 'Sub Brand' },
                { value: 'count', label: 'Count' },
            ],
            YAxisKeyValue: [
                { value: 'retail_price', label: 'Retail Price' },
                { value: 'list_price', label: 'List Price' },
                { value: 'base_price', label: 'Base Price' },
            ],
            levels: [
                { value: 'brand', label: 'Brand' },
                { value: 'sub_brand', label: 'Sub Brand' },
                { value: 'sub_category', label: 'Sub Category' },
                { value: 'category', label: 'Category' },
                { value: 'manufacturer', label: 'Manufacturer' },
                { value: 'count', label: 'Count' },
                { value: 'ounces', label: 'Ounces' },
            ],
            subTileData: [
                {
                    label: 'PU',
                    key: 'PU',
                    dataKey: 'per_unit',
                },
                {
                    label: 'PEQ',
                    key: 'PEQ',
                    dataKey: 'per_eq',
                },
            ],
            chartColors: [
                '#E8A122',
                '#293BB8',
                '#E06936',
                '#19669D',
                '#A5582D',
                '#43C9E2',
                '#DD449F',
                '#37C7BE',
                '#9E5897',
                '#00798C',
                '#EDB44E',
                '#4557D5',
                '#E6875E',
                '#228BD6',
                '#CC7442',
                '#69D4E8',
                '#E469B2',
                '#5FD3CB',
                '#B377AD',
                '#3394A3',
                '#F1C77A',
                '#7381E0',
                '#ECA586',
                '#55A8E4',
                '#D89672',
                '#8EDFEE',
                '#EB8FC5',
                '#87DED8',
                '#C699C2',
                '#66AFBA',
                '#F6D9A7',
                '#A2ABEA',
                '#F3C3AF',
                '#8EC5ED',
                '#E5B9A1',
                '#B4E9F3',
                '#F1B4D9',
                '#AFE9E5',
                '#D9BBD6',
                '#99C9D1',
                '#FAECD3',
                '#D0D5F5',
                '#F9E1D7',
                '#C6E2F6',
                '#F2DCD0',
                '#D9F4F9',
                '#F8DAEC',
                '#D7F4F2',
                '#ECDDEB',
                '#CCE4E8',
            ],
            tableHeaders: [
                { label: 'List Price $', key: 'list_price' },
                { label: 'List Price $ YA', key: 'list_price_ya' },
                { label: 'Retail Price $', key: 'retail_price' },
                { label: 'Retail Price $ YA', key: 'retail_price_ya' },
                { label: 'Base Price $', key: 'base_price' },
                { label: 'Base Price $ YA', key: 'base_price_ya' },
            ],
        },
        pricePoint: {
            priceRange: [0, 10],
            graphColorScheme: ['#D7D6D9', '#66AFBA', '#ECA586', '#F1C77A', '#EB8FC5'],
            hideMraup: true,
            limit: 500,
            dimensionConfig: {
                //snake case eg sub_category
                excludedDimensions: [],
                defaultDimension: 'Manufacturer',
            },
            contributionThreshold: 5,
            priceTypeOptions: [
                { label: 'Avg Price', value: 'avg_price' },
                { label: 'Base Price', value: 'base_price' },
            ],
            subTileData: [
                {
                    label: 'PU',
                    key: 'per_unit',
                    xAxisLabel: 'Price Per Unit',
                    tooltip: 'Per Unit',
                },
                {
                    label: 'PEQ',
                    key: 'per_volume',
                    xAxisLabel: 'Price Per Eq',
                    tooltip: 'Per Eq Volume',
                },
            ],
            yAxisDropdownData: [
                {
                    label: 'Dollars',
                    value: 'value',
                },
                {
                    label: 'Volume',
                    value: 'volume',
                },
                {
                    label: 'Units',
                    value: 'units',
                },
            ],
            tableHeaderKeyMapping: {
                growth_percentage: ['Growth % vs YA', '', '%'],
                total_sales: ['Total Value ($)', '$', ''],
                total_volume: ['Total Volume', '', ''],
                total_units: ['Total Units', '', ''],
                avg_price_per_unit: ['Avg. Price per Unit', '$', ''],
                avg_price_per_eq: ['Avg. Price per EQ', '$', ''],
                base_price_per_unit: ['Base Price per Unit', '$', ''],
                base_price_per_eq: ['Base Price per EQ', '$', ''],
                acv_per_unit: ['Unit Velocity', '', ''],
                acv_per_value: ['EQ Velocity', '', ''],
            },
            drilldownTableHeaderKeyMapping: {
                growth_abs: ['Growth Abs', '$', ''],
                growth_percentage: ['Growth %', '', '%'],
                contribution_to_category: ['Contribution to category', '$', ''],
                cy_share: ['CY share', '', '%'],
                ya_share: ['YA share', '', '%'],
                change: ['Change %', '', '%'],
            },
            dropdown2Filter: ['Category', 'Pack_Size', 'Segment', 'Channel', 'Retailer'],
            customThresholdData: [
                {
                    id: 1,
                    value: '',
                },
                {
                    id: 2,
                    value: '',
                },
                {
                    id: 3,
                    value: '',
                },
                {
                    id: 4,
                    value: '',
                },
                {
                    id: 5,
                    value: '',
                },
            ],
        },
        priceTracking: {
            limit: 20,
            dimensionConfig: {
                //snake case eg sub_category
                excludedDimensions: ['segment', 'form', 'count', 'ounces'],
                defaultRowDimension: 'Product',
                defaultColumnDimension: 'Division',
            },
            attributeNamesLimit: 50,
            frequency: 'W',
            timePeriodOptions: [
                { label: 'YA', value: 'year_ago' },
                { label: 'Prior Period', value: 'prior_period' },
                { label: 'Custom Period', value: 'custom' },
            ],
            priceTypeOptions: [
                { label: 'Base Price', value: 'base' },
                { label: 'Avg Price', value: 'average' },
            ],
            kpiOptions: [
                { label: '% Change', value: 'percent_change' },
                { label: 'Price Index', value: 'index' },
            ],
            subTileData: [
                {
                    label: 'PU',
                    key: 'units',
                    xAxisLabel: 'Price Per Unit',
                    tooltip: 'Per Unit',
                },
                {
                    label: 'PEQ',
                    key: 'volume',
                    xAxisLabel: 'Price Per Eq',
                    tooltip: 'Per Eq Volume',
                },
            ],
            weeksOptions: [
                { label: 'L W1', value: 1 },
                { label: 'L W4', value: 4 },
                { label: 'L W12', value: 12 },
            ],
            monthsOptions: [
                { label: 'L M1', value: 1 },
                { label: 'L M3', value: 3 },
                { label: 'L M6', value: 6 },
                { label: 'L M12', value: 12 },
            ],
            quartersOptions: [
                { label: 'L Q1', value: 1 },
                { label: 'L Q2', value: 2 },
                { label: 'L Q4', value: 4 },
            ],
            kpiMapping: {
                'Base Price': ['$', ''],
                'Base Price YA': ['$', ''],
                'Avg Price': ['$', ''],
                'Avg Price YA': ['$', ''],
                'Base Price Index % Chg': ['', '%'],
                'Base Price % Chg': ['', '%'],
                'Avg Price Index % Chg': ['', '%'],
                'Avg Price % Chg': ['', '%'],
                'TDP % Chg': ['', '%'],
                TDP: ['', ''],
                'TDP YA': ['', ''],
                'Volume Velocity % Chg': ['', '%'],
                'Volume Velocity': ['', ''],
                'Volume Velocity YA': ['', ''],
            },
        },
        bestWeeks: {
            limit: 50,
            drilldownTableConfig: [
                { label: 'Period No:', value: 'period_no', sorting: false },
                { label: 'Year', value: 'year', sorting: false },
            ],
            dimensionConfig: {
                //snake case eg sub_category
                excludedDimensions: ['dim2'],
                defaultDimension: 'Brand',
            },
            rankingCriteriaOptions: [
                { label: 'Base Volume', value: 'base_eq_volume' },
                { label: 'ACV', value: 'total_per_acv_dist' },
                { label: 'Incremental Volume', value: 'incremental_eq_volume' },
                { label: 'Total Volume', value: 'total_eq_volume' },
            ],
        },
    },
    gp: {
        //COMMON CONFIG
        commonConfig: {
            clientName: 'GP',
            handleDim2SortingFromFrontend: false,
            dateFormat: 'MM/DD/YYYY',
            dateFormatAlt: 'MM/DD/YY',
            calenderStartDay: 'Sunday',
            showSecondaryLogo: false,
            showLogoInNavbar: true,
            logoHeight: '32px',
            logoWidth: '162px',
            loginPageTextPart1: 'Welcome to the',
            loginPageTextPart2: 'RGM Hub',
            width: window.innerWidth,
            limit: 10,
            offset: 0,
            lagList: [0, 1],
            graphFontSize: calculateFontSize(window.innerWidth, 13),
            graphFontSizeAlt: calculateFontSize(window.innerWidth, 13),
            graphFontFamily: "'Helvetica Neue', sans-serif",
            graphLabelColorAlt: '#4E4C55',
            graphLabelColor: '#433C4A',
            units: {
                currency: '$',
                volume: 'Eq Vol',
                currencyText: 'Dollar',
            },
            filterFormat: { dim1: { ids: [] }, dim2: { ids: [] } },
            frequency: 'W',
            showCampignCalender: false,
            showFullLabel: true,
            decimalForPercentage: 1,
            decimalForNonPercentage: 2,
        },
        latestDateForDifferentRoutes: {
            'promo-score-card': 'Promotion Data',
            'roi-analysis': 'Promotion Data',
            'roi-tracker': 'Promotion Data',
            'promo-recommendation': 'Promotion Data',
            default: 'POS Data',
        },
        screenDetailsWithRoutes: [
            {
                label: 'Growth Analysis',
                path: 'promo/category-diagnostics/growth-analysis',
                id: 'ga',
                pageId: 'ga',
            },
            {
                label: 'Bump Report',
                path: 'promo/category-diagnostics/bump-report',
                id: 'br',
                pageId: 'br',
            },
            {
                label: 'Performance Scorecard',
                path: 'promo/category-diagnostics/promo-score-card',
                id: 'ps',
                pageId: 'ps',
            },
            // {
            //     label: 'PVM Analysis',
            //     path: 'promo/category-diagnostics/pvm-analysis',
            //     id: 'pvm',
            //     pageId: 'pvm',
            // },
            {
                label: 'Price Change',
                path: 'pricing/analytics/price-change',
                id: 'pcn',
                pageId: 'pcn',
            },
            {
                label: 'Price Point',
                path: 'pricing/analytics/price-point',
                id: 'pp',
                pageId: 'pp',
            },
            {
                label: 'Price Ladder',
                path: 'pricing/analytics/price-ladder',
                id: 'pld',
                pageId: 'pld',
            },
            {
                label: 'Price Curve',
                path: 'pricing/analytics/price-curve',
                id: 'pc',
                pageId: 'pc',
            },
            {
                label: 'Price Tracking',
                path: 'pricing/analytics/price-tracking',
                id: 'pt',
                pageId: 'pt',
            },
            {
                label: 'Opportunity Identification',
                path: 'pricing/analytics/opportunity-identification',
                id: 'oi',
                pageId: 'oi',
            },
            {
                label: 'Investment & MPIC Tracker',
                path: 'promo/analytics/roi-tracker',
                id: 'pl',
                pageId: 'pl',
            },
            {
                label: 'Promo MPIC Analysis',
                path: 'promo/analytics/roi-analysis',
                id: 'pa',
                pageId: 'pa',
            },
            // {
            //     label: 'Promo Recommendation',
            //     path: 'promo/recommendation/promo-recommendation',
            //     id: 'pr',
            //     pageId: 'pr',
            // },
            {
                label: 'Pricing Simulator',
                path: 'pricing/recommendation/pricing-simulator',
                id: 'psrV2', //update id in simulator context as well
                pageId: 'psrV2',
            },
            {
                label: 'Pricing Simulator',
                path: 'pricing/recommendation/pricing-simulator/:mode/:projectId/scenario/:scenarioId',
                id: 'psr',
                pageId: 'psrV2Update',
            },
            {
                label: 'Pricing Simulator',
                path: 'pricing/recommendation/pricing-simulator/:mode/:projectId/scenario/:scenarioId',
                id: 'psr',
                pageId: 'psrV2View',
            },
            {
                label: 'Pricing Analytics',
                path: 'pricing/recommendation/pricing-analytics',
                id: 'psa',
                pageId: 'psa', // pricing analytics
            },
            {
                label: 'Pricing Analytics',
                path: 'pricing/recommendation/pricing-analytics/:mode/:reportId',
                id: 'psa',
                pageId: 'psaUpdate', // pricing analytics update
            },
            {
                label: 'Pricing Analytics',
                path: 'pricing/recommendation/pricing-analytics/:mode/:reportId',
                id: 'psa',
                pageId: 'psaView', // pricing analytics view
            },
            // {
            //     label: 'Trade Promo Optimization',
            //     path: 'promo/recommendation/tpo',
            //     id: 'tpo',
            //     pageId: 'tpo',
            //     subRoutes: [
            //         {
            //             suffix: 'plan',
            //             pageId: 'plan', // dynamic route for update and view
            //         },
            //         {
            //             suffix: 'plan/:mode/:planId',
            //             pageId: 'viewUpdatePlan', // dynamic route for update and view
            //         },
            //         {
            //             suffix: 'tool/best-weeks',
            //             pageId: 'bestWeeksTool',
            //         },
            //         {
            //             suffix: 'tool/playbook',
            //             pageId: 'playbookTool',
            //         },
            //         {
            //             suffix: 'tool/promo-library',
            //             pageId: 'promoLibraryTool',
            //         },
            //         {
            //             suffix: 'report',
            //             pageId: 'report',
            //         },
            //     ],
            // },
            // {
            //     label: 'Pricing Simulator',
            //     path: 'pricing/recommendation/price-simulator',
            //     id: 'psr',
            //     pageId: 'psr',
            // },
            // {
            //     label: 'Pricing Simulator',
            //     path: 'pricing/recommendation/price-simulator/new',
            //     id: 'psr',
            //     pageId: 'psrNew',
            // },
            // {
            //     label: 'Pricing Simulator',
            //     path: 'pricing/recommendation/price-simulator/edit/:id',
            //     id: 'psr',
            //     pageId: 'psrEdit',
            // },
            // {
            //     label: 'Pricing Simulator',
            //     path: 'pricing/recommendation/price-simulator/view/:id',
            //     id: 'psr',
            //     pageId: 'psrView',
            // },
            {
                label: 'Best Weeks',
                path: 'promo/recommendation/best-weeks',
                id: 'bw',
                pageId: 'bw',
            },
        ],
        screens: [
            {
                label: 'Category Diagnostics',
                path: ['promo/category-diagnostics'],
                showSubHeader: false,
                options: {
                    Promo: [
                        {
                            label: 'Growth Analysis',
                            path: 'growth-analysis',
                            id: 'ga',
                        },
                        { label: 'Bump Report', path: 'bump-report', id: 'br' },
                        {
                            label: 'Performance Scorecard',
                            path: 'promo-score-card',
                            id: 'ps',
                        },
                    ],
                    visible: false,
                },
            },
            {
                label: 'Pricing Diagnostics',
                path: ['pricing/analytics', null],
                showSubHeader: false,
                options: {
                    Promo: [
                        {
                            label: 'Price Change',
                            path: 'price-change',
                            id: 'pcn',
                        },
                        { label: 'Price Point', path: 'price-point', id: 'pp' },
                        {
                            label: 'Price Ladder',
                            path: 'price-ladder',
                            id: 'pld',
                        },
                        { label: 'Price Curve', path: 'price-curve', id: 'pc' },
                        {
                            label: 'Price Tracking',
                            path: 'price-tracking',
                            id: 'pt',
                        },
                        {
                            label: 'Opportunity Identification',
                            path: 'opportunity-identification',
                            id: 'oi',
                        },
                    ],
                    visible: false,
                },
            },
            // {
            //     label: 'Promo Analytics',
            //     path: ['promo/analytics', null],
            //     showSubHeader: false,
            //     options: {
            //         Promo: [
            //             {
            //                 label: 'Promo Scorecard',
            //                 path: 'promo-score-card',
            //                 id: 'ps',
            //             },
            //             {
            //                 label: 'Investment & ROI Tracker',
            //                 path: 'roi-tracker',
            //                 id: 'pl',
            //             },
            //             {
            //                 label: 'Promo ROI Analysis',
            //                 path: 'roi-analysis',
            //                 id: 'pa',
            {
                label: 'Promo Diagnostics',
                path: ['promo/analytics', null],
                showSubHeader: false,
                options: {
                    Promo: [
                        {
                            label: 'Investment & MPIC Tracker',
                            path: 'roi-tracker',
                            id: 'pl',
                        },
                        {
                            label: 'Promo MPIC Analysis',
                            path: 'roi-analysis',
                            id: 'pa',
                        },
                    ],
                    visible: false,
                },
            },
            // {
            //     label: 'Price & Promo Modeling',
            //     path: ['promo/recommendation', 'pricing/recommendation'],
            //     showSubHeader: true,
            //     options: {
            //         Promo: [
            //             {
            //                 label: 'Promo Recommendation',
            //                 path: 'promo-recommendation',
            //                 id: 'pr',
            //             },
            // {
            //     label: 'Best Weeks',
            //     path: 'best-weeks',
            //     id: 'bw',
            // },
            //         ],
            //         Pricing: [
            //             {
            //                 label: 'Pricing Simulator',
            //                 path: 'price-simulator',
            //                 id: 'psr',
            //             },
            //         ],
            //         visible: false,
            //     },
            // },
            {
                label: 'Price & Promo Modeling',
                path: ['promo/recommendation', 'pricing/recommendation'],
                showSubHeader: true,
                options: {
                    Promo: [
                        // {
                        //     label: 'Trade Promo Optimization',
                        //     path: 'tpo',
                        //     id: 'tpo',
                        // },
                        {
                            label: 'Best Weeks',
                            path: 'best-weeks',
                            id: 'bw',
                        },
                    ],
                    // Pricing: [{ label: 'Pricing Simulator', path: 'pricing-simulator', id: 'psrV2' }],
                    visible: false,
                },
            },
        ],
        globalFilter: {
            presetConfig: {
                disablePresetFilter: false,
                presetEnabledRoutes: {
                    all: true,
                },
            },
            availableFrequenciesList: [{ key: 'W', label: 'Week' }],
            globalFilterChangingRoutes: {
                //the keys should be equal to the final/last path of the screen
                'roi-tracker': {
                    dimensionListKey: 'promo_diagnostics',
                    getGlobalTimestampsKey: 'promo_diagnostics',
                    getMaxTimestampsKey: 'promo_diagnostics',
                    getAttributeNamesKey: 'promo_diagnostics',
                    groupKey: 'promo_diagnostics',
                    calenderStartDay: 'Monday',
                    defaultGlobalFilterObj: {
                        dim1: {
                            Product_Category: {
                                inclusion: [
                                    {
                                        dimension: 'dim1',
                                        isActive: true,
                                        attributeType: 'Product_Category',
                                        attributeDesc: 'LIVINGWARE',
                                        attributeExId: 'LIVINGWARE',
                                    },
                                ],
                            },
                        },
                        dim2: {},
                        dim3: {},
                    },
                },
                'roi-analysis': {
                    dimensionListKey: 'promo_diagnostics',
                    getAttributeNamesKey: 'promo_diagnostics',
                    getGlobalTimestampsKey: 'promo_diagnostics',
                    getMaxTimestampsKey: 'promo_diagnostics',
                    groupKey: 'promo_diagnostics',
                    calenderStartDay: 'Monday',
                    defaultGlobalFilterObj: {
                        dim1: {
                            Product_Category: {
                                inclusion: [
                                    {
                                        dimension: 'dim1',
                                        isActive: true,
                                        attributeType: 'Product_Category',
                                        attributeDesc: 'LIVINGWARE',
                                        attributeExId: 'LIVINGWARE',
                                    },
                                ],
                            },
                        },
                        dim2: {},
                        dim3: {},
                    },
                },
            },
            limit: 50,
            selectionAllowed: {
                'promo-recommendation': {
                    dim2: {
                        Retailer: 1,
                    },
                },
            },
            allSelectedLimit: 15,
            timePeriodScreenMapping: {
                default: ['4W', '13W', '26W', '52W', '1M', '3M', '6M', '12M', '1Q', '2Q', '4Q', 'YTD', 'CUSTOM DATE'],
                'bump-report': ['52W', '104W', '156W', '1M', '3M', '6M', '12M', '1Q', '2Q', '4Q', 'YTD', 'CUSTOM DATE'],
            },

            defaultPeriod: ['52W'],
            applyFilterApiPostFormat: {
                jsonstring_dim1: '{}',
                jsonstring_dim2: '{}',
            },
            defaultPreviousIdObject: {
                dim1: ['attr', 'attr'],
                dim2: ['attr', 'attr'],
            },
            defaultIdObject: {
                dim1: { ids: [] },
                dim2: { ids: [] },
            },
            defaultAttrIdObject: {
                attr: {
                    dim1: { ids: [] },
                    dim2: { ids: [] },
                },
            },
            promoScoreCardDefault: {
                Category: 'CONS BATH TISSUE',
            },
            retainFiltersAcrossFeatures: false,
            PromoScoreCardDefaultObj: {
                dim1: {
                    Category: {
                        inclusion: [
                            {
                                dimension: 'dim1',
                                isAttribute: true,
                                isActive: true,
                                attributeType: 'Category',
                                attributeDesc: 'CONS BATH TISSUE',
                                attributeExId: 'CONS BATH TISSUE',
                                count: 1,
                                __typename: 'AttributeDetails',
                            },
                        ],
                    },
                },
                dim2: {
                    geography: {
                        inclusion: [
                            {
                                dimension: 'dim2',
                                isAttribute: true,
                                isActive: true,
                                attributeType: 'geography',
                                attributeDesc: 'Total US - Multi Outlet+',
                                attributeExId: 'Total US - Multi Outlet+',
                                count: 1,
                                __typename: 'AttributeDetails',
                            },
                        ],
                    },
                },
            },
        },
        priceSimulator: {
            dataSources: [
                { label: 'Projected Consumption', value: 'iri' },
                { label: 'Consumption Actuals', value: 'l52_weeks' },
                { label: 'Financials', value: 'financials' },
            ],
            allScenariosTableLimit: 500,
            a: 10,
            opportunityIdentificationTiles: [
                { key: 'recommendation', label: 'Recommendation' },
                { key: 'input', label: 'Input' },
                { key: 'output', label: 'Output' },
            ],
            cascadingColumns: ['COGS Rate', 'List Price', 'Everyday Retail Price'], // this should match with input key mapping and price simulator input columns
            levels: ['product', 'retailer'],
            inputKeyMapping: {
                // keep the order accuretly, to get it in multiselect
                cogs: 'COGS Rate',
                lp: 'List Price',
                rp: 'Everyday Retail Price',
                acv: 'ACV Distribution',
                oi: 'OI Rate',
                non_oi: 'Non OI Rate',
                promo_trade_spends: 'Promo Trade Rate Spends',
                tr: 'Trade Rate',
                cf: 'Comp Follow',
            },
            outputKeyMapping: {
                volume: {
                    label: 'New Volume',
                    pre: '',
                    pos: '',
                },
                volume_old: {
                    label: 'Current Volume',
                    pre: '',
                    pos: '',
                },
                vlmChg: {
                    label: 'Volume Chg %',
                    pre: '',
                    pos: '%',
                },
                units: {
                    label: 'New Units',
                    pre: '',
                    pos: '',
                },
                units_old: {
                    label: 'Current Units',
                    pre: '',
                    pos: '',
                },
                unitsChg: {
                    label: 'Units Chg %',
                    pre: '',
                    pos: '%',
                },
                rsv: {
                    label: 'New RSV',
                    pre: '$',
                    pos: '',
                },
                rsv_old: {
                    label: 'Current RSV',
                    pre: '$',
                    pos: '',
                },
                rsvChg: {
                    label: 'RSV Chg %',
                    pre: '',
                    pos: '%',
                },
                gsv: {
                    label: 'New GSV',
                    pre: '$',
                    pos: '',
                },
                gsv_old: {
                    label: 'Current GSV',
                    pre: '$',
                    pos: '',
                },
                gsvChg: {
                    label: 'GSV Chg %',
                    pre: '',
                    pos: '%',
                },
                nsv: {
                    label: 'New NSV',
                    pre: '$',
                    pos: '',
                },
                nsv_old: {
                    label: 'Current NSV',
                    pre: '$',
                    pos: '',
                },
                nsvChg: {
                    label: 'NSV Chg %',
                    pre: '',
                    pos: '%',
                },
                gmac: {
                    label: 'New GMAC',
                    pre: '$',
                    pos: '',
                },
                gmac_old: {
                    label: 'Current GMAC',
                    pre: '$',
                    pos: '',
                },
                gmacChg: {
                    label: 'GMAC Chg %',
                    pre: '',
                    pos: '%',
                },
                rtMg: {
                    label: 'New Retail Margin %',
                    pre: '',
                    pos: '%',
                },
                rtMg_old: {
                    label: 'Current Retail Margin %',
                    pre: '',
                    pos: '%',
                },
                rtMgPcChg: {
                    label: 'Retail Margin Chg %',
                    pre: '',
                    pos: '%',
                },
                retailer_profit: {
                    label: 'New Retail Profit',
                    pre: '',
                    pos: '',
                },
                retailer_profit_old: {
                    label: 'Current Retail Profit',
                    pre: '',
                    pos: '',
                },
                rtPfChg: {
                    label: 'Retail Profit Chg %',
                    pre: '',
                    pos: '%',
                },
                netRpChg: {
                    label: 'Net Effective Price % Chg',
                    pre: '',
                    pos: '%',
                },
                mgPc: {
                    label: 'New Margin %',
                    pre: '',
                    pos: '%',
                },
                mgPc_old: {
                    label: 'Current Margin %',
                    pre: '',
                    pos: '%',
                },
                mgPcChg: {
                    label: 'Margin Chg %',
                    pre: '',
                    pos: '%',
                },
                profitPool: {
                    label: 'New Profit Pool',
                    pre: '',
                    pos: '%',
                },
                profitPool_old: {
                    label: 'Current Profit Pool',
                    pre: '',
                    pos: '%',
                },
                profitPoolChg: {
                    label: 'Profit Pool Chg %',
                    pre: '',
                    pos: '$',
                },
                oi_cp: {
                    label: 'Current OI Rate',
                    pre: '',
                    pos: '%',
                },
                oi_np: {
                    label: 'New OI Rate',
                    pre: '',
                    pos: '',
                },
                oi_pc: {
                    label: 'OI Rate Chg %',
                    pre: '',
                    pos: '%',
                },
                non_oi_cp: {
                    label: 'Current Non OI Rate',
                    pre: '',
                    pos: '',
                },
                non_oi_np: {
                    label: 'New Non OI Rate',
                    pre: '',
                    pos: '',
                },
                non_oi_pc: {
                    label: 'Non OI Rate Chg %',
                    pre: '',
                    pos: '%',
                },
                promo_trade_spends_cp: {
                    label: 'Current Promo Trade Rate Spends',
                    pre: '',
                    pos: '',
                },
                promo_trade_spends_np: {
                    label: 'Current Promo Trade Rate Spends',
                    pre: '',
                    pos: '',
                },
                promo_trade_spends_pc: {
                    label: 'Promo Trade Rate Spends Chg %',
                    pre: '',
                    pos: '%',
                },
                tr_cp: {
                    label: 'Current Trade Rate',
                    pre: '',
                    pos: '',
                },
                tr_np: {
                    label: 'New Trade Rate',
                    pre: '',
                    pos: '',
                },
                tr_pc: {
                    label: 'Trade Rate Chg %',
                    pre: '',
                    pos: '%',
                },
            },
            recommendationKeyMapping: {
                recommended_list_price: {
                    label: 'New list price recom',
                    pre: '$',
                    pos: '',
                },
                role: {
                    label: 'Role',
                    pre: '',
                    pos: '',
                },
                strategy: {
                    label: 'Strategy',
                    pre: '',
                    pos: '',
                },
                mix: {
                    label: 'Mix',
                    pre: '',
                    pos: '',
                },
                growth: {
                    label: 'Growth',
                    pre: '',
                    pos: '',
                },
                gap: {
                    label: 'Gap',
                    pre: '',
                    pos: '',
                },

                cogs: {
                    label: 'COGs',
                    pre: '',
                    pos: '%',
                },
                list_to_retail: {
                    label: 'List to Retail',
                    pre: '',
                    pos: '',
                },
                bpe: {
                    label: 'BPE',
                    pre: '',
                    pos: '',
                },
                ppe: {
                    label: 'PPE',
                    pre: '',
                    pos: '',
                },
                margin: {
                    label: 'Margin',
                    pre: '',
                    pos: '%',
                },
                growth_vs_category: {
                    label: 'Gowth vs Category',
                    pre: '',
                    pos: '%',
                },
                pl_vs_category: {
                    label: 'PL vs Category',
                    pre: '',
                    pos: '%',
                },
                threshold: {
                    label: 'Threshold',
                    pre: '',
                    pos: '',
                },
                comp_index: {
                    label: 'Comp. Index',
                    pre: '',
                    pos: '',
                },
                curve_index: {
                    label: 'Curve Index',
                    pre: '',
                    pos: '',
                },
                cogs_realization: {
                    label: 'COGS & Realization',
                    pre: '',
                    pos: '',
                },
                cogs_forecast: {
                    label: 'COGS Forecast',
                    pre: '',
                    pos: '%',
                },
                net_to_retail: {
                    label: 'Net to Retail',
                    pre: '',
                    pos: '%',
                },
                gross_to_net: {
                    label: 'Gross to Net',
                    pre: '',
                    pos: '%',
                },
            },
            defaultKpiMetrics: [1, 2, 3, 4, 5],
            kpiMetrics: [
                {
                    key: 1,
                    value: 'volume_sales',
                    name: 'GP Volume Sales',
                    pre: '',
                    post: '',
                    decimalToRoundOff: 0,
                },
                {
                    key: 2,
                    value: 'value_sales',
                    name: 'GP Value Sales ($)',
                    pre: '$',
                    post: '',
                    decimalToRoundOff: 0,
                },
                {
                    key: 3,
                    value: 'profit_abs',
                    name: 'GP Profit Abs ($)',
                    pre: '$',
                    post: '',
                    decimalToRoundOff: 0,
                },
                {
                    key: 4,
                    value: 'margin_percent',
                    name: 'GP Margin (%)',
                    pre: '',
                    post: '%',
                    decimalToRoundOff: 2,
                },
                {
                    key: 5,
                    value: 'trade_rate_percent',
                    name: 'GP Trade Rate (%)',
                    pre: '',
                    post: '%',
                    decimalToRoundOff: 2,
                },
                {
                    key: 6,
                    value: 'retailer_margin_percent',
                    name: 'GP Retailer Margin (%)',
                    pre: '',
                    post: '%',
                    decimalToRoundOff: 2,
                },
                {
                    key: 7,
                    value: 'gross_profit',
                    name: 'GP Gross Profit ($)',
                    pre: '$',
                    post: '',
                    decimalToRoundOff: 0,
                },
                {
                    key: 8,
                    value: 'retailer_profit',
                    name: 'GP Retailer Profit ($)',
                    pre: '$',
                    post: '',
                    decimalToRoundOff: 0,
                },
                {
                    key: 9,
                    value: 'gross_sales',
                    name: 'GP Gross Sales ($)',
                    pre: '$',
                    post: '',
                    decimalToRoundOff: 0,
                },
                {
                    key: 10,
                    value: 'net_sales',
                    name: 'GP Net Sales($)',
                    pre: '$',
                    post: '',
                    decimalToRoundOff: 0,
                },
                {
                    key: 11,
                    value: 'total_volume',
                    name: 'Total Volume Sales',
                    pre: '$',
                    post: '',
                    decimalToRoundOff: 0,
                },
                {
                    key: 12,
                    value: 'total_value',
                    name: 'Total Value Sales($)',
                    pre: '$',
                    post: '',
                    decimalToRoundOff: 0,
                },
                {
                    key: 13,
                    value: 'net_retail_price_change',
                    name: 'GP Net Retailer Price % Chg',
                    pre: '',
                    post: '%',
                    decimalToRoundOff: 2,
                },
            ],
            addPortfolioUpdateKpis: [
                {
                    key: 'volume',
                    value: '',
                    label: 'Volume',
                    rval: '',
                    percentChange: '',
                },
                {
                    key: 'value',
                    value: '',
                    label: 'Value',
                    rval: '',
                    percentChange: '',
                },
                {
                    key: 'units',
                    value: '',
                    label: 'Units',
                    rval: '',
                    percentChange: '',
                },
                {
                    key: 'trade_rate',
                    value: '',
                    label: 'Trade Rate %',
                    rval: '',
                    percentChange: '',
                },
                {
                    key: 'list_price',
                    value: '',
                    label: 'List Price per unit',
                    rval: '',
                    percentChange: '',
                },
                {
                    key: 'retail_price',
                    value: '',
                    label: 'Retail Price per unit',
                    rval: '',
                    percentChange: '',
                },
                {
                    key: 'acv',
                    value: '',
                    label: 'ACV Distribution %',
                    rval: '',
                    percentChange: '',
                },
                {
                    key: 'cogs',
                    value: '',
                    label: 'COGS per unit',
                    rval: '',
                    percentChange: '',
                },
                {
                    key: 'base_elasticity',
                    value: '',
                    label: 'Base Elasticity',
                    rval: '',
                    percentChange: '',
                },
                {
                    key: 'acv_elasticity',
                    value: '',
                    label: 'Acv Elasticity',
                    rval: '',
                    percentChange: '',
                },
            ],
            quarterMetricKeyMapping: [
                {
                    name: 'Volume',
                    value: 'volume',
                    pre: '',
                    post: '',
                },
                {
                    name: 'Revenue',
                    value: 'revenue',
                    pre: '$',
                    post: '',
                },
                {
                    name: 'Profit',
                    value: 'profit',
                    pre: '$',
                    post: '',
                },
                {
                    name: 'Trade Rate Percent',
                    value: 'tradeRatePercent',
                    pre: '',
                    post: '%',
                },
                {
                    name: 'Retailer Margin',
                    value: 'retailerMargin',
                    pre: '',
                    post: '',
                },
            ],
        },
        pricingSimulator: {
            enableAnalyticsTab: true,
            enableBulkUpload: false,
            indexPageTableLimit: 50,
            scenarioFilterOffsetLimit: 50,
            scenarioPerProjectLimit: 10,
            scenarioTableLimit: 500,
            analyticsChartLimit: 100,
            comparisonTableLimit: 50,
            dimAttributesLimit: 7,
            characterLimit: {
                kpiTileCharLimit: 22,
                kpiCompareCardLimit: 30,
            },
            enablePrivatePublicToggle: true,
            enableMicroInfoForTables: true,
            enableOneChangeAnalyticsChart: false,
            defaultGlobalKpiCount: 6,
            disableExport: false,
            indexTableFixedColumns: [
                { label: 'Project Name', key: 'projectName', sortKey: 'project_name' },
                { label: 'Created By', key: 'createdBy', sortKey: 'created_by' },
                { label: 'Status', key: 'status' },
                { label: 'Last Updated', key: 'lastUpdated', sortKey: 'updated_at' },
                { label: 'Simulation Period', key: 'simulationPeriod' },
                { label: 'Price Effective Date', key: 'priceEffectiveDate' },
            ],
            analyticsBaseScenarioFixedColumns: [
                { label: 'Project Name', key: 'projectName', sortKey: 'project_name' },
                { label: 'Created By', key: 'createdBy', sortKey: 'created_by' },
                { label: 'Status', key: 'status' },
            ],
            analyticsTableColumns: [
                { label: 'Report Name', key: 'reportName', sortKey: 'report_name' },
                { label: 'Base Scenario', key: 'baseScenario', sortKey: 'base_scenario' },
                { label: 'Created By', key: 'createdBy', sortKey: 'created_by' },
                { label: 'Last Updated', key: 'lastUpdated', sortKey: 'updated_at' },
                { label: 'Date Created', key: 'dateCreated', sortKey: 'created_at' },
            ],
            projectStatuses: {
                ACTIVE: { label: 'Active', colorType: 'success' },
                DRAFT: { label: 'Draft', colorType: 'processing' },
                SETUP: { label: 'Setup', colorType: 'processing' },
                IN_PROGRESS: { label: 'In-Progress', colorType: 'processing' },
                EXPIRED: { label: 'Expired', colorType: 'default' },
                ERROR: { label: 'Error', colorType: 'error' },
                INVALID: { label: 'Invalid', colorType: 'error' },
            },
            projectDataSource: [{ label: 'Circana', value: 'depletion_data' }],
            simulatedPeriodItems: [
                { label: 'Custom Date', value: 'custom_date', dateArray: null },
                { label: 'Current Year', value: 'current_year', dateArray: ['01-05-2025', '12-28-2025'] },
                // { label: 'Financial Year', value: 'financial_year', dateArray: ['03-02-2025', '02-22-2026'] },
            ],
            iconsMappings: {
                Elasticity: 'BorderOuterOutlined',
                BaseInput: 'BorderlessTableOutlined',
                COGS: 'DollarOutlined',
                Distributor: 'BuildOutlined',
                'Distributor P&L': 'BuildOutlined',
                FOB: 'ClusterOutlined',
                'P&L': 'LineChartOutlined',
                Price: 'MoneyCollectOutlined',
                Promotions: 'BoxPlotOutlined',
                'Retailer P&L': 'LineChartOutlined',
                Sales: 'AreaChartOutlined',
                Taxes: 'BlockOutlined',
                Volume: 'ExperimentOutlined',
                Others: 'UngroupOutlined',
                Product: 'GoldOutlined',
                Geo: 'ExpandOutlined',
                'Dollar Impact': 'DollarOutlined',
                'Standard Increase Metrics': 'ToTopOutlined',
                'EQV Metrics': 'BlockOutlined',
            },
            categoryMovementKpis: [
                { label: 'Units Impact', value: 'units', yAxisLabel: 'unit', xAxisLabel: 'Total Units' },
                { label: 'Sales Impact', value: 'sales', yAxisLabel: 'Sales $', xAxisLabel: 'Retailer Sales $' },
            ],
        },
        tradePromoOptimization: {
            indexPageTableLimit: 50,
            offerDataDropdownLimit: 100,
            attributesListLimit: 100,
            tableLimit: 100,
            enableMultiSelectDim1: false,
            enableMultiSelectDim2: false,
            defaultDisplayACV: 80,
            defaultFeatureACV: 80,
            plansIndexTableFixedColumns: [
                { label: '', key: 'last_optimised_status', sortKey: null },
                { label: 'Plan Name', key: 'plan_name', sortKey: 'plan_name' },
                { label: 'Created By', key: 'created_by', sortKey: 'created_by' },
                { label: 'Year of plan', key: 'plan_year', sortKey: 'plan_year' },
                { label: 'Status', key: 'status' },
                { label: 'Last Updated', key: 'updated_at', sortKey: 'updated_at' },
                { label: 'TPM Last Sync', key: 'tpm_last_sync_date', sort: 'tpm_last_sync_date' },
                { label: 'Date Created', key: 'created_at', sortKey: 'created_at' },
                { label: '', key: 'edit', sortKey: null },
            ],
            dim1Attribute: { label: 'Product Category', key: 'product_category', dimension: 'dim1' },
            dim2Attribute: { label: 'Customer', key: 'customer_name', dimension: 'dim2' },
            eventDim1Attribute: { label: 'Brand', key: 'brand', dimension: 'dim1' },
            eventDim1NestedAttribute: { label: 'Material Group', key: 'material_group', dimension: 'dim1' },
            playbookAttributeTypes: [{ label: 'Customer', key: 'customer_name', sortKey: false }],
            promoLibraryAttributeTypes: [
                {
                    label: 'Material Group Name',
                    key: 'material_group_name',
                    dimension: 'dim1',
                    sortKey: 'material_group_name',
                },
                { label: 'Customer', dimension: 'dim2', key: 'customer_name', sortKey: 'customer_name' },
            ],
            mechanicsLibraryAttributeTypes: [
                { label: 'Product Category', key: 'product_category', dimension: 'dim1', sortKey: 'product_category' },
                { label: 'Customer', dimension: 'dim2', key: 'customer_name', sortKey: 'customer_name' },
            ],
            promoLibraryExportThreshold: 100000,
            dimensionDropdownList: [
                {
                    label: 'Event',
                    value: 'event',
                    tableHeader: 'Event',
                    dataKey: 'event_name',
                    sortKey: false,
                    isDefault: true,
                },
                {
                    label: 'Promo',
                    value: 'promo',
                    tableHeader: 'Promo',
                    dataKey: 'promo_name',
                    sortKey: false,
                    isDefault: true,
                },
                {
                    label: 'Material Group Name',
                    value: 'material_group_name',
                    tableHeader: 'Material Group Name',
                    dataKey: 'material_group_name',
                    sortKey: false,
                    isDefault: true,
                },
            ],
            planViewDropdownList: [
                {
                    label: 'Plan',
                    value: 'plan',
                    tableHeader: 'Plan',
                    dataKey: 'plan_name',
                    sortKey: false,
                    isDefault: true,
                },

                {
                    label: 'Material Group Name',
                    value: 'material_group_name',
                    tableHeader: 'Material Group Name',
                    dataKey: 'material_group_name',
                    sortKey: false,
                    isDefault: true,
                },
                {
                    label: 'Week',
                    value: 'week',
                    tableHeader: 'Week Start',
                    dataKey: 'week',
                    sortKey: false,
                    isDefault: true,
                },
            ],
            planVersionDropdownOptions: [
                { label: 'A', value: 'a' },
                { label: 'B', value: 'b' },
                { label: 'C', value: 'c' },
                { label: 'Draft', value: 'draft' },
            ],
            statuses: {
                ACTIVE: { label: 'Active', colorType: 'success' },
                DRAFT: { label: 'Draft', colorType: 'processing' },
                SETUP: { label: 'Setup', colorType: 'processing' },
                IN_PROGRESS: { label: 'In-Progress', colorType: 'processing' },
                EXPIRED: { label: 'Expired', colorType: 'default' },
                ERROR: { label: 'Error', colorType: 'error' },
                INVALID: { label: 'Invalid', colorType: 'error' },
            },
            legendColorsArray: [
                colorConstants.lightGreenAlt,
                colorConstants.darkGreenAlt2,
                colorConstants.pinkAlt,
                colorConstants.orangeAlt2,
                colorConstants.darkYellow,
                colorConstants.darkBlueAlt,
                colorConstants.darkGreen,
            ],
            calenderHoverOptions: [
                { label: 'Promo Dates', key: 'promo_dates', pre: '', post: '' },
                { label: 'CRA Dates', key: 'cra_dates', pre: '', post: '' },
                { label: 'Promo Status', key: 'new_status', pre: '', post: '' },
                { label: 'Promo ID', key: 'tpm_tpo_id', pre: '', post: '' },
                { label: 'Material Group', key: 'material_group', pre: '', post: '' },
                { label: 'Division', key: 'division', pre: '', post: '' },
            ],
            kpiViewOptions: [
                { key: 'actuals_vs_plan', label: 'Actuals vs Plan', tableSubHeader: ['Actuals', 'Plan'] },
                {
                    key: 'actuals_vs_pre_snapshot',
                    label: 'Actuals vs Pre Snapshot',
                    tableSubHeader: ['Actuals', 'Pre Snapshot'],
                },
            ],
            enableEditMode: true,
        },
        priceChange: {
            // TODO: remove unwanted props
            limit: 60,
            dimensionConfig: {
                //snake case eg sub_category
                excludedDimensions: [],
                defaultDimension: 'Brand',
            },
            hiddenTableRows: [],
            timePeriodOptions: [
                { label: 'YA', value: 'year_ago' },
                { label: 'Prior Period', value: 'prior_period' },
                { label: 'Custom Period', value: 'custom' },
            ],
            absTileData: [
                { key: 'abs', label: 'Abs' },
                { key: 'percentage', label: '%' },
            ],
            kpiListData: [
                {
                    key: 'base_price',
                    label: 'Base Price',
                    value: 'base',
                    dataKey: 'base_price',
                },
                {
                    key: 'avg_price',
                    label: 'Avg Price',
                    value: 'average',
                    dataKey: 'avg_price',
                },
            ],
            volTileData: [
                {
                    key: 'vol',
                    label: 'PEQ',
                    value: 'vol',
                    dataKey: 'volume',
                    tooltip: 'Per Eq Volume',
                },
                {
                    key: 'units',
                    label: 'PU',
                    value: 'units',
                    dataKey: 'units',
                    tooltip: 'Per Unit',
                },
            ],
            salesTileData: [
                { key: 'sales', label: 'Sales' },
                { key: 'incremental', label: 'Incremental' },
                { key: 'promo', label: 'Promo' },
            ],
            salesAttributionChart: {
                colorList: ['#10AB5E', '#DC3826'],
                colorListType2: ['#758BEE', '#758BEE'],
                profitPoolColor: ['#826FD0', '#826FD0'],
                backGroundColor: 'rgba(0, 0, 0, 0.02)',
            },
            salesAttributionDrillDownChartKeyValueMapping: {
                'feature_&_display': 'Feature & Display',
                'Feature & Display': 'feature_&_display',
            },
            salesAttributionChart2Limit: 20,
        },
        growthAnalysis: {
            limit: 60,
            includeAggPeriod: true,
            dimensionConfig: {
                //snake case eg sub_category
                excludedDimensions: [],
                defaultDimension: 'Category',
            },
            absTileData: [
                { key: 'abs', label: 'Abs' },
                { key: 'percentage', label: '%' },
            ],
            subTileData: [
                {
                    label: 'PU',
                    key: 'PU',
                },
                {
                    label: 'PEQ',
                    key: 'PEQ',
                },
            ],
            volTileData: [
                {
                    key: 'val',
                    label: 'Dollars',
                    value: 'val',
                    dataKey: 'value',
                },
                {
                    key: 'vol',
                    label: 'Eq Volume',
                    value: 'vol',
                    dataKey: 'volume',
                },
                {
                    key: 'units',
                    label: 'Units',
                    value: 'units',
                    dataKey: 'units',
                },
                // { key: 'profit', label: 'Profit', value: 'profit', dataKey: 'profit' },
            ],
            showTotal: false,
            tableLabelKeys: {
                incremental_val: 'Dollar Sales ',
                promo_val: 'Dollar Sales ',
                sales_val: 'Dollar Sales ',
            },
            currentYearLabel: '',
            yearAgoLabel: 'YA',
            trendChartDropdownData: [
                {
                    key: 'sales_volume',
                    label: 'Sales Volume',
                    value: 'sales_volume',
                    dataKey: 'sales_volume',
                },
                {
                    key: 'sales',
                    label: 'Sales $',
                    value: 'sales',
                    dataKey: 'sales',
                },
                {
                    key: 'average_price',
                    label: 'Average Price',
                    value: 'average_price',
                    dataKey: 'average_price',
                },
                {
                    key: 'base_price',
                    label: 'Base Price',
                    value: 'base_price',
                    dataKey: 'base_price',
                },
                { key: 'acv', label: '%ACV', value: 'acv', dataKey: 'acv' },
                {
                    key: 'avg_items',
                    label: 'Avg. no. of items',
                    value: 'avg_items',
                    dataKey: 'avg_items',
                },
                { key: 'tdp', label: 'TDP', value: 'tdp', dataKey: 'tdp' },
            ],
            salesTileData: [
                { key: 'sales', label: 'Sales' },
                { key: 'incremental', label: 'Incremental' },
                { key: 'promo', label: 'Promo' },
            ],
            graphExportHeaderMapping: {
                promo: ['Non-promo', 'Promo'],
                incremental: ['Base', 'Incremental'],
                sales: ['Sales Change'],
            },
            depletionDropdownData: [
                {
                    value: 'frontline_sales',
                    dataKey: 'frontline_sales',
                    key: 'frontline_sales',
                    label: 'Frontline Sales',
                },
                {
                    value: 'net_sales',
                    dataKey: 'net_sales',
                    key: 'net_sales',
                    label: 'Net Sales',
                },
            ],
            tableKeyUnitMapping: {
                'Market Share CY': {
                    unit: '%',
                    label: 'Share of Total',
                    includePercentageChange: false,
                },
                'Market Share YA': {
                    unit: '%',
                    label: 'Share of Total YA',
                    includePercentageChange: false,
                },
                'ACV CY': {
                    unit: '%',
                    label: 'Estimated ACV %',
                    includePercentageChange: false,
                },
                'ACV YA': {
                    unit: '%',
                    label: 'Estimated ACV % YA',
                    includePercentageChange: false,
                },
                'Average Unit Price CY': {
                    unit: '',
                    label: 'Average Unit Price',
                    includePercentageChange: true,
                },
                'Average Eq Price CY': {
                    unit: '',
                    label: 'Average Eq Price',
                    includePercentageChange: true,
                },
            },
            salesAttributionChart: {
                colorList: ['#10AB5E', '#DC3826'],
                colorListType2: ['#758BEE', '#758BEE'],
                profitPoolColor: ['#826FD0', '#826FD0'],
                backGroundColor: 'rgba(0, 0, 0, 0.02)',
            },
            salesAttributionDrillDownChartKeyValueMapping: {
                'feature_&_display': 'Feature & Display',
                'Feature & Display': 'feature_&_display',
            },
            salesAttributionChart2DisabledItems: ['unexplained'],
            salesAttributionChart2Limit: 50,
        },
        //BUMP REPORT
        bumpReport: {
            mainHeader: 'Bump Report',
            groupByKey: 'groupBy',
            comparisonTileData: [
                { key: 'cy_vs_ya', label: 'CY vs YA' },
                { key: 'difference', label: 'Difference' },
            ],
            enablePromoCalender: true,
            isPromoUpliftPercentValue: true,
            volGroupByOptionsMapping: {
                vol: [
                    {
                        value: 'total_eq_volume',
                        label: 'Total EQ Volume',
                        index: 1,
                    },
                    {
                        value: 'any_promo_eq_volume',
                        label: 'Any promo EQ Volume',
                        index: 1,
                    },
                    {
                        value: 'no_promo_eq_volume',
                        label: 'No Promo EQ Volume',
                        index: 1,
                    },
                    {
                        value: 'base_eq_volume',
                        label: 'Base EQ Volume',
                        index: 0,
                    },
                    {
                        value: 'incremental_eq_volume',
                        label: 'Incremental EQ Volume Total',
                        index: 0,
                    },
                    {
                        value: 'tpr_incremental_eq_volume',
                        label: 'Incremental EQ Volume TPR',
                        index: 0,
                    },
                    {
                        value: 'feature_incremental_eq_volume',
                        label: 'Incremental EQ Volume Feature',
                        index: 0,
                    },
                    {
                        value: 'display_incremental_eq_volume',
                        label: 'Incremental EQ Volume Display',
                        index: 0,
                    },
                    {
                        value: 'feature_and_display_incremental_eq_volume',
                        label: 'Incremental EQ Volume Feature & Display',
                        index: 0,
                    },
                ],
                val: [
                    { value: 'total_value', label: 'Total Value', index: 1 },
                    {
                        value: 'any_promo_value',
                        label: 'Any Promo Value',
                        index: 1,
                    },
                    {
                        value: 'no_promo_value',
                        label: 'No Promo Value',
                        index: 1,
                    },
                    { value: 'base_value', label: 'Base Value', index: 0 },
                    {
                        value: 'incremental_value',
                        label: 'Incremental Value Total',
                        index: 0,
                    },
                    {
                        value: 'tpr_incremental_value',
                        label: 'Incremental Value TPR',
                        index: 0,
                    },
                    {
                        value: 'feature_incremental_value',
                        label: 'Incremental Value Feature',
                        index: 0,
                    },
                    {
                        value: 'display_incremental_value',
                        label: 'Incremental Value Display',
                        index: 0,
                    },
                    {
                        value: 'feature_and_display_incremental_value',
                        label: 'Incremental Value Feature & Display',
                        index: 0,
                    },
                ],
                units: [
                    { value: 'total_units', label: 'Total Units', index: 1 },
                    {
                        value: 'any_promo_units',
                        label: 'Any Promo Units',
                        index: 1,
                    },
                    {
                        value: 'no_promo_units',
                        label: 'No Promo Units',
                        index: 1,
                    },
                    { value: 'base_units', label: 'Base Units', index: 0 },
                    {
                        value: 'incremental_units',
                        label: 'Incremental Units Total',
                        index: 0,
                    },
                    {
                        value: 'tpr_incremental_units',
                        label: 'Incremental Units TPR',
                        index: 0,
                    },
                    {
                        value: 'feature_incremental_units',
                        label: 'Incremental Units Feature',
                        index: 0,
                    },
                    {
                        value: 'display_incremental_units',
                        label: 'Incremental Units Display',
                        index: 0,
                    },
                    {
                        value: 'feature_and_display_incremental_units',
                        label: 'Incremental Units Feature & Display',
                        index: 0,
                    },
                ],
            },
            tooltipKeyLabelMapping: {
                increments: 'Incremental',
                promo: 'Any Promo',
            },
            bumpReportTileData: [
                { key: 'increments', label: 'Attribution' },
                { key: 'promo', label: 'Consumption' },
                { key: 'groupBy', label: 'Group By' },
            ],
            bumpReportTile1Data: [
                {
                    key: 'promo',
                    label: 'Promotions',
                    visibleTabs: ['increments', 'promo', 'groupBy'],
                }, //keys should match bumpReportTileData keys
            ],
            bumpReportTile2Data: [
                { key: 'total', label: 'Total' },
                { key: 'breakout', label: 'Breakout' },
            ],
            absTileData: [
                { key: 'abs', label: 'Abs' },
                { key: 'percentage', label: '%' },
            ],

            volTileData: [
                { key: 'val', label: 'Dollars', dataKey: 'value' },
                { key: 'vol', label: 'Eq Volume', dataKey: 'volume' },
                { key: 'units', label: 'Units', dataKey: 'units' },
            ],
            bumpChartY2Colors: [
                '#293BB8',
                '#DD449F',
                '#9E5897',
                '#19669D',
                '#43C9E2',
                '#37C7BE',
                '#00798C',
                '#E8A122',
                '#E06936',
                '#A5582D',
            ],
            bumpChartY2AxisOptions: {
                vol: [
                    {
                        value: 'avg_price_per_eq',
                        index: 0,
                        label: 'Avg. Price/EQ',
                        unit: '',
                    },
                    {
                        value: 'base_price_per_eq',
                        index: 0,
                        label: 'Base Price/EQ',
                        unit: '',
                    },
                    {
                        value: 'promo_price_per_eq',
                        index: 0,
                        label: 'Promo Price/EQ',
                        unit: '',
                    },
                    {
                        value: 'market_share_volume',
                        index: 0,
                        label: 'Market Share %',
                        unit: '',
                    },
                    // {
                    //     value: 'distribution_tdp',
                    //     index: 0,
                    //     label: 'Distribution TDP',
                    //     unit: '',
                    // },
                    // {
                    //     value: 'display_tdp',
                    //     index: 0,
                    //     label: 'Display TDP',
                    //     unit: '',
                    // },
                    // {
                    //     value: 'feature_tdp',
                    //     index: 0,
                    //     label: 'Feature TDP',
                    //     unit: '',
                    // },
                    // {
                    //     value: 'feature_and_display_tdp',
                    //     index: 0,
                    //     label: 'Feature and Display TDP',
                    //     unit: '',
                    // },
                    {
                        value: 'distribution_acv',
                        index: 0,
                        label: 'Estimated Distribution ACV %',
                        unit: '',
                    },
                    {
                        value: 'display_acv',
                        index: 0,
                        label: 'Estimated Display ACV %',
                        unit: '',
                    },
                    {
                        value: 'feature_acv',
                        index: 0,
                        label: 'Estimated Feature ACV %',
                        unit: '',
                    },
                    {
                        value: 'feature_and_display_acv',
                        index: 0,
                        label: 'Estimated Feature & Display ACV %',
                        unit: '',
                    },
                    {
                        value: 'unit_velocity',
                        index: 0,
                        label: 'Units per Pt of % ACV per week',
                        unit: '',
                    },
                    {
                        value: 'sales_velocity',
                        index: 0,
                        label: 'Dollars per Pt of % ACV per week',
                        unit: '$',
                    },
                    {
                        value: 'volume_velocity',
                        index: 0,
                        label: 'Volume (EQ) per Pt of % ACV per week',
                        unit: '',
                    },
                    {
                        value: 'subsidized_base_sales',
                        index: 0,
                        label: 'Subsidized Base Sales',
                        unit: '',
                    },
                ],
                val: [
                    {
                        value: 'avg_price_per_unit',
                        index: 0,
                        label: 'Avg. Price/Unit ($)',
                        unit: '',
                    },
                    {
                        value: 'base_price_per_unit',
                        index: 0,
                        label: 'Base Price/unit',
                        unit: '',
                    },
                    {
                        value: 'promo_price_per_unit',
                        index: 0,
                        label: 'Promo Price/Unit',
                        unit: '',
                    },
                    {
                        value: 'market_share_value',
                        index: 0,
                        label: 'Market Share %',
                        unit: '',
                    },
                    // {
                    //     value: 'distribution_tdp',
                    //     index: 0,
                    //     label: 'Distribution TDP',
                    //     unit: '',
                    // },
                    // {
                    //     value: 'display_tdp',
                    //     index: 0,
                    //     label: 'Display TDP',
                    //     unit: '',
                    // },
                    // {
                    //     value: 'feature_tdp',
                    //     index: 0,
                    //     label: 'Feature TDP',
                    //     unit: '',
                    // },
                    // {
                    //     value: 'feature_and_display_tdp',
                    //     index: 0,
                    //     label: 'Feature and Display TDP',
                    //     unit: '',
                    // },
                    {
                        value: 'distribution_acv',
                        index: 0,
                        label: 'Estimated Distribution ACV %',
                        unit: '',
                    },
                    {
                        value: 'display_acv',
                        index: 0,
                        label: 'Estimated Display ACV %',
                        unit: '',
                    },
                    {
                        value: 'feature_acv',
                        index: 0,
                        label: 'Estimated Feature ACV %',
                        unit: '',
                    },
                    {
                        value: 'feature_and_display_acv',
                        index: 0,
                        label: 'Estimated Feature & Display ACV %',
                        unit: '',
                    },
                    {
                        value: 'unit_velocity',
                        index: 0,
                        label: 'Units per Pt of % ACV per week',
                        unit: '',
                    },
                    {
                        value: 'sales_velocity',
                        index: 0,
                        label: 'Dollars per Pt of % ACV per week',
                        unit: '$',
                    },
                    {
                        value: 'volume_velocity',
                        index: 0,
                        label: 'Volume (EQ) per Pt of % ACV per week',
                        unit: '',
                    },
                    {
                        value: 'subsidized_base_sales',
                        index: 0,
                        label: 'Subsidized Base Sales',
                        unit: '',
                    },
                ],
                units: [
                    {
                        value: 'avg_price_per_unit',
                        index: 0,
                        label: 'Avg. Price/Unit ($)',
                        unit: '',
                    },
                    {
                        value: 'base_price_per_unit',
                        index: 0,
                        label: 'Base Price/unit',
                        unit: '',
                    },
                    {
                        value: 'promo_price_per_unit',
                        index: 0,
                        label: 'Promo Price/Unit',
                        unit: '',
                    },
                    {
                        value: 'market_share_units',
                        index: 0,
                        label: 'Market Share %',
                        unit: '',
                    },
                    // {
                    //     value: 'distribution_tdp',
                    //     index: 0,
                    //     label: 'Distribution TDP',
                    //     unit: '',
                    // },
                    // {
                    //     value: 'display_tdp',
                    //     index: 0,
                    //     label: 'Display TDP',
                    //     unit: '',
                    // },
                    // {
                    //     value: 'feature_tdp',
                    //     index: 0,
                    //     label: 'Feature TDP',
                    //     unit: '',
                    // },
                    // {
                    //     value: 'feature_and_display_tdp',
                    //     index: 0,
                    //     label: 'Feature and Display TDP',
                    //     unit: '',
                    // },
                    {
                        value: 'distribution_acv',
                        index: 0,
                        label: 'Estimated Distribution ACV %',
                        unit: '',
                    },
                    {
                        value: 'display_acv',
                        index: 0,
                        label: 'Estimated Display ACV %',
                        unit: '',
                    },
                    {
                        value: 'feature_acv',
                        index: 0,
                        label: 'Estimated Feature ACV %',
                        unit: '',
                    },
                    {
                        value: 'feature_and_display_acv',
                        index: 0,
                        label: 'Estimated Feature & Display ACV %',
                        unit: '',
                    },
                    {
                        value: 'unit_velocity',
                        index: 0,
                        label: 'Units per Pt of % ACV per week',
                        unit: '',
                    },
                    {
                        value: 'sales_velocity',
                        index: 0,
                        label: 'Dollars per Pt of % ACV per week',
                        unit: '$',
                    },
                    {
                        value: 'volume_velocity',
                        index: 0,
                        label: 'Volume (EQ) per Pt of % ACV per week',
                        unit: '',
                    },
                    {
                        value: 'subsidized_base_sales',
                        index: 0,
                        label: 'Subsidized Base Sales',
                        unit: '',
                    },
                ],
            },
            promoTypeColorMapping: {
                'non-incentive - media': {
                    label: 'NON-INCENTIVE - MEDIA',
                    color: colorConstants.lightGreenAlt,
                },
                'incentive - digital coupon': {
                    label: 'INCENTIVE - DIGITAL COUPON',
                    color: colorConstants.darkGreenAlt2,
                },
                'incentive - paper coupon': { label: 'INCENTIVE - PAPER COUPON', color: colorConstants.pinkAlt },
                'feature & display': {
                    label: 'FEATURE & DISPLAY',
                    color: colorConstants.orangeAlt2,
                },
                'incentive  - loyalty card (non-digital)': {
                    label: 'INCENTIVE - LOYALTY CARD (NON-DIGITAL)',
                    color: colorConstants.darkBlueAlt,
                },
                tpr: {
                    label: 'TPR',
                    color: colorConstants.yellow,
                },
                feature: {
                    label: 'FEATURE',
                    color: colorConstants.yellowAlt,
                },
                edlp: {
                    label: 'EDLP',
                    color: colorConstants.darkYellow,
                },
                'non-incentive all other': {
                    label: 'NON-INCENTIVE ALL OTHER',
                    color: colorConstants.limeGreenAlt1,
                },
                display: {
                    label: 'DISPLAY',
                    color: colorConstants.blueAlt4,
                },
                'non-incentive - point of sale': {
                    label: 'INCENTIVE - POINT OF SALE',
                    color: colorConstants.redAlt1,
                },
                other: {
                    label: 'OTHER',
                    color: colorConstants.violetAlt,
                },
            },
            stackedColors: [
                colorConstants.lightGreenAlt,
                colorConstants.darkGreenAlt2,
                colorConstants.pinkAlt,
                colorConstants.orangeAlt2,
                colorConstants.darkYellow,
            ],
            fieldKeyLabelMapping: {
                base_eq_volume: {
                    label: 'Base Sales (Eq Vol)',
                    color: colorConstants.darkYellow,
                    tableLabel: 'Base',
                },
                base_value: {
                    label: 'Base Sales ($)',
                    color: colorConstants.darkYellow,
                    tableLabel: 'Base',
                },
                base_units: {
                    label: 'Base Units',
                    color: colorConstants.darkYellow,
                    tableLabel: 'Base',
                },
                incremental_eq_volume: {
                    label: 'Incremental Sales (Eq Vol)',
                    color: colorConstants.darkGreenAlt2,
                    tableLabel: 'Incremental',
                },
                incremental_value: {
                    label: 'Incremental Sales ($)',
                    color: colorConstants.darkGreenAlt2,
                    tableLabel: 'Incremental',
                },
                incremental_units: {
                    label: 'Incremental Units',
                    color: colorConstants.darkGreenAlt2,
                    tableLabel: 'Incremental',
                },
                any_promo_eq_volume: {
                    label: 'Promo',
                    color: colorConstants.darkGreenAlt2,
                    tableLabel: 'Promo',
                },
                any_promo_value: {
                    label: 'Promo',
                    color: colorConstants.darkGreenAlt2,
                    tableLabel: 'Promo',
                },
                any_promo_units: {
                    label: 'Promo',
                    color: colorConstants.darkGreenAlt2,
                    tableLabel: 'Promo',
                },
                tpr_incremental_eq_volume: {
                    label: 'TPR Incremental',
                    color: colorConstants.lightGreenAlt,
                    tableLabel: 'TPR Incremental',
                },
                feature_incremental_eq_volume: {
                    label: 'Feature Incremental',
                    color: colorConstants.darkGreenAlt2,
                    tableLabel: 'Feature Incremental',
                },
                display_incremental_eq_volume: {
                    label: 'Display Incremental',
                    color: colorConstants.pinkAlt,
                    tableLabel: 'Display Incremental',
                },
                feature_and_display_incremental_eq_volume: {
                    label: 'F & D Incremental',
                    color: colorConstants.orangeAlt2,
                    tableLabel: 'F & D Incremental',
                },
                tpr_incremental_value: {
                    label: 'TPR Incremental',
                    color: colorConstants.lightGreenAlt,
                    tableLabel: 'TPR Incremental',
                },
                feature_incremental_value: {
                    label: 'Feature Incremental',
                    color: colorConstants.darkGreenAlt2,
                    tableLabel: 'Feature Incremental',
                },
                display_incremental_value: {
                    label: 'Display Incremental',
                    color: colorConstants.pinkAlt,
                    tableLabel: 'Display Incremental',
                },
                feature_and_display_incremental_value: {
                    label: 'F & D Incremental',
                    color: colorConstants.orangeAlt2,
                    tableLabel: 'F & D Incremental',
                },
                tpr_incremental_units: {
                    label: 'TPR Incremental',
                    color: colorConstants.lightGreenAlt,
                    tableLabel: 'TPR Incremental',
                },
                feature_incremental_units: {
                    label: 'Feature Incremental',
                    color: colorConstants.darkGreenAlt2,
                    tableLabel: 'Feature Incremental',
                },
                display_incremental_units: {
                    label: 'Display Incremental',
                    color: colorConstants.pinkAlt,
                    tableLabel: 'Display Incremental',
                },
                feature_and_display_incremental_units: {
                    label: 'F & D Incremental',
                    color: colorConstants.orangeAlt2,
                    tableLabel: 'F & D Incremental',
                },
                tpr_only_eq_volume: {
                    label: 'TPR',
                    color: colorConstants.lightGreenAlt,
                    tableLabel: 'TPR',
                },
                tpr_only_value: {
                    label: 'TPR',
                    color: colorConstants.lightGreenAlt,
                    tableLabel: 'TPR',
                },
                feature_only_eq_volume: {
                    label: 'Feature',
                    color: colorConstants.darkGreenAlt2,
                    tableLabel: 'Feature',
                },
                feature_only_value: {
                    label: 'Feature',
                    color: colorConstants.darkGreenAlt2,
                    tableLabel: 'Feature',
                },
                display_only_eq_volume: {
                    label: 'Display',
                    color: colorConstants.pinkAlt,
                    tableLabel: 'Display',
                },
                display_only_value: {
                    label: 'Display',
                    color: colorConstants.pinkAlt,
                    tableLabel: 'Display',
                },
                feature_and_display_only_eq_volume: {
                    label: 'F & D',
                    color: colorConstants.orangeAlt2,
                    tableLabel: 'F & D',
                },
                feature_and_display_only_value: {
                    label: 'F & D',
                    color: colorConstants.orangeAlt2,
                    tableLabel: 'F & D',
                },
                no_promo_eq_volume: {
                    label: 'Non Promo',
                    color: colorConstants.darkYellow,
                    tableLabel: 'Non Promo',
                },
                no_promo_value: {
                    label: 'Non Promo',
                    color: colorConstants.darkYellow,
                    tableLabel: 'Non Promo',
                },
                tpr_only_units: {
                    label: 'TPR',
                    color: colorConstants.lightGreenAlt,
                    tableLabel: 'TPR',
                },
                feature_only_units: {
                    label: 'Feature',
                    color: colorConstants.darkGreenAlt2,
                    tableLabel: 'Feature',
                },
                display_only_units: {
                    label: 'Display',
                    color: colorConstants.pinkAlt,
                    tableLabel: 'Display',
                },
                feature_and_display_only_units: {
                    label: 'F & D',
                    color: colorConstants.orangeAlt2,
                    tableLabel: 'F & D',
                },
                no_promo_units: {
                    label: 'Non Promo',
                    color: colorConstants.darkYellow,
                    tableLabel: 'Non Promo',
                },

                //for export label
                sales_year_ago: { label: 'YA Sales' },
                total_value: { label: 'Total' },
                incremental_eq_volume_percentage: {
                    label: 'Incremental Sales Percentage',
                },
                incremental_value_percentage: {
                    label: 'Incremental Sales Percentage',
                },
                incremental_units_percentage: {
                    label: 'Incremental Sales Percentage',
                },
                base_value_percentage: { label: 'Base Sales Percentage' },
                base_eq_volume_percentage: { label: 'Base Sales Percentage' },
                base_units_percentage: { label: 'Base Units Percentage' },
                any_promo_eq_volume_percentage: { label: 'Promo Percentage' },
                any_promo_value_percentage: { label: 'Promo Percentage' },
                any_promo_units_percentage: { label: 'Promo Percentage' },
                no_promo_eq_volume_percentage: {
                    label: 'Non Promo Percentage',
                },
                promo_lift: {
                    label: 'Promo Uplift (Units)',
                },
                no_promo_units_percentage: { label: 'Non Promo Percentage' },
                no_promo_value_percentage: { label: 'Non Promo Percentage' },
            },

            tooltipExtraItems: {
                tpr_acv: { label: 'Tpr ACV %' },
                display_acv: { label: 'Display ACV %' },
                feature_acv: { label: 'Feature ACV %' },
                feature_and_display_acv: { label: 'F&D ACV %' },
                uplift: { label: 'Uplift' },
                promo_lift: { label: 'Promo Uplift (Units)' },
                media_lift: { label: 'Media Uplift' },
            },
            promoCalenderAttributeLevels: {
                promo: [
                    { value: 'product_group', label: 'Product Group' },
                    { value: 'geography', label: 'Geography' },
                ],
            },
            overlayKeys: {
                promo: [
                    { label: 'Start Week', dataKey: 'startTimestamp' },
                    { label: 'End Week', dataKey: 'endTimestamp' },
                    { label: 'Product Group', dataKey: 'product' },
                    { label: 'Promo Mechanics', dataKey: 'promoMech' },
                    { label: 'Promo Type', dataKey: 'promoType' },
                    { label: 'Investment', dataKey: 'field_value' },
                    // { label: 'ROI', dataKey: 'roi' },
                    // { label: 'Lift', dataKey: 'lift' },
                    // { label: 'Incremental Profit', dataKey: 'incrementalProfit' },
                    // { label: 'Incremental Retailer Profit', dataKey: 'incrementalRetailerProfit' },
                ],
            },
        },
        //PROMO SCORE CARD
        promoScoreCard: {
            mainHeader: 'Performance Scorecard',
            limit: 50,
            nestedTableLimit: 10,
            questionsNo: [1, 2, 3, 4, 5, 6, 7, 8],
            question: {
                Q: [
                    'Am I getting my fair share of promo support? ',
                    'How does my % Discount compare to competition? ',
                    'What % of Volume was sold on promotion? ',
                    'How many weeks am I promoting? ',
                    'What is my average price per volume? ',
                    'What is my average price/units? ',
                    'What is my dollar share of promotions? ',
                    'What is my volume share of promotions? ',
                ],
                unitsInItalics: [
                    '(Fair Share Index $ Sold)',
                    '(Weighted Average % Price Reduction)',
                    '(% of Volume)',
                    '(Weighted Weeks)',
                    '',
                    '(Price per Unit)',
                    '(Dollar share %)',
                    '(Volume %)',
                ],
                unit: ['value', '%', '%', 'week', '$', '$', '%', '%'],
                numberFormateDecimal: [0, 1, 1, 0, 2, 2, 1, 1],
            },
            promoTypeLabelMapping: {
                display: { label: 'Display Only' },
                tpr: { label: 'TPR Only' },
                feature: { label: 'Feature Only' },
                feature_and_display: { label: 'Feature & Display Only' },
                feature_display: { label: 'Feature & Display Only' },
            },
            showGradientTile: false,
            promoType: ['TPR Only', 'Display Only', 'Feature Only', 'Feature & Display Only'],
            promoExpandedViewTableUnit: 'volume',
            promoExpandedViewTableSalesAndVolumeLabel: ['EQ Volume', 'Total Sales $'],
            dropDown: ['Manufacturer', 'Category', 'Sub Category', 'Brand', 'Sub_Brand'],
            listFor: ['Manufacturer', 'Brand', 'Sub_Brand', 'product_group'],
            listForToDisplay: ['Manufacturer', 'Brand', 'Sub_Brand', 'product_group'],
            listIn: ['Category', 'Sub_Category', 'Pack_Size'],
        },
        // PROMO LANDSCAPE
        promoLandscape: {
            mainHeader: 'Investment & MPIC Tracker',
            roiLabel: 'MPIC',
            defaultAttributeTypeIndex: 0,
            optimalInvestmentIndexThreshold1: 0.8,
            optimalInvestmentIndexThreshold2: 1.2,
            promoTacticDropdownName: 'Promotion Tactic',
            dimensionConfig: {
                //snake case eg sub_category
                excludedDimensions: ['promotion_name', 'promotion_code'],
                defaultDimension: '',
            },
            thresholdColorMapping: {
                optimal: { label: 'Optimal', color: colorConstants.darkGreen },
                over: { label: 'Over', color: colorConstants.darkRed },
                under: { label: 'Under', color: colorConstants.darkBlueAlt },
            },
            limit: 60,
            promoTypes: [
                { value: 'display', label: 'Display' },
                { value: 'tpr', label: 'TPR' },
                { value: 'feature', label: 'Feature' },
                // { value: 'feature & display', label: 'Feature & Display' },  //not required for now
            ],
            mediaLevelsDropdown: [],
            optimalIndexKey: 'competition_spend_index',
            showInvestmentDropdown: false,
            tableRowsKeyMapping: [
                {
                    label: 'Investment',
                    children: null,
                    parentKey: null,
                    key: 'investments',
                    unit: '$',
                },
                {
                    label: 'MPIC',
                    children: null,
                    parentKey: null,
                    key: 'roi',
                    unit: '',
                },
                {
                    label: 'Optimal Investment Index',
                    children: [
                        {
                            label: 'Share of Investment',
                            key: 'share_of_investment',
                            unit: '',
                        },
                        {
                            label: 'Share of Sales',
                            key: 'share_of_sales',
                            unit: '',
                        },
                    ],
                    unit: '',
                    parentKey: 'competition_data',
                    key: 'competition_spend_index',
                },
                {
                    label: 'Incremental Sales Dollar',
                    children: [
                        {
                            label: 'Total Sales Dollar',
                            key: 'total_sales',
                            unit: '$',
                        },
                        {
                            label: 'Base Sales Dollar',
                            key: 'base_sales_dollar',
                            unit: '$',
                        },
                        {
                            label: 'Incremental Sales Eq',
                            key: 'incremental_sales_eq',
                            unit: '',
                        },
                        {
                            label: 'Total Sales Eq',
                            key: 'total_sales_eq',
                            unit: '',
                        },
                        {
                            label: 'Base Sales Eq',
                            key: 'base_sales_eq',
                            unit: '',
                        },
                    ],
                    unit: '$',
                    parentKey: 'incremental_sales_dollar_data',
                    key: 'incremental_sales_dollar',
                },
                {
                    label: 'Incremental Profit',
                    children: [
                        {
                            label: 'Share of Profit Pool',
                            key: 'share_of_profit_pool',
                            unit: '',
                        },
                        {
                            label: 'Total Profit',
                            key: 'total_profit',
                            unit: '',
                        },
                        {
                            label: 'Baseline Profit',
                            key: 'baseline_profit',
                            unit: '',
                        },

                        {
                            label: 'Incremental Net Sales',
                            key: 'incremental_net_sales',
                            unit: '$',
                        },
                        {
                            label: 'Total Net Sales',
                            key: 'total_net_sales',
                            unit: '$',
                        },
                        {
                            label: 'Baseline Net Sales',
                            key: 'baseline_net_sales',
                            unit: '$',
                        },
                        {
                            label: 'Promo % Margin',
                            key: 'promo_percentage_margin',
                            unit: '',
                        },
                        {
                            label: 'Baseline % Margin',
                            key: 'baseline_percentage_margin',
                            unit: '',
                        },
                    ],
                    parentKey: 'incremental_profit_data',
                    key: 'incremental_profit',
                    unit: '$',
                },
                {
                    label: 'Incremental Retailer Profit',
                    unit: '$',
                    children: [
                        {
                            label: 'Share of Profit Pool',
                            key: 'share_of_profit_pool_retailer',
                            unit: '',
                        },
                        {
                            label: 'Total Retailer Profit',
                            key: 'total_retailer_profit',
                            unit: '',
                        },
                        {
                            label: 'Baseline Retailer Profit',
                            key: 'baseline_retailer_profit',
                            unit: '',
                        },
                        {
                            label: 'Retailer Promo % Margin',
                            key: 'retailer_promo_percentage_margin',
                            unit: '',
                        },
                        {
                            label: 'Retailer Baseline % Margin',
                            key: 'retailer_baseline_percentage_margin',
                            unit: '',
                        },
                    ],
                    parentKey: 'incremental_retailer_profit_data',
                    key: 'incremental_retailer_profit',
                },
            ],
        },
        //PORTFOLIO ANALYSIS
        portfolioAnalysis: {
            mainHeader: 'Promo MPIC Analysis',
            limit: 60,
            defaultGroupByIndex: 5,
            defaultGroupBy2Index: 3,
            chartColors: [],
            absTileData: [
                { key: 'Promotions', label: 'Promotions' },
                { key: 'Drivers', label: 'Drivers' },
            ],
            salesAttributionChart: {
                colorList: ['#10AB5E', '#DC3826'],
                colorListType2: ['#758BEE', '#758BEE'],
                profitPoolColor: ['#826FD0', '#826FD0'],
                backGroundColor: 'rgba(0, 0, 0, 0.02)',
            },
            // chartColors: [
            //     '#E8A122',
            //     '#293BB8',
            //     '#E06936',
            //     '#19669D',
            //     '#A5582D',
            //     '#43C9E2',
            //     '#DD449F',
            //     '#37C7BE',
            //     '#9E5897',
            //     '#00798C',
            //     '#EDB44E',
            //     '#4557D5',
            //     '#E6875E',
            //     '#228BD6',
            //     '#CC7442',
            //     '#69D4E8',
            //     '#E469B2',
            //     '#5FD3CB',
            //     '#B377AD',
            //     '#3394A3',
            //     '#F1C77A',
            //     '#7381E0',
            //     '#ECA586',
            //     '#55A8E4',
            //     '#D89672',
            //     '#8EDFEE',
            //     '#EB8FC5',
            //     '#87DED8',
            //     '#C699C2',
            //     '#66AFBA',
            //     '#F6D9A7',
            //     '#A2ABEA',
            //     '#F3C3AF',
            //     '#8EC5ED',
            //     '#E5B9A1',
            //     '#B4E9F3',
            //     '#F1B4D9',
            //     '#AFE9E5',
            //     '#D9BBD6',
            //     '#99C9D1',
            //     '#FAECD3',
            //     '#D0D5F5',
            //     '#F9E1D7',
            //     '#C6E2F6',
            //     '#F2DCD0',
            //     '#D9F4F9',
            //     '#F8DAEC',
            //     '#D7F4F2',
            //     '#ECDDEB',
            //     '#CCE4E8',
            // ],
            chartDropdownExtraKpis: [
                {
                    dimension: 'none',
                    label: 'Tactics',
                    dataKey: 'tactic_description',
                },
                {
                    dimension: 'none',
                    label: 'Mechanics',
                    dataKey: 'promotion_mechanic',
                },
                {
                    dimension: 'none',
                    label: 'Event Name',
                    dataKey: 'event_name',
                },
                {
                    dimension: 'dim1',
                    label: 'Week',
                    dataKey: 'week',
                },
            ],
            groupByHeaders: [
                {
                    label: 'Product Category',
                    value: 'product_category',
                    dimension: 'dim1',
                    isSelected: false,
                    sortKey: 'product_category',
                    multiSelectFilter: false,
                },
                {
                    label: 'Brand',
                    value: 'brand',
                    dimension: 'dim1',
                    isSelected: false,
                    sortKey: 'brand',
                    multiSelectFilter: false,
                },
                {
                    label: 'Promotion Type',
                    value: 'promotion_type',
                    dimension: 'dim3',
                    isSelected: false,
                    sortKey: 'promotion_type',
                    multiSelectFilter: false,
                },
                {
                    label: 'Mechanics',
                    value: 'promotion_mechanic',
                    dimension: null,
                    isSelected: false,
                    sortKey: 'promotion_mechanic',
                    multiSelectFilter: true,
                },
                {
                    label: 'Tactic',
                    value: 'tactic_description',
                    dimension: null,
                    isSelected: false,
                    sortKey: 'tactic_description',
                    multiSelectFilter: true,
                },
                {
                    label: 'Promotion',
                    value: 'promotion_name',
                    dimension: 'dim3',
                    isSelected: false,
                    sortKey: 'promotion_name',
                    multiSelectFilter: false,
                },
                {
                    label: 'Promotion Code',
                    value: 'promotion_code',
                    dimension: 'dim3',
                    isSelected: false,
                    sortKey: 'promotion_code',
                    multiSelectFilter: false,
                },
                {
                    label: 'Material Group Name',
                    value: 'material_group_name',
                    dimension: 'dim1',
                    isSelected: true,
                    sortKey: 'material_group_name',
                    multiSelectFilter: false,
                },
            ],

            chartHeaderLabelKeyMapping: {
                lift: { label: 'Lift' },
                mpic_units: { label: 'MPIC (Unit)' },
                investments: { label: 'Investments' },
                incremental_net_sales: { label: 'Incremental Net Sales' },
                incremental_profit: { label: 'Incremental Profit' },
                incremental_retailer_profit: {
                    label: 'Incremental Retailer Profit',
                },
                acv: { label: 'ACV Distribution' },
                profit_pool: { label: 'Profit Pool' },
                tpr_acv: { label: 'Tpr ACV' },
                display_acv: { label: 'Display ACV' },
                feature_acv: { label: 'Feature ACV' },
                feature_and_display_acv: { label: 'F&D ACV' },
                total_acv: { label: 'Total ACV' },
                weeks: { label: 'Promo Weeks' },
            },
            promoTypesChartLegends: [
                {
                    label: 'TPR',
                    color: colorConstants.lightCyan,
                    style: {
                        borderRadius: '100%',
                        height: `8px`,
                        width: '8px',
                    },
                },
                {
                    label: 'Feature',
                    color: colorConstants.lightCream,
                    style: {
                        borderRadius: '100%',
                        height: `8px`,
                        width: '8px',
                    },
                },
                {
                    label: 'Display',
                    color: colorConstants.lightPink,
                    style: {
                        borderRadius: '100%',
                        height: `8px`,
                        width: '8px',
                    },
                },
            ],
            promoTypes: ['tpr', 'feature', 'display'],
            promoTypesLabelMapping: {
                tpr: 'TPR',
                feature: 'Feature',
                display: 'Display',
            },
        },
        promoRecommendation: {
            playbookLimit: 50,
            clientName: 'GP',
            mainHeader: 'Promo Recommendation',

            retailerKey: 'Retailer',
            hideAddSpends: false,

            calenderStartDay: 'Monday',
            spendLeversList: [
                {
                    label: 'Baseline Volume',
                    placeholder: 'Baseline Volume',
                    value: 'baseVolume',
                    isDisabled: false,
                },
                {
                    label: 'Uplift',
                    placeholder: 'Uplift',
                    value: 'uplift',
                    isDisabled: false,
                },
                {
                    label: 'Total Volume',
                    placeholder: 'Total Volume',
                    value: 'totalVolume',
                    isDisabled: true,
                },
                {
                    label: `Total GP Profit ($)`,
                    placeholder: `Total GP Profit`,
                    value: 'totalKindProfit',
                    isDisabled: true,
                },
                {
                    label: 'ROI',
                    placeholder: 'ROI',
                    value: 'roi',
                    isDisabled: true,
                },
                {
                    label: `Total Retailer Profit ($)`,
                    placeholder: 'Total Retailer Profit',
                    value: 'totalRetailerProfit',
                    isDisabled: true,
                },
            ],
            spendTypeList: [
                {
                    label: 'Lump Sum',
                    value: 'lump_sum',
                    inputRule: '',
                },
                {
                    label: 'Per Qty',
                    value: 'per_qty',
                    inputRule: '',
                },
                {
                    label: 'Display',
                    value: 'display',
                    inputRule: '',
                },
                {
                    label: 'Feature',
                    value: 'feature',
                    inputRule: '',
                },
            ],
            playbookKeyMapping: {
                Product: ['ppgName'],
                '%TS': ['guidelinePercentageTotalSpends', 'percentageTotalSpends', 'lesser_than', '', '%'],
                Frequency: ['guidelineFrequency', 'frequency', 'range', ''],
                ROI: ['guidelineRoi', 'roi', 'greater_than', '', ''],
            },
            // comparisonOperator: {
            //     '%TS': '<',
            //     Frequency: 'range',
            //     ROI: '>',
            // },
            menuButtons: [
                { key: 'recommendations', label: 'Recommendations' },
                {
                    key: 'summary',
                    label: 'Summary',
                },
                {
                    key: 'playbook',
                    label: 'Playbook',
                },
            ],

            promoTypeColorMapping: {
                'tpr/scan': {
                    label: 'TPR/Scan',
                    color: colorConstants.lightGreenAlt,
                },
                feature_ad: {
                    label: 'Feature Ad',
                    color: colorConstants.darkGreenAlt2,
                },
                display: { label: 'Display', color: colorConstants.pinkAlt },
                feature_display_tpr: {
                    label: 'Feature_Display_TPR',
                    color: colorConstants.orangeAlt2,
                },
                display_tpr: {
                    label: 'Display_TPR',
                    color: colorConstants.darkBlueAlt,
                },
            },
            overlayKeys: [
                {
                    label: 'Start Date',
                    dataKey: 'startDate',
                    pre: '',
                    post: '',
                },
                { label: 'Duration', dataKey: 'duration', pre: '', post: '' },
                {
                    label: 'Promo Type',
                    dataKey: 'tacticDescription',
                    pre: '',
                    post: '',
                },
                { label: 'Product(s)', dataKey: 'dim1AttributeNames', pre: '', post: '' },
                {
                    label: 'Total Volume',
                    dataKey: 'totalVolume',
                    pre: '',
                    post: '',
                    arrowConfig: 'positiveUp',
                },
                {
                    label: 'Total GSV',
                    dataKey: 'totalGsv',
                    pre: '$',
                    post: '',
                    arrowConfig: 'positiveUp',
                },
                {
                    label: 'Total NSV',
                    dataKey: 'totalNsv',
                    pre: '$',
                    post: '',
                    arrowConfig: 'positiveUp',
                },
                {
                    label: 'Total GP Profit',
                    dataKey: 'totalGPProfit',
                    pre: '$',
                    post: '',
                    arrowConfig: 'positiveUp',
                },
                {
                    label: 'Total Retailer Profit',
                    dataKey: 'totalRetailerProfit',
                    pre: '$',
                    post: '',
                    arrowConfig: 'positiveUp',
                },
                {
                    label: 'Promo Spends',
                    dataKey: 'promoSpends',
                    pre: '$',
                    post: '',
                    arrowConfig: 'negativeUp',
                },
                {
                    label: '% Trade Spends GSV',
                    dataKey: 'percentageTradeSpendsGsv',
                    pre: '',
                    post: '%',
                    arrowConfig: 'negativeUp',
                },
                {
                    label: '% Trade Spends NSV',
                    dataKey: 'percentageTradeSpendsNsv',
                    pre: '',
                    post: '%',
                    arrowConfig: 'negativeUp',
                },

                {
                    label: 'Incremental Volume',
                    dataKey: 'incrementalVolume',
                    pre: '',
                    post: '',
                    arrowConfig: 'positiveUp',
                },
                {
                    label: 'Incremental GSV',
                    dataKey: 'incrementalGsv',
                    pre: '$',
                    post: '',
                    arrowConfig: 'positiveUp',
                },
                {
                    label: 'Incremental NSV',
                    dataKey: 'incrementalNsv',
                    pre: '$',
                    post: '',
                    arrowConfig: 'positiveUp',
                },
                {
                    label: 'Total Profit %',
                    dataKey: 'totalProfitPercentage',
                    pre: '',
                    post: '%',
                    arrowConfig: 'positiveUp',
                },
                {
                    label: 'Incremental Profit',
                    dataKey: 'incrementalProfit',
                    pre: '$',
                    post: '',
                    arrowConfig: 'positiveUp',
                },
                {
                    label: 'Promo ROI',
                    dataKey: 'roi',
                    pre: '',
                    post: '',
                    arrowConfig: 'positiveUp',
                },
                {
                    label: 'Retailer Incremental Profit',
                    dataKey: 'retailerIncrementalProfit',
                    pre: '$',
                    post: '',
                    arrowConfig: 'positiveUp',
                },
            ],
            spendLabel: {
                lump_sum: 'Lump Sum',
                per_qty: 'Per Qty',
                display: 'Display',
                feature: 'Feature',
            },
            offerMethodList: [
                { value: 'option', label: 'List of Option', dimension: 'dim1' },
                { value: 'manual', label: 'Manual', dimension: 'dim1' },
                { value: 'previous', label: 'Previous', dimension: 'dim1' },
            ],
            addEventList: [
                { value: 'new', label: 'Add New Event' },
                { value: 'import', label: 'Import Event' },
            ],
            leverKeys: [
                'promptEventName',
                'offerMethod',
                'discount',
                'startDate',
                'duration',
                'displayAcv',
                'featureAcv',
            ],
            spendTopForm: ['baseVolume', 'uplift', 'totalVolume', 'totalKindProfit', 'roi', 'totalRetailerProfit'],
            formList: [
                {
                    value: 'duration',
                    label: 'Duration',
                    inputRule: '',
                    placeHolder: 'Enter',
                },
                {
                    value: 'displayAcv',
                    label: 'Display ACV',
                    inputRule: '',
                    placeHolder: 'Enter display ACV',
                },
                {
                    value: 'featureAcv',
                    label: 'Feature ACV',
                    inputRule: '',
                    placeHolder: 'Enter feature ACV',
                },
            ],
            offerSelectionKeys: ['promotionMechanic', 'tacticDescription'],
            spendPerQtyKey: ['per_qty', 'redemption'],
        },
        priceLadder: {
            isThresholdDropdownEnabled: true,
            hideMraup: true,
            limit: 50, //update this when implementing infinite scroller
            dimensionConfig: {
                //snake case eg sub_category
                excludedDimensions: [],
                defaultDimension: 'brand',
            },
            tileData: [
                {
                    label: 'Product by Market',
                    key: 'product by market',
                },
                // {
                //     label: 'Product vs Competitors',
                //     key: 'product vs competitors',
                // },
            ],
            subTileData: [
                {
                    label: 'PEQ',
                    key: 'PEQ',
                },
                {
                    label: 'PU',
                    key: 'PU',
                },
            ],
            legendMapping: {
                PU: [
                    {
                        color: '#E6E6EA',
                        label: 'Sales $',
                        key: 'salesValueDollars',
                        dataKey: 'sales',
                        metricDataKey: 'units',
                    },
                    {
                        color: '#66AFBA',
                        label: 'Avg. Price PU',
                        key: 'avgPrice',
                        dataKey: 'avg_price_per_unit',
                        metricDataKey: 'units',
                    },
                    {
                        color: '#ECA586',
                        label: 'Max Price PU',
                        key: 'maxPrice',
                        dataKey: 'max_price_per_unit',
                        metricDataKey: 'units',
                    },
                    {
                        color: '#EB8FC5',
                        label: 'Min Price PU',
                        key: 'minPrice',
                        dataKey: 'min_price_per_unit',
                        metricDataKey: 'units',
                    },
                    {
                        color: '#F1C77A',
                        label: 'Promo Price PU',
                        key: 'promoPrice',
                        dataKey: 'promo_price_per_unit',
                        metricDataKey: 'units',
                    },
                    {
                        color: '#6771DB',
                        label: 'Base Price PU',
                        key: 'basePrice',
                        dataKey: 'base_price_per_unit',
                        metricDataKey: 'units',
                    },
                    // { color: '#5463FF', label: 'MRAUP', key: 'mraup', dataKey: 'mraup' },
                ],
                PEQ: [
                    {
                        color: '#E6E6EA',
                        label: 'Sales $',
                        key: 'salesValueDollars',
                        dataKey: '',
                        metricDataKey: 'volume',
                    },
                    {
                        color: '#66AFBA',
                        label: 'Avg. Price PEQ',
                        key: 'avgPrice',
                        dataKey: 'avg_price_per_eq',
                        metricDataKey: 'volume',
                    },
                    {
                        color: '#ECA586',
                        label: 'Max Price PEQ',
                        key: 'maxPrice',
                        dataKey: 'max_price_per_eq',
                        metricDataKey: 'volume',
                    },
                    {
                        color: '#EB8FC5',
                        label: 'Min Price PEQ',
                        key: 'minPrice',
                        dataKey: 'min_price_per_eq',
                        metricDataKey: 'volume',
                    },
                    {
                        color: '#F1C77A',
                        label: 'Promo Price PEQ',
                        key: 'promoPrice',
                        dataKey: 'promo_price_per_eq',
                        metricDataKey: 'volume',
                    },
                    {
                        color: '#6771DB',
                        label: 'Base Price PEQ',
                        key: 'basePrice',
                        dataKey: 'base_price_per_eq',
                        metricDataKey: 'volume',
                    },
                    // { color: '#5463FF', label: 'MRAUP', key: 'mraup', dataKey: 'mraup' },
                ],
            },
            dataKeyMapping: {
                PU: [
                    { label: 'Sales $', key: 'salesValueDollars' },
                    { label: 'Avg. Price PU', key: 'avgPrice' },
                    { label: 'Max Price PU', key: 'maxPrice' },
                    { label: 'Min Price PU', key: 'minPrice' },
                    { label: 'Promo Price PU', key: 'promoPrice' },
                    { label: 'Base Price PU', key: 'basePrice' },
                ],
                PEQ: [
                    { label: 'Sales $', key: 'salesValueDollars' },
                    { label: 'Avg. Price PEQ', key: 'avgPrice' },
                    { label: 'Max Price PEQ', key: 'maxPrice' },
                    { label: 'Min Price PEQ', key: 'minPrice' },
                    { label: 'Promo Price PEQ', key: 'promoPrice' },
                    { label: 'Base Price PEQ', key: 'basePrice' },
                ],
            },
            tableColumnLabelKeyMapping: {
                sales: { label: 'Sales $' },
                sales_percentage: { label: 'Sales %' },
                avg_price_pu: { label: 'Average Price $ PU' },
                avg_price_peq: { label: 'Average Price $ PEQ' },
                max_price_pu: { label: 'Max Price $ PU' },
                max_price_peq: { label: 'Max Price $ PEQ' },
                min_price_pu: { label: 'Min Price $ PU' },
                min_price_peq: { label: 'Min Price $ PEQ' },
                // mraup: { label: 'MRAUP' },
                base_price_pu: { label: 'Base Price $ PU' },
                base_price_peq: { label: 'Base Price $ PEQ' },
                promo_price_pu: { label: 'Promo Price $ PU' },
                promo_price_peq: { label: 'Promo Price $ PEQ' },
            },
            dropdown2Filter: ['Category', 'Pack_Size', 'Segment', 'Channel', 'Retailer'],
        },
        opportunityIdentification: {
            reversePpeAxis: true,
            bubbleCategoryOptions: [
                { value: 'brand', label: 'Brand', dimension: 'dim1' },
                { value: 'product_group', label: 'Product Group', dimension: 'dim1' },
                { value: 'category', label: 'Category', dimension: 'dim1' },
                {
                    value: 'sub_category',
                    label: 'Sub Category',
                    dimension: 'dim1',
                },
                { value: 'manufacturer', label: 'Manufacturer', dimension: 'dim1' },
                { value: 'sub_brand', label: 'Sub Brand', dimension: 'dim1' },
            ],
            kpis: {
                xaxis: [
                    { label: 'BPE', value: 'bpe' },
                    { label: '% RSV Growth', value: 'rsv_growth' },
                    { label: 'MAC %', value: 'mac_percentage' },
                ],
                yaxis: [
                    { label: 'PPE', value: 'ppe' },
                    { label: '% RSV Growth', value: 'rsv_growth' },
                    { label: 'MAC %', value: 'mac_percentage' },
                ],
                bubbleSize: [
                    { label: 'Eq Volume', value: 'total_volume' },
                    { label: 'BPE', value: 'bpe' },
                    { label: 'PPE', value: 'ppe' },
                    { label: 'MAC', value: 'mac' },
                    { label: 'MAC %', value: 'mac_percentage' },
                    { label: 'RSV', value: 'rsv' },
                    { label: '% RSV Growth', value: 'rsv_growth' },
                ],
            },
            elasticityDriver: {
                chart2Limit: 100,
                levels: [
                    { label: 'Category', value: 'category', dimension: 'dim1' },
                    { label: 'Sub Category', value: 'sub_category', dimension: 'dim1' },
                    { label: 'Manufacturer', value: 'manufacturer', dimension: 'dim1' },
                    { label: 'Brand', value: 'brand', dimension: 'dim1' },
                    { label: 'Sub Brand', value: 'sub_brand', dimension: 'dim1' },
                    { label: 'Product Group', value: 'product_group', dimension: 'dim1' },
                    { label: 'Retailer', value: 'retailer', dimension: 'dim2' },
                ],
                limit: 50,
                offset: 0,
                dimension: 'dim1',
                legendMapping: [
                    {
                        dataKey: 'own',
                        label: 'Own Elasticity',
                        color: '#69D4E8',
                    },
                    {
                        dataKey: 'internal',
                        label: 'Internal Competitor Elasticity',
                        color: '#E469B2',
                    },
                    {
                        dataKey: 'external',
                        label: 'External Competitor Elasticity',
                        color: '#EDB44E',
                    },
                ],
            },
        },
        priceCurve: {
            chart1Limit: 100,
            xAxisKeyValue: [
                { value: 'roll_equivalent', label: 'Roll Equivalent' },
                { value: 'pack_size', label: 'Pack Size' },
                { value: 'count', label: 'Count' },
                { value: 'size_range', label: 'Size Range' },
                { value: 'count_range', label: 'Count Range' },
            ],
            YAxisKeyValue: [
                { value: 'base_price', label: 'Base Price' },
                { value: 'retail_price', label: 'Avg Price' },
                // { value: 'list_price', label: 'List Price' },
            ],
            levels: [
                { value: 'brand', label: 'Brand' },
                { value: 'category', label: 'Category' },
                { value: 'sub_category', label: 'Sub Category' },
                { value: 'manufacturer', label: 'Manufacturer' },
                { value: 'sub_brand', label: 'Sub Brand' },
                { value: 'color', label: 'Color' },
                { value: 'count', label: 'Count' },
                { value: 'innovation', label: 'Innovation' },
                { value: 'market_structure', label: 'Market Structure' },
                { value: 'material', label: 'Material' },
                { value: 'pack_size', label: 'Pack Size' },
                { value: 'performance_tier', label: 'Performance Tier' },
                { value: 'roll_equivalent', label: 'Roll Equivalent' },
                { value: 'roll_size', label: 'Roll Size' },
                { value: 'scented', label: 'Scented' },
                { value: 'size_range', label: 'Size Range' },
                { value: 'type', label: 'Type' },
                { value: 'product_group', label: 'Product Group' },
            ],
            subTileData: [
                {
                    label: 'PU',
                    key: 'PU',
                    dataKey: 'per_unit',
                },
                {
                    label: 'PEQ',
                    key: 'PEQ',
                    dataKey: 'per_eq',
                },
            ],
            chartColors: [
                '#E8A122',
                '#293BB8',
                '#E06936',
                '#19669D',
                '#A5582D',
                '#43C9E2',
                '#DD449F',
                '#37C7BE',
                '#9E5897',
                '#00798C',
                '#EDB44E',
                '#4557D5',
                '#E6875E',
                '#228BD6',
                '#CC7442',
                '#69D4E8',
                '#E469B2',
                '#5FD3CB',
                '#B377AD',
                '#3394A3',
                '#F1C77A',
                '#7381E0',
                '#ECA586',
                '#55A8E4',
                '#D89672',
                '#8EDFEE',
                '#EB8FC5',
                '#87DED8',
                '#C699C2',
                '#66AFBA',
                '#F6D9A7',
                '#A2ABEA',
                '#F3C3AF',
                '#8EC5ED',
                '#E5B9A1',
                '#B4E9F3',
                '#F1B4D9',
                '#AFE9E5',
                '#D9BBD6',
                '#99C9D1',
                '#FAECD3',
                '#D0D5F5',
                '#F9E1D7',
                '#C6E2F6',
                '#F2DCD0',
                '#D9F4F9',
                '#F8DAEC',
                '#D7F4F2',
                '#ECDDEB',
                '#CCE4E8',
            ],
            tableHeaders: [
                { label: 'Avg Price $', key: 'retail_price' },
                { label: 'Avg Price $ YA', key: 'retail_price_ya' },
                { label: 'Base Price $', key: 'base_price' },
                { label: 'Base Price $ YA', key: 'base_price_ya' },
            ],
        },
        pricePoint: {
            priceRange: [0, 10],
            graphColorScheme: ['#D7D6D9', '#69d4e8', '#228bd6', '#b377ad', '#66AFBA', '#ECA586', '#F1C77A', '#EB8FC5'],
            hideMraup: true,
            limit: 500,
            dimensionConfig: {
                //snake case eg sub_category
                excludedDimensions: [],
                defaultDimension: 'Brand',
            },
            contributionThreshold: 5,
            priceTypeOptions: [
                { label: 'Base Price', value: 'base_price' },
                { label: 'Avg Price', value: 'avg_price' },
            ],
            subTileData: [
                {
                    label: 'PU',
                    key: 'per_unit',
                    xAxisLabel: 'Price Per Unit',
                    tooltip: 'Per Unit',
                },
                {
                    label: 'PEQ',
                    key: 'per_volume',
                    xAxisLabel: 'Price Per Eq',
                    tooltip: 'Per Eq Volume',
                },
            ],
            yAxisDropdownData: [
                {
                    label: 'Units',
                    value: 'units',
                },
                {
                    label: 'Dollars',
                    value: 'value',
                },
                {
                    label: 'Volume',
                    value: 'volume',
                },
            ],
            tableHeaderKeyMapping: {
                growth_percentage: ['Growth % vs YA', '', '%'],
                total_sales: ['Total Value ($)', '$', ''],
                total_volume: ['Total Volume', '', ''],
                total_units: ['Total Units', '', ''],
                avg_price_per_unit: ['Avg. Price per Unit', '$', ''],
                avg_price_per_eq: ['Avg. Price per EQ', '$', ''],
                base_price_per_unit: ['Base Price per Unit', '$', ''],
                base_price_per_eq: ['Base Price per EQ', '$', ''],
            },
            drilldownTableHeaderKeyMapping: {
                growth_abs: ['Growth Abs', '$', ''],
                growth_percentage: ['Growth %', '', '%'],
                contribution_to_category: ['Contribution to category', '$', ''],
                cy_share: ['CY share', '', '%'],
                ya_share: ['YA share', '', '%'],
                change: ['Change %', '', '%'],
            },
            dropdown2Filter: ['Category', 'Pack_Size', 'Segment', 'Channel', 'Retailer'],
            customThresholdData: [
                {
                    id: 1,
                    value: '',
                },
                {
                    id: 2,
                    value: '',
                },
                {
                    id: 3,
                    value: '',
                },
                {
                    id: 4,
                    value: '',
                },
                {
                    id: 5,
                    value: '',
                },
            ],
        },
        priceTracking: {
            limit: 20,
            dimensionConfig: {
                //snake case eg sub_category
                excludedDimensions: ['mega_category', 'count_range'],
                defaultRowDimension: 'Brand',
                defaultColumnDimension: 'Geography',
            },
            attributeNamesLimit: 50,
            frequency: 'W',
            timePeriodOptions: [
                { label: 'YA', value: 'year_ago' },
                { label: 'Prior Period', value: 'prior_period' },
                { label: 'Custom Period', value: 'custom' },
            ],
            priceTypeOptions: [
                { label: 'Base Price', value: 'base' },
                { label: 'Avg Price', value: 'average' },
            ],
            kpiOptions: [
                { label: '% Change', value: 'percent_change' },
                { label: 'Price Index', value: 'index' },
                { label: 'Current Price', value: 'current_price' },
            ],
            subTileData: [
                {
                    label: 'PU',
                    key: 'units',
                    xAxisLabel: 'Price Per Unit',
                    tooltip: 'Per Unit',
                },
                {
                    label: 'PEQ',
                    key: 'volume',
                    xAxisLabel: 'Price Per Eq',
                    tooltip: 'Per Eq Volume',
                },
            ],
            weeksOptions: [
                { label: 'L W1', value: 1 },
                { label: 'L W4', value: 4 },
                { label: 'L W13', value: 13 },
                { label: 'L W26', value: 26 },
                { label: 'L W52', value: 52 },
            ],
            monthsOptions: [
                { label: 'L M1', value: 1 },
                { label: 'L M3', value: 3 },
                { label: 'L M6', value: 6 },
                { label: 'L M12', value: 12 },
            ],
            quartersOptions: [
                { label: 'L Q1', value: 1 },
                { label: 'L Q2', value: 2 },
                { label: 'L Q4', value: 4 },
            ],
            kpiMapping: {
                'Base Price': ['$', ''],
                'Base Price YA': ['$', ''],
                'Avg Price': ['$', ''],
                'Avg Price YA': ['$', ''],
                'Base Price Index % Chg': ['', '%'],
                'Base Price % Chg': ['', '%'],
                'Avg Price Index % Chg': ['', '%'],
                'Avg Price % Chg': ['', '%'],
                'TDP % Chg': ['', '%'],
                TDP: ['', ''],
                'TDP YA': ['', ''],
                'Volume Velocity % Chg': ['', '%'],
                'Volume Velocity': ['', ''],
                'Volume Velocity YA': ['', ''],
            },
        },
        tpo: {
            promoLimit: 5,
            deleteAllowedStatus: ['draft', 'planned', 'approved'],
        },
        bestWeeks: {
            limit: 50,
            drilldownTableConfig: [
                { label: 'Period No:', value: 'period_no', sorting: false },
                { label: 'Year', value: 'year', sorting: false },
            ],
            dimensionConfig: {
                //snake case eg sub_category
                excludedDimensions: [],
                defaultDimension: 'Brand',
            },
            rankingCriteriaOptions: [
                { label: 'Base Volume', value: 'base_eq_volume' },
                { label: 'ACV', value: 'total_per_acv_dist' },
                { label: 'Incremental Volume', value: 'incremental_eq_volume' },
                { label: 'Total Volume', value: 'total_eq_volume' },
            ],
        },
    },
    nomadFoods: {
        //COMMON CONFIG
        commonConfig: {
            clientName: 'Nomad Foods',
            handleDim2SortingFromFrontend: false,
            dateFormat: 'DD/MM/YY',
            dateFormatAlt: 'DD/MM/YY',
            calenderStartDay: 'Sunday',
            showSecondaryLogo: false,
            showLogoInNavbar: true,
            logoHeight: '38px',
            logoWidth: '127px',
            loginPageTextPart1: 'Welcome to',
            loginPageTextPart2: 'RGM Analytics - Predictive and Prescriptive module',
            width: window.innerWidth,
            limit: 10,
            offset: 0,
            lagList: [0, 1],
            graphFontSize: calculateFontSize(window.innerWidth, 13),
            graphFontSizeAlt: calculateFontSize(window.innerWidth, 13),
            graphFontFamily: "'Helvetica Neue', sans-serif",
            graphLabelColorAlt: '#4E4C55',
            graphLabelColor: '#433C4A',
            units: {
                currency: '£',
                volume: 'Vol',
                currencyText: 'Value',
            },
            filterFormat: { dim1: { ids: [] }, dim2: { ids: [] } },
            frequency: 'W',
            showCampignCalender: false,
            showFullLabel: true,
            decimalForPercentage: 1,
            decimalForNonPercentage: 2,
        },
        latestDateForDifferentRoutes: {
            'promo-score-card': 'Promotion Data',
            'roi-analysis': 'Promotion Data',
            'roi-tracker': 'Promotion Data',
            default: 'POS Data',
        },
        screenDetailsWithRoutes: [
            {
                label: 'Growth Analysis',
                path: 'promo/category-diagnostics/growth-analysis',
                id: 'ga',
                pageId: 'ga',
            },
            {
                label: 'Bump Report',
                path: 'promo/category-diagnostics/bump-report',
                id: 'br',
                pageId: 'br',
            },
            {
                label: 'Price Change',
                path: 'pricing/analytics/price-change',
                id: 'pcn',
                pageId: 'pcn',
            },
            {
                label: 'Price Point',
                path: 'pricing/analytics/price-point',
                id: 'pp',
                pageId: 'pp',
            },
            {
                label: 'Price Ladder',
                path: 'pricing/analytics/price-ladder',
                id: 'pld',
                pageId: 'pld',
            },
            {
                label: 'Price Curve',
                path: 'pricing/analytics/price-curve',
                id: 'pc',
                pageId: 'pc',
            },
            {
                label: 'Price Tracking',
                path: 'pricing/analytics/price-tracking',
                id: 'pt',
                pageId: 'pt',
            },
            {
                label: 'Opportunity Identification',
                path: 'pricing/analytics/opportunity-identification',
                id: 'oi',
                pageId: 'oi',
            },
            // {
            //     label: 'Promo Scorecard',
            //     path: 'promo/analytics/promo-score-card',
            //     id: 'ps',
            //     pageId: 'ps',
            // },
            {
                label: 'Investment & ROI Tracker',
                path: 'promo/analytics/roi-tracker',
                id: 'pl',
                pageId: 'pl',
            },
            {
                label: 'Promo ROI Analysis',
                path: 'promo/analytics/roi-analysis',
                id: 'pa',
                pageId: 'pa',
            },
            {
                label: 'Commercial Forecast',
                path: 'promo/recommendation/commercial-forecast',
                id: 'cf',
                pageId: 'cf',
            },

            {
                label: 'Promo Recommendation',
                path: 'promo/recommendation/promo-recommendation',
                id: 'pr',
                pageId: 'pr',
            },
            // { label: 'Pricing Simulator', path: 'pricing/recommendation/price-simulator', id: 'psr', pageId: 'psr' },
            // {
            //     label: 'Pricing Simulator',
            //     path: 'pricing/recommendation/price-simulator/new',
            //     id: 'psr',
            //     pageId: 'psrNew',
            // },
            // {
            //     label: 'Pricing Simulator',
            //     path: 'pricing/recommendation/price-simulator/edit/:id',
            //     id: 'psr',
            //     pageId: 'psrEdit',
            // },
            // {
            //     label: 'Pricing Simulator',
            //     path: 'pricing/recommendation/price-simulator/view/:id',
            //     id: 'psr',
            //     pageId: 'psrView',
            // },
            {
                label: 'Pricing Simulator',
                path: 'pricing/recommendation/pricing-simulator',
                id: 'psrV2', //update id in simulator context as well
                pageId: 'psrV2',
            },
            {
                label: 'Pricing Simulator',
                path: 'pricing/recommendation/pricing-simulator/:mode/:projectId/scenario/:scenarioId',
                id: 'psr',
                pageId: 'psrV2Update',
            },
            {
                label: 'Pricing Simulator',
                path: 'pricing/recommendation/pricing-simulator/:mode/:projectId/scenario/:scenarioId',
                id: 'psr',
                pageId: 'psrV2View',
            },
            {
                label: 'Pricing Analytics',
                path: 'pricing/recommendation/pricing-analytics',
                id: 'psa',
                pageId: 'psa', // pricing analytics
            },
            {
                label: 'Pricing Analytics',
                path: 'pricing/recommendation/pricing-analytics/:mode/:reportId',
                id: 'psa',
                pageId: 'psaUpdate', // pricing analytics update
            },
            {
                label: 'Pricing Analytics',
                path: 'pricing/recommendation/pricing-analytics/:mode/:reportId',
                id: 'psa',
                pageId: 'psaView', // pricing analytics view
            },
            {
                label: 'Best Weeks',
                path: 'promo/recommendation/best-weeks',
                id: 'bw',
                pageId: 'bw',
            },
        ],
        screens: [
            {
                label: 'Category Diagnostics',
                path: ['promo/category-diagnostics'],
                showSubHeader: false,
                options: {
                    Promo: [
                        {
                            label: 'Growth Analysis',
                            path: 'growth-analysis',
                            id: 'ga',
                        },
                        { label: 'Bump Report', path: 'bump-report', id: 'br' },
                    ],
                    visible: false,
                },
            },
            {
                label: 'Pricing Analytics',
                path: ['pricing/analytics', null],
                showSubHeader: false,
                options: {
                    Promo: [
                        {
                            label: 'Price Change',
                            path: 'price-change',
                            id: 'pcn',
                        },
                        { label: 'Price Point', path: 'price-point', id: 'pp' },
                        {
                            label: 'Price Ladder',
                            path: 'price-ladder',
                            id: 'pld',
                        },
                        { label: 'Price Curve', path: 'price-curve', id: 'pc' },
                        {
                            label: 'Price Tracking',
                            path: 'price-tracking',
                            id: 'pt',
                        },
                        {
                            label: 'Opportunity Identification',
                            path: 'opportunity-identification',
                            id: 'oi',
                        },
                    ],
                    visible: false,
                },
            },
            {
                label: 'Promo Analytics',
                path: ['promo/analytics', null],
                showSubHeader: false,
                options: {
                    Promo: [
                        // {
                        //     label: 'Promo Scorecard',
                        //     path: 'promo-score-card',
                        //     id: 'ps',
                        // },
                        {
                            label: 'Investment & ROI Tracker',
                            path: 'roi-tracker',
                            id: 'pl',
                        },
                        {
                            label: 'Promo ROI Analysis',
                            path: 'roi-analysis',
                            id: 'pa',
                        },
                    ],
                    visible: false,
                },
            },
            {
                label: 'Price & Promo Modeling',
                path: ['promo/recommendation', 'pricing/recommendation'],
                showSubHeader: true,
                options: {
                    Promo: [
                        { label: 'Promo Recommendation', path: 'promo-recommendation', id: 'pr' },
                        // { label: 'Commercial Forecast', path: 'commercial-forecast', id: 'cf' },
                        // {
                        //     label: 'Best Weeks',
                        //     path: 'best-weeks',
                        //     id: 'bw',
                        // },
                    ],
                    Pricing: [{ label: 'Pricing Simulator', path: 'pricing-simulator', id: 'psrV2' }],
                    visible: false,
                },
            },
        ],
        globalFilter: {
            presetConfig: {
                disablePresetFilter: true,
                presetEnabledRoutes: {
                    all: true,
                },
            },
            availableFrequenciesList: [{ key: 'W', label: 'Week' }],
            globalFilterChangingRoutes: {},
            retainFiltersAcrossFeatures: true,
            limit: 50,
            selectionAllowed: {
                'promo-recommendation': {
                    dim2: {
                        Retailer: 1,
                    },
                },
            },
            allSelectedLimit: 15,
            timePeriodScreenMapping: {
                default: ['4W', '12W', '26W', '52W', '1M', '3M', '6M', '12M', '1Q', '2Q', '4Q', 'YTD', 'CUSTOM DATE'],
                'bump-report': ['52W', '104W', '156W', '1M', '3M', '6M', '12M', '1Q', '2Q', '4Q', 'YTD', 'CUSTOM DATE'],
                'commercial-forecast': [
                    '4W',
                    '12W',
                    '26W',
                    '52W',
                    '1M',
                    '3M',
                    '6M',
                    '12M',
                    '1Q',
                    '2Q',
                    '4Q',
                    'YTG',
                    'CUSTOM DATE',
                ],
            },

            defaultPeriod: ['52W'],
            applyFilterApiPostFormat: {
                jsonstring_dim1: '{}',
                jsonstring_dim2: '{}',
            },
            defaultPreviousIdObject: {
                dim1: ['attr', 'attr'],
                dim2: ['attr', 'attr'],
            },
            defaultIdObject: {
                dim1: { ids: [] },
                dim2: { ids: [] },
            },
            defaultAttrIdObject: {
                attr: {
                    dim1: { ids: [] },
                    dim2: { ids: [] },
                },
            },

            promoScoreCardDefault: {
                Category: 'FROZEN FISH',
                channel: 'GB_Tesco',
            },
            PromoScoreCardDefaultObj: {
                dim1: {
                    Category: {
                        inclusion: [
                            {
                                dimension: 'dim1',
                                isActive: true,
                                attributeType: 'Category',
                                attributeDesc: 'FROZEN FISH',
                                attributeExId: 'FROZEN FISH',
                            },
                        ],
                    },
                },
                dim2: null,
            },
        },
        pricingSimulator: {
            enableAnalyticsTab: true,
            enableBulkUpload: false,
            indexPageTableLimit: 50,
            scenarioFilterOffsetLimit: 50,
            scenarioPerProjectLimit: 10,
            scenarioTableLimit: 500,
            analyticsChartLimit: 100,
            comparisonTableLimit: 50,
            dimAttributesLimit: 4,
            characterLimit: {
                kpiTileCharLimit: 22,
                kpiCompareCardLimit: 30,
            },
            enablePrivatePublicToggle: false,
            enableMicroInfoForTables: false,
            enableOneChangeAnalyticsChart: false,
            defaultGlobalKpiCount: 6,
            disableExport: false,
            indexTableFixedColumns: [
                { label: 'Project Name', key: 'projectName', sortKey: 'project_name' },
                { label: 'Created By', key: 'createdBy', sortKey: 'created_by' },
                { label: 'Status', key: 'status' },
                { label: 'Last Updated', key: 'lastUpdated', sortKey: 'updated_at' },
                { label: 'Simulation Period', key: 'simulationPeriod' },
                { label: 'Price Effective Date', key: 'priceEffectiveDate' },
            ],
            analyticsBaseScenarioFixedColumns: [
                { label: 'Project Name', key: 'projectName', sortKey: 'project_name' },
                { label: 'Created By', key: 'createdBy', sortKey: 'created_by' },
                { label: 'Status', key: 'status' },
            ],
            analyticsTableColumns: [
                { label: 'Report Name', key: 'reportName', sortKey: 'report_name' },
                { label: 'Base Scenario', key: 'baseScenario', sortKey: 'base_scenario' },
                { label: 'Created By', key: 'createdBy', sortKey: 'created_by' },
                { label: 'Last Updated', key: 'lastUpdated', sortKey: 'updated_at' },
                { label: 'Date Created', key: 'dateCreated', sortKey: 'created_at' },
            ],
            projectStatuses: {
                ACTIVE: { label: 'Active', colorType: 'success' },
                DRAFT: { label: 'Draft', colorType: 'processing' },
                SETUP: { label: 'Setup', colorType: 'processing' },
                IN_PROGRESS: { label: 'In-Progress', colorType: 'processing' },
                EXPIRED: { label: 'Expired', colorType: 'default' },
                ERROR: { label: 'Error', colorType: 'error' },
                INVALID: { label: 'Invalid', colorType: 'error' },
            },
            projectDataSource: [{ label: 'Projected', value: 'depletion_data' }],
            simulatedPeriodItems: [
                { label: 'Custom Date', value: 'custom_date', dateArray: null },
                { label: 'Current Year', value: 'current_year', dateArray: ['01-05-2025', '12-28-2025'] },
                // { label: 'Financial Year', value: 'financial_year', dateArray: ['03-03-2024', '02-23-2025'] },
            ],
            iconsMappings: {
                Elasticity: 'BorderOuterOutlined',
                BaseInput: 'BorderlessTableOutlined',
                COGS: 'DollarOutlined',
                Distributor: 'BuildOutlined',
                'Distributor P&L': 'BuildOutlined',
                FOB: 'ClusterOutlined',
                'P&L': 'LineChartOutlined',
                Price: 'MoneyCollectOutlined',
                Promotions: 'BoxPlotOutlined',
                'Retailer P&L': 'LineChartOutlined',
                Sales: 'AreaChartOutlined',
                Taxes: 'BlockOutlined',
                Volume: 'ExperimentOutlined',
                Others: 'UngroupOutlined',
                Product: 'GoldOutlined',
                Geo: 'ExpandOutlined',
                'Dollar Impact': 'DollarOutlined',
                'Standard Increase Metrics': 'ToTopOutlined',
                'EQV Metrics': 'BlockOutlined',
            },
            categoryMovementKpis: [
                { label: 'Units Impact', value: 'units', yAxisLabel: 'Units', xAxisLabel: 'Retailer Units' },
                { label: 'Sales Impact', value: 'sales', yAxisLabel: 'Sales £', xAxisLabel: 'Retailer Sales £' },
            ],
        },
        priceChange: {
            // TODO: remove unwanted props
            limit: 60,
            dimensionConfig: {
                //snake case eg sub_category
                excludedDimensions: [],
                defaultDimension: 'Manufacturer',
            },
            hiddenTableRows: [],
            timePeriodOptions: [
                { label: 'YA', value: 'year_ago' },
                { label: 'Prior Period', value: 'prior_period' },
                { label: 'Custom Period', value: 'custom' },
            ],
            absTileData: [
                { key: 'abs', label: 'Abs' },
                { key: 'percentage', label: '%' },
            ],
            kpiListData: [
                {
                    key: 'avg_price',
                    label: 'Avg Price',
                    value: 'average',
                    dataKey: 'avg_price',
                },
                {
                    key: 'base_price',
                    label: 'Base Price',
                    value: 'base',
                    dataKey: 'base_price',
                },
            ],
            volTileData: [
                {
                    key: 'units',
                    label: 'PPU',
                    value: 'units',
                    dataKey: 'units',
                    tooltip: 'Per Unit',
                },
                {
                    key: 'vol',
                    label: 'PPKG',
                    value: 'vol',
                    dataKey: 'volume',
                    tooltip: 'Per Eq Volume',
                },
            ],
            salesTileData: [
                { key: 'sales', label: 'Sales' },
                { key: 'incremental', label: 'Incremental' },
                { key: 'promo', label: 'Promo' },
            ],
            salesAttributionChart: {
                colorList: ['#10AB5E', '#DC3826'],
                colorListType2: ['#758BEE', '#758BEE'],
                profitPoolColor: ['#826FD0', '#826FD0'],
                backGroundColor: 'rgba(0, 0, 0, 0.02)',
            },
            salesAttributionDrillDownChartKeyValueMapping: {
                'feature_&_display': 'Feature & Display',
                'Feature & Display': 'feature_&_display',
            },
            salesAttributionChart2Limit: 20,
        },
        growthAnalysis: {
            limit: 60,
            includeAggPeriod: true,
            dimensionConfig: {
                //snake case eg sub_category
                excludedDimensions: [],
                defaultDimension: 'Manufacturer',
            },
            absTileData: [
                { key: 'abs', label: 'Abs' },
                { key: 'percentage', label: '%' },
            ],
            subTileData: [
                {
                    label: 'PPU',
                    key: 'PU',
                },
                {
                    label: 'PPKG',
                    key: 'PEQ',
                },
            ],
            volTileData: [
                { key: 'vol', label: 'Volume', value: 'vol', dataKey: 'volume' },
                { key: 'val', label: 'Value', value: 'val', dataKey: 'value' },
                {
                    key: 'units',
                    label: 'Units',
                    value: 'units',
                    dataKey: 'units',
                },
                // { key: 'profit', label: 'Profit', value: 'profit', dataKey: 'profit' },
            ],
            showTotal: true,
            currentYearLabel: 'CY',
            yearAgoLabel: 'YA',
            trendChartDropdownData: [
                {
                    key: 'sales_volume',
                    label: 'Sales Volume',
                    value: 'sales_volume',
                    dataKey: 'sales_volume',
                },
                {
                    key: 'sales',
                    label: 'Sales £',
                    value: 'sales',
                    dataKey: 'sales',
                },
                {
                    key: 'average_price',
                    label: 'Average Price',
                    value: 'average_price',
                    dataKey: 'average_price',
                },
                {
                    key: 'base_price',
                    label: 'Base Price',
                    value: 'base_price',
                    dataKey: 'base_price',
                },
                { key: 'acv', label: '%ACV', value: 'acv', dataKey: 'acv' },
                {
                    key: 'avg_items',
                    label: 'Avg. no. of items',
                    value: 'avg_items',
                    dataKey: 'avg_items',
                },
                { key: 'tdp', label: 'TDP', value: 'tdp', dataKey: 'tdp' },
            ],
            salesTileData: [
                { key: 'sales', label: 'Sales' },
                { key: 'incremental', label: 'Incremental' },
                // { key: 'promo', label: 'Promo' },
            ],
            graphExportHeaderMapping: {
                promo: ['Non-promo', 'Promo'],
                incremental: ['Base', 'Incremental'],
                sales: ['Sales Change'],
            },
            depletionDropdownData: [
                {
                    value: 'frontline_sales',
                    dataKey: 'frontline_sales',
                    key: 'frontline_sales',
                    label: 'Frontline Sales',
                },
                {
                    value: 'net_sales',
                    dataKey: 'net_sales',
                    key: 'net_sales',
                    label: 'Net Sales',
                },
            ],
            tableKeyUnitMapping: {
                'Average Eq Price YA': {
                    unit: '',
                    label: 'Average Price YA',
                    includePercentageChange: true,
                },
                'Average Eq Price CY': {
                    unit: '',
                    label: 'Average Price CY',
                    includePercentageChange: false,
                },
                'Market Share CY': {
                    unit: '%',
                    label: 'Market Share',
                    includePercentageChange: false,
                },
                'Market Share YA': {
                    unit: '%',
                    label: 'Market Share YA',
                    includePercentageChange: false,
                },
                'ACV CY': {
                    unit: '%',
                    label: 'Wtd. Avg ACV %',
                    includePercentageChange: false,
                },
                'ACV YA': {
                    unit: '%',
                    label: 'Wtd. Avg ACV % YA',
                    includePercentageChange: false,
                },
            },
            salesAttributionChart: {
                colorList: ['#10AB5E', '#DC3826'],
                colorListType2: ['#758BEE', '#758BEE'],
                profitPoolColor: ['#826FD0', '#826FD0'],
                backGroundColor: 'rgba(0, 0, 0, 0.02)',
            },
            salesAttributionDrillDownChartKeyValueMapping: {
                'feature_&_display': 'Feature & Display',
                'Feature & Display': 'feature_&_display',
            },
            salesAttributionChart2DisabledItems: ['unexplained'],
            salesAttributionChart2Limit: 50,
        },
        //BUMP REPORT
        bumpReport: {
            mainHeader: 'Bump Report',
            groupByKey: 'groupBy',
            comparisonTileData: [
                { key: 'cy_vs_ya', label: 'CY vs YA' },
                { key: 'difference', label: 'Difference' },
            ],
            enablePromoCalender: true,
            isPromoUpliftPercentValue: false,
            volGroupByOptionsMapping: {
                vol: [
                    { value: 'total_eq_volume', label: 'Total KG Volume', index: 1 },
                    { value: 'any_promo_eq_volume', label: 'Any promo KG Volume', index: 1 },
                    { value: 'no_promo_eq_volume', label: 'No Promo KG Volume', index: 1 },

                    { value: 'base_eq_volume', label: 'Base KG Volume', index: 0 },
                    { value: 'incremental_eq_volume', label: 'Incremental KG Volume Total', index: 0 },
                    { value: 'tpr_incremental_eq_volume', label: 'Incremental KG Volume TPR', index: 0 },
                    { value: 'feature_incremental_eq_volume', label: 'Incremental KG Volume Feature', index: 0 },
                    { value: 'display_incremental_eq_volume', label: 'Incremental KG Volume Display', index: 0 },
                    {
                        value: 'feature_and_display_incremental_eq_volume',
                        label: 'Incremental KG Volume Feature & Display',
                        index: 0,
                    },
                ],
                val: [
                    { value: 'total_value', label: 'Total Value', index: 1 },
                    {
                        value: 'any_promo_value',
                        label: 'Any Promo Value',
                        index: 1,
                    },
                    {
                        value: 'no_promo_value',
                        label: 'No Promo Value',
                        index: 1,
                    },
                    { value: 'base_value', label: 'Base Value', index: 0 },
                    {
                        value: 'incremental_value',
                        label: 'Incremental Value Total',
                        index: 0,
                    },
                    {
                        value: 'tpr_incremental_value',
                        label: 'Price Cut Incremental Value',
                        index: 0,
                    },
                    {
                        value: 'feature_incremental_value',
                        label: 'Feature Incremental Value',
                        index: 0,
                    },
                    {
                        value: 'display_incremental_value',
                        label: 'Display Incremental Value',
                        index: 0,
                    },
                    {
                        value: 'feature_and_display_incremental_value',
                        label: 'Feature & Display Incremental Value',
                        index: 0,
                    },
                ],
                units: [
                    { value: 'total_units', label: 'Total Units', index: 1 },
                    {
                        value: 'any_promo_units',
                        label: 'Any Promo Units',
                        index: 1,
                    },
                    {
                        value: 'no_promo_units',
                        label: 'No Promo Units',
                        index: 1,
                    },
                    { value: 'base_units', label: 'Base Units', index: 0 },
                    {
                        value: 'incremental_units',
                        label: 'Incremental Units Total',
                        index: 0,
                    },
                    {
                        value: 'tpr_incremental_units',
                        label: 'Price Cut Incremental Units',
                        index: 0,
                    },
                    {
                        value: 'feature_incremental_units',
                        label: 'Feature Incremental Units',
                        index: 0,
                    },
                    {
                        value: 'display_incremental_units',
                        label: 'Display Incremental Units',
                        index: 0,
                    },
                    {
                        value: 'feature_and_display_incremental_units',
                        label: 'Feature & Display Incremental Units',
                        index: 0,
                    },
                ],
            },
            tooltipKeyLabelMapping: {
                increments: 'Incremental',
                promo: 'Any Promo',
            },
            bumpReportTileData: [
                { key: 'increments', label: 'Attribution' },
                { key: 'promo', label: 'Consumption' },
                { key: 'groupBy', label: 'Group By' },
            ],
            bumpReportTile1Data: [
                {
                    key: 'promo',
                    label: 'Promotions',
                    visibleTabs: ['increments', 'promo', 'groupBy'],
                }, //keys should match bumpReportTileData keys
            ],
            bumpReportTile2Data: [
                { key: 'total', label: 'Total' },
                { key: 'breakout', label: 'Breakout' },
            ],
            absTileData: [
                { key: 'abs', label: 'Abs' },
                { key: 'percentage', label: '%' },
            ],

            volTileData: [
                { key: 'vol', label: 'Volume', dataKey: 'volume' },
                { key: 'val', label: 'Value', dataKey: 'value' },
                { key: 'units', label: 'Units', dataKey: 'units' },
            ],
            bumpChartY2Colors: [
                '#293BB8',
                '#DD449F',
                '#9E5897',
                '#19669D',
                '#43C9E2',
                '#37C7BE',
                '#00798C',
                '#E8A122',
                '#E06936',
                '#A5582D',
            ],
            bumpChartY2AxisOptions: {
                vol: [
                    { value: 'avg_price_per_eq', index: 0, label: 'Avg. Price/KG', unit: '' },
                    { value: 'base_price_per_eq', index: 0, label: 'Base Price/KG', unit: '' },
                    { value: 'promo_price_per_eq', index: 0, label: 'Promo Price/KG', unit: '' },
                    { value: 'distribution_tdp', index: 0, label: 'Distribution TDP', unit: '' },
                    { value: 'display_tdp', index: 0, label: 'Display TDP', unit: '' },
                    { value: 'feature_tdp', index: 0, label: 'Feature TDP', unit: '' },
                    { value: 'feature_and_display_tdp', index: 0, label: 'Feature and Display TDP', unit: '' },
                    { value: 'unit_velocity', index: 0, label: 'Unit ROS', unit: '' },
                    { value: 'sales_velocity', index: 0, label: 'Dollar ROS', unit: '£' },
                    { value: 'volume_velocity', index: 0, label: 'KG ROS', unit: '' },
                ],
                val: [
                    {
                        value: 'avg_price_per_unit',
                        index: 0,
                        label: 'Avg. Price/Unit (£)',
                        unit: '',
                    },
                    {
                        value: 'base_price_per_unit',
                        index: 0,
                        label: 'Base Price/Unit',
                        unit: '',
                    },
                    {
                        value: 'promo_price_per_unit',
                        index: 0,
                        label: 'Promo Price/Unit',
                        unit: '',
                    },
                    {
                        value: 'market_share_value',
                        index: 0,
                        label: 'Market Share %',
                        unit: '',
                    },
                    {
                        value: 'distribution_tdp',
                        index: 0,
                        label: 'Distribution TDP',
                        unit: '',
                    },
                    {
                        value: 'display_tdp',
                        index: 0,
                        label: 'Display TDP',
                        unit: '',
                    },
                    {
                        value: 'feature_tdp',
                        index: 0,
                        label: 'Feature TDP',
                        unit: '',
                    },
                    {
                        value: 'feature_and_display_tdp',
                        index: 0,
                        label: 'Feature & Display TDP',
                        unit: '',
                    },
                    {
                        value: 'distribution_acv',
                        index: 0,
                        label: 'Distribution ACV %',
                        unit: '',
                    },
                    {
                        value: 'display_acv',
                        index: 0,
                        label: 'Display ACV %',
                        unit: '',
                    },
                    {
                        value: 'feature_acv',
                        index: 0,
                        label: 'Feature ACV %',
                        unit: '',
                    },
                    {
                        value: 'feature_and_display_acv',
                        index: 0,
                        label: 'Feature & Display ACV %',
                        unit: '',
                    },

                    {
                        value: 'unit_velocity',
                        index: 0,
                        label: 'Unit ROS',
                        unit: '',
                    },
                    {
                        value: 'sales_velocity',
                        index: 0,
                        label: 'Value ROS',
                        unit: '£',
                    },
                    {
                        value: 'subsidized_base_sales',
                        index: 0,
                        label: 'Subsidized Base Sales',
                        unit: '',
                    },
                    // { value: 'volume_velocity', index: 0, label: 'Eq Velocity', unit: '' },
                ],
                units: [
                    {
                        value: 'avg_price_per_unit',
                        index: 0,
                        label: 'Avg. Price/Unit (£)',
                        unit: '',
                    },
                    {
                        value: 'base_price_per_unit',
                        index: 0,
                        label: 'Base Price/Unit',
                        unit: '',
                    },
                    {
                        value: 'promo_price_per_unit',
                        index: 0,
                        label: 'Promo Price/Unit',
                        unit: '',
                    },
                    {
                        value: 'market_share_units',
                        index: 0,
                        label: 'Market Share %',
                        unit: '',
                    },
                    {
                        value: 'distribution_tdp',
                        index: 0,
                        label: 'Distribution TDP',
                        unit: '',
                    },
                    {
                        value: 'display_tdp',
                        index: 0,
                        label: 'Display TDP',
                        unit: '',
                    },
                    {
                        value: 'feature_tdp',
                        index: 0,
                        label: 'Feature TDP',
                        unit: '',
                    },
                    {
                        value: 'feature_and_display_tdp',
                        index: 0,
                        label: 'Feature & Display TDP',
                        unit: '',
                    },
                    {
                        value: 'distribution_acv',
                        index: 0,
                        label: 'Distribution ACV %',
                        unit: '',
                    },
                    {
                        value: 'display_acv',
                        index: 0,
                        label: 'Display ACV %',
                        unit: '',
                    },
                    {
                        value: 'feature_acv',
                        index: 0,
                        label: 'Feature ACV %',
                        unit: '',
                    },
                    {
                        value: 'feature_and_display_acv',
                        index: 0,
                        label: 'Feature & Display ACV %',
                        unit: '',
                    },

                    {
                        value: 'unit_velocity',
                        index: 0,
                        label: 'Unit ROS',
                        unit: '',
                    },
                    {
                        value: 'sales_velocity',
                        index: 0,
                        label: 'Value ROS',
                        unit: '£',
                    },
                    {
                        value: 'subsidized_base_sales',
                        index: 0,
                        label: 'Subsidized Base Sales',
                        unit: '',
                    },
                    // { value: 'volume_velocity', index: 0, label: 'Eq Velocity', unit: '' },
                ],
            },
            promoTypeColorMapping: {
                'end 1': {
                    label: 'End 1',
                    color: colorConstants.lightGreenAlt,
                },
                other: {
                    label: 'Other',
                    color: colorConstants.darkGreenAlt2,
                },
                'display and feature': { label: 'Display & Feature', color: colorConstants.pinkAlt },
                display: {
                    label: 'Display',
                    color: colorConstants.orangeAlt2,
                },
                shelf: {
                    label: 'Shelf',
                    color: colorConstants.darkYellow,
                },
                'end 3': { label: 'End 3', color: colorConstants.violetAlt2 },
                'end 5': {
                    label: 'End 5',
                    color: colorConstants.violetAlt3,
                },
                'end 4': { label: 'End 4', color: colorConstants.purpleAlt1 },
            },
            stackedColors: [
                colorConstants.lightGreenAlt,
                colorConstants.darkGreenAlt2,
                colorConstants.pinkAlt,
                colorConstants.orangeAlt2,
                colorConstants.darkYellow,
            ],
            fieldKeyLabelMapping: {
                base_eq_volume: {
                    label: 'Base Sales (Vol)',
                    color: colorConstants.darkYellow,
                    tableLabel: 'Base',
                },
                base_value: {
                    label: 'Base Sales (£)',
                    color: colorConstants.darkYellow,
                    tableLabel: 'Base',
                },
                base_units: {
                    label: 'Base Units',
                    color: colorConstants.darkYellow,
                    tableLabel: 'Base',
                },
                incremental_eq_volume: {
                    label: 'Incremental Sales (Vol)',
                    color: colorConstants.darkGreenAlt2,
                    tableLabel: 'Incremental',
                },
                incremental_value: {
                    label: 'Incremental Sales (£)',
                    color: colorConstants.lightGreenAlt,
                    tableLabel: 'Promotion',
                },
                tpr_incremental_eq_volume: {
                    label: 'Price Cut',
                    color: colorConstants.lightGreenAlt,
                    tableLabel: 'Price Cut',
                },
                feature_incremental_eq_volume: {
                    label: 'Feature',
                    color: colorConstants.darkGreenAlt2,
                    tableLabel: 'Feature',
                },
                display_incremental_eq_volume: {
                    label: 'Display',
                    color: colorConstants.pinkAlt,
                    tableLabel: 'Display',
                },
                feature_and_display_incremental_eq_volume: {
                    label: 'Feature & Display',
                    color: colorConstants.orangeAlt2,
                    tableLabel: 'Feature & Display',
                },
                tpr_incremental_value: {
                    label: 'Price Cut',
                    color: colorConstants.lightGreenAlt,
                    tableLabel: 'Price Cut',
                },
                feature_incremental_value: {
                    label: 'Feature',
                    color: colorConstants.darkGreenAlt2,
                    tableLabel: 'Feature',
                },
                display_incremental_value: {
                    label: 'Display',
                    color: colorConstants.pinkAlt,
                    tableLabel: 'Display',
                },
                incremental_units: {
                    label: 'Promotion Units',
                    color: colorConstants.lightGreenAlt,
                    tableLabel: 'Promotion',
                },
                feature_and_display_incremental_value: {
                    label: 'Feature & Display',
                    color: colorConstants.orangeAlt2,
                    tableLabel: 'Feature & Display',
                },
                tpr_incremental_units: {
                    label: 'Price Cut',
                    color: colorConstants.lightGreenAlt,
                    tableLabel: 'Price Cut',
                },
                feature_incremental_units: {
                    label: 'Feature',
                    color: colorConstants.darkGreenAlt2,
                    tableLabel: 'Feature',
                },
                display_incremental_units: {
                    label: 'Display',
                    color: colorConstants.pinkAlt,
                    tableLabel: 'Display',
                },
                feature_and_display_incremental_units: {
                    label: 'Feature & Display',
                    color: colorConstants.orangeAlt2,
                    tableLabel: 'Feature & Display',
                },
                incremental_total_units: {
                    label: 'Promotions',
                    color: colorConstants.lightGreenAlt,
                    tableLabel: 'Promotions',
                },
                incremental_total_value: {
                    label: 'Promotions',
                    color: colorConstants.lightGreenAlt,
                    tableLabel: 'Promotions',
                },

                tpr_only_eq_volume: {
                    label: 'Price Cut',
                    color: colorConstants.lightGreenAlt,
                    tableLabel: 'Price Cut',
                },
                tpr_only_value: {
                    label: 'Price Cut',
                    color: colorConstants.lightGreenAlt,
                    tableLabel: 'Price Cut',
                },
                feature_only_eq_volume: {
                    label: 'Feature',
                    color: colorConstants.darkGreenAlt2,
                    tableLabel: 'Feature',
                },
                feature_only_value: {
                    label: 'Feature',
                    color: colorConstants.darkGreenAlt2,
                    tableLabel: 'Feature',
                },
                display_only_eq_volume: {
                    label: 'Display',
                    color: colorConstants.pinkAlt,
                    tableLabel: 'Display',
                },
                display_only_value: {
                    label: 'Display',
                    color: colorConstants.pinkAlt,
                    tableLabel: 'Display',
                },
                feature_and_display_only_eq_volume: {
                    label: 'Feature & Display',
                    color: colorConstants.orangeAlt2,
                    tableLabel: 'Feature & Display',
                },
                feature_and_display_only_value: {
                    label: 'Feature & Display',
                    color: colorConstants.orangeAlt2,
                    tableLabel: 'Feature & Display',
                },
                no_promo_eq_volume: {
                    label: 'Non Promo',
                    color: colorConstants.darkYellow,
                    tableLabel: 'Non Promo',
                },
                any_promo_eq_volume: {
                    label: 'Promo',
                    color: colorConstants.darkGreenAlt2,
                    tableLabel: 'Promo',
                },
                no_promo_value: {
                    label: 'Non Promo',
                    color: colorConstants.darkYellow,
                    tableLabel: 'Non Promo',
                },
                any_promo_value: {
                    label: 'Promo',
                    color: colorConstants.lightGreenAlt,
                    tableLabel: 'Promo',
                },
                tpr_only_units: {
                    label: 'Price Cut',
                    color: colorConstants.lightGreenAlt,
                    tableLabel: 'Price Cut',
                },
                feature_only_units: {
                    label: 'Feature',
                    color: colorConstants.darkGreenAlt2,
                    tableLabel: 'Feature',
                },
                display_only_units: {
                    label: 'Display',
                    color: colorConstants.pinkAlt,
                    tableLabel: 'Display',
                },
                feature_and_display_only_units: {
                    label: 'Feature & Display',
                    color: colorConstants.orangeAlt2,
                    tableLabel: 'Feature & Display',
                },

                no_promo_units: {
                    label: 'Non Promo',
                    color: colorConstants.darkYellow,
                    tableLabel: 'Non Promo',
                },
                any_promo_units: {
                    label: 'Promo',
                    color: colorConstants.lightGreenAlt,
                    tableLabel: 'Promo',
                },
                promo_only_total_value: {
                    label: 'Promotions',
                    color: colorConstants.lightGreenAlt,
                    tableLabel: 'Promotions',
                },
                promo_only_total_units: {
                    label: 'Promotions',
                    color: colorConstants.lightGreenAlt,
                    tableLabel: 'Promotions',
                },

                //for export label
                sales_year_ago: { label: 'YA Sales' },
                total_value: { label: 'Total' },

                incremental_value_percentage: {
                    label: 'Promotion Sales Percentage',
                },
                incremental_units_percentage: {
                    label: 'Promotion Sales Percentage',
                },
                base_value_percentage: { label: 'Base Sales Percentage' },
                base_units_percentage: { label: 'Base Sales Percentage' },
                tpr_incremental_value_percentage: {
                    label: 'Price Cut Percentage',
                },
                tpr_incremental_units_percentage: {
                    label: 'Price Cut Percentage',
                },
                tpr_only_value_percentage: {
                    label: 'Price Cut Percentage',
                },
                tpr_only_units_percentage: {
                    label: 'Price Cut Percentage',
                },
                feature_incremental_value_percentage: {
                    label: 'Feature Percentage',
                },
                feature_incremental_units_percentage: {
                    label: 'Feature Percentage',
                },
                feature_only_value_percentage: { label: 'Feature Percentage' },
                feature_only_units_percentage: { label: 'Feature Percentage' },
                display_incremental_value_percentage: {
                    label: 'Display Percentage',
                },
                display_incremental_units_percentage: {
                    label: 'Display Percentage',
                },
                display_only_value_percentage: {
                    label: 'Display Percentage',
                },
                display_only_units_percentage: {
                    label: 'Display Percentage',
                },
                feature_and_display_incremental_value_percentage: {
                    label: 'Feature & Display Percentage',
                },
                feature_and_display_incremental_units_percentage: {
                    label: 'Feature & Display Percentage',
                },
                feature_and_display_only_value_percentage: {
                    label: 'Feature & Display Percentage',
                },
                feature_and_display_only_units_percentage: {
                    label: 'Feature & Display Percentage',
                },
                no_promo_value_percentage: { label: 'Non Promo Percentage' },
                no_promo_units_percentage: { label: 'Non Promo Percentage' },
                incremental_eq_volume_percentage: { label: 'Incremental Volume Percentage' },
                base_eq_volume_percentage: { label: 'Base Volume Percentage' },
            },
            tooltipExtraItems: {
                tpr_acv: { label: 'Price Cut ACV %' },
                display_acv: { label: 'Display ACV %' },
                feature_acv: { label: 'Feature ACV %' },
                feature_and_display_acv: { label: 'Feature & Display ACV %' },
                uplift: { label: 'Uplift' },
                promo_lift: { label: 'Promo Uplift' },
            },
            promoCalenderAttributeLevels: {
                promo: [
                    { value: 'product', label: 'Product' },
                    { value: 'channel', label: 'Channel' },
                ],
            },
            overlayKeys: {
                promo: [
                    { label: 'Start Week', dataKey: 'startTimestamp' },
                    { label: 'End Week', dataKey: 'endTimestamp' },
                    { label: 'Product', dataKey: 'product' },
                    { label: 'Promo Mechanics', dataKey: 'promoMech' },
                    { label: 'Promo Type', dataKey: 'promoType' },
                    { label: 'Investment', dataKey: 'field_value' },
                    // { label: 'ROI', dataKey: 'roi' },
                    // { label: 'Lift', dataKey: 'lift' },
                    // { label: 'Incremental Profit', dataKey: 'incrementalProfit' },
                    // { label: 'Incremental Retailer Profit', dataKey: 'incrementalRetailerProfit' },
                ],
            },
        },
        //PROMO SCORE CARD
        promoScoreCard: {
            mainHeader: 'Promo Scorecard',
            limit: 50,
            nestedTableLimit: 10,
            questionsNo: [1, 2, 3, 4, 6, 7],
            question: {
                Q: [
                    'Am I getting my fair share of quality support? ',
                    'How does my % Discount compare to competition? ',
                    'What % of Volume was sold on promotion? ',
                    'How many weeks am I promoting? ',
                    'What is my average price/units? ',
                    'What is my value share of promotions? ',
                ],
                unitsInItalics: [
                    '(Fair Share Index -£ Sold)',
                    '(Weighted Average % Price Reduction)',
                    '(% of Volume)',
                    '(Weighted Weeks)',
                    '(Price per Unit)',
                    '(Value share %)',
                ],
                unit: ['value', '%', '%', 'week', '£', '%'],
                numberFormateDecimal: [0, 1, 1, 0, 2, 1],
            },
            promoTypeLabelMapping: {
                display: { label: 'Display' },
                tpr: { label: 'Price Cut' },
                feature: { label: 'Feature' },
                feature_and_display: { label: 'Feature & Display' },
                feature_display: { label: 'Feature & Display' },
            },
            showGradientTile: true,
            promoType: ['Price Cut', 'Display', 'Feature', 'Feature & Display'],
            promoExpandedViewTableUnit: 'volume',
            promoExpandedViewTableSalesAndVolumeLabel: ['Volume', 'Total Sales £'],
            dropDown: ['Category', 'Subsector', 'Segment', 'Manufacturer'],
            listFor: ['Manufacturer', 'Product_Variant'],
            listForToDisplay: ['Manufacturer', 'Product_Variant'],
            listIn: ['Category', 'Subsector', 'Segment', 'Pack_Size', 'Channel'],
        },

        // PROMO LANDSCAPE
        promoLandscape: {
            mainHeader: 'Investment & ROI Tracker',
            roiLabel: 'ROI',
            defaultAttributeTypeIndex: 0,
            optimalInvestmentIndexThreshold1: 0.8,
            optimalInvestmentIndexThreshold2: 1.2,
            promoTacticDropdownName: 'Investment Type',
            dimensionConfig: {
                //snake case eg sub_category
                excludedDimensions: [],
                defaultDimension: '',
            },
            thresholdColorMapping: {
                optimal: { label: 'Optimal', color: colorConstants.darkGreen },
                over: { label: 'Over', color: colorConstants.darkRed },
                under: { label: 'Under', color: colorConstants.darkBlueAlt },
            },
            limit: 60,
            promoTypes: [
                { value: 'display', label: 'Display' },
                { value: 'tpr', label: 'Price Cut' },
                { value: 'feature', label: 'Feature' },
                // { value: 'feature & display', label: 'Feature & Display' },  //not required for now
            ],
            mediaLevelsDropdown: [],
            showInvestmentDropdown: false,
            optimalIndexKey: 'competition_spend_index',
            tableRowsKeyMapping: [
                {
                    label: 'Investment',
                    children: null,
                    parentKey: null,
                    key: 'investments',
                    unit: '£',
                },
                {
                    label: 'ROI',
                    children: null,
                    parentKey: null,
                    key: 'roi',
                    unit: '',
                },
                {
                    label: 'Optimal Investment Index',
                    children: [
                        {
                            label: 'Share of Investment',
                            key: 'share_of_investment',
                            unit: '',
                        },
                        {
                            label: 'Share of Sales',
                            key: 'share_of_sales',
                            unit: '',
                        },
                    ],
                    unit: '',
                    parentKey: 'competition_data',
                    key: 'competition_spend_index',
                },
                {
                    label: 'Incremental Sales',
                    children: [
                        {
                            label: 'Total Sales',
                            key: 'total_sales',
                            unit: '£',
                        },
                        {
                            label: 'Base Sales',
                            key: 'base_sales_dollar',
                            unit: '£',
                        },
                        {
                            label: 'Incremental Sales Eq',
                            key: 'incremental_sales_eq',
                            unit: '',
                        },
                        {
                            label: 'Total Sales Eq',
                            key: 'total_sales_eq',
                            unit: '',
                        },
                        {
                            label: 'Base Sales Eq',
                            key: 'base_sales_eq',
                            unit: '',
                        },
                    ],
                    unit: '£',
                    parentKey: 'incremental_sales_dollar_data',
                    key: 'incremental_sales_dollar',
                },
                {
                    label: 'Incremental Profit',
                    children: [
                        {
                            label: 'Share of Profit Pool',
                            key: 'share_of_profit_pool',
                            unit: '',
                        },
                        {
                            label: 'Total Profit',
                            key: 'total_profit',
                            unit: '',
                        },
                        {
                            label: 'Baseline Profit',
                            key: 'baseline_profit',
                            unit: '',
                        },

                        {
                            label: 'Incremental Net Sales',
                            key: 'incremental_net_sales',
                            unit: '£',
                        },
                        {
                            label: 'Total Net Sales',
                            key: 'total_net_sales',
                            unit: '£',
                        },
                        {
                            label: 'Baseline Net Sales',
                            key: 'baseline_net_sales',
                            unit: '£',
                        },
                        {
                            label: 'Promo % Margin',
                            key: 'promo_percentage_margin',
                            unit: '',
                        },
                        {
                            label: 'Baseline % Margin',
                            key: 'baseline_percentage_margin',
                            unit: '',
                        },
                    ],
                    parentKey: 'incremental_profit_data',
                    key: 'incremental_profit',
                    unit: '£',
                },
                {
                    label: 'Incremental Retailer Profit',
                    unit: '£',
                    children: [
                        {
                            label: 'Share of Profit Pool',
                            key: 'share_of_profit_pool_retailer',
                            unit: '',
                        },
                        {
                            label: 'Total Retailer Profit',
                            key: 'total_retailer_profit',
                            unit: '',
                        },
                        {
                            label: 'Baseline Retailer Profit',
                            key: 'baseline_retailer_profit',
                            unit: '',
                        },
                        {
                            label: 'Retailer Promo % Margin',
                            key: 'retailer_promo_percentage_margin',
                            unit: '',
                        },
                        {
                            label: 'Retailer Baseline % Margin',
                            key: 'retailer_baseline_percentage_margin',
                            unit: '',
                        },
                    ],
                    parentKey: 'incremental_retailer_profit_data',
                    key: 'incremental_retailer_profit',
                },
            ],
        },
        //PORTFOLIO ANALYSIS
        portfolioAnalysis: {
            mainHeader: 'Promo ROI Analysis',
            limit: 20,
            defaultGroupByIndex: 5,
            defaultGroupBy2Index: 6,
            chartColors: [],
            absTileData: [
                { key: 'Promotions', label: 'Promotions' },
                { key: 'Drivers', label: 'Drivers' },
            ],
            salesAttributionChart: {
                colorList: ['#10AB5E', '#DC3826'],
                colorListType2: ['#758BEE', '#758BEE'],
                profitPoolColor: ['#826FD0', '#826FD0'],
                backGroundColor: 'rgba(0, 0, 0, 0.02)',
            },
            chartDropdownExtraKpis: [
                {
                    dimension: 'none',
                    label: 'Tactics',
                    dataKey: 'tactic_description',
                },
                {
                    dimension: 'none',
                    label: 'Mechanics',
                    dataKey: 'promotion_mechanic',
                },
                // {
                //     dimension: 'none',
                //     label: 'Event Name',
                //     dataKey: 'event_name',
                // },
                {
                    dimension: 'dim1',
                    label: 'Week',
                    dataKey: 'week',
                },
            ],
            groupByHeaders: [
                {
                    label: 'Category',
                    value: 'category',
                    dimension: 'dim1',
                    isSelected: false,
                    sortKey: 'category',
                    multiSelectFilter: false,
                },
                {
                    label: 'Subsector',
                    value: 'subsector',
                    dimension: 'dim1',
                    isSelected: false,
                    sortKey: 'subsector',
                    multiSelectFilter: false,
                },

                {
                    label: 'Segment',
                    value: 'segment',
                    dimension: 'dim1',
                    isSelected: false,
                    sortKey: 'segment',
                    multiSelectFilter: false,
                },
                {
                    label: 'Product',
                    value: 'product',
                    dimension: 'dim1',
                    isSelected: true,
                    sortKey: 'product',
                    multiSelectFilter: false,
                },
                {
                    label: 'Mechanics',
                    value: 'promotion_mechanic',
                    dimension: null,
                    isSelected: false,
                    sortKey: 'promotion_mechanic',
                    multiSelectFilter: true,
                },
                {
                    label: 'Tactics',
                    value: 'tactic_description',
                    dimension: null,
                    isSelected: false,
                    sortKey: 'tactic_description',
                    multiSelectFilter: true,
                },
            ],
            chartHeaderLabelKeyMapping: {
                lift: { label: 'Lift' },
                roi: { label: 'ROI' },
                investments: { label: 'Investments' },
                incremental_net_sales: { label: 'Incremental Net Sales' },
                incremental_profit: { label: 'Incremental Profit' },
                incremental_retailer_profit: {
                    label: 'Incremental Retailer Profit',
                },
                acv: { label: 'ACV Distribution' },
                profit_pool: { label: 'Profit Pool' },
                tpr_acv: { label: 'Price Cut ACV' },
                display_acv: { label: 'Display ACV' },
                feature_acv: { label: 'Feature ACV' },
                feature_and_display_acv: { label: 'Feature & Display ACV' },
                total_acv: { label: 'Total ACV' },
                weeks: { label: 'Promo Weeks' },
            },
            dimension: 'dim1',
            attributeType: 'product',
            promoTypesChartLegends: [
                {
                    label: 'Price Cut',
                    color: colorConstants.lightCyan,
                    style: {
                        borderRadius: '100%',
                        height: `8px`,
                        width: '8px',
                    },
                },
                {
                    label: 'Feature',
                    color: colorConstants.lightCream,
                    style: {
                        borderRadius: '100%',
                        height: `8px`,
                        width: '8px',
                    },
                },
                {
                    label: 'Display',
                    color: colorConstants.lightPink,
                    style: {
                        borderRadius: '100%',
                        height: `8px`,
                        width: '8px',
                    },
                },
            ],
            promoTypes: ['tpr', 'feature', 'display'],
            promoTypesLabelMapping: {
                tpr: 'Price Cut',
                feature: 'Feature',
                display: 'Display',
            },
        },
        promoRecommendation: {
            playbookLimit: 50,
            clientName: 'Nomad Foods',
            mainHeader: 'Promo Recommendation',

            retailerKey: 'channel',
            hideAddSpends: false,

            calenderStartDay: 'Monday',
            spendLeversList: [
                {
                    label: 'Baseline Volume',
                    placeholder: 'Baseline Volume',
                    value: 'baseVolume',
                    isDisabled: false,
                },
                {
                    label: 'Uplift',
                    placeholder: 'Uplift',
                    value: 'uplift',
                    isDisabled: false,
                },
                {
                    label: 'Total Volume',
                    placeholder: 'Total Volume',
                    value: 'totalVolume',
                    isDisabled: true,
                },
                {
                    label: `Total Nomad Foods Profit (£)`,
                    placeholder: `Total Nomad Foods Profit`,
                    value: 'totalKindProfit',
                    isDisabled: true,
                },
                {
                    label: 'ROI',
                    placeholder: 'ROI',
                    value: 'roi',
                    isDisabled: true,
                },
                {
                    label: `Total Retailer Profit (£)`,
                    placeholder: 'Total Retailer Profit',
                    value: 'totalRetailerProfit',
                    isDisabled: true,
                },
            ],
            spendTypeList: [
                {
                    label: 'Lump Sum',
                    value: 'lump_sum',
                    inputRule: '',
                },
                {
                    label: 'Per Qty',
                    value: 'per_qty',
                    inputRule: '',
                },
                {
                    label: 'Off Shelf',
                    value: 'display',
                    inputRule: '',
                },
                {
                    label: 'On Shelf',
                    value: 'feature',
                    inputRule: '',
                },
            ],
            playbookKeyMapping: {
                Product: ['ppgName'],
                '%TS': ['guidelinePercentageTotalSpends', 'percentageTotalSpends', 'lesser_than', '', '%'],
                Frequency: ['guidelineFrequency', 'frequency', 'range', ''],
                ROI: ['guidelineRoi', 'roi', 'greater_than', '', ''],
            },
            // comparisonOperator: {
            //     '%TS': '<',
            //     Frequency: 'range',
            //     ROI: '>',
            // },
            menuButtons: [
                { key: 'recommendations', label: 'Recommendations' },
                {
                    key: 'summary',
                    label: 'Summary',
                },
                {
                    key: 'playbook',
                    label: 'Playbook',
                },
            ],

            promoTypeColorMapping: {
                'display and feature#end 1': {
                    label: 'End 1',
                    color: colorConstants.lightGreenAlt,
                },
                'display and feature#end 2': {
                    label: 'End 2',
                    color: colorConstants.darkGreenAlt2,
                },
                'display and feature#end 3': {
                    label: 'End 3',
                    color: colorConstants.pinkAlt,
                },
                'display and feature#end 4': {
                    label: 'End 4',
                    color: colorConstants.orangeAlt2,
                },
                'display and feature#end 5': {
                    label: 'End 5',
                    color: colorConstants.darkYellow,
                },
                'display and feature#end 6': {
                    label: 'End 6',
                    color: colorConstants.blueAlt4,
                },
                'display#shelf': {
                    label: 'Shelf',
                    color: colorConstants.violetAlt,
                },
                // 'display online only': {
                //     label: 'Online Only',
                //     color: colorConstants.lightGreenAlt2,
                // },
            },
            overlayKeys: [
                {
                    label: 'Start Date',
                    dataKey: 'startDate',
                    pre: '',
                    post: '',
                },
                { label: 'Duration', dataKey: 'duration', pre: '', post: '' },
                {
                    label: 'Promo Type',
                    dataKey: 'tacticDescription',
                    pre: '',
                    post: '',
                },
                { label: 'Product(s)', dataKey: 'dim1AttributeNames', pre: '', post: '' },
                {
                    label: 'Total Volume',
                    dataKey: 'totalVolume',
                    pre: '',
                    post: '',
                    arrowConfig: 'positiveUp',
                },
                {
                    label: 'Total GSV',
                    dataKey: 'totalGsv',
                    pre: '£',
                    post: '',
                    arrowConfig: 'positiveUp',
                },
                {
                    label: 'Total NSV',
                    dataKey: 'totalNsv',
                    pre: '£',
                    post: '',
                    arrowConfig: 'positiveUp',
                },
                {
                    label: 'Total Nomad Foods Profit',
                    dataKey: 'totalKindProfit',
                    pre: '£',
                    post: '',
                    arrowConfig: 'positiveUp',
                },
                {
                    label: 'Total Retailer Profit',
                    dataKey: 'totalRetailerProfit',
                    pre: '£',
                    post: '',
                    arrowConfig: 'positiveUp',
                },
                {
                    label: 'Promo Spends',
                    dataKey: 'promoSpends',
                    pre: '£',
                    post: '',
                    arrowConfig: 'negativeUp',
                },
                {
                    label: '% Trade Spends GSV',
                    dataKey: 'percentageTradeSpendsGsv',
                    pre: '',
                    post: '%',
                    arrowConfig: 'negativeUp',
                },
                {
                    label: '% Trade Spends NSV',
                    dataKey: 'percentageTradeSpendsNsv',
                    pre: '',
                    post: '%',
                    arrowConfig: 'negativeUp',
                },

                {
                    label: 'Incremental Volume',
                    dataKey: 'incrementalVolume',
                    pre: '',
                    post: '',
                    arrowConfig: 'positiveUp',
                },
                {
                    label: 'Incremental GSV',
                    dataKey: 'incrementalGsv',
                    pre: '£',
                    post: '',
                    arrowConfig: 'positiveUp',
                },
                {
                    label: 'Incremental NSV',
                    dataKey: 'incrementalNsv',
                    pre: '£',
                    post: '',
                    arrowConfig: 'positiveUp',
                },
                {
                    label: 'Total Profit %',
                    dataKey: 'totalProfitPercentage',
                    pre: '',
                    post: '%',
                    arrowConfig: 'positiveUp',
                },
                {
                    label: 'Incremental Profit',
                    dataKey: 'incrementalProfit',
                    pre: '£',
                    post: '',
                    arrowConfig: 'positiveUp',
                },
                {
                    label: 'Promo ROI',
                    dataKey: 'roi',
                    pre: '',
                    post: '',
                    arrowConfig: 'positiveUp',
                },
                {
                    label: 'Retailer Incremental Profit',
                    dataKey: 'retailerIncrementalProfit',
                    pre: '£',
                    post: '',
                    arrowConfig: 'positiveUp',
                },
            ],
            spendLabel: {
                lump_sum: 'Lump Sum',
                per_qty: 'Per Qty',
                display: 'Off Shelf',
                feature: 'On Shelf',
            },
            offerMethodList: [
                { value: 'option', label: 'List of Option', dimension: 'dim1' },
                { value: 'manual', label: 'Manual', dimension: 'dim1' },
                { value: 'previous', label: 'Previous', dimension: 'dim1' },
            ],
            addEventList: [
                { value: 'new', label: 'Add New Event' },
                { value: 'import', label: 'Import Event' },
            ],
            leverKeys: [
                'promptEventName',
                'offerMethod',
                'discount',
                'startDate',
                'duration',
                'displayAcv',
                'featureAcv',
            ],
            spendTopForm: ['baseVolume', 'uplift', 'totalVolume', 'totalKindProfit', 'roi', 'totalRetailerProfit'],
            formList: [
                {
                    value: 'duration',
                    label: 'Duration',
                    inputRule: '',
                    placeHolder: 'Enter',
                },
                {
                    value: 'displayAcv',
                    label: 'Off Shelf ACV',
                    inputRule: '',
                    placeHolder: 'Enter Off Shelf ACV',
                },
                {
                    value: 'featureAcv',
                    label: 'On Shelf ACV',
                    inputRule: '',
                    placeHolder: 'Enter On Shelf ACV',
                },
            ],
            offerSelectionKeys: ['promotionMechanic', 'tacticDescription'],
            spendPerQtyKey: ['per_qty', 'redemption'],
        },
        commercialForecast: {
            externalAnalyticsToolName: { shortName: 'VF' },
            excludedAttributeTypes: ['manufacturer'],
            limit: 60,
            forecastDropdownData: [
                {
                    key: 'asper',
                    label: 'Asper Forecast',
                    value: 'asper',
                    dataKey: 'asper',
                },
                {
                    key: 'external',
                    label: 'VF Forecast',
                    value: 'external',
                    dataKey: 'external',
                },
                {
                    key: 'difference',
                    label: 'Difference',
                    value: 'difference',
                    dataKey: 'difference',
                },
                // { key: 'profit', label: 'Profit', value: 'profit', dataKey: 'profit' },
            ],
            trendChartDropdownData: [
                {
                    key: 'month',
                    label: 'Months',
                    labelAlt: 'Monthly',
                    value: 'month',
                    dataKey: 'month',
                },
                {
                    key: 'week',
                    label: 'Weeks',
                    labelAlt: 'Weekly',
                    value: 'week',
                    dataKey: 'week',
                },
                // { key: 'profit', label: 'Profit', value: 'profit', dataKey: 'profit' },
            ],
            graphExportHeaderMapping: {
                base: ['Non-promo', 'Promo'],
                incremental: ['Base', 'Incremental'],
                total: ['Consumption'],
                depletion: ['Depletion'],
            },
            mainTileData: [
                { key: 'total', label: 'Total' },
                { key: 'base', label: 'Base' },
                { key: 'incremental', label: 'Incremental' },
            ],
            graphLegendMapping: {
                total_asper: {
                    color: colorConstants.lightGreenAlt,
                    label: 'Total Units Asper',
                },
                base_asper: {
                    color: colorConstants.lightGreenAlt,
                    label: 'Base Units Asper',
                },
                incremental_asper: {
                    color: colorConstants.lightGreenAlt,
                    label: 'Incremental Units Asper',
                },
                total_external: {
                    color: colorConstants.darkYellow,
                    label: 'Total Units VF',
                },
                base_external: {
                    color: colorConstants.darkYellow,
                    label: 'Base Units VF',
                },
                incremental_external: {
                    color: colorConstants.darkYellow,
                    label: 'Incremental Units VF',
                },
                total_difference: {
                    color: colorConstants.orangeAlt2,
                    label: 'Total Units Difference',
                },
                base_difference: {
                    color: colorConstants.orangeAlt2,
                    label: 'Base Units Difference',
                },
                incremental_difference: {
                    color: colorConstants.orangeAlt2,
                    label: 'Incremental Units Difference',
                },
            },
            tableKeyLabelMapping: {
                total_sales_asper: {
                    label: 'Total Units Asper',
                    pre: '',
                    post: '',
                },
                total_sales_difference: {
                    label: 'Total Units Difference',
                    pre: '',
                    post: '',
                },
                total_sales_external: {
                    label: 'Total Units VF',
                    pre: '',
                    post: '',
                },
                incremental_sales_asper: {
                    label: 'Incremental Units Asper',
                    pre: '',
                    post: '',
                },
                incremental_sales_difference: {
                    label: 'Incremental Units Difference',
                    pre: '',
                    post: '',
                },
                incremental_sales_external: {
                    label: 'Incremental Units VF',
                    pre: '',
                    post: '',
                },
                base_sales_asper: {
                    label: 'Base Units Asper',
                    pre: '',
                    post: '',
                },
                base_sales_difference: {
                    label: 'Base Units Difference',
                    pre: '',
                    post: '',
                },
                base_sales_external: {
                    label: 'Base Units VF',
                    pre: '',
                    post: '',
                },
            },
        },
        priceLadder: {
            isThresholdDropdownEnabled: true,
            hideMraup: true,
            limit: 50, //update this when implementing infinite scroller,
            dimensionConfig: {
                //snake case eg sub_category
                excludedDimensions: [],
                defaultDimension: 'Manufacturer',
            },
            tileData: [
                {
                    label: 'Product by Market',
                    key: 'product by market',
                },
                // {
                //     label: 'Product vs Competitors',
                //     key: 'product vs competitors',
                // },
            ],
            subTileData: [
                {
                    label: 'PPU',
                    key: 'PU',
                },
                {
                    label: 'PPKG',
                    key: 'PEQ',
                },
            ],
            legendMapping: {
                PU: [
                    {
                        color: '#E6E6EA',
                        label: 'Sales £',
                        key: 'salesValueDollars',
                        dataKey: 'sales',
                        metricDataKey: 'units',
                    },
                    {
                        color: '#66AFBA',
                        label: 'Avg. Price Per Unit',
                        key: 'avgPrice',
                        dataKey: 'avg_price_per_unit',
                        metricDataKey: 'units',
                    },
                    {
                        color: '#ECA586',
                        label: 'Max Price Per Unit',
                        key: 'maxPrice',
                        dataKey: 'max_price_per_unit',
                        metricDataKey: 'units',
                    },
                    {
                        color: '#EB8FC5',
                        label: 'Min Price Per Unit',
                        key: 'minPrice',
                        dataKey: 'min_price_per_unit',
                        metricDataKey: 'units',
                    },
                    {
                        color: '#F1C77A',
                        label: 'Promo Price Per Unit',
                        key: 'promoPrice',
                        dataKey: 'promo_price_per_unit',
                        metricDataKey: 'units',
                    },
                    {
                        color: '#6771DB',
                        label: 'Base Price Per Unit',
                        key: 'basePrice',
                        dataKey: 'base_price_per_unit',
                        metricDataKey: 'units',
                    },
                    // { color: '#5463FF', label: 'MRAUP', key: 'mraup', dataKey: 'mraup' },
                ],
                PEQ: [
                    {
                        color: '#E6E6EA',
                        label: 'Sales £',
                        key: 'salesValueDollars',
                        dataKey: '',
                        metricDataKey: 'volume',
                    },
                    {
                        color: '#66AFBA',
                        label: 'Avg. Price PEQ',
                        key: 'avgPrice',
                        dataKey: 'avg_price_per_eq',
                        metricDataKey: 'volume',
                    },
                    {
                        color: '#ECA586',
                        label: 'Max Price PEQ',
                        key: 'maxPrice',
                        dataKey: 'max_price_per_eq',
                        metricDataKey: 'volume',
                    },
                    {
                        color: '#EB8FC5',
                        label: 'Min Price PEQ',
                        key: 'minPrice',
                        dataKey: 'min_price_per_eq',
                        metricDataKey: 'volume',
                    },
                    {
                        color: '#F1C77A',
                        label: 'Promo Price PEQ',
                        key: 'promoPrice',
                        dataKey: 'promo_price_per_eq',
                        metricDataKey: 'volume',
                    },
                    {
                        color: '#6771DB',
                        label: 'Base Price PEQ',
                        key: 'basePrice',
                        dataKey: 'base_price_per_eq',
                        metricDataKey: 'volume',
                    },
                    // { color: '#5463FF', label: 'MRAUP', key: 'mraup', dataKey: 'mraup' },
                ],
            },
            dataKeyMapping: {
                PU: [
                    { label: 'Sales £', key: 'salesValueDollars' },
                    { label: 'Avg. Price Per Unit', key: 'avgPrice' },
                    { label: 'Max Price Per Unit', key: 'maxPrice' },
                    { label: 'Min Price Per Unit', key: 'minPrice' },
                    { label: 'Promo Price Per Unit', key: 'promoPrice' },
                    { label: 'Base Price Per Unit', key: 'basePrice' },
                ],
                PEQ: [
                    { label: 'Sales £', key: 'salesValueDollars' },
                    { label: 'Avg. Price PEQ', key: 'avgPrice' },
                    { label: 'Max Price PEQ', key: 'maxPrice' },
                    { label: 'Min Price PEQ', key: 'minPrice' },
                    { label: 'Promo Price PEQ', key: 'promoPrice' },
                    { label: 'Base Price PEQ', key: 'basePrice' },
                ],
            },
            tableColumnLabelKeyMapping: {
                sales: { label: 'Sales £' },
                sales_percentage: { label: 'Sales %' },
                avg_price_pu: { label: 'Average Price £ Per Unit' },
                // avg_price_peq: { label: 'Average Price £ PEQ' },
                max_price_pu: { label: 'Max Price £ Per Unit' },
                // max_price_peq: { label: 'Max Price £ PEQ' },
                min_price_pu: { label: 'Min Price £ Per Unit' },
                // min_price_peq: { label: 'Min Price £ PEQ' },
                // mraup: { label: 'MRAUP' },
                base_price_pu: { label: 'Base Price £ Per Unit' },
                // base_price_peq: { label: 'Base Price £ PEQ' },
                promo_price_pu: { label: 'Promo Price £ Per Unit' },
                // promo_price_peq: { label: 'Promo Price £ PEQ' },
            },
            dropdown2Filter: ['Category', 'Pack_Size', 'Segment', 'Channel', 'Retailer'],
        },
        opportunityIdentification: {
            reversePpeAxis: false,
            bubbleCategoryOptions: [
                { value: 'category', label: 'Category', dimension: 'dim1' },
                { value: 'subsector', label: 'Subsector', dimension: 'dim1' },
                {
                    value: 'manufacturer',
                    label: 'Manufacturer',
                    dimension: 'dim1',
                },
                { value: 'pack_size', label: 'Pack Size', dimension: 'dim1' },

                { value: 'product', label: 'Product', dimension: 'dim1' },
                { value: 'channel', label: 'Channel', dimension: 'dim2' },
            ],
            kpis: {
                xaxis: [
                    { label: 'Base Price Elasticity', value: 'bpe' },
                    { label: 'Value Sales Growth %', value: 'rsv_growth' },
                    { label: 'Gross Profit %', value: 'mac_percentage' },
                ],
                yaxis: [
                    { label: 'Promo Depth Elasticity', value: 'ppe' },
                    { label: 'Value Sales Growth %', value: 'rsv_growth' },
                    { label: 'Gross Profit %', value: 'mac_percentage' },
                ],
                bubbleSize: [
                    { label: 'Eq Volume', value: 'total_volume' },
                    // { label: 'Units', value: 'total_units' },
                    { label: 'Base Price Elasticity', value: 'bpe' },
                    { label: 'Promo Depth Elasticity', value: 'ppe' },
                    { label: 'Gross Profit', value: 'mac' },
                    { label: 'Gross Profit %', value: 'mac_percentage' },
                    { label: 'Value Sales', value: 'rsv' },
                    { label: 'Value Sales Growth %', value: 'rsv_growth' },
                ],
            },
            elasticityDriver: {
                chart2Limit: 100,
                levels: [
                    { value: 'category', label: 'Category', dimension: 'dim1' },
                    { value: 'subsector', label: 'Subsector', dimension: 'dim1' },
                    {
                        value: 'manufacturer',
                        label: 'Manufacturer',
                        dimension: 'dim1',
                    },
                    { value: 'pack_size', label: 'Pack Size', dimension: 'dim1' },

                    { value: 'product', label: 'Product', dimension: 'dim1' },
                    { value: 'channel', label: 'Channel', dimension: 'dim2' },
                ],
                limit: 50,
                offset: 0,
                dimension: 'dim1',
                legendMapping: [
                    {
                        dataKey: 'own',
                        label: 'Own Elasticity',
                        color: '#69D4E8',
                    },
                    {
                        dataKey: 'internal',
                        label: 'Internal Competitor Elasticity',
                        color: '#E469B2',
                    },
                    {
                        dataKey: 'external',
                        label: 'External Competitor Elasticity',
                        color: '#EDB44E',
                    },
                ],
            },
        },
        priceCurve: {
            chart1Limit: 100,
            xAxisKeyValue: [
                // { value: 'pack_size', label: 'Pack Size' },
                { value: 'subsector', label: 'Subsector' },
                { value: 'segment', label: 'Segment' },
                { value: 'manufacturer', label: 'Manufacturer' },
            ],
            YAxisKeyValue: [
                { value: 'retail_price', label: 'Retail Price' },
                // { value: 'list_price', label: 'List Price' },
                { value: 'base_price', label: 'Base Price' },
            ],
            levels: [
                { value: 'category', label: 'Category' },
                { value: 'subsector', label: 'Subsector' },
                { value: 'manufacturer', label: 'Manufacturer' },
                { value: 'product_variant', label: 'Product Variant' },
                // { value: 'pack_size', label: 'Pack Size' },
            ],
            subTileData: [
                {
                    label: 'PPU',
                    key: 'PU',
                    dataKey: 'per_unit',
                },
                {
                    label: 'PPKG',
                    key: 'PEQ',
                    dataKey: 'per_eq',
                },
            ],
            chartColors: [
                '#E8A122',
                '#293BB8',
                '#E06936',
                '#19669D',
                '#A5582D',
                '#43C9E2',
                '#DD449F',
                '#37C7BE',
                '#9E5897',
                '#00798C',
                '#EDB44E',
                '#4557D5',
                '#E6875E',
                '#228BD6',
                '#CC7442',
                '#69D4E8',
                '#E469B2',
                '#5FD3CB',
                '#B377AD',
                '#3394A3',
                '#F1C77A',
                '#7381E0',
                '#ECA586',
                '#55A8E4',
                '#D89672',
                '#8EDFEE',
                '#EB8FC5',
                '#87DED8',
                '#C699C2',
                '#66AFBA',
                '#F6D9A7',
                '#A2ABEA',
                '#F3C3AF',
                '#8EC5ED',
                '#E5B9A1',
                '#B4E9F3',
                '#F1B4D9',
                '#AFE9E5',
                '#D9BBD6',
                '#99C9D1',
                '#FAECD3',
                '#D0D5F5',
                '#F9E1D7',
                '#C6E2F6',
                '#F2DCD0',
                '#D9F4F9',
                '#F8DAEC',
                '#D7F4F2',
                '#ECDDEB',
                '#CCE4E8',
            ],
            tableHeaders: [
                { label: 'List Price £', key: 'list_price' },
                { label: 'List Price £ YA', key: 'list_price_ya' },
                { label: 'Retail Price £', key: 'retail_price' },
                { label: 'Retail Price £ YA', key: 'retail_price_ya' },
                { label: 'Base Price £', key: 'base_price' },
                { label: 'Base Price £ YA', key: 'base_price_ya' },
            ],
        },
        pricePoint: {
            priceRange: [0, 10],
            graphColorScheme: ['#D7D6D9', '#69d4e8', '#228bd6', '#b377ad', '#66AFBA', '#ECA586', '#F1C77A', '#EB8FC5'],
            hideMraup: true,
            limit: 500,
            dimensionConfig: {
                //snake case eg sub_category
                excludedDimensions: [],
                defaultDimension: 'Manufacturer',
            },
            contributionThreshold: 5,
            priceTypeOptions: [
                { label: 'Avg Price', value: 'avg_price' },
                { label: 'Base Price', value: 'base_price' },
            ],
            subTileData: [
                {
                    label: 'PPU',
                    key: 'per_unit',
                    xAxisLabel: 'Price Per Unit',
                    tooltip: 'Per Unit',
                },
                {
                    label: 'PPKG',
                    key: 'per_volume',
                    xAxisLabel: 'Price Per Eq',
                    tooltip: 'Per Eq Volume',
                },
            ],
            yAxisDropdownData: [
                {
                    label: 'Value',
                    value: 'value',
                },
                // {
                //     label: 'Volume',
                //     value: 'volume',
                // },
                {
                    label: 'Units',
                    value: 'units',
                },
            ],
            tableHeaderKeyMapping: {
                growth_percentage: ['Growth % vs YA', '', '%'],
                total_sales: ['Total Value (£)', '£', ''],
                total_volume: ['Total Volume', '', ''],
                total_units: ['Total Units', '£', ''],
                avg_price_per_unit: ['Avg. Price per Unit', '£', ''],
                avg_price_per_eq: ['Avg. Price per EQ', '£', ''],
                base_price_per_unit: ['Base Price per Unit', '$', ''],
                base_price_per_eq: ['Base Price per EQ', '$', ''],
            },
            drilldownTableHeaderKeyMapping: {
                growth_abs: ['Growth Abs', '£', ''],
                growth_percentage: ['Growth %', '', '%'],
                contribution_to_category: ['Contribution to category', '£', ''],
                cy_share: ['CY share', '', '%'],
                ya_share: ['YA share', '', '%'],
                change: ['Change %', '', '%'],
            },
            dropdown2Filter: ['Category', 'Segment', 'Channel', 'Retailer'],
            customThresholdData: [
                {
                    id: 1,
                    value: '',
                },
                {
                    id: 2,
                    value: '',
                },
                {
                    id: 3,
                    value: '',
                },
                {
                    id: 4,
                    value: '',
                },
                {
                    id: 5,
                    value: '',
                },
            ],
        },
        priceTracking: {
            limit: 20,
            dimensionConfig: {
                //snake case eg sub_category
                excludedDimensions: [],
                defaultRowDimension: 'Product',
                defaultColumnDimension: 'Channel',
            },
            attributeNamesLimit: 50,
            frequency: 'W',
            timePeriodOptions: [
                { label: 'YA', value: 'year_ago' },
                { label: 'Prior Period', value: 'prior_period' },
                { label: 'Custom Period', value: 'custom' },
            ],
            priceTypeOptions: [
                { label: 'Base Price', value: 'base' },
                { label: 'Avg Price', value: 'average' },
            ],
            kpiOptions: [
                { label: '% Change', value: 'percent_change' },
                { label: 'Price Index', value: 'index' },
            ],
            subTileData: [
                {
                    label: 'PPU',
                    key: 'units',
                    xAxisLabel: 'Price Per Unit',
                    tooltip: 'Per Unit',
                },
                {
                    label: 'PPKG',
                    key: 'volume',
                    xAxisLabel: 'Price Per Eq',
                    tooltip: 'Per Eq Volume',
                },
            ],

            weeksOptions: [
                { label: 'L W1', value: 1 },
                { label: 'L W4', value: 4 },
                { label: 'L W12', value: 12 },
            ],
            monthsOptions: [
                { label: 'L M1', value: 1 },
                { label: 'L M3', value: 3 },
                { label: 'L M6', value: 6 },
                { label: 'L M12', value: 12 },
            ],
            quartersOptions: [
                { label: 'L Q1', value: 1 },
                { label: 'L Q2', value: 2 },
                { label: 'L Q4', value: 4 },
            ],
            kpiMapping: {
                'Base Price': ['£', ''],
                'Base Price YA': ['£', ''],
                'Avg Price': ['£', ''],
                'Avg Price YA': ['£', ''],
                'Base Price Index % Chg': ['', '%'],
                'Base Price % Chg': ['', '%'],
                'Avg Price Index % Chg': ['', '%'],
                'Avg Price % Chg': ['', '%'],
                'TDP % Chg': ['', '%'],
                TDP: ['', ''],
                'TDP YA': ['', ''],
                'Volume Velocity % Chg': ['', '%'],
                'Volume Velocity': ['', ''],
                'Volume Velocity YA': ['', ''],
            },
        },
        bestWeeks: {
            limit: 50,
            drilldownTableConfig: [
                { label: 'Period No:', value: 'period_no', sorting: false },
                { label: 'Year', value: 'year', sorting: false },
            ],
            dimensionConfig: {
                //snake case eg sub_category
                excludedDimensions: ['dim2'],
                defaultDimension: 'Brand',
            },
        },
    },
    perrigoSpain: {
        //COMMON CONFIG
        commonConfig: {
            clientName: 'Perrigo Spain',
            handleDim2SortingFromFrontend: false,
            dateFormat: 'DD/MM/YY',
            dateFormatAlt: 'DD/MM/YY',
            calenderStartDay: 'Saturday',
            showSecondaryLogo: false,
            showLogoInNavbar: true,
            logoHeight: '32px',
            logoWidth: '125px',
            loginPageTextPart1: 'Welcome to',
            loginPageTextPart2: 'Commercial Growth AI Tool',
            width: window.innerWidth,
            limit: 10,
            offset: 0,
            lagList: [0, 1],
            graphFontSize: calculateFontSize(window.innerWidth, 13),
            graphFontSizeAlt: calculateFontSize(window.innerWidth, 13),
            graphFontFamily: "'Helvetica Neue', sans-serif",
            graphLabelColorAlt: '#4E4C55',
            graphLabelColor: '#433C4A',
            units: {
                currency: '€',
                volume: 'Eq Vol',
                currencyText: 'Value',
            },
            filterFormat: { dim1: { ids: [] }, dim2: { ids: [] } },
            frequency: 'M',
            showCampignCalender: false,
            showFullLabel: true,
            decimalForPercentage: 1,
            decimalForNonPercentage: 2,
        },
        latestDateForDifferentRoutes: {
            'promo-score-card': 'Promotion Data',
            'roi-analysis': 'Promotion Data',
            'roi-tracker': 'Promotion Data',
            'commercial-forecast': 'Commercial Forecast',
            default: 'POS Data',
        },
        screenDetailsWithRoutes: [
            {
                label: 'Growth Analysis',
                path: 'promo/category-diagnostics/growth-analysis',
                id: 'ga',
                pageId: 'ga',
            },
            {
                label: 'Bump Report',
                path: 'promo/category-diagnostics/bump-report',
                id: 'br',
                pageId: 'br',
            },
            {
                label: 'Growth Analysis',
                path: 'promo/shipment-analysis/s-growth-analysis', //shipment analysis
                id: 'sga',
                pageId: 'sga',
            },
            {
                label: 'Bump Report',
                path: 'promo/shipment-analysis/s-bump-report', //shipment analysis
                id: 'sbr',
                pageId: 'sbr',
            },
            {
                label: 'Price Change',
                path: 'pricing/analytics/price-change',
                id: 'pcn',
                pageId: 'pcn',
            },
            {
                label: 'Price Point',
                path: 'pricing/analytics/price-point',
                id: 'pp',
                pageId: 'pp',
            },
            {
                label: 'Price Ladder',
                path: 'pricing/analytics/price-ladder',
                id: 'pld',
                pageId: 'pld',
            },
            {
                label: 'Price Curve',
                path: 'pricing/analytics/price-curve',
                id: 'pc',
                pageId: 'pc',
            },
            {
                label: 'Price Tracking',
                path: 'pricing/analytics/price-tracking',
                id: 'pt',
                pageId: 'pt',
            },
            {
                label: 'Opportunity Identification',
                path: 'pricing/analytics/opportunity-identification',
                id: 'oi',
                pageId: 'oi',
            },
            // {
            //     label: 'Promo Scorecard',
            //     path: 'promo/analytics/promo-score-card',
            //     id: 'ps',
            //     pageId: 'ps',
            // },
            // {
            //     label: 'Investment & ROI Tracker',
            //     path: 'promo/analytics/roi-tracker',
            //     id: 'pl',
            //     pageId: 'pl',
            // },
            // {
            //     label: 'Promo ROI Analysis',
            //     path: 'promo/analytics/roi-analysis',
            //     id: 'pa',
            //     pageId: 'pa',
            // },
            {
                label: 'Commercial Forecast',
                path: 'promo/recommendation/commercial-forecast',
                id: 'cf',
                pageId: 'cf',
            },

            {
                label: 'Promo Recommendation',
                path: 'promo/recommendation/promo-recommendation',
                id: 'pr',
                pageId: 'pr',
            },
            // { label: 'Pricing Simulator', path: 'pricing/recommendation/price-simulator', id: 'psr', pageId: 'psr' },
            // {
            //     label: 'Pricing Simulator',
            //     path: 'pricing/recommendation/price-simulator/new',
            //     id: 'psr',
            //     pageId: 'psrNew',
            // },
            // {
            //     label: 'Pricing Simulator',
            //     path: 'pricing/recommendation/price-simulator/edit/:id',
            //     id: 'psr',
            //     pageId: 'psrEdit',
            // },
            // {
            //     label: 'Pricing Simulator',
            //     path: 'pricing/recommendation/price-simulator/view/:id',
            //     id: 'psr',
            //     pageId: 'psrView',
            // },
            {
                label: 'Pricing Simulator',
                path: 'pricing/recommendation/pricing-simulator',
                id: 'psrV2', //update id in simulator context as well
                pageId: 'psrV2',
            },
            {
                label: 'Pricing Simulator',
                path: 'pricing/recommendation/pricing-simulator/:mode/:projectId/scenario/:scenarioId',
                id: 'psr',
                pageId: 'psrV2Update',
            },
            {
                label: 'Pricing Simulator',
                path: 'pricing/recommendation/pricing-simulator/:mode/:projectId/scenario/:scenarioId',
                id: 'psr',
                pageId: 'psrV2View',
            },
            {
                label: 'Pricing Analytics',
                path: 'pricing/recommendation/pricing-analytics',
                id: 'psa',
                pageId: 'psa', // pricing analytics
            },
            {
                label: 'Pricing Analytics',
                path: 'pricing/recommendation/pricing-analytics/:mode/:reportId',
                id: 'psa',
                pageId: 'psaUpdate', // pricing analytics update
            },
            {
                label: 'Pricing Analytics',
                path: 'pricing/recommendation/pricing-analytics/:mode/:reportId',
                id: 'psa',
                pageId: 'psaView', // pricing analytics view
            },
            {
                label: 'Best Weeks',
                path: 'promo/recommendation/best-weeks',
                id: 'bw',
                pageId: 'bw',
            },
        ],
        screens: [
            {
                label: 'Category Diagnostics',
                path: ['promo/category-diagnostics'],
                showSubHeader: false,
                options: {
                    Promo: [
                        {
                            label: 'Growth Analysis',
                            path: 'growth-analysis',
                            id: 'ga',
                        },
                        { label: 'Bump Report', path: 'bump-report', id: 'br' },
                    ],
                    visible: false,
                },
            },
            {
                label: 'Shipment Analysis',
                path: ['promo/shipment-analysis'],
                showSubHeader: false,
                options: {
                    Promo: [
                        {
                            label: 'Growth Analysis',
                            path: 's-growth-analysis',
                            id: 'sga',
                        },
                        { label: 'Bump Report', path: 's-bump-report', id: 'sbr' },
                    ],
                    visible: false,
                },
            },
            {
                label: 'Pricing Analytics',
                path: ['pricing/analytics', null],
                showSubHeader: false,
                options: {
                    Promo: [
                        {
                            label: 'Price Change',
                            path: 'price-change',
                            id: 'pcn',
                        },
                        { label: 'Price Point', path: 'price-point', id: 'pp' },
                        {
                            label: 'Price Ladder',
                            path: 'price-ladder',
                            id: 'pld',
                        },
                        { label: 'Price Curve', path: 'price-curve', id: 'pc' },
                        {
                            label: 'Price Tracking',
                            path: 'price-tracking',
                            id: 'pt',
                        },
                        {
                            label: 'Opportunity Identification',
                            path: 'opportunity-identification',
                            id: 'oi',
                        },
                    ],
                    visible: false,
                },
            },
            // {
            //     label: 'Promo Analytics',
            //     path: ['promo/analytics', null],
            //     showSubHeader: false,
            //     options: {
            //         Promo: [
            //             {
            //                 label: 'Promo Scorecard',
            //                 path: 'promo-score-card',
            //                 id: 'ps',
            //             },
            //             {
            //                 label: 'Investment & ROI Tracker',
            //                 path: 'roi-tracker',
            //                 id: 'pl',
            //             },
            //             {
            //                 label: 'Promo ROI Analysis',
            //                 path: 'roi-analysis',
            //                 id: 'pa',
            //             },
            //         ],
            //         visible: false,
            //     },
            // },
            {
                label: 'Price & Promo Modeling',
                path: ['promo/recommendation', 'pricing/recommendation'],
                showSubHeader: true,
                options: {
                    Promo: [
                        { label: 'On Invoice Discounts Simulator', path: 'promo-recommendation', id: 'pr' },
                        // { label: 'Commercial Forecast', path: 'commercial-forecast', id: 'cf' },
                        // {
                        //     label: 'Best Weeks',
                        //     path: 'best-weeks',
                        //     id: 'bw',
                        // },
                    ],
                    Pricing: [{ label: 'Pricing Simulator', path: 'pricing-simulator', id: 'psrV2' }],
                    visible: false,
                },
            },
        ],
        globalFilter: {
            presetConfig: {
                disablePresetFilter: true,
                presetEnabledRoutes: {
                    all: true,
                },
            },
            availableFrequenciesList: [
                { key: 'W', label: 'Week' },
                { key: 'M', label: 'Month' },
            ],
            globalFilterChangingRoutes: {
                'commercial-forecast': {
                    dimensionListKey: 'default',
                    getGlobalTimestampsKey: 'commercial_forecast',
                    getAttributeNamesKey: 'default',
                    // disabledAttributeTypes: ['manufacturer'],
                    defaultGlobalFilterObj: null,
                },
                's-growth-analysis': {
                    dimensionListKey: 'sellin',
                    getGlobalTimestampsKey: 'default',
                    getAttributeNamesKey: 'sellin',
                    groupKey: 'sellin',
                    defaultGlobalFilterObj: {
                        dim1: {
                            Category: {
                                inclusion: [
                                    {
                                        dimension: 'dim1',
                                        isActive: true,
                                        attributeType: 'Category',
                                        attributeDesc: 'UPPER RESPIRATORY',
                                        attributeExId: 'UPPER RESPIRATORY',
                                    },
                                ],
                            },
                        },
                        dim2: {
                            channel: {
                                inclusion: [
                                    {
                                        dimension: 'dim2',
                                        isActive: true,
                                        attributeType: 'channel',
                                        attributeDesc: 'Pharmacy',
                                        attributeExId: 'Pharmacy',
                                    },
                                ],
                            },
                        },
                    },
                },
                's-bump-report': {
                    dimensionListKey: 'sellin',
                    getGlobalTimestampsKey: 'default',
                    getAttributeNamesKey: 'sellin',
                    groupKey: 'sellin',
                    defaultGlobalFilterObj: {
                        dim1: {
                            Category: {
                                inclusion: [
                                    {
                                        dimension: 'dim1',
                                        isActive: true,
                                        attributeType: 'Category',
                                        attributeDesc: 'UPPER RESPIRATORY',
                                        attributeExId: 'UPPER RESPIRATORY',
                                    },
                                ],
                            },
                        },
                        dim2: {
                            channel: {
                                inclusion: [
                                    {
                                        dimension: 'dim2',
                                        isActive: true,
                                        attributeType: 'channel',
                                        attributeDesc: 'Pharmacy',
                                        attributeExId: 'Pharmacy',
                                    },
                                ],
                            },
                        },
                    },
                },
                'promo-recommendation': {
                    dimensionListKey: 'sellin',
                    getGlobalTimestampsKey: 'default',
                    getAttributeNamesKey: 'sellin',
                    groupKey: 'sellin',
                    defaultGlobalFilterObj: {
                        dim1: {
                            Category: {
                                inclusion: [
                                    {
                                        dimension: 'dim1',
                                        isActive: true,
                                        attributeType: 'Category',
                                        attributeDesc: 'UPPER RESPIRATORY',
                                        attributeExId: 'UPPER RESPIRATORY',
                                    },
                                ],
                            },
                        },
                        dim2: {
                            channel: {
                                inclusion: [
                                    {
                                        dimension: 'dim2',
                                        isActive: true,
                                        attributeType: 'channel',
                                        attributeDesc: 'Pharmacy',
                                        attributeExId: 'Pharmacy',
                                    },
                                ],
                            },
                        },
                    },
                },
            },
            retainFiltersAcrossFeatures: false,
            limit: 50,
            selectionAllowed: {
                'promo-recommendation': {
                    dim2: {
                        Retailer: 1,
                    },
                },
            },
            allSelectedLimit: 15,
            timePeriodScreenMapping: {
                default: ['4W', '12W', '26W', '52W', '1M', '3M', '6M', '12M', '1Q', '2Q', '4Q', 'YTD', 'CUSTOM DATE'],
                'bump-report': ['52W', '104W', '156W', '12M', '24M', '36M', '1Q', '2Q', '4Q', 'YTD', 'CUSTOM DATE'],
                'commercial-forecast': [
                    '4W',
                    '12W',
                    '26W',
                    '52W',
                    '1M',
                    '3M',
                    '6M',
                    '1Q',
                    '2Q',
                    '4Q',
                    'YTG',
                    'CUSTOM DATE',
                ],
            },

            defaultPeriod: ['52W', '12M'],
            applyFilterApiPostFormat: {
                jsonstring_dim1: '{}',
                jsonstring_dim2: '{}',
            },
            defaultPreviousIdObject: {
                dim1: ['attr', 'attr'],
                dim2: ['attr', 'attr'],
            },
            defaultIdObject: {
                dim1: { ids: [] },
                dim2: { ids: [] },
            },
            defaultAttrIdObject: {
                attr: {
                    dim1: { ids: [] },
                    dim2: { ids: [] },
                },
            },

            promoScoreCardDefault: {
                Category: 'UPPER RESPIRATORY',
                channel: 'Pharmacy',
            },
            PromoScoreCardDefaultObj: {
                dim1: {
                    Category: {
                        inclusion: [
                            {
                                dimension: 'dim1',
                                isActive: true,
                                attributeType: 'Category',
                                attributeDesc: 'UPPER RESPIRATORY',
                                attributeExId: 'UPPER RESPIRATORY',
                            },
                        ],
                    },
                },
                dim2: {
                    channel: {
                        inclusion: [
                            {
                                dimension: 'dim2',
                                isActive: true,
                                attributeType: 'channel',
                                attributeDesc: 'Pharmacy',
                                attributeExId: 'Pharmacy',
                            },
                        ],
                    },
                },
            },
        },
        pricingSimulator: {
            enableAnalyticsTab: true,
            enableBulkUpload: false,
            indexPageTableLimit: 50,
            scenarioFilterOffsetLimit: 50,
            scenarioPerProjectLimit: 10,
            scenarioTableLimit: 500,
            analyticsChartLimit: 100,
            comparisonTableLimit: 50,
            dimAttributesLimit: 4,
            characterLimit: {
                kpiTileCharLimit: 22,
                kpiCompareCardLimit: 30,
            },
            enablePrivatePublicToggle: false,
            enableMicroInfoForTables: false,
            enableOneChangeAnalyticsChart: true,
            defaultGlobalKpiCount: 6,
            disableExport: false,
            indexTableFixedColumns: [
                { label: 'Project Name', key: 'projectName', sortKey: 'project_name' },
                { label: 'Created By', key: 'createdBy', sortKey: 'created_by' },
                { label: 'Status', key: 'status' },
                { label: 'Last Updated', key: 'lastUpdated', sortKey: 'updated_at' },
                { label: 'Simulation Period', key: 'simulationPeriod' },
                { label: 'Price Effective Date', key: 'priceEffectiveDate' },
            ],
            analyticsBaseScenarioFixedColumns: [
                { label: 'Project Name', key: 'projectName', sortKey: 'project_name' },
                { label: 'Created By', key: 'createdBy', sortKey: 'created_by' },
                { label: 'Status', key: 'status' },
            ],
            analyticsTableColumns: [
                { label: 'Report Name', key: 'reportName', sortKey: 'report_name' },
                { label: 'Base Scenario', key: 'baseScenario', sortKey: 'base_scenario' },
                { label: 'Created By', key: 'createdBy', sortKey: 'created_by' },
                { label: 'Last Updated', key: 'lastUpdated', sortKey: 'updated_at' },
                { label: 'Date Created', key: 'dateCreated', sortKey: 'created_at' },
            ],
            projectStatuses: {
                ACTIVE: { label: 'Active', colorType: 'success' },
                DRAFT: { label: 'Draft', colorType: 'processing' },
                SETUP: { label: 'Setup', colorType: 'processing' },
                IN_PROGRESS: { label: 'In-Progress', colorType: 'processing' },
                EXPIRED: { label: 'Expired', colorType: 'default' },
                ERROR: { label: 'Error', colorType: 'error' },
                INVALID: { label: 'Invalid', colorType: 'error' },
            },
            projectDataSource: [{ label: 'Projected', value: 'depletion_data' }],
            simulatedPeriodItems: [
                { label: 'Custom Date', value: 'custom_date', dateArray: null },
                { label: 'Current Year', value: 'current_year', dateArray: ['01-05-2025', '12-28-2025'] },
                // { label: 'Financial Year', value: 'financial_year', dateArray: ['03-03-2024', '02-23-2025'] },
            ],
            iconsMappings: {
                Elasticity: 'BorderOuterOutlined',
                BaseInput: 'BorderlessTableOutlined',
                COGS: 'DollarOutlined',
                Distributor: 'BuildOutlined',
                'Distributor P&L': 'BuildOutlined',
                FOB: 'ClusterOutlined',
                'P&L': 'LineChartOutlined',
                Price: 'MoneyCollectOutlined',
                Promotions: 'BoxPlotOutlined',
                'Retailer P&L': 'LineChartOutlined',
                Sales: 'AreaChartOutlined',
                Taxes: 'BlockOutlined',
                Volume: 'ExperimentOutlined',
                Others: 'UngroupOutlined',
                Product: 'GoldOutlined',
                Geo: 'ExpandOutlined',
                'Dollar Impact': 'DollarOutlined',
                'Standard Increase Metrics': 'ToTopOutlined',
                'EQV Metrics': 'BlockOutlined',
            },
            categoryMovementKpis: [
                { label: 'Units Impact', value: 'units', yAxisLabel: 'Units', xAxisLabel: 'Retailer Units' },
                { label: 'Sales Impact', value: 'sales', yAxisLabel: 'Sales £', xAxisLabel: 'Retailer Sales £' },
            ],
        },
        priceChange: {
            // TODO: remove unwanted props
            limit: 60,
            dimensionConfig: {
                //snake case eg sub_category
                excludedDimensions: [],
                defaultDimension: 'Manufacturer',
            },
            hiddenTableRows: ['Change due to mix(%)'],
            timePeriodOptions: [
                { label: 'YA', value: 'year_ago' },
                { label: 'Prior Period', value: 'prior_period' },
                { label: 'Custom Period', value: 'custom' },
            ],
            absTileData: [
                { key: 'abs', label: 'Abs' },
                { key: 'percentage', label: '%' },
            ],
            kpiListData: [
                {
                    key: 'avg_price',
                    label: 'Avg Price',
                    value: 'average',
                    dataKey: 'avg_price',
                },
                // {
                //     key: 'base_price',
                //     label: 'Regular Price',
                //     value: 'base',
                //     dataKey: 'base_price',
                // },
            ],
            volTileData: [
                {
                    key: 'units',
                    label: 'Per Unit',
                    value: 'units',
                    dataKey: 'units',
                    tooltip: 'Per Unit',
                },
                // { key: 'vol', label: 'PEQ', value: 'vol', dataKey: 'volume', tooltip: 'Per Eq Volume' },
            ],
            salesTileData: [
                { key: 'sales', label: 'Sales' },
                { key: 'incremental', label: 'Incremental' },
                { key: 'promo', label: 'Promo' },
            ],
            salesAttributionChart: {
                colorList: ['#10AB5E', '#DC3826'],
                colorListType2: ['#758BEE', '#758BEE'],
                profitPoolColor: ['#826FD0', '#826FD0'],
                backGroundColor: 'rgba(0, 0, 0, 0.02)',
            },
            salesAttributionDrillDownChartKeyValueMapping: {
                'feature_&_display': 'Feature & Display',
                'Feature & Display': 'feature_&_display',
            },
            salesAttributionChart2Limit: 20,
        },
        growthAnalysis: {
            limit: 60,
            includeAggPeriod: false,
            dimensionConfig: {
                //snake case eg sub_category
                excludedDimensions: [],
                defaultDimension: 'Manufacturer',
            },
            absTileData: [
                { key: 'abs', label: 'Abs' },
                { key: 'percentage', label: '%' },
            ],
            subTileData: [
                {
                    label: 'Per Unit',
                    key: 'PU',
                },
                {
                    label: 'PEQ',
                    key: 'PEQ',
                },
            ],
            volTileData: [
                // { key: 'vol', label: 'Eq Volume', value: 'vol', dataKey: 'volume' },
                { key: 'val', label: 'Value', value: 'val', dataKey: 'value' },
                {
                    key: 'units',
                    label: 'Units',
                    value: 'units',
                    dataKey: 'units',
                },
                // { key: 'profit', label: 'Profit', value: 'profit', dataKey: 'profit' },
            ],
            showTotal: true,
            currentYearLabel: 'CY',
            yearAgoLabel: 'YA',
            trendChartDropdownData: [
                {
                    key: 'sales_volume',
                    label: 'Sales Volume',
                    value: 'sales_volume',
                    dataKey: 'sales_volume',
                },
                {
                    key: 'sales',
                    label: 'Sales €',
                    value: 'sales',
                    dataKey: 'sales',
                },
                {
                    key: 'average_price',
                    label: 'Average Price',
                    value: 'average_price',
                    dataKey: 'average_price',
                },
                {
                    key: 'base_price',
                    label: 'Base Price',
                    value: 'base_price',
                    dataKey: 'base_price',
                },
                { key: 'acv', label: '%ACV', value: 'acv', dataKey: 'acv' },
                {
                    key: 'avg_items',
                    label: 'Avg. no. of items',
                    value: 'avg_items',
                    dataKey: 'avg_items',
                },
                { key: 'tdp', label: 'TDP', value: 'tdp', dataKey: 'tdp' },
            ],
            salesTileData: [
                { key: 'sales', label: 'Sales' },
                { key: 'incremental', label: 'Incremental' },
                // { key: 'promo', label: 'Promo' },
            ],
            graphExportHeaderMapping: {
                promo: ['Non-promo', 'Promo'],
                incremental: ['Base', 'Incremental'],
                sales: ['Sales Change'],
            },
            depletionDropdownData: [
                {
                    value: 'frontline_sales',
                    dataKey: 'frontline_sales',
                    key: 'frontline_sales',
                    label: 'Frontline Sales',
                },
                {
                    value: 'net_sales',
                    dataKey: 'net_sales',
                    key: 'net_sales',
                    label: 'Net Sales',
                },
            ],
            tableKeyUnitMapping: {
                'Market Share CY': {
                    unit: '%',
                    label: 'Market Share CY',
                    includePercentageChange: false,
                },
                'Market Share YA': {
                    unit: '%',
                    label: 'Market Share YA',
                    includePercentageChange: false,
                },
                'ACV CY': {
                    unit: '%',
                    label: 'Sales Weighted Distribution %',
                    includePercentageChange: false,
                },
                'ACV YA': {
                    unit: '%',
                    label: 'Sales Weighted Distribution % YA',
                    includePercentageChange: false,
                },
            },
            salesAttributionChart: {
                colorList: ['#10AB5E', '#DC3826'],
                colorListType2: ['#758BEE', '#758BEE'],
                profitPoolColor: ['#826FD0', '#826FD0'],
                backGroundColor: 'rgba(0, 0, 0, 0.02)',
            },
            salesAttributionDrillDownChartKeyValueMapping: {
                'feature_&_display': 'Feature & Display',
                'Feature & Display': 'feature_&_display',
            },
            salesAttributionChart2DisabledItems: ['unexplained'],
            salesAttributionChart2Limit: 50,
        },
        //BUMP REPORT
        bumpReport: {
            mainHeader: 'Bump Report',
            groupByKey: 'groupBy',
            enablePromoCalender: false,
            comparisonTileData: [
                { key: 'cy_vs_ya', label: 'CY vs YA' },
                { key: 'difference', label: 'Difference' },
            ],
            isPromoUpliftPercentValue: false,
            volGroupByOptionsMapping: {
                // vol: [
                //     { value: 'total_eq_volume', label: 'Total EQ Volume', index: 1 },
                //     { value: 'any_promo_eq_volume', label: 'Any promo EQ Volume', index: 1 },
                //     { value: 'no_promo_eq_volume', label: 'No Promo EQ Volume', index: 1 },

                //     { value: 'base_eq_volume', label: 'Base EQ Volume', index: 0 },
                //     { value: 'incremental_eq_volume', label: 'Incremental EQ Volume Total', index: 0 },
                //     { value: 'tpr_incremental_eq_volume', label: 'Incremental EQ Volume TPR', index: 0 },
                //     { value: 'feature_incremental_eq_volume', label: 'Incremental EQ Volume Feature', index: 0 },
                //     { value: 'display_incremental_eq_volume', label: 'Incremental EQ Volume Display', index: 0 },
                //     {
                //         value: 'feature_and_display_incremental_eq_volume',
                //         label: 'Incremental EQ Volume Feature & Display',
                //         index: 0,
                //     },
                // ],
                val: [
                    { value: 'total_value', label: 'Total Value', index: 1 },
                    // {
                    //     value: 'any_promo_value',
                    //     label: 'Any Promo Value',
                    //     index: 1,
                    // },
                    // {
                    //     value: 'no_promo_value',
                    //     label: 'No Promo Value',
                    //     index: 1,
                    // },
                    { value: 'base_value', label: 'Regular Value', index: 0 },
                    {
                        value: 'incremental_value',
                        label: 'Incremental Value',
                        index: 0,
                    },
                    // {
                    //     value: 'tpr_incremental_value',
                    //     label: 'Price Cut Incremental Value',
                    //     index: 0,
                    // },
                    // {
                    //     value: 'feature_incremental_value',
                    //     label: 'On Shelf Incremental Value',
                    //     index: 0,
                    // },
                    // {
                    //     value: 'display_incremental_value',
                    //     label: 'Off Shelf Incremental Value',
                    //     index: 0,
                    // },
                    // {
                    //     value: 'feature_and_display_incremental_value',
                    //     label: 'Special Pack Incremental Value',
                    //     index: 0,
                    // },
                ],
                units: [
                    { value: 'total_units', label: 'Total Units', index: 1 },
                    // {
                    //     value: 'any_promo_units',
                    //     label: 'Any Promo Units',
                    //     index: 1,
                    // },
                    // {
                    //     value: 'no_promo_units',
                    //     label: 'No Promo Units',
                    //     index: 1,
                    // },
                    { value: 'base_units', label: 'Regular Units', index: 0 },
                    {
                        value: 'incremental_units',
                        label: 'Incremental Units',
                        index: 0,
                    },
                    // {
                    //     value: 'tpr_incremental_units',
                    //     label: 'Price Cut Incremental Units',
                    //     index: 0,
                    // },
                    // {
                    //     value: 'feature_incremental_units',
                    //     label: 'On Shelf Incremental Units',
                    //     index: 0,
                    // },
                    // {
                    //     value: 'display_incremental_units',
                    //     label: 'Off Shelf Incremental Units',
                    //     index: 0,
                    // },
                    // {
                    //     value: 'feature_and_display_incremental_units',
                    //     label: 'Special Pack Incremental Units',
                    //     index: 0,
                    // },
                ],
            },
            tooltipKeyLabelMapping: {
                increments: 'Incremental',
                promo: 'Any Promo',
            },
            bumpReportTileData: [
                { key: 'increments', label: 'Attribution' },
                // { key: 'promo', label: 'Consumption' },
                { key: 'groupBy', label: 'Group By' },
            ],
            bumpReportTile1Data: [
                {
                    key: 'promo',
                    label: 'Promotions',
                    visibleTabs: ['increments', 'promo', 'groupBy'],
                }, //keys should match bumpReportTileData keys
                // {
                //     key: 'media',
                //     label: 'Media',
                //     visibleTabs: ['increments', 'groupBy'],
                // }, //keys should match bumpReportTileData keys
            ],
            bumpReportTile2Data: [
                { key: 'total', label: 'Total' },
                // { key: 'breakout', label: 'Breakout' },
            ],
            absTileData: [
                { key: 'abs', label: 'Abs' },
                { key: 'percentage', label: '%' },
            ],

            volTileData: [
                // { key: 'vol', label: 'Eq Volume', dataKey: 'volume' },
                { key: 'val', label: 'Value', dataKey: 'value' },
                { key: 'units', label: 'Units', dataKey: 'units' },
            ],
            bumpChartY2Colors: [
                '#293BB8',
                '#DD449F',
                '#9E5897',
                '#19669D',
                '#43C9E2',
                '#37C7BE',
                '#00798C',
                '#E8A122',
                '#E06936',
                '#A5582D',
            ],
            bumpChartY2AxisOptions: {
                // vol: [
                //     { value: 'avg_price_per_eq', index: 0, label: 'Avg. Price/EQ', unit: '' },
                //     { value: 'base_price_per_eq', index: 0, label: 'Base Price/EQ', unit: '' },
                //     { value: 'promo_price_per_eq', index: 0, label: 'Promo Price/EQ', unit: '' },
                //     { value: 'distribution_tdp', index: 0, label: 'Distribution TDP', unit: '' },
                //     { value: 'display_tdp', index: 0, label: 'Display TDP', unit: '' },
                //     { value: 'feature_tdp', index: 0, label: 'Feature TDP', unit: '' },
                //     { value: 'feature_and_display_tdp', index: 0, label: 'Feature and Display TDP', unit: '' },
                //     { value: 'unit_velocity', index: 0, label: 'Unit Velocity', unit: '' },
                //     { value: 'sales_velocity', index: 0, label: 'Dollar Velocity', unit: '€' },
                //     { value: 'volume_velocity', index: 0, label: 'Eq Velocity', unit: '' },
                // ],
                val: [
                    {
                        value: 'avg_price_per_unit',
                        index: 0,
                        label: 'Avg. Price/Unit (€)',
                        unit: '',
                    },
                    // {
                    //     value: 'base_price_per_unit',
                    //     index: 0,
                    //     label: 'Regular Price/Unit',
                    //     unit: '',
                    // },
                    // {
                    //     value: 'promo_price_per_unit',
                    //     index: 0,
                    //     label: 'Promo Price/Unit',
                    //     unit: '',
                    // },
                    {
                        value: 'market_share_value',
                        index: 0,
                        label: 'Market Share %',
                        unit: '',
                    },
                    // {
                    //     value: 'distribution_tdp',
                    //     index: 0,
                    //     label: 'Distribution TDP',
                    //     unit: '',
                    // },
                    // {
                    //     value: 'display_tdp',
                    //     index: 0,
                    //     label: 'Off Shelf TDP',
                    //     unit: '',
                    // },
                    // {
                    //     value: 'feature_tdp',
                    //     index: 0,
                    //     label: 'On Shelf TDP',
                    //     unit: '',
                    // },
                    // {
                    //     value: 'feature_and_display_tdp',
                    //     index: 0,
                    //     label: 'Special Pack TDP',
                    //     unit: '',
                    // },
                    {
                        value: 'distribution_tdp',
                        index: 0,
                        label: 'Sales Weighted Distribution',
                        unit: '',
                    },
                    // {
                    //     value: 'display_acv',
                    //     index: 0,
                    //     label: 'Stock Weighted Distribution',
                    //     unit: '',
                    // },
                    {
                        value: 'feature_and_display_acv',
                        index: 0,
                        label: 'Sales Numeric Distribution',
                        unit: '',
                    },
                    {
                        value: 'feature_acv',
                        index: 0,
                        label: 'Stock Numeric Distribution',
                        unit: '',
                    },
                    // {
                    //     value: 'cwd_weighted_distribution',
                    //     index: 0,
                    //     label: 'Purchase Numeric Distribution',
                    //     unit: '',
                    // },
                    {
                        value: 'unit_velocity',
                        index: 0,
                        label: 'Unit Velocity',
                        unit: '',
                    },
                    // {
                    //     value: 'sales_velocity',
                    //     index: 0,
                    //     label: 'Value Velocity',
                    //     unit: '€',
                    // },
                    // {
                    //     value: 'subsidized_base_sales',
                    //     index: 0,
                    //     label: 'Subsidized Base Sales',
                    //     unit: '',
                    // },
                    // { value: 'volume_velocity', index: 0, label: 'Eq Velocity', unit: '' },
                ],
                units: [
                    {
                        value: 'avg_price_per_unit',
                        index: 0,
                        label: 'Avg. Price/Unit (€)',
                        unit: '',
                    },
                    // {
                    //     value: 'base_price_per_unit',
                    //     index: 0,
                    //     label: 'Regular Price/Unit',
                    //     unit: '',
                    // },
                    // {
                    //     value: 'promo_price_per_unit',
                    //     index: 0,
                    //     label: 'Promo Price/Unit',
                    //     unit: '',
                    // },
                    {
                        value: 'market_share_units',
                        index: 0,
                        label: 'Market Share %',
                        unit: '',
                    },
                    // {
                    //     value: 'distribution_tdp',
                    //     index: 0,
                    //     label: 'Distribution TDP',
                    //     unit: '',
                    // },
                    // {
                    //     value: 'display_tdp',
                    //     index: 0,
                    //     label: 'Off Shelf TDP',
                    //     unit: '',
                    // },
                    // {
                    //     value: 'feature_tdp',
                    //     index: 0,
                    //     label: 'On Shelf TDP',
                    //     unit: '',
                    // },
                    // {
                    //     value: 'feature_and_display_tdp',
                    //     index: 0,
                    //     label: 'Special Pack TDP',
                    //     unit: '',
                    // },
                    // {
                    {
                        value: 'distribution_tdp',
                        index: 0,
                        label: 'Sales Weighted Distribution',
                        unit: '',
                    },
                    // {
                    //     value: 'display_acv',
                    //     index: 0,
                    //     label: 'Stock Weighted Distribution',
                    //     unit: '',
                    // },
                    {
                        value: 'feature_and_display_acv',
                        index: 0,
                        label: 'Sales Numeric Distribution',
                        unit: '',
                    },
                    {
                        value: 'feature_acv',
                        index: 0,
                        label: 'Stock Numeric Distribution',
                        unit: '',
                    },
                    // {
                    //     value: 'cwd_weighted_distribution',
                    //     index: 0,
                    //     label: 'Purchase Numeric Distribution',
                    //     unit: '',
                    // },
                    {
                        value: 'unit_velocity',
                        index: 0,
                        label: 'Unit Velocity',
                        unit: '',
                    },
                    // {
                    //     value: 'sales_velocity',
                    //     index: 0,
                    //     label: 'Value Velocity',
                    //     unit: '€',
                    // },
                    // {
                    //     value: 'subsidized_base_sales',
                    //     index: 0,
                    //     label: 'Subsidized Base Sales',
                    //     unit: '',
                    // },
                    // { value: 'volume_velocity', index: 0, label: 'Eq Velocity', unit: '' },
                ],
            },
            promoTypeColorMapping: {
                'tpr/scan': {
                    label: 'Price Cut',
                    color: colorConstants.lightGreenAlt,
                },
                'feature ad': {
                    label: 'Price Cut & On Shelf',
                    color: colorConstants.darkGreenAlt2,
                },
                display: { label: 'Off Shelf', color: colorConstants.pinkAlt },
                feature_display_tpr: {
                    label: 'Special Pack',
                    color: colorConstants.orangeAlt2,
                },
                cinema: {
                    label: 'Cinema',
                    color: colorConstants.lightGreenAlt,
                }, // media types starts here
                digital: { label: 'Digital', color: colorConstants.violetAlt2 },
                'direct mail': {
                    label: 'Direct Mail',
                    color: colorConstants.violetAlt3,
                },
                outdoor: { label: 'Outdoor', color: colorConstants.purpleAlt1 },
                press: { label: 'Press', color: colorConstants.pinkAlt2 },
                radio: { label: 'Radio', color: colorConstants.orangeAlt3 },
                tv: { label: 'TV', color: colorConstants.yellow },
                // display_tpr: { label: 'Display_TPR', color: colorConstants.darkBlueAlt },
            },
            stackedColors: [
                colorConstants.lightGreenAlt,
                colorConstants.darkGreenAlt2,
                colorConstants.pinkAlt,
                colorConstants.orangeAlt2,
                colorConstants.darkYellow,
            ],
            fieldKeyLabelMapping: {
                base_eq_volume: {
                    label: 'Regular Sales (Eq Vol)',
                    color: colorConstants.darkYellow,
                    tableLabel: 'Regular',
                },
                base_value: {
                    label: 'Regular Sales (€)',
                    color: colorConstants.darkYellow,
                    tableLabel: 'Regular',
                },
                base_units: {
                    label: 'Regular Units',
                    color: colorConstants.darkYellow,
                    tableLabel: 'Regular',
                },
                incremental_eq_volume: {
                    label: 'Incremental Sales (Eq Vol)',
                    color: colorConstants.darkGreenAlt2,
                    tableLabel: 'Incremental',
                },
                incremental_value: {
                    label: 'Promotion Sales (€)',
                    color: colorConstants.lightGreenAlt,
                    tableLabel: 'Promotion',
                },
                tpr_incremental_eq_volume: {
                    label: 'Price Cut & On Shelf',
                    color: colorConstants.lightGreenAlt,
                    tableLabel: 'Price Cut & On Shelf',
                },
                feature_incremental_eq_volume: {
                    label: 'On Shelf',
                    color: colorConstants.darkGreenAlt2,
                    tableLabel: 'On Shelf',
                },
                display_incremental_eq_volume: {
                    label: 'Off Shelf',
                    color: colorConstants.pinkAlt,
                    tableLabel: 'Off Shelf',
                },
                feature_and_display_incremental_eq_volume: {
                    label: 'Special Pack',
                    color: colorConstants.orangeAlt2,
                    tableLabel: 'Special Pack',
                },
                tpr_incremental_value: {
                    label: 'Price Cut & On Shelf',
                    color: colorConstants.lightGreenAlt,
                    tableLabel: 'Price Cut & On Shelf',
                },
                feature_incremental_value: {
                    label: 'On Shelf',
                    color: colorConstants.darkGreenAlt2,
                    tableLabel: 'On Shelf',
                },
                display_incremental_value: {
                    label: 'Off Shelf',
                    color: colorConstants.pinkAlt,
                    tableLabel: 'Off Shelf',
                },
                incremental_units: {
                    label: 'Promotion Units',
                    color: colorConstants.lightGreenAlt,
                    tableLabel: 'Promotion',
                },
                feature_and_display_incremental_value: {
                    label: 'Special Pack',
                    color: colorConstants.orangeAlt2,
                    tableLabel: 'Special Pack',
                },
                tpr_incremental_units: {
                    label: 'Price Cut & On Shelf',
                    color: colorConstants.lightGreenAlt,
                    tableLabel: 'Price Cut & On Shelf',
                },
                feature_incremental_units: {
                    label: 'On Shelf',
                    color: colorConstants.darkGreenAlt2,
                    tableLabel: 'On Shelf',
                },
                display_incremental_units: {
                    label: 'Off Shelf',
                    color: colorConstants.pinkAlt,
                    tableLabel: 'Off Shelf',
                },
                feature_and_display_incremental_units: {
                    label: 'Special Pack',
                    color: colorConstants.orangeAlt2,
                    tableLabel: 'Special Pack',
                },
                incremental_total_units: {
                    label: 'Promotions',
                    color: colorConstants.lightGreenAlt,
                    tableLabel: 'Promotions',
                },
                incremental_total_value: {
                    label: 'Promotions',
                    color: colorConstants.lightGreenAlt,
                    tableLabel: 'Promotions',
                },
                media_incremental_value: {
                    label: 'Media',
                    color: colorConstants.darkGreenAlt3,
                    tableLabel: 'Media',
                },
                media_incremental_units: {
                    label: 'Media',
                    color: colorConstants.darkGreenAlt3,
                    tableLabel: 'Media',
                },
                tpr_only_eq_volume: {
                    label: 'Price Cut & On Shelf',
                    color: colorConstants.lightGreenAlt,
                    tableLabel: 'Price Cut & On Shelf',
                },
                tpr_only_value: {
                    label: 'Price Cut & On Shelf',
                    color: colorConstants.lightGreenAlt,
                    tableLabel: 'Price Cut & On Shelf',
                },
                feature_only_eq_volume: {
                    label: 'On Shelf',
                    color: colorConstants.darkGreenAlt2,
                    tableLabel: 'On Shelf',
                },
                feature_only_value: {
                    label: 'On Shelf',
                    color: colorConstants.darkGreenAlt2,
                    tableLabel: 'On Shelf',
                },
                display_only_eq_volume: {
                    label: 'Off Shelf',
                    color: colorConstants.pinkAlt,
                    tableLabel: 'Off Shelf',
                },
                display_only_value: {
                    label: 'Off Shelf',
                    color: colorConstants.pinkAlt,
                    tableLabel: 'Off Shelf',
                },
                feature_and_display_only_eq_volume: {
                    label: 'Special Pack',
                    color: colorConstants.orangeAlt2,
                    tableLabel: 'Special Pack',
                },
                feature_and_display_only_value: {
                    label: 'Special Pack',
                    color: colorConstants.orangeAlt2,
                    tableLabel: 'Special Pack',
                },
                no_promo_eq_volume: {
                    label: 'Non Promo',
                    color: colorConstants.darkYellow,
                    tableLabel: 'Non Promo',
                },
                no_promo_value: {
                    label: 'Non Promo',
                    color: colorConstants.darkYellow,
                    tableLabel: 'Non Promo',
                },
                any_promo_value: {
                    label: 'Promo',
                    color: colorConstants.lightGreenAlt,
                    tableLabel: 'Promo',
                },
                tpr_only_units: {
                    label: 'Price Cut & On Shelf',
                    color: colorConstants.lightGreenAlt,
                    tableLabel: 'Price Cut & On Shelf',
                },
                feature_only_units: {
                    label: 'On Shelf',
                    color: colorConstants.darkGreenAlt2,
                    tableLabel: 'On Shelf',
                },
                display_only_units: {
                    label: 'Off Shelf',
                    color: colorConstants.pinkAlt,
                    tableLabel: 'Off Shelf',
                },
                feature_and_display_only_units: {
                    label: 'Special Pack',
                    color: colorConstants.orangeAlt2,
                    tableLabel: 'Special Pack',
                },

                no_promo_units: {
                    label: 'Non Promo',
                    color: colorConstants.darkYellow,
                    tableLabel: 'Non Promo',
                },
                any_promo_units: {
                    label: 'Promo',
                    color: colorConstants.lightGreenAlt,
                    tableLabel: 'Promo',
                },
                promo_only_total_value: {
                    label: 'Promotions',
                    color: colorConstants.lightGreenAlt,
                    tableLabel: 'Promotions',
                },
                promo_only_total_units: {
                    label: 'Promotions',
                    color: colorConstants.lightGreenAlt,
                    tableLabel: 'Promotions',
                },
                tv_value: {
                    label: 'TV',
                    color: colorConstants.orangeAlt2,
                    tableLabel: 'TV',
                }, // media types starts here
                tv_units: {
                    label: 'TV',
                    color: colorConstants.orangeAlt2,
                    tableLabel: 'TV',
                },
                cinema_value: {
                    label: 'Cinema',
                    color: colorConstants.lightGreenAlt1,
                    tableLabel: 'Cinema',
                },
                cinema_units: {
                    label: 'Cinema',
                    color: colorConstants.lightGreenAlt1,
                    tableLabel: 'Cinema',
                },
                digital_units: {
                    label: 'Digital',
                    color: colorConstants.darkGreenAlt2,
                    tableLabel: 'Digital',
                },
                digital_value: {
                    label: 'Digital',
                    color: colorConstants.darkGreenAlt2,
                    tableLabel: 'Digital',
                },
                directmail_value: {
                    label: 'Direct mail',
                    color: colorConstants.darkGreenAlt3,
                    tableLabel: 'Direct mail',
                },
                directmail_units: {
                    label: 'Direct mail',
                    color: colorConstants.darkGreenAlt3,
                    tableLabel: 'Direct mail',
                },
                outdoor_units: {
                    label: 'Outdoor',
                    color: colorConstants.purpleAlt,
                    tableLabel: 'Outdoor',
                },
                outdoor_value: {
                    label: 'Outdoor',
                    color: colorConstants.purpleAlt,
                    tableLabel: 'Outdoor',
                },
                press_value: {
                    label: 'Press',
                    color: colorConstants.pinkAlt,
                    tableLabel: 'Press',
                },
                press_units: {
                    label: 'Press',
                    color: colorConstants.pinkAlt,
                    tableLabel: 'Press',
                },
                radio_units: {
                    label: 'Radio',
                    color: colorConstants.orangeAlt1,
                    tableLabel: 'Radio',
                },
                radio_value: {
                    label: 'Radio',
                    color: colorConstants.orangeAlt1,
                    tableLabel: 'Radio',
                },

                //for export label
                sales_year_ago: { label: 'YA Sales' },
                total_value: { label: 'Total' },
                media_incremental_value_percentage: {
                    label: 'Media Percentage',
                },
                media_incremental_units_percentage: {
                    label: 'Media Percentage',
                },
                incremental_value_percentage: {
                    label: 'Promotion Sales Percentage',
                },
                incremental_units_percentage: {
                    label: 'Promotion Sales Percentage',
                },
                base_value_percentage: { label: 'Regular Sales Percentage' },
                base_units_percentage: { label: 'Regular Sales Percentage' },
                tpr_incremental_value_percentage: {
                    label: 'Price Cut & On Shelf Percentage',
                },
                tpr_incremental_units_percentage: {
                    label: 'Price Cut & On Shelf Percentage',
                },
                tpr_only_value_percentage: {
                    label: 'Price Cut & On Shelf Percentage',
                },
                tpr_only_units_percentage: {
                    label: 'Price Cut & On Shelf Percentage',
                },
                feature_incremental_value_percentage: {
                    label: 'On Shelf Percentage',
                },
                feature_incremental_units_percentage: {
                    label: 'On Shelf Percentage',
                },
                feature_only_value_percentage: { label: 'On Shelf Percentage' },
                feature_only_units_percentage: { label: 'On Shelf Percentage' },
                display_incremental_value_percentage: {
                    label: 'Off Shelf Percentage',
                },
                display_incremental_units_percentage: {
                    label: 'Off Shelf Percentage',
                },
                display_only_value_percentage: {
                    label: 'Off Shelf Percentage',
                },
                display_only_units_percentage: {
                    label: 'Off Shelf Percentage',
                },
                feature_and_display_incremental_value_percentage: {
                    label: 'Special Pack Percentage',
                },
                feature_and_display_incremental_units_percentage: {
                    label: 'Special Pack Percentage',
                },
                feature_and_display_only_value_percentage: {
                    label: 'Special Pack Percentage',
                },
                feature_and_display_only_units_percentage: {
                    label: 'Special Pack Percentage',
                },
                no_promo_value_percentage: { label: 'Non Promo Percentage' },
                no_promo_units_percentage: { label: 'Non Promo Percentage' },
            },
            tooltipExtraItems: {
                tpr_acv: { label: 'Price Cut ACV %' },
                display_acv: { label: 'Off Shelf ACV %' },
                feature_acv: { label: 'On Shelf ACV %' },
                feature_and_display_acv: { label: 'Special Pack ACV %' },
                uplift: { label: 'Uplift' },
                promo_lift: { label: 'Promo Uplift' },
                media_lift: { label: 'Media Uplift' },
            },
            promoCalenderAttributeLevels: {
                promo: [
                    { value: 'product', label: 'Product' },
                    { value: 'retailer', label: 'Retailer' },
                ],
                media: [{ value: 'sub_brand', label: 'Sub Brand' }],
            },
            overlayKeys: {
                promo: [
                    { label: 'Start Week', dataKey: 'startTimestamp' },
                    { label: 'End Week', dataKey: 'endTimestamp' },
                    { label: 'Product', dataKey: 'product' },
                    { label: 'Promo Mechanics', dataKey: 'promoMech' },
                    { label: 'Promo Type', dataKey: 'promoType' },
                    { label: 'Investment', dataKey: 'field_value' },
                    // { label: 'ROI', dataKey: 'roi' },
                    // { label: 'Lift', dataKey: 'lift' },
                    // { label: 'Incremental Profit', dataKey: 'incrementalProfit' },
                    // { label: 'Incremental Retailer Profit', dataKey: 'incrementalRetailerProfit' },
                ],
                media: [
                    { label: 'Start Week', dataKey: 'startTimestamp' },
                    { label: 'End Week', dataKey: 'endTimestamp' },
                    { label: 'Sub Brand', dataKey: 'product' },
                    { label: 'Media Type', dataKey: 'promoType' },
                    { label: 'Investment', dataKey: 'field_value' },
                ],
            },
        },
        shipmentBumpReport: {
            mainHeader: 'Bump Report',
            groupByKey: 'groupBy',
            enablePromoCalender: false,
            comparisonTileData: [
                { key: 'cy_vs_ya', label: 'CY vs YA' },
                { key: 'difference', label: 'Difference' },
            ],
            isPromoUpliftPercentValue: false,
            volGroupByOptionsMapping: {
                // vol: [
                //     { value: 'total_eq_volume', label: 'Total EQ Volume', index: 1 },
                //     { value: 'any_promo_eq_volume', label: 'Any promo EQ Volume', index: 1 },
                //     { value: 'no_promo_eq_volume', label: 'No Promo EQ Volume', index: 1 },

                //     { value: 'base_eq_volume', label: 'Base EQ Volume', index: 0 },
                //     { value: 'incremental_eq_volume', label: 'Incremental EQ Volume Total', index: 0 },
                //     { value: 'tpr_incremental_eq_volume', label: 'Incremental EQ Volume TPR', index: 0 },
                //     { value: 'feature_incremental_eq_volume', label: 'Incremental EQ Volume Feature', index: 0 },
                //     { value: 'display_incremental_eq_volume', label: 'Incremental EQ Volume Display', index: 0 },
                //     {
                //         value: 'feature_and_display_incremental_eq_volume',
                //         label: 'Incremental EQ Volume Feature & Display',
                //         index: 0,
                //     },
                // ],
                val: [
                    { value: 'total_value', label: 'Total Value', index: 1 },
                    { value: 'base_value', label: 'Regular Value', index: 0 },
                    {
                        value: 'incremental_value',
                        label: 'Incremental Value',
                        index: 0,
                    },
                ],
                units: [
                    { value: 'total_units', label: 'Total Units', index: 1 },
                    // {
                    //     value: 'any_promo_units',
                    //     label: 'Any Promo Units',
                    //     index: 1,
                    // },
                    // {
                    //     value: 'no_promo_units',
                    //     label: 'No Promo Units',
                    //     index: 1,
                    // },
                    { value: 'base_units', label: 'Regular Units', index: 0 },
                    {
                        value: 'incremental_units',
                        label: 'Incremental Units',
                        index: 0,
                    },
                ],
            },
            tooltipKeyLabelMapping: {
                increments: 'Incremental',
                promo: 'Any Promo',
            },
            bumpReportTileData: [
                { key: 'increments', label: 'Attribution' },
                // { key: 'promo', label: 'Consumption' },
                { key: 'groupBy', label: 'Group By' },
            ],
            bumpReportTile1Data: [
                {
                    key: 'promo',
                    label: 'Promotions',
                    visibleTabs: ['increments', 'promo', 'groupBy'],
                }, //keys should match bumpReportTileData keys
                // {
                //     key: 'media',
                //     label: 'Media',
                //     visibleTabs: ['increments', 'groupBy'],
                // }, //keys should match bumpReportTileData keys
            ],
            bumpReportTile2Data: [
                { key: 'total', label: 'Total' },
                // { key: 'breakout', label: 'Breakout' },
            ],
            absTileData: [
                { key: 'abs', label: 'Abs' },
                { key: 'percentage', label: '%' },
            ],

            volTileData: [
                // { key: 'vol', label: 'Eq Volume', dataKey: 'volume' },
                { key: 'val', label: 'Value', dataKey: 'value' },
                { key: 'units', label: 'Units', dataKey: 'units' },
            ],
            bumpChartY2Colors: [
                '#293BB8',
                '#DD449F',
                '#9E5897',
                '#19669D',
                '#43C9E2',
                '#37C7BE',
                '#00798C',
                '#E8A122',
                '#E06936',
                '#A5582D',
            ],
            bumpChartY2AxisOptions: {
                // vol: [
                //     { value: 'avg_price_per_eq', index: 0, label: 'Avg. Price/EQ', unit: '' },
                //     { value: 'base_price_per_eq', index: 0, label: 'Base Price/EQ', unit: '' },
                //     { value: 'promo_price_per_eq', index: 0, label: 'Promo Price/EQ', unit: '' },
                //     { value: 'distribution_tdp', index: 0, label: 'Distribution TDP', unit: '' },
                //     { value: 'display_tdp', index: 0, label: 'Display TDP', unit: '' },
                //     { value: 'feature_tdp', index: 0, label: 'Feature TDP', unit: '' },
                //     { value: 'feature_and_display_tdp', index: 0, label: 'Feature and Display TDP', unit: '' },
                //     { value: 'unit_velocity', index: 0, label: 'Unit Velocity', unit: '' },
                //     { value: 'sales_velocity', index: 0, label: 'Dollar Velocity', unit: '€' },
                //     { value: 'volume_velocity', index: 0, label: 'Eq Velocity', unit: '' },
                // ],
                val: [
                    {
                        value: 'avg_price_per_unit',
                        index: 0,
                        label: 'Avg. Price/Unit (€)',
                        unit: '',
                    },
                    // {
                    //     value: 'market_share_value',
                    //     index: 0,
                    //     label: 'Discount %',
                    //     unit: '',
                    // },
                    // {
                    //     value: 'distribution_tdp',
                    //     index: 0,
                    //     label: 'Sales Weighted Distribution',
                    //     unit: '',
                    // },
                    {
                        value: 'feature_and_display_acv',
                        index: 0,
                        label: 'Sales Numeric Distribution',
                        unit: '',
                    },
                    // {
                    //     value: 'feature_acv',
                    //     index: 0,
                    //     label: 'Stock Numeric Distribution',
                    //     unit: '',
                    // },
                    // {
                    //     value: 'cwd_weighted_distribution',
                    //     index: 0,
                    //     label: 'Stock Weighted Distribution',
                    //     unit: '',
                    // },
                ],
                units: [
                    {
                        value: 'avg_price_per_unit',
                        index: 0,
                        label: 'Avg. Price/Unit (€)',
                        unit: '',
                    },
                    // {
                    //     value: 'market_share_value',
                    //     index: 0,
                    //     label: 'Discount %',
                    //     unit: '',
                    // },
                    // {
                    //     value: 'distribution_tdp',
                    //     index: 0,
                    //     label: 'Sales Weighted Distribution',
                    //     unit: '',
                    // },
                    {
                        value: 'feature_and_display_acv',
                        index: 0,
                        label: 'Sales Numeric Distribution',
                        unit: '',
                    },
                    // {
                    //     value: 'feature_acv',
                    //     index: 0,
                    //     label: 'Stock Numeric Distribution',
                    //     unit: '',
                    // },
                    // {
                    //     value: 'cwd_weighted_distribution',
                    //     index: 0,
                    //     label: 'Stock Weighted Distribution',
                    //     unit: '',
                    // },
                ],
            },
            promoTypeColorMapping: {
                'tpr/scan': {
                    label: 'Price Cut',
                    color: colorConstants.lightGreenAlt,
                },
                'feature ad': {
                    label: 'Price Cut & On Shelf',
                    color: colorConstants.darkGreenAlt2,
                },
                display: { label: 'Off Shelf', color: colorConstants.pinkAlt },
                feature_display_tpr: {
                    label: 'Special Pack',
                    color: colorConstants.orangeAlt2,
                },
                cinema: {
                    label: 'Cinema',
                    color: colorConstants.lightGreenAlt,
                }, // media types starts here
                digital: { label: 'Digital', color: colorConstants.violetAlt2 },
                'direct mail': {
                    label: 'Direct Mail',
                    color: colorConstants.violetAlt3,
                },
                outdoor: { label: 'Outdoor', color: colorConstants.purpleAlt1 },
                press: { label: 'Press', color: colorConstants.pinkAlt2 },
                radio: { label: 'Radio', color: colorConstants.orangeAlt3 },
                tv: { label: 'TV', color: colorConstants.yellow },
                // display_tpr: { label: 'Display_TPR', color: colorConstants.darkBlueAlt },
            },
            stackedColors: [
                colorConstants.lightGreenAlt,
                colorConstants.darkGreenAlt2,
                colorConstants.pinkAlt,
                colorConstants.orangeAlt2,
                colorConstants.darkYellow,
            ],
            fieldKeyLabelMapping: {
                base_eq_volume: {
                    label: 'Regular Sales (Eq Vol)',
                    color: colorConstants.darkYellow,
                    tableLabel: 'Regular',
                },
                base_value: {
                    label: 'Regular Sales (€)',
                    color: colorConstants.darkYellow,
                    tableLabel: 'Regular',
                },
                base_units: {
                    label: 'Regular Units',
                    color: colorConstants.darkYellow,
                    tableLabel: 'Regular',
                },
                incremental_eq_volume: {
                    label: 'Incremental Sales (Eq Vol)',
                    color: colorConstants.darkGreenAlt2,
                    tableLabel: 'Incremental',
                },
                incremental_value: {
                    label: 'Promotion Sales (€)',
                    color: colorConstants.lightGreenAlt,
                    tableLabel: 'Promotion',
                },
                tpr_incremental_eq_volume: {
                    label: 'Price Cut & On Shelf',
                    color: colorConstants.lightGreenAlt,
                    tableLabel: 'Price Cut & On Shelf',
                },
                feature_incremental_eq_volume: {
                    label: 'On Shelf',
                    color: colorConstants.darkGreenAlt2,
                    tableLabel: 'On Shelf',
                },
                display_incremental_eq_volume: {
                    label: 'Off Shelf',
                    color: colorConstants.pinkAlt,
                    tableLabel: 'Off Shelf',
                },
                feature_and_display_incremental_eq_volume: {
                    label: 'Special Pack',
                    color: colorConstants.orangeAlt2,
                    tableLabel: 'Special Pack',
                },
                tpr_incremental_value: {
                    label: 'Price Cut & On Shelf',
                    color: colorConstants.lightGreenAlt,
                    tableLabel: 'Price Cut & On Shelf',
                },
                feature_incremental_value: {
                    label: 'On Shelf',
                    color: colorConstants.darkGreenAlt2,
                    tableLabel: 'On Shelf',
                },
                display_incremental_value: {
                    label: 'Off Shelf',
                    color: colorConstants.pinkAlt,
                    tableLabel: 'Off Shelf',
                },
                incremental_units: {
                    label: 'Promotion Units',
                    color: colorConstants.lightGreenAlt,
                    tableLabel: 'Promotion',
                },
                feature_and_display_incremental_value: {
                    label: 'Special Pack',
                    color: colorConstants.orangeAlt2,
                    tableLabel: 'Special Pack',
                },
                tpr_incremental_units: {
                    label: 'Price Cut & On Shelf',
                    color: colorConstants.lightGreenAlt,
                    tableLabel: 'Price Cut & On Shelf',
                },
                feature_incremental_units: {
                    label: 'On Shelf',
                    color: colorConstants.darkGreenAlt2,
                    tableLabel: 'On Shelf',
                },
                display_incremental_units: {
                    label: 'Off Shelf',
                    color: colorConstants.pinkAlt,
                    tableLabel: 'Off Shelf',
                },
                feature_and_display_incremental_units: {
                    label: 'Special Pack',
                    color: colorConstants.orangeAlt2,
                    tableLabel: 'Special Pack',
                },
                incremental_total_units: {
                    label: 'Promotions',
                    color: colorConstants.lightGreenAlt,
                    tableLabel: 'Promotions',
                },
                incremental_total_value: {
                    label: 'Promotions',
                    color: colorConstants.lightGreenAlt,
                    tableLabel: 'Promotions',
                },
                media_incremental_value: {
                    label: 'Media',
                    color: colorConstants.darkGreenAlt3,
                    tableLabel: 'Media',
                },
                media_incremental_units: {
                    label: 'Media',
                    color: colorConstants.darkGreenAlt3,
                    tableLabel: 'Media',
                },
                tpr_only_eq_volume: {
                    label: 'Price Cut & On Shelf',
                    color: colorConstants.lightGreenAlt,
                    tableLabel: 'Price Cut & On Shelf',
                },
                tpr_only_value: {
                    label: 'Price Cut & On Shelf',
                    color: colorConstants.lightGreenAlt,
                    tableLabel: 'Price Cut & On Shelf',
                },
                feature_only_eq_volume: {
                    label: 'On Shelf',
                    color: colorConstants.darkGreenAlt2,
                    tableLabel: 'On Shelf',
                },
                feature_only_value: {
                    label: 'On Shelf',
                    color: colorConstants.darkGreenAlt2,
                    tableLabel: 'On Shelf',
                },
                display_only_eq_volume: {
                    label: 'Off Shelf',
                    color: colorConstants.pinkAlt,
                    tableLabel: 'Off Shelf',
                },
                display_only_value: {
                    label: 'Off Shelf',
                    color: colorConstants.pinkAlt,
                    tableLabel: 'Off Shelf',
                },
                feature_and_display_only_eq_volume: {
                    label: 'Special Pack',
                    color: colorConstants.orangeAlt2,
                    tableLabel: 'Special Pack',
                },
                feature_and_display_only_value: {
                    label: 'Special Pack',
                    color: colorConstants.orangeAlt2,
                    tableLabel: 'Special Pack',
                },
                no_promo_eq_volume: {
                    label: 'Non Promo',
                    color: colorConstants.darkYellow,
                    tableLabel: 'Non Promo',
                },
                no_promo_value: {
                    label: 'Non Promo',
                    color: colorConstants.darkYellow,
                    tableLabel: 'Non Promo',
                },
                any_promo_value: {
                    label: 'Promo',
                    color: colorConstants.lightGreenAlt,
                    tableLabel: 'Promo',
                },
                tpr_only_units: {
                    label: 'Price Cut & On Shelf',
                    color: colorConstants.lightGreenAlt,
                    tableLabel: 'Price Cut & On Shelf',
                },
                feature_only_units: {
                    label: 'On Shelf',
                    color: colorConstants.darkGreenAlt2,
                    tableLabel: 'On Shelf',
                },
                display_only_units: {
                    label: 'Off Shelf',
                    color: colorConstants.pinkAlt,
                    tableLabel: 'Off Shelf',
                },
                feature_and_display_only_units: {
                    label: 'Special Pack',
                    color: colorConstants.orangeAlt2,
                    tableLabel: 'Special Pack',
                },

                no_promo_units: {
                    label: 'Non Promo',
                    color: colorConstants.darkYellow,
                    tableLabel: 'Non Promo',
                },
                any_promo_units: {
                    label: 'Promo',
                    color: colorConstants.lightGreenAlt,
                    tableLabel: 'Promo',
                },
                promo_only_total_value: {
                    label: 'Promotions',
                    color: colorConstants.lightGreenAlt,
                    tableLabel: 'Promotions',
                },
                promo_only_total_units: {
                    label: 'Promotions',
                    color: colorConstants.lightGreenAlt,
                    tableLabel: 'Promotions',
                },
                tv_value: {
                    label: 'TV',
                    color: colorConstants.orangeAlt2,
                    tableLabel: 'TV',
                }, // media types starts here
                tv_units: {
                    label: 'TV',
                    color: colorConstants.orangeAlt2,
                    tableLabel: 'TV',
                },
                cinema_value: {
                    label: 'Cinema',
                    color: colorConstants.lightGreenAlt1,
                    tableLabel: 'Cinema',
                },
                cinema_units: {
                    label: 'Cinema',
                    color: colorConstants.lightGreenAlt1,
                    tableLabel: 'Cinema',
                },
                digital_units: {
                    label: 'Digital',
                    color: colorConstants.darkGreenAlt2,
                    tableLabel: 'Digital',
                },
                digital_value: {
                    label: 'Digital',
                    color: colorConstants.darkGreenAlt2,
                    tableLabel: 'Digital',
                },
                directmail_value: {
                    label: 'Direct mail',
                    color: colorConstants.darkGreenAlt3,
                    tableLabel: 'Direct mail',
                },
                directmail_units: {
                    label: 'Direct mail',
                    color: colorConstants.darkGreenAlt3,
                    tableLabel: 'Direct mail',
                },
                outdoor_units: {
                    label: 'Outdoor',
                    color: colorConstants.purpleAlt,
                    tableLabel: 'Outdoor',
                },
                outdoor_value: {
                    label: 'Outdoor',
                    color: colorConstants.purpleAlt,
                    tableLabel: 'Outdoor',
                },
                press_value: {
                    label: 'Press',
                    color: colorConstants.pinkAlt,
                    tableLabel: 'Press',
                },
                press_units: {
                    label: 'Press',
                    color: colorConstants.pinkAlt,
                    tableLabel: 'Press',
                },
                radio_units: {
                    label: 'Radio',
                    color: colorConstants.orangeAlt1,
                    tableLabel: 'Radio',
                },
                radio_value: {
                    label: 'Radio',
                    color: colorConstants.orangeAlt1,
                    tableLabel: 'Radio',
                },

                //for export label
                sales_year_ago: { label: 'YA Sales' },
                total_value: { label: 'Total' },
                media_incremental_value_percentage: {
                    label: 'Media Percentage',
                },
                media_incremental_units_percentage: {
                    label: 'Media Percentage',
                },
                incremental_value_percentage: {
                    label: 'Promotion Sales Percentage',
                },
                incremental_units_percentage: {
                    label: 'Promotion Sales Percentage',
                },
                base_value_percentage: { label: 'Regular Sales Percentage' },
                base_units_percentage: { label: 'Regular Sales Percentage' },
                tpr_incremental_value_percentage: {
                    label: 'Price Cut & On Shelf Percentage',
                },
                tpr_incremental_units_percentage: {
                    label: 'Price Cut & On Shelf Percentage',
                },
                tpr_only_value_percentage: {
                    label: 'Price Cut & On Shelf Percentage',
                },
                tpr_only_units_percentage: {
                    label: 'Price Cut & On Shelf Percentage',
                },
                feature_incremental_value_percentage: {
                    label: 'On Shelf Percentage',
                },
                feature_incremental_units_percentage: {
                    label: 'On Shelf Percentage',
                },
                feature_only_value_percentage: { label: 'On Shelf Percentage' },
                feature_only_units_percentage: { label: 'On Shelf Percentage' },
                display_incremental_value_percentage: {
                    label: 'Off Shelf Percentage',
                },
                display_incremental_units_percentage: {
                    label: 'Off Shelf Percentage',
                },
                display_only_value_percentage: {
                    label: 'Off Shelf Percentage',
                },
                display_only_units_percentage: {
                    label: 'Off Shelf Percentage',
                },
                feature_and_display_incremental_value_percentage: {
                    label: 'Special Pack Percentage',
                },
                feature_and_display_incremental_units_percentage: {
                    label: 'Special Pack Percentage',
                },
                feature_and_display_only_value_percentage: {
                    label: 'Special Pack Percentage',
                },
                feature_and_display_only_units_percentage: {
                    label: 'Special Pack Percentage',
                },
                no_promo_value_percentage: { label: 'Non Promo Percentage' },
                no_promo_units_percentage: { label: 'Non Promo Percentage' },
            },
            tooltipExtraItems: {
                tpr_acv: { label: 'Price Cut ACV %' },
                display_acv: { label: 'Off Shelf ACV %' },
                feature_acv: { label: 'On Shelf ACV %' },
                feature_and_display_acv: { label: 'Special Pack ACV %' },
                uplift: { label: 'Uplift' },
                promo_lift: { label: 'Promo Uplift' },
                media_lift: { label: 'Media Uplift' },
            },
            promoCalenderAttributeLevels: {
                promo: [
                    { value: 'product', label: 'Product' },
                    { value: 'retailer', label: 'Retailer' },
                ],
                media: [{ value: 'sub_brand', label: 'Sub Brand' }],
            },
            overlayKeys: {
                promo: [
                    { label: 'Start Week', dataKey: 'startTimestamp' },
                    { label: 'End Week', dataKey: 'endTimestamp' },
                    { label: 'Product', dataKey: 'product' },
                    { label: 'Promo Mechanics', dataKey: 'promoMech' },
                    { label: 'Promo Type', dataKey: 'promoType' },
                    { label: 'Investment', dataKey: 'field_value' },
                    // { label: 'ROI', dataKey: 'roi' },
                    // { label: 'Lift', dataKey: 'lift' },
                    // { label: 'Incremental Profit', dataKey: 'incrementalProfit' },
                    // { label: 'Incremental Retailer Profit', dataKey: 'incrementalRetailerProfit' },
                ],
                media: [
                    { label: 'Start Week', dataKey: 'startTimestamp' },
                    { label: 'End Week', dataKey: 'endTimestamp' },
                    { label: 'Sub Brand', dataKey: 'product' },
                    { label: 'Media Type', dataKey: 'promoType' },
                    { label: 'Investment', dataKey: 'field_value' },
                ],
            },
        },
        //PROMO SCORE CARD
        promoScoreCard: {
            mainHeader: 'Promo Scorecard',
            limit: 50,
            nestedTableLimit: 10,
            questionsNo: [1, 2, 3, 4, 6, 7],
            question: {
                Q: [
                    'Am I getting my fair share of quality support? ',
                    'How does my % Discount compare to competition? ',
                    'What % of Volume was sold on promotion? ',
                    'How many weeks am I promoting? ',
                    'What is my average price/units? ',
                    'What is my value share of promotions? ',
                ],
                unitsInItalics: [
                    '(Fair Share Index -€ Sold)',
                    '(Weighted Average % Price Reduction)',
                    '(% of Volume)',
                    '(Weighted Weeks)',
                    '(Price per Unit)',
                    '(Value share %)',
                ],
                unit: ['value', '%', '%', 'week', '€', '%'],
                numberFormateDecimal: [0, 1, 1, 0, 2, 1],
            },
            promoTypeLabelMapping: {
                display: { label: 'Off Shelf Only' },
                tpr: { label: 'Price Cut Only' },
                feature: { label: 'On Shelf Only' },
                feature_and_display: { label: 'Special Pack Only' },
                feature_display: { label: 'Special Pack Only' },
            },
            showGradientTile: true,
            promoType: ['Price Cut Only', 'Off Shelf Only', 'On Shelf Only', 'Special Pack Only'],
            promoExpandedViewTableUnit: 'volume',
            promoExpandedViewTableSalesAndVolumeLabel: ['Units', 'Total Sales €'],
            dropDown: ['Category', 'Sub_Category', 'Brand', 'Sub_Brand', 'Type'],
            listFor: ['Manufacturer', 'Brand', 'Sub_Brand', 'Branding', 'Perrigo_Pl', 'Dosage', 'product'],
            listForToDisplay: [
                'Manufacturer',
                'Brand',
                'Sub_Brand',
                'Branding',
                'Perrigo_Pl',
                'Dosage',
                'product',
                'Retailer',
                'Channel',
                'Country',
            ],
            listIn: [
                'Category',
                'Sub_Category',
                // 'Pack_Size',
                'Type',
                'Class',
                'Consumer',
                'Retailer',
                'Channel',
                'Country',
            ],
        },

        // PROMO LANDSCAPE
        promoLandscape: {
            mainHeader: 'Investment & ROI Tracker',
            roiLabel: 'ROI',
            defaultAttributeTypeIndex: 3,
            defaultInvestmentTypeItems: ['digital'],
            optimalInvestmentIndexThreshold1: 0.8,
            optimalInvestmentIndexThreshold2: 1.2,
            promoTacticDropdownName: 'Investment Type',
            dimensionConfig: {
                //snake case eg sub_category
                excludedDimensions: [],
                defaultDimension: '',
            },
            thresholdColorMapping: {
                optimal: { label: 'Optimal', color: colorConstants.darkGreen },
                over: { label: 'Over', color: colorConstants.darkRed },
                under: { label: 'Under', color: colorConstants.darkBlueAlt },
            },
            limit: 60,
            promoTypes: [
                { value: 'display', label: 'Off Shelf' },
                { value: 'tpr', label: 'Price Cut' },
                { value: 'feature', label: 'On Shelf' },
                // { value: 'feature & display', label: 'Feature & Display' },  //not required for now
            ],
            mediaLevelsDropdown: ['Manufacturer', 'Category', 'Sub Category', 'Brand', 'Sub Brand', 'Type'],
            showInvestmentDropdown: true,
            optimalIndexKey: 'competition_spend_index',
            tableRowsKeyMapping: [
                {
                    label: 'Investment',
                    children: null,
                    parentKey: null,
                    key: 'investments',
                    unit: '€',
                },
                {
                    label: 'ROI',
                    children: null,
                    parentKey: null,
                    key: 'roi',
                    unit: '',
                },
                {
                    label: 'Competition Spend Index',
                    children: [
                        {
                            label: 'Share of Investment',
                            key: 'share_of_investment',
                            unit: '%',
                        },
                        {
                            label: 'Share of Sales',
                            key: 'share_of_sales',
                            unit: '%',
                        },
                    ],
                    unit: '',
                    parentKey: 'competition_data',
                    key: 'competition_spend_index',
                },
                {
                    label: 'Incremental Sales',
                    unit: '€',
                    children: [
                        {
                            label: 'Total Sales',
                            key: 'total_sales',
                            unit: '',
                        },
                        {
                            label: 'Base Sales',
                            key: 'base_sales',
                            unit: '',
                        },
                    ],
                    parentKey: 'sales_data',
                    key: 'incremental_retail_sales',
                },
                {
                    label: 'Total Profit',
                    unit: '€',
                    children: [
                        {
                            label: 'Incremental Profit',
                            key: 'incremental_profit',
                            unit: '€',
                        },
                        {
                            label: 'Base Profit',
                            key: 'base_profit',
                            unit: '€',
                        },
                    ],
                    parentKey: 'profit_data',
                    key: 'total_profit',
                },
                // {
                //     label: 'Share of Spends',
                //     children: null,
                //     parentKey: null,
                //     key: 'shareOfSpends',
                //     unit: '',
                // },
            ],
        },
        //PORTFOLIO ANALYSIS
        portfolioAnalysis: {
            mainHeader: 'Promo ROI Analysis',
            limit: 20,
            defaultGroupByIndex: 18,
            defaultGroupBy2Index: 5,
            chartColors: [],
            absTileData: [
                { key: 'Promotions', label: 'Promotions' },
                { key: 'Drivers', label: 'Drivers' },
                { key: 'Media', label: 'Media' },
            ],
            salesAttributionChart: {
                colorList: ['#10AB5E', '#DC3826'],
                colorListType2: ['#758BEE', '#758BEE'],
                profitPoolColor: ['#826FD0', '#826FD0'],
                backGroundColor: 'rgba(0, 0, 0, 0.02)',
            },
            chartDropdownExtraKpis: [
                {
                    dimension: 'none',
                    label: 'Media Descriptor',
                    dataKey: 'tactic_description',
                },
                {
                    dimension: 'none',
                    label: 'Mechanics',
                    dataKey: 'promotion_mechanic',
                },
                {
                    dimension: 'none',
                    label: 'Event Name',
                    dataKey: 'event_name',
                },
                {
                    dimension: 'dim1',
                    label: 'Week',
                    dataKey: 'week',
                },
            ],
            groupByHeaders: [
                {
                    label: 'Category',
                    value: 'category',
                    dimension: 'dim1',
                    isSelected: false,
                    sortKey: 'category',
                    multiSelectFilter: false,
                },
                {
                    label: 'Sub Category',
                    value: 'sub_category',
                    dimension: 'dim1',
                    isSelected: false,
                    sortKey: 'sub_category',
                    multiSelectFilter: false,
                },
                {
                    label: 'Brand',
                    value: 'brand',
                    dimension: 'dim1',
                    isSelected: false,
                    sortKey: 'brand',
                    multiSelectFilter: false,
                },
                {
                    label: 'Sub Brand',
                    value: 'sub_brand',
                    dimension: 'dim1',
                    isSelected: false,
                    sortKey: 'sub_brand',
                    multiSelectFilter: false,
                },
                {
                    label: 'Product',
                    value: 'product',
                    dimension: 'dim1',
                    isSelected: true,
                    sortKey: 'product',
                    multiSelectFilter: false,
                },
                {
                    label: 'Mechanics',
                    value: 'promotion_mechanic',
                    dimension: null,
                    isSelected: true,
                    sortKey: 'promotion_mechanic',
                    multiSelectFilter: true,
                },
                {
                    label: 'Media Descriptor',
                    value: 'tactic_description',
                    dimension: null,
                    isSelected: false,
                    sortKey: 'tactic_description',
                    multiSelectFilter: true,
                },
            ],

            mediaSpendsLabelKeyMapping: {
                attribute_name: 'Attribute Name',
                media_type: 'Media Type',
                media_investment: 'Media Spends',
                share_of_media_spend: 'Share Of Media Spends(%)',
                incremental_retail_sales: 'Incremental Sales from Media',
                media_lift: 'Media Lift',
                media_roi: 'Media ROI',
            },
            mediaSpendsAttributeOptions: [
                { label: 'Sub Brand', key: 'Sub_Brand', dim: 'dim1' },
                { label: 'Brand', key: 'Brand', dim: 'dim1' },
                { label: 'Manufacturer', key: 'Manufacturer', dim: 'dim1' },
                { label: 'Category', key: 'Category', dim: 'dim1' },
                { label: 'Sub Category', key: 'Sub_Category', dim: 'dim1' },
            ],

            chartHeaderLabelKeyMapping: {
                lift: { label: 'Lift' },
                roi: { label: 'ROI' },
                investments: { label: 'Investments' },
                incremental_net_sales: { label: 'Incremental Net Sales' },
                incremental_profit: { label: 'Incremental Profit' },
                incremental_retailer_profit: {
                    label: 'Incremental Retailer Profit',
                },
                acv: { label: 'ACV Distribution' },
                profit_pool: { label: 'Profit Pool' },
                tpr_acv: { label: 'Price Cut ACV' },
                display_acv: { label: 'Off Shelf ACV' },
                feature_acv: { label: 'On Shelf ACV' },
                feature_and_display_acv: { label: 'Special Pack ACV' },
                total_acv: { label: 'Total ACV' },
                weeks: { label: 'Promo Weeks' },
            },
            dimension: 'dim1',
            attributeType: 'product',
            promoTypesChartLegends: [
                {
                    label: 'Price Cut',
                    color: colorConstants.lightCyan,
                    style: {
                        borderRadius: '100%',
                        height: `8px`,
                        width: '8px',
                    },
                },
                {
                    label: 'On Shelf',
                    color: colorConstants.lightCream,
                    style: {
                        borderRadius: '100%',
                        height: `8px`,
                        width: '8px',
                    },
                },
                {
                    label: 'Off Shelf',
                    color: colorConstants.lightPink,
                    style: {
                        borderRadius: '100%',
                        height: `8px`,
                        width: '8px',
                    },
                },
            ],
            promoTypes: ['tpr/scan', 'feature ad', 'display'],
            promoTypesLabelMapping: {
                'tpr/scan': 'Price Cut',
                'feature ad': 'On Shelf',
                display: 'Off Shelf',
            },
        },
        promoRecommendation: {
            playbookLimit: 50,
            clientName: 'Perrigo',
            mainHeader: 'On Invoice Discounts Simulator',
            retailerKey: 'channel',
            hideAddSpends: false,
            calenderStartDay: 'Saturday',
            spendLeversList: [
                {
                    label: 'Baseline Unit',
                    placeholder: 'Baseline Unit',
                    value: 'baseVolume',
                    isDisabled: false,
                },
                {
                    label: 'Uplift',
                    placeholder: 'Uplift',
                    value: 'uplift',
                    isDisabled: false,
                },
                {
                    label: 'Total Unit',
                    placeholder: 'Total Unit',
                    value: 'totalVolume',
                    isDisabled: true,
                },
                {
                    label: `Total Perrigo Profit (€)`,
                    placeholder: `Total Perrigo Profit`,
                    value: 'totalKindProfit',
                    isDisabled: true,
                },
                {
                    label: 'ROI',
                    placeholder: 'ROI',
                    value: 'roi',
                    isDisabled: true,
                },
                {
                    label: `Total Retailer Profit (€)`,
                    placeholder: 'Total Retailer Profit',
                    value: 'totalRetailerProfit',
                    isDisabled: true,
                },
                {
                    label: `Total GSV`,
                    placeholder: 'Total GSV',
                    value: 'totalGsv',
                    isDisabled: true,
                },
            ],
            spendTypeList: [
                {
                    label: 'Lump Sum',
                    value: 'lump_sum',
                    inputRule: '',
                },
                {
                    label: 'Per Qty',
                    value: 'per_qty',
                    inputRule: '',
                },
                {
                    label: 'Display',
                    value: 'display',
                    inputRule: '',
                },
                {
                    label: 'Feature',
                    value: 'feature',
                    inputRule: '',
                },
            ],
            playbookKeyMapping: {
                Product: ['ppgName'],
                '%TS': ['guidelinePercentageTotalSpends', 'percentageTotalSpends', 'lesser_than', '', '%'],
                Frequency: ['guidelineFrequency', 'frequency', 'range', ''],
                ROI: ['guidelineRoi', 'roi', 'greater_than', '', ''],
            },
            // comparisonOperator: {
            //     '%TS': '<',
            //     Frequency: 'range',
            //     ROI: '>',
            // },
            menuButtons: [
                { key: 'recommendations', label: 'Recommendations' },
                {
                    key: 'summary',
                    label: 'Summary',
                },
                {
                    key: 'playbook',
                    label: 'Playbook',
                },
            ],

            promoTypeColorMapping: {
                'volume discounts': {
                    label: 'Volume Discounts',
                    color: colorConstants.lightGreenAlt,
                },
                // feature_ad: {
                //     label: 'Feature Ad',
                //     color: colorConstants.darkGreenAlt2,
                // },
                // display: { label: 'Display', color: colorConstants.pinkAlt },
                // feature_display_tpr: {
                //     label: 'Feature_Display_TPR',
                //     color: colorConstants.orangeAlt2,
                // },
                // display_tpr: {
                //     label: 'Display_TPR',
                //     color: colorConstants.darkBlueAlt,
                // },
            },
            overlayKeys: [
                {
                    label: 'Start Date',
                    dataKey: 'startDate',
                    pre: '',
                    post: '',
                },
                { label: 'Duration', dataKey: 'duration', pre: '', post: '' },
                {
                    label: 'Promo Type',
                    dataKey: 'tacticDescription',
                    pre: '',
                    post: '',
                },
                { label: 'Product(s)', dataKey: 'dim1AttributeNames', pre: '', post: '' },
                {
                    label: 'Total Volume',
                    dataKey: 'totalVolume',
                    pre: '',
                    post: '',
                    arrowConfig: 'positiveUp',
                },
                {
                    label: 'Total GSV',
                    dataKey: 'totalGsv',
                    pre: '€',
                    post: '',
                    arrowConfig: 'positiveUp',
                },
                {
                    label: 'Total NSV',
                    dataKey: 'totalNsv',
                    pre: '€',
                    post: '',
                    arrowConfig: 'positiveUp',
                },
                {
                    label: 'Total Perrigo Profit',
                    dataKey: 'totalKindProfit',
                    pre: '€',
                    post: '',
                    arrowConfig: 'positiveUp',
                },
                // {
                //     label: 'Total Retailer Profit',
                //     dataKey: 'totalRetailerProfit',
                //     pre: '€',
                //     post: '',
                //     arrowConfig: 'positiveUp',
                // },
                {
                    label: 'Promo Spends',
                    dataKey: 'promoSpends',
                    pre: '€',
                    post: '',
                    arrowConfig: 'negativeUp',
                },
                {
                    label: '% Trade Spends GSV',
                    dataKey: 'percentageTradeSpendsGsv',
                    pre: '',
                    post: '%',
                    arrowConfig: 'negativeUp',
                },
                {
                    label: '% Trade Spends NSV',
                    dataKey: 'percentageTradeSpendsNsv',
                    pre: '',
                    post: '%',
                    arrowConfig: 'negativeUp',
                },

                {
                    label: 'Incremental Volume',
                    dataKey: 'incrementalVolume',
                    pre: '',
                    post: '',
                    arrowConfig: 'positiveUp',
                },
                {
                    label: 'Incremental GSV',
                    dataKey: 'incrementalGsv',
                    pre: '€',
                    post: '',
                    arrowConfig: 'positiveUp',
                },
                {
                    label: 'Incremental NSV',
                    dataKey: 'incrementalNsv',
                    pre: '€',
                    post: '',
                    arrowConfig: 'positiveUp',
                },
                {
                    label: 'Total Profit %',
                    dataKey: 'totalProfitPercentage',
                    pre: '',
                    post: '%',
                    arrowConfig: 'positiveUp',
                },
                {
                    label: 'Incremental Profit',
                    dataKey: 'incrementalProfit',
                    pre: '€',
                    post: '',
                    arrowConfig: 'positiveUp',
                },
                {
                    label: 'Promo ROI',
                    dataKey: 'roi',
                    pre: '',
                    post: '',
                    arrowConfig: 'positiveUp',
                },
                // {
                //     label: 'Retailer Incremental Profit',
                //     dataKey: 'retailerIncrementalProfit',
                //     pre: '€',
                //     post: '',
                //     arrowConfig: 'positiveUp',
                // },
            ],
            spendLabel: {
                lump_sum: 'Lump Sum',
                per_qty: 'Per Qty',
                display: 'Display',
                feature: 'Feature',
            },
            offerMethodList: [
                // { value: 'option', label: 'List of Option', dimension: 'dim1' },
                { value: 'manual', label: 'Manual', dimension: 'dim1' },
                // { value: 'previous', label: 'Previous', dimension: 'dim1' },
            ],
            addEventList: [
                { value: 'new', label: 'Add New Event' },
                { value: 'import', label: 'Import Event' },
            ],
            leverKeys: [
                'promptEventName',
                'offerMethod',
                'discount',
                'startDate',
                'duration',
                'displayAcv',
                'featureAcv',
            ],
            spendTopForm: [
                'baseVolume',
                'uplift',
                'totalVolume',
                'totalKindProfit',
                'roi',
                'totalRetailerProfit',
                'totalGsv',
            ],
            formList: [
                {
                    value: 'duration',
                    label: 'Duration',
                    inputRule: '',
                    placeHolder: 'Enter',
                },
                // {
                //     value: 'displayAcv',
                //     label: 'Display ACV',
                //     inputRule: '',
                //     placeHolder: 'Enter display ACV',
                // },
                // {
                //     value: 'featureAcv',
                //     label: 'Feature ACV',
                //     inputRule: '',
                //     placeHolder: 'Enter feature ACV',
                // },
            ],
            offerSelectionKeys: ['promotionMechanic', 'tacticDescription'],
            spendPerQtyKey: ['per_qty', 'redemption'],
        },
        commercialForecast: {
            externalAnalyticsToolName: { shortName: 'VF' },
            excludedAttributeTypes: ['manufacturer'],
            limit: 60,
            forecastDropdownData: [
                {
                    key: 'asper',
                    label: 'Asper Forecast',
                    value: 'asper',
                    dataKey: 'asper',
                },
                {
                    key: 'external',
                    label: 'VF Forecast',
                    value: 'external',
                    dataKey: 'external',
                },
                {
                    key: 'difference',
                    label: 'Difference',
                    value: 'difference',
                    dataKey: 'difference',
                },
                // { key: 'profit', label: 'Profit', value: 'profit', dataKey: 'profit' },
            ],
            trendChartDropdownData: [
                {
                    key: 'month',
                    label: 'Months',
                    labelAlt: 'Monthly',
                    value: 'month',
                    dataKey: 'month',
                },
                {
                    key: 'week',
                    label: 'Weeks',
                    labelAlt: 'Weekly',
                    value: 'week',
                    dataKey: 'week',
                },
                // { key: 'profit', label: 'Profit', value: 'profit', dataKey: 'profit' },
            ],
            graphExportHeaderMapping: {
                base: ['Non-promo', 'Promo'],
                incremental: ['Base', 'Incremental'],
                total: ['Consumption'],
                depletion: ['Depletion'],
            },
            mainTileData: [
                { key: 'total', label: 'Total' },
                { key: 'base', label: 'Base' },
                { key: 'incremental', label: 'Incremental' },
            ],
            graphLegendMapping: {
                total_asper: {
                    color: colorConstants.lightGreenAlt,
                    label: 'Total Units Asper',
                },
                base_asper: {
                    color: colorConstants.lightGreenAlt,
                    label: 'Base Units Asper',
                },
                incremental_asper: {
                    color: colorConstants.lightGreenAlt,
                    label: 'Incremental Units Asper',
                },
                total_external: {
                    color: colorConstants.darkYellow,
                    label: 'Total Units VF',
                },
                base_external: {
                    color: colorConstants.darkYellow,
                    label: 'Base Units VF',
                },
                incremental_external: {
                    color: colorConstants.darkYellow,
                    label: 'Incremental Units VF',
                },
                total_difference: {
                    color: colorConstants.orangeAlt2,
                    label: 'Total Units Difference',
                },
                base_difference: {
                    color: colorConstants.orangeAlt2,
                    label: 'Base Units Difference',
                },
                incremental_difference: {
                    color: colorConstants.orangeAlt2,
                    label: 'Incremental Units Difference',
                },
            },
            tableKeyLabelMapping: {
                total_sales_asper: {
                    label: 'Total Units Asper',
                    pre: '',
                    post: '',
                },
                total_sales_difference: {
                    label: 'Total Units Difference',
                    pre: '',
                    post: '',
                },
                total_sales_external: {
                    label: 'Total Units VF',
                    pre: '',
                    post: '',
                },
                incremental_sales_asper: {
                    label: 'Incremental Units Asper',
                    pre: '',
                    post: '',
                },
                incremental_sales_difference: {
                    label: 'Incremental Units Difference',
                    pre: '',
                    post: '',
                },
                incremental_sales_external: {
                    label: 'Incremental Units VF',
                    pre: '',
                    post: '',
                },
                base_sales_asper: {
                    label: 'Base Units Asper',
                    pre: '',
                    post: '',
                },
                base_sales_difference: {
                    label: 'Base Units Difference',
                    pre: '',
                    post: '',
                },
                base_sales_external: {
                    label: 'Base Units VF',
                    pre: '',
                    post: '',
                },
            },
        },
        priceLadder: {
            isThresholdDropdownEnabled: true,
            hideMraup: true,
            limit: 50, //update this when implementing infinite scroller,
            dimensionConfig: {
                //snake case eg sub_category
                excludedDimensions: [],
                defaultDimension: 'Brand',
            },
            tileData: [
                {
                    label: 'Product by Market',
                    key: 'product by market',
                },
                // {
                //     label: 'Product vs Competitors',
                //     key: 'product vs competitors',
                // },
            ],
            subTileData: [
                {
                    label: 'Per Unit',
                    key: 'PU',
                },
                // {
                //     label: 'PEQ',
                //     key: 'PEQ',
                // },
            ],
            legendMapping: {
                PU: [
                    {
                        color: '#E6E6EA',
                        label: 'Sales €',
                        key: 'salesValueDollars',
                        dataKey: 'sales',
                        metricDataKey: 'units',
                    },
                    {
                        color: '#66AFBA',
                        label: 'Avg. Price Per Unit',
                        key: 'avgPrice',
                        dataKey: 'avg_price_per_unit',
                        metricDataKey: 'units',
                    },
                    {
                        color: '#ECA586',
                        label: 'Max Price Per Unit',
                        key: 'maxPrice',
                        dataKey: 'max_price_per_unit',
                        metricDataKey: 'units',
                    },
                    {
                        color: '#EB8FC5',
                        label: 'Min Price Per Unit',
                        key: 'minPrice',
                        dataKey: 'min_price_per_unit',
                        metricDataKey: 'units',
                    },
                    // {
                    //     color: '#F1C77A',
                    //     label: 'Promo Price Per Unit',
                    //     key: 'promoPrice',
                    //     dataKey: 'promo_price_per_unit',
                    //     metricDataKey: 'units',
                    // },
                    // {
                    //     color: '#6771DB',
                    //     label: 'Regular Price Per Unit',
                    //     key: 'basePrice',
                    //     dataKey: 'base_price_per_unit',
                    //     metricDataKey: 'units',
                    // },
                    // { color: '#5463FF', label: 'MRAUP', key: 'mraup', dataKey: 'mraup' },
                ],
                PEQ: [
                    {
                        color: '#E6E6EA',
                        label: 'Sales €',
                        key: 'salesValueDollars',
                        dataKey: '',
                        metricDataKey: 'volume',
                    },
                    {
                        color: '#66AFBA',
                        label: 'Avg. Price PEQ',
                        key: 'avgPrice',
                        dataKey: 'avg_price_per_eq',
                        metricDataKey: 'volume',
                    },
                    {
                        color: '#ECA586',
                        label: 'Max Price PEQ',
                        key: 'maxPrice',
                        dataKey: 'max_price_per_eq',
                        metricDataKey: 'volume',
                    },
                    {
                        color: '#EB8FC5',
                        label: 'Min Price PEQ',
                        key: 'minPrice',
                        dataKey: 'min_price_per_eq',
                        metricDataKey: 'volume',
                    },
                    // {
                    //     color: '#F1C77A',
                    //     label: 'Promo Price PEQ',
                    //     key: 'promoPrice',
                    //     dataKey: 'promo_price_per_eq',
                    //     metricDataKey: 'volume',
                    // },
                    // {
                    //     color: '#6771DB',
                    //     label: 'Regular Price PEQ',
                    //     key: 'basePrice',
                    //     dataKey: 'base_price_per_eq',
                    //     metricDataKey: 'volume',
                    // },
                    // { color: '#5463FF', label: 'MRAUP', key: 'mraup', dataKey: 'mraup' },
                ],
            },
            dataKeyMapping: {
                PU: [
                    { label: 'Sales €', key: 'salesValueDollars' },
                    { label: 'Avg. Price Per Unit', key: 'avgPrice' },
                    { label: 'Max Price Per Unit', key: 'maxPrice' },
                    { label: 'Min Price Per Unit', key: 'minPrice' },
                    // { label: 'Promo Price Per Unit', key: 'promoPrice' },
                    // { label: 'Regular Price Per Unit', key: 'basePrice' },
                ],
                PEQ: [
                    { label: 'Sales €', key: 'salesValueDollars' },
                    { label: 'Avg. Price PEQ', key: 'avgPrice' },
                    { label: 'Max Price PEQ', key: 'maxPrice' },
                    { label: 'Min Price PEQ', key: 'minPrice' },
                    // { label: 'Promo Price PEQ', key: 'promoPrice' },
                    // { label: 'Regular Price PEQ', key: 'basePrice' },
                ],
            },
            tableColumnLabelKeyMapping: {
                sales: { label: 'Sales €' },
                sales_percentage: { label: 'Sales %' },
                avg_price_pu: { label: 'Average Price € Per Unit' },
                // avg_price_peq: { label: 'Average Price € PEQ' },
                max_price_pu: { label: 'Max Price € Per Unit' },
                // max_price_peq: { label: 'Max Price € PEQ' },
                min_price_pu: { label: 'Min Price € Per Unit' },
                // min_price_peq: { label: 'Min Price € PEQ' },
                // mraup: { label: 'MRAUP' },
                // base_price_pu: { label: 'Regular Price € Per Unit' },
                // // base_price_peq: { label: 'Base Price € PEQ' },
                // promo_price_pu: { label: 'Promo Price € Per Unit' },
                // promo_price_peq: { label: 'Promo Price € PEQ' },
            },
            dropdown2Filter: ['Category', 'Segment', 'Channel', 'Retailer'],
        },
        opportunityIdentification: {
            reversePpeAxis: false,
            bubbleCategoryOptions: [
                { value: 'brand', label: 'Brand', dimension: 'dim1' },
                { value: 'sub_brand', label: 'Sub Brand', dimension: 'dim1' },
                { value: 'category', label: 'Category', dimension: 'dim1' },
                // { value: 'pack_size', label: 'Pack Size', dimension: 'dim1' },
                {
                    value: 'manufacturer',
                    label: 'Manufacturer',
                    dimension: 'dim1',
                },
                { value: 'product', label: 'Product', dimension: 'dim1' },
            ],
            kpis: {
                xaxis: [
                    { label: 'APE', value: 'bpe' },
                    { label: 'Value Sales Growth %', value: 'rsv_growth' },
                    { label: 'Units', value: 'total_units' },
                    { label: 'Value Sales', value: 'rsv' },
                ],
                yaxis: [
                    { label: 'Value Sales Growth %', value: 'rsv_growth' },
                    { label: 'Units', value: 'total_units' },
                    { label: 'APE', value: 'bpe' },
                    { label: 'Value Sales', value: 'rsv' },
                ],
                bubbleSize: [
                    { label: 'Units', value: 'total_units' },
                    { label: 'APE', value: 'bpe' },
                    { label: 'Value Sales', value: 'rsv' },
                    { label: 'Value Sales Growth %', value: 'rsv_growth' },
                ],
            },
            elasticityDriver: {
                chart2Limit: 100,
                levels: [
                    { label: 'Category', value: 'category', dimension: 'dim1' },
                    { label: 'Product', value: 'product', dimension: 'dim1' },
                    { label: 'Brand', value: 'brand', dimension: 'dim1' },
                    { label: 'Sub brand', value: 'sub_brand', dimension: 'dim1' },
                    // { label: 'Pack Size', value: 'pack_size', dimension: 'dim1' },
                    { label: 'Geography', value: 'geography', dimension: 'dim2' },
                ],
                limit: 50,
                offset: 0,
                dimension: 'dim1',
                legendMapping: [
                    {
                        dataKey: 'own',
                        label: 'Own Elasticity',
                        color: '#69D4E8',
                    },
                    {
                        dataKey: 'internal',
                        label: 'Internal Competitor Elasticity',
                        color: '#E469B2',
                    },
                    {
                        dataKey: 'external',
                        label: 'External Competitor Elasticity',
                        color: '#EDB44E',
                    },
                ],
            },
        },
        priceCurve: {
            chart1Limit: 100,
            xAxisKeyValue: [
                { value: 'dosage', label: 'Dosage' },
                { value: 'unit_size', label: 'Unit Size' },
                { value: 'brand', label: 'Brand' },
                { value: 'sub_brand', label: 'Sub Brand' },
            ],
            YAxisKeyValue: [
                // { value: 'retail_price', label: 'Retail Price' },
                // { value: 'list_price', label: 'List Price' },
                { value: 'base_price', label: 'Regular Price' },
            ],
            levels: [
                { value: 'brand', label: 'Brand' },
                { value: 'sub_brand', label: 'Sub Brand' },
                { value: 'manufacturer', label: 'Manufacturer' },
                { value: 'consumer', label: 'Consumer' },
                { value: 'dosage', label: 'Dosage' },
            ],
            subTileData: [
                {
                    label: 'Per Unit',
                    key: 'PU',
                    dataKey: 'per_unit',
                },
                // {
                //     label: 'PEQ',
                //     key: 'PEQ',
                //     dataKey: 'per_eq',
                // },
            ],
            chartColors: [
                '#E8A122',
                '#293BB8',
                '#E06936',
                '#19669D',
                '#A5582D',
                '#43C9E2',
                '#DD449F',
                '#37C7BE',
                '#9E5897',
                '#00798C',
                '#EDB44E',
                '#4557D5',
                '#E6875E',
                '#228BD6',
                '#CC7442',
                '#69D4E8',
                '#E469B2',
                '#5FD3CB',
                '#B377AD',
                '#3394A3',
                '#F1C77A',
                '#7381E0',
                '#ECA586',
                '#55A8E4',
                '#D89672',
                '#8EDFEE',
                '#EB8FC5',
                '#87DED8',
                '#C699C2',
                '#66AFBA',
                '#F6D9A7',
                '#A2ABEA',
                '#F3C3AF',
                '#8EC5ED',
                '#E5B9A1',
                '#B4E9F3',
                '#F1B4D9',
                '#AFE9E5',
                '#D9BBD6',
                '#99C9D1',
                '#FAECD3',
                '#D0D5F5',
                '#F9E1D7',
                '#C6E2F6',
                '#F2DCD0',
                '#D9F4F9',
                '#F8DAEC',
                '#D7F4F2',
                '#ECDDEB',
                '#CCE4E8',
            ],
            tableHeaders: [
                // { label: 'List Price €', key: 'list_price' },
                // { label: 'List Price € YA', key: 'list_price_ya' },
                // { label: 'Retail Price €', key: 'retail_price' },
                // { label: 'Retail Price € YA', key: 'retail_price_ya' },
                { label: 'Regular Price €', key: 'base_price' },
                { label: 'Regular Price € YA', key: 'base_price_ya' },
            ],
        },
        pricePoint: {
            priceRange: [0, 10],
            graphColorScheme: ['#D7D6D9', '#69d4e8', '#228bd6', '#b377ad', '#66AFBA', '#ECA586', '#F1C77A', '#EB8FC5'],
            hideMraup: true,
            limit: 500,
            dimensionConfig: {
                //snake case eg sub_category
                excludedDimensions: [],
                defaultDimension: 'Manufacturer',
            },
            contributionThreshold: 5,
            priceTypeOptions: [
                { label: 'Avg Price', value: 'avg_price' },
                // { label: 'Base Price', value: 'base_price' },
            ],
            subTileData: [
                {
                    label: 'Per Unit',
                    key: 'per_unit',
                    xAxisLabel: 'Price Per Unit',
                    tooltip: 'Per Unit',
                },
                // {
                //     label: 'PEQ',
                //     key: 'per_volume',
                //     xAxisLabel: 'Price Per Eq',
                //     tooltip: 'Per Eq Volume',
                // },
            ],
            yAxisDropdownData: [
                {
                    label: 'Value',
                    value: 'value',
                },
                // {
                //     label: 'Volume',
                //     value: 'volume',
                // },
                {
                    label: 'Units',
                    value: 'units',
                },
            ],
            tableHeaderKeyMapping: {
                growth_percentage: ['Growth % vs YA', '', '%'],
                total_sales: ['Total Value (€)', '€', ''],
                total_volume: ['Total Volume', '', ''],
                total_units: ['Total Units', '', ''],
                avg_price_per_unit: ['Avg. Price per Unit', '€', ''],
                avg_price_per_eq: ['Avg. Price per EQ', '€', ''],
                base_price_per_unit: ['Base Price per Unit', '€', ''],
                base_price_per_eq: ['Base Price per EQ', '€', ''],
            },
            drilldownTableHeaderKeyMapping: {
                growth_abs: ['Growth Abs', '€', ''],
                growth_percentage: ['Growth %', '', '%'],
                contribution_to_category: ['Contribution to category', '€', ''],
                cy_share: ['CY share', '', '%'],
                ya_share: ['YA share', '', '%'],
                change: ['Change %', '', '%'],
            },
            dropdown2Filter: ['Category', 'Segment', 'Channel', 'Retailer'],
            customThresholdData: [
                {
                    id: 1,
                    value: '',
                },
                {
                    id: 2,
                    value: '',
                },
                {
                    id: 3,
                    value: '',
                },
                {
                    id: 4,
                    value: '',
                },
                {
                    id: 5,
                    value: '',
                },
            ],
        },
        priceTracking: {
            limit: 20,
            dimensionConfig: {
                //snake case eg sub_category
                excludedDimensions: ['manufacturer', 'consumer', 'dosage'],
                defaultRowDimension: 'Product',
                defaultColumnDimension: 'Channel',
            },
            attributeNamesLimit: 50,
            frequency: 'W',
            timePeriodOptions: [
                { label: 'YA', value: 'year_ago' },
                { label: 'Prior Period', value: 'prior_period' },
                { label: 'Custom Period', value: 'custom' },
            ],
            priceTypeOptions: [
                // { label: 'Regular Price', value: 'base' },
                { label: 'Avg Price', value: 'average' },
            ],
            kpiOptions: [
                { label: '% Change', value: 'percent_change' },
                { label: 'Price Index', value: 'index' },
            ],
            subTileData: [
                {
                    label: 'Per Unit',
                    key: 'units',
                    xAxisLabel: 'Price Per Unit',
                    tooltip: 'Per Unit',
                },
                // {
                //     label: 'PEQ',
                //     key: 'volume',
                //     xAxisLabel: 'Price Per Eq',
                //     tooltip: 'Per Eq Volume',
                // },
            ],

            weeksOptions: [
                { label: 'L W1', value: 1 },
                { label: 'L W4', value: 4 },
                { label: 'L W12', value: 12 },
            ],
            monthsOptions: [
                { label: 'L M1', value: 1 },
                { label: 'L M3', value: 3 },
                { label: 'L M6', value: 6 },
                { label: 'L M12', value: 12 },
            ],
            quartersOptions: [
                { label: 'L Q1', value: 1 },
                { label: 'L Q2', value: 2 },
                { label: 'L Q4', value: 4 },
            ],
            kpiMapping: {
                'Base Price': ['€', ''],
                'Base Price YA': ['€', ''],
                'Avg Price': ['€', ''],
                'Avg Price YA': ['€', ''],
                'Base Price Index % Chg': ['', '%'],
                'Base Price % Chg': ['', '%'],
                'Avg Price Index % Chg': ['', '%'],
                'Avg Price % Chg': ['', '%'],
                'TDP % Chg': ['', '%'],
                TDP: ['', ''],
                'TDP YA': ['', ''],
                'Volume Velocity % Chg': ['', '%'],
                'Volume Velocity': ['', ''],
                'Volume Velocity YA': ['', ''],
            },
        },
        bestWeeks: {
            limit: 50,
            drilldownTableConfig: [
                { label: 'Period No:', value: 'period_no', sorting: false },
                { label: 'Year', value: 'year', sorting: false },
            ],
            dimensionConfig: {
                //snake case eg sub_category
                excludedDimensions: ['dim2'],
                defaultDimension: 'Brand',
            },
            rankingCriteriaOptions: [
                { label: 'Base Volume', value: 'base_eq_volume' },
                { label: 'ACV', value: 'total_per_acv_dist' },
                { label: 'Incremental Volume', value: 'incremental_eq_volume' },
                { label: 'Total Volume', value: 'total_eq_volume' },
            ],
        },
    },
    perrigoBelgium: {
        //COMMON CONFIG
        commonConfig: {
            clientName: 'Perrigo Belgium',
            handleDim2SortingFromFrontend: false,
            dateFormat: 'DD/MM/YY',
            dateFormatAlt: 'DD/MM/YY',
            calenderStartDay: 'Saturday',
            showSecondaryLogo: false,
            showLogoInNavbar: true,
            logoHeight: '32px',
            logoWidth: '125px',
            loginPageTextPart1: 'Welcome to',
            loginPageTextPart2: 'Commercial Growth AI Tool',
            width: window.innerWidth,
            limit: 10,
            offset: 0,
            lagList: [0, 1],
            graphFontSize: calculateFontSize(window.innerWidth, 13),
            graphFontSizeAlt: calculateFontSize(window.innerWidth, 13),
            graphFontFamily: "'Helvetica Neue', sans-serif",
            graphLabelColorAlt: '#4E4C55',
            graphLabelColor: '#433C4A',
            units: {
                currency: '£',
                volume: 'Eq Vol',
                currencyText: 'Value',
            },
            filterFormat: { dim1: { ids: [] }, dim2: { ids: [] } },
            frequency: 'W',
            showCampignCalender: false,
            showFullLabel: true,
            decimalForPercentage: 1,
            decimalForNonPercentage: 2,
        },
        latestDateForDifferentRoutes: {
            'promo-score-card': 'Promotion Data',
            'roi-analysis': 'Promotion Data',
            'roi-tracker': 'Promotion Data',
            'commercial-forecast': 'Commercial Forecast',
            default: 'POS Data',
        },
        screenDetailsWithRoutes: [
            {
                label: 'Growth Analysis',
                path: 'promo/category-diagnostics/growth-analysis',
                id: 'ga',
                pageId: 'ga',
            },
            {
                label: 'Bump Report',
                path: 'promo/category-diagnostics/bump-report',
                id: 'br',
                pageId: 'br',
            },
            {
                label: 'Price Change',
                path: 'pricing/analytics/price-change',
                id: 'pcn',
                pageId: 'pcn',
            },
            {
                label: 'Price Point',
                path: 'pricing/analytics/price-point',
                id: 'pp',
                pageId: 'pp',
            },
            {
                label: 'Price Ladder',
                path: 'pricing/analytics/price-ladder',
                id: 'pld',
                pageId: 'pld',
            },
            {
                label: 'Price Curve',
                path: 'pricing/analytics/price-curve',
                id: 'pc',
                pageId: 'pc',
            },
            {
                label: 'Price Tracking',
                path: 'pricing/analytics/price-tracking',
                id: 'pt',
                pageId: 'pt',
            },
            {
                label: 'Opportunity Identification',
                path: 'pricing/analytics/opportunity-identification',
                id: 'oi',
                pageId: 'oi',
            },
            {
                label: 'Promo Scorecard',
                path: 'promo/analytics/promo-score-card',
                id: 'ps',
                pageId: 'ps',
            },
            {
                label: 'Investment & ROI Tracker',
                path: 'promo/analytics/roi-tracker',
                id: 'pl',
                pageId: 'pl',
            },
            {
                label: 'Promo ROI Analysis',
                path: 'promo/analytics/roi-analysis',
                id: 'pa',
                pageId: 'pa',
            },
            {
                label: 'Commercial Forecast',
                path: 'promo/recommendation/commercial-forecast',
                id: 'cf',
                pageId: 'cf',
            },

            {
                label: 'Promo Recommendation',
                path: 'promo/recommendation/promo-recommendation',
                id: 'pr',
                pageId: 'pr',
            },
            // { label: 'Pricing Simulator', path: 'pricing/recommendation/price-simulator', id: 'psr', pageId: 'psr' },
            // {
            //     label: 'Pricing Simulator',
            //     path: 'pricing/recommendation/price-simulator/new',
            //     id: 'psr',
            //     pageId: 'psrNew',
            // },
            // {
            //     label: 'Pricing Simulator',
            //     path: 'pricing/recommendation/price-simulator/edit/:id',
            //     id: 'psr',
            //     pageId: 'psrEdit',
            // },
            // {
            //     label: 'Pricing Simulator',
            //     path: 'pricing/recommendation/price-simulator/view/:id',
            //     id: 'psr',
            //     pageId: 'psrView',
            // },
            {
                label: 'Pricing Simulator',
                path: 'pricing/recommendation/pricing-simulator',
                id: 'psrV2', //update id in simulator context as well
                pageId: 'psrV2',
            },
            {
                label: 'Pricing Simulator',
                path: 'pricing/recommendation/pricing-simulator/:mode/:projectId/scenario/:scenarioId',
                id: 'psr',
                pageId: 'psrV2Update',
            },
            {
                label: 'Pricing Simulator',
                path: 'pricing/recommendation/pricing-simulator/:mode/:projectId/scenario/:scenarioId',
                id: 'psr',
                pageId: 'psrV2View',
            },
            {
                label: 'Pricing Analytics',
                path: 'pricing/recommendation/pricing-analytics',
                id: 'psa',
                pageId: 'psa', // pricing analytics
            },
            {
                label: 'Pricing Analytics',
                path: 'pricing/recommendation/pricing-analytics/:mode/:reportId',
                id: 'psa',
                pageId: 'psaUpdate', // pricing analytics update
            },
            {
                label: 'Pricing Analytics',
                path: 'pricing/recommendation/pricing-analytics/:mode/:reportId',
                id: 'psa',
                pageId: 'psaView', // pricing analytics view
            },
            {
                label: 'Best Weeks',
                path: 'promo/recommendation/best-weeks',
                id: 'bw',
                pageId: 'bw',
            },
        ],
        screens: [
            {
                label: 'Category Diagnostics',
                path: ['promo/category-diagnostics'],
                showSubHeader: false,
                options: {
                    Promo: [
                        {
                            label: 'Growth Analysis',
                            path: 'growth-analysis',
                            id: 'ga',
                        },
                        { label: 'Bump Report', path: 'bump-report', id: 'br' },
                    ],
                    visible: false,
                },
            },
            {
                label: 'Pricing Analytics',
                path: ['pricing/analytics', null],
                showSubHeader: false,
                options: {
                    Promo: [
                        {
                            label: 'Price Change',
                            path: 'price-change',
                            id: 'pcn',
                        },
                        { label: 'Price Point', path: 'price-point', id: 'pp' },
                        {
                            label: 'Price Ladder',
                            path: 'price-ladder',
                            id: 'pld',
                        },
                        { label: 'Price Curve', path: 'price-curve', id: 'pc' },
                        {
                            label: 'Price Tracking',
                            path: 'price-tracking',
                            id: 'pt',
                        },
                        {
                            label: 'Opportunity Identification',
                            path: 'opportunity-identification',
                            id: 'oi',
                        },
                    ],
                    visible: false,
                },
            },
            {
                label: 'Spend Analytics',
                path: ['promo/analytics', null],
                showSubHeader: false,
                options: {
                    Promo: [
                        {
                            label: 'Promo Scorecard',
                            path: 'promo-score-card',
                            id: 'ps',
                        },
                        {
                            label: 'Investment & ROI Tracker',
                            path: 'roi-tracker',
                            id: 'pl',
                        },
                        {
                            label: 'Promo ROI Analysis',
                            path: 'roi-analysis',
                            id: 'pa',
                        },
                    ],
                    visible: false,
                },
            },
            {
                label: 'Price & Promo Modeling',
                path: ['promo/recommendation', 'pricing/recommendation'],
                showSubHeader: true,
                options: {
                    Promo: [
                        { label: 'Promo Recommendation', path: 'promo-recommendation', id: 'pr' },
                        { label: 'Commercial Forecast', path: 'commercial-forecast', id: 'cf' },
                        {
                            label: 'Best Weeks',
                            path: 'best-weeks',
                            id: 'bw',
                        },
                    ],
                    Pricing: [{ label: 'Pricing Simulator', path: 'pricing-simulator', id: 'psrV2' }],
                    visible: false,
                },
            },
        ],
        globalFilter: {
            presetConfig: {
                disablePresetFilter: false,
                presetEnabledRoutes: {
                    all: true,
                },
            },
            availableFrequenciesList: [{ key: 'W', label: 'Week' }],
            globalFilterChangingRoutes: {
                'commercial-forecast': {
                    dimensionListKey: 'default',
                    getGlobalTimestampsKey: 'commercial_forecast',
                    getAttributeNamesKey: 'default',
                    // disabledAttributeTypes: ['manufacturer'],
                    defaultGlobalFilterObj: null,
                },
            },
            retainFiltersAcrossFeatures: false,
            limit: 50,
            selectionAllowed: {
                'promo-recommendation': {
                    dim2: {
                        Retailer: 1,
                    },
                },
            },
            allSelectedLimit: 15,
            timePeriodScreenMapping: {
                default: ['4W', '12W', '26W', '52W', '1M', '3M', '6M', '12M', '1Q', '2Q', '4Q', 'YTD', 'CUSTOM DATE'],
                'bump-report': ['52W', '104W', '156W', '1M', '3M', '6M', '12M', '1Q', '2Q', '4Q', 'YTD', 'CUSTOM DATE'],
                'commercial-forecast': [
                    '4W',
                    '12W',
                    '26W',
                    '52W',
                    '1M',
                    '3M',
                    '6M',
                    '12M',
                    '1Q',
                    '2Q',
                    '4Q',
                    'YTG',
                    'CUSTOM DATE',
                ],
            },

            defaultPeriod: ['52W'],
            applyFilterApiPostFormat: {
                jsonstring_dim1: '{}',
                jsonstring_dim2: '{}',
            },
            defaultPreviousIdObject: {
                dim1: ['attr', 'attr'],
                dim2: ['attr', 'attr'],
            },
            defaultIdObject: {
                dim1: { ids: [] },
                dim2: { ids: [] },
            },
            defaultAttrIdObject: {
                attr: {
                    dim1: { ids: [] },
                    dim2: { ids: [] },
                },
            },

            promoScoreCardDefault: {
                Category: 'COUGH, COLD & RESPIRATORY',
                Retailer: 'IRI All Outlets inc Chemists',
            },
            PromoScoreCardDefaultObj: {
                dim1: {
                    // Manufacturer: {
                    //     inclusion: [
                    //         {
                    //             dimension: 'dim1',
                    //             isActive: true,
                    //             attributeType: 'Manufacturer',
                    //             attributeDesc: 'PERRIGO',
                    //             attributeExId: 'PERRIGO',
                    //         },
                    //     ],
                    // },
                    Category: {
                        inclusion: [
                            {
                                dimension: 'dim1',
                                isActive: true,
                                attributeType: 'Category',
                                attributeDesc: 'COUGH, COLD & RESPIRATORY',
                                attributeExId: 'COUGH, COLD & RESPIRATORY',
                            },
                        ],
                    },
                },
                dim2: {
                    Retailer: {
                        inclusion: [
                            {
                                dimension: 'dim2',
                                isActive: true,
                                attributeType: 'Retailer',
                                attributeDesc: 'IRI All Outlets inc Chemists',
                                attributeExId: 'IRI All Outlets inc Chemists',
                            },
                        ],
                    },
                },
            },
        },
        priceSimulator: {
            allScenariosTableLimit: 500,
            a: 10,
            opportunityIdentificationTiles: [
                { key: 'recommendation', label: 'Recommendation' },
                { key: 'input', label: 'Input' },
                { key: 'output', label: 'Output' },
            ],
            cascadingColumns: ['COGS Rate', 'List Price', 'Everyday Retail Price'], // this should match with input key mapping and price simulator input columns
            levels: ['product', 'retailer'],
            inputKeyMapping: {
                // keep the order accuretly, to get it in multiselect
                cogs: 'COGS Rate',
                lp: 'List Price',
                rp: 'Everyday Retail Price',
                acv: 'ACV Distribution',
                oi: 'OI Rate',
                non_oi: 'Non OI Rate',
                promo_trade_spends: 'Promo Trade Rate Spends',
                tr: 'Trade Rate',
                cf: 'Comp Follow',
            },
            outputKeyMapping: {
                gsv: {
                    label: 'GSV',
                    pre: '£',
                    pos: '',
                },
                nsv: {
                    label: 'NSV',
                    pre: '£',
                    pos: '',
                },
                volume: {
                    label: 'Volume',
                    pre: '£',
                    pos: '',
                },
                rsv: {
                    label: 'RSV',
                    pre: '£',
                    pos: '',
                },
                rtMg: {
                    label: 'Retail Margin %',
                    pre: '',
                    pos: '%',
                },
                gmac: {
                    label: 'GMAC',
                    pre: '£',
                    pos: '',
                },
                units: {
                    label: 'Units',
                    pre: '£',
                    pos: '',
                },
                rsvMkSh: {
                    label: 'RSV Mkt Share',
                    pre: '£',
                    pos: '',
                },
                vlmMkSh: {
                    label: 'Volume Mkt Share',
                    pre: '',
                    pos: '%',
                },
                gsvMkSh: {
                    label: 'GSV Mkt Share',
                    pre: '',
                    pos: '%',
                },
                vlmChg: {
                    label: 'Volume Chg %',
                    pre: '',
                    pos: '%',
                },
                rtPfChg: {
                    label: 'Retail Profit % Chg',
                    pre: '',
                    pos: '%',
                },
                rMgChg: {
                    label: 'Retail Margin % Chg',
                    pre: '',
                    pos: '%',
                },
                netRpChg: {
                    label: 'Net Effective Price % Chg',
                    pre: '',
                    pos: '%',
                },
            },
            recommendationKeyMapping: {
                recommended_list_price: {
                    label: 'New Recommendation Price',
                    pre: '£',
                    pos: '',
                },
                role: {
                    label: 'Role',
                    pre: '',
                    pos: '',
                },
                strategy: {
                    label: 'Strategy',
                    pre: '',
                    pos: '',
                },
                mix: {
                    label: 'Mix',
                    pre: '',
                    pos: '',
                },
                growth: {
                    label: 'Growth',
                    pre: '',
                    pos: '',
                },
                gap: {
                    label: 'Gap',
                    pre: '',
                    pos: '',
                },
                cogs_realization: {
                    label: 'COGS & Realization',
                    pre: '',
                    pos: '',
                },
                cogs: {
                    label: 'COGs',
                    pre: '',
                    pos: '%',
                },
                list_to_retail: {
                    label: 'List to Retail',
                    pre: '',
                    pos: '',
                },
                bpe: {
                    label: 'BPE',
                    pre: '',
                    pos: '',
                },
                ppe: {
                    label: 'PPE',
                    pre: '',
                    pos: '',
                },
                margin: {
                    label: 'Margin',
                    pre: '',
                    pos: '',
                },
                growth_vs_category: {
                    label: 'Gowth vs Category',
                    pre: '',
                    pos: '%',
                },
                pl_vs_category: {
                    label: 'PL vs Category',
                    pre: '',
                    pos: '%',
                },
                threshold: {
                    label: 'Threshold',
                    pre: '',
                    pos: '',
                },
                comp_index: {
                    label: 'Comp. Index',
                    pre: '',
                    pos: '',
                },
                curve_index: {
                    label: 'Curve Index',
                    pre: '',
                    pos: '',
                },
            },
            defaultKpiMetrics: [1, 2, 3, 4, 5],
            kpiMetrics: [
                {
                    key: 1,
                    value: 'volume_sales',
                    name: 'Volume Sales',
                    pre: '',
                    post: '',
                },
                {
                    key: 2,
                    value: 'value_sales',
                    name: 'Value Sales (£)',
                    pre: '£',
                    post: '',
                },
                {
                    key: 3,
                    value: 'profit_abs',
                    name: 'Profit Abs (£)',
                    pre: '£',
                    post: '',
                },
                {
                    key: 4,
                    value: 'margin_percent',
                    name: 'Margin (%)',
                    pre: '',
                    post: '%',
                },
                {
                    key: 5,
                    value: 'trade_rate_percent',
                    name: 'Trade Rate (%)',
                    pre: '',
                    post: '%',
                },

                {
                    key: 6,
                    value: 'retailer_margin_percent',
                    name: 'Retailer Margin (%)',
                    pre: '',
                    post: '%',
                },
                {
                    key: 7,
                    value: 'gross_profit',
                    name: 'Gross Profit (£)',
                    pre: '£',
                    post: '',
                },
                {
                    key: 8,
                    value: 'retailer_profit',
                    name: 'Retailer Profit (£)',
                    pre: '£',
                    post: '',
                },
                {
                    key: 9,
                    value: 'net_retail_price_change',
                    name: 'Net Retailer Price % Chg',
                    pre: '',
                    post: '%',
                },
            ],
        },
        pricingSimulator: {
            enableAnalyticsTab: true,
            enableBulkUpload: false,
            indexPageTableLimit: 50,
            scenarioFilterOffsetLimit: 50,
            scenarioPerProjectLimit: 10,
            scenarioTableLimit: 500,
            analyticsChartLimit: 100,
            comparisonTableLimit: 50,
            dimAttributesLimit: 4,
            characterLimit: {
                kpiTileCharLimit: 22,
                kpiCompareCardLimit: 30,
            },
            enablePrivatePublicToggle: false,
            enableMicroInfoForTables: false,
            enableOneChangeAnalyticsChart: false,
            defaultGlobalKpiCount: 6,
            disableExport: false,
            indexTableFixedColumns: [
                { label: 'Project Name', key: 'projectName', sortKey: 'project_name' },
                { label: 'Created By', key: 'createdBy', sortKey: 'created_by' },
                { label: 'Status', key: 'status' },
                { label: 'Last Updated', key: 'lastUpdated', sortKey: 'updated_at' },
                { label: 'Simulation Period', key: 'simulationPeriod' },
                { label: 'Price Effective Date', key: 'priceEffectiveDate' },
            ],
            analyticsBaseScenarioFixedColumns: [
                { label: 'Project Name', key: 'projectName', sortKey: 'project_name' },
                { label: 'Created By', key: 'createdBy', sortKey: 'created_by' },
                { label: 'Status', key: 'status' },
            ],
            analyticsTableColumns: [
                { label: 'Report Name', key: 'reportName', sortKey: 'report_name' },
                { label: 'Base Scenario', key: 'baseScenario', sortKey: 'base_scenario' },
                { label: 'Created By', key: 'createdBy', sortKey: 'created_by' },
                { label: 'Last Updated', key: 'lastUpdated', sortKey: 'updated_at' },
                { label: 'Date Created', key: 'dateCreated', sortKey: 'created_at' },
            ],
            projectStatuses: {
                ACTIVE: { label: 'Active', colorType: 'success' },
                DRAFT: { label: 'Draft', colorType: 'processing' },
                SETUP: { label: 'Setup', colorType: 'processing' },
                IN_PROGRESS: { label: 'In-Progress', colorType: 'processing' },
                EXPIRED: { label: 'Expired', colorType: 'default' },
                ERROR: { label: 'Error', colorType: 'error' },
                INVALID: { label: 'Invalid', colorType: 'error' },
            },
            projectDataSource: [{ label: 'Projected', value: 'depletion_data' }],
            simulatedPeriodItems: [
                { label: 'Custom Date', value: 'custom_date', dateArray: null },
                { label: 'Current Year', value: 'current_year', dateArray: ['01-05-2025', '12-28-2025'] },
                // { label: 'Financial Year', value: 'financial_year', dateArray: ['03-03-2024', '02-23-2025'] },
            ],
            iconsMappings: {
                Elasticity: 'BorderOuterOutlined',
                BaseInput: 'BorderlessTableOutlined',
                COGS: 'DollarOutlined',
                Distributor: 'BuildOutlined',
                'Distributor P&L': 'BuildOutlined',
                FOB: 'ClusterOutlined',
                'P&L': 'LineChartOutlined',
                Price: 'MoneyCollectOutlined',
                Promotions: 'BoxPlotOutlined',
                'Retailer P&L': 'LineChartOutlined',
                Sales: 'AreaChartOutlined',
                Taxes: 'BlockOutlined',
                Volume: 'ExperimentOutlined',
                Others: 'UngroupOutlined',
                Product: 'GoldOutlined',
                Geo: 'ExpandOutlined',
                'Dollar Impact': 'DollarOutlined',
                'Standard Increase Metrics': 'ToTopOutlined',
                'EQV Metrics': 'BlockOutlined',
            },
            categoryMovementKpis: [
                { label: 'Volume Impact', value: 'volume', yAxisLabel: 'Vol', xAxisLabel: 'Retailer Vol' },
                { label: 'Sales Impact', value: 'sales', yAxisLabel: 'Sales £', xAxisLabel: 'Retailer Sales £' },
            ],
        },
        priceChange: {
            // TODO: remove unwanted props
            limit: 60,
            dimensionConfig: {
                //snake case eg sub_category
                excludedDimensions: [],
                defaultDimension: 'Manufacturer',
            },
            hiddenTableRows: [],
            timePeriodOptions: [
                { label: 'YA', value: 'year_ago' },
                { label: 'Prior Period', value: 'prior_period' },
                { label: 'Custom Period', value: 'custom' },
            ],
            absTileData: [
                { key: 'abs', label: 'Abs' },
                { key: 'percentage', label: '%' },
            ],
            kpiListData: [
                {
                    key: 'avg_price',
                    label: 'Avg Price',
                    value: 'average',
                    dataKey: 'avg_price',
                },
                {
                    key: 'base_price',
                    label: 'Regular Price',
                    value: 'base',
                    dataKey: 'base_price',
                },
            ],
            volTileData: [
                {
                    key: 'units',
                    label: 'Per Unit',
                    value: 'units',
                    dataKey: 'units',
                    tooltip: 'Per Unit',
                },
                // { key: 'vol', label: 'PEQ', value: 'vol', dataKey: 'volume', tooltip: 'Per Eq Volume' },
            ],
            salesTileData: [
                { key: 'sales', label: 'Sales' },
                { key: 'incremental', label: 'Incremental' },
                { key: 'promo', label: 'Promo' },
            ],
            salesAttributionChart: {
                colorList: ['#10AB5E', '#DC3826'],
                colorListType2: ['#758BEE', '#758BEE'],
                profitPoolColor: ['#826FD0', '#826FD0'],
                backGroundColor: 'rgba(0, 0, 0, 0.02)',
            },
            salesAttributionDrillDownChartKeyValueMapping: {
                'feature_&_display': 'Feature & Display',
                'Feature & Display': 'feature_&_display',
            },
            salesAttributionChart2Limit: 20,
        },
        growthAnalysis: {
            limit: 60,
            includeAggPeriod: false,
            dimensionConfig: {
                //snake case eg sub_category
                excludedDimensions: [],
                defaultDimension: 'Manufacturer',
            },
            absTileData: [
                { key: 'abs', label: 'Abs' },
                { key: 'percentage', label: '%' },
            ],
            subTileData: [
                {
                    label: 'Per Unit',
                    key: 'PU',
                },
                {
                    label: 'PEQ',
                    key: 'PEQ',
                },
            ],
            volTileData: [
                // { key: 'vol', label: 'Eq Volume', value: 'vol', dataKey: 'volume' },
                { key: 'val', label: 'Value', value: 'val', dataKey: 'value' },
                {
                    key: 'units',
                    label: 'Units',
                    value: 'units',
                    dataKey: 'units',
                },
                // { key: 'profit', label: 'Profit', value: 'profit', dataKey: 'profit' },
            ],
            showTotal: true,
            currentYearLabel: 'CY',
            yearAgoLabel: 'YA',
            trendChartDropdownData: [
                {
                    key: 'sales_volume',
                    label: 'Sales Volume',
                    value: 'sales_volume',
                    dataKey: 'sales_volume',
                },
                {
                    key: 'sales',
                    label: 'Sales £',
                    value: 'sales',
                    dataKey: 'sales',
                },
                {
                    key: 'average_price',
                    label: 'Average Price',
                    value: 'average_price',
                    dataKey: 'average_price',
                },
                {
                    key: 'base_price',
                    label: 'Base Price',
                    value: 'base_price',
                    dataKey: 'base_price',
                },
                { key: 'acv', label: '%ACV', value: 'acv', dataKey: 'acv' },
                {
                    key: 'avg_items',
                    label: 'Avg. no. of items',
                    value: 'avg_items',
                    dataKey: 'avg_items',
                },
                { key: 'tdp', label: 'TDP', value: 'tdp', dataKey: 'tdp' },
            ],
            salesTileData: [
                { key: 'sales', label: 'Sales' },
                { key: 'incremental', label: 'Incremental' },
                { key: 'promo', label: 'Promo' },
            ],
            graphExportHeaderMapping: {
                promo: ['Non-promo', 'Promo'],
                incremental: ['Base', 'Incremental'],
                sales: ['Sales Change'],
            },
            depletionDropdownData: [
                {
                    value: 'frontline_sales',
                    dataKey: 'frontline_sales',
                    key: 'frontline_sales',
                    label: 'Frontline Sales',
                },
                {
                    value: 'net_sales',
                    dataKey: 'net_sales',
                    key: 'net_sales',
                    label: 'Net Sales',
                },
            ],
            tableKeyUnitMapping: {
                'Market Share CY': {
                    unit: '%',
                    label: 'Market Share CY',
                    includePercentageChange: false,
                },
                'Market Share YA': {
                    unit: '%',
                    label: 'Market Share YA',
                    includePercentageChange: false,
                },
                'ACV CY': {
                    unit: '%',
                    label: 'Wtd. Avg ACV %',
                    includePercentageChange: false,
                },
                'ACV YA': {
                    unit: '%',
                    label: 'Wtd. Avg ACV % YA',
                    includePercentageChange: false,
                },
            },
            salesAttributionChart: {
                colorList: ['#10AB5E', '#DC3826'],
                colorListType2: ['#758BEE', '#758BEE'],
                profitPoolColor: ['#826FD0', '#826FD0'],
                backGroundColor: 'rgba(0, 0, 0, 0.02)',
            },
            salesAttributionDrillDownChartKeyValueMapping: {
                'feature_&_display': 'Feature & Display',
                'Feature & Display': 'feature_&_display',
            },
            salesAttributionChart2DisabledItems: ['unexplained'],
            salesAttributionChart2Limit: 50,
        },
        //BUMP REPORT
        bumpReport: {
            mainHeader: 'Bump Report',
            groupByKey: 'groupBy',
            comparisonTileData: [
                { key: 'cy_vs_ya', label: 'CY vs YA' },
                { key: 'difference', label: 'Difference' },
            ],
            enablePromoCalender: true,
            isPromoUpliftPercentValue: false,
            volGroupByOptionsMapping: {
                // vol: [
                //     { value: 'total_eq_volume', label: 'Total EQ Volume', index: 1 },
                //     { value: 'any_promo_eq_volume', label: 'Any promo EQ Volume', index: 1 },
                //     { value: 'no_promo_eq_volume', label: 'No Promo EQ Volume', index: 1 },

                //     { value: 'base_eq_volume', label: 'Base EQ Volume', index: 0 },
                //     { value: 'incremental_eq_volume', label: 'Incremental EQ Volume Total', index: 0 },
                //     { value: 'tpr_incremental_eq_volume', label: 'Incremental EQ Volume TPR', index: 0 },
                //     { value: 'feature_incremental_eq_volume', label: 'Incremental EQ Volume Feature', index: 0 },
                //     { value: 'display_incremental_eq_volume', label: 'Incremental EQ Volume Display', index: 0 },
                //     {
                //         value: 'feature_and_display_incremental_eq_volume',
                //         label: 'Incremental EQ Volume Feature & Display',
                //         index: 0,
                //     },
                // ],
                val: [
                    { value: 'total_value', label: 'Total Value', index: 1 },
                    {
                        value: 'any_promo_value',
                        label: 'Any Promo Value',
                        index: 1,
                    },
                    {
                        value: 'no_promo_value',
                        label: 'No Promo Value',
                        index: 1,
                    },
                    { value: 'base_value', label: 'Regular Value', index: 0 },
                    {
                        value: 'incremental_value',
                        label: 'Incremental Value Total',
                        index: 0,
                    },
                    {
                        value: 'tpr_incremental_value',
                        label: 'Price Cut Incremental Value',
                        index: 0,
                    },
                    {
                        value: 'feature_incremental_value',
                        label: 'On Shelf Incremental Value',
                        index: 0,
                    },
                    {
                        value: 'display_incremental_value',
                        label: 'Off Shelf Incremental Value',
                        index: 0,
                    },
                    {
                        value: 'feature_and_display_incremental_value',
                        label: 'Special Pack Incremental Value',
                        index: 0,
                    },
                ],
                units: [
                    { value: 'total_units', label: 'Total Units', index: 1 },
                    {
                        value: 'any_promo_units',
                        label: 'Any Promo Units',
                        index: 1,
                    },
                    {
                        value: 'no_promo_units',
                        label: 'No Promo Units',
                        index: 1,
                    },
                    { value: 'base_units', label: 'Regular Units', index: 0 },
                    {
                        value: 'incremental_units',
                        label: 'Incremental Units Total',
                        index: 0,
                    },
                    {
                        value: 'tpr_incremental_units',
                        label: 'Price Cut Incremental Units',
                        index: 0,
                    },
                    {
                        value: 'feature_incremental_units',
                        label: 'On Shelf Incremental Units',
                        index: 0,
                    },
                    {
                        value: 'display_incremental_units',
                        label: 'Off Shelf Incremental Units',
                        index: 0,
                    },
                    {
                        value: 'feature_and_display_incremental_units',
                        label: 'Special Pack Incremental Units',
                        index: 0,
                    },
                ],
            },
            tooltipKeyLabelMapping: {
                increments: 'Incremental',
                promo: 'Any Promo',
            },
            bumpReportTileData: [
                { key: 'increments', label: 'Attribution' },
                { key: 'promo', label: 'Consumption' },
                { key: 'groupBy', label: 'Group By' },
            ],
            bumpReportTile1Data: [
                {
                    key: 'promo',
                    label: 'Promotions',
                    visibleTabs: ['increments', 'promo', 'groupBy'],
                }, //keys should match bumpReportTileData keys
                {
                    key: 'media',
                    label: 'Media',
                    visibleTabs: ['increments', 'groupBy'],
                }, //keys should match bumpReportTileData keys
            ],
            bumpReportTile2Data: [
                { key: 'total', label: 'Total' },
                { key: 'breakout', label: 'Breakout' },
            ],
            absTileData: [
                { key: 'abs', label: 'Abs' },
                { key: 'percentage', label: '%' },
            ],

            volTileData: [
                // { key: 'vol', label: 'Eq Volume', dataKey: 'volume' },
                { key: 'val', label: 'Value', dataKey: 'value' },
                { key: 'units', label: 'Units', dataKey: 'units' },
            ],
            bumpChartY2Colors: [
                '#293BB8',
                '#DD449F',
                '#9E5897',
                '#19669D',
                '#43C9E2',
                '#37C7BE',
                '#00798C',
                '#E8A122',
                '#E06936',
                '#A5582D',
            ],
            bumpChartY2AxisOptions: {
                // vol: [
                //     { value: 'avg_price_per_eq', index: 0, label: 'Avg. Price/EQ', unit: '' },
                //     { value: 'base_price_per_eq', index: 0, label: 'Base Price/EQ', unit: '' },
                //     { value: 'promo_price_per_eq', index: 0, label: 'Promo Price/EQ', unit: '' },
                //     { value: 'distribution_tdp', index: 0, label: 'Distribution TDP', unit: '' },
                //     { value: 'display_tdp', index: 0, label: 'Display TDP', unit: '' },
                //     { value: 'feature_tdp', index: 0, label: 'Feature TDP', unit: '' },
                //     { value: 'feature_and_display_tdp', index: 0, label: 'Feature and Display TDP', unit: '' },
                //     { value: 'unit_velocity', index: 0, label: 'Unit Velocity', unit: '' },
                //     { value: 'sales_velocity', index: 0, label: 'Dollar Velocity', unit: '£' },
                //     { value: 'volume_velocity', index: 0, label: 'Eq Velocity', unit: '' },
                // ],
                val: [
                    {
                        value: 'avg_price_per_unit',
                        index: 0,
                        label: 'Avg. Price/Unit (£)',
                        unit: '',
                    },
                    {
                        value: 'base_price_per_unit',
                        index: 0,
                        label: 'Regular Price/Unit',
                        unit: '',
                    },
                    {
                        value: 'promo_price_per_unit',
                        index: 0,
                        label: 'Promo Price/Unit',
                        unit: '',
                    },
                    {
                        value: 'market_share_value',
                        index: 0,
                        label: 'Market Share %',
                        unit: '',
                    },
                    {
                        value: 'distribution_tdp',
                        index: 0,
                        label: 'Distribution TDP',
                        unit: '',
                    },
                    {
                        value: 'display_tdp',
                        index: 0,
                        label: 'Off Shelf TDP',
                        unit: '',
                    },
                    {
                        value: 'feature_tdp',
                        index: 0,
                        label: 'On Shelf TDP',
                        unit: '',
                    },
                    {
                        value: 'feature_and_display_tdp',
                        index: 0,
                        label: 'Special Pack TDP',
                        unit: '',
                    },
                    {
                        value: 'distribution_acv',
                        index: 0,
                        label: 'Distribution ACV %',
                        unit: '',
                    },
                    {
                        value: 'display_acv',
                        index: 0,
                        label: 'Off Shelf ACV %',
                        unit: '',
                    },
                    {
                        value: 'feature_acv',
                        index: 0,
                        label: 'On Shelf ACV %',
                        unit: '',
                    },
                    {
                        value: 'feature_and_display_acv',
                        index: 0,
                        label: 'Special Pack ACV %',
                        unit: '',
                    },
                    {
                        value: 'cwd_weighted_distribution',
                        index: 0,
                        label: 'CWD weighted distribution',
                        unit: '',
                    },
                    {
                        value: 'unit_velocity',
                        index: 0,
                        label: 'Unit Velocity',
                        unit: '',
                    },
                    {
                        value: 'sales_velocity',
                        index: 0,
                        label: 'Value Velocity',
                        unit: '£',
                    },
                    {
                        value: 'subsidized_base_sales',
                        index: 0,
                        label: 'Subsidized Base Sales',
                        unit: '',
                    },
                    // { value: 'volume_velocity', index: 0, label: 'Eq Velocity', unit: '' },
                ],
                units: [
                    {
                        value: 'avg_price_per_unit',
                        index: 0,
                        label: 'Avg. Price/Unit (£)',
                        unit: '',
                    },
                    {
                        value: 'base_price_per_unit',
                        index: 0,
                        label: 'Regular Price/Unit',
                        unit: '',
                    },
                    {
                        value: 'promo_price_per_unit',
                        index: 0,
                        label: 'Promo Price/Unit',
                        unit: '',
                    },
                    {
                        value: 'market_share_units',
                        index: 0,
                        label: 'Market Share %',
                        unit: '',
                    },
                    {
                        value: 'distribution_tdp',
                        index: 0,
                        label: 'Distribution TDP',
                        unit: '',
                    },
                    {
                        value: 'display_tdp',
                        index: 0,
                        label: 'Off Shelf TDP',
                        unit: '',
                    },
                    {
                        value: 'feature_tdp',
                        index: 0,
                        label: 'On Shelf TDP',
                        unit: '',
                    },
                    {
                        value: 'feature_and_display_tdp',
                        index: 0,
                        label: 'Special Pack TDP',
                        unit: '',
                    },
                    {
                        value: 'distribution_acv',
                        index: 0,
                        label: 'Distribution ACV %',
                        unit: '',
                    },
                    {
                        value: 'display_acv',
                        index: 0,
                        label: 'Off Shelf ACV %',
                        unit: '',
                    },
                    {
                        value: 'feature_acv',
                        index: 0,
                        label: 'On Shelf ACV %',
                        unit: '',
                    },
                    {
                        value: 'feature_and_display_acv',
                        index: 0,
                        label: 'Special Pack ACV %',
                        unit: '',
                    },
                    {
                        value: 'cwd_weighted_distribution',
                        index: 0,
                        label: 'CWD weighted distribution',
                        unit: '',
                    },
                    {
                        value: 'unit_velocity',
                        index: 0,
                        label: 'Unit Velocity',
                        unit: '',
                    },
                    {
                        value: 'sales_velocity',
                        index: 0,
                        label: 'Value Velocity',
                        unit: '£',
                    },
                    {
                        value: 'subsidized_base_sales',
                        index: 0,
                        label: 'Subsidized Base Sales',
                        unit: '',
                    },
                    // { value: 'volume_velocity', index: 0, label: 'Eq Velocity', unit: '' },
                ],
            },
            promoTypeColorMapping: {
                'tpr/scan': {
                    label: 'Price Cut',
                    color: colorConstants.lightGreenAlt,
                },
                'feature ad': {
                    label: 'Price Cut & On Shelf',
                    color: colorConstants.darkGreenAlt2,
                },
                display: { label: 'Off Shelf', color: colorConstants.pinkAlt },
                feature_display_tpr: {
                    label: 'Special Pack',
                    color: colorConstants.orangeAlt2,
                },
                cinema: {
                    label: 'Cinema',
                    color: colorConstants.lightGreenAlt,
                }, // media types starts here
                digital: { label: 'Digital', color: colorConstants.violetAlt2 },
                'direct mail': {
                    label: 'Direct Mail',
                    color: colorConstants.violetAlt3,
                },
                outdoor: { label: 'Outdoor', color: colorConstants.purpleAlt1 },
                press: { label: 'Press', color: colorConstants.pinkAlt2 },
                radio: { label: 'Radio', color: colorConstants.orangeAlt3 },
                tv: { label: 'TV', color: colorConstants.yellow },
                // display_tpr: { label: 'Display_TPR', color: colorConstants.darkBlueAlt },
            },
            stackedColors: [
                colorConstants.lightGreenAlt,
                colorConstants.darkGreenAlt2,
                colorConstants.pinkAlt,
                colorConstants.orangeAlt2,
                colorConstants.darkYellow,
            ],
            fieldKeyLabelMapping: {
                base_eq_volume: {
                    label: 'Regular Sales (Eq Vol)',
                    color: colorConstants.darkYellow,
                    tableLabel: 'Regular',
                },
                base_value: {
                    label: 'Regular Sales (£)',
                    color: colorConstants.darkYellow,
                    tableLabel: 'Regular',
                },
                base_units: {
                    label: 'Regular Units',
                    color: colorConstants.darkYellow,
                    tableLabel: 'Regular',
                },
                incremental_eq_volume: {
                    label: 'Incremental Sales (Eq Vol)',
                    color: colorConstants.darkGreenAlt2,
                    tableLabel: 'Incremental',
                },
                incremental_value: {
                    label: 'Promotion Sales (£)',
                    color: colorConstants.lightGreenAlt,
                    tableLabel: 'Promotion',
                },
                tpr_incremental_eq_volume: {
                    label: 'Price Cut & On Shelf',
                    color: colorConstants.lightGreenAlt,
                    tableLabel: 'Price Cut & On Shelf',
                },
                feature_incremental_eq_volume: {
                    label: 'On Shelf',
                    color: colorConstants.darkGreenAlt2,
                    tableLabel: 'On Shelf',
                },
                display_incremental_eq_volume: {
                    label: 'Off Shelf',
                    color: colorConstants.pinkAlt,
                    tableLabel: 'Off Shelf',
                },
                feature_and_display_incremental_eq_volume: {
                    label: 'Special Pack',
                    color: colorConstants.orangeAlt2,
                    tableLabel: 'Special Pack',
                },
                tpr_incremental_value: {
                    label: 'Price Cut & On Shelf',
                    color: colorConstants.lightGreenAlt,
                    tableLabel: 'Price Cut & On Shelf',
                },
                feature_incremental_value: {
                    label: 'On Shelf',
                    color: colorConstants.darkGreenAlt2,
                    tableLabel: 'On Shelf',
                },
                display_incremental_value: {
                    label: 'Off Shelf',
                    color: colorConstants.pinkAlt,
                    tableLabel: 'Off Shelf',
                },
                incremental_units: {
                    label: 'Promotion Units',
                    color: colorConstants.lightGreenAlt,
                    tableLabel: 'Promotion',
                },
                feature_and_display_incremental_value: {
                    label: 'Special Pack',
                    color: colorConstants.orangeAlt2,
                    tableLabel: 'Special Pack',
                },
                tpr_incremental_units: {
                    label: 'Price Cut & On Shelf',
                    color: colorConstants.lightGreenAlt,
                    tableLabel: 'Price Cut & On Shelf',
                },
                feature_incremental_units: {
                    label: 'On Shelf',
                    color: colorConstants.darkGreenAlt2,
                    tableLabel: 'On Shelf',
                },
                display_incremental_units: {
                    label: 'Off Shelf',
                    color: colorConstants.pinkAlt,
                    tableLabel: 'Off Shelf',
                },
                feature_and_display_incremental_units: {
                    label: 'Special Pack',
                    color: colorConstants.orangeAlt2,
                    tableLabel: 'Special Pack',
                },
                incremental_total_units: {
                    label: 'Promotions',
                    color: colorConstants.lightGreenAlt,
                    tableLabel: 'Promotions',
                },
                incremental_total_value: {
                    label: 'Promotions',
                    color: colorConstants.lightGreenAlt,
                    tableLabel: 'Promotions',
                },
                media_incremental_value: {
                    label: 'Media',
                    color: colorConstants.darkGreenAlt3,
                    tableLabel: 'Media',
                },
                media_incremental_units: {
                    label: 'Media',
                    color: colorConstants.darkGreenAlt3,
                    tableLabel: 'Media',
                },
                tpr_only_eq_volume: {
                    label: 'Price Cut & On Shelf',
                    color: colorConstants.lightGreenAlt,
                    tableLabel: 'Price Cut & On Shelf',
                },
                tpr_only_value: {
                    label: 'Price Cut & On Shelf',
                    color: colorConstants.lightGreenAlt,
                    tableLabel: 'Price Cut & On Shelf',
                },
                feature_only_eq_volume: {
                    label: 'On Shelf',
                    color: colorConstants.darkGreenAlt2,
                    tableLabel: 'On Shelf',
                },
                feature_only_value: {
                    label: 'On Shelf',
                    color: colorConstants.darkGreenAlt2,
                    tableLabel: 'On Shelf',
                },
                display_only_eq_volume: {
                    label: 'Off Shelf',
                    color: colorConstants.pinkAlt,
                    tableLabel: 'Off Shelf',
                },
                display_only_value: {
                    label: 'Off Shelf',
                    color: colorConstants.pinkAlt,
                    tableLabel: 'Off Shelf',
                },
                feature_and_display_only_eq_volume: {
                    label: 'Special Pack',
                    color: colorConstants.orangeAlt2,
                    tableLabel: 'Special Pack',
                },
                feature_and_display_only_value: {
                    label: 'Special Pack',
                    color: colorConstants.orangeAlt2,
                    tableLabel: 'Special Pack',
                },
                no_promo_eq_volume: {
                    label: 'Non Promo',
                    color: colorConstants.darkYellow,
                    tableLabel: 'Non Promo',
                },
                no_promo_value: {
                    label: 'Non Promo',
                    color: colorConstants.darkYellow,
                    tableLabel: 'Non Promo',
                },
                any_promo_value: {
                    label: 'Promo',
                    color: colorConstants.lightGreenAlt,
                    tableLabel: 'Promo',
                },
                tpr_only_units: {
                    label: 'Price Cut & On Shelf',
                    color: colorConstants.lightGreenAlt,
                    tableLabel: 'Price Cut & On Shelf',
                },
                feature_only_units: {
                    label: 'On Shelf',
                    color: colorConstants.darkGreenAlt2,
                    tableLabel: 'On Shelf',
                },
                display_only_units: {
                    label: 'Off Shelf',
                    color: colorConstants.pinkAlt,
                    tableLabel: 'Off Shelf',
                },
                feature_and_display_only_units: {
                    label: 'Special Pack',
                    color: colorConstants.orangeAlt2,
                    tableLabel: 'Special Pack',
                },

                no_promo_units: {
                    label: 'Non Promo',
                    color: colorConstants.darkYellow,
                    tableLabel: 'Non Promo',
                },
                any_promo_units: {
                    label: 'Promo',
                    color: colorConstants.lightGreenAlt,
                    tableLabel: 'Promo',
                },
                promo_only_total_value: {
                    label: 'Promotions',
                    color: colorConstants.lightGreenAlt,
                    tableLabel: 'Promotions',
                },
                promo_only_total_units: {
                    label: 'Promotions',
                    color: colorConstants.lightGreenAlt,
                    tableLabel: 'Promotions',
                },
                tv_value: {
                    label: 'TV',
                    color: colorConstants.orangeAlt2,
                    tableLabel: 'TV',
                }, // media types starts here
                tv_units: {
                    label: 'TV',
                    color: colorConstants.orangeAlt2,
                    tableLabel: 'TV',
                },
                cinema_value: {
                    label: 'Cinema',
                    color: colorConstants.lightGreenAlt1,
                    tableLabel: 'Cinema',
                },
                cinema_units: {
                    label: 'Cinema',
                    color: colorConstants.lightGreenAlt1,
                    tableLabel: 'Cinema',
                },
                digital_units: {
                    label: 'Digital',
                    color: colorConstants.darkGreenAlt2,
                    tableLabel: 'Digital',
                },
                digital_value: {
                    label: 'Digital',
                    color: colorConstants.darkGreenAlt2,
                    tableLabel: 'Digital',
                },
                directmail_value: {
                    label: 'Direct mail',
                    color: colorConstants.darkGreenAlt3,
                    tableLabel: 'Direct mail',
                },
                directmail_units: {
                    label: 'Direct mail',
                    color: colorConstants.darkGreenAlt3,
                    tableLabel: 'Direct mail',
                },
                outdoor_units: {
                    label: 'Outdoor',
                    color: colorConstants.purpleAlt,
                    tableLabel: 'Outdoor',
                },
                outdoor_value: {
                    label: 'Outdoor',
                    color: colorConstants.purpleAlt,
                    tableLabel: 'Outdoor',
                },
                press_value: {
                    label: 'Press',
                    color: colorConstants.pinkAlt,
                    tableLabel: 'Press',
                },
                press_units: {
                    label: 'Press',
                    color: colorConstants.pinkAlt,
                    tableLabel: 'Press',
                },
                radio_units: {
                    label: 'Radio',
                    color: colorConstants.orangeAlt1,
                    tableLabel: 'Radio',
                },
                radio_value: {
                    label: 'Radio',
                    color: colorConstants.orangeAlt1,
                    tableLabel: 'Radio',
                },

                //for export label
                sales_year_ago: { label: 'YA Sales' },
                total_value: { label: 'Total' },
                media_incremental_value_percentage: {
                    label: 'Media Percentage',
                },
                media_incremental_units_percentage: {
                    label: 'Media Percentage',
                },
                incremental_value_percentage: {
                    label: 'Promotion Sales Percentage',
                },
                incremental_units_percentage: {
                    label: 'Promotion Sales Percentage',
                },
                base_value_percentage: { label: 'Regular Sales Percentage' },
                base_units_percentage: { label: 'Regular Sales Percentage' },
                tpr_incremental_value_percentage: {
                    label: 'Price Cut & On Shelf Percentage',
                },
                tpr_incremental_units_percentage: {
                    label: 'Price Cut & On Shelf Percentage',
                },
                tpr_only_value_percentage: {
                    label: 'Price Cut & On Shelf Percentage',
                },
                tpr_only_units_percentage: {
                    label: 'Price Cut & On Shelf Percentage',
                },
                feature_incremental_value_percentage: {
                    label: 'On Shelf Percentage',
                },
                feature_incremental_units_percentage: {
                    label: 'On Shelf Percentage',
                },
                feature_only_value_percentage: { label: 'On Shelf Percentage' },
                feature_only_units_percentage: { label: 'On Shelf Percentage' },
                display_incremental_value_percentage: {
                    label: 'Off Shelf Percentage',
                },
                display_incremental_units_percentage: {
                    label: 'Off Shelf Percentage',
                },
                display_only_value_percentage: {
                    label: 'Off Shelf Percentage',
                },
                display_only_units_percentage: {
                    label: 'Off Shelf Percentage',
                },
                feature_and_display_incremental_value_percentage: {
                    label: 'Special Pack Percentage',
                },
                feature_and_display_incremental_units_percentage: {
                    label: 'Special Pack Percentage',
                },
                feature_and_display_only_value_percentage: {
                    label: 'Special Pack Percentage',
                },
                feature_and_display_only_units_percentage: {
                    label: 'Special Pack Percentage',
                },
                no_promo_value_percentage: { label: 'Non Promo Percentage' },
                no_promo_units_percentage: { label: 'Non Promo Percentage' },
            },
            tooltipExtraItems: {
                tpr_acv: { label: 'Price Cut ACV %' },
                display_acv: { label: 'Off Shelf ACV %' },
                feature_acv: { label: 'On Shelf ACV %' },
                feature_and_display_acv: { label: 'Special Pack ACV %' },
                uplift: { label: 'Uplift' },
                promo_lift: { label: 'Promo Uplift' },
                media_lift: { label: 'Media Uplift' },
            },
            promoCalenderAttributeLevels: {
                promo: [
                    { value: 'product', label: 'Product' },
                    { value: 'retailer', label: 'Retailer' },
                ],
                media: [{ value: 'sub_brand', label: 'Sub Brand' }],
            },
            overlayKeys: {
                promo: [
                    { label: 'Start Week', dataKey: 'startTimestamp' },
                    { label: 'End Week', dataKey: 'endTimestamp' },
                    { label: 'Product', dataKey: 'product' },
                    { label: 'Promo Mechanics', dataKey: 'promoMech' },
                    { label: 'Promo Type', dataKey: 'promoType' },
                    { label: 'Investment', dataKey: 'field_value' },
                    // { label: 'ROI', dataKey: 'roi' },
                    // { label: 'Lift', dataKey: 'lift' },
                    // { label: 'Incremental Profit', dataKey: 'incrementalProfit' },
                    // { label: 'Incremental Retailer Profit', dataKey: 'incrementalRetailerProfit' },
                ],
                media: [
                    { label: 'Start Week', dataKey: 'startTimestamp' },
                    { label: 'End Week', dataKey: 'endTimestamp' },
                    { label: 'Sub Brand', dataKey: 'product' },
                    { label: 'Media Type', dataKey: 'promoType' },
                    { label: 'Investment', dataKey: 'field_value' },
                ],
            },
        },
        //PROMO SCORE CARD
        promoScoreCard: {
            mainHeader: 'Promo Scorecard',
            limit: 50,
            nestedTableLimit: 10,
            questionsNo: [1, 2, 3, 4, 6, 7],
            question: {
                Q: [
                    'Am I getting my fair share of quality support? ',
                    'How does my % Discount compare to competition? ',
                    'What % of Volume was sold on promotion? ',
                    'How many weeks am I promoting? ',
                    'What is my average price/units? ',
                    'What is my value share of promotions? ',
                ],
                unitsInItalics: [
                    '(Fair Share Index -£ Sold)',
                    '(Weighted Average % Price Reduction)',
                    '(% of Volume)',
                    '(Weighted Weeks)',
                    '(Price per Unit)',
                    '(Value share %)',
                ],
                unit: ['value', '%', '%', 'week', '£', '%'],
                numberFormateDecimal: [0, 1, 1, 0, 2, 1],
            },
            promoTypeLabelMapping: {
                display: { label: 'Off Shelf Only' },
                tpr: { label: 'Price Cut Only' },
                feature: { label: 'On Shelf Only' },
                feature_and_display: { label: 'Special Pack Only' },
                feature_display: { label: 'Special Pack Only' },
            },
            showGradientTile: true,
            promoType: ['Price Cut Only', 'Off Shelf Only', 'On Shelf Only', 'Special Pack Only'],
            promoExpandedViewTableUnit: 'volume',
            promoExpandedViewTableSalesAndVolumeLabel: ['Units', 'Total Sales £'],
            dropDown: ['Category', 'Sub_Category', 'Brand', 'Sub_Brand', 'Type'],
            listFor: ['Manufacturer', 'Brand', 'Sub_Brand', 'Branding', 'Perrigo_Pl', 'Dosage', 'product'],
            listForToDisplay: [
                'Manufacturer',
                'Brand',
                'Sub_Brand',
                'Branding',
                'Perrigo_Pl',
                'Dosage',
                'product',
                'Retailer',
                'Channel',
                'Country',
            ],
            listIn: [
                'Category',
                'Sub_Category',
                'Pack_Size',
                'Type',
                'Class',
                'Consumer',
                'Retailer',
                'Channel',
                'Country',
            ],
        },

        // PROMO LANDSCAPE
        promoLandscape: {
            mainHeader: 'Investment & ROI Tracker',
            roiLabel: 'ROI',
            defaultAttributeTypeIndex: 3,
            defaultInvestmentTypeItems: ['digital'],
            optimalInvestmentIndexThreshold1: 0.8,
            optimalInvestmentIndexThreshold2: 1.2,
            promoTacticDropdownName: 'Investment Type',
            dimensionConfig: {
                //snake case eg sub_category
                excludedDimensions: [],
                defaultDimension: '',
            },
            thresholdColorMapping: {
                optimal: { label: 'Optimal', color: colorConstants.darkGreen },
                over: { label: 'Over', color: colorConstants.darkRed },
                under: { label: 'Under', color: colorConstants.darkBlueAlt },
            },
            limit: 60,
            promoTypes: [
                { value: 'display', label: 'Off Shelf' },
                { value: 'tpr', label: 'Price Cut' },
                { value: 'feature', label: 'On Shelf' },
                // { value: 'feature & display', label: 'Feature & Display' },  //not required for now
            ],
            mediaLevelsDropdown: ['Manufacturer', 'Category', 'Sub Category', 'Brand', 'Sub Brand', 'Type'],
            showInvestmentDropdown: true,
            optimalIndexKey: 'competition_spend_index',
            tableRowsKeyMapping: [
                {
                    label: 'Investment',
                    children: null,
                    parentKey: null,
                    key: 'investments',
                    unit: '£',
                },
                {
                    label: 'ROI',
                    children: null,
                    parentKey: null,
                    key: 'roi',
                    unit: '',
                },
                {
                    label: 'Competition Spend Index',
                    children: [
                        {
                            label: 'Share of Investment',
                            key: 'share_of_investment',
                            unit: '%',
                        },
                        {
                            label: 'Share of Sales',
                            key: 'share_of_sales',
                            unit: '%',
                        },
                    ],
                    unit: '',
                    parentKey: 'competition_data',
                    key: 'competition_spend_index',
                },
                {
                    label: 'Incremental Sales',
                    unit: '£',
                    children: [
                        {
                            label: 'Total Sales',
                            key: 'total_sales',
                            unit: '',
                        },
                        {
                            label: 'Base Sales',
                            key: 'base_sales',
                            unit: '',
                        },
                    ],
                    parentKey: 'sales_data',
                    key: 'incremental_retail_sales',
                },
                {
                    label: 'Total Profit',
                    unit: '£',
                    children: [
                        {
                            label: 'Incremental Profit',
                            key: 'incremental_profit',
                            unit: '£',
                        },
                        {
                            label: 'Base Profit',
                            key: 'base_profit',
                            unit: '£',
                        },
                    ],
                    parentKey: 'profit_data',
                    key: 'total_profit',
                },
                // {
                //     label: 'Share of Spends',
                //     children: null,
                //     parentKey: null,
                //     key: 'shareOfSpends',
                //     unit: '',
                // },
            ],
        },
        //PORTFOLIO ANALYSIS
        portfolioAnalysis: {
            mainHeader: 'Promo ROI Analysis',
            limit: 20,
            defaultGroupByIndex: 18,
            defaultGroupBy2Index: 5,
            chartColors: [],
            absTileData: [
                { key: 'Promotions', label: 'Promotions' },
                { key: 'Drivers', label: 'Drivers' },
                { key: 'Media', label: 'Media' },
            ],
            salesAttributionChart: {
                colorList: ['#10AB5E', '#DC3826'],
                colorListType2: ['#758BEE', '#758BEE'],
                profitPoolColor: ['#826FD0', '#826FD0'],
                backGroundColor: 'rgba(0, 0, 0, 0.02)',
            },
            chartDropdownExtraKpis: [
                {
                    dimension: 'none',
                    label: 'Media Descriptor',
                    dataKey: 'tactic_description',
                },
                {
                    dimension: 'none',
                    label: 'Mechanics',
                    dataKey: 'promotion_mechanic',
                },
                {
                    dimension: 'none',
                    label: 'Event Name',
                    dataKey: 'event_name',
                },
                {
                    dimension: 'dim1',
                    label: 'Week',
                    dataKey: 'week',
                },
            ],
            groupByHeaders: [
                {
                    label: 'Category',
                    value: 'category',
                    dimension: 'dim1',
                    isSelected: false,
                    sortKey: 'category',
                    multiSelectFilter: false,
                },
                {
                    label: 'Sub Category',
                    value: 'sub_category',
                    dimension: 'dim1',
                    isSelected: false,
                    sortKey: 'sub_category',
                    multiSelectFilter: false,
                },
                {
                    label: 'Brand',
                    value: 'brand',
                    dimension: 'dim1',
                    isSelected: false,
                    sortKey: 'brand',
                    multiSelectFilter: false,
                },
                {
                    label: 'Sub Brand',
                    value: 'sub_brand',
                    dimension: 'dim1',
                    isSelected: false,
                    sortKey: 'sub_brand',
                    multiSelectFilter: false,
                },
                {
                    label: 'Product',
                    value: 'product',
                    dimension: 'dim1',
                    isSelected: true,
                    sortKey: 'product',
                    multiSelectFilter: false,
                },
                {
                    label: 'Mechanics',
                    value: 'promotion_mechanic',
                    dimension: null,
                    isSelected: true,
                    sortKey: 'promotion_mechanic',
                    multiSelectFilter: true,
                },
                {
                    label: 'Media Descriptor',
                    value: 'tactic_description',
                    dimension: null,
                    isSelected: false,
                    sortKey: 'tactic_description',
                    multiSelectFilter: true,
                },
            ],

            mediaSpendsLabelKeyMapping: {
                attribute_name: 'Attribute Name',
                media_type: 'Media Type',
                media_investment: 'Media Spends',
                share_of_media_spend: 'Share Of Media Spends(%)',
                incremental_retail_sales: 'Incremental Sales from Media',
                media_lift: 'Media Lift',
                media_roi: 'Media ROI',
            },
            mediaSpendsAttributeOptions: [
                { label: 'Sub Brand', key: 'Sub_Brand', dim: 'dim1' },
                { label: 'Brand', key: 'Brand', dim: 'dim1' },
                { label: 'Manufacturer', key: 'Manufacturer', dim: 'dim1' },
                { label: 'Category', key: 'Category', dim: 'dim1' },
                { label: 'Sub Category', key: 'Sub_Category', dim: 'dim1' },
            ],

            chartHeaderLabelKeyMapping: {
                lift: { label: 'Lift' },
                roi: { label: 'ROI' },
                investments: { label: 'Investments' },
                incremental_net_sales: { label: 'Incremental Net Sales' },
                incremental_profit: { label: 'Incremental Profit' },
                incremental_retailer_profit: {
                    label: 'Incremental Retailer Profit',
                },
                acv: { label: 'ACV Distribution' },
                profit_pool: { label: 'Profit Pool' },
                tpr_acv: { label: 'Price Cut ACV' },
                display_acv: { label: 'Off Shelf ACV' },
                feature_acv: { label: 'On Shelf ACV' },
                feature_and_display_acv: { label: 'Special Pack ACV' },
                total_acv: { label: 'Total ACV' },
                weeks: { label: 'Promo Weeks' },
            },
            dimension: 'dim1',
            attributeType: 'product',
            promoTypesChartLegends: [
                {
                    label: 'Price Cut',
                    color: colorConstants.lightCyan,
                    style: {
                        borderRadius: '100%',
                        height: `8px`,
                        width: '8px',
                    },
                },
                {
                    label: 'On Shelf',
                    color: colorConstants.lightCream,
                    style: {
                        borderRadius: '100%',
                        height: `8px`,
                        width: '8px',
                    },
                },
                {
                    label: 'Off Shelf',
                    color: colorConstants.lightPink,
                    style: {
                        borderRadius: '100%',
                        height: `8px`,
                        width: '8px',
                    },
                },
            ],
            promoTypes: ['tpr/scan', 'feature ad', 'display'],
            promoTypesLabelMapping: {
                'tpr/scan': 'Price Cut',
                'feature ad': 'On Shelf',
                display: 'Off Shelf',
            },
        },
        promoRecommendation: {
            playbookLimit: 50,
            clientName: 'Perrigo',
            mainHeader: 'Promo Recommendation',
            retailerKey: 'Retailer',
            hideAddSpends: false,
            calenderStartDay: 'Sunday',
            spendLeversList: [
                {
                    label: 'Baseline Volume',
                    placeholder: 'Baseline Volume',
                    value: 'baseVolume',
                    isDisabled: false,
                },
                {
                    label: 'Uplift',
                    placeholder: 'Uplift',
                    value: 'uplift',
                    isDisabled: false,
                },
                {
                    label: 'Total Volume',
                    placeholder: 'Total Volume',
                    value: 'totalVolume',
                    isDisabled: true,
                },
                {
                    label: `Total Perrigo Profit (£)`,
                    placeholder: `Total Perrigo Profit`,
                    value: 'totalKindProfit',
                    isDisabled: true,
                },
                {
                    label: 'ROI',
                    placeholder: 'ROI',
                    value: 'roi',
                    isDisabled: true,
                },
                {
                    label: `Total Retailer Profit (£)`,
                    placeholder: 'Total Retailer Profit',
                    value: 'totalRetailerProfit',
                    isDisabled: true,
                },
            ],
            spendTypeList: [
                {
                    label: 'Lump Sum',
                    value: 'lump_sum',
                    inputRule: '',
                },
                {
                    label: 'Per Qty',
                    value: 'per_qty',
                    inputRule: '',
                },
                {
                    label: 'Off Shelf',
                    value: 'display',
                    inputRule: '',
                },
                {
                    label: 'On Shelf',
                    value: 'feature',
                    inputRule: '',
                },
            ],
            playbookKeyMapping: {
                Product: ['ppgName'],
                '%TS': ['guidelinePercentageTotalSpends', 'percentageTotalSpends', 'lesser_than', '', '%'],
                Frequency: ['guidelineFrequency', 'frequency', 'range', ''],
                ROI: ['guidelineRoi', 'roi', 'greater_than', '', ''],
            },
            // comparisonOperator: {
            //     '%TS': '<',
            //     Frequency: 'range',
            //     ROI: '>',
            // },
            menuButtons: [
                { key: 'recommendations', label: 'Recommendations' },
                {
                    key: 'summary',
                    label: 'Summary',
                },
                {
                    key: 'playbook',
                    label: 'Playbook',
                },
            ],

            promoTypeColorMapping: {
                'tpr/scan': {
                    label: 'Price Cut',
                    color: colorConstants.lightGreenAlt,
                },
                'feature ad': {
                    label: 'On Shelf',
                    color: colorConstants.darkGreenAlt2,
                },
                display: { label: 'Off Shelf', color: colorConstants.pinkAlt },
                feature_display_tpr: {
                    label: 'Special Pack',
                    color: colorConstants.orangeAlt2,
                },
                // display_tpr: { label: 'Display_TPR', color: colorConstants.darkBlueAlt },
            },
            overlayKeys: [
                {
                    label: 'Start Date',
                    dataKey: 'startDate',
                    pre: '',
                    post: '',
                },
                { label: 'Duration', dataKey: 'duration', pre: '', post: '' },
                {
                    label: 'Promo Type',
                    dataKey: 'tacticDescription',
                    pre: '',
                    post: '',
                },
                { label: 'Product(s)', dataKey: 'dim1AttributeNames', pre: '', post: '' },
                {
                    label: 'Total Volume',
                    dataKey: 'totalVolume',
                    pre: '',
                    post: '',
                    arrowConfig: 'positiveUp',
                },
                {
                    label: 'Total GSV',
                    dataKey: 'totalGsv',
                    pre: '£',
                    post: '',
                    arrowConfig: 'positiveUp',
                },
                {
                    label: 'Total NSV',
                    dataKey: 'totalNsv',
                    pre: '£',
                    post: '',
                    arrowConfig: 'positiveUp',
                },
                {
                    label: 'Total Perrigo Profit',
                    dataKey: 'totalKindProfit',
                    pre: '£',
                    post: '',
                    arrowConfig: 'positiveUp',
                },
                {
                    label: 'Total Retailer Profit',
                    dataKey: 'totalRetailerProfit',
                    pre: '£',
                    post: '',
                    arrowConfig: 'positiveUp',
                },
                {
                    label: 'Promo Spends',
                    dataKey: 'promoSpends',
                    pre: '£',
                    post: '',
                    arrowConfig: 'negativeUp',
                },
                {
                    label: '% Trade Spends GSV',
                    dataKey: 'percentageTradeSpendsGsv',
                    pre: '',
                    post: '%',
                    arrowConfig: 'negativeUp',
                },
                {
                    label: '% Trade Spends NSV',
                    dataKey: 'percentageTradeSpendsNsv',
                    pre: '',
                    post: '%',
                    arrowConfig: 'negativeUp',
                },

                {
                    label: 'Incremental Volume',
                    dataKey: 'incrementalVolume',
                    pre: '',
                    post: '',
                    arrowConfig: 'positiveUp',
                },
                {
                    label: 'Incremental GSV',
                    dataKey: 'incrementalGsv',
                    pre: '£',
                    post: '',
                    arrowConfig: 'positiveUp',
                },
                {
                    label: 'Incremental NSV',
                    dataKey: 'incrementalNsv',
                    pre: '£',
                    post: '',
                    arrowConfig: 'positiveUp',
                },
                {
                    label: 'Total Profit %',
                    dataKey: 'totalProfitPercentage',
                    pre: '',
                    post: '%',
                    arrowConfig: 'positiveUp',
                },
                {
                    label: 'Incremental Profit',
                    dataKey: 'incrementalProfit',
                    pre: '£',
                    post: '',
                    arrowConfig: 'positiveUp',
                },
                {
                    label: 'Promo ROI',
                    dataKey: 'roi',
                    pre: '',
                    post: '',
                    arrowConfig: 'positiveUp',
                },
                {
                    label: 'Retailer Incremental Profit',
                    dataKey: 'retailerIncrementalProfit',
                    pre: '£',
                    post: '',
                    arrowConfig: 'positiveUp',
                },
            ],
            spendLabel: {
                lump_sum: 'Lump Sum',
                per_qty: 'Per Qty',
                display: 'Off Shelf',
                feature: 'On Shelf',
            },
            offerMethodList: [
                { value: 'option', label: 'List of Option', dimension: 'dim1' },
                { value: 'manual', label: 'Manual', dimension: 'dim1' },
                { value: 'previous', label: 'Previous', dimension: 'dim1' },
            ],
            addEventList: [
                { value: 'new', label: 'Add New Event' },
                { value: 'import', label: 'Import Event' },
            ],
            leverKeys: [
                'promptEventName',
                'offerMethod',
                'discount',
                'startDate',
                'duration',
                'displayAcv',
                'featureAcv',
            ],
            spendTopForm: ['baseVolume', 'uplift', 'totalVolume', 'totalKindProfit', 'roi', 'totalRetailerProfit'],
            formList: [
                {
                    value: 'duration',
                    label: 'Duration',
                    inputRule: '',
                    placeHolder: 'Enter',
                },
                {
                    value: 'displayAcv',
                    label: 'Off Shelf ACV',
                    inputRule: '',
                    placeHolder: 'Enter Off Shelf ACV',
                },
                {
                    value: 'featureAcv',
                    label: 'On Shelf ACV',
                    inputRule: '',
                    placeHolder: 'Enter On Shelf ACV',
                },
            ],
            offerSelectionKeys: ['promotionMechanic', 'tacticDescription'],
            spendPerQtyKey: ['per_qty', 'redemption'],
        },
        commercialForecast: {
            externalAnalyticsToolName: { shortName: 'VF' },
            excludedAttributeTypes: ['manufacturer'],
            limit: 60,
            forecastDropdownData: [
                {
                    key: 'asper',
                    label: 'Asper Forecast',
                    value: 'asper',
                    dataKey: 'asper',
                },
                {
                    key: 'external',
                    label: 'VF Forecast',
                    value: 'external',
                    dataKey: 'external',
                },
                {
                    key: 'difference',
                    label: 'Difference',
                    value: 'difference',
                    dataKey: 'difference',
                },
                // { key: 'profit', label: 'Profit', value: 'profit', dataKey: 'profit' },
            ],
            trendChartDropdownData: [
                {
                    key: 'month',
                    label: 'Months',
                    labelAlt: 'Monthly',
                    value: 'month',
                    dataKey: 'month',
                },
                {
                    key: 'week',
                    label: 'Weeks',
                    labelAlt: 'Weekly',
                    value: 'week',
                    dataKey: 'week',
                },
                // { key: 'profit', label: 'Profit', value: 'profit', dataKey: 'profit' },
            ],
            graphExportHeaderMapping: {
                base: ['Non-promo', 'Promo'],
                incremental: ['Base', 'Incremental'],
                total: ['Consumption'],
                depletion: ['Depletion'],
            },
            mainTileData: [
                { key: 'total', label: 'Total' },
                { key: 'base', label: 'Base' },
                { key: 'incremental', label: 'Incremental' },
            ],
            graphLegendMapping: {
                total_asper: {
                    color: colorConstants.lightGreenAlt,
                    label: 'Total Units Asper',
                },
                base_asper: {
                    color: colorConstants.lightGreenAlt,
                    label: 'Base Units Asper',
                },
                incremental_asper: {
                    color: colorConstants.lightGreenAlt,
                    label: 'Incremental Units Asper',
                },
                total_external: {
                    color: colorConstants.darkYellow,
                    label: 'Total Units VF',
                },
                base_external: {
                    color: colorConstants.darkYellow,
                    label: 'Base Units VF',
                },
                incremental_external: {
                    color: colorConstants.darkYellow,
                    label: 'Incremental Units VF',
                },
                total_difference: {
                    color: colorConstants.orangeAlt2,
                    label: 'Total Units Difference',
                },
                base_difference: {
                    color: colorConstants.orangeAlt2,
                    label: 'Base Units Difference',
                },
                incremental_difference: {
                    color: colorConstants.orangeAlt2,
                    label: 'Incremental Units Difference',
                },
            },
            tableKeyLabelMapping: {
                total_sales_asper: {
                    label: 'Total Units Asper',
                    pre: '',
                    post: '',
                },
                total_sales_difference: {
                    label: 'Total Units Difference',
                    pre: '',
                    post: '',
                },
                total_sales_external: {
                    label: 'Total Units VF',
                    pre: '',
                    post: '',
                },
                incremental_sales_asper: {
                    label: 'Incremental Units Asper',
                    pre: '',
                    post: '',
                },
                incremental_sales_difference: {
                    label: 'Incremental Units Difference',
                    pre: '',
                    post: '',
                },
                incremental_sales_external: {
                    label: 'Incremental Units VF',
                    pre: '',
                    post: '',
                },
                base_sales_asper: {
                    label: 'Base Units Asper',
                    pre: '',
                    post: '',
                },
                base_sales_difference: {
                    label: 'Base Units Difference',
                    pre: '',
                    post: '',
                },
                base_sales_external: {
                    label: 'Base Units VF',
                    pre: '',
                    post: '',
                },
            },
        },
        priceLadder: {
            isThresholdDropdownEnabled: true,
            hideMraup: true,
            limit: 50, //update this when implementing infinite scroller,
            dimensionConfig: {
                //snake case eg sub_category
                excludedDimensions: [],
                defaultDimension: 'Brand',
            },
            tileData: [
                {
                    label: 'Product by Market',
                    key: 'product by market',
                },
                // {
                //     label: 'Product vs Competitors',
                //     key: 'product vs competitors',
                // },
            ],
            subTileData: [
                {
                    label: 'Per Unit',
                    key: 'PU',
                },
                // {
                //     label: 'PEQ',
                //     key: 'PEQ',
                // },
            ],
            legendMapping: {
                PU: [
                    {
                        color: '#E6E6EA',
                        label: 'Sales £',
                        key: 'salesValueDollars',
                        dataKey: 'sales',
                        metricDataKey: 'units',
                    },
                    {
                        color: '#66AFBA',
                        label: 'Avg. Price Per Unit',
                        key: 'avgPrice',
                        dataKey: 'avg_price_per_unit',
                        metricDataKey: 'units',
                    },
                    {
                        color: '#ECA586',
                        label: 'Max Price Per Unit',
                        key: 'maxPrice',
                        dataKey: 'max_price_per_unit',
                        metricDataKey: 'units',
                    },
                    {
                        color: '#EB8FC5',
                        label: 'Min Price Per Unit',
                        key: 'minPrice',
                        dataKey: 'min_price_per_unit',
                        metricDataKey: 'units',
                    },
                    {
                        color: '#F1C77A',
                        label: 'Promo Price Per Unit',
                        key: 'promoPrice',
                        dataKey: 'promo_price_per_unit',
                        metricDataKey: 'units',
                    },
                    {
                        color: '#6771DB',
                        label: 'Regular Price Per Unit',
                        key: 'basePrice',
                        dataKey: 'base_price_per_unit',
                        metricDataKey: 'units',
                    },
                    // { color: '#5463FF', label: 'MRAUP', key: 'mraup', dataKey: 'mraup' },
                ],
                PEQ: [
                    {
                        color: '#E6E6EA',
                        label: 'Sales £',
                        key: 'salesValueDollars',
                        dataKey: '',
                        metricDataKey: 'volume',
                    },
                    {
                        color: '#66AFBA',
                        label: 'Avg. Price PEQ',
                        key: 'avgPrice',
                        dataKey: 'avg_price_per_eq',
                        metricDataKey: 'volume',
                    },
                    {
                        color: '#ECA586',
                        label: 'Max Price PEQ',
                        key: 'maxPrice',
                        dataKey: 'max_price_per_eq',
                        metricDataKey: 'volume',
                    },
                    {
                        color: '#EB8FC5',
                        label: 'Min Price PEQ',
                        key: 'minPrice',
                        dataKey: 'min_price_per_eq',
                        metricDataKey: 'volume',
                    },
                    {
                        color: '#F1C77A',
                        label: 'Promo Price PEQ',
                        key: 'promoPrice',
                        dataKey: 'promo_price_per_eq',
                        metricDataKey: 'volume',
                    },
                    {
                        color: '#6771DB',
                        label: 'Regular Price PEQ',
                        key: 'basePrice',
                        dataKey: 'base_price_per_eq',
                        metricDataKey: 'volume',
                    },
                    // { color: '#5463FF', label: 'MRAUP', key: 'mraup', dataKey: 'mraup' },
                ],
            },
            dataKeyMapping: {
                PU: [
                    { label: 'Sales £', key: 'salesValueDollars' },
                    { label: 'Avg. Price Per Unit', key: 'avgPrice' },
                    { label: 'Max Price Per Unit', key: 'maxPrice' },
                    { label: 'Min Price Per Unit', key: 'minPrice' },
                    { label: 'Promo Price Per Unit', key: 'promoPrice' },
                    { label: 'Regular Price Per Unit', key: 'basePrice' },
                ],
                PEQ: [
                    { label: 'Sales £', key: 'salesValueDollars' },
                    { label: 'Avg. Price PEQ', key: 'avgPrice' },
                    { label: 'Max Price PEQ', key: 'maxPrice' },
                    { label: 'Min Price PEQ', key: 'minPrice' },
                    { label: 'Promo Price PEQ', key: 'promoPrice' },
                    { label: 'Regular Price PEQ', key: 'basePrice' },
                ],
            },
            tableColumnLabelKeyMapping: {
                sales: { label: 'Sales £' },
                sales_percentage: { label: 'Sales %' },
                avg_price_pu: { label: 'Average Price £ Per Unit' },
                // avg_price_peq: { label: 'Average Price £ PEQ' },
                max_price_pu: { label: 'Max Price £ Per Unit' },
                // max_price_peq: { label: 'Max Price £ PEQ' },
                min_price_pu: { label: 'Min Price £ Per Unit' },
                // min_price_peq: { label: 'Min Price £ PEQ' },
                // mraup: { label: 'MRAUP' },
                base_price_pu: { label: 'Regular Price £ Per Unit' },
                // base_price_peq: { label: 'Base Price £ PEQ' },
                promo_price_pu: { label: 'Promo Price £ Per Unit' },
                // promo_price_peq: { label: 'Promo Price £ PEQ' },
            },
            dropdown2Filter: ['Category', 'Pack_Size', 'Segment', 'Channel', 'Retailer'],
        },
        opportunityIdentification: {
            reversePpeAxis: false,
            bubbleCategoryOptions: [
                { value: 'brand', label: 'Brand', dimension: 'dim1' },
                { value: 'sub_brand', label: 'Sub Brand', dimension: 'dim1' },
                { value: 'category', label: 'Category', dimension: 'dim1' },
                {
                    value: 'sub_category',
                    label: 'Sub Category',
                    dimension: 'dim1',
                },
                { value: 'pack_size', label: 'Pack Size', dimension: 'dim1' },
                {
                    value: 'manufacturer',
                    label: 'Manufacturer',
                    dimension: 'dim1',
                },
                { value: 'product', label: 'Product', dimension: 'dim1' },
            ],
            kpis: {
                xaxis: [
                    { label: 'BPE', value: 'bpe' },
                    { label: 'Value Sales Growth %', value: 'rsv_growth' },
                    { label: 'Gross Profit %', value: 'mac_percentage' },
                ],
                yaxis: [
                    { label: 'PPE', value: 'ppe' },
                    { label: 'Value Sales Growth %', value: 'rsv_growth' },
                    { label: 'Gross Profit %', value: 'mac_percentage' },
                ],
                bubbleSize: [
                    //{ label: 'Eq Volume', value: 'total_volume' },
                    { label: 'Units', value: 'total_units' },
                    { label: 'BPE', value: 'bpe' },
                    { label: 'PPE', value: 'ppe' },
                    { label: 'Gross Profit', value: 'mac' },
                    { label: 'Gross Profit %', value: 'mac_percentage' },
                    { label: 'Value Sales', value: 'rsv' },
                    { label: 'Value Sales Growth %', value: 'rsv_growth' },
                ],
            },
            elasticityDriver: {
                chart2Limit: 100,
                levels: [
                    { label: 'Retailer', value: 'retailer', dimension: 'dim2' },
                    { label: 'Product', value: 'product', dimension: 'dim1' },
                    { label: 'Category', value: 'category', dimension: 'dim1' },
                    { label: 'Sub Category', value: 'sub_category', dimension: 'dim1' },
                    { label: 'Brand', value: 'brand', dimension: 'dim1' },
                    { label: 'Sub-brand', value: 'sub_brand', dimension: 'dim1' },
                    { label: 'Pack Size', value: 'pack_size', dimension: 'dim1' },
                    { label: 'Channel', value: 'channel', dimension: 'dim2' },
                    { label: 'Country', value: 'country', dimension: 'dim2' },
                ],
                limit: 50,
                offset: 0,
                dimension: 'dim1',
                legendMapping: [
                    {
                        dataKey: 'own',
                        label: 'Own Elasticity',
                        color: '#69D4E8',
                    },
                    {
                        dataKey: 'internal',
                        label: 'Internal Competitor Elasticity',
                        color: '#E469B2',
                    },
                    {
                        dataKey: 'external',
                        label: 'External Competitor Elasticity',
                        color: '#EDB44E',
                    },
                ],
            },
        },
        priceCurve: {
            chart1Limit: 100,
            xAxisKeyValue: [
                { value: 'pack_size', label: 'Pack Size' },
                { value: 'dosage', label: 'Dosage' },
                { value: 'brand', label: 'Brand' },
                { value: 'sub_brand', label: 'Sub Brand' },
            ],
            YAxisKeyValue: [
                { value: 'retail_price', label: 'Retail Price' },
                { value: 'list_price', label: 'List Price' },
                { value: 'base_price', label: 'Regular Price' },
            ],
            levels: [
                { value: 'brand', label: 'Brand' },
                { value: 'sub_brand', label: 'Sub Brand' },
                { value: 'manufacturer', label: 'Manufacturer' },
                { value: 'type', label: 'Type' },
                { value: 'class', label: 'Class' },
                { value: 'consumer', label: 'Consumer' },
                { value: 'dosage', label: 'Dosage' },
            ],
            subTileData: [
                {
                    label: 'Per Unit',
                    key: 'PU',
                    dataKey: 'per_unit',
                },
                // {
                //     label: 'PEQ',
                //     key: 'PEQ',
                //     dataKey: 'per_eq',
                // },
            ],
            chartColors: [
                '#E8A122',
                '#293BB8',
                '#E06936',
                '#19669D',
                '#A5582D',
                '#43C9E2',
                '#DD449F',
                '#37C7BE',
                '#9E5897',
                '#00798C',
                '#EDB44E',
                '#4557D5',
                '#E6875E',
                '#228BD6',
                '#CC7442',
                '#69D4E8',
                '#E469B2',
                '#5FD3CB',
                '#B377AD',
                '#3394A3',
                '#F1C77A',
                '#7381E0',
                '#ECA586',
                '#55A8E4',
                '#D89672',
                '#8EDFEE',
                '#EB8FC5',
                '#87DED8',
                '#C699C2',
                '#66AFBA',
                '#F6D9A7',
                '#A2ABEA',
                '#F3C3AF',
                '#8EC5ED',
                '#E5B9A1',
                '#B4E9F3',
                '#F1B4D9',
                '#AFE9E5',
                '#D9BBD6',
                '#99C9D1',
                '#FAECD3',
                '#D0D5F5',
                '#F9E1D7',
                '#C6E2F6',
                '#F2DCD0',
                '#D9F4F9',
                '#F8DAEC',
                '#D7F4F2',
                '#ECDDEB',
                '#CCE4E8',
            ],
            tableHeaders: [
                { label: 'List Price £', key: 'list_price' },
                { label: 'List Price £ YA', key: 'list_price_ya' },
                { label: 'Retail Price £', key: 'retail_price' },
                { label: 'Retail Price £ YA', key: 'retail_price_ya' },
                { label: 'Regular Price £', key: 'base_price' },
                { label: 'Regular Price £ YA', key: 'base_price_ya' },
            ],
        },
        pricePoint: {
            priceRange: [0, 10],
            graphColorScheme: ['#D7D6D9', '#66AFBA', '#ECA586', '#F1C77A', '#EB8FC5'],
            hideMraup: true,
            limit: 500,
            dimensionConfig: {
                //snake case eg sub_category
                excludedDimensions: [],
                defaultDimension: 'Manufacturer',
            },
            contributionThreshold: 5,
            priceTypeOptions: [
                { label: 'Avg Price', value: 'avg_price' },
                { label: 'Base Price', value: 'base_price' },
            ],
            subTileData: [
                {
                    label: 'Per Unit',
                    key: 'per_unit',
                    xAxisLabel: 'Price Per Unit',
                    tooltip: 'Per Unit',
                },
                // {
                //     label: 'PEQ',
                //     key: 'per_volume',
                //     xAxisLabel: 'Price Per Eq',
                //     tooltip: 'Per Eq Volume',
                // },
            ],
            yAxisDropdownData: [
                {
                    label: 'Value',
                    value: 'value',
                },
                // {
                //     label: 'Volume',
                //     value: 'volume',
                // },
                {
                    label: 'Units',
                    value: 'units',
                },
            ],
            tableHeaderKeyMapping: {
                growth_percentage: ['Growth % vs YA', '', '%'],
                total_sales: ['Total Value (£)', '£', ''],
                total_volume: ['Total Volume', '', ''],
                total_units: ['Total Units', '£', ''],
                avg_price_per_unit: ['Avg. Price per Unit', '£', ''],
                avg_price_per_eq: ['Avg. Price per EQ', '£', ''],
                base_price_per_unit: ['Base Price per Unit', '$', ''],
                base_price_per_eq: ['Base Price per EQ', '$', ''],
            },
            drilldownTableHeaderKeyMapping: {
                growth_abs: ['Growth Abs', '£', ''],
                growth_percentage: ['Growth %', '', '%'],
                contribution_to_category: ['Contribution to category', '£', ''],
                cy_share: ['CY share', '', '%'],
                ya_share: ['YA share', '', '%'],
                change: ['Change %', '', '%'],
            },
            dropdown2Filter: ['Category', 'Pack_Size', 'Segment', 'Channel', 'Retailer'],
            customThresholdData: [
                {
                    id: 1,
                    value: '',
                },
                {
                    id: 2,
                    value: '',
                },
                {
                    id: 3,
                    value: '',
                },
                {
                    id: 4,
                    value: '',
                },
                {
                    id: 5,
                    value: '',
                },
            ],
        },
        priceTracking: {
            limit: 20,
            dimensionConfig: {
                //snake case eg sub_category
                excludedDimensions: ['manufacturer', 'type', 'class', 'consumer', 'dosage', 'branding', 'perrigo_pl'],
                defaultRowDimension: 'Product',
                defaultColumnDimension: 'Retailer',
            },
            attributeNamesLimit: 50,
            frequency: 'W',
            timePeriodOptions: [
                { label: 'YA', value: 'year_ago' },
                { label: 'Prior Period', value: 'prior_period' },
                { label: 'Custom Period', value: 'custom' },
            ],
            priceTypeOptions: [
                { label: 'Regular Price', value: 'base' },
                { label: 'Avg Price', value: 'average' },
            ],
            kpiOptions: [
                { label: '% Change', value: 'percent_change' },
                { label: 'Price Index', value: 'index' },
            ],
            subTileData: [
                {
                    label: 'Per Unit',
                    key: 'units',
                    xAxisLabel: 'Price Per Unit',
                    tooltip: 'Per Unit',
                },
                // {
                //     label: 'PEQ',
                //     key: 'volume',
                //     xAxisLabel: 'Price Per Eq',
                //     tooltip: 'Per Eq Volume',
                // },
            ],

            weeksOptions: [
                { label: 'L W1', value: 1 },
                { label: 'L W4', value: 4 },
                { label: 'L W12', value: 12 },
            ],
            monthsOptions: [
                { label: 'L M1', value: 1 },
                { label: 'L M3', value: 3 },
                { label: 'L M6', value: 6 },
                { label: 'L M12', value: 12 },
            ],
            quartersOptions: [
                { label: 'L Q1', value: 1 },
                { label: 'L Q2', value: 2 },
                { label: 'L Q4', value: 4 },
            ],
            kpiMapping: {
                'Base Price': ['£', ''],
                'Base Price YA': ['£', ''],
                'Avg Price': ['£', ''],
                'Avg Price YA': ['£', ''],
                'Base Price Index % Chg': ['', '%'],
                'Base Price % Chg': ['', '%'],
                'Avg Price Index % Chg': ['', '%'],
                'Avg Price % Chg': ['', '%'],
                'TDP % Chg': ['', '%'],
                TDP: ['', ''],
                'TDP YA': ['', ''],
                'Volume Velocity % Chg': ['', '%'],
                'Volume Velocity': ['', ''],
                'Volume Velocity YA': ['', ''],
            },
        },
        bestWeeks: {
            limit: 50,
            drilldownTableConfig: [
                { label: 'Period No:', value: 'period_no', sorting: false },
                { label: 'Year', value: 'year', sorting: false },
            ],
            dimensionConfig: {
                //snake case eg sub_category
                excludedDimensions: ['dim2'],
                defaultDimension: 'Brand',
            },
            rankingCriteriaOptions: [
                { label: 'Base Volume', value: 'base_eq_volume' },
                { label: 'ACV', value: 'total_per_acv_dist' },
                { label: 'Incremental Volume', value: 'incremental_eq_volume' },
                { label: 'Total Volume', value: 'total_eq_volume' },
            ],
        },
    },
    cooper: {
        //COMMON CONFIG
        commonConfig: {
            clientName: 'Cooper',
            handleDim2SortingFromFrontend: false,
            dateFormat: 'MM/DD/YYYY',
            dateFormatAlt: 'MM/DD/YY',
            calenderStartDay: 'Sunday',
            showSecondaryLogo: false,
            showLogoInNavbar: true,
            logoHeight: '48px',
            logoWidth: '125px',
            loginPageTextPart1: 'Welcome to the',
            loginPageTextPart2: 'SRM Analytic Intelligence (AI) Tool Suite',
            width: window.innerWidth,
            limit: 10,
            offset: 0,
            lagList: [0, 1],
            graphFontSize: calculateFontSize(window.innerWidth, 13),
            graphFontSizeAlt: calculateFontSize(window.innerWidth, 13),
            graphFontFamily: "'Helvetica Neue', sans-serif",
            graphLabelColorAlt: '#4E4C55',
            graphLabelColor: '#433C4A',
            units: {
                currency: 'kr',
                volume: 'Eq Vol',
                currencyText: 'SEK',
            },
            filterFormat: { dim1: { ids: [] }, dim2: { ids: [] } },
            frequency: 'W',
            showCampignCalender: false,
            showFullLabel: true,
            decimalForPercentage: 1,
            decimalForNonPercentage: 2,
        },
        latestDateForDifferentRoutes: {
            'promo-score-card': 'Promotion Data',
            'roi-analysis': 'Promotion Data',
            'roi-tracker': 'Promotion Data',
            'promo-recommendation': 'Promotion Data',
            default: 'POS Data',
        },
        screenDetailsWithRoutes: [
            {
                label: 'Growth Analysis',
                path: 'promo/category-diagnostics/growth-analysis',
                id: 'ga',
                pageId: 'ga',
            },
            {
                label: 'Bump Report',
                path: 'promo/category-diagnostics/bump-report',
                id: 'br',
                pageId: 'br',
            },
            {
                label: 'PVM Analysis',
                path: 'promo/category-diagnostics/pvm-analysis',
                id: 'pvm',
                pageId: 'pvm',
            },
            {
                label: 'Price Change',
                path: 'pricing/analytics/price-change',
                id: 'pcn',
                pageId: 'pcn',
            },
            {
                label: 'Price Point',
                path: 'pricing/analytics/price-point',
                id: 'pp',
                pageId: 'pp',
            },
            {
                label: 'Price Ladder',
                path: 'pricing/analytics/price-ladder',
                id: 'pld',
                pageId: 'pld',
            },
            {
                label: 'Price Curve',
                path: 'pricing/analytics/price-curve',
                id: 'pc',
                pageId: 'pc',
            },
            {
                label: 'Price Tracking',
                path: 'pricing/analytics/price-tracking',
                id: 'pt',
                pageId: 'pt',
            },
            {
                label: 'Opportunity Identification',
                path: 'pricing/analytics/opportunity-identification',
                id: 'oi',
                pageId: 'oi',
            },
            {
                label: 'Promo Scorecard',
                path: 'promo/analytics/promo-score-card',
                id: 'ps',
                pageId: 'ps',
            },
            {
                label: 'Investment & ROI Tracker',
                path: 'promo/analytics/roi-tracker',
                id: 'pl',
                pageId: 'pl',
            },
            {
                label: 'Promo ROI Analysis',
                path: 'promo/analytics/roi-analysis',
                id: 'pa',
                pageId: 'pa',
            },
            {
                label: 'Promo Recommendation',
                path: 'promo/recommendation/promo-recommendation',
                id: 'pr',
                pageId: 'pr',
            },
            {
                label: 'Best Weeks',
                path: 'promo/recommendation/best-weeks',
                id: 'bw',
                pageId: 'bw',
            },
            {
                label: 'Pricing Simulator v1',
                path: 'pricing/recommendation/price-simulator',
                id: 'psr',
                pageId: 'psr',
            },
            {
                label: 'Pricing Simulator v1',
                path: 'pricing/recommendation/price-simulator/new',
                id: 'psr',
                pageId: 'psrNew',
            },
            {
                label: 'Pricing Simulator v1',
                path: 'pricing/recommendation/price-simulator/edit/:id',
                id: 'psr',
                pageId: 'psrEdit',
            },
            {
                label: 'Pricing Simulator v1',
                path: 'pricing/recommendation/price-simulator/view/:id',
                id: 'psr',
                pageId: 'psrView',
            },
            {
                label: 'Pricing Simulator',
                path: 'pricing/recommendation/pricing-simulator',
                id: 'psrV2', //update id in simulator context as well
                pageId: 'psrV2',
            },
            {
                label: 'Pricing Simulator ',
                path: 'pricing/recommendation/pricing-simulator/:mode/:projectId/scenario/:scenarioId',
                id: 'psr',
                pageId: 'psrV2Update',
            },
            {
                label: 'Pricing Simulator',
                path: 'pricing/recommendation/pricing-simulator/:mode/:projectId/scenario/:scenarioId',
                id: 'psr',
                pageId: 'psrV2View',
            },
            {
                label: 'Pricing Analytics',
                path: 'pricing/recommendation/pricing-analytics',
                id: 'psa',
                pageId: 'psa', // pricing analytics
            },
            {
                label: 'Pricing Analytics',
                path: 'pricing/recommendation/pricing-analytics/:mode/:reportId',
                id: 'psa',
                pageId: 'psaUpdate', // pricing analytics update
            },
            {
                label: 'Pricing Analytics',
                path: 'pricing/recommendation/pricing-analytics/:mode/:reportId',
                id: 'psa',
                pageId: 'psaView', // pricing analytics view
            },
        ],
        screens: [
            {
                label: 'Category Diagnostics',
                path: ['promo/category-diagnostics'],
                showSubHeader: false,
                options: {
                    Promo: [
                        {
                            label: 'Growth Analysis',
                            path: 'growth-analysis',
                            id: 'ga',
                        },
                        { label: 'Bump Report', path: 'bump-report', id: 'br' },
                    ],
                    visible: false,
                },
            },
            {
                label: 'Pricing Analytics',
                path: ['pricing/analytics', null],
                showSubHeader: false,
                options: {
                    Promo: [
                        {
                            label: 'Price Change',
                            path: 'price-change',
                            id: 'pcn',
                        },
                        { label: 'Price Point', path: 'price-point', id: 'pp' },
                        {
                            label: 'Price Ladder',
                            path: 'price-ladder',
                            id: 'pld',
                        },
                        { label: 'Price Curve', path: 'price-curve', id: 'pc' },
                        {
                            label: 'Price Tracking',
                            path: 'price-tracking',
                            id: 'pt',
                        },
                        {
                            label: 'Opportunity Identification',
                            path: 'opportunity-identification',
                            id: 'oi',
                        },
                    ],
                    visible: false,
                },
            },
            // {
            //     label: 'Promo Analytics',
            //     path: ['promo/analytics', null],
            //     showSubHeader: false,
            //     options: {
            //         Promo: [
            //             {
            //                 label: 'Promo Scorecard',
            //                 path: 'promo-score-card',
            //                 id: 'ps',
            //             },
            //             {
            //                 label: 'Investment & ROI Tracker',
            //                 path: 'roi-tracker',
            //                 id: 'pl',
            //             },
            //             {
            //                 label: 'Promo ROI Analysis',
            //                 path: 'roi-analysis',
            //                 id: 'pa',
            //             },
            //         ],
            //         visible: false,
            //     },
            // },
            // {
            //     label: 'Price & Promo Modeling',
            //     path: ['promo/recommendation', 'pricing/recommendation'],
            //     showSubHeader: true,
            //     options: {
            //         Promo: [
            //             {
            //                 label: 'Promo Recommendation',
            //                 path: 'promo-recommendation',
            //                 id: 'pr',
            //             },
            //             {
            //                 label: 'Best Weeks',
            //                 path: 'best-weeks',
            //                 id: 'bw',
            //             },
            //         ],
            //         Pricing: [
            //             {
            //                 label: 'Pricing Simulator v1',
            //                 path: 'price-simulator',
            //                 id: 'psr',
            //             },
            //             { label: 'Pricing Simulator', path: 'pricing-simulator', id: 'psrV2' },
            //         ],
            //         visible: false,
            //     },
            // },
        ],
        globalFilter: {
            presetConfig: {
                disablePresetFilter: false,
                presetEnabledRoutes: {
                    all: true,
                },
            },
            availableFrequenciesList: [{ key: 'W', label: 'Week' }],
            globalFilterChangingRoutes: {
                // 'growth-analysis': {
                //     dimensionListKey: 'growth_analysis',
                //     getGlobalTimestampsKey: 'default',
                //     getAttributeNamesKey: 'growth_analysis',
                //     groupKey: 'upc',
                //     // disabledAttributeTypes: ['manufacturer'],
                //     defaultGlobalFilterObj: {
                //         dim1: {
                //             Category: {
                //                 inclusion: [
                //                     {
                //                         dimension: 'dim1',
                //                         isActive: true,
                //                         attributeType: 'Category',
                //                         attributeDesc: 'TOTAL BARS',
                //                         attributeExId: 'TOTAL BARS',
                //                     },
                //                 ],
                //             },
                //         },
                //         dim2: {
                //             Retailer: {
                //                 inclusion: [
                //                     {
                //                         dimension: 'dim2',
                //                         isActive: true,
                //                         attributeType: 'Retailer',
                //                         attributeDesc: 'Kroger Corp w Roundys',
                //                         attributeExId: 'Kroger Corp w Roundys',
                //                     },
                //                 ],
                //             },
                //         },
                //     },
                // },
                // 'bump-report': {
                //     dimensionListKey: 'bump_report',
                //     getGlobalTimestampsKey: 'default',
                //     getAttributeNamesKey: 'bump_report',
                //     groupKey: 'upc',
                //     // disabledAttributeTypes: ['manufacturer'],
                //     defaultGlobalFilterObj: {
                //         dim1: {
                //             Category: {
                //                 inclusion: [
                //                     {
                //                         dimension: 'dim1',
                //                         isActive: true,
                //                         attributeType: 'Category',
                //                         attributeDesc: 'TOTAL BARS',
                //                         attributeExId: 'TOTAL BARS',
                //                     },
                //                 ],
                //             },
                //         },
                //         dim2: {
                //             Retailer: {
                //                 inclusion: [
                //                     {
                //                         dimension: 'dim2',
                //                         isActive: true,
                //                         attributeType: 'Retailer',
                //                         attributeDesc: 'Kroger Corp w Roundys',
                //                         attributeExId: 'Kroger Corp w Roundys',
                //                     },
                //                 ],
                //             },
                //         },
                //     },
                // },
                // 'promo-score-card': {
                //     dimensionListKey: 'promo_scorecard',
                //     getGlobalTimestampsKey: 'default',
                //     getAttributeNamesKey: 'promo_scorecard',
                //     groupKey: 'upc',
                //     // disabledAttributeTypes: ['manufacturer'],
                //     defaultGlobalFilterObj: {
                //         dim1: {
                //             Category: {
                //                 inclusion: [
                //                     {
                //                         dimension: 'dim1',
                //                         isActive: true,
                //                         attributeType: 'Category',
                //                         attributeDesc: 'TOTAL BARS',
                //                         attributeExId: 'TOTAL BARS',
                //                     },
                //                 ],
                //             },
                //         },
                //         dim2: {
                //             Retailer: {
                //                 inclusion: [
                //                     {
                //                         dimension: 'dim2',
                //                         isActive: true,
                //                         attributeType: 'Retailer',
                //                         attributeDesc: 'Kroger Corp w Roundys',
                //                         attributeExId: 'Kroger Corp w Roundys',
                //                     },
                //                 ],
                //             },
                //         },
                //     },
                // },
            },
            limit: 50,
            selectionAllowed: {
                'promo-recommendation': {
                    dim2: {
                        Retailer: 1,
                    },
                },
            },
            allSelectedLimit: 15,
            timePeriodScreenMapping: {
                default: ['4W', '12W', '26W', '52W', 'YTD', 'CUSTOM DATE'],
                'bump-report': ['52W', '104W', '156W', 'YTD', 'CUSTOM DATE'],
            },

            defaultPeriod: ['52W'],
            applyFilterApiPostFormat: {
                jsonstring_dim1: '{}',
                jsonstring_dim2: '{}',
            },
            defaultPreviousIdObject: {
                dim1: ['attr', 'attr'],
                dim2: ['attr', 'attr'],
            },
            defaultIdObject: {
                dim1: { ids: [] },
                dim2: { ids: [] },
            },
            defaultAttrIdObject: {
                attr: {
                    dim1: { ids: [] },
                    dim2: { ids: [] },
                },
            },
            promoScoreCardDefault: {
                Category: 'Pain Internal',
                Channel: 'ONLINE',
            },
            retainFiltersAcrossFeatures: true,
            PromoScoreCardDefaultObj: {
                dim1: {
                    Category: {
                        inclusion: [
                            {
                                dimension: 'dim1',
                                isActive: true,
                                attributeType: 'Category',
                                attributeDesc: 'Pain Internal',
                                attributeExId: 'Pain Internal',
                            },
                        ],
                    },
                },
                dim2: {
                    Channel: {
                        inclusion: [
                            {
                                dimension: 'dim2',
                                isActive: true,
                                attributeType: 'Channel',
                                attributeDesc: 'ONLINE',
                                attributeExId: 'ONLINE',
                            },
                        ],
                    },
                },
            },
        },
        priceSimulator: {
            dataSources: [
                { label: 'Projected Consumption', value: 'iri' },
                { label: 'Consumption Actuals', value: 'l52_weeks' },
                { label: 'Financials', value: 'financials' },
            ],
            allScenariosTableLimit: 500,
            a: 10,
            opportunityIdentificationTiles: [
                { key: 'recommendation', label: 'Recommendation' },
                { key: 'input', label: 'Input' },
                { key: 'output', label: 'Output' },
            ],
            cascadingColumns: ['COGS Rate', 'List Price', 'Everyday Retail Price'], // this should match with input key mapping and price simulator input columns
            levels: ['product', 'retailer'],
            inputKeyMapping: {
                // keep the order accuretly, to get it in multiselect
                cogs: 'COGS Rate',
                lp: 'List Price',
                rp: 'Everyday Retail Price',
                acv: 'ACV Distribution',
                oi: 'OI Rate',
                non_oi: 'Non OI Rate',
                promo_trade_spends: 'Promo Trade Rate Spends',
                tr: 'Trade Rate',
                cf: 'Comp Follow',
            },
            outputKeyMapping: {
                volume: {
                    label: 'New Volume',
                    pre: '',
                    pos: '',
                },
                volume_old: {
                    label: 'Current Volume',
                    pre: '',
                    pos: '',
                },
                vlmChg: {
                    label: 'Volume Chg %',
                    pre: '',
                    pos: '%',
                },
                units: {
                    label: 'New Units',
                    pre: '',
                    pos: '',
                },
                units_old: {
                    label: 'Current Units',
                    pre: '',
                    pos: '',
                },
                unitsChg: {
                    label: 'Units Chg %',
                    pre: '',
                    pos: '%',
                },
                rsv: {
                    label: 'New RSV',
                    pre: '$',
                    pos: '',
                },
                rsv_old: {
                    label: 'Current RSV',
                    pre: '$',
                    pos: '',
                },
                rsvChg: {
                    label: 'RSV Chg %',
                    pre: '',
                    pos: '%',
                },
                gsv: {
                    label: 'New GSV',
                    pre: '$',
                    pos: '',
                },
                gsv_old: {
                    label: 'Current GSV',
                    pre: '$',
                    pos: '',
                },
                gsvChg: {
                    label: 'GSV Chg %',
                    pre: '',
                    pos: '%',
                },
                nsv: {
                    label: 'New NSV',
                    pre: '$',
                    pos: '',
                },
                nsv_old: {
                    label: 'Current NSV',
                    pre: '$',
                    pos: '',
                },
                nsvChg: {
                    label: 'NSV Chg %',
                    pre: '',
                    pos: '%',
                },
                gmac: {
                    label: 'New GMAC',
                    pre: '$',
                    pos: '',
                },
                gmac_old: {
                    label: 'Current GMAC',
                    pre: '$',
                    pos: '',
                },
                gmacChg: {
                    label: 'GMAC Chg %',
                    pre: '',
                    pos: '%',
                },
                rtMg: {
                    label: 'New Retail Margin %',
                    pre: '',
                    pos: '%',
                },
                rtMg_old: {
                    label: 'Current Retail Margin %',
                    pre: '',
                    pos: '%',
                },
                rtMgPcChg: {
                    label: 'Retail Margin Chg %',
                    pre: '',
                    pos: '%',
                },
                retailer_profit: {
                    label: 'New Retail Profit',
                    pre: '',
                    pos: '',
                },
                retailer_profit_old: {
                    label: 'Current Retail Profit',
                    pre: '',
                    pos: '',
                },
                rtPfChg: {
                    label: 'Retail Profit Chg %',
                    pre: '',
                    pos: '%',
                },
                netRpChg: {
                    label: 'Net Effective Price % Chg',
                    pre: '',
                    pos: '%',
                },
                mgPc: {
                    label: 'New Margin %',
                    pre: '',
                    pos: '%',
                },
                mgPc_old: {
                    label: 'Current Margin %',
                    pre: '',
                    pos: '%',
                },
                mgPcChg: {
                    label: 'Margin Chg %',
                    pre: '',
                    pos: '%',
                },
                profitPool: {
                    label: 'New Profit Pool',
                    pre: '',
                    pos: '%',
                },
                profitPool_old: {
                    label: 'Current Profit Pool',
                    pre: '',
                    pos: '%',
                },
                profitPoolChg: {
                    label: 'Profit Pool Chg %',
                    pre: '',
                    pos: '$',
                },
                oi_cp: {
                    label: 'Current OI Rate',
                    pre: '',
                    pos: '%',
                },
                oi_np: {
                    label: 'New OI Rate',
                    pre: '',
                    pos: '',
                },
                oi_pc: {
                    label: 'OI Rate Chg %',
                    pre: '',
                    pos: '%',
                },
                non_oi_cp: {
                    label: 'Current Non OI Rate',
                    pre: '',
                    pos: '',
                },
                non_oi_np: {
                    label: 'New Non OI Rate',
                    pre: '',
                    pos: '',
                },
                non_oi_pc: {
                    label: 'Non OI Rate Chg %',
                    pre: '',
                    pos: '%',
                },
                promo_trade_spends_cp: {
                    label: 'Current Promo Trade Rate Spends',
                    pre: '',
                    pos: '',
                },
                promo_trade_spends_np: {
                    label: 'Current Promo Trade Rate Spends',
                    pre: '',
                    pos: '',
                },
                promo_trade_spends_pc: {
                    label: 'Promo Trade Rate Spends Chg %',
                    pre: '',
                    pos: '%',
                },
                tr_cp: {
                    label: 'Current Trade Rate',
                    pre: '',
                    pos: '',
                },
                tr_np: {
                    label: 'New Trade Rate',
                    pre: '',
                    pos: '',
                },
                tr_pc: {
                    label: 'Trade Rate Chg %',
                    pre: '',
                    pos: '%',
                },
            },
            recommendationKeyMapping: {
                recommended_list_price: {
                    label: 'New list price recom',
                    pre: '$',
                    pos: '',
                },
                role: {
                    label: 'Role',
                    pre: '',
                    pos: '',
                },
                strategy: {
                    label: 'Strategy',
                    pre: '',
                    pos: '',
                },
                mix: {
                    label: 'Mix',
                    pre: '',
                    pos: '',
                },
                growth: {
                    label: 'Growth',
                    pre: '',
                    pos: '',
                },
                gap: {
                    label: 'Gap',
                    pre: '',
                    pos: '',
                },

                cogs: {
                    label: 'COGs',
                    pre: '',
                    pos: '%',
                },
                list_to_retail: {
                    label: 'List to Retail',
                    pre: '',
                    pos: '',
                },
                bpe: {
                    label: 'BPE',
                    pre: '',
                    pos: '',
                },
                ppe: {
                    label: 'PPE',
                    pre: '',
                    pos: '',
                },
                margin: {
                    label: 'Margin',
                    pre: '',
                    pos: '%',
                },
                growth_vs_category: {
                    label: 'Gowth vs Category',
                    pre: '',
                    pos: '%',
                },
                pl_vs_category: {
                    label: 'PL vs Category',
                    pre: '',
                    pos: '%',
                },
                threshold: {
                    label: 'Threshold',
                    pre: '',
                    pos: '',
                },
                comp_index: {
                    label: 'Comp. Index',
                    pre: '',
                    pos: '',
                },
                curve_index: {
                    label: 'Curve Index',
                    pre: '',
                    pos: '',
                },
                cogs_realization: {
                    label: 'COGS & Realization',
                    pre: '',
                    pos: '',
                },
                cogs_forecast: {
                    label: 'COGS Forecast',
                    pre: '',
                    pos: '%',
                },
                net_to_retail: {
                    label: 'Net to Retail',
                    pre: '',
                    pos: '%',
                },
                gross_to_net: {
                    label: 'Gross to Net',
                    pre: '',
                    pos: '%',
                },
            },
            defaultKpiMetrics: [1, 2, 3, 4, 5],
            kpiMetrics: [
                {
                    key: 1,
                    value: 'volume_sales',
                    name: 'Kind Volume Sales',
                    pre: '',
                    post: '',
                    decimalToRoundOff: 0,
                },
                {
                    key: 2,
                    value: 'value_sales',
                    name: 'Kind Value Sales ($)',
                    pre: '$',
                    post: '',
                    decimalToRoundOff: 0,
                },
                {
                    key: 3,
                    value: 'profit_abs',
                    name: 'Kind Profit Abs ($)',
                    pre: '$',
                    post: '',
                    decimalToRoundOff: 0,
                },
                {
                    key: 4,
                    value: 'margin_percent',
                    name: 'Kind Margin (%)',
                    pre: '',
                    post: '%',
                    decimalToRoundOff: 2,
                },
                {
                    key: 5,
                    value: 'trade_rate_percent',
                    name: 'Kind Trade Rate (%)',
                    pre: '',
                    post: '%',
                    decimalToRoundOff: 2,
                },
                {
                    key: 6,
                    value: 'retailer_margin_percent',
                    name: 'Kind Retailer Margin (%)',
                    pre: '',
                    post: '%',
                    decimalToRoundOff: 2,
                },
                {
                    key: 7,
                    value: 'gross_profit',
                    name: 'Kind Gross Profit ($)',
                    pre: '$',
                    post: '',
                    decimalToRoundOff: 0,
                },
                {
                    key: 8,
                    value: 'retailer_profit',
                    name: 'Kind Retailer Profit ($)',
                    pre: '$',
                    post: '',
                    decimalToRoundOff: 0,
                },
                {
                    key: 9,
                    value: 'gross_sales',
                    name: 'Kind Gross Sales ($)',
                    pre: '$',
                    post: '',
                    decimalToRoundOff: 0,
                },
                {
                    key: 10,
                    value: 'net_sales',
                    name: 'Kind Net Sales($)',
                    pre: '$',
                    post: '',
                    decimalToRoundOff: 0,
                },
                {
                    key: 11,
                    value: 'total_volume',
                    name: 'Total Volume Sales',
                    pre: '$',
                    post: '',
                    decimalToRoundOff: 0,
                },
                {
                    key: 12,
                    value: 'total_value',
                    name: 'Total Value Sales($)',
                    pre: '$',
                    post: '',
                    decimalToRoundOff: 0,
                },
                {
                    key: 13,
                    value: 'net_retail_price_change',
                    name: 'Kind Net Retailer Price % Chg',
                    pre: '',
                    post: '%',
                    decimalToRoundOff: 2,
                },
            ],
            addPortfolioUpdateKpis: [
                {
                    key: 'volume',
                    value: '',
                    label: 'Volume',
                    rval: '',
                    percentChange: '',
                },
                {
                    key: 'value',
                    value: '',
                    label: 'Value',
                    rval: '',
                    percentChange: '',
                },
                {
                    key: 'units',
                    value: '',
                    label: 'Units',
                    rval: '',
                    percentChange: '',
                },
                {
                    key: 'trade_rate',
                    value: '',
                    label: 'Trade Rate %',
                    rval: '',
                    percentChange: '',
                },
                {
                    key: 'list_price',
                    value: '',
                    label: 'List Price per unit',
                    rval: '',
                    percentChange: '',
                },
                {
                    key: 'retail_price',
                    value: '',
                    label: 'Retail Price per unit',
                    rval: '',
                    percentChange: '',
                },
                {
                    key: 'acv',
                    value: '',
                    label: 'ACV Distribution %',
                    rval: '',
                    percentChange: '',
                },
                {
                    key: 'cogs',
                    value: '',
                    label: 'COGS per unit',
                    rval: '',
                    percentChange: '',
                },
                {
                    key: 'base_elasticity',
                    value: '',
                    label: 'Base Elasticity',
                    rval: '',
                    percentChange: '',
                },
                {
                    key: 'acv_elasticity',
                    value: '',
                    label: 'Acv Elasticity',
                    rval: '',
                    percentChange: '',
                },
            ],
            quarterMetricKeyMapping: [
                {
                    name: 'Volume',
                    value: 'volume',
                    pre: '',
                    post: '',
                },
                {
                    name: 'Revenue',
                    value: 'revenue',
                    pre: '$',
                    post: '',
                },
                {
                    name: 'Profit',
                    value: 'profit',
                    pre: '$',
                    post: '',
                },
                {
                    name: 'Trade Rate Percent',
                    value: 'tradeRatePercent',
                    pre: '',
                    post: '%',
                },
                {
                    name: 'Retailer Margin',
                    value: 'retailerMargin',
                    pre: '',
                    post: '',
                },
            ],
        },
        pricingSimulator: {
            enableAnalyticsTab: true,
            enableBulkUpload: false,
            indexPageTableLimit: 50,
            scenarioFilterOffsetLimit: 50,
            scenarioPerProjectLimit: 10,
            scenarioTableLimit: 500,
            analyticsChartLimit: 100,
            comparisonTableLimit: 50,
            dimAttributesLimit: 4,
            characterLimit: {
                kpiTileCharLimit: 22,
                kpiCompareCardLimit: 30,
            },
            enablePrivatePublicToggle: false,
            enableMicroInfoForTables: false,
            enableOneChangeAnalyticsChart: false,
            defaultGlobalKpiCount: 6,
            disableExport: true,
            indexTableFixedColumns: [
                { label: 'Project Name', key: 'projectName', sortKey: 'project_name' },
                { label: 'Created By', key: 'createdBy', sortKey: 'created_by' },
                { label: 'Status', key: 'status' },
                { label: 'Last Updated', key: 'lastUpdated', sortKey: 'updated_at' },
                { label: 'Simulation Period', key: 'simulationPeriod' },
                { label: 'Price Effective Date', key: 'priceEffectiveDate' },
            ],
            analyticsBaseScenarioFixedColumns: [
                { label: 'Project Name', key: 'projectName', sortKey: 'project_name' },
                { label: 'Created By', key: 'createdBy', sortKey: 'created_by' },
                { label: 'Status', key: 'status' },
            ],
            analyticsTableColumns: [
                { label: 'Report Name', key: 'reportName', sortKey: 'report_name' },
                { label: 'Base Scenario', key: 'baseScenario', sortKey: 'base_scenario' },
                { label: 'Created By', key: 'createdBy', sortKey: 'created_by' },
                { label: 'Last Updated', key: 'lastUpdated', sortKey: 'updated_at' },
                { label: 'Date Created', key: 'dateCreated', sortKey: 'created_at' },
            ],

            projectStatuses: {
                ACTIVE: { label: 'Active', colorType: 'success' },
                DRAFT: { label: 'Draft', colorType: 'processing' },
                SETUP: { label: 'Setup', colorType: 'processing' },
                IN_PROGRESS: { label: 'In-Progress', colorType: 'processing' },
                EXPIRED: { label: 'Expired', colorType: 'default' },
                ERROR: { label: 'Error', colorType: 'error' },
                INVALID: { label: 'Invalid', colorType: 'error' },
            },
            projectDataSource: [{ label: 'Actuals', value: 'depletion_data' }],
            simulatedPeriodItems: [
                { label: 'Custom Date', value: 'custom_date', dateArray: null },
                { label: 'Current Year', value: 'current_year', dateArray: ['01-05-2025', '12-28-2025'] },
                { label: 'Financial Year', value: 'financial_year', dateArray: ['03-02-2025', '02-22-2026'] },
            ],
            iconsMappings: {
                Elasticity: 'BorderOuterOutlined',
                BaseInput: 'BorderlessTableOutlined',
                COGS: 'DollarOutlined',
                Distributor: 'BuildOutlined',
                'Distributor P&L': 'BuildOutlined',
                FOB: 'ClusterOutlined',
                'P & L': 'LineChartOutlined',
                'Price Tree': 'MoneyCollectOutlined',
                Promotions: 'BoxPlotOutlined',
                'Retailer P&L': 'LineChartOutlined',
                Sales: 'AreaChartOutlined',
                Taxes: 'BlockOutlined',
                Volume: 'ExperimentOutlined',
                Others: 'UngroupOutlined',
                Product: 'GoldOutlined',
                Geo: 'ExpandOutlined',
                'Dollar Impact': 'DollarOutlined',
                'Standard Increase Metrics': 'ToTopOutlined',
                'EQV Metrics': 'BlockOutlined',
            },

            categoryMovementKpis: [
                { label: 'Volume Impact', value: 'volume', yAxisLabel: 'Vol', xAxisLabel: 'Retailer Vol' },
                { label: 'Sales Impact', value: 'sales', yAxisLabel: 'Sales $', xAxisLabel: 'Retailer Sales $' },
            ],
        },
        priceChange: {
            // TODO: remove unwanted props
            limit: 60,
            dimensionConfig: {
                //snake case eg sub_category
                excludedDimensions: [],
                defaultDimension: 'Vendor',
            },
            hiddenTableRows: [],
            timePeriodOptions: [
                { label: 'YA', value: 'year_ago' },
                { label: 'Prior Period', value: 'prior_period' },
                { label: 'Custom Period', value: 'custom' },
            ],
            absTileData: [
                { key: 'abs', label: 'Abs' },
                { key: 'percentage', label: '%' },
            ],
            kpiListData: [
                {
                    key: 'avg_price',
                    label: 'Avg Price',
                    value: 'average',
                    dataKey: 'avg_price',
                },
                {
                    key: 'base_price',
                    label: 'Base Price',
                    value: 'base',
                    dataKey: 'base_price',
                },
            ],
            volTileData: [
                {
                    key: 'units',
                    label: 'PU',
                    value: 'units',
                    dataKey: 'units',
                    tooltip: 'Per Unit',
                },
                // {
                //     key: 'vol',
                //     label: 'PEQ',
                //     value: 'vol',
                //     dataKey: 'volume',
                //     tooltip: 'Per Eq Volume',
                // },
            ],
            salesTileData: [
                { key: 'sales', label: 'Sales' },
                { key: 'incremental', label: 'Incremental' },
                { key: 'promo', label: 'Promo' },
            ],
            salesAttributionChart: {
                colorList: ['#10AB5E', '#DC3826'],
                colorListType2: ['#758BEE', '#758BEE'],
                profitPoolColor: ['#826FD0', '#826FD0'],
                backGroundColor: 'rgba(0, 0, 0, 0.02)',
            },
            salesAttributionDrillDownChartKeyValueMapping: {
                'feature_&_display': 'Feature & Display',
                'Feature & Display': 'feature_&_display',
            },
            salesAttributionChart2Limit: 20,
        },
        growthAnalysis: {
            limit: 60,
            includeAggPeriod: true,
            dimensionConfig: {
                //snake case eg sub_category
                excludedDimensions: [],
                defaultDimension: 'Vendor',
            },
            absTileData: [
                { key: 'abs', label: 'Abs' },
                { key: 'percentage', label: '%' },
            ],
            subTileData: [
                {
                    label: 'PU',
                    key: 'PU',
                },
                {
                    label: 'PEQ',
                    key: 'PEQ',
                },
            ],
            volTileData: [
                {
                    key: 'val',
                    label: 'SEK',
                    value: 'val',
                    dataKey: 'value',
                },
                // {
                //     key: 'vol',
                //     label: 'Eq Volume',
                //     value: 'vol',
                //     dataKey: 'volume',
                // },
                {
                    key: 'units',
                    label: 'Units',
                    value: 'units',
                    dataKey: 'units',
                },
                // { key: 'profit', label: 'Profit', value: 'profit', dataKey: 'profit' },
            ],
            showTotal: true,
            currentYearLabel: 'CY',
            yearAgoLabel: 'YA',
            trendChartDropdownData: [
                {
                    key: 'sales_volume',
                    label: 'Sales Volume',
                    value: 'sales_volume',
                    dataKey: 'sales_volume',
                },
                {
                    key: 'sales',
                    label: 'Sales $',
                    value: 'sales',
                    dataKey: 'sales',
                },
                {
                    key: 'average_price',
                    label: 'Average Price',
                    value: 'average_price',
                    dataKey: 'average_price',
                },
                {
                    key: 'base_price',
                    label: 'Base Price',
                    value: 'base_price',
                    dataKey: 'base_price',
                },
                { key: 'acv', label: '%ACV', value: 'acv', dataKey: 'acv' },
                {
                    key: 'avg_items',
                    label: 'Avg. no. of items',
                    value: 'avg_items',
                    dataKey: 'avg_items',
                },
                { key: 'tdp', label: 'TDP', value: 'tdp', dataKey: 'tdp' },
            ],
            salesTileData: [
                { key: 'sales', label: 'Sales' },
                { key: 'incremental', label: 'Incremental' },
                // { key: 'promo', label: 'Promo' },
            ],
            graphExportHeaderMapping: {
                promo: ['Non-promo', 'Promo'],
                incremental: ['Base', 'Incremental'],
                sales: ['Sales Change'],
            },
            depletionDropdownData: [
                {
                    value: 'frontline_sales',
                    dataKey: 'frontline_sales',
                    key: 'frontline_sales',
                    label: 'Frontline Sales',
                },
                {
                    value: 'net_sales',
                    dataKey: 'net_sales',
                    key: 'net_sales',
                    label: 'Net Sales',
                },
            ],
            tableKeyUnitMapping: {
                'Market Share CY': {
                    unit: '%',
                    label: 'Market Share CY',
                    includePercentageChange: false,
                },
                'Market Share YA': {
                    unit: '%',
                    label: 'Market Share YA',
                    includePercentageChange: false,
                },
                'ACV CY': {
                    unit: '%',
                    label: 'Wtd. Avg ACV %',
                    includePercentageChange: false,
                },
                'ACV YA': {
                    unit: '%',
                    label: 'Wtd. Avg ACV % YA',
                    includePercentageChange: false,
                },
            },
            salesAttributionChart: {
                colorList: ['#10AB5E', '#DC3826'],
                colorListType2: ['#758BEE', '#758BEE'],
                profitPoolColor: ['#826FD0', '#826FD0'],
                backGroundColor: 'rgba(0, 0, 0, 0.02)',
            },
            salesAttributionDrillDownChartKeyValueMapping: {
                'feature_&_display': 'Feature & Display',
                'Feature & Display': 'feature_&_display',
            },
            salesAttributionChart2DisabledItems: ['unexplained'],
            salesAttributionChart2Limit: 50,
        },
        //BUMP REPORT
        bumpReport: {
            mainHeader: 'Bump Report',
            groupByKey: 'groupBy',
            comparisonTileData: [
                { key: 'cy_vs_ya', label: 'CY vs YA' },
                { key: 'difference', label: 'Difference' },
            ],
            enablePromoCalender: true,
            isPromoUpliftPercentValue: false,
            volGroupByOptionsMapping: {
                vol: [
                    {
                        value: 'total_eq_volume',
                        label: 'Total EQ Volume',
                        index: 1,
                    },
                    {
                        value: 'any_promo_eq_volume',
                        label: 'Any promo EQ Volume',
                        index: 1,
                    },
                    {
                        value: 'no_promo_eq_volume',
                        label: 'No Promo EQ Volume',
                        index: 1,
                    },

                    {
                        value: 'base_eq_volume',
                        label: 'Base EQ Volume',
                        index: 0,
                    },
                    {
                        value: 'incremental_eq_volume',
                        label: 'Incremental EQ Volume Total',
                        index: 0,
                    },
                    {
                        value: 'tpr_incremental_eq_volume',
                        label: 'Incremental EQ Volume TPR',
                        index: 0,
                    },
                    {
                        value: 'feature_incremental_eq_volume',
                        label: 'Incremental EQ Volume Feature',
                        index: 0,
                    },
                    {
                        value: 'display_incremental_eq_volume',
                        label: 'Incremental EQ Volume Display',
                        index: 0,
                    },
                    {
                        value: 'feature_and_display_incremental_eq_volume',
                        label: 'Incremental EQ Volume Feature & Display',
                        index: 0,
                    },
                ],
                val: [
                    { value: 'total_value', label: 'Total Value', index: 1 },
                    // {
                    //     value: 'any_promo_value',
                    //     label: 'Any Promo Value',
                    //     index: 1,
                    // },
                    // {
                    //     value: 'no_promo_value',
                    //     label: 'No Promo Value',
                    //     index: 1,
                    // },
                    { value: 'base_value', label: 'Base Value', index: 0 },
                    {
                        value: 'incremental_value',
                        label: 'Incremental Value Total',
                        index: 0,
                    },
                    // {
                    //     value: 'tpr_incremental_value',
                    //     label: 'Incremental Value TPR',
                    //     index: 0,
                    // },
                    // {
                    //     value: 'feature_incremental_value',
                    //     label: 'Incremental Value Feature',
                    //     index: 0,
                    // },
                    // {
                    //     value: 'display_incremental_value',
                    //     label: 'Incremental Value Display',
                    //     index: 0,
                    // },
                    // {
                    //     value: 'feature_and_display_incremental_value',
                    //     label: 'Incremental Value Feature & Display',
                    //     index: 0,
                    // },
                ],
                units: [
                    { value: 'total_units', label: 'Total Units', index: 1 },
                    // {
                    //     value: 'any_promo_units',
                    //     label: 'Any Promo Units',
                    //     index: 1,
                    // },
                    // {
                    //     value: 'no_promo_units',
                    //     label: 'No Promo Units',
                    //     index: 1,
                    // },
                    { value: 'base_units', label: 'Base Units', index: 0 },
                    {
                        value: 'incremental_units',
                        label: 'Incremental Units Total',
                        index: 0,
                    },
                    // {
                    //     value: 'tpr_incremental_units',
                    //     label: 'Incremental Units TPR',
                    //     index: 0,
                    // },
                    // {
                    //     value: 'feature_incremental_units',
                    //     label: 'Incremental Units Feature',
                    //     index: 0,
                    // },
                    // {
                    //     value: 'display_incremental_units',
                    //     label: 'Incremental Units Display',
                    //     index: 0,
                    // },
                    // {
                    //     value: 'feature_and_display_incremental_units',
                    //     label: 'Incremental Units Feature & Display',
                    //     index: 0,
                    // },
                ],
            },
            tooltipKeyLabelMapping: {
                increments: 'Incremental',
                promo: 'Any Promo',
            },
            bumpReportTileData: [
                { key: 'increments', label: 'Attribution' },
                // { key: 'promo', label: 'Consumption' },
                { key: 'groupBy', label: 'Group By' },
            ],
            bumpReportTile1Data: [
                {
                    key: 'promo',
                    label: 'Promotions',
                    visibleTabs: ['increments', 'promo', 'groupBy'],
                }, //keys should match bumpReportTileData keys
            ],
            bumpReportTile2Data: [
                { key: 'total', label: 'Total' },
                // { key: 'breakout', label: 'Breakout' },
            ],
            absTileData: [
                { key: 'abs', label: 'Abs' },
                { key: 'percentage', label: '%' },
            ],

            volTileData: [
                { key: 'val', label: 'SEK', dataKey: 'value' },
                // { key: 'vol', label: 'Eq Volume', dataKey: 'volume' },
                { key: 'units', label: 'Units', dataKey: 'units' },
            ],
            bumpChartY2Colors: [
                '#293BB8',
                '#DD449F',
                '#9E5897',
                '#19669D',
                '#43C9E2',
                '#37C7BE',
                '#00798C',
                '#E8A122',
                '#E06936',
                '#A5582D',
            ],
            bumpChartY2AxisOptions: {
                vol: [
                    {
                        value: 'avg_price_per_eq',
                        index: 0,
                        label: 'Avg. Price/EQ',
                        unit: '',
                    },
                    {
                        value: 'base_price_per_eq',
                        index: 0,
                        label: 'Base Price/EQ',
                        unit: '',
                    },
                    {
                        value: 'promo_price_per_eq',
                        index: 0,
                        label: 'Promo Price/EQ',
                        unit: '',
                    },
                    {
                        value: 'market_share_volume',
                        index: 0,
                        label: 'Market Share %',
                        unit: '',
                    },
                    {
                        value: 'distribution_tdp',
                        index: 0,
                        label: 'Distribution TDP',
                        unit: '',
                    },
                    {
                        value: 'display_tdp',
                        index: 0,
                        label: 'Display TDP',
                        unit: '',
                    },
                    {
                        value: 'feature_tdp',
                        index: 0,
                        label: 'Feature TDP',
                        unit: '',
                    },
                    {
                        value: 'feature_and_display_tdp',
                        index: 0,
                        label: 'Feature and Display TDP',
                        unit: '',
                    },
                    {
                        value: 'distribution_acv',
                        index: 0,
                        label: 'Distribution ACV %',
                        unit: '',
                    },
                    {
                        value: 'display_acv',
                        index: 0,
                        label: 'Display ACV %',
                        unit: '',
                    },
                    {
                        value: 'feature_acv',
                        index: 0,
                        label: 'Feature ACV %',
                        unit: '',
                    },
                    {
                        value: 'feature_and_display_acv',
                        index: 0,
                        label: 'Feature & Display ACV %',
                        unit: '',
                    },
                    {
                        value: 'unit_velocity',
                        index: 0,
                        label: 'Unit Velocity',
                        unit: '',
                    },
                    {
                        value: 'sales_velocity',
                        index: 0,
                        label: 'Dollar Velocity',
                        unit: '$',
                    },
                    {
                        value: 'volume_velocity',
                        index: 0,
                        label: 'Eq Velocity',
                        unit: '',
                    },
                    {
                        value: 'subsidized_base_sales',
                        index: 0,
                        label: 'Subsidized Base Sales',
                        unit: '',
                    },
                ],
                val: [
                    {
                        value: 'avg_price_per_unit',
                        index: 0,
                        label: 'Avg. Price/Unit (kr)',
                        unit: '',
                    },
                    {
                        value: 'base_price_per_unit',
                        index: 0,
                        label: 'Base Price/unit',
                        unit: '',
                    },
                    {
                        value: 'promo_price_per_unit',
                        index: 0,
                        label: 'Promo Price/Unit',
                        unit: '',
                    },
                    // {
                    //     value: 'market_share_value',
                    //     index: 0,
                    //     label: 'Market Share %',
                    //     unit: '',
                    // },
                    {
                        value: 'distribution_tdp',
                        index: 0,
                        label: 'Distribution TDP',
                        unit: '',
                    },
                    // {
                    //     value: 'display_tdp',
                    //     index: 0,
                    //     label: 'Display TDP',
                    //     unit: '',
                    // },
                    // {
                    //     value: 'feature_tdp',
                    //     index: 0,
                    //     label: 'Feature TDP',
                    //     unit: '',
                    // },
                    // {
                    //     value: 'feature_and_display_tdp',
                    //     index: 0,
                    //     label: 'Feature and Display TDP',
                    //     unit: '',
                    // },
                    // {
                    //     value: 'distribution_acv',
                    //     index: 0,
                    //     label: 'Distribution ACV %',
                    //     unit: '',
                    // },
                    // {
                    //     value: 'display_acv',
                    //     index: 0,
                    //     label: 'Display ACV %',
                    //     unit: '',
                    // },
                    // {
                    //     value: 'feature_acv',
                    //     index: 0,
                    //     label: 'Feature ACV %',
                    //     unit: '',
                    // },
                    // {
                    //     value: 'feature_and_display_acv',
                    //     index: 0,
                    //     label: 'Feature & Display ACV %',
                    //     unit: '',
                    // },
                    {
                        value: 'unit_velocity',
                        index: 0,
                        label: 'Unit Velocity',
                        unit: '',
                    },
                    {
                        value: 'sales_velocity',
                        index: 0,
                        label: 'SEK Velocity',
                        unit: 'kr',
                    },
                    // {
                    //     value: 'volume_velocity',
                    //     index: 0,
                    //     label: 'Eq Velocity',
                    //     unit: '',
                    // },
                    // {
                    //     value: 'subsidized_base_sales',
                    //     index: 0,
                    //     label: 'Subsidized Base Sales',
                    //     unit: '',
                    // },
                ],
                units: [
                    {
                        value: 'avg_price_per_unit',
                        index: 0,
                        label: 'Avg. Price/Unit (kr)',
                        unit: '',
                    },
                    {
                        value: 'base_price_per_unit',
                        index: 0,
                        label: 'Base Price/unit',
                        unit: '',
                    },
                    {
                        value: 'promo_price_per_unit',
                        index: 0,
                        label: 'Promo Price/Unit',
                        unit: '',
                    },
                    // {
                    //     value: 'market_share_value',
                    //     index: 0,
                    //     label: 'Market Share %',
                    //     unit: '',
                    // },
                    {
                        value: 'distribution_tdp',
                        index: 0,
                        label: 'Distribution TDP',
                        unit: '',
                    },
                    // {
                    //     value: 'display_tdp',
                    //     index: 0,
                    //     label: 'Display TDP',
                    //     unit: '',
                    // },
                    // {
                    //     value: 'feature_tdp',
                    //     index: 0,
                    //     label: 'Feature TDP',
                    //     unit: '',
                    // },
                    // {
                    //     value: 'feature_and_display_tdp',
                    //     index: 0,
                    //     label: 'Feature and Display TDP',
                    //     unit: '',
                    // },
                    // {
                    //     value: 'distribution_acv',
                    //     index: 0,
                    //     label: 'Distribution ACV %',
                    //     unit: '',
                    // },
                    // {
                    //     value: 'display_acv',
                    //     index: 0,
                    //     label: 'Display ACV %',
                    //     unit: '',
                    // },
                    // {
                    //     value: 'feature_acv',
                    //     index: 0,
                    //     label: 'Feature ACV %',
                    //     unit: '',
                    // },
                    // {
                    //     value: 'feature_and_display_acv',
                    //     index: 0,
                    //     label: 'Feature & Display ACV %',
                    //     unit: '',
                    // },
                    {
                        value: 'unit_velocity',
                        index: 0,
                        label: 'Unit Velocity',
                        unit: '',
                    },
                    {
                        value: 'sales_velocity',
                        index: 0,
                        label: 'SEK Velocity',
                        unit: 'kr',
                    },
                    // {
                    //     value: 'volume_velocity',
                    //     index: 0,
                    //     label: 'Eq Velocity',
                    //     unit: '',
                    // },
                    // {
                    //     value: 'subsidized_base_sales',
                    //     index: 0,
                    //     label: 'Subsidized Base Sales',
                    //     unit: '',
                    // },
                ],
            },
            promoTypeColorMapping: {
                'tpr/scan': {
                    label: 'TPR/Scan',
                    color: colorConstants.lightGreenAlt,
                },
                'feature ad': {
                    label: 'Feature Ad',
                    color: colorConstants.darkGreenAlt2,
                },
                display: { label: 'Display', color: colorConstants.pinkAlt },
                feature_display_tpr: {
                    label: 'Feature_Display_TPR',
                    color: colorConstants.orangeAlt2,
                },
                display_tpr: {
                    label: 'Display_TPR',
                    color: colorConstants.darkBlueAlt,
                },
            },
            stackedColors: [
                colorConstants.lightGreenAlt,
                colorConstants.darkGreenAlt2,
                colorConstants.pinkAlt,
                colorConstants.orangeAlt2,
                colorConstants.darkYellow,
            ],
            fieldKeyLabelMapping: {
                base_eq_volume: {
                    label: 'Base Sales (Eq Vol)',
                    color: colorConstants.darkYellow,
                    tableLabel: 'Base',
                },
                base_value: {
                    label: 'Base Sales ($)',
                    color: colorConstants.darkYellow,
                    tableLabel: 'Base',
                },
                base_units: {
                    label: 'Base Units',
                    color: colorConstants.darkYellow,
                    tableLabel: 'Base',
                },
                incremental_eq_volume: {
                    label: 'Incremental Sales (Eq Vol)',
                    color: colorConstants.darkGreenAlt2,
                    tableLabel: 'Incremental',
                },
                incremental_value: {
                    label: 'Incremental Sales ($)',
                    color: colorConstants.darkGreenAlt2,
                    tableLabel: 'Incremental',
                },
                incremental_units: {
                    label: 'Incremental Units',
                    color: colorConstants.darkGreenAlt2,
                    tableLabel: 'Incremental',
                },
                any_promo_eq_volume: {
                    label: 'Promo',
                    color: colorConstants.darkGreenAlt2,
                    tableLabel: 'Promo',
                },
                any_promo_value: {
                    label: 'Promo',
                    color: colorConstants.darkGreenAlt2,
                    tableLabel: 'Promo',
                },
                any_promo_units: {
                    label: 'Promo',
                    color: colorConstants.darkGreenAlt2,
                    tableLabel: 'Promo',
                },
                tpr_incremental_eq_volume: {
                    label: 'TPR Incremental',
                    color: colorConstants.lightGreenAlt,
                    tableLabel: 'TPR Incremental',
                },
                feature_incremental_eq_volume: {
                    label: 'Feature Incremental',
                    color: colorConstants.darkGreenAlt2,
                    tableLabel: 'Feature Incremental',
                },
                display_incremental_eq_volume: {
                    label: 'Display Incremental',
                    color: colorConstants.pinkAlt,
                    tableLabel: 'Display Incremental',
                },
                feature_and_display_incremental_eq_volume: {
                    label: 'F & D Incremental',
                    color: colorConstants.orangeAlt2,
                    tableLabel: 'F & D Incremental',
                },
                tpr_incremental_value: {
                    label: 'TPR Incremental',
                    color: colorConstants.lightGreenAlt,
                    tableLabel: 'TPR Incremental',
                },
                feature_incremental_value: {
                    label: 'Feature Incremental',
                    color: colorConstants.darkGreenAlt2,
                    tableLabel: 'Feature Incremental',
                },
                display_incremental_value: {
                    label: 'Display Incremental',
                    color: colorConstants.pinkAlt,
                    tableLabel: 'Display Incremental',
                },
                feature_and_display_incremental_value: {
                    label: 'F & D Incremental',
                    color: colorConstants.orangeAlt2,
                    tableLabel: 'F & D Incremental',
                },
                tpr_incremental_units: {
                    label: 'TPR Incremental',
                    color: colorConstants.lightGreenAlt,
                    tableLabel: 'TPR Incremental',
                },
                feature_incremental_units: {
                    label: 'Feature Incremental',
                    color: colorConstants.darkGreenAlt2,
                    tableLabel: 'Feature Incremental',
                },
                display_incremental_units: {
                    label: 'Display Incremental',
                    color: colorConstants.pinkAlt,
                    tableLabel: 'Display Incremental',
                },
                feature_and_display_incremental_units: {
                    label: 'F & D Incremental',
                    color: colorConstants.orangeAlt2,
                    tableLabel: 'F & D Incremental',
                },
                tpr_only_eq_volume: {
                    label: 'TPR',
                    color: colorConstants.lightGreenAlt,
                    tableLabel: 'TPR',
                },
                tpr_only_value: {
                    label: 'TPR',
                    color: colorConstants.lightGreenAlt,
                    tableLabel: 'TPR',
                },
                feature_only_eq_volume: {
                    label: 'Feature',
                    color: colorConstants.darkGreenAlt2,
                    tableLabel: 'Feature',
                },
                feature_only_value: {
                    label: 'Feature',
                    color: colorConstants.darkGreenAlt2,
                    tableLabel: 'Feature',
                },
                display_only_eq_volume: {
                    label: 'Display',
                    color: colorConstants.pinkAlt,
                    tableLabel: 'Display',
                },
                display_only_value: {
                    label: 'Display',
                    color: colorConstants.pinkAlt,
                    tableLabel: 'Display',
                },
                feature_and_display_only_eq_volume: {
                    label: 'F & D',
                    color: colorConstants.orangeAlt2,
                    tableLabel: 'F & D',
                },
                feature_and_display_only_value: {
                    label: 'F & D',
                    color: colorConstants.orangeAlt2,
                    tableLabel: 'F & D',
                },
                no_promo_eq_volume: {
                    label: 'Non Promo',
                    color: colorConstants.darkYellow,
                    tableLabel: 'Non Promo',
                },
                no_promo_value: {
                    label: 'Non Promo',
                    color: colorConstants.darkYellow,
                    tableLabel: 'Non Promo',
                },
                tpr_only_units: {
                    label: 'TPR',
                    color: colorConstants.lightGreenAlt,
                    tableLabel: 'TPR',
                },
                feature_only_units: {
                    label: 'Feature',
                    color: colorConstants.darkGreenAlt2,
                    tableLabel: 'Feature',
                },
                display_only_units: {
                    label: 'Display',
                    color: colorConstants.pinkAlt,
                    tableLabel: 'Display',
                },
                feature_and_display_only_units: {
                    label: 'F & D',
                    color: colorConstants.orangeAlt2,
                    tableLabel: 'F & D',
                },
                no_promo_units: {
                    label: 'Non Promo',
                    color: colorConstants.darkYellow,
                    tableLabel: 'Non Promo',
                },

                //for export label
                sales_year_ago: { label: 'YA Sales' },
                total_value: { label: 'Total' },
                incremental_eq_volume_percentage: {
                    label: 'Incremental Sales Percentage',
                },
                incremental_value_percentage: {
                    label: 'Incremental Sales Percentage',
                },
                incremental_units_percentage: {
                    label: 'Incremental Sales Percentage',
                },
                base_value_percentage: { label: 'Base Sales Percentage' },
                base_eq_volume_percentage: { label: 'Base Sales Percentage' },
                base_units_percentage: { label: 'Base Units Percentage' },
                any_promo_eq_volume_percentage: { label: 'Promo Percentage' },
                any_promo_value_percentage: { label: 'Promo Percentage' },
                any_promo_units_percentage: { label: 'Promo Percentage' },
                no_promo_eq_volume_percentage: {
                    label: 'Non Promo Percentage',
                },
                no_promo_units_percentage: { label: 'Non Promo Percentage' },
                no_promo_value_percentage: { label: 'Non Promo Percentage' },
            },

            tooltipExtraItems: {
                tpr_acv: { label: 'Tpr ACV %' },
                display_acv: { label: 'Display ACV %' },
                feature_acv: { label: 'Feature ACV %' },
                feature_and_display_acv: { label: 'F&D ACV %' },
                uplift: { label: 'Uplift' },
                promo_lift: { label: 'Promo Uplift' },
                media_lift: { label: 'Media Uplift' },
            },
            promoCalenderAttributeLevels: {
                promo: [
                    { value: 'product', label: 'Product' },
                    { value: 'geography', label: 'Geography' },
                ],
            },
            overlayKeys: {
                promo: [
                    { label: 'Start Week', dataKey: 'startTimestamp' },
                    { label: 'End Week', dataKey: 'endTimestamp' },
                    { label: 'Product', dataKey: 'product' },
                    { label: 'Promo Mechanics', dataKey: 'promoMech' },
                    { label: 'Promo Type', dataKey: 'promoType' },
                    { label: 'Investment', dataKey: 'field_value' },
                    // { label: 'ROI', dataKey: 'roi' },
                    // { label: 'Lift', dataKey: 'lift' },
                    // { label: 'Incremental Profit', dataKey: 'incrementalProfit' },
                    // { label: 'Incremental Retailer Profit', dataKey: 'incrementalRetailerProfit' },
                ],
            },
        },
        //PROMO SCORE CARD
        promoScoreCard: {
            mainHeader: 'Promotional Score Card',
            limit: 50,
            nestedTableLimit: 10,
            questionsNo: [1, 2, 3, 4, 5, 6, 7, 8],
            question: {
                Q: [
                    'Am I getting my fair share of quality support? ',
                    'How does my % Discount compare to competition? ',
                    'What % of Volume was sold on promotion? ',
                    'How many weeks am I promoting? ',
                    'What is my average price per eq volume? ',
                    'What is my average price/units? ',
                    'What is my value share of promotions? ',
                    'What is my volume share of promotions? ',
                ],
                unitsInItalics: [
                    '(Fair Share Index -$ Sold)',
                    '(Weighted Average % Price Reduction)',
                    '(% of Volume)',
                    '(Weighted Weeks)',
                    '(Price per bars/oz)',
                    '(Price per Unit)',
                    '(Value share %)',
                    '(EQ Volume %)',
                ],
                unit: ['value', '%', '%', 'week', '$', '$', '%', '%'],
                numberFormateDecimal: [0, 1, 1, 0, 2, 2, 1, 1],
            },
            promoTypeLabelMapping: {
                display: { label: 'Display Only' },
                tpr: { label: 'TPR Only' },
                feature: { label: 'Feature Only' },
                feature_and_display: { label: 'Feature & Display Only' },
                feature_display: { label: 'Feature & Display Only' },
            },
            showGradientTile: true,
            promoType: ['TPR Only', 'Display Only', 'Feature Only', 'Feature & Display Only'],
            promoExpandedViewTableUnit: 'volume',
            promoExpandedViewTableSalesAndVolumeLabel: ['EQ Volume', 'Total Sales $'],
            dropDown: ['Vendor', 'Brand', 'Sub_Brand'],
            listFor: ['Vendor', 'Brand', 'Sub_Brand', 'Product'],
            listForToDisplay: ['Vendor', 'Brand', 'Sub_Brand', 'Product'],
            listIn: ['Category', 'Sub_Category', 'Pack_Size', 'Form', 'Segment', 'Retailer'],
        },
        // PROMO LANDSCAPE
        promoLandscape: {
            mainHeader: 'Investment & ROI Tracker',
            roiLabel: 'ROI',
            defaultAttributeTypeIndex: 10,
            optimalInvestmentIndexThreshold1: 0.8,
            optimalInvestmentIndexThreshold2: 1.2,
            promoTacticDropdownName: 'Investment Type',
            dimensionConfig: {
                //snake case eg sub_category
                excludedDimensions: [],
                defaultDimension: '',
            },
            thresholdColorMapping: {
                optimal: { label: 'Optimal', color: colorConstants.darkGreen },
                over: { label: 'Over', color: colorConstants.darkRed },
                under: { label: 'Under', color: colorConstants.darkBlueAlt },
            },
            limit: 60,
            promoTypes: [
                { value: 'display', label: 'Display' },
                { value: 'tpr', label: 'TPR' },
                { value: 'feature', label: 'Feature' },
                // { value: 'feature & display', label: 'Feature & Display' },  //not required for now
            ],
            mediaLevelsDropdown: [],
            optimalIndexKey: 'competition_spend_index',
            showInvestmentDropdown: false,
            tableRowsKeyMapping: [
                {
                    label: 'Investment',
                    children: null,
                    parentKey: null,
                    key: 'investments',
                    unit: '$',
                },
                {
                    label: 'ROI',
                    children: null,
                    parentKey: null,
                    key: 'roi',
                    unit: '',
                },
                {
                    label: 'Optimal Investment Index',
                    children: [
                        {
                            label: 'Share of Investment',
                            key: 'share_of_investment',
                            unit: '',
                        },
                        {
                            label: 'Share of Sales',
                            key: 'share_of_sales',
                            unit: '',
                        },
                    ],
                    unit: '',
                    parentKey: 'competition_data',
                    key: 'competition_spend_index',
                },
                {
                    label: 'Incremental Sales Dollar',
                    children: [
                        {
                            label: 'Total Sales Dollar',
                            key: 'total_sales',
                            unit: '$',
                        },
                        {
                            label: 'Base Sales Dollar',
                            key: 'base_sales_dollar',
                            unit: '$',
                        },
                        {
                            label: 'Incremental Sales Eq',
                            key: 'incremental_sales_eq',
                            unit: '',
                        },
                        {
                            label: 'Total Sales Eq',
                            key: 'total_sales_eq',
                            unit: '',
                        },
                        {
                            label: 'Base Sales Eq',
                            key: 'base_sales_eq',
                            unit: '',
                        },
                    ],
                    unit: '$',
                    parentKey: 'incremental_sales_dollar_data',
                    key: 'incremental_sales_dollar',
                },
                {
                    label: 'Incremental Profit',
                    children: [
                        {
                            label: 'Share of Profit Pool',
                            key: 'share_of_profit_pool',
                            unit: '',
                        },
                        {
                            label: 'Total Profit',
                            key: 'total_profit',
                            unit: '',
                        },
                        {
                            label: 'Baseline Profit',
                            key: 'baseline_profit',
                            unit: '',
                        },

                        {
                            label: 'Incremental Net Sales',
                            key: 'incremental_net_sales',
                            unit: '$',
                        },
                        {
                            label: 'Total Net Sales',
                            key: 'total_net_sales',
                            unit: '$',
                        },
                        {
                            label: 'Baseline Net Sales',
                            key: 'baseline_net_sales',
                            unit: '$',
                        },
                        {
                            label: 'Promo % Margin',
                            key: 'promo_percentage_margin',
                            unit: '',
                        },
                        {
                            label: 'Baseline % Margin',
                            key: 'baseline_percentage_margin',
                            unit: '',
                        },
                    ],
                    parentKey: 'incremental_profit_data',
                    key: 'incremental_profit',
                    unit: '$',
                },
                {
                    label: 'Incremental Retailer Profit',
                    unit: '$',
                    children: [
                        {
                            label: 'Share of Profit Pool',
                            key: 'share_of_profit_pool_retailer',
                            unit: '',
                        },
                        {
                            label: 'Total Retailer Profit',
                            key: 'total_retailer_profit',
                            unit: '',
                        },
                        {
                            label: 'Baseline Retailer Profit',
                            key: 'baseline_retailer_profit',
                            unit: '',
                        },
                        {
                            label: 'Retailer Promo % Margin',
                            key: 'retailer_promo_percentage_margin',
                            unit: '',
                        },
                        {
                            label: 'Retailer Baseline % Margin',
                            key: 'retailer_baseline_percentage_margin',
                            unit: '',
                        },
                    ],
                    parentKey: 'incremental_retailer_profit_data',
                    key: 'incremental_retailer_profit',
                },
            ],
        },
        //PORTFOLIO ANALYSIS
        portfolioAnalysis: {
            mainHeader: 'Promo ROI Analysis',
            limit: 20,
            defaultGroupByIndex: 18,
            defaultGroupBy2Index: 5,
            chartColors: [],
            absTileData: [
                { key: 'Promotions', label: 'Promotions' },
                { key: 'Drivers', label: 'Drivers' },
            ],
            salesAttributionChart: {
                colorList: ['#10AB5E', '#DC3826'],
                colorListType2: ['#758BEE', '#758BEE'],
                profitPoolColor: ['#826FD0', '#826FD0'],
                backGroundColor: 'rgba(0, 0, 0, 0.02)',
            },
            // chartColors: [
            //     '#E8A122',
            //     '#293BB8',
            //     '#E06936',
            //     '#19669D',
            //     '#A5582D',
            //     '#43C9E2',
            //     '#DD449F',
            //     '#37C7BE',
            //     '#9E5897',
            //     '#00798C',
            //     '#EDB44E',
            //     '#4557D5',
            //     '#E6875E',
            //     '#228BD6',
            //     '#CC7442',
            //     '#69D4E8',
            //     '#E469B2',
            //     '#5FD3CB',
            //     '#B377AD',
            //     '#3394A3',
            //     '#F1C77A',
            //     '#7381E0',
            //     '#ECA586',
            //     '#55A8E4',
            //     '#D89672',
            //     '#8EDFEE',
            //     '#EB8FC5',
            //     '#87DED8',
            //     '#C699C2',
            //     '#66AFBA',
            //     '#F6D9A7',
            //     '#A2ABEA',
            //     '#F3C3AF',
            //     '#8EC5ED',
            //     '#E5B9A1',
            //     '#B4E9F3',
            //     '#F1B4D9',
            //     '#AFE9E5',
            //     '#D9BBD6',
            //     '#99C9D1',
            //     '#FAECD3',
            //     '#D0D5F5',
            //     '#F9E1D7',
            //     '#C6E2F6',
            //     '#F2DCD0',
            //     '#D9F4F9',
            //     '#F8DAEC',
            //     '#D7F4F2',
            //     '#ECDDEB',
            //     '#CCE4E8',
            // ],
            chartDropdownExtraKpis: [
                {
                    dimension: 'none',
                    label: 'Tactics',
                    dataKey: 'tactic_description',
                },
                {
                    dimension: 'none',
                    label: 'Mechanics',
                    dataKey: 'promotion_mechanic',
                },
                {
                    dimension: 'none',
                    label: 'Event Name',
                    dataKey: 'event_name',
                },
                {
                    dimension: 'dim1',
                    label: 'Week',
                    dataKey: 'week',
                },
            ],
            groupByHeaders: [
                {
                    label: 'Category',
                    value: 'category',
                    dimension: 'dim1',
                    isSelected: false,
                    sortKey: 'category',
                    multiSelectFilter: false,
                },
                {
                    label: 'Sub Category',
                    value: 'sub_category',
                    dimension: 'dim1',
                    isSelected: false,
                    sortKey: 'sub_category',
                    multiSelectFilter: false,
                },
                {
                    label: 'Brand',
                    value: 'brand',
                    dimension: 'dim1',
                    isSelected: true,
                    sortKey: 'brand',
                    multiSelectFilter: false,
                },
                {
                    label: 'Sub Brand',
                    value: 'sub_brand',
                    dimension: 'dim1',
                    isSelected: false,
                    sortKey: 'sub_brand',
                    multiSelectFilter: false,
                },
                {
                    label: 'Product',
                    value: 'product',
                    dimension: 'dim1',
                    isSelected: true,
                    sortKey: 'product',
                    multiSelectFilter: false,
                },
                {
                    label: 'Mechanics',
                    value: 'promotion_mechanic',
                    dimension: null,
                    isSelected: false,
                    sortKey: 'promotion_mechanic',
                    multiSelectFilter: true,
                },
                {
                    label: 'Tactic',
                    value: 'tactic_description',
                    dimension: null,
                    isSelected: false,
                    sortKey: 'tactic_description',
                    multiSelectFilter: true,
                },
                {
                    label: 'Week',
                    value: 'week',
                    dimension: null,
                    isSelected: true,
                    sortKey: 'week',
                    multiSelectFilter: false,
                },
            ],
            chartHeaderLabelKeyMapping: {
                lift: { label: 'Lift' },
                roi: { label: 'ROI' },
                investments: { label: 'Investments' },
                incremental_net_sales: { label: 'Incremental Net Sales' },
                incremental_profit: { label: 'Incremental Profit' },
                incremental_retailer_profit: {
                    label: 'Incremental Retailer Profit',
                },
                acv: { label: 'ACV Distribution' },
                profit_pool: { label: 'Profit Pool' },
                tpr_acv: { label: 'Tpr ACV' },
                display_acv: { label: 'Display ACV' },
                feature_acv: { label: 'Feature ACV' },
                feature_and_display_acv: { label: 'F&D ACV' },
                total_acv: { label: 'Total ACV' },
                weeks: { label: 'Promo Weeks' },
            },
            promoTypesChartLegends: [
                {
                    label: 'TPR',
                    color: colorConstants.lightCyan,
                    style: {
                        borderRadius: '100%',
                        height: `8px`,
                        width: '8px',
                    },
                },
                {
                    label: 'Feature',
                    color: colorConstants.lightCream,
                    style: {
                        borderRadius: '100%',
                        height: `8px`,
                        width: '8px',
                    },
                },
                {
                    label: 'Display',
                    color: colorConstants.lightPink,
                    style: {
                        borderRadius: '100%',
                        height: `8px`,
                        width: '8px',
                    },
                },
            ],
            promoTypes: ['tpr', 'feature', 'display'],
            promoTypesLabelMapping: {
                tpr: 'TPR',
                feature: 'Feature',
                display: 'Display',
            },
        },
        promoRecommendation: {
            playbookLimit: 50,
            clientName: 'Kind',
            mainHeader: 'Promo Recommendation',
            retailerKey: 'Retailer',
            hideAddSpends: false,
            calenderStartDay: 'Monday',
            spendLeversList: [
                {
                    label: 'Baseline Volume',
                    placeholder: 'Baseline Volume',
                    value: 'baseVolume',
                    isDisabled: false,
                },
                {
                    label: 'Uplift',
                    placeholder: 'Uplift',
                    value: 'uplift',
                    isDisabled: false,
                },
                {
                    label: 'Total Volume',
                    placeholder: 'Total Volume',
                    value: 'totalVolume',
                    isDisabled: true,
                },
                {
                    label: `Total Kind Profit ($)`,
                    placeholder: `Total Kind Profit`,
                    value: 'totalKindProfit',
                    isDisabled: true,
                },
                {
                    label: 'ROI',
                    placeholder: 'ROI',
                    value: 'roi',
                    isDisabled: true,
                },
                {
                    label: `Total Retailer Profit ($)`,
                    placeholder: 'Total Retailer Profit',
                    value: 'totalRetailerProfit',
                    isDisabled: true,
                },
            ],
            spendTypeList: [
                {
                    label: 'Lump Sum',
                    value: 'lump_sum',
                    inputRule: '',
                },
                {
                    label: 'Per Qty',
                    value: 'per_qty',
                    inputRule: '',
                },
                {
                    label: 'Display',
                    value: 'display',
                    inputRule: '',
                },
                {
                    label: 'Feature',
                    value: 'feature',
                    inputRule: '',
                },
            ],
            playbookKeyMapping: {
                Product: ['ppgName'],
                '%TS': ['guidelinePercentageTotalSpends', 'percentageTotalSpends', 'lesser_than', '', '%'],
                Frequency: ['guidelineFrequency', 'frequency', 'range', ''],
                ROI: ['guidelineRoi', 'roi', 'greater_than', '', ''],
            },
            // comparisonOperator: {
            //     '%TS': '<',
            //     Frequency: 'range',
            //     ROI: '>',
            // },
            menuButtons: [
                { key: 'recommendations', label: 'Recommendations' },
                {
                    key: 'summary',
                    label: 'Summary',
                },
                {
                    key: 'playbook',
                    label: 'Playbook',
                },
            ],

            promoTypeColorMapping: {
                'tpr/scan': {
                    label: 'TPR/Scan',
                    color: colorConstants.lightGreenAlt,
                },
                feature_ad: {
                    label: 'Feature Ad',
                    color: colorConstants.darkGreenAlt2,
                },
                display: { label: 'Display', color: colorConstants.pinkAlt },
                feature_display_tpr: {
                    label: 'Feature_Display_TPR',
                    color: colorConstants.orangeAlt2,
                },
                display_tpr: {
                    label: 'Display_TPR',
                    color: colorConstants.darkBlueAlt,
                },
            },
            overlayKeys: [
                {
                    label: 'Start Date',
                    dataKey: 'startDate',
                    pre: '',
                    post: '',
                },
                { label: 'Duration', dataKey: 'duration', pre: '', post: '' },
                {
                    label: 'Promo Type',
                    dataKey: 'tacticDescription',
                    pre: '',
                    post: '',
                },
                { label: 'Product(s)', dataKey: 'dim1AttributeNames', pre: '', post: '' },
                {
                    label: 'Total Volume',
                    dataKey: 'totalVolume',
                    pre: '',
                    post: '',
                    arrowConfig: 'positiveUp',
                },
                {
                    label: 'Total GSV',
                    dataKey: 'totalGsv',
                    pre: '$',
                    post: '',
                    arrowConfig: 'positiveUp',
                },
                {
                    label: 'Total NSV',
                    dataKey: 'totalNsv',
                    pre: '$',
                    post: '',
                    arrowConfig: 'positiveUp',
                },
                {
                    label: 'Total KIND Profit',
                    dataKey: 'totalKindProfit',
                    pre: '$',
                    post: '',
                    arrowConfig: 'positiveUp',
                },
                {
                    label: 'Total Retailer Profit',
                    dataKey: 'totalRetailerProfit',
                    pre: '$',
                    post: '',
                    arrowConfig: 'positiveUp',
                },
                {
                    label: 'Promo Spends',
                    dataKey: 'promoSpends',
                    pre: '$',
                    post: '',
                    arrowConfig: 'negativeUp',
                },
                {
                    label: '% Trade Spends GSV',
                    dataKey: 'percentageTradeSpendsGsv',
                    pre: '',
                    post: '%',
                    arrowConfig: 'negativeUp',
                },
                {
                    label: '% Trade Spends NSV',
                    dataKey: 'percentageTradeSpendsNsv',
                    pre: '',
                    post: '%',
                    arrowConfig: 'negativeUp',
                },

                {
                    label: 'Incremental Volume',
                    dataKey: 'incrementalVolume',
                    pre: '',
                    post: '',
                    arrowConfig: 'positiveUp',
                },
                {
                    label: 'Incremental GSV',
                    dataKey: 'incrementalGsv',
                    pre: '$',
                    post: '',
                    arrowConfig: 'positiveUp',
                },
                {
                    label: 'Incremental NSV',
                    dataKey: 'incrementalNsv',
                    pre: '$',
                    post: '',
                    arrowConfig: 'positiveUp',
                },
                {
                    label: 'Total Profit %',
                    dataKey: 'totalProfitPercentage',
                    pre: '',
                    post: '%',
                    arrowConfig: 'positiveUp',
                },
                {
                    label: 'Incremental Profit',
                    dataKey: 'incrementalProfit',
                    pre: '$',
                    post: '',
                    arrowConfig: 'positiveUp',
                },
                {
                    label: 'Promo ROI',
                    dataKey: 'roi',
                    pre: '',
                    post: '',
                    arrowConfig: 'positiveUp',
                },
                {
                    label: 'Retailer Incremental Profit',
                    dataKey: 'retailerIncrementalProfit',
                    pre: '$',
                    post: '',
                    arrowConfig: 'positiveUp',
                },
            ],
            spendLabel: {
                lump_sum: 'Lump Sum',
                per_qty: 'Per Qty',
                display: 'Display',
                feature: 'Feature',
            },
            offerMethodList: [
                { value: 'option', label: 'List of Option', dimension: 'dim1' },
                { value: 'manual', label: 'Manual', dimension: 'dim1' },
                { value: 'previous', label: 'Previous', dimension: 'dim1' },
            ],
            addEventList: [
                { value: 'new', label: 'Add New Event' },
                { value: 'import', label: 'Import Event' },
            ],
            leverKeys: [
                'promptEventName',
                'offerMethod',
                'discount',
                'startDate',
                'duration',
                'displayAcv',
                'featureAcv',
            ],
            spendTopForm: ['baseVolume', 'uplift', 'totalVolume', 'totalKindProfit', 'roi', 'totalRetailerProfit'],
            formList: [
                {
                    value: 'duration',
                    label: 'Duration',
                    inputRule: '',
                    placeHolder: 'Enter',
                },
                {
                    value: 'displayAcv',
                    label: 'Display ACV',
                    inputRule: '',
                    placeHolder: 'Enter display ACV',
                },
                {
                    value: 'featureAcv',
                    label: 'Feature ACV',
                    inputRule: '',
                    placeHolder: 'Enter feature ACV',
                },
            ],
            offerSelectionKeys: ['promotionMechanic', 'tacticDescription'],
            spendPerQtyKey: ['per_qty', 'redemption'],
        },
        priceLadder: {
            isThresholdDropdownEnabled: true,
            hideMraup: true,
            limit: 50, //update this when implementing infinite scroller
            dimensionConfig: {
                //snake case eg sub_category
                excludedDimensions: [],
                defaultDimension: 'Manufacturer',
            },
            tileData: [
                {
                    label: 'Product by Market',
                    key: 'product by market',
                },
                // {
                //     label: 'Product vs Competitors',
                //     key: 'product vs competitors',
                // },
            ],
            subTileData: [
                {
                    label: 'PU',
                    key: 'PU',
                },
                // {
                //     label: 'PEQ',
                //     key: 'PEQ',
                // },
            ],
            legendMapping: {
                PU: [
                    {
                        color: '#E6E6EA',
                        label: 'Sales kr',
                        key: 'salesValueDollars',
                        dataKey: 'sales',
                        metricDataKey: 'units',
                    },
                    {
                        color: '#66AFBA',
                        label: 'Avg. Price PU',
                        key: 'avgPrice',
                        dataKey: 'avg_price_per_unit',
                        metricDataKey: 'units',
                    },
                    {
                        color: '#ECA586',
                        label: 'Max Price PU',
                        key: 'maxPrice',
                        dataKey: 'max_price_per_unit',
                        metricDataKey: 'units',
                    },
                    {
                        color: '#EB8FC5',
                        label: 'Min Price PU',
                        key: 'minPrice',
                        dataKey: 'min_price_per_unit',
                        metricDataKey: 'units',
                    },
                    {
                        color: '#F1C77A',
                        label: 'Promo Price PU',
                        key: 'promoPrice',
                        dataKey: 'promo_price_per_unit',
                        metricDataKey: 'units',
                    },
                    {
                        color: '#6771DB',
                        label: 'Base Price PU',
                        key: 'basePrice',
                        dataKey: 'base_price_per_unit',
                        metricDataKey: 'units',
                    },
                    // { color: '#5463FF', label: 'MRAUP', key: 'mraup', dataKey: 'mraup' },
                ],
                PEQ: [
                    {
                        color: '#E6E6EA',
                        label: 'Sales kr',
                        key: 'salesValueDollars',
                        dataKey: '',
                        metricDataKey: 'volume',
                    },
                    {
                        color: '#66AFBA',
                        label: 'Avg. Price PEQ',
                        key: 'avgPrice',
                        dataKey: 'avg_price_per_eq',
                        metricDataKey: 'volume',
                    },
                    {
                        color: '#ECA586',
                        label: 'Max Price PEQ',
                        key: 'maxPrice',
                        dataKey: 'max_price_per_eq',
                        metricDataKey: 'volume',
                    },
                    {
                        color: '#EB8FC5',
                        label: 'Min Price PEQ',
                        key: 'minPrice',
                        dataKey: 'min_price_per_eq',
                        metricDataKey: 'volume',
                    },
                    {
                        color: '#F1C77A',
                        label: 'Promo Price PEQ',
                        key: 'promoPrice',
                        dataKey: 'promo_price_per_eq',
                        metricDataKey: 'volume',
                    },
                    {
                        color: '#6771DB',
                        label: 'Base Price PEQ',
                        key: 'basePrice',
                        dataKey: 'base_price_per_eq',
                        metricDataKey: 'volume',
                    },
                    // { color: '#5463FF', label: 'MRAUP', key: 'mraup', dataKey: 'mraup' },
                ],
            },
            dataKeyMapping: {
                PU: [
                    { label: 'Sales kr', key: 'salesValueDollars' },
                    { label: 'Avg. Price PU', key: 'avgPrice' },
                    { label: 'Max Price PU', key: 'maxPrice' },
                    { label: 'Min Price PU', key: 'minPrice' },
                    { label: 'Promo Price PU', key: 'promoPrice' },
                    { label: 'Base Price PU', key: 'basePrice' },
                ],
                PEQ: [
                    { label: 'Sales kr', key: 'salesValueDollars' },
                    { label: 'Avg. Price PEQ', key: 'avgPrice' },
                    { label: 'Max Price PEQ', key: 'maxPrice' },
                    { label: 'Min Price PEQ', key: 'minPrice' },
                    { label: 'Promo Price PEQ', key: 'promoPrice' },
                    { label: 'Base Price PEQ', key: 'basePrice' },
                ],
            },
            tableColumnLabelKeyMapping: {
                sales: { label: 'Sales kr' },
                sales_percentage: { label: 'Sales %' },
                avg_price_pu: { label: 'Average Price kr PU' },
                avg_price_peq: { label: 'Average Price kr PEQ' },
                max_price_pu: { label: 'Max Price kr PU' },
                max_price_peq: { label: 'Max Price kr PEQ' },
                min_price_pu: { label: 'Min Price kr PU' },
                min_price_peq: { label: 'Min Price kr PEQ' },
                // mraup: { label: 'MRAUP' },
                base_price_pu: { label: 'Base Price kr PU' },
                base_price_peq: { label: 'Base Price kr PEQ' },
                promo_price_pu: { label: 'Promo Price kr PU' },
                promo_price_peq: { label: 'Promo Price kr PEQ' },
            },
            dropdown2Filter: ['Category', 'Manufacturer', 'Brand', 'Channel', 'Chain'],
        },
        opportunityIdentification: {
            reversePpeAxis: true,
            bubbleCategoryOptions: [
                { value: 'brand', label: 'Brand', dimension: 'dim1' },
                { value: 'category', label: 'Category', dimension: 'dim1' },
                { value: 'manufacturer', label: 'Manufacturer', dimension: 'dim1' },
                { value: 'substance', label: 'Substance', dimension: 'dim1' },
                { value: 'nec_2', label: 'NEC 2', dimension: 'dim1' },
                { value: 'product', label: 'Product', dimension: 'dim1' },
                { value: 'market', label: 'Market', dimension: 'dim2' },
                { value: 'channel', label: 'Channel', dimension: 'dim2' },
                { value: 'chain', label: 'Chain', dimension: 'dim2' },
            ],
            kpis: {
                xaxis: [
                    { label: 'BPE', value: 'bpe' },
                    { label: '% RSV Growth', value: 'rsv_growth' },
                    { label: 'MAC %', value: 'mac_percentage' },
                ],
                yaxis: [
                    { label: 'PPE', value: 'ppe' },
                    { label: '% RSV Growth', value: 'rsv_growth' },
                    { label: 'MAC %', value: 'mac_percentage' },
                ],
                bubbleSize: [
                    { label: 'Eq Volume', value: 'total_volume' },
                    { label: 'BPE', value: 'bpe' },
                    { label: 'PPE', value: 'ppe' },
                    { label: 'MAC', value: 'mac' },
                    { label: 'MAC %', value: 'mac_percentage' },
                    { label: 'RSV', value: 'rsv' },
                    { label: '% RSV Growth', value: 'rsv_growth' },
                ],
            },
            elasticityDriver: {
                chart2Limit: 100,
                levels: [
                    { value: 'brand', label: 'Brand', dimension: 'dim1' },
                    { value: 'category', label: 'Category', dimension: 'dim1' },
                    { value: 'manufacturer', label: 'Manufacturer', dimension: 'dim1' },
                    { value: 'substance', label: 'Substance', dimension: 'dim1' },
                    { value: 'nec_2', label: 'NEC 2', dimension: 'dim1' },
                    { value: 'product', label: 'Product', dimension: 'dim1' },
                    { value: 'market', label: 'Market', dimension: 'dim2' },
                    { value: 'channel', label: 'Channel', dimension: 'dim2' },
                    { value: 'chain', label: 'Chain', dimension: 'dim2' },
                ],
                limit: 50,
                offset: 0,
                dimension: 'dim1',
                legendMapping: [
                    {
                        dataKey: 'own',
                        label: 'Own Elasticity',
                        color: '#69D4E8',
                    },
                    {
                        dataKey: 'internal',
                        label: 'Internal Competitor Elasticity',
                        color: '#E469B2',
                    },
                    {
                        dataKey: 'external',
                        label: 'External Competitor Elasticity',
                        color: '#EDB44E',
                    },
                ],
            },
        },
        priceCurve: {
            chart1Limit: 100,
            xAxisKeyValue: [
                // { value: 'category', label: 'Category' },
                { value: 'manufacturer', label: 'Manufacturer' },
                { value: 'brand', label: 'Brand' },
                { value: 'nec_2', label: 'NEC 2' },
                { value: 'substance', label: 'Substance' },
            ],
            YAxisKeyValue: [
                { value: 'retail_price', label: 'Avg Price' },
                { value: 'list_price', label: 'List Price' },
                { value: 'base_price', label: 'Base Price' },
            ],
            levels: [
                { value: 'manufacturer', label: 'Manufacturer' },
                { value: 'category', label: 'Category' },
                { value: 'brand', label: 'Brand' },
                { value: 'nec_2', label: 'NEC 2' },
                { value: 'substance', label: 'Substance' },
            ],
            subTileData: [
                {
                    label: 'PU',
                    key: 'PU',
                    dataKey: 'per_unit',
                },
                // {
                //     label: 'PEQ',
                //     key: 'PEQ',
                //     dataKey: 'per_eq',
                // },
            ],
            chartColors: [
                '#E8A122',
                '#293BB8',
                '#E06936',
                '#19669D',
                '#A5582D',
                '#43C9E2',
                '#DD449F',
                '#37C7BE',
                '#9E5897',
                '#00798C',
                '#EDB44E',
                '#4557D5',
                '#E6875E',
                '#228BD6',
                '#CC7442',
                '#69D4E8',
                '#E469B2',
                '#5FD3CB',
                '#B377AD',
                '#3394A3',
                '#F1C77A',
                '#7381E0',
                '#ECA586',
                '#55A8E4',
                '#D89672',
                '#8EDFEE',
                '#EB8FC5',
                '#87DED8',
                '#C699C2',
                '#66AFBA',
                '#F6D9A7',
                '#A2ABEA',
                '#F3C3AF',
                '#8EC5ED',
                '#E5B9A1',
                '#B4E9F3',
                '#F1B4D9',
                '#AFE9E5',
                '#D9BBD6',
                '#99C9D1',
                '#FAECD3',
                '#D0D5F5',
                '#F9E1D7',
                '#C6E2F6',
                '#F2DCD0',
                '#D9F4F9',
                '#F8DAEC',
                '#D7F4F2',
                '#ECDDEB',
                '#CCE4E8',
            ],
            tableHeaders: [
                { label: 'List Price kr', key: 'list_price' },
                { label: 'List Price kr YA', key: 'list_price_ya' },
                { label: 'Avg Price kr', key: 'retail_price' },
                { label: 'Avg Price kr YA', key: 'retail_price_ya' },
                { label: 'Base Price kr', key: 'base_price' },
                { label: 'Base Price kr YA', key: 'base_price_ya' },
            ],
        },
        pricePoint: {
            priceRange: [0, 10],
            graphColorScheme: ['#D7D6D9', '#66AFBA', '#ECA586', '#F1C77A', '#EB8FC5'],
            hideMraup: true,
            limit: 500,
            dimensionConfig: {
                //snake case eg sub_category
                excludedDimensions: [],
                defaultDimension: 'Vendor',
            },
            contributionThreshold: 5,
            priceTypeOptions: [
                { label: 'Avg Price', value: 'avg_price' },
                { label: 'Base Price', value: 'base_price' },
            ],
            subTileData: [
                {
                    label: 'PU',
                    key: 'per_unit',
                    xAxisLabel: 'Price Per Unit',
                    tooltip: 'Per Unit',
                },
                // {
                //     label: 'PEQ',
                //     key: 'per_volume',
                //     xAxisLabel: 'Price Per Eq',
                //     tooltip: 'Per Eq Volume',
                // },
            ],
            yAxisDropdownData: [
                {
                    label: 'SEK',
                    value: 'value',
                },
                {
                    label: 'Units',
                    value: 'units',
                },
            ],
            tableHeaderKeyMapping: {
                growth_percentage: ['Growth % vs YA', '', '%'],
                total_sales: ['Total Value ($)', '$', ''],
                total_volume: ['Total Volume', '', ''],
                total_units: ['Total Units', '', ''],
                avg_price_per_unit: ['Avg. Price per Unit', '$', ''],
                avg_price_per_eq: ['Avg. Price per EQ', '$', ''],
                base_price_per_unit: ['Base Price per Unit', '$', ''],
                base_price_per_eq: ['Base Price per EQ', '$', ''],
            },
            drilldownTableHeaderKeyMapping: {
                growth_abs: ['Growth Abs', '$', ''],
                growth_percentage: ['Growth %', '', '%'],
                contribution_to_category: ['Contribution to category', '$', ''],
                cy_share: ['CY share', '', '%'],
                ya_share: ['YA share', '', '%'],
                change: ['Change %', '', '%'],
            },
            dropdown2Filter: ['Category', 'Pack_Size', 'Segment', 'Channel', 'Retailer'],
            customThresholdData: [
                {
                    id: 1,
                    value: '',
                },
                {
                    id: 2,
                    value: '',
                },
                {
                    id: 3,
                    value: '',
                },
                {
                    id: 4,
                    value: '',
                },
                {
                    id: 5,
                    value: '',
                },
            ],
        },
        priceTracking: {
            limit: 20,
            dimensionConfig: {
                //snake case eg sub_category
                excludedDimensions: ['segment', 'form', 'count', 'ounces'],
                defaultRowDimension: 'Product',
                defaultColumnDimension: 'Manufacturer',
            },
            attributeNamesLimit: 50,
            frequency: 'W',
            timePeriodOptions: [
                { label: 'YA', value: 'year_ago' },
                { label: 'Prior Period', value: 'prior_period' },
                { label: 'Custom Period', value: 'custom' },
            ],
            priceTypeOptions: [
                { label: 'Base Price', value: 'base' },
                { label: 'Avg Price', value: 'average' },
            ],
            kpiOptions: [
                { label: '% Change', value: 'percent_change' },
                { label: 'Price Index', value: 'index' },
            ],
            subTileData: [
                {
                    label: 'PU',
                    key: 'units',
                    xAxisLabel: 'Price Per Unit',
                    tooltip: 'Per Unit',
                },
                // {
                //     label: 'PEQ',
                //     key: 'volume',
                //     xAxisLabel: 'Price Per Eq',
                //     tooltip: 'Per Eq Volume',
                // },
            ],
            weeksOptions: [
                { label: 'L W1', value: 1 },
                { label: 'L W4', value: 4 },
                { label: 'L W12', value: 12 },
            ],
            monthsOptions: [
                { label: 'L M1', value: 1 },
                { label: 'L M3', value: 3 },
                { label: 'L M6', value: 6 },
                { label: 'L M12', value: 12 },
            ],
            quartersOptions: [
                { label: 'L Q1', value: 1 },
                { label: 'L Q2', value: 2 },
                { label: 'L Q4', value: 4 },
            ],
            kpiMapping: {
                'Base Price': ['kr', ''],
                'Base Price YA': ['kr', ''],
                'Avg Price': ['kr', ''],
                'Avg Price YA': ['kr', ''],
                'Base Price Index % Chg': ['', '%'],
                'Base Price % Chg': ['', '%'],
                'Avg Price Index % Chg': ['', '%'],
                'Avg Price % Chg': ['', '%'],
                'TDP % Chg': ['', '%'],
                TDP: ['', ''],
                'TDP YA': ['', ''],
                'Volume Velocity % Chg': ['', '%'],
                'Volume Velocity': ['', ''],
                'Volume Velocity YA': ['', ''],
            },
        },
        bestWeeks: {
            limit: 50,
            drilldownTableConfig: [
                { label: 'Period No:', value: 'period_no', sorting: false },
                { label: 'Year', value: 'year', sorting: false },
            ],
            dimensionConfig: {
                //snake case eg sub_category
                excludedDimensions: ['dim2'],
                defaultDimension: 'Brand',
            },
            rankingCriteriaOptions: [
                { label: 'Base Volume', value: 'base_eq_volume' },
                { label: 'ACV', value: 'total_per_acv_dist' },
                { label: 'Incremental Volume', value: 'incremental_eq_volume' },
                { label: 'Total Volume', value: 'total_eq_volume' },
            ],
        },
    },
};
